webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {'use strict';
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularCookies = __webpack_require__(80);
	
	var _angularCookies2 = _interopRequireDefault(_angularCookies);
	
	var _angularResource = __webpack_require__(82);
	
	var _angularResource2 = _interopRequireDefault(_angularResource);
	
	var _angularSanitize = __webpack_require__(84);
	
	var _angularSanitize2 = _interopRequireDefault(_angularSanitize);
	
	var _angularUiRouter = __webpack_require__(86);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _angularUiBootstrap = __webpack_require__(87);
	
	var _angularUiBootstrap2 = _interopRequireDefault(_angularUiBootstrap);
	
	var _ngFileUpload = __webpack_require__(89);
	
	var _ngFileUpload2 = _interopRequireDefault(_ngFileUpload);
	
	var _angularjsToaster = __webpack_require__(91);
	
	var _angularjsToaster2 = _interopRequireDefault(_angularjsToaster);
	
	var _angularLoadingBar = __webpack_require__(97);
	
	var _angularLoadingBar2 = _interopRequireDefault(_angularLoadingBar);
	
	var _app = __webpack_require__(101);
	
	var _auth = __webpack_require__(102);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _account = __webpack_require__(122);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _admin = __webpack_require__(134);
	
	var _admin2 = _interopRequireDefault(_admin);
	
	var _navbar = __webpack_require__(138);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _footer = __webpack_require__(140);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _app2 = __webpack_require__(103);
	
	var _app3 = _interopRequireDefault(_app2);
	
	var _util = __webpack_require__(105);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _firmwares = __webpack_require__(142);
	
	var _firmwares2 = _interopRequireDefault(_firmwares);
	
	var _betausers = __webpack_require__(175);
	
	var _betausers2 = _interopRequireDefault(_betausers);
	
	var _apps = __webpack_require__(187);
	
	var _apps2 = _interopRequireDefault(_apps);
	
	var _jdOrder = __webpack_require__(206);
	
	var _jdOrder2 = _interopRequireDefault(_jdOrder);
	
	var _appstore = __webpack_require__(215);
	
	var _appstore2 = _interopRequireDefault(_appstore);
	
	var _appIconCheck = __webpack_require__(236);
	
	var _appIconCheck2 = _interopRequireDefault(_appIconCheck);
	
	var _waveforms = __webpack_require__(237);
	
	var _waveforms2 = _interopRequireDefault(_waveforms);
	
	var _booklist = __webpack_require__(249);
	
	var _booklist2 = _interopRequireDefault(_booklist);
	
	var _appconfs = __webpack_require__(264);
	
	var _appconfs2 = _interopRequireDefault(_appconfs);
	
	var _betagroups = __webpack_require__(293);
	
	var _betagroups2 = _interopRequireDefault(_betagroups);
	
	var _groupName = __webpack_require__(314);
	
	var _groupName2 = _interopRequireDefault(_groupName);
	
	var _usermanual = __webpack_require__(315);
	
	var _usermanual2 = _interopRequireDefault(_usermanual);
	
	var _dictionaries = __webpack_require__(327);
	
	var _dictionaries2 = _interopRequireDefault(_dictionaries);
	
	var _devices = __webpack_require__(339);
	
	var _devices2 = _interopRequireDefault(_devices);
	
	var _myscripts = __webpack_require__(354);
	
	var _myscripts2 = _interopRequireDefault(_myscripts);
	
	var _categories = __webpack_require__(378);
	
	var _categories2 = _interopRequireDefault(_categories);
	
	var _carousel = __webpack_require__(396);
	
	var _carousel2 = _interopRequireDefault(_carousel);
	
	var _writeTpl = __webpack_require__(411);
	
	var _writeTpl2 = _interopRequireDefault(_writeTpl);
	
	var _screenSaver = __webpack_require__(423);
	
	var _screenSaver2 = _interopRequireDefault(_screenSaver);
	
	var _appconfgroups = __webpack_require__(438);
	
	var _appconfgroups2 = _interopRequireDefault(_appconfgroups);
	
	var _tutorial = __webpack_require__(456);
	
	var _tutorial2 = _interopRequireDefault(_tutorial);
	
	var _peripheral = __webpack_require__(468);
	
	var _peripheral2 = _interopRequireDefault(_peripheral);
	
	var _fonts = __webpack_require__(481);
	
	var _fonts2 = _interopRequireDefault(_fonts);
	
	var _devicecert = __webpack_require__(493);
	
	var _devicecert2 = _interopRequireDefault(_devicecert);
	
	var _tpFirmwares = __webpack_require__(505);
	
	var _tpFirmwares2 = _interopRequireDefault(_tpFirmwares);
	
	var _monitor = __webpack_require__(517);
	
	var _monitor2 = _interopRequireDefault(_monitor);
	
	var _keyboard = __webpack_require__(529);
	
	var _keyboard2 = _interopRequireDefault(_keyboard);
	
	var _deviceconfigs = __webpack_require__(539);
	
	var _deviceconfigs2 = _interopRequireDefault(_deviceconfigs);
	
	var _tags = __webpack_require__(554);
	
	var _tags2 = _interopRequireDefault(_tags);
	
	__webpack_require__(563);
	
	var _jqueryMin = __webpack_require__(1);
	
	var _jqueryMin2 = _interopRequireDefault(_jqueryMin);
	
	__webpack_require__(565);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	window.$ = __webpack_provided_window_dot_jQuery = _jqueryMin2.default;
	
	__webpack_require__(566);
	__webpack_require__(569);
	__webpack_require__(575);
	
	_angular2.default.module('updateServerApp', [_angularCookies2.default, _angularResource2.default, _angularSanitize2.default, _angularUiRouter2.default, _angularUiBootstrap2.default, _auth2.default, _ngFileUpload2.default, _angularjsToaster2.default, _angularLoadingBar2.default, _account2.default, _admin2.default, _navbar2.default, _footer2.default, _app3.default, _util2.default, _firmwares2.default, _betausers2.default, _apps2.default, _jdOrder2.default, _appstore2.default, _appIconCheck2.default, _waveforms2.default, _booklist2.default, _appconfs2.default, _betagroups2.default, _groupName2.default, _usermanual2.default, _dictionaries2.default, _devices2.default, _myscripts2.default, _categories2.default, _carousel2.default, _writeTpl2.default, _screenSaver2.default, _appconfgroups2.default, _tutorial2.default, _peripheral2.default, _fonts2.default, _devicecert2.default, _tpFirmwares2.default, _monitor2.default, _keyboard2.default, _deviceconfigs2.default, _tags2.default, 'summernote']).config(_app.routeConfig).config(['cfpLoadingBarProvider', function (cfpLoadingBarProvider) {
	  cfpLoadingBarProvider.includeSpinner = false;
	}]).run(['$rootScope', '$location', 'Auth', function ($rootScope, $location, Auth) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next) {
	    Auth.isLoggedIn(function (loggedIn) {
	      if (next.authenticate && !loggedIn) {
	        $location.path('/login');
	      }
	    });
	  });
	}]);
	
	_angular2.default.element(document).ready(function () {
	  _angular2.default.bootstrap(document, ['updateServerApp'], {
	    strictDi: true
	  });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(90);
	module.exports = 'ngFileUpload';

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery, jQuery) {/**!
	 * AngularJS file upload directives and services. Supports: file upload/drop/paste, resume, cancel/abort,
	 * progress, resize, thumbnail, preview, validation and CORS
	 * FileAPI Flash shim for old browsers not supporting FormData
	 * @author  Danial  <danial.farid@gmail.com>
	 * @version 12.2.13
	 */
	
	(function () {
	  /** @namespace FileAPI.noContentTimeout */
	
	  function patchXHR(fnName, newFn) {
	    window.XMLHttpRequest.prototype[fnName] = newFn(window.XMLHttpRequest.prototype[fnName]);
	  }
	
	  function redefineProp(xhr, prop, fn) {
	    try {
	      Object.defineProperty(xhr, prop, {get: fn});
	    } catch (e) {/*ignore*/
	    }
	  }
	
	  if (!window.FileAPI) {
	    window.FileAPI = {};
	  }
	
	  if (!window.XMLHttpRequest) {
	    throw 'AJAX is not supported. XMLHttpRequest is not defined.';
	  }
	
	  FileAPI.shouldLoad = !window.FormData || FileAPI.forceLoad;
	  if (FileAPI.shouldLoad) {
	    var initializeUploadListener = function (xhr) {
	      if (!xhr.__listeners) {
	        if (!xhr.upload) xhr.upload = {};
	        xhr.__listeners = [];
	        var origAddEventListener = xhr.upload.addEventListener;
	        xhr.upload.addEventListener = function (t, fn) {
	          xhr.__listeners[t] = fn;
	          if (origAddEventListener) origAddEventListener.apply(this, arguments);
	        };
	      }
	    };
	
	    patchXHR('open', function (orig) {
	      return function (m, url, b) {
	        initializeUploadListener(this);
	        this.__url = url;
	        try {
	          orig.apply(this, [m, url, b]);
	        } catch (e) {
	          if (e.message.indexOf('Access is denied') > -1) {
	            this.__origError = e;
	            orig.apply(this, [m, '_fix_for_ie_crossdomain__', b]);
	          }
	        }
	      };
	    });
	
	    patchXHR('getResponseHeader', function (orig) {
	      return function (h) {
	        return this.__fileApiXHR && this.__fileApiXHR.getResponseHeader ? this.__fileApiXHR.getResponseHeader(h) : (orig == null ? null : orig.apply(this, [h]));
	      };
	    });
	
	    patchXHR('getAllResponseHeaders', function (orig) {
	      return function () {
	        return this.__fileApiXHR && this.__fileApiXHR.getAllResponseHeaders ? this.__fileApiXHR.getAllResponseHeaders() : (orig == null ? null : orig.apply(this));
	      };
	    });
	
	    patchXHR('abort', function (orig) {
	      return function () {
	        return this.__fileApiXHR && this.__fileApiXHR.abort ? this.__fileApiXHR.abort() : (orig == null ? null : orig.apply(this));
	      };
	    });
	
	    patchXHR('setRequestHeader', function (orig) {
	      return function (header, value) {
	        if (header === '__setXHR_') {
	          initializeUploadListener(this);
	          var val = value(this);
	          // fix for angular < 1.2.0
	          if (val instanceof Function) {
	            val(this);
	          }
	        } else {
	          this.__requestHeaders = this.__requestHeaders || {};
	          this.__requestHeaders[header] = value;
	          orig.apply(this, arguments);
	        }
	      };
	    });
	
	    patchXHR('send', function (orig) {
	      return function () {
	        var xhr = this;
	        if (arguments[0] && arguments[0].__isFileAPIShim) {
	          var formData = arguments[0];
	          var config = {
	            url: xhr.__url,
	            jsonp: false, //removes the callback form param
	            cache: true, //removes the ?fileapiXXX in the url
	            complete: function (err, fileApiXHR) {
	              if (err && angular.isString(err) && err.indexOf('#2174') !== -1) {
	                // this error seems to be fine the file is being uploaded properly.
	                err = null;
	              }
	              xhr.__completed = true;
	              if (!err && xhr.__listeners.load)
	                xhr.__listeners.load({
	                  type: 'load',
	                  loaded: xhr.__loaded,
	                  total: xhr.__total,
	                  target: xhr,
	                  lengthComputable: true
	                });
	              if (!err && xhr.__listeners.loadend)
	                xhr.__listeners.loadend({
	                  type: 'loadend',
	                  loaded: xhr.__loaded,
	                  total: xhr.__total,
	                  target: xhr,
	                  lengthComputable: true
	                });
	              if (err === 'abort' && xhr.__listeners.abort)
	                xhr.__listeners.abort({
	                  type: 'abort',
	                  loaded: xhr.__loaded,
	                  total: xhr.__total,
	                  target: xhr,
	                  lengthComputable: true
	                });
	              if (fileApiXHR.status !== undefined) redefineProp(xhr, 'status', function () {
	                return (fileApiXHR.status === 0 && err && err !== 'abort') ? 500 : fileApiXHR.status;
	              });
	              if (fileApiXHR.statusText !== undefined) redefineProp(xhr, 'statusText', function () {
	                return fileApiXHR.statusText;
	              });
	              redefineProp(xhr, 'readyState', function () {
	                return 4;
	              });
	              if (fileApiXHR.response !== undefined) redefineProp(xhr, 'response', function () {
	                return fileApiXHR.response;
	              });
	              var resp = fileApiXHR.responseText || (err && fileApiXHR.status === 0 && err !== 'abort' ? err : undefined);
	              redefineProp(xhr, 'responseText', function () {
	                return resp;
	              });
	              redefineProp(xhr, 'response', function () {
	                return resp;
	              });
	              if (err) redefineProp(xhr, 'err', function () {
	                return err;
	              });
	              xhr.__fileApiXHR = fileApiXHR;
	              if (xhr.onreadystatechange) xhr.onreadystatechange();
	              if (xhr.onload) xhr.onload();
	            },
	            progress: function (e) {
	              e.target = xhr;
	              if (xhr.__listeners.progress) xhr.__listeners.progress(e);
	              xhr.__total = e.total;
	              xhr.__loaded = e.loaded;
	              if (e.total === e.loaded) {
	                // fix flash issue that doesn't call complete if there is no response text from the server
	                var _this = this;
	                setTimeout(function () {
	                  if (!xhr.__completed) {
	                    xhr.getAllResponseHeaders = function () {
	                    };
	                    _this.complete(null, {status: 204, statusText: 'No Content'});
	                  }
	                }, FileAPI.noContentTimeout || 10000);
	              }
	            },
	            headers: xhr.__requestHeaders
	          };
	          config.data = {};
	          config.files = {};
	          for (var i = 0; i < formData.data.length; i++) {
	            var item = formData.data[i];
	            if (item.val != null && item.val.name != null && item.val.size != null && item.val.type != null) {
	              config.files[item.key] = item.val;
	            } else {
	              config.data[item.key] = item.val;
	            }
	          }
	
	          setTimeout(function () {
	            if (!FileAPI.hasFlash) {
	              throw 'Adode Flash Player need to be installed. To check ahead use "FileAPI.hasFlash"';
	            }
	            xhr.__fileApiXHR = FileAPI.upload(config);
	          }, 1);
	        } else {
	          if (this.__origError) {
	            throw this.__origError;
	          }
	          orig.apply(xhr, arguments);
	        }
	      };
	    });
	    window.XMLHttpRequest.__isFileAPIShim = true;
	    window.FormData = FormData = function () {
	      return {
	        append: function (key, val, name) {
	          if (val.__isFileAPIBlobShim) {
	            val = val.data[0];
	          }
	          this.data.push({
	            key: key,
	            val: val,
	            name: name
	          });
	        },
	        data: [],
	        __isFileAPIShim: true
	      };
	    };
	
	    window.Blob = Blob = function (b) {
	      return {
	        data: b,
	        __isFileAPIBlobShim: true
	      };
	    };
	  }
	
	})();
	
	(function () {
	  /** @namespace FileAPI.forceLoad */
	  /** @namespace window.FileAPI.jsUrl */
	  /** @namespace window.FileAPI.jsPath */
	
	  function isInputTypeFile(elem) {
	    return elem[0].tagName.toLowerCase() === 'input' && elem.attr('type') && elem.attr('type').toLowerCase() === 'file';
	  }
	
	  function hasFlash() {
	    try {
	      var fo = new ActiveXObject('ShockwaveFlash.ShockwaveFlash');
	      if (fo) return true;
	    } catch (e) {
	      if (navigator.mimeTypes['application/x-shockwave-flash'] !== undefined) return true;
	    }
	    return false;
	  }
	
	  function getOffset(obj) {
	    var left = 0, top = 0;
	
	    if (__webpack_provided_window_dot_jQuery) {
	      return jQuery(obj).offset();
	    }
	
	    if (obj.offsetParent) {
	      do {
	        left += (obj.offsetLeft - obj.scrollLeft);
	        top += (obj.offsetTop - obj.scrollTop);
	        obj = obj.offsetParent;
	      } while (obj);
	    }
	    return {
	      left: left,
	      top: top
	    };
	  }
	
	  if (FileAPI.shouldLoad) {
	    FileAPI.hasFlash = hasFlash();
	
	    //load FileAPI
	    if (FileAPI.forceLoad) {
	      FileAPI.html5 = false;
	    }
	
	    if (!FileAPI.upload) {
	      var jsUrl, basePath, script = document.createElement('script'), allScripts = document.getElementsByTagName('script'), i, index, src;
	      if (window.FileAPI.jsUrl) {
	        jsUrl = window.FileAPI.jsUrl;
	      } else if (window.FileAPI.jsPath) {
	        basePath = window.FileAPI.jsPath;
	      } else {
	        for (i = 0; i < allScripts.length; i++) {
	          src = allScripts[i].src;
	          index = src.search(/\/ng\-file\-upload[\-a-zA-z0-9\.]*\.js/);
	          if (index > -1) {
	            basePath = src.substring(0, index + 1);
	            break;
	          }
	        }
	      }
	
	      if (FileAPI.staticPath == null) FileAPI.staticPath = basePath;
	      script.setAttribute('src', jsUrl || basePath + 'FileAPI.min.js');
	      document.getElementsByTagName('head')[0].appendChild(script);
	    }
	
	    FileAPI.ngfFixIE = function (elem, fileElem, changeFn) {
	      if (!hasFlash()) {
	        throw 'Adode Flash Player need to be installed. To check ahead use "FileAPI.hasFlash"';
	      }
	      var fixInputStyle = function () {
	        var label = fileElem.parent();
	        if (elem.attr('disabled')) {
	          if (label) label.removeClass('js-fileapi-wrapper');
	        } else {
	          if (!fileElem.attr('__ngf_flash_')) {
	            fileElem.unbind('change');
	            fileElem.unbind('click');
	            fileElem.bind('change', function (evt) {
	              fileApiChangeFn.apply(this, [evt]);
	              changeFn.apply(this, [evt]);
	            });
	            fileElem.attr('__ngf_flash_', 'true');
	          }
	          label.addClass('js-fileapi-wrapper');
	          if (!isInputTypeFile(elem)) {
	            label.css('position', 'absolute')
	              .css('top', getOffset(elem[0]).top + 'px').css('left', getOffset(elem[0]).left + 'px')
	              .css('width', elem[0].offsetWidth + 'px').css('height', elem[0].offsetHeight + 'px')
	              .css('filter', 'alpha(opacity=0)').css('display', elem.css('display'))
	              .css('overflow', 'hidden').css('z-index', '900000')
	              .css('visibility', 'visible');
	            fileElem.css('width', elem[0].offsetWidth + 'px').css('height', elem[0].offsetHeight + 'px')
	              .css('position', 'absolute').css('top', '0px').css('left', '0px');
	          }
	        }
	      };
	
	      elem.bind('mouseenter', fixInputStyle);
	
	      var fileApiChangeFn = function (evt) {
	        var files = FileAPI.getFiles(evt);
	        //just a double check for #233
	        for (var i = 0; i < files.length; i++) {
	          if (files[i].size === undefined) files[i].size = 0;
	          if (files[i].name === undefined) files[i].name = 'file';
	          if (files[i].type === undefined) files[i].type = 'undefined';
	        }
	        if (!evt.target) {
	          evt.target = {};
	        }
	        evt.target.files = files;
	        // if evt.target.files is not writable use helper field
	        if (evt.target.files !== files) {
	          evt.__files_ = files;
	        }
	        (evt.__files_ || evt.target.files).item = function (i) {
	          return (evt.__files_ || evt.target.files)[i] || null;
	        };
	      };
	    };
	
	    FileAPI.disableFileInput = function (elem, disable) {
	      if (disable) {
	        elem.removeClass('js-fileapi-wrapper');
	      } else {
	        elem.addClass('js-fileapi-wrapper');
	      }
	    };
	  }
	})();
	
	if (!window.FileReader) {
	  window.FileReader = function () {
	    var _this = this, loadStarted = false;
	    this.listeners = {};
	    this.addEventListener = function (type, fn) {
	      _this.listeners[type] = _this.listeners[type] || [];
	      _this.listeners[type].push(fn);
	    };
	    this.removeEventListener = function (type, fn) {
	      if (_this.listeners[type]) _this.listeners[type].splice(_this.listeners[type].indexOf(fn), 1);
	    };
	    this.dispatchEvent = function (evt) {
	      var list = _this.listeners[evt.type];
	      if (list) {
	        for (var i = 0; i < list.length; i++) {
	          list[i].call(_this, evt);
	        }
	      }
	    };
	    this.onabort = this.onerror = this.onload = this.onloadstart = this.onloadend = this.onprogress = null;
	
	    var constructEvent = function (type, evt) {
	      var e = {type: type, target: _this, loaded: evt.loaded, total: evt.total, error: evt.error};
	      if (evt.result != null) e.target.result = evt.result;
	      return e;
	    };
	    var listener = function (evt) {
	      if (!loadStarted) {
	        loadStarted = true;
	        if (_this.onloadstart) _this.onloadstart(constructEvent('loadstart', evt));
	      }
	      var e;
	      if (evt.type === 'load') {
	        if (_this.onloadend) _this.onloadend(constructEvent('loadend', evt));
	        e = constructEvent('load', evt);
	        if (_this.onload) _this.onload(e);
	        _this.dispatchEvent(e);
	      } else if (evt.type === 'progress') {
	        e = constructEvent('progress', evt);
	        if (_this.onprogress) _this.onprogress(e);
	        _this.dispatchEvent(e);
	      } else {
	        e = constructEvent('error', evt);
	        if (_this.onerror) _this.onerror(e);
	        _this.dispatchEvent(e);
	      }
	    };
	    this.readAsDataURL = function (file) {
	      FileAPI.readAsDataURL(file, listener);
	    };
	    this.readAsText = function (file) {
	      FileAPI.readAsText(file, listener);
	    };
	  };
	}
	
	/**!
	 * AngularJS file upload directives and services. Supoorts: file upload/drop/paste, resume, cancel/abort,
	 * progress, resize, thumbnail, preview, validation and CORS
	 * @author  Danial  <danial.farid@gmail.com>
	 * @version 12.2.13
	 */
	
	if (window.XMLHttpRequest && !(window.FileAPI && FileAPI.shouldLoad)) {
	  window.XMLHttpRequest.prototype.setRequestHeader = (function (orig) {
	    return function (header, value) {
	      if (header === '__setXHR_') {
	        var val = value(this);
	        // fix for angular < 1.2.0
	        if (val instanceof Function) {
	          val(this);
	        }
	      } else {
	        orig.apply(this, arguments);
	      }
	    };
	  })(window.XMLHttpRequest.prototype.setRequestHeader);
	}
	
	var ngFileUpload = angular.module('ngFileUpload', []);
	
	ngFileUpload.version = '12.2.13';
	
	ngFileUpload.service('UploadBase', ['$http', '$q', '$timeout', function ($http, $q, $timeout) {
	  var upload = this;
	  upload.promisesCount = 0;
	
	  this.isResumeSupported = function () {
	    return window.Blob && window.Blob.prototype.slice;
	  };
	
	  var resumeSupported = this.isResumeSupported();
	
	  function sendHttp(config) {
	    config.method = config.method || 'POST';
	    config.headers = config.headers || {};
	
	    var deferred = config._deferred = config._deferred || $q.defer();
	    var promise = deferred.promise;
	
	    function notifyProgress(e) {
	      if (deferred.notify) {
	        deferred.notify(e);
	      }
	      if (promise.progressFunc) {
	        $timeout(function () {
	          promise.progressFunc(e);
	        });
	      }
	    }
	
	    function getNotifyEvent(n) {
	      if (config._start != null && resumeSupported) {
	        return {
	          loaded: n.loaded + config._start,
	          total: (config._file && config._file.size) || n.total,
	          type: n.type, config: config,
	          lengthComputable: true, target: n.target
	        };
	      } else {
	        return n;
	      }
	    }
	
	    if (!config.disableProgress) {
	      config.headers.__setXHR_ = function () {
	        return function (xhr) {
	          if (!xhr || !xhr.upload || !xhr.upload.addEventListener) return;
	          config.__XHR = xhr;
	          if (config.xhrFn) config.xhrFn(xhr);
	          xhr.upload.addEventListener('progress', function (e) {
	            e.config = config;
	            notifyProgress(getNotifyEvent(e));
	          }, false);
	          //fix for firefox not firing upload progress end, also IE8-9
	          xhr.upload.addEventListener('load', function (e) {
	            if (e.lengthComputable) {
	              e.config = config;
	              notifyProgress(getNotifyEvent(e));
	            }
	          }, false);
	        };
	      };
	    }
	
	    function uploadWithAngular() {
	      $http(config).then(function (r) {
	          if (resumeSupported && config._chunkSize && !config._finished && config._file) {
	            var fileSize = config._file && config._file.size || 0;
	            notifyProgress({
	                loaded: Math.min(config._end, fileSize),
	                total: fileSize,
	                config: config,
	                type: 'progress'
	              }
	            );
	            upload.upload(config, true);
	          } else {
	            if (config._finished) delete config._finished;
	            deferred.resolve(r);
	          }
	        }, function (e) {
	          deferred.reject(e);
	        }, function (n) {
	          deferred.notify(n);
	        }
	      );
	    }
	
	    if (!resumeSupported) {
	      uploadWithAngular();
	    } else if (config._chunkSize && config._end && !config._finished) {
	      config._start = config._end;
	      config._end += config._chunkSize;
	      uploadWithAngular();
	    } else if (config.resumeSizeUrl) {
	      $http.get(config.resumeSizeUrl).then(function (resp) {
	        if (config.resumeSizeResponseReader) {
	          config._start = config.resumeSizeResponseReader(resp.data);
	        } else {
	          config._start = parseInt((resp.data.size == null ? resp.data : resp.data.size).toString());
	        }
	        if (config._chunkSize) {
	          config._end = config._start + config._chunkSize;
	        }
	        uploadWithAngular();
	      }, function (e) {
	        throw e;
	      });
	    } else if (config.resumeSize) {
	      config.resumeSize().then(function (size) {
	        config._start = size;
	        if (config._chunkSize) {
	          config._end = config._start + config._chunkSize;
	        }
	        uploadWithAngular();
	      }, function (e) {
	        throw e;
	      });
	    } else {
	      if (config._chunkSize) {
	        config._start = 0;
	        config._end = config._start + config._chunkSize;
	      }
	      uploadWithAngular();
	    }
	
	
	    promise.success = function (fn) {
	      promise.then(function (response) {
	        fn(response.data, response.status, response.headers, config);
	      });
	      return promise;
	    };
	
	    promise.error = function (fn) {
	      promise.then(null, function (response) {
	        fn(response.data, response.status, response.headers, config);
	      });
	      return promise;
	    };
	
	    promise.progress = function (fn) {
	      promise.progressFunc = fn;
	      promise.then(null, null, function (n) {
	        fn(n);
	      });
	      return promise;
	    };
	    promise.abort = promise.pause = function () {
	      if (config.__XHR) {
	        $timeout(function () {
	          config.__XHR.abort();
	        });
	      }
	      return promise;
	    };
	    promise.xhr = function (fn) {
	      config.xhrFn = (function (origXhrFn) {
	        return function () {
	          if (origXhrFn) origXhrFn.apply(promise, arguments);
	          fn.apply(promise, arguments);
	        };
	      })(config.xhrFn);
	      return promise;
	    };
	
	    upload.promisesCount++;
	    if (promise['finally'] && promise['finally'] instanceof Function) {
	      promise['finally'](function () {
	        upload.promisesCount--;
	      });
	    }
	    return promise;
	  }
	
	  this.isUploadInProgress = function () {
	    return upload.promisesCount > 0;
	  };
	
	  this.rename = function (file, name) {
	    file.ngfName = name;
	    return file;
	  };
	
	  this.jsonBlob = function (val) {
	    if (val != null && !angular.isString(val)) {
	      val = JSON.stringify(val);
	    }
	    var blob = new window.Blob([val], {type: 'application/json'});
	    blob._ngfBlob = true;
	    return blob;
	  };
	
	  this.json = function (val) {
	    return angular.toJson(val);
	  };
	
	  function copy(obj) {
	    var clone = {};
	    for (var key in obj) {
	      if (obj.hasOwnProperty(key)) {
	        clone[key] = obj[key];
	      }
	    }
	    return clone;
	  }
	
	  this.isFile = function (file) {
	    return file != null && (file instanceof window.Blob || (file.flashId && file.name && file.size));
	  };
	
	  this.upload = function (config, internal) {
	    function toResumeFile(file, formData) {
	      if (file._ngfBlob) return file;
	      config._file = config._file || file;
	      if (config._start != null && resumeSupported) {
	        if (config._end && config._end >= file.size) {
	          config._finished = true;
	          config._end = file.size;
	        }
	        var slice = file.slice(config._start, config._end || file.size);
	        slice.name = file.name;
	        slice.ngfName = file.ngfName;
	        if (config._chunkSize) {
	          formData.append('_chunkSize', config._chunkSize);
	          formData.append('_currentChunkSize', config._end - config._start);
	          formData.append('_chunkNumber', Math.floor(config._start / config._chunkSize));
	          formData.append('_totalSize', config._file.size);
	        }
	        return slice;
	      }
	      return file;
	    }
	
	    function addFieldToFormData(formData, val, key) {
	      if (val !== undefined) {
	        if (angular.isDate(val)) {
	          val = val.toISOString();
	        }
	        if (angular.isString(val)) {
	          formData.append(key, val);
	        } else if (upload.isFile(val)) {
	          var file = toResumeFile(val, formData);
	          var split = key.split(',');
	          if (split[1]) {
	            file.ngfName = split[1].replace(/^\s+|\s+$/g, '');
	            key = split[0];
	          }
	          config._fileKey = config._fileKey || key;
	          formData.append(key, file, file.ngfName || file.name);
	        } else {
	          if (angular.isObject(val)) {
	            if (val.$$ngfCircularDetection) throw 'ngFileUpload: Circular reference in config.data. Make sure specified data for Upload.upload() has no circular reference: ' + key;
	
	            val.$$ngfCircularDetection = true;
	            try {
	              for (var k in val) {
	                if (val.hasOwnProperty(k) && k !== '$$ngfCircularDetection') {
	                  var objectKey = config.objectKey == null ? '[i]' : config.objectKey;
	                  if (val.length && parseInt(k) > -1) {
	                    objectKey = config.arrayKey == null ? objectKey : config.arrayKey;
	                  }
	                  addFieldToFormData(formData, val[k], key + objectKey.replace(/[ik]/g, k));
	                }
	              }
	            } finally {
	              delete val.$$ngfCircularDetection;
	            }
	          } else {
	            formData.append(key, val);
	          }
	        }
	      }
	    }
	
	    function digestConfig() {
	      config._chunkSize = upload.translateScalars(config.resumeChunkSize);
	      config._chunkSize = config._chunkSize ? parseInt(config._chunkSize.toString()) : null;
	
	      config.headers = config.headers || {};
	      config.headers['Content-Type'] = undefined;
	      config.transformRequest = config.transformRequest ?
	        (angular.isArray(config.transformRequest) ?
	          config.transformRequest : [config.transformRequest]) : [];
	      config.transformRequest.push(function (data) {
	        var formData = new window.FormData(), key;
	        data = data || config.fields || {};
	        if (config.file) {
	          data.file = config.file;
	        }
	        for (key in data) {
	          if (data.hasOwnProperty(key)) {
	            var val = data[key];
	            if (config.formDataAppender) {
	              config.formDataAppender(formData, key, val);
	            } else {
	              addFieldToFormData(formData, val, key);
	            }
	          }
	        }
	
	        return formData;
	      });
	    }
	
	    if (!internal) config = copy(config);
	    if (!config._isDigested) {
	      config._isDigested = true;
	      digestConfig();
	    }
	
	    return sendHttp(config);
	  };
	
	  this.http = function (config) {
	    config = copy(config);
	    config.transformRequest = config.transformRequest || function (data) {
	        if ((window.ArrayBuffer && data instanceof window.ArrayBuffer) || data instanceof window.Blob) {
	          return data;
	        }
	        return $http.defaults.transformRequest[0].apply(this, arguments);
	      };
	    config._chunkSize = upload.translateScalars(config.resumeChunkSize);
	    config._chunkSize = config._chunkSize ? parseInt(config._chunkSize.toString()) : null;
	
	    return sendHttp(config);
	  };
	
	  this.translateScalars = function (str) {
	    if (angular.isString(str)) {
	      if (str.search(/kb/i) === str.length - 2) {
	        return parseFloat(str.substring(0, str.length - 2) * 1024);
	      } else if (str.search(/mb/i) === str.length - 2) {
	        return parseFloat(str.substring(0, str.length - 2) * 1048576);
	      } else if (str.search(/gb/i) === str.length - 2) {
	        return parseFloat(str.substring(0, str.length - 2) * 1073741824);
	      } else if (str.search(/b/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1));
	      } else if (str.search(/s/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1));
	      } else if (str.search(/m/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1) * 60);
	      } else if (str.search(/h/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1) * 3600);
	      }
	    }
	    return str;
	  };
	
	  this.urlToBlob = function(url) {
	    var defer = $q.defer();
	    $http({url: url, method: 'get', responseType: 'arraybuffer'}).then(function (resp) {
	      var arrayBufferView = new Uint8Array(resp.data);
	      var type = resp.headers('content-type') || 'image/WebP';
	      var blob = new window.Blob([arrayBufferView], {type: type});
	      var matches = url.match(/.*\/(.+?)(\?.*)?$/);
	      if (matches.length > 1) {
	        blob.name = matches[1];
	      }
	      defer.resolve(blob);
	    }, function (e) {
	      defer.reject(e);
	    });
	    return defer.promise;
	  };
	
	  this.setDefaults = function (defaults) {
	    this.defaults = defaults || {};
	  };
	
	  this.defaults = {};
	  this.version = ngFileUpload.version;
	}
	
	]);
	
	ngFileUpload.service('Upload', ['$parse', '$timeout', '$compile', '$q', 'UploadExif', function ($parse, $timeout, $compile, $q, UploadExif) {
	  var upload = UploadExif;
	  upload.getAttrWithDefaults = function (attr, name) {
	    if (attr[name] != null) return attr[name];
	    var def = upload.defaults[name];
	    return (def == null ? def : (angular.isString(def) ? def : JSON.stringify(def)));
	  };
	
	  upload.attrGetter = function (name, attr, scope, params) {
	    var attrVal = this.getAttrWithDefaults(attr, name);
	    if (scope) {
	      try {
	        if (params) {
	          return $parse(attrVal)(scope, params);
	        } else {
	          return $parse(attrVal)(scope);
	        }
	      } catch (e) {
	        // hangle string value without single qoute
	        if (name.search(/min|max|pattern/i)) {
	          return attrVal;
	        } else {
	          throw e;
	        }
	      }
	    } else {
	      return attrVal;
	    }
	  };
	
	  upload.shouldUpdateOn = function (type, attr, scope) {
	    var modelOptions = upload.attrGetter('ngfModelOptions', attr, scope);
	    if (modelOptions && modelOptions.updateOn) {
	      return modelOptions.updateOn.split(' ').indexOf(type) > -1;
	    }
	    return true;
	  };
	
	  upload.emptyPromise = function () {
	    var d = $q.defer();
	    var args = arguments;
	    $timeout(function () {
	      d.resolve.apply(d, args);
	    });
	    return d.promise;
	  };
	
	  upload.rejectPromise = function () {
	    var d = $q.defer();
	    var args = arguments;
	    $timeout(function () {
	      d.reject.apply(d, args);
	    });
	    return d.promise;
	  };
	
	  upload.happyPromise = function (promise, data) {
	    var d = $q.defer();
	    promise.then(function (result) {
	      d.resolve(result);
	    }, function (error) {
	      $timeout(function () {
	        throw error;
	      });
	      d.resolve(data);
	    });
	    return d.promise;
	  };
	
	  function applyExifRotations(files, attr, scope) {
	    var promises = [upload.emptyPromise()];
	    angular.forEach(files, function (f, i) {
	      if (f.type.indexOf('image/jpeg') === 0 && upload.attrGetter('ngfFixOrientation', attr, scope, {$file: f})) {
	        promises.push(upload.happyPromise(upload.applyExifRotation(f), f).then(function (fixedFile) {
	          files.splice(i, 1, fixedFile);
	        }));
	      }
	    });
	    return $q.all(promises);
	  }
	
	  function resizeFile(files, attr, scope, ngModel) {
	    var resizeVal = upload.attrGetter('ngfResize', attr, scope);
	    if (!resizeVal || !upload.isResizeSupported() || !files.length) return upload.emptyPromise();
	    if (resizeVal instanceof Function) {
	      var defer = $q.defer();
	      return resizeVal(files).then(function (p) {
	        resizeWithParams(p, files, attr, scope, ngModel).then(function (r) {
	          defer.resolve(r);
	        }, function (e) {
	          defer.reject(e);
	        });
	      }, function (e) {
	        defer.reject(e);
	      });
	    } else {
	      return resizeWithParams(resizeVal, files, attr, scope, ngModel);
	    }
	  }
	
	  function resizeWithParams(params, files, attr, scope, ngModel) {
	    var promises = [upload.emptyPromise()];
	
	    function handleFile(f, i) {
	      if (f.type.indexOf('image') === 0) {
	        if (params.pattern && !upload.validatePattern(f, params.pattern)) return;
	        params.resizeIf = function (width, height) {
	          return upload.attrGetter('ngfResizeIf', attr, scope,
	            {$width: width, $height: height, $file: f});
	        };
	        var promise = upload.resize(f, params);
	        promises.push(promise);
	        promise.then(function (resizedFile) {
	          files.splice(i, 1, resizedFile);
	        }, function (e) {
	          f.$error = 'resize';
	          (f.$errorMessages = (f.$errorMessages || {})).resize = true;
	          f.$errorParam = (e ? (e.message ? e.message : e) + ': ' : '') + (f && f.name);
	          ngModel.$ngfValidations.push({name: 'resize', valid: false});
	          upload.applyModelValidation(ngModel, files);
	        });
	      }
	    }
	
	    for (var i = 0; i < files.length; i++) {
	      handleFile(files[i], i);
	    }
	    return $q.all(promises);
	  }
	
	  upload.updateModel = function (ngModel, attr, scope, fileChange, files, evt, noDelay) {
	    function update(files, invalidFiles, newFiles, dupFiles, isSingleModel) {
	      attr.$$ngfPrevValidFiles = files;
	      attr.$$ngfPrevInvalidFiles = invalidFiles;
	      var file = files && files.length ? files[0] : null;
	      var invalidFile = invalidFiles && invalidFiles.length ? invalidFiles[0] : null;
	
	      if (ngModel) {
	        upload.applyModelValidation(ngModel, files);
	        ngModel.$setViewValue(isSingleModel ? file : files);
	      }
	
	      if (fileChange) {
	        $parse(fileChange)(scope, {
	          $files: files,
	          $file: file,
	          $newFiles: newFiles,
	          $duplicateFiles: dupFiles,
	          $invalidFiles: invalidFiles,
	          $invalidFile: invalidFile,
	          $event: evt
	        });
	      }
	
	      var invalidModel = upload.attrGetter('ngfModelInvalid', attr);
	      if (invalidModel) {
	        $timeout(function () {
	          $parse(invalidModel).assign(scope, isSingleModel ? invalidFile : invalidFiles);
	        });
	      }
	      $timeout(function () {
	        // scope apply changes
	      });
	    }
	
	    var allNewFiles, dupFiles = [], prevValidFiles, prevInvalidFiles,
	      invalids = [], valids = [];
	
	    function removeDuplicates() {
	      function equals(f1, f2) {
	        return f1.name === f2.name && (f1.$ngfOrigSize || f1.size) === (f2.$ngfOrigSize || f2.size) &&
	          f1.type === f2.type;
	      }
	
	      function isInPrevFiles(f) {
	        var j;
	        for (j = 0; j < prevValidFiles.length; j++) {
	          if (equals(f, prevValidFiles[j])) {
	            return true;
	          }
	        }
	        for (j = 0; j < prevInvalidFiles.length; j++) {
	          if (equals(f, prevInvalidFiles[j])) {
	            return true;
	          }
	        }
	        return false;
	      }
	
	      if (files) {
	        allNewFiles = [];
	        dupFiles = [];
	        for (var i = 0; i < files.length; i++) {
	          if (isInPrevFiles(files[i])) {
	            dupFiles.push(files[i]);
	          } else {
	            allNewFiles.push(files[i]);
	          }
	        }
	      }
	    }
	
	    function toArray(v) {
	      return angular.isArray(v) ? v : [v];
	    }
	
	    function resizeAndUpdate() {
	      function updateModel() {
	        $timeout(function () {
	          update(keep ? prevValidFiles.concat(valids) : valids,
	            keep ? prevInvalidFiles.concat(invalids) : invalids,
	            files, dupFiles, isSingleModel);
	        }, options && options.debounce ? options.debounce.change || options.debounce : 0);
	      }
	
	      var resizingFiles = validateAfterResize ? allNewFiles : valids;
	      resizeFile(resizingFiles, attr, scope, ngModel).then(function () {
	        if (validateAfterResize) {
	          upload.validate(allNewFiles, keep ? prevValidFiles.length : 0, ngModel, attr, scope)
	            .then(function (validationResult) {
	              valids = validationResult.validsFiles;
	              invalids = validationResult.invalidsFiles;
	              updateModel();
	            });
	        } else {
	          updateModel();
	        }
	      }, function () {
	        for (var i = 0; i < resizingFiles.length; i++) {
	          var f = resizingFiles[i];
	          if (f.$error === 'resize') {
	            var index = valids.indexOf(f);
	            if (index > -1) {
	              valids.splice(index, 1);
	              invalids.push(f);
	            }
	            updateModel();
	          }
	        }
	      });
	    }
	
	    prevValidFiles = attr.$$ngfPrevValidFiles || [];
	    prevInvalidFiles = attr.$$ngfPrevInvalidFiles || [];
	    if (ngModel && ngModel.$modelValue) {
	      prevValidFiles = toArray(ngModel.$modelValue);
	    }
	
	    var keep = upload.attrGetter('ngfKeep', attr, scope);
	    allNewFiles = (files || []).slice(0);
	    if (keep === 'distinct' || upload.attrGetter('ngfKeepDistinct', attr, scope) === true) {
	      removeDuplicates(attr, scope);
	    }
	
	    var isSingleModel = !keep && !upload.attrGetter('ngfMultiple', attr, scope) && !upload.attrGetter('multiple', attr);
	
	    if (keep && !allNewFiles.length) return;
	
	    upload.attrGetter('ngfBeforeModelChange', attr, scope, {
	      $files: files,
	      $file: files && files.length ? files[0] : null,
	      $newFiles: allNewFiles,
	      $duplicateFiles: dupFiles,
	      $event: evt
	    });
	
	    var validateAfterResize = upload.attrGetter('ngfValidateAfterResize', attr, scope);
	
	    var options = upload.attrGetter('ngfModelOptions', attr, scope);
	    upload.validate(allNewFiles, keep ? prevValidFiles.length : 0, ngModel, attr, scope)
	      .then(function (validationResult) {
	      if (noDelay) {
	        update(allNewFiles, [], files, dupFiles, isSingleModel);
	      } else {
	        if ((!options || !options.allowInvalid) && !validateAfterResize) {
	          valids = validationResult.validFiles;
	          invalids = validationResult.invalidFiles;
	        } else {
	          valids = allNewFiles;
	        }
	        if (upload.attrGetter('ngfFixOrientation', attr, scope) && upload.isExifSupported()) {
	          applyExifRotations(valids, attr, scope).then(function () {
	            resizeAndUpdate();
	          });
	        } else {
	          resizeAndUpdate();
	        }
	      }
	    });
	  };
	
	  return upload;
	}]);
	
	ngFileUpload.directive('ngfSelect', ['$parse', '$timeout', '$compile', 'Upload', function ($parse, $timeout, $compile, Upload) {
	  var generatedElems = [];
	
	  function isDelayedClickSupported(ua) {
	    // fix for android native browser < 4.4 and safari windows
	    var m = ua.match(/Android[^\d]*(\d+)\.(\d+)/);
	    if (m && m.length > 2) {
	      var v = Upload.defaults.androidFixMinorVersion || 4;
	      return parseInt(m[1]) < 4 || (parseInt(m[1]) === v && parseInt(m[2]) < v);
	    }
	
	    // safari on windows
	    return ua.indexOf('Chrome') === -1 && /.*Windows.*Safari.*/.test(ua);
	  }
	
	  function linkFileSelect(scope, elem, attr, ngModel, $parse, $timeout, $compile, upload) {
	    /** @namespace attr.ngfSelect */
	    /** @namespace attr.ngfChange */
	    /** @namespace attr.ngModel */
	    /** @namespace attr.ngfModelOptions */
	    /** @namespace attr.ngfMultiple */
	    /** @namespace attr.ngfCapture */
	    /** @namespace attr.ngfValidate */
	    /** @namespace attr.ngfKeep */
	    var attrGetter = function (name, scope) {
	      return upload.attrGetter(name, attr, scope);
	    };
	
	    function isInputTypeFile() {
	      return elem[0].tagName.toLowerCase() === 'input' && attr.type && attr.type.toLowerCase() === 'file';
	    }
	
	    function fileChangeAttr() {
	      return attrGetter('ngfChange') || attrGetter('ngfSelect');
	    }
	
	    function changeFn(evt) {
	      if (upload.shouldUpdateOn('change', attr, scope)) {
	        var fileList = evt.__files_ || (evt.target && evt.target.files), files = [];
	        /* Handle duplicate call in  IE11 */
	        if (!fileList) return;
	        for (var i = 0; i < fileList.length; i++) {
	          files.push(fileList[i]);
	        }
	        upload.updateModel(ngModel, attr, scope, fileChangeAttr(),
	          files.length ? files : null, evt);
	      }
	    }
	
	    upload.registerModelChangeValidator(ngModel, attr, scope);
	
	    var unwatches = [];
	    if (attrGetter('ngfMultiple')) {
	      unwatches.push(scope.$watch(attrGetter('ngfMultiple'), function () {
	        fileElem.attr('multiple', attrGetter('ngfMultiple', scope));
	      }));
	    }
	    if (attrGetter('ngfCapture')) {
	      unwatches.push(scope.$watch(attrGetter('ngfCapture'), function () {
	        fileElem.attr('capture', attrGetter('ngfCapture', scope));
	      }));
	    }
	    if (attrGetter('ngfAccept')) {
	      unwatches.push(scope.$watch(attrGetter('ngfAccept'), function () {
	        fileElem.attr('accept', attrGetter('ngfAccept', scope));
	      }));
	    }
	    unwatches.push(attr.$observe('accept', function () {
	      fileElem.attr('accept', attrGetter('accept'));
	    }));
	    function bindAttrToFileInput(fileElem, label) {
	      function updateId(val) {
	        fileElem.attr('id', 'ngf-' + val);
	        label.attr('id', 'ngf-label-' + val);
	      }
	
	      for (var i = 0; i < elem[0].attributes.length; i++) {
	        var attribute = elem[0].attributes[i];
	        if (attribute.name !== 'type' && attribute.name !== 'class' && attribute.name !== 'style') {
	          if (attribute.name === 'id') {
	            updateId(attribute.value);
	            unwatches.push(attr.$observe('id', updateId));
	          } else {
	            fileElem.attr(attribute.name, (!attribute.value && (attribute.name === 'required' ||
	            attribute.name === 'multiple')) ? attribute.name : attribute.value);
	          }
	        }
	      }
	    }
	
	    function createFileInput() {
	      if (isInputTypeFile()) {
	        return elem;
	      }
	
	      var fileElem = angular.element('<input type="file">');
	
	      var label = angular.element('<label>upload</label>');
	      label.css('visibility', 'hidden').css('position', 'absolute').css('overflow', 'hidden')
	        .css('width', '0px').css('height', '0px').css('border', 'none')
	        .css('margin', '0px').css('padding', '0px').attr('tabindex', '-1');
	      bindAttrToFileInput(fileElem, label);
	
	      generatedElems.push({el: elem, ref: label});
	
	      document.body.appendChild(label.append(fileElem)[0]);
	
	      return fileElem;
	    }
	
	    function clickHandler(evt) {
	      if (elem.attr('disabled')) return false;
	      if (attrGetter('ngfSelectDisabled', scope)) return;
	
	      var r = detectSwipe(evt);
	      // prevent the click if it is a swipe
	      if (r != null) return r;
	
	      resetModel(evt);
	
	      // fix for md when the element is removed from the DOM and added back #460
	      try {
	        if (!isInputTypeFile() && !document.body.contains(fileElem[0])) {
	          generatedElems.push({el: elem, ref: fileElem.parent()});
	          document.body.appendChild(fileElem.parent()[0]);
	          fileElem.bind('change', changeFn);
	        }
	      } catch (e) {/*ignore*/
	      }
	
	      if (isDelayedClickSupported(navigator.userAgent)) {
	        setTimeout(function () {
	          fileElem[0].click();
	        }, 0);
	      } else {
	        fileElem[0].click();
	      }
	
	      return false;
	    }
	
	
	    var initialTouchStartY = 0;
	    var initialTouchStartX = 0;
	
	    function detectSwipe(evt) {
	      var touches = evt.changedTouches || (evt.originalEvent && evt.originalEvent.changedTouches);
	      if (touches) {
	        if (evt.type === 'touchstart') {
	          initialTouchStartX = touches[0].clientX;
	          initialTouchStartY = touches[0].clientY;
	          return true; // don't block event default
	        } else {
	          // prevent scroll from triggering event
	          if (evt.type === 'touchend') {
	            var currentX = touches[0].clientX;
	            var currentY = touches[0].clientY;
	            if ((Math.abs(currentX - initialTouchStartX) > 20) ||
	              (Math.abs(currentY - initialTouchStartY) > 20)) {
	              evt.stopPropagation();
	              evt.preventDefault();
	              return false;
	            }
	          }
	          return true;
	        }
	      }
	    }
	
	    var fileElem = elem;
	
	    function resetModel(evt) {
	      if (upload.shouldUpdateOn('click', attr, scope) && fileElem.val()) {
	        fileElem.val(null);
	        upload.updateModel(ngModel, attr, scope, fileChangeAttr(), null, evt, true);
	      }
	    }
	
	    if (!isInputTypeFile()) {
	      fileElem = createFileInput();
	    }
	    fileElem.bind('change', changeFn);
	
	    if (!isInputTypeFile()) {
	      elem.bind('click touchstart touchend', clickHandler);
	    } else {
	      elem.bind('click', resetModel);
	    }
	
	    function ie10SameFileSelectFix(evt) {
	      if (fileElem && !fileElem.attr('__ngf_ie10_Fix_')) {
	        if (!fileElem[0].parentNode) {
	          fileElem = null;
	          return;
	        }
	        evt.preventDefault();
	        evt.stopPropagation();
	        fileElem.unbind('click');
	        var clone = fileElem.clone();
	        fileElem.replaceWith(clone);
	        fileElem = clone;
	        fileElem.attr('__ngf_ie10_Fix_', 'true');
	        fileElem.bind('change', changeFn);
	        fileElem.bind('click', ie10SameFileSelectFix);
	        fileElem[0].click();
	        return false;
	      } else {
	        fileElem.removeAttr('__ngf_ie10_Fix_');
	      }
	    }
	
	    if (navigator.appVersion.indexOf('MSIE 10') !== -1) {
	      fileElem.bind('click', ie10SameFileSelectFix);
	    }
	
	    if (ngModel) ngModel.$formatters.push(function (val) {
	      if (val == null || val.length === 0) {
	        if (fileElem.val()) {
	          fileElem.val(null);
	        }
	      }
	      return val;
	    });
	
	    scope.$on('$destroy', function () {
	      if (!isInputTypeFile()) fileElem.parent().remove();
	      angular.forEach(unwatches, function (unwatch) {
	        unwatch();
	      });
	    });
	
	    $timeout(function () {
	      for (var i = 0; i < generatedElems.length; i++) {
	        var g = generatedElems[i];
	        if (!document.body.contains(g.el[0])) {
	          generatedElems.splice(i, 1);
	          g.ref.remove();
	        }
	      }
	    });
	
	    if (window.FileAPI && window.FileAPI.ngfFixIE) {
	      window.FileAPI.ngfFixIE(elem, fileElem, changeFn);
	    }
	  }
	
	  return {
	    restrict: 'AEC',
	    require: '?ngModel',
	    link: function (scope, elem, attr, ngModel) {
	      linkFileSelect(scope, elem, attr, ngModel, $parse, $timeout, $compile, Upload);
	    }
	  };
	}]);
	
	(function () {
	
	  ngFileUpload.service('UploadDataUrl', ['UploadBase', '$timeout', '$q', function (UploadBase, $timeout, $q) {
	    var upload = UploadBase;
	    upload.base64DataUrl = function (file) {
	      if (angular.isArray(file)) {
	        var d = $q.defer(), count = 0;
	        angular.forEach(file, function (f) {
	          upload.dataUrl(f, true)['finally'](function () {
	            count++;
	            if (count === file.length) {
	              var urls = [];
	              angular.forEach(file, function (ff) {
	                urls.push(ff.$ngfDataUrl);
	              });
	              d.resolve(urls, file);
	            }
	          });
	        });
	        return d.promise;
	      } else {
	        return upload.dataUrl(file, true);
	      }
	    };
	    upload.dataUrl = function (file, disallowObjectUrl) {
	      if (!file) return upload.emptyPromise(file, file);
	      if ((disallowObjectUrl && file.$ngfDataUrl != null) || (!disallowObjectUrl && file.$ngfBlobUrl != null)) {
	        return upload.emptyPromise(disallowObjectUrl ? file.$ngfDataUrl : file.$ngfBlobUrl, file);
	      }
	      var p = disallowObjectUrl ? file.$$ngfDataUrlPromise : file.$$ngfBlobUrlPromise;
	      if (p) return p;
	
	      var deferred = $q.defer();
	      $timeout(function () {
	        if (window.FileReader && file &&
	          (!window.FileAPI || navigator.userAgent.indexOf('MSIE 8') === -1 || file.size < 20000) &&
	          (!window.FileAPI || navigator.userAgent.indexOf('MSIE 9') === -1 || file.size < 4000000)) {
	          //prefer URL.createObjectURL for handling refrences to files of all sizes
	          //since it doesn´t build a large string in memory
	          var URL = window.URL || window.webkitURL;
	          if (URL && URL.createObjectURL && !disallowObjectUrl) {
	            var url;
	            try {
	              url = URL.createObjectURL(file);
	            } catch (e) {
	              $timeout(function () {
	                file.$ngfBlobUrl = '';
	                deferred.reject();
	              });
	              return;
	            }
	            $timeout(function () {
	              file.$ngfBlobUrl = url;
	              if (url) {
	                deferred.resolve(url, file);
	                upload.blobUrls = upload.blobUrls || [];
	                upload.blobUrlsTotalSize = upload.blobUrlsTotalSize || 0;
	                upload.blobUrls.push({url: url, size: file.size});
	                upload.blobUrlsTotalSize += file.size || 0;
	                var maxMemory = upload.defaults.blobUrlsMaxMemory || 268435456;
	                var maxLength = upload.defaults.blobUrlsMaxQueueSize || 200;
	                while ((upload.blobUrlsTotalSize > maxMemory || upload.blobUrls.length > maxLength) && upload.blobUrls.length > 1) {
	                  var obj = upload.blobUrls.splice(0, 1)[0];
	                  URL.revokeObjectURL(obj.url);
	                  upload.blobUrlsTotalSize -= obj.size;
	                }
	              }
	            });
	          } else {
	            var fileReader = new FileReader();
	            fileReader.onload = function (e) {
	              $timeout(function () {
	                file.$ngfDataUrl = e.target.result;
	                deferred.resolve(e.target.result, file);
	                $timeout(function () {
	                  delete file.$ngfDataUrl;
	                }, 1000);
	              });
	            };
	            fileReader.onerror = function () {
	              $timeout(function () {
	                file.$ngfDataUrl = '';
	                deferred.reject();
	              });
	            };
	            fileReader.readAsDataURL(file);
	          }
	        } else {
	          $timeout(function () {
	            file[disallowObjectUrl ? '$ngfDataUrl' : '$ngfBlobUrl'] = '';
	            deferred.reject();
	          });
	        }
	      });
	
	      if (disallowObjectUrl) {
	        p = file.$$ngfDataUrlPromise = deferred.promise;
	      } else {
	        p = file.$$ngfBlobUrlPromise = deferred.promise;
	      }
	      p['finally'](function () {
	        delete file[disallowObjectUrl ? '$$ngfDataUrlPromise' : '$$ngfBlobUrlPromise'];
	      });
	      return p;
	    };
	    return upload;
	  }]);
	
	  function getTagType(el) {
	    if (el.tagName.toLowerCase() === 'img') return 'image';
	    if (el.tagName.toLowerCase() === 'audio') return 'audio';
	    if (el.tagName.toLowerCase() === 'video') return 'video';
	    return /./;
	  }
	
	  function linkFileDirective(Upload, $timeout, scope, elem, attr, directiveName, resizeParams, isBackground) {
	    function constructDataUrl(file) {
	      var disallowObjectUrl = Upload.attrGetter('ngfNoObjectUrl', attr, scope);
	      Upload.dataUrl(file, disallowObjectUrl)['finally'](function () {
	        $timeout(function () {
	          var src = (disallowObjectUrl ? file.$ngfDataUrl : file.$ngfBlobUrl) || file.$ngfDataUrl;
	          if (isBackground) {
	            elem.css('background-image', 'url(\'' + (src || '') + '\')');
	          } else {
	            elem.attr('src', src);
	          }
	          if (src) {
	            elem.removeClass('ng-hide');
	          } else {
	            elem.addClass('ng-hide');
	          }
	        });
	      });
	    }
	
	    $timeout(function () {
	      var unwatch = scope.$watch(attr[directiveName], function (file) {
	        var size = resizeParams;
	        if (directiveName === 'ngfThumbnail') {
	          if (!size) {
	            size = {
	              width: elem[0].naturalWidth || elem[0].clientWidth,
	              height: elem[0].naturalHeight || elem[0].clientHeight
	            };
	          }
	          if (size.width === 0 && window.getComputedStyle) {
	            var style = getComputedStyle(elem[0]);
	            if (style.width && style.width.indexOf('px') > -1 && style.height && style.height.indexOf('px') > -1) {
	              size = {
	                width: parseInt(style.width.slice(0, -2)),
	                height: parseInt(style.height.slice(0, -2))
	              };
	            }
	          }
	        }
	
	        if (angular.isString(file)) {
	          elem.removeClass('ng-hide');
	          if (isBackground) {
	            return elem.css('background-image', 'url(\'' + file + '\')');
	          } else {
	            return elem.attr('src', file);
	          }
	        }
	        if (file && file.type && file.type.search(getTagType(elem[0])) === 0 &&
	          (!isBackground || file.type.indexOf('image') === 0)) {
	          if (size && Upload.isResizeSupported()) {
	            size.resizeIf = function (width, height) {
	              return Upload.attrGetter('ngfResizeIf', attr, scope,
	                {$width: width, $height: height, $file: file});
	            };
	            Upload.resize(file, size).then(
	              function (f) {
	                constructDataUrl(f);
	              }, function (e) {
	                throw e;
	              }
	            );
	          } else {
	            constructDataUrl(file);
	          }
	        } else {
	          elem.addClass('ng-hide');
	        }
	      });
	
	      scope.$on('$destroy', function () {
	        unwatch();
	      });
	    });
	  }
	
	
	  /** @namespace attr.ngfSrc */
	  /** @namespace attr.ngfNoObjectUrl */
	  ngFileUpload.directive('ngfSrc', ['Upload', '$timeout', function (Upload, $timeout) {
	    return {
	      restrict: 'AE',
	      link: function (scope, elem, attr) {
	        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfSrc',
	          Upload.attrGetter('ngfResize', attr, scope), false);
	      }
	    };
	  }]);
	
	  /** @namespace attr.ngfBackground */
	  /** @namespace attr.ngfNoObjectUrl */
	  ngFileUpload.directive('ngfBackground', ['Upload', '$timeout', function (Upload, $timeout) {
	    return {
	      restrict: 'AE',
	      link: function (scope, elem, attr) {
	        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfBackground',
	          Upload.attrGetter('ngfResize', attr, scope), true);
	      }
	    };
	  }]);
	
	  /** @namespace attr.ngfThumbnail */
	  /** @namespace attr.ngfAsBackground */
	  /** @namespace attr.ngfSize */
	  /** @namespace attr.ngfNoObjectUrl */
	  ngFileUpload.directive('ngfThumbnail', ['Upload', '$timeout', function (Upload, $timeout) {
	    return {
	      restrict: 'AE',
	      link: function (scope, elem, attr) {
	        var size = Upload.attrGetter('ngfSize', attr, scope);
	        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfThumbnail', size,
	          Upload.attrGetter('ngfAsBackground', attr, scope));
	      }
	    };
	  }]);
	
	  ngFileUpload.config(['$compileProvider', function ($compileProvider) {
	    if ($compileProvider.imgSrcSanitizationWhitelist) $compileProvider.imgSrcSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|webcal|local|file|data|blob):/);
	    if ($compileProvider.aHrefSanitizationWhitelist) $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|webcal|local|file|data|blob):/);
	  }]);
	
	  ngFileUpload.filter('ngfDataUrl', ['UploadDataUrl', '$sce', function (UploadDataUrl, $sce) {
	    return function (file, disallowObjectUrl, trustedUrl) {
	      if (angular.isString(file)) {
	        return $sce.trustAsResourceUrl(file);
	      }
	      var src = file && ((disallowObjectUrl ? file.$ngfDataUrl : file.$ngfBlobUrl) || file.$ngfDataUrl);
	      if (file && !src) {
	        if (!file.$ngfDataUrlFilterInProgress && angular.isObject(file)) {
	          file.$ngfDataUrlFilterInProgress = true;
	          UploadDataUrl.dataUrl(file, disallowObjectUrl);
	        }
	        return '';
	      }
	      if (file) delete file.$ngfDataUrlFilterInProgress;
	      return (file && src ? (trustedUrl ? $sce.trustAsResourceUrl(src) : src) : file) || '';
	    };
	  }]);
	
	})();
	
	ngFileUpload.service('UploadValidate', ['UploadDataUrl', '$q', '$timeout', function (UploadDataUrl, $q, $timeout) {
	  var upload = UploadDataUrl;
	
	  function globStringToRegex(str) {
	    var regexp = '', excludes = [];
	    if (str.length > 2 && str[0] === '/' && str[str.length - 1] === '/') {
	      regexp = str.substring(1, str.length - 1);
	    } else {
	      var split = str.split(',');
	      if (split.length > 1) {
	        for (var i = 0; i < split.length; i++) {
	          var r = globStringToRegex(split[i]);
	          if (r.regexp) {
	            regexp += '(' + r.regexp + ')';
	            if (i < split.length - 1) {
	              regexp += '|';
	            }
	          } else {
	            excludes = excludes.concat(r.excludes);
	          }
	        }
	      } else {
	        if (str.indexOf('!') === 0) {
	          excludes.push('^((?!' + globStringToRegex(str.substring(1)).regexp + ').)*$');
	        } else {
	          if (str.indexOf('.') === 0) {
	            str = '*' + str;
	          }
	          regexp = '^' + str.replace(new RegExp('[.\\\\+*?\\[\\^\\]$(){}=!<>|:\\-]', 'g'), '\\$&') + '$';
	          regexp = regexp.replace(/\\\*/g, '.*').replace(/\\\?/g, '.');
	        }
	      }
	    }
	    return {regexp: regexp, excludes: excludes};
	  }
	
	  upload.validatePattern = function (file, val) {
	    if (!val) {
	      return true;
	    }
	    var pattern = globStringToRegex(val), valid = true;
	    if (pattern.regexp && pattern.regexp.length) {
	      var regexp = new RegExp(pattern.regexp, 'i');
	      valid = (file.type != null && regexp.test(file.type)) ||
	        (file.name != null && regexp.test(file.name));
	    }
	    var len = pattern.excludes.length;
	    while (len--) {
	      var exclude = new RegExp(pattern.excludes[len], 'i');
	      valid = valid && (file.type == null || exclude.test(file.type)) &&
	        (file.name == null || exclude.test(file.name));
	    }
	    return valid;
	  };
	
	  upload.ratioToFloat = function (val) {
	    var r = val.toString(), xIndex = r.search(/[x:]/i);
	    if (xIndex > -1) {
	      r = parseFloat(r.substring(0, xIndex)) / parseFloat(r.substring(xIndex + 1));
	    } else {
	      r = parseFloat(r);
	    }
	    return r;
	  };
	
	  upload.registerModelChangeValidator = function (ngModel, attr, scope) {
	    if (ngModel) {
	      ngModel.$formatters.push(function (files) {
	        if (ngModel.$dirty) {
	          var filesArray = files;
	          if (files && !angular.isArray(files)) {
	            filesArray = [files];
	          }
	          upload.validate(filesArray, 0, ngModel, attr, scope).then(function () {
	            upload.applyModelValidation(ngModel, filesArray);
	          });
	        }
	        return files;
	      });
	    }
	  };
	
	  function markModelAsDirty(ngModel, files) {
	    if (files != null && !ngModel.$dirty) {
	      if (ngModel.$setDirty) {
	        ngModel.$setDirty();
	      } else {
	        ngModel.$dirty = true;
	      }
	    }
	  }
	
	  upload.applyModelValidation = function (ngModel, files) {
	    markModelAsDirty(ngModel, files);
	    angular.forEach(ngModel.$ngfValidations, function (validation) {
	      ngModel.$setValidity(validation.name, validation.valid);
	    });
	  };
	
	  upload.getValidationAttr = function (attr, scope, name, validationName, file) {
	    var dName = 'ngf' + name[0].toUpperCase() + name.substr(1);
	    var val = upload.attrGetter(dName, attr, scope, {$file: file});
	    if (val == null) {
	      val = upload.attrGetter('ngfValidate', attr, scope, {$file: file});
	      if (val) {
	        var split = (validationName || name).split('.');
	        val = val[split[0]];
	        if (split.length > 1) {
	          val = val && val[split[1]];
	        }
	      }
	    }
	    return val;
	  };
	
	  upload.validate = function (files, prevLength, ngModel, attr, scope) {
	    ngModel = ngModel || {};
	    ngModel.$ngfValidations = ngModel.$ngfValidations || [];
	
	    angular.forEach(ngModel.$ngfValidations, function (v) {
	      v.valid = true;
	    });
	
	    var attrGetter = function (name, params) {
	      return upload.attrGetter(name, attr, scope, params);
	    };
	
	    var ignoredErrors = (upload.attrGetter('ngfIgnoreInvalid', attr, scope) || '').split(' ');
	    var runAllValidation = upload.attrGetter('ngfRunAllValidations', attr, scope);
	
	    if (files == null || files.length === 0) {
	      return upload.emptyPromise({'validFiles': files, 'invalidFiles': []});
	    }
	
	    files = files.length === undefined ? [files] : files.slice(0);
	    var invalidFiles = [];
	
	    function validateSync(name, validationName, fn) {
	      if (files) {
	        var i = files.length, valid = null;
	        while (i--) {
	          var file = files[i];
	          if (file) {
	            var val = upload.getValidationAttr(attr, scope, name, validationName, file);
	            if (val != null) {
	              if (!fn(file, val, i)) {
	                if (ignoredErrors.indexOf(name) === -1) {
	                  file.$error = name;
	                  (file.$errorMessages = (file.$errorMessages || {}))[name] = true;
	                  file.$errorParam = val;
	                  if (invalidFiles.indexOf(file) === -1) {
	                    invalidFiles.push(file);
	                  }
	                  if (!runAllValidation) {
	                    files.splice(i, 1);
	                  }
	                  valid = false;
	                } else {
	                  files.splice(i, 1);
	                }
	              }
	            }
	          }
	        }
	        if (valid !== null) {
	          ngModel.$ngfValidations.push({name: name, valid: valid});
	        }
	      }
	    }
	
	    validateSync('pattern', null, upload.validatePattern);
	    validateSync('minSize', 'size.min', function (file, val) {
	      return file.size + 0.1 >= upload.translateScalars(val);
	    });
	    validateSync('maxSize', 'size.max', function (file, val) {
	      return file.size - 0.1 <= upload.translateScalars(val);
	    });
	    var totalSize = 0;
	    validateSync('maxTotalSize', null, function (file, val) {
	      totalSize += file.size;
	      if (totalSize > upload.translateScalars(val)) {
	        files.splice(0, files.length);
	        return false;
	      }
	      return true;
	    });
	
	    validateSync('validateFn', null, function (file, r) {
	      return r === true || r === null || r === '';
	    });
	
	    if (!files.length) {
	      return upload.emptyPromise({'validFiles': [], 'invalidFiles': invalidFiles});
	    }
	
	    function validateAsync(name, validationName, type, asyncFn, fn) {
	      function resolveResult(defer, file, val) {
	        function resolveInternal(fn) {
	          if (fn()) {
	            if (ignoredErrors.indexOf(name) === -1) {
	              file.$error = name;
	              (file.$errorMessages = (file.$errorMessages || {}))[name] = true;
	              file.$errorParam = val;
	              if (invalidFiles.indexOf(file) === -1) {
	                invalidFiles.push(file);
	              }
	              if (!runAllValidation) {
	                var i = files.indexOf(file);
	                if (i > -1) files.splice(i, 1);
	              }
	              defer.resolve(false);
	            } else {
	              var j = files.indexOf(file);
	              if (j > -1) files.splice(j, 1);
	              defer.resolve(true);
	            }
	          } else {
	            defer.resolve(true);
	          }
	        }
	
	        if (val != null) {
	          asyncFn(file, val).then(function (d) {
	            resolveInternal(function () {
	              return !fn(d, val);
	            });
	          }, function () {
	            resolveInternal(function () {
	              return attrGetter('ngfValidateForce', {$file: file});
	            });
	          });
	        } else {
	          defer.resolve(true);
	        }
	      }
	
	      var promises = [upload.emptyPromise(true)];
	      if (files) {
	        files = files.length === undefined ? [files] : files;
	        angular.forEach(files, function (file) {
	          var defer = $q.defer();
	          promises.push(defer.promise);
	          if (type && (file.type == null || file.type.search(type) !== 0)) {
	            defer.resolve(true);
	            return;
	          }
	          if (name === 'dimensions' && upload.attrGetter('ngfDimensions', attr) != null) {
	            upload.imageDimensions(file).then(function (d) {
	              resolveResult(defer, file,
	                attrGetter('ngfDimensions', {$file: file, $width: d.width, $height: d.height}));
	            }, function () {
	              defer.resolve(false);
	            });
	          } else if (name === 'duration' && upload.attrGetter('ngfDuration', attr) != null) {
	            upload.mediaDuration(file).then(function (d) {
	              resolveResult(defer, file,
	                attrGetter('ngfDuration', {$file: file, $duration: d}));
	            }, function () {
	              defer.resolve(false);
	            });
	          } else {
	            resolveResult(defer, file,
	              upload.getValidationAttr(attr, scope, name, validationName, file));
	          }
	        });
	      }
	      var deffer = $q.defer();
	      $q.all(promises).then(function (values) {
	        var isValid = true;
	        for (var i = 0; i < values.length; i++) {
	          if (!values[i]) {
	            isValid = false;
	            break;
	          }
	        }
	        ngModel.$ngfValidations.push({name: name, valid: isValid});
	        deffer.resolve(isValid);
	      });
	      return deffer.promise;
	    }
	
	    var deffer = $q.defer();
	    var promises = [];
	
	    promises.push(validateAsync('maxHeight', 'height.max', /image/,
	      this.imageDimensions, function (d, val) {
	        return d.height <= val;
	      }));
	    promises.push(validateAsync('minHeight', 'height.min', /image/,
	      this.imageDimensions, function (d, val) {
	        return d.height >= val;
	      }));
	    promises.push(validateAsync('maxWidth', 'width.max', /image/,
	      this.imageDimensions, function (d, val) {
	        return d.width <= val;
	      }));
	    promises.push(validateAsync('minWidth', 'width.min', /image/,
	      this.imageDimensions, function (d, val) {
	        return d.width >= val;
	      }));
	    promises.push(validateAsync('dimensions', null, /image/,
	      function (file, val) {
	        return upload.emptyPromise(val);
	      }, function (r) {
	        return r;
	      }));
	    promises.push(validateAsync('ratio', null, /image/,
	      this.imageDimensions, function (d, val) {
	        var split = val.toString().split(','), valid = false;
	        for (var i = 0; i < split.length; i++) {
	          if (Math.abs((d.width / d.height) - upload.ratioToFloat(split[i])) < 0.01) {
	            valid = true;
	          }
	        }
	        return valid;
	      }));
	    promises.push(validateAsync('maxRatio', 'ratio.max', /image/,
	      this.imageDimensions, function (d, val) {
	        return (d.width / d.height) - upload.ratioToFloat(val) < 0.0001;
	      }));
	    promises.push(validateAsync('minRatio', 'ratio.min', /image/,
	      this.imageDimensions, function (d, val) {
	        return (d.width / d.height) - upload.ratioToFloat(val) > -0.0001;
	      }));
	    promises.push(validateAsync('maxDuration', 'duration.max', /audio|video/,
	      this.mediaDuration, function (d, val) {
	        return d <= upload.translateScalars(val);
	      }));
	    promises.push(validateAsync('minDuration', 'duration.min', /audio|video/,
	      this.mediaDuration, function (d, val) {
	        return d >= upload.translateScalars(val);
	      }));
	    promises.push(validateAsync('duration', null, /audio|video/,
	      function (file, val) {
	        return upload.emptyPromise(val);
	      }, function (r) {
	        return r;
	      }));
	
	    promises.push(validateAsync('validateAsyncFn', null, null,
	      function (file, val) {
	        return val;
	      }, function (r) {
	        return r === true || r === null || r === '';
	      }));
	
	    $q.all(promises).then(function () {
	
	      if (runAllValidation) {
	        for (var i = 0; i < files.length; i++) {
	          var file = files[i];
	          if (file.$error) {
	            files.splice(i--, 1);
	          }
	        }
	      }
	
	      runAllValidation = false;
	      validateSync('maxFiles', null, function (file, val, i) {
	        return prevLength + i < val;
	      });
	
	      deffer.resolve({'validFiles': files, 'invalidFiles': invalidFiles});
	    });
	    return deffer.promise;
	  };
	
	  upload.imageDimensions = function (file) {
	    if (file.$ngfWidth && file.$ngfHeight) {
	      var d = $q.defer();
	      $timeout(function () {
	        d.resolve({width: file.$ngfWidth, height: file.$ngfHeight});
	      });
	      return d.promise;
	    }
	    if (file.$ngfDimensionPromise) return file.$ngfDimensionPromise;
	
	    var deferred = $q.defer();
	    $timeout(function () {
	      if (file.type.indexOf('image') !== 0) {
	        deferred.reject('not image');
	        return;
	      }
	      upload.dataUrl(file).then(function (dataUrl) {
	        var img = angular.element('<img>').attr('src', dataUrl)
	          .css('visibility', 'hidden').css('position', 'fixed')
	          .css('max-width', 'none !important').css('max-height', 'none !important');
	
	        function success() {
	          var width = img[0].naturalWidth || img[0].clientWidth;
	          var height = img[0].naturalHeight || img[0].clientHeight;
	          img.remove();
	          file.$ngfWidth = width;
	          file.$ngfHeight = height;
	          deferred.resolve({width: width, height: height});
	        }
	
	        function error() {
	          img.remove();
	          deferred.reject('load error');
	        }
	
	        img.on('load', success);
	        img.on('error', error);
	
	        var secondsCounter = 0;
	        function checkLoadErrorInCaseOfNoCallback() {
	          $timeout(function () {
	            if (img[0].parentNode) {
	              if (img[0].clientWidth) {
	                success();
	              } else if (secondsCounter++ > 10) {
	                error();
	              } else {
	                checkLoadErrorInCaseOfNoCallback();
	              }
	            }
	          }, 1000);
	        }
	
	        checkLoadErrorInCaseOfNoCallback();
	
	        angular.element(document.getElementsByTagName('body')[0]).append(img);
	      }, function () {
	        deferred.reject('load error');
	      });
	    });
	
	    file.$ngfDimensionPromise = deferred.promise;
	    file.$ngfDimensionPromise['finally'](function () {
	      delete file.$ngfDimensionPromise;
	    });
	    return file.$ngfDimensionPromise;
	  };
	
	  upload.mediaDuration = function (file) {
	    if (file.$ngfDuration) {
	      var d = $q.defer();
	      $timeout(function () {
	        d.resolve(file.$ngfDuration);
	      });
	      return d.promise;
	    }
	    if (file.$ngfDurationPromise) return file.$ngfDurationPromise;
	
	    var deferred = $q.defer();
	    $timeout(function () {
	      if (file.type.indexOf('audio') !== 0 && file.type.indexOf('video') !== 0) {
	        deferred.reject('not media');
	        return;
	      }
	      upload.dataUrl(file).then(function (dataUrl) {
	        var el = angular.element(file.type.indexOf('audio') === 0 ? '<audio>' : '<video>')
	          .attr('src', dataUrl).css('visibility', 'none').css('position', 'fixed');
	
	        function success() {
	          var duration = el[0].duration;
	          file.$ngfDuration = duration;
	          el.remove();
	          deferred.resolve(duration);
	        }
	
	        function error() {
	          el.remove();
	          deferred.reject('load error');
	        }
	
	        el.on('loadedmetadata', success);
	        el.on('error', error);
	        var count = 0;
	
	        function checkLoadError() {
	          $timeout(function () {
	            if (el[0].parentNode) {
	              if (el[0].duration) {
	                success();
	              } else if (count > 10) {
	                error();
	              } else {
	                checkLoadError();
	              }
	            }
	          }, 1000);
	        }
	
	        checkLoadError();
	
	        angular.element(document.body).append(el);
	      }, function () {
	        deferred.reject('load error');
	      });
	    });
	
	    file.$ngfDurationPromise = deferred.promise;
	    file.$ngfDurationPromise['finally'](function () {
	      delete file.$ngfDurationPromise;
	    });
	    return file.$ngfDurationPromise;
	  };
	  return upload;
	}
	]);
	
	ngFileUpload.service('UploadResize', ['UploadValidate', '$q', function (UploadValidate, $q) {
	  var upload = UploadValidate;
	
	  /**
	   * Conserve aspect ratio of the original region. Useful when shrinking/enlarging
	   * images to fit into a certain area.
	   * Source:  http://stackoverflow.com/a/14731922
	   *
	   * @param {Number} srcWidth Source area width
	   * @param {Number} srcHeight Source area height
	   * @param {Number} maxWidth Nestable area maximum available width
	   * @param {Number} maxHeight Nestable area maximum available height
	   * @return {Object} { width, height }
	   */
	  var calculateAspectRatioFit = function (srcWidth, srcHeight, maxWidth, maxHeight, centerCrop) {
	    var ratio = centerCrop ? Math.max(maxWidth / srcWidth, maxHeight / srcHeight) :
	      Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
	    return {
	      width: srcWidth * ratio, height: srcHeight * ratio,
	      marginX: srcWidth * ratio - maxWidth, marginY: srcHeight * ratio - maxHeight
	    };
	  };
	
	  // Extracted from https://github.com/romelgomez/angular-firebase-image-upload/blob/master/app/scripts/fileUpload.js#L89
	  var resize = function (imagen, width, height, quality, type, ratio, centerCrop, resizeIf) {
	    var deferred = $q.defer();
	    var canvasElement = document.createElement('canvas');
	    var imageElement = document.createElement('img');
	    imageElement.setAttribute('style', 'visibility:hidden;position:fixed;z-index:-100000');
	    document.body.appendChild(imageElement);
	
	    imageElement.onload = function () {
	      var imgWidth = imageElement.width, imgHeight = imageElement.height;
	      imageElement.parentNode.removeChild(imageElement);
	      if (resizeIf != null && resizeIf(imgWidth, imgHeight) === false) {
	        deferred.reject('resizeIf');
	        return;
	      }
	      try {
	        if (ratio) {
	          var ratioFloat = upload.ratioToFloat(ratio);
	          var imgRatio = imgWidth / imgHeight;
	          if (imgRatio < ratioFloat) {
	            width = imgWidth;
	            height = width / ratioFloat;
	          } else {
	            height = imgHeight;
	            width = height * ratioFloat;
	          }
	        }
	        if (!width) {
	          width = imgWidth;
	        }
	        if (!height) {
	          height = imgHeight;
	        }
	        var dimensions = calculateAspectRatioFit(imgWidth, imgHeight, width, height, centerCrop);
	        canvasElement.width = Math.min(dimensions.width, width);
	        canvasElement.height = Math.min(dimensions.height, height);
	        var context = canvasElement.getContext('2d');
	        context.drawImage(imageElement,
	          Math.min(0, -dimensions.marginX / 2), Math.min(0, -dimensions.marginY / 2),
	          dimensions.width, dimensions.height);
	        deferred.resolve(canvasElement.toDataURL(type || 'image/WebP', quality || 0.934));
	      } catch (e) {
	        deferred.reject(e);
	      }
	    };
	    imageElement.onerror = function () {
	      imageElement.parentNode.removeChild(imageElement);
	      deferred.reject();
	    };
	    imageElement.src = imagen;
	    return deferred.promise;
	  };
	
	  upload.dataUrltoBlob = function (dataurl, name, origSize) {
	    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
	      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
	    while (n--) {
	      u8arr[n] = bstr.charCodeAt(n);
	    }
	    var blob = new window.Blob([u8arr], {type: mime});
	    blob.name = name;
	    blob.$ngfOrigSize = origSize;
	    return blob;
	  };
	
	  upload.isResizeSupported = function () {
	    var elem = document.createElement('canvas');
	    return window.atob && elem.getContext && elem.getContext('2d') && window.Blob;
	  };
	
	  if (upload.isResizeSupported()) {
	    // add name getter to the blob constructor prototype
	    Object.defineProperty(window.Blob.prototype, 'name', {
	      get: function () {
	        return this.$ngfName;
	      },
	      set: function (v) {
	        this.$ngfName = v;
	      },
	      configurable: true
	    });
	  }
	
	  upload.resize = function (file, options) {
	    if (file.type.indexOf('image') !== 0) return upload.emptyPromise(file);
	
	    var deferred = $q.defer();
	    upload.dataUrl(file, true).then(function (url) {
	      resize(url, options.width, options.height, options.quality, options.type || file.type,
	        options.ratio, options.centerCrop, options.resizeIf)
	        .then(function (dataUrl) {
	          if (file.type === 'image/jpeg' && options.restoreExif !== false) {
	            try {
	              dataUrl = upload.restoreExif(url, dataUrl);
	            } catch (e) {
	              setTimeout(function () {throw e;}, 1);
	            }
	          }
	          try {
	            var blob = upload.dataUrltoBlob(dataUrl, file.name, file.size);
	            deferred.resolve(blob);
	          } catch (e) {
	            deferred.reject(e);
	          }
	        }, function (r) {
	          if (r === 'resizeIf') {
	            deferred.resolve(file);
	          }
	          deferred.reject(r);
	        });
	    }, function (e) {
	      deferred.reject(e);
	    });
	    return deferred.promise;
	  };
	
	  return upload;
	}]);
	
	(function () {
	  ngFileUpload.directive('ngfDrop', ['$parse', '$timeout', '$window', 'Upload', '$http', '$q',
	    function ($parse, $timeout, $window, Upload, $http, $q) {
	      return {
	        restrict: 'AEC',
	        require: '?ngModel',
	        link: function (scope, elem, attr, ngModel) {
	          linkDrop(scope, elem, attr, ngModel, $parse, $timeout, $window, Upload, $http, $q);
	        }
	      };
	    }]);
	
	  ngFileUpload.directive('ngfNoFileDrop', function () {
	    return function (scope, elem) {
	      if (dropAvailable()) elem.css('display', 'none');
	    };
	  });
	
	  ngFileUpload.directive('ngfDropAvailable', ['$parse', '$timeout', 'Upload', function ($parse, $timeout, Upload) {
	    return function (scope, elem, attr) {
	      if (dropAvailable()) {
	        var model = $parse(Upload.attrGetter('ngfDropAvailable', attr));
	        $timeout(function () {
	          model(scope);
	          if (model.assign) {
	            model.assign(scope, true);
	          }
	        });
	      }
	    };
	  }]);
	
	  function linkDrop(scope, elem, attr, ngModel, $parse, $timeout, $window, upload, $http, $q) {
	    var available = dropAvailable();
	
	    var attrGetter = function (name, scope, params) {
	      return upload.attrGetter(name, attr, scope, params);
	    };
	
	    if (attrGetter('dropAvailable')) {
	      $timeout(function () {
	        if (scope[attrGetter('dropAvailable')]) {
	          scope[attrGetter('dropAvailable')].value = available;
	        } else {
	          scope[attrGetter('dropAvailable')] = available;
	        }
	      });
	    }
	    if (!available) {
	      if (attrGetter('ngfHideOnDropNotAvailable', scope) === true) {
	        elem.css('display', 'none');
	      }
	      return;
	    }
	
	    function isDisabled() {
	      return elem.attr('disabled') || attrGetter('ngfDropDisabled', scope);
	    }
	
	    if (attrGetter('ngfSelect') == null) {
	      upload.registerModelChangeValidator(ngModel, attr, scope);
	    }
	
	    var leaveTimeout = null;
	    var stopPropagation = $parse(attrGetter('ngfStopPropagation'));
	    var dragOverDelay = 1;
	    var actualDragOverClass;
	
	    elem[0].addEventListener('dragover', function (evt) {
	      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	      // handling dragover events from the Chrome download bar
	      if (navigator.userAgent.indexOf('Chrome') > -1) {
	        var b = evt.dataTransfer.effectAllowed;
	        evt.dataTransfer.dropEffect = ('move' === b || 'linkMove' === b) ? 'move' : 'copy';
	      }
	      $timeout.cancel(leaveTimeout);
	      if (!actualDragOverClass) {
	        actualDragOverClass = 'C';
	        calculateDragOverClass(scope, attr, evt, function (clazz) {
	          actualDragOverClass = clazz;
	          elem.addClass(actualDragOverClass);
	          attrGetter('ngfDrag', scope, {$isDragging: true, $class: actualDragOverClass, $event: evt});
	        });
	      }
	    }, false);
	    elem[0].addEventListener('dragenter', function (evt) {
	      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	    }, false);
	    elem[0].addEventListener('dragleave', function (evt) {
	      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	      leaveTimeout = $timeout(function () {
	        if (actualDragOverClass) elem.removeClass(actualDragOverClass);
	        actualDragOverClass = null;
	        attrGetter('ngfDrag', scope, {$isDragging: false, $event: evt});
	      }, dragOverDelay || 100);
	    }, false);
	    elem[0].addEventListener('drop', function (evt) {
	      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	      if (actualDragOverClass) elem.removeClass(actualDragOverClass);
	      actualDragOverClass = null;
	      extractFilesAndUpdateModel(evt.dataTransfer, evt, 'dropUrl');
	    }, false);
	    elem[0].addEventListener('paste', function (evt) {
	      if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1 &&
	        attrGetter('ngfEnableFirefoxPaste', scope)) {
	        evt.preventDefault();
	      }
	      if (isDisabled() || !upload.shouldUpdateOn('paste', attr, scope)) return;
	      extractFilesAndUpdateModel(evt.clipboardData || evt.originalEvent.clipboardData, evt, 'pasteUrl');
	    }, false);
	
	    if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1 &&
	      attrGetter('ngfEnableFirefoxPaste', scope)) {
	      elem.attr('contenteditable', true);
	      elem.on('keypress', function (e) {
	        if (!e.metaKey && !e.ctrlKey) {
	          e.preventDefault();
	        }
	      });
	    }
	
	    function extractFilesAndUpdateModel(source, evt, updateOnType) {
	      if (!source) return;
	      // html needs to be calculated on the same process otherwise the data will be wiped
	      // after promise resolve or setTimeout.
	      var html;
	      try {
	        html = source && source.getData && source.getData('text/html');
	      } catch (e) {/* Fix IE11 that throw error calling getData */
	      }
	      extractFiles(source.items, source.files, attrGetter('ngfAllowDir', scope) !== false,
	        attrGetter('multiple') || attrGetter('ngfMultiple', scope)).then(function (files) {
	        if (files.length) {
	          updateModel(files, evt);
	        } else {
	          extractFilesFromHtml(updateOnType, html).then(function (files) {
	            updateModel(files, evt);
	          });
	        }
	      });
	    }
	
	    function updateModel(files, evt) {
	      upload.updateModel(ngModel, attr, scope, attrGetter('ngfChange') || attrGetter('ngfDrop'), files, evt);
	    }
	
	    function extractFilesFromHtml(updateOn, html) {
	      if (!upload.shouldUpdateOn(updateOn, attr, scope) || typeof html !== 'string') return upload.rejectPromise([]);
	      var urls = [];
	      html.replace(/<(img src|img [^>]* src) *=\"([^\"]*)\"/gi, function (m, n, src) {
	        urls.push(src);
	      });
	      var promises = [], files = [];
	      if (urls.length) {
	        angular.forEach(urls, function (url) {
	          promises.push(upload.urlToBlob(url).then(function (blob) {
	            files.push(blob);
	          }));
	        });
	        var defer = $q.defer();
	        $q.all(promises).then(function () {
	          defer.resolve(files);
	        }, function (e) {
	          defer.reject(e);
	        });
	        return defer.promise;
	      }
	      return upload.emptyPromise();
	    }
	
	    function calculateDragOverClass(scope, attr, evt, callback) {
	      var obj = attrGetter('ngfDragOverClass', scope, {$event: evt}), dClass = 'dragover';
	      if (angular.isString(obj)) {
	        dClass = obj;
	      } else if (obj) {
	        if (obj.delay) dragOverDelay = obj.delay;
	        if (obj.accept || obj.reject) {
	          var items = evt.dataTransfer.items;
	          if (items == null || !items.length) {
	            dClass = obj.accept;
	          } else {
	            var pattern = obj.pattern || attrGetter('ngfPattern', scope, {$event: evt});
	            var len = items.length;
	            while (len--) {
	              if (!upload.validatePattern(items[len], pattern)) {
	                dClass = obj.reject;
	                break;
	              } else {
	                dClass = obj.accept;
	              }
	            }
	          }
	        }
	      }
	      callback(dClass);
	    }
	
	    function extractFiles(items, fileList, allowDir, multiple) {
	      var maxFiles = upload.getValidationAttr(attr, scope, 'maxFiles');
	      if (maxFiles == null) {
	        maxFiles = Number.MAX_VALUE;
	      }
	      var maxTotalSize = upload.getValidationAttr(attr, scope, 'maxTotalSize');
	      if (maxTotalSize == null) {
	        maxTotalSize = Number.MAX_VALUE;
	      }
	      var includeDir = attrGetter('ngfIncludeDir', scope);
	      var files = [], totalSize = 0;
	
	      function traverseFileTree(entry, path) {
	        var defer = $q.defer();
	        if (entry != null) {
	          if (entry.isDirectory) {
	            var promises = [upload.emptyPromise()];
	            if (includeDir) {
	              var file = {type: 'directory'};
	              file.name = file.path = (path || '') + entry.name;
	              files.push(file);
	            }
	            var dirReader = entry.createReader();
	            var entries = [];
	            var readEntries = function () {
	              dirReader.readEntries(function (results) {
	                try {
	                  if (!results.length) {
	                    angular.forEach(entries.slice(0), function (e) {
	                      if (files.length <= maxFiles && totalSize <= maxTotalSize) {
	                        promises.push(traverseFileTree(e, (path ? path : '') + entry.name + '/'));
	                      }
	                    });
	                    $q.all(promises).then(function () {
	                      defer.resolve();
	                    }, function (e) {
	                      defer.reject(e);
	                    });
	                  } else {
	                    entries = entries.concat(Array.prototype.slice.call(results || [], 0));
	                    readEntries();
	                  }
	                } catch (e) {
	                  defer.reject(e);
	                }
	              }, function (e) {
	                defer.reject(e);
	              });
	            };
	            readEntries();
	          } else {
	            entry.file(function (file) {
	              try {
	                file.path = (path ? path : '') + file.name;
	                if (includeDir) {
	                  file = upload.rename(file, file.path);
	                }
	                files.push(file);
	                totalSize += file.size;
	                defer.resolve();
	              } catch (e) {
	                defer.reject(e);
	              }
	            }, function (e) {
	              defer.reject(e);
	            });
	          }
	        }
	        return defer.promise;
	      }
	
	      var promises = [upload.emptyPromise()];
	
	      if (items && items.length > 0 && $window.location.protocol !== 'file:') {
	        for (var i = 0; i < items.length; i++) {
	          if (items[i].webkitGetAsEntry && items[i].webkitGetAsEntry() && items[i].webkitGetAsEntry().isDirectory) {
	            var entry = items[i].webkitGetAsEntry();
	            if (entry.isDirectory && !allowDir) {
	              continue;
	            }
	            if (entry != null) {
	              promises.push(traverseFileTree(entry));
	            }
	          } else {
	            var f = items[i].getAsFile();
	            if (f != null) {
	              files.push(f);
	              totalSize += f.size;
	            }
	          }
	          if (files.length > maxFiles || totalSize > maxTotalSize ||
	            (!multiple && files.length > 0)) break;
	        }
	      } else {
	        if (fileList != null) {
	          for (var j = 0; j < fileList.length; j++) {
	            var file = fileList.item(j);
	            if (file.type || file.size > 0) {
	              files.push(file);
	              totalSize += file.size;
	            }
	            if (files.length > maxFiles || totalSize > maxTotalSize ||
	              (!multiple && files.length > 0)) break;
	          }
	        }
	      }
	
	      var defer = $q.defer();
	      $q.all(promises).then(function () {
	        if (!multiple && !includeDir && files.length) {
	          var i = 0;
	          while (files[i] && files[i].type === 'directory') i++;
	          defer.resolve([files[i]]);
	        } else {
	          defer.resolve(files);
	        }
	      }, function (e) {
	        defer.reject(e);
	      });
	
	      return defer.promise;
	    }
	  }
	
	  function dropAvailable() {
	    var div = document.createElement('div');
	    return ('draggable' in div) && ('ondrop' in div) && !/Edge\/12./i.test(navigator.userAgent);
	  }
	
	})();
	
	// customized version of https://github.com/exif-js/exif-js
	ngFileUpload.service('UploadExif', ['UploadResize', '$q', function (UploadResize, $q) {
	  var upload = UploadResize;
	
	  upload.isExifSupported = function () {
	    return window.FileReader && new FileReader().readAsArrayBuffer && upload.isResizeSupported();
	  };
	
	  function applyTransform(ctx, orientation, width, height) {
	    switch (orientation) {
	      case 2:
	        return ctx.transform(-1, 0, 0, 1, width, 0);
	      case 3:
	        return ctx.transform(-1, 0, 0, -1, width, height);
	      case 4:
	        return ctx.transform(1, 0, 0, -1, 0, height);
	      case 5:
	        return ctx.transform(0, 1, 1, 0, 0, 0);
	      case 6:
	        return ctx.transform(0, 1, -1, 0, height, 0);
	      case 7:
	        return ctx.transform(0, -1, -1, 0, height, width);
	      case 8:
	        return ctx.transform(0, -1, 1, 0, 0, width);
	    }
	  }
	
	  upload.readOrientation = function (file) {
	    var defer = $q.defer();
	    var reader = new FileReader();
	    var slicedFile = file.slice ? file.slice(0, 64 * 1024) : file;
	    reader.readAsArrayBuffer(slicedFile);
	    reader.onerror = function (e) {
	      return defer.reject(e);
	    };
	    reader.onload = function (e) {
	      var result = {orientation: 1};
	      var view = new DataView(this.result);
	      if (view.getUint16(0, false) !== 0xFFD8) return defer.resolve(result);
	
	      var length = view.byteLength,
	        offset = 2;
	      while (offset < length) {
	        var marker = view.getUint16(offset, false);
	        offset += 2;
	        if (marker === 0xFFE1) {
	          if (view.getUint32(offset += 2, false) !== 0x45786966) return defer.resolve(result);
	
	          var little = view.getUint16(offset += 6, false) === 0x4949;
	          offset += view.getUint32(offset + 4, little);
	          var tags = view.getUint16(offset, little);
	          offset += 2;
	          for (var i = 0; i < tags; i++)
	            if (view.getUint16(offset + (i * 12), little) === 0x0112) {
	              var orientation = view.getUint16(offset + (i * 12) + 8, little);
	              if (orientation >= 2 && orientation <= 8) {
	                view.setUint16(offset + (i * 12) + 8, 1, little);
	                result.fixedArrayBuffer = e.target.result;
	              }
	              result.orientation = orientation;
	              return defer.resolve(result);
	            }
	        } else if ((marker & 0xFF00) !== 0xFF00) break;
	        else offset += view.getUint16(offset, false);
	      }
	      return defer.resolve(result);
	    };
	    return defer.promise;
	  };
	
	  function arrayBufferToBase64(buffer) {
	    var binary = '';
	    var bytes = new Uint8Array(buffer);
	    var len = bytes.byteLength;
	    for (var i = 0; i < len; i++) {
	      binary += String.fromCharCode(bytes[i]);
	    }
	    return window.btoa(binary);
	  }
	
	  upload.applyExifRotation = function (file) {
	    if (file.type.indexOf('image/jpeg') !== 0) {
	      return upload.emptyPromise(file);
	    }
	
	    var deferred = $q.defer();
	    upload.readOrientation(file).then(function (result) {
	      if (result.orientation < 2 || result.orientation > 8) {
	        return deferred.resolve(file);
	      }
	      upload.dataUrl(file, true).then(function (url) {
	        var canvas = document.createElement('canvas');
	        var img = document.createElement('img');
	
	        img.onload = function () {
	          try {
	            canvas.width = result.orientation > 4 ? img.height : img.width;
	            canvas.height = result.orientation > 4 ? img.width : img.height;
	            var ctx = canvas.getContext('2d');
	            applyTransform(ctx, result.orientation, img.width, img.height);
	            ctx.drawImage(img, 0, 0);
	            var dataUrl = canvas.toDataURL(file.type || 'image/WebP', 0.934);
	            dataUrl = upload.restoreExif(arrayBufferToBase64(result.fixedArrayBuffer), dataUrl);
	            var blob = upload.dataUrltoBlob(dataUrl, file.name);
	            deferred.resolve(blob);
	          } catch (e) {
	            return deferred.reject(e);
	          }
	        };
	        img.onerror = function () {
	          deferred.reject();
	        };
	        img.src = url;
	      }, function (e) {
	        deferred.reject(e);
	      });
	    }, function (e) {
	      deferred.reject(e);
	    });
	    return deferred.promise;
	  };
	
	  upload.restoreExif = function (orig, resized) {
	    var ExifRestorer = {};
	
	    ExifRestorer.KEY_STR = 'ABCDEFGHIJKLMNOP' +
	      'QRSTUVWXYZabcdef' +
	      'ghijklmnopqrstuv' +
	      'wxyz0123456789+/' +
	      '=';
	
	    ExifRestorer.encode64 = function (input) {
	      var output = '',
	        chr1, chr2, chr3 = '',
	        enc1, enc2, enc3, enc4 = '',
	        i = 0;
	
	      do {
	        chr1 = input[i++];
	        chr2 = input[i++];
	        chr3 = input[i++];
	
	        enc1 = chr1 >> 2;
	        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
	        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
	        enc4 = chr3 & 63;
	
	        if (isNaN(chr2)) {
	          enc3 = enc4 = 64;
	        } else if (isNaN(chr3)) {
	          enc4 = 64;
	        }
	
	        output = output +
	          this.KEY_STR.charAt(enc1) +
	          this.KEY_STR.charAt(enc2) +
	          this.KEY_STR.charAt(enc3) +
	          this.KEY_STR.charAt(enc4);
	        chr1 = chr2 = chr3 = '';
	        enc1 = enc2 = enc3 = enc4 = '';
	      } while (i < input.length);
	
	      return output;
	    };
	
	    ExifRestorer.restore = function (origFileBase64, resizedFileBase64) {
	      if (origFileBase64.match('data:image/jpeg;base64,')) {
	        origFileBase64 = origFileBase64.replace('data:image/jpeg;base64,', '');
	      }
	
	      var rawImage = this.decode64(origFileBase64);
	      var segments = this.slice2Segments(rawImage);
	
	      var image = this.exifManipulation(resizedFileBase64, segments);
	
	      return 'data:image/jpeg;base64,' + this.encode64(image);
	    };
	
	
	    ExifRestorer.exifManipulation = function (resizedFileBase64, segments) {
	      var exifArray = this.getExifArray(segments),
	        newImageArray = this.insertExif(resizedFileBase64, exifArray);
	      return new Uint8Array(newImageArray);
	    };
	
	
	    ExifRestorer.getExifArray = function (segments) {
	      var seg;
	      for (var x = 0; x < segments.length; x++) {
	        seg = segments[x];
	        if (seg[0] === 255 & seg[1] === 225) //(ff e1)
	        {
	          return seg;
	        }
	      }
	      return [];
	    };
	
	
	    ExifRestorer.insertExif = function (resizedFileBase64, exifArray) {
	      var imageData = resizedFileBase64.replace('data:image/jpeg;base64,', ''),
	        buf = this.decode64(imageData),
	        separatePoint = buf.indexOf(255, 3),
	        mae = buf.slice(0, separatePoint),
	        ato = buf.slice(separatePoint),
	        array = mae;
	
	      array = array.concat(exifArray);
	      array = array.concat(ato);
	      return array;
	    };
	
	
	    ExifRestorer.slice2Segments = function (rawImageArray) {
	      var head = 0,
	        segments = [];
	
	      while (1) {
	        if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 218) {
	          break;
	        }
	        if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 216) {
	          head += 2;
	        }
	        else {
	          var length = rawImageArray[head + 2] * 256 + rawImageArray[head + 3],
	            endPoint = head + length + 2,
	            seg = rawImageArray.slice(head, endPoint);
	          segments.push(seg);
	          head = endPoint;
	        }
	        if (head > rawImageArray.length) {
	          break;
	        }
	      }
	
	      return segments;
	    };
	
	
	    ExifRestorer.decode64 = function (input) {
	      var chr1, chr2, chr3 = '',
	        enc1, enc2, enc3, enc4 = '',
	        i = 0,
	        buf = [];
	
	      // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
	      var base64test = /[^A-Za-z0-9\+\/\=]/g;
	      if (base64test.exec(input)) {
	        console.log('There were invalid base64 characters in the input text.\n' +
	          'Valid base64 characters are A-Z, a-z, 0-9, ' + ', ' / ',and "="\n' +
	          'Expect errors in decoding.');
	      }
	      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');
	
	      do {
	        enc1 = this.KEY_STR.indexOf(input.charAt(i++));
	        enc2 = this.KEY_STR.indexOf(input.charAt(i++));
	        enc3 = this.KEY_STR.indexOf(input.charAt(i++));
	        enc4 = this.KEY_STR.indexOf(input.charAt(i++));
	
	        chr1 = (enc1 << 2) | (enc2 >> 4);
	        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
	        chr3 = ((enc3 & 3) << 6) | enc4;
	
	        buf.push(chr1);
	
	        if (enc3 !== 64) {
	          buf.push(chr2);
	        }
	        if (enc4 !== 64) {
	          buf.push(chr3);
	        }
	
	        chr1 = chr2 = chr3 = '';
	        enc1 = enc2 = enc3 = enc4 = '';
	
	      } while (i < input.length);
	
	      return buf;
	    };
	
	    return ExifRestorer.restore(orig, resized);  //<= EXIF
	  };
	
	  return upload;
	}]);
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(1)))

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(92);
	__webpack_require__(93);
	module.exports = "toaster";


/***/ }),
/* 92 */
/***/ (function(module, exports) {

	/* global angular */
	(function(window, document) {
	    'use strict';
	
	    /*
	     * AngularJS Toaster
	     * Version: 2.0.0
	     *
	     * Copyright 2013-2016 Jiri Kavulak.
	     * All Rights Reserved.
	     * Use, reproduction, distribution, and modification of this code is subject to the terms and
	     * conditions of the MIT license, available at http://www.opensource.org/licenses/mit-license.php
	     *
	     * Author: Jiri Kavulak
	     * Related to project of John Papa, Hans Fjällemark and Nguyễn Thiện Hùng (thienhung1989)
	     */
	
	    angular.module('toaster', []).constant(
	        'toasterConfig', {
	            'limit': 0,                   // limits max number of toasts
	            'tap-to-dismiss': true,
	            'close-button': false,
	            'close-html': '<button class="toast-close-button" type="button">&times;</button>',
	            'newest-on-top': true,
	            'time-out': 5000,
	            'icon-classes': {
	                error: 'toast-error',
	                info: 'toast-info',
	                wait: 'toast-wait',
	                success: 'toast-success',
	                warning: 'toast-warning'
	            },
	            'body-output-type': '', // Options: '', 'trustedHtml', 'template', 'templateWithData', 'directive'
	            'body-template': 'toasterBodyTmpl.html',
	            'icon-class': 'toast-info',
	            'position-class': 'toast-top-right', // Options (see CSS):
	            // 'toast-top-full-width', 'toast-bottom-full-width', 'toast-center',
	            // 'toast-top-left', 'toast-top-center', 'toast-top-right',
	            // 'toast-bottom-left', 'toast-bottom-center', 'toast-bottom-right',
	            'title-class': 'toast-title',
	            'message-class': 'toast-message',
	            'prevent-duplicates': false,
	            'mouseover-timer-stop': true // stop timeout on mouseover and restart timer on mouseout
	        }
	    ).service(
	        'toaster', [
	            '$rootScope', 'toasterConfig', function($rootScope, toasterConfig) {
	                // http://stackoverflow.com/questions/26501688/a-typescript-guid-class
	                var Guid = (function() {
	                    var Guid = {};
	                    Guid.newGuid = function() {
	                        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
	                            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
	                            return v.toString(16);
	                        });
	                    };
	                    return Guid;
	                }());
	
	                this.pop = function(type, title, body, timeout, bodyOutputType, clickHandler, toasterId, showCloseButton, toastId, onHideCallback) {
	                    if (angular.isObject(type)) {
	                        var params = type; // Enable named parameters as pop argument
	                        this.toast = {
	                            type: params.type,
	                            title: params.title,
	                            body: params.body,
	                            timeout: params.timeout,
	                            bodyOutputType: params.bodyOutputType,
	                            clickHandler: params.clickHandler,
	                            showCloseButton: params.showCloseButton,
	                            closeHtml: params.closeHtml,
	                            toastId: params.toastId,
	                            onShowCallback: params.onShowCallback,
	                            onHideCallback: params.onHideCallback,
	                            directiveData: params.directiveData
	                        };
	                        toasterId = params.toasterId;
	                    } else {
	                        this.toast = {
	                            type: type,
	                            title: title,
	                            body: body,
	                            timeout: timeout,
	                            bodyOutputType: bodyOutputType,
	                            clickHandler: clickHandler,
	                            showCloseButton: showCloseButton,
	                            toastId: toastId,
	                            onHideCallback: onHideCallback
	                        };
	                    }
	
	                    if (!this.toast.toastId || !this.toast.toastId.length) {
	                        this.toast.toastId = Guid.newGuid();
	                    }
	
	                    $rootScope.$emit('toaster-newToast', toasterId, this.toast.toastId);
	                    
	                    return {
	                        toasterId: toasterId,
	                        toastId: this.toast.toastId
	                    };
	                };
	
	                this.clear = function(toasterId, toastId) {
	                    if (angular.isObject(toasterId)) {
	                        $rootScope.$emit('toaster-clearToasts', toasterId.toasterId, toasterId.toastId);
	                    } else {
	                        $rootScope.$emit('toaster-clearToasts', toasterId, toastId);
	                    }
	                };
	
	                // Create one method per icon class, to allow to call toaster.info() and similar
	                for (var type in toasterConfig['icon-classes']) {
	                    this[type] = createTypeMethod(type);
	                }
	
	                function createTypeMethod(toasterType) {
	                    return function(title, body, timeout, bodyOutputType, clickHandler, toasterId, showCloseButton, toastId, onHideCallback) {
	                        if (angular.isString(title)) {
	                            return this.pop(
	                                toasterType,
	                                title,
	                                body,
	                                timeout,
	                                bodyOutputType,
	                                clickHandler,
	                                toasterId,
	                                showCloseButton,
	                                toastId,
	                                onHideCallback);
	                        } else { // 'title' is actually an object with options
	                            return this.pop(angular.extend(title, { type: toasterType }));
	                        }
	                    };
	                }
	            }]
	        ).factory(
	        'toasterEventRegistry', [
	            '$rootScope', function($rootScope) {
	                var deregisterNewToast = null, deregisterClearToasts = null, newToastEventSubscribers = [], clearToastsEventSubscribers = [], toasterFactory;
	
	                toasterFactory = {
	                    setup: function() {
	                        if (!deregisterNewToast) {
	                            deregisterNewToast = $rootScope.$on(
	                                'toaster-newToast', function(event, toasterId, toastId) {
	                                    for (var i = 0, len = newToastEventSubscribers.length; i < len; i++) {
	                                        newToastEventSubscribers[i](event, toasterId, toastId);
	                                    }
	                                });
	                        }
	
	                        if (!deregisterClearToasts) {
	                            deregisterClearToasts = $rootScope.$on(
	                                'toaster-clearToasts', function(event, toasterId, toastId) {
	                                    for (var i = 0, len = clearToastsEventSubscribers.length; i < len; i++) {
	                                        clearToastsEventSubscribers[i](event, toasterId, toastId);
	                                    }
	                                });
	                        }
	                    },
	
	                    subscribeToNewToastEvent: function(onNewToast) {
	                        newToastEventSubscribers.push(onNewToast);
	                    },
	                    subscribeToClearToastsEvent: function(onClearToasts) {
	                        clearToastsEventSubscribers.push(onClearToasts);
	                    },
	                    unsubscribeToNewToastEvent: function(onNewToast) {
	                        var index = newToastEventSubscribers.indexOf(onNewToast);
	                        if (index >= 0) {
	                            newToastEventSubscribers.splice(index, 1);
	                        }
	
	                        if (newToastEventSubscribers.length === 0) {
	                            deregisterNewToast();
	                            deregisterNewToast = null;
	                        }
	                    },
	                    unsubscribeToClearToastsEvent: function(onClearToasts) {
	                        var index = clearToastsEventSubscribers.indexOf(onClearToasts);
	                        if (index >= 0) {
	                            clearToastsEventSubscribers.splice(index, 1);
	                        }
	
	                        if (clearToastsEventSubscribers.length === 0) {
	                            deregisterClearToasts();
	                            deregisterClearToasts = null;
	                        }
	                    }
	                };
	                return {
	                    setup: toasterFactory.setup,
	                    subscribeToNewToastEvent: toasterFactory.subscribeToNewToastEvent,
	                    subscribeToClearToastsEvent: toasterFactory.subscribeToClearToastsEvent,
	                    unsubscribeToNewToastEvent: toasterFactory.unsubscribeToNewToastEvent,
	                    unsubscribeToClearToastsEvent: toasterFactory.unsubscribeToClearToastsEvent
	                };
	            }]
	        )
	        .directive('directiveTemplate', ['$compile', '$injector', function($compile, $injector) {
	            return {
	                restrict: 'A',
	                scope: {
	                    directiveName: '@directiveName',
	                    directiveData: '@directiveData'
	                },
	                replace: true,
	                link: function(scope, elm, attrs) {
	                    scope.$watch('directiveName', function(directiveName) {
	                        if (angular.isUndefined(directiveName) || directiveName.length <= 0)
	                            throw new Error('A valid directive name must be provided via the toast body argument when using bodyOutputType: directive');
	
	                        var directive;
	
	                        try {
	                            directive = $injector.get(attrs.$normalize(directiveName) + 'Directive');
	                        } catch (e) {
	                            throw new Error(directiveName + ' could not be found. ' +
	                                'The name should appear as it exists in the markup, not camelCased as it would appear in the directive declaration,' +
	                                ' e.g. directive-name not directiveName.');
	                        }
	
	
	                        var directiveDetails = directive[0];
	
	                        if (directiveDetails.scope !== true && directiveDetails.scope) {
	                            throw new Error('Cannot use a directive with an isolated scope. ' +
	                                'The scope must be either true or falsy (e.g. false/null/undefined). ' +
	                                'Occurred for directive ' + directiveName + '.');
	                        }
	
	                        if (directiveDetails.restrict.indexOf('A') < 0) {
	                            throw new Error('Directives must be usable as attributes. ' +
	                                'Add "A" to the restrict option (or remove the option entirely). Occurred for directive ' +
	                                directiveName + '.');
	                        }
	
	                        if (scope.directiveData)
	                            scope.directiveData = angular.fromJson(scope.directiveData);
	
	                        var template = $compile('<div ' + directiveName + '></div>')(scope);
	
	                        elm.append(template);
	                    });
	                }
	            };
	        }])
	        .directive(
	        'toasterContainer', [
	            '$parse', '$rootScope', '$interval', '$sce', 'toasterConfig', 'toaster', 'toasterEventRegistry',
	            function($parse, $rootScope, $interval, $sce, toasterConfig, toaster, toasterEventRegistry) {
	                return {
	                    replace: true,
	                    restrict: 'EA',
	                    scope: true, // creates an internal scope for this directive (one per directive instance)
	                    link: function(scope, elm, attrs) {
	                        var mergedConfig;
	
	                        // Merges configuration set in directive with default one
	                        mergedConfig = angular.extend({}, toasterConfig, scope.$eval(attrs.toasterOptions));
	
	                        scope.config = {
	                            toasterId: mergedConfig['toaster-id'],
	                            position: mergedConfig['position-class'],
	                            title: mergedConfig['title-class'],
	                            message: mergedConfig['message-class'],
	                            tap: mergedConfig['tap-to-dismiss'],
	                            closeButton: mergedConfig['close-button'],
	                            closeHtml: mergedConfig['close-html'],
	                            animation: mergedConfig['animation-class'],
	                            mouseoverTimer: mergedConfig['mouseover-timer-stop']
	                        };
	
	                        scope.$on(
	                            "$destroy", function() {
	                                toasterEventRegistry.unsubscribeToNewToastEvent(scope._onNewToast);
	                                toasterEventRegistry.unsubscribeToClearToastsEvent(scope._onClearToasts);
	                            }
	                        );
	
	                        function setTimeout(toast, time) {
	                            toast.timeoutPromise = $interval(
	                                function() {
	                                    scope.removeToast(toast.toastId);
	                                }, time, 1
	                            );
	                        }
	
	                        scope.configureTimer = function(toast) {
	                            var timeout = angular.isNumber(toast.timeout) ? toast.timeout : mergedConfig['time-out'];
	                            if (typeof timeout === "object") timeout = timeout[toast.type];
	                            if (timeout > 0) {
	                                setTimeout(toast, timeout);
	                            }
	                        };
	
	                        function addToast(toast, toastId) {
	                            toast.type = mergedConfig['icon-classes'][toast.type];
	                            if (!toast.type) {
	                                toast.type = mergedConfig['icon-class'];
	                            }
	
	                            if (mergedConfig['prevent-duplicates'] === true && scope.toasters.length) {
	                                if (scope.toasters[scope.toasters.length - 1].body === toast.body) {
	                                    return;
	                                } else {
	                                    var i, len, dupFound = false;
	                                    for (i = 0, len = scope.toasters.length; i < len; i++) {
	                                        if (scope.toasters[i].toastId === toastId) {
	                                            dupFound = true;
	                                            break;
	                                        }
	                                    }
	                                    
	                                    if (dupFound) return;
	                                }
	                            }
	
	
	                            // set the showCloseButton property on the toast so that
	                            // each template can bind directly to the property to show/hide
	                            // the close button
	                            var closeButton = mergedConfig['close-button'];
	
	                            // if toast.showCloseButton is a boolean value,
	                            // it was specifically overriden in the pop arguments
	                            if (typeof toast.showCloseButton === "boolean") {
	
	                            } else if (typeof closeButton === "boolean") {
	                                toast.showCloseButton = closeButton;
	                            } else if (typeof closeButton === "object") {
	                                var closeButtonForType = closeButton[toast.type];
	
	                                if (typeof closeButtonForType !== "undefined" && closeButtonForType !== null) {
	                                    toast.showCloseButton = closeButtonForType;
	                                }
	                            } else {
	                                // if an option was not set, default to false.
	                                toast.showCloseButton = false;
	                            }
	
	                            if (toast.showCloseButton) {
	                                toast.closeHtml = $sce.trustAsHtml(toast.closeHtml || scope.config.closeHtml);
	                            }
	
	                            // Set the toast.bodyOutputType to the default if it isn't set
	                            toast.bodyOutputType = toast.bodyOutputType || mergedConfig['body-output-type'];
	                            switch (toast.bodyOutputType) {
	                                case 'trustedHtml':
	                                    toast.html = $sce.trustAsHtml(toast.body);
	                                    break;
	                                case 'template':
	                                    toast.bodyTemplate = toast.body || mergedConfig['body-template'];
	                                    break;
	                                case 'templateWithData':
	                                    var fcGet = $parse(toast.body || mergedConfig['body-template']);
	                                    var templateWithData = fcGet(scope);
	                                    toast.bodyTemplate = templateWithData.template;
	                                    toast.data = templateWithData.data;
	                                    break;
	                                case 'directive':
	                                    toast.html = toast.body;
	                                    break;
	                            }
	
	                            scope.configureTimer(toast);
	
	                            if (mergedConfig['newest-on-top'] === true) {
	                                scope.toasters.unshift(toast);
	                                if (mergedConfig['limit'] > 0 && scope.toasters.length > mergedConfig['limit']) {
	                                    scope.toasters.pop();
	                                }
	                            } else {
	                                scope.toasters.push(toast);
	                                if (mergedConfig['limit'] > 0 && scope.toasters.length > mergedConfig['limit']) {
	                                    scope.toasters.shift();
	                                }
	                            }
	
	                            if (angular.isFunction(toast.onShowCallback)) {
	                                toast.onShowCallback();
	                            }
	                        }
	
	                        scope.removeToast = function(toastId) {
	                            var i, len;
	                            for (i = 0, len = scope.toasters.length; i < len; i++) {
	                                if (scope.toasters[i].toastId === toastId) {
	                                    removeToast(i);
	                                    break;
	                                }
	                            }
	                        };
	
	                        function removeToast(toastIndex) {
	                            var toast = scope.toasters[toastIndex];
	
	                            // toast is always defined since the index always has a match
	                            if (toast.timeoutPromise) {
	                                $interval.cancel(toast.timeoutPromise);
	                            }
	                            scope.toasters.splice(toastIndex, 1);
	
	                            if (angular.isFunction(toast.onHideCallback)) {
	                                toast.onHideCallback();
	                            }
	                        }
	
	                        function removeAllToasts(toastId) {
	                            for (var i = scope.toasters.length - 1; i >= 0; i--) {
	                                if (isUndefinedOrNull(toastId)) {
	                                    removeToast(i);
	                                } else {
	                                    if (scope.toasters[i].toastId == toastId) {
	                                        removeToast(i);
	                                    }
	                                }
	                            }
	                        }
	
	                        scope.toasters = [];
	
	                        function isUndefinedOrNull(val) {
	                            return angular.isUndefined(val) || val === null;
	                        }
	
	                        scope._onNewToast = function(event, toasterId, toastId) {
	                            // Compatibility: if toaster has no toasterId defined, and if call to display
	                            // hasn't either, then the request is for us
	
	                            if ((isUndefinedOrNull(scope.config.toasterId) && isUndefinedOrNull(toasterId)) || (!isUndefinedOrNull(scope.config.toasterId) && !isUndefinedOrNull(toasterId) && scope.config.toasterId == toasterId)) {
	                                addToast(toaster.toast, toastId);
	                            }
	                        };
	                        scope._onClearToasts = function(event, toasterId, toastId) {
	                            // Compatibility: if toaster has no toasterId defined, and if call to display
	                            // hasn't either, then the request is for us
	                            if (toasterId == '*' || (isUndefinedOrNull(scope.config.toasterId) && isUndefinedOrNull(toasterId)) || (!isUndefinedOrNull(scope.config.toasterId) && !isUndefinedOrNull(toasterId) && scope.config.toasterId == toasterId)) {
	                                removeAllToasts(toastId);
	                            }
	                        };
	
	                        toasterEventRegistry.setup();
	
	                        toasterEventRegistry.subscribeToNewToastEvent(scope._onNewToast);
	                        toasterEventRegistry.subscribeToClearToastsEvent(scope._onClearToasts);
	                    },
	                    controller: [
	                        '$scope', '$element', '$attrs', function($scope, $element, $attrs) {
	                            // Called on mouseover
	                            $scope.stopTimer = function(toast) {
	                                if ($scope.config.mouseoverTimer === true) {
	                                    if (toast.timeoutPromise) {
	                                        $interval.cancel(toast.timeoutPromise);
	                                        toast.timeoutPromise = null;
	                                    }
	                                }
	                            };
	
	                            // Called on mouseout
	                            $scope.restartTimer = function(toast) {
	                                if ($scope.config.mouseoverTimer === true) {
	                                    if (!toast.timeoutPromise) {
	                                        $scope.configureTimer(toast);
	                                    }
	                                } else if (toast.timeoutPromise === null) {
	                                    $scope.removeToast(toast.toastId);
	                                }
	                            };
	
	                            $scope.click = function(toast, isCloseButton) {
	                                if ($scope.config.tap === true || (toast.showCloseButton === true && isCloseButton === true)) {
	                                    var removeToast = true;
	                                    if (toast.clickHandler) {
	                                        if (angular.isFunction(toast.clickHandler)) {
	                                            removeToast = toast.clickHandler(toast, isCloseButton);
	                                        } else if (angular.isFunction($scope.$parent.$eval(toast.clickHandler))) {
	                                            removeToast = $scope.$parent.$eval(toast.clickHandler)(toast, isCloseButton);
	                                        } else {
	                                            console.log("TOAST-NOTE: Your click handler is not inside a parent scope of toaster-container.");
	                                        }
	                                    }
	                                    if (removeToast) {
	                                        $scope.removeToast(toast.toastId);
	                                    }
	                                }
	                            };
	                        }],
	                    template:
	                    '<div id="toast-container" ng-class="[config.position, config.animation]">' +
	                    '<div ng-repeat="toaster in toasters" class="toast" ng-class="toaster.type" ng-click="click(toaster)" ng-mouseover="stopTimer(toaster)" ng-mouseout="restartTimer(toaster)">' +
	                    '<div ng-if="toaster.showCloseButton" ng-click="click(toaster, true)" ng-bind-html="toaster.closeHtml"></div>' +
	                    '<div ng-class="config.title">{{toaster.title}}</div>' +
	                    '<div ng-class="config.message" ng-switch on="toaster.bodyOutputType">' +
	                    '<div ng-switch-when="trustedHtml" ng-bind-html="toaster.html"></div>' +
	                    '<div ng-switch-when="template"><div ng-include="toaster.bodyTemplate"></div></div>' +
	                    '<div ng-switch-when="templateWithData"><div ng-include="toaster.bodyTemplate"></div></div>' +
	                    '<div ng-switch-when="directive"><div directive-template directive-name="{{toaster.html}}" directive-data="{{toaster.directiveData}}"></div></div>' +
	                    '<div ng-switch-default >{{toaster.body}}</div>' +
	                    '</div>' +
	                    '</div>' +
	                    '</div>'
	                };
	            }]
	        );
	})(window, document);

/***/ }),
/* 93 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 94 */,
/* 95 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(98);
	__webpack_require__(99);
	module.exports = 'angular-loading-bar';


/***/ }),
/* 98 */
/***/ (function(module, exports) {

	/*! 
	 * angular-loading-bar v0.9.0
	 * https://chieffancypants.github.io/angular-loading-bar
	 * Copyright (c) 2016 Wes Cruver
	 * License: MIT
	 */
	/*
	 * angular-loading-bar
	 *
	 * intercepts XHR requests and creates a loading bar.
	 * Based on the excellent nprogress work by rstacruz (more info in readme)
	 *
	 * (c) 2013 Wes Cruver
	 * License: MIT
	 */
	
	
	(function() {
	
	'use strict';
	
	// Alias the loading bar for various backwards compatibilities since the project has matured:
	angular.module('angular-loading-bar', ['cfp.loadingBarInterceptor']);
	angular.module('chieffancypants.loadingBar', ['cfp.loadingBarInterceptor']);
	
	
	/**
	 * loadingBarInterceptor service
	 *
	 * Registers itself as an Angular interceptor and listens for XHR requests.
	 */
	angular.module('cfp.loadingBarInterceptor', ['cfp.loadingBar'])
	  .config(['$httpProvider', function ($httpProvider) {
	
	    var interceptor = ['$q', '$cacheFactory', '$timeout', '$rootScope', '$log', 'cfpLoadingBar', function ($q, $cacheFactory, $timeout, $rootScope, $log, cfpLoadingBar) {
	
	      /**
	       * The total number of requests made
	       */
	      var reqsTotal = 0;
	
	      /**
	       * The number of requests completed (either successfully or not)
	       */
	      var reqsCompleted = 0;
	
	      /**
	       * The amount of time spent fetching before showing the loading bar
	       */
	      var latencyThreshold = cfpLoadingBar.latencyThreshold;
	
	      /**
	       * $timeout handle for latencyThreshold
	       */
	      var startTimeout;
	
	
	      /**
	       * calls cfpLoadingBar.complete() which removes the
	       * loading bar from the DOM.
	       */
	      function setComplete() {
	        $timeout.cancel(startTimeout);
	        cfpLoadingBar.complete();
	        reqsCompleted = 0;
	        reqsTotal = 0;
	      }
	
	      /**
	       * Determine if the response has already been cached
	       * @param  {Object}  config the config option from the request
	       * @return {Boolean} retrns true if cached, otherwise false
	       */
	      function isCached(config) {
	        var cache;
	        var defaultCache = $cacheFactory.get('$http');
	        var defaults = $httpProvider.defaults;
	
	        // Choose the proper cache source. Borrowed from angular: $http service
	        if ((config.cache || defaults.cache) && config.cache !== false &&
	          (config.method === 'GET' || config.method === 'JSONP')) {
	            cache = angular.isObject(config.cache) ? config.cache
	              : angular.isObject(defaults.cache) ? defaults.cache
	              : defaultCache;
	        }
	
	        var cached = cache !== undefined ?
	          cache.get(config.url) !== undefined : false;
	
	        if (config.cached !== undefined && cached !== config.cached) {
	          return config.cached;
	        }
	        config.cached = cached;
	        return cached;
	      }
	
	
	      return {
	        'request': function(config) {
	          // Check to make sure this request hasn't already been cached and that
	          // the requester didn't explicitly ask us to ignore this request:
	          if (!config.ignoreLoadingBar && !isCached(config)) {
	            $rootScope.$broadcast('cfpLoadingBar:loading', {url: config.url});
	            if (reqsTotal === 0) {
	              startTimeout = $timeout(function() {
	                cfpLoadingBar.start();
	              }, latencyThreshold);
	            }
	            reqsTotal++;
	            cfpLoadingBar.set(reqsCompleted / reqsTotal);
	          }
	          return config;
	        },
	
	        'response': function(response) {
	          if (!response || !response.config) {
	            $log.error('Broken interceptor detected: Config object not supplied in response:\n https://github.com/chieffancypants/angular-loading-bar/pull/50');
	            return response;
	          }
	
	          if (!response.config.ignoreLoadingBar && !isCached(response.config)) {
	            reqsCompleted++;
	            if (reqsCompleted >= reqsTotal) {
	              $rootScope.$broadcast('cfpLoadingBar:loaded', {url: response.config.url, result: response});
	              setComplete();
	            } else {
	              cfpLoadingBar.set(reqsCompleted / reqsTotal);
	            }
	          }
	          return response;
	        },
	
	        'responseError': function(rejection) {
	          if (!rejection || !rejection.config) {
	            $log.error('Broken interceptor detected: Config object not supplied in rejection:\n https://github.com/chieffancypants/angular-loading-bar/pull/50');
	            return $q.reject(rejection);
	          }
	
	          if (!rejection.config.ignoreLoadingBar && !isCached(rejection.config)) {
	            reqsCompleted++;
	            if (reqsCompleted >= reqsTotal) {
	              $rootScope.$broadcast('cfpLoadingBar:loaded', {url: rejection.config.url, result: rejection});
	              setComplete();
	            } else {
	              cfpLoadingBar.set(reqsCompleted / reqsTotal);
	            }
	          }
	          return $q.reject(rejection);
	        }
	      };
	    }];
	
	    $httpProvider.interceptors.push(interceptor);
	  }]);
	
	
	/**
	 * Loading Bar
	 *
	 * This service handles adding and removing the actual element in the DOM.
	 * Generally, best practices for DOM manipulation is to take place in a
	 * directive, but because the element itself is injected in the DOM only upon
	 * XHR requests, and it's likely needed on every view, the best option is to
	 * use a service.
	 */
	angular.module('cfp.loadingBar', [])
	  .provider('cfpLoadingBar', function() {
	
	    this.autoIncrement = true;
	    this.includeSpinner = true;
	    this.includeBar = true;
	    this.latencyThreshold = 100;
	    this.startSize = 0.02;
	    this.parentSelector = 'body';
	    this.spinnerTemplate = '<div id="loading-bar-spinner"><div class="spinner-icon"></div></div>';
	    this.loadingBarTemplate = '<div id="loading-bar"><div class="bar"><div class="peg"></div></div></div>';
	
	    this.$get = ['$injector', '$document', '$timeout', '$rootScope', function ($injector, $document, $timeout, $rootScope) {
	      var $animate;
	      var $parentSelector = this.parentSelector,
	        loadingBarContainer = angular.element(this.loadingBarTemplate),
	        loadingBar = loadingBarContainer.find('div').eq(0),
	        spinner = angular.element(this.spinnerTemplate);
	
	      var incTimeout,
	        completeTimeout,
	        started = false,
	        status = 0;
	
	      var autoIncrement = this.autoIncrement;
	      var includeSpinner = this.includeSpinner;
	      var includeBar = this.includeBar;
	      var startSize = this.startSize;
	
	      /**
	       * Inserts the loading bar element into the dom, and sets it to 2%
	       */
	      function _start() {
	        if (!$animate) {
	          $animate = $injector.get('$animate');
	        }
	
	        $timeout.cancel(completeTimeout);
	
	        // do not continually broadcast the started event:
	        if (started) {
	          return;
	        }
	
	        var document = $document[0];
	        var parent = document.querySelector ?
	          document.querySelector($parentSelector)
	          : $document.find($parentSelector)[0]
	        ;
	
	        if (! parent) {
	          parent = document.getElementsByTagName('body')[0];
	        }
	
	        var $parent = angular.element(parent);
	        var $after = parent.lastChild && angular.element(parent.lastChild);
	
	        $rootScope.$broadcast('cfpLoadingBar:started');
	        started = true;
	
	        if (includeBar) {
	          $animate.enter(loadingBarContainer, $parent, $after);
	        }
	
	        if (includeSpinner) {
	          $animate.enter(spinner, $parent, loadingBarContainer);
	        }
	
	        _set(startSize);
	      }
	
	      /**
	       * Set the loading bar's width to a certain percent.
	       *
	       * @param n any value between 0 and 1
	       */
	      function _set(n) {
	        if (!started) {
	          return;
	        }
	        var pct = (n * 100) + '%';
	        loadingBar.css('width', pct);
	        status = n;
	
	        // increment loadingbar to give the illusion that there is always
	        // progress but make sure to cancel the previous timeouts so we don't
	        // have multiple incs running at the same time.
	        if (autoIncrement) {
	          $timeout.cancel(incTimeout);
	          incTimeout = $timeout(function() {
	            _inc();
	          }, 250);
	        }
	      }
	
	      /**
	       * Increments the loading bar by a random amount
	       * but slows down as it progresses
	       */
	      function _inc() {
	        if (_status() >= 1) {
	          return;
	        }
	
	        var rnd = 0;
	
	        // TODO: do this mathmatically instead of through conditions
	
	        var stat = _status();
	        if (stat >= 0 && stat < 0.25) {
	          // Start out between 3 - 6% increments
	          rnd = (Math.random() * (5 - 3 + 1) + 3) / 100;
	        } else if (stat >= 0.25 && stat < 0.65) {
	          // increment between 0 - 3%
	          rnd = (Math.random() * 3) / 100;
	        } else if (stat >= 0.65 && stat < 0.9) {
	          // increment between 0 - 2%
	          rnd = (Math.random() * 2) / 100;
	        } else if (stat >= 0.9 && stat < 0.99) {
	          // finally, increment it .5 %
	          rnd = 0.005;
	        } else {
	          // after 99%, don't increment:
	          rnd = 0;
	        }
	
	        var pct = _status() + rnd;
	        _set(pct);
	      }
	
	      function _status() {
	        return status;
	      }
	
	      function _completeAnimation() {
	        status = 0;
	        started = false;
	      }
	
	      function _complete() {
	        if (!$animate) {
	          $animate = $injector.get('$animate');
	        }
	
	        _set(1);
	        $timeout.cancel(completeTimeout);
	
	        // Attempt to aggregate any start/complete calls within 500ms:
	        completeTimeout = $timeout(function() {
	          var promise = $animate.leave(loadingBarContainer, _completeAnimation);
	          if (promise && promise.then) {
	            promise.then(_completeAnimation);
	          }
	          $animate.leave(spinner);
	          $rootScope.$broadcast('cfpLoadingBar:completed');
	        }, 500);
	      }
	
	      return {
	        start            : _start,
	        set              : _set,
	        status           : _status,
	        inc              : _inc,
	        complete         : _complete,
	        autoIncrement    : this.autoIncrement,
	        includeSpinner   : this.includeSpinner,
	        latencyThreshold : this.latencyThreshold,
	        parentSelector   : this.parentSelector,
	        startSize        : this.startSize
	      };
	
	
	    }];     //
	  });       // wtf javascript. srsly
	})();       //


/***/ }),
/* 99 */
93,
/* 100 */,
/* 101 */
/***/ (function(module, exports) {

	'use strict';
	
	routeConfig.$inject = ['$urlRouterProvider', '$locationProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routeConfig = routeConfig;
	function routeConfig($urlRouterProvider, $locationProvider) {
	  'ngInject';
	
	  $urlRouterProvider.otherwise('/');
	
	  $locationProvider.html5Mode(true);
	}

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	addInterceptor.$inject = ['$httpProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _app = __webpack_require__(103);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _util = __webpack_require__(105);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _angularCookies = __webpack_require__(80);
	
	var _angularCookies2 = _interopRequireDefault(_angularCookies);
	
	var _interceptor = __webpack_require__(107);
	
	var _router = __webpack_require__(108);
	
	var _auth = __webpack_require__(109);
	
	var _user = __webpack_require__(121);
	
	var _angularUiRouter = __webpack_require__(86);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addInterceptor($httpProvider) {
	  'ngInject';
	
	  $httpProvider.interceptors.push('authInterceptor');
	}
	
	exports.default = _angular2.default.module('updateServerApp.auth', [_app2.default, _util2.default, _angularCookies2.default, _angularUiRouter2.default]).factory('authInterceptor', _interceptor.authInterceptor).run(_router.routerDecorator).factory('Auth', _auth.AuthService).factory('User', _user.UserResource).config(['$httpProvider', addInterceptor]).name;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.constants', []).constant('appConfig', __webpack_require__(104)).name;

/***/ }),
/* 104 */
/***/ (function(module, exports) {

	'use strict'
	// ac0d7f0f-ef9c-48b6-8d8a-6b7a75b0a036  keybox
	exports = module.exports = {
	  // List of user roles
	  userRoles: ['guest', 'user', 'admin'],
	  encryptKey: '8chLv9pat4WlE5IzyUwF9lOEtRYaPo9d1v0EYQnIak8iJDHLdIkJQW994iQZzLIoMhErq190IU8NEYACVnkrxtr6uOXTqkWuiClOC5ACbIWB0zUk5hALBaGWEvXDhudK',
	  newEncryptKey: 'f6135e24571e312e31563926519d1676',
	  ThirdPartyToken: ['a870d5fd-66db-4d2d-9dd7-d4a0e4ebe45b', '648220d9-7b90-43fd-bc2d-d217e00da1a7', 'ff210891-9cf5-4555-bede-4c6965459da7', 'ac0d7f0f-ef9c-48b6-8d8a-6b7a75b0a036', 'f225c15b-c50e-4f76-83b6-19bba5485a66', '4c6c3119-b8bb-4d97-909a-5f5c6b77e92a']
	}


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _util = __webpack_require__(106);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.util', []).factory('Util', _util.UtilService).name;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	UtilService.$inject = ['$window'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UtilService = UtilService;
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function UtilService($window) {
	  'ngInject';
	
	  var Util = {
	    safeCb: function safeCb(cb) {
	      return _angular2.default.isFunction(cb) ? cb : _angular2.default.noop;
	    },
	    urlParse: function urlParse(url) {
	      var a = document.createElement('a');
	      a.href = url;
	
	      if (a.host === '') {
	        a.href = a.href;
	      }
	
	      return a;
	    },
	    isSameOrigin: function isSameOrigin(url, origins) {
	      url = Util.urlParse(url);
	      origins = origins && [].concat(origins) || [];
	      origins = origins.map(Util.urlParse);
	      origins.push($window.location);
	      origins = origins.filter(function (o) {
	        var hostnameCheck = url.hostname === o.hostname;
	        var protocolCheck = url.protocol === o.protocol;
	
	        var portCheck = url.port === o.port || o.port === '' && (url.port === '80' || url.port === '443');
	        return hostnameCheck && protocolCheck && portCheck;
	      });
	      return origins.length >= 1;
	    }
	  };
	
	  return Util;
	}

/***/ }),
/* 107 */
/***/ (function(module, exports) {

	'use strict';
	
	authInterceptor.$inject = ['$rootScope', '$q', '$cookies', '$injector', 'Util'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.authInterceptor = authInterceptor;
	function authInterceptor($rootScope, $q, $cookies, $injector, Util) {
	  'ngInject';
	
	  var state;
	  return {
	    request: function request(config) {
	      config.headers = config.headers || {};
	      if ($cookies.get('token') && Util.isSameOrigin(config.url)) {
	        config.headers.Authorization = 'Bearer ' + $cookies.get('token');
	      }
	      return config;
	    },
	    responseError: function responseError(response) {
	      if (response.status === 401) {
	        (state || (state = $injector.get('$state'))).go('login');
	
	        $cookies.remove('token');
	      }
	      return $q.reject(response);
	    }
	  };
	}

/***/ }),
/* 108 */
/***/ (function(module, exports) {

	'use strict';
	
	routerDecorator.$inject = ['$rootScope', '$state', 'Auth'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routerDecorator = routerDecorator;
	function routerDecorator($rootScope, $state, Auth) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next) {
	    if (!next.authenticate) {
	      return;
	    }
	
	    if (typeof next.authenticate === 'string') {
	      Auth.hasRole(next.authenticate).then(function (has) {
	        if (has) {
	          return;
	        }
	
	        event.preventDefault();
	        return Auth.isLoggedIn().then(function (is) {
	          $state.go(is ? 'main' : 'login');
	        });
	      });
	    } else {
	      Auth.isLoggedIn().then(function (is) {
	        if (is) {
	          return;
	        }
	
	        event.preventDefault();
	
	        $state.go('login');
	      });
	    }
	  });
	}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	AuthService.$inject = ['$location', '$http', '$cookies', '$q', 'appConfig', 'Util', 'User'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(110);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	exports.AuthService = AuthService;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _User = function _User() {
	  (0, _classCallCheck3.default)(this, _User);
	  this._id = '';
	  this.name = '';
	  this.email = '';
	  this.role = '';
	  this.$promise = undefined;
	};
	
	function AuthService($location, $http, $cookies, $q, appConfig, Util, User) {
	  'ngInject';
	
	  var safeCb = Util.safeCb;
	  var currentUser = new _User();
	  var userRoles = appConfig.userRoles || [];
	
	  var _hasRole = function _hasRole(userRole, role) {
	    return userRoles.indexOf(userRole) >= userRoles.indexOf(role);
	  };
	
	  if ($cookies.get('token') && $location.path() !== '/logout') {
	    currentUser = User.get();
	  }
	
	  var Auth = {
	    login: function login(_ref, callback) {
	      var email = _ref.email,
	          password = _ref.password;
	
	      return $http.post('/auth/local', {
	        email: email,
	        password: password
	      }).then(function (res) {
	        $cookies.put('token', res.data.token);
	        currentUser = User.get();
	        return currentUser.$promise;
	      }).then(function (user) {
	        safeCb(callback)(null, user);
	        return user;
	      }).catch(function (err) {
	        Auth.logout();
	        safeCb(callback)(err.data);
	        return $q.reject(err.data);
	      });
	    },
	    logout: function logout() {
	      $cookies.remove('token');
	      currentUser = new _User();
	    },
	    createUser: function createUser(user, callback) {
	      return User.save(user, function (data) {
	        $cookies.put('token', data.token);
	        currentUser = User.get();
	        return safeCb(callback)(null, user);
	      }, function (err) {
	        Auth.logout();
	        return safeCb(callback)(err);
	      }).$promise;
	    },
	    changePassword: function changePassword(oldPassword, newPassword, callback) {
	      return User.changePassword({
	        id: currentUser._id
	      }, {
	        oldPassword: oldPassword,
	        newPassword: newPassword
	      }, function () {
	        return safeCb(callback)(null);
	      }, function (err) {
	        return safeCb(callback)(err);
	      }).$promise;
	    },
	    getCurrentUser: function getCurrentUser(callback) {
	      var value = _.get(currentUser, '$promise') ? currentUser.$promise : currentUser;
	
	      return $q.when(value).then(function (user) {
	        safeCb(callback)(user);
	        return user;
	      }, function () {
	        safeCb(callback)({});
	        return {};
	      });
	    },
	    getCurrentUserSync: function getCurrentUserSync() {
	      return currentUser;
	    },
	    isLoggedIn: function isLoggedIn(callback) {
	      return Auth.getCurrentUser(undefined).then(function (user) {
	        var is = _.get(user, 'role');
	
	        safeCb(callback)(is);
	        return is;
	      });
	    },
	    isLoggedInSync: function isLoggedInSync() {
	      return !!_.get(currentUser, 'role');
	    },
	    hasRole: function hasRole(role, callback) {
	      return Auth.getCurrentUser(undefined).then(function (user) {
	        var has = _hasRole(_.get(user, 'role'), role);
	
	        safeCb(callback)(has);
	        return has;
	      });
	    },
	    hasRoleSync: function hasRoleSync(role) {
	      return _hasRole(_.get(currentUser, 'role'), role);
	    },
	    isAdmin: function isAdmin() {
	      return Auth.hasRole.apply(Auth, (0, _toConsumableArray3.default)([].concat.apply(['admin'], arguments)));
	    },
	    isAdminSync: function isAdminSync() {
	      return Auth.hasRoleSync('admin');
	    },
	    getToken: function getToken() {
	      return $cookies.get('token');
	    }
	  };
	
	  return Auth;
	}

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(111);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(112), __esModule: true };

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(23);
	__webpack_require__(113);
	module.exports = __webpack_require__(8).Array.from;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(9);
	var $export = __webpack_require__(6);
	var toObject = __webpack_require__(51);
	var call = __webpack_require__(114);
	var isArrayIter = __webpack_require__(115);
	var toLength = __webpack_require__(41);
	var createProperty = __webpack_require__(116);
	var getIterFn = __webpack_require__(117);
	
	$export($export.S + $export.F * !__webpack_require__(119)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(13);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(31);
	var ITERATOR = __webpack_require__(49)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(12);
	var createDesc = __webpack_require__(20);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(118);
	var ITERATOR = __webpack_require__(49)('iterator');
	var Iterators = __webpack_require__(31);
	module.exports = __webpack_require__(8).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(39);
	var TAG = __webpack_require__(49)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(49)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 120 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 121 */
/***/ (function(module, exports) {

	'use strict';
	
	UserResource.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UserResource = UserResource;
	function UserResource($resource) {
	  'ngInject';
	
	  return $resource('/api/users/:id/:controller', {
	    id: '@_id'
	  }, {
	    changePassword: {
	      method: 'PUT',
	      params: {
	        controller: 'password'
	      }
	    },
	    get: {
	      method: 'GET',
	      params: {
	        id: 'me'
	      }
	    }
	  });
	}

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(86);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _account = __webpack_require__(123);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _login = __webpack_require__(127);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _settings = __webpack_require__(130);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _signup = __webpack_require__(132);
	
	var _signup2 = _interopRequireDefault(_signup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.account', [_angularUiRouter2.default, _login2.default, _settings2.default, _signup2.default]).config(_account2.default).run(['$rootScope', function ($rootScope) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
	    if (next.name === 'logout' && current && current.name && !current.authenticate) {
	      next.referrer = current.name;
	    }
	  });
	}]).name;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('login', {
	    url: '/login',
	    template: __webpack_require__(124),
	    controller: 'LoginController',
	    controllerAs: 'vm'
	  }).state('logout', {
	    url: '/logout?referrer',
	    referrer: 'main',
	    template: '',
	    controller: ['$state', 'Auth', function controller($state, Auth) {
	      'ngInject';
	
	      var referrer = $state.params.referrer || $state.current.referrer || 'main';
	      Auth.logout();
	      $state.go('login');
	    }]
	  }).state('signup', {
	    url: '/signup',
	    template: __webpack_require__(125),
	    controller: 'SignupController',
	    controllerAs: 'vm'
	  }).state('settings', {
	    url: '/settings',
	    template: __webpack_require__(126),
	    controller: 'SettingsController',
	    controllerAs: 'vm',
	    authenticate: true
	  });
	}

/***/ }),
/* 124 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <h1>Login</h1>\n    </div>\n    <div class=\"col-sm-12\">\n      <form class=\"form\" name=\"form\" ng-submit=\"vm.login(form)\" novalidate>\n\n        <div class=\"form-group\">\n          <label>Email</label>\n\n          <input type=\"email\" name=\"email\" class=\"form-control\" ng-model=\"vm.user.email\" required>\n        </div>\n\n        <div class=\"form-group\">\n          <label>Password</label>\n\n          <input type=\"password\" name=\"password\" class=\"form-control\" ng-model=\"vm.user.password\" required>\n        </div>\n\n        <div class=\"form-group has-error\">\n          <p class=\"help-block\" ng-show=\"form.email.$error.required && form.password.$error.required && vm.submitted\">\n             Please enter your email and password.\n          </p>\n          <p class=\"help-block\" ng-show=\"form.email.$error.email && vm.submitted\">\n             Please enter a valid email.\n          </p>\n\n          <p class=\"help-block\">{{ vm.errors.login }}</p>\n        </div>\n\n        <div>\n          <button class=\"btn btn-inverse btn-lg btn-login\" type=\"submit\">\n            Login\n          </button>\n        </div>\n\n      </form>\n    </div>\n  </div>\n  <hr>\n</div>\n"

/***/ }),
/* 125 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <h1>Sign up</h1>\n    </div>\n    <div class=\"col-sm-12\">\n      <form class=\"form\" name=\"form\" ng-submit=\"vm.register(form)\" novalidate>\n\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.name.$valid && vm.submitted,\n                                            'has-error': form.name.$invalid && vm.submitted }\">\n          <label>Name</label>\n\n          <input type=\"text\" name=\"name\" class=\"form-control\" ng-model=\"vm.user.name\"\n                 required/>\n          <p class=\"help-block\" ng-show=\"form.name.$error.required && vm.submitted\">\n            A name is required\n          </p>\n        </div>\n\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.email.$valid && vm.submitted,\n                                            'has-error': form.email.$invalid && vm.submitted }\">\n          <label>Email</label>\n\n          <input type=\"email\" name=\"email\" class=\"form-control\" ng-model=\"vm.user.email\"\n                 required\n                 mongoose-error/>\n          <p class=\"help-block\" ng-show=\"form.email.$error.email && vm.submitted\">\n            Doesn't look like a valid email.\n          </p>\n          <p class=\"help-block\" ng-show=\"form.email.$error.required && vm.submitted\">\n            What's your email address?\n          </p>\n          <p class=\"help-block\" ng-show=\"form.email.$error.mongoose\">\n            {{ vm.errors.email }}\n          </p>\n        </div>\n\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.password.$valid && vm.submitted,\n                                            'has-error': form.password.$invalid && vm.submitted }\">\n          <label>Password</label>\n\n          <input type=\"password\" name=\"password\" class=\"form-control\" ng-model=\"vm.user.password\"\n                 ng-minlength=\"3\"\n                 required\n                 mongoose-error/>\n          <p class=\"help-block\"\n             ng-show=\"(form.password.$error.minlength || form.password.$error.required) && vm.submitted\">\n            Password must be at least 3 characters.\n          </p>\n          <p class=\"help-block\" ng-show=\"form.password.$error.mongoose\">\n            {{ vm.errors.password }}\n          </p>\n        </div>\n\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.confirmPassword.$valid && vm.submitted,\n                                            'has-error': form.confirmPassword.$invalid && vm.submitted }\">\n          <label>Confirm Password</label>\n          <input type=\"password\" name=\"confirmPassword\" class=\"form-control\" ng-model=\"vm.user.confirmPassword\"\n                 match=\"vm.user.password\"\n                 ng-minlength=\"3\" required/>\n          <p class=\"help-block\"\n             ng-show=\"form.confirmPassword.$error.match && vm.submitted\">\n            Passwords must match.\n          </p>\n        </div>\n\n        <div>\n          <button class=\"btn btn-inverse btn-lg btn-register\" type=\"submit\">\n            Sign up\n          </button>\n          <a class=\"btn btn-default btn-lg btn-login\" ui-sref=\"login\">\n            Login\n          </a>\n        </div>\n\n      </form>\n    </div>\n  </div>\n  <hr>\n</div>\n"

/***/ }),
/* 126 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <h1>Change Password</h1>\n    </div>\n    <div class=\"col-sm-12\">\n      <form class=\"form\" name=\"form\" ng-submit=\"vm.changePassword(form)\" novalidate>\n\n        <div class=\"form-group\">\n          <label>Current Password</label>\n\n          <input type=\"password\" name=\"password\" class=\"form-control\" ng-model=\"vm.user.oldPassword\"\n                 mongoose-error/>\n          <p class=\"help-block\" ng-show=\"form.password.$error.mongoose\">\n              {{ vm.errors.other }}\n          </p>\n        </div>\n\n        <div class=\"form-group\">\n          <label>New Password</label>\n\n          <input type=\"password\" name=\"newPassword\" class=\"form-control\" ng-model=\"vm.user.newPassword\"\n                 ng-minlength=\"3\"\n                 required/>\n          <p class=\"help-block\"\n             ng-show=\"(form.newPassword.$error.minlength || form.newPassword.$error.required) && (form.newPassword.$dirty || vm.submitted)\">\n            Password must be at least 3 characters.\n          </p>\n        </div>\n\n        <div class=\"form-group\">\n          <label>Confirm New Password</label>\n\n          <input type=\"password\" name=\"confirmPassword\" class=\"form-control\" ng-model=\"vm.user.confirmPassword\"\n                 match=\"vm.user.newPassword\"\n                 ng-minlength=\"3\"\n                 required=\"\"/>\n          <p class=\"help-block\"\n             ng-show=\"form.confirmPassword.$error.match && vm.submitted\">\n            Passwords must match.\n          </p>\n\n        </div>\n\n        <p class=\"help-block\"> {{ vm.message }} </p>\n\n        <button class=\"btn btn-lg btn-primary\" type=\"submit\">Save changes</button>\n      </form>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _login = __webpack_require__(128);
	
	var _login2 = _interopRequireDefault(_login);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.login', []).controller('LoginController', _login2.default).name;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoginController = function () {
	
	  /*@ngInject*/
	  LoginController.$inject = ['Auth', '$state'];
	  function LoginController(Auth, $state) {
	    (0, _classCallCheck3.default)(this, LoginController);
	    this.user = {
	      name: '',
	      email: '',
	      password: ''
	    };
	    this.errors = {
	      login: undefined
	    };
	    this.submitted = false;
	
	    this.Auth = Auth;
	    this.$state = $state;
	  }
	
	  (0, _createClass3.default)(LoginController, [{
	    key: 'login',
	    value: function login(form) {
	      var _this = this;
	
	      this.submitted = true;
	
	      if (form.$valid) {
	        this.Auth.login({
	          email: this.user.email,
	          password: this.user.password
	        }).then(function (user) {
	          if (user.role === 'staff') {
	            _this.$state.go('appstore');
	          } else if (user.role === 'customer') {
	            _this.$state.go('carousel');
	          } else {
	            _this.$state.go('appstore');
	          }
	        }).catch(function (err) {
	          _this.errors.login = err.message;
	        });
	      }
	    }
	  }]);
	  return LoginController;
	}();
	
	exports.default = LoginController;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(3);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _settings = __webpack_require__(131);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.settings', []).controller('SettingsController', _settings2.default).name;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SettingsController = function () {
	
	  /*@ngInject*/
	  SettingsController.$inject = ['Auth'];
	  function SettingsController(Auth) {
	    (0, _classCallCheck3.default)(this, SettingsController);
	    this.user = {
	      oldPassword: '',
	      newPassword: '',
	      confirmPassword: ''
	    };
	    this.errors = {
	      other: undefined
	    };
	    this.message = '';
	    this.submitted = false;
	
	    this.Auth = Auth;
	  }
	
	  (0, _createClass3.default)(SettingsController, [{
	    key: 'changePassword',
	    value: function changePassword(form) {
	      var _this = this;
	
	      this.submitted = true;
	
	      if (form.$valid) {
	        this.Auth.changePassword(this.user.oldPassword, this.user.newPassword).then(function () {
	          _this.message = 'Password successfully changed.';
	        }).catch(function () {
	          form.password.$setValidity('mongoose', false);
	          _this.errors.other = 'Incorrect password';
	          _this.message = '';
	        });
	      }
	    }
	  }]);
	  return SettingsController;
	}();
	
	exports.default = SettingsController;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _signup = __webpack_require__(133);
	
	var _signup2 = _interopRequireDefault(_signup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.signup', []).controller('SignupController', _signup2.default).name;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SignupController = function () {
	
	  /*@ngInject*/
	  SignupController.$inject = ['Auth', '$state'];
	  function SignupController(Auth, $state) {
	    (0, _classCallCheck3.default)(this, SignupController);
	    this.user = {
	      name: '',
	      email: '',
	      password: ''
	    };
	    this.errors = {};
	    this.submitted = false;
	
	    this.Auth = Auth;
	    this.$state = $state;
	  }
	
	  (0, _createClass3.default)(SignupController, [{
	    key: 'register',
	    value: function register(form) {
	      var _this = this;
	
	      this.submitted = true;
	
	      if (form.$valid) {
	        return this.Auth.createUser({
	          name: this.user.name,
	          email: this.user.email,
	          password: this.user.password
	        }).then(function () {
	          _this.$state.go('firmwares');
	        }).catch(function (err) {
	          err = err.data;
	          _this.errors = {};
	
	          _angular2.default.forEach(err.errors, function (error, field) {
	            form[field].$setValidity('mongoose', false);
	            _this.errors[field] = error.message;
	          });
	        });
	      }
	    }
	  }]);
	  return SignupController;
	}();
	
	exports.default = SignupController;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _admin = __webpack_require__(135);
	
	var _admin2 = _interopRequireDefault(_admin);
	
	var _admin3 = __webpack_require__(137);
	
	var _admin4 = _interopRequireDefault(_admin3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.admin', ['updateServerApp.auth', 'ui.router']).config(_admin2.default).controller('AdminController', _admin4.default).name;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('admin', {
	    url: '/admin',
	    template: __webpack_require__(136),
	    controller: 'AdminController',
	    controllerAs: 'admin',
	    authenticate: 'admin'
	  });
	}

/***/ }),
/* 136 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <p>The delete user and user index api routes are restricted to users with the 'admin' role.</p>\n  <ul class=\"list-group user-list\">\n    <li class=\"list-group-item\" ng-repeat=\"user in admin.users\">\n\t    <div class=\"user-info\">\n\t        <strong>{{user.name}}</strong><br>\n\t        <span class=\"text-muted\">{{user.email}}</span>\n\t    </div>\n        <a ng-click=\"admin.delete(user)\" class=\"trash\"><span class=\"fa fa-trash fa-2x\"></span></a>\n    </li>\n  </ul>\n</div>\n"

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AdminController = function () {
	  /*@ngInject*/
	  AdminController.$inject = ['User'];
	  function AdminController(User) {
	    (0, _classCallCheck3.default)(this, AdminController);
	
	    this.users = User.query();
	  }
	
	  (0, _createClass3.default)(AdminController, [{
	    key: 'delete',
	    value: function _delete(user) {
	      user.$remove();
	      this.users.splice(this.users.indexOf(user), 1);
	    }
	  }]);
	  return AdminController;
	}();
	
	exports.default = AdminController;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NavbarComponent = undefined;
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavbarComponent = exports.NavbarComponent = ['Auth', '$state', '$rootScope', '$location', function NavbarComponent(Auth, $state, $rootScope, $location) {
	  'ngInject';
	
	  var _this = this;
	
	  (0, _classCallCheck3.default)(this, NavbarComponent);
	  this.menu = [];
	  this.isCollapsed = true;
	  this.isLoggedIn = Auth.isLoggedInSync;
	  this.isAdmin = Auth.isAdminSync;
	  this.getCurrentUser = Auth.getCurrentUserSync;
	  this.$rootScope = $rootScope;
	  this.$rootScope.public_page = false;
	
	  Auth.isLoggedIn(function (loggedIn) {
	    if (!loggedIn) {
	      $location.path('/login');
	    }
	  });
	
	  if (this.getCurrentUser().$promise) {
	    this.getCurrentUser().$promise.then(function (user) {
	      if (user.role === 'customer') {
	        _this.menu = [{
	          title: 'Carousel',
	          state: 'carousel',
	          role: 'customer'
	        }];
	      } else {
	        _this.menu = [{
	          title: '固件',
	          state: 'firmwares'
	        }, {
	          title: '测试组',
	          state: 'betagroups'
	        }, {
	          title: '应用',
	          state: 'apps'
	        }, {
	          title: '应用市场',
	          state: 'appstore',
	          roles: ['staff']
	        }, {
	          title: 'Waveform',
	          state: 'waveforms'
	        }, {
	          title: 'BookList',
	          state: 'booklist'
	        }, {
	          title: 'JDOrder',
	          state: 'jdOrder'
	        }, {
	          title: '应用优化配置',
	          state: 'appconfs',
	          roles: ['staff']
	        }, {
	          title: '大神码',
	          state: 'codeappconfs',
	          roles: ['staff']
	        }, {
	          title: '用户手册',
	          state: 'tutorial'
	        }, {
	          title: '字典',
	          state: 'dictionaries'
	        }, {
	          title: 'MyScripts',
	          state: 'myscripts'
	        }, {
	          title: 'Carousel',
	          state: 'carousel'
	        }, {
	          title: '手写模板',
	          state: 'writetpl'
	        }, {
	          title: '屏保',
	          state: 'screensavers'
	        }, {
	          title: '分类',
	          state: 'categories'
	        }, {
	          title: '标签',
	          state: 'tags'
	        }, {
	          title: '外设固件',
	          state: 'peripheral'
	        }, {
	          title: 'TP固件',
	          state: 'tpFirmwares'
	        }, {
	          title: '字体',
	          state: 'fonts'
	        }, {
	          title: '设备认证',
	          state: 'devicecert'
	        }, {
	          title: '设备组',
	          state: 'appconfgroups'
	        }, {
	          title: '显示器',
	          state: 'monitor'
	        }, {
	          title: '输入法',
	          state: 'keyboard'
	        }, {
	          title: '设备配置',
	          state: 'deviceconfigs'
	        }, {
	          title: '设备管理',
	          state: 'devices'
	        }];
	      }
	
	      if (user.role !== 'admin') {
	        _this.menu = _this.menu.filter(function (item) {
	          return item.roles && item.roles.indexOf(user.role) !== -1;
	        });
	      }
	    });
	  }
	}];
	
	exports.default = _angular2.default.module('directives.navbar', []).component('navbar', {
	  template: __webpack_require__(139),
	  controller: NavbarComponent
	}).name;

/***/ }),
/* 139 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"navbar navbar-default navbar-static-top\">\n  <div class=\"container-full\" ng-if=\"!$ctrl.$rootScope.public_page\">\n    <div class=\"navbar-header\">\n      <button class=\"navbar-toggle\" type=\"button\" ng-click=\"$ctrl.isCollapsed = !$ctrl.isCollapsed\">\n        <span class=\"sr-only\">Toggle navigation</span>\n        <span class=\"icon-bar\"></span>\n        <span class=\"icon-bar\"></span>\n        <span class=\"icon-bar\"></span>\n      </button>\n      <a href=\"#\" class=\"navbar-brand\">ONYX</a>\n    </div>\n    <div uib-collapse=\"$ctrl.isCollapsed\" class=\"navbar-collapse collapse\" id=\"navbar-main\">\n      <ul class=\"nav navbar-nav\">\n        <li ng-repeat=\"item in $ctrl.menu\" ui-sref-active=\"active\" ng-show=\"$ctrl.isLoggedIn()\">\n            <a ui-sref=\"{{item.state}}\">{{item.title}}</a>\n        </li>\n        <!-- <li ng-show=\"$ctrl.isAdmin()\" ui-sref-active=\"active\"><a ui-sref=\"admin\">Admin</a></li> -->\n      </ul>\n\n      <ul class=\"nav navbar-nav navbar-right\">\n        <!-- <li ng-hide=\"$ctrl.isLoggedIn()\" ui-sref-active=\"active\"><a ui-sref=\"signup\">Sign up</a></li> -->\n        <li ng-hide=\"$ctrl.isLoggedIn()\" ui-sref-active=\"active\"><a ui-sref=\"login\">Login</a></li>\n        <li ng-show=\"$ctrl.isLoggedIn()\"><p class=\"navbar-text\">{{ $ctrl.getCurrentUser().name }}</p> </li>\n        <li ng-show=\"$ctrl.isLoggedIn()\" ui-sref-active=\"active\"><a ui-sref=\"settings\"><span class=\"glyphicon glyphicon-cog\"></span></a></li>\n        <li ng-show=\"$ctrl.isLoggedIn()\"><a ui-sref=\"logout\">Logout</a></li>\n      </ul>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FooterComponent = undefined;
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FooterComponent = exports.FooterComponent = function FooterComponent() {
	  (0, _classCallCheck3.default)(this, FooterComponent);
	};
	
	exports.default = _angular2.default.module('directives.footer', []).component('footer', {
	  template: __webpack_require__(141),
	  controller: FooterComponent
	}).name;

/***/ }),
/* 141 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  \n</div>\n"

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(86);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _firmwares = __webpack_require__(143);
	
	var _firmwares2 = _interopRequireDefault(_firmwares);
	
	var _list = __webpack_require__(153);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _edit = __webpack_require__(155);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _add = __webpack_require__(160);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _nanoreader = __webpack_require__(162);
	
	var _nanoreader2 = _interopRequireDefault(_nanoreader);
	
	var _updated = __webpack_require__(164);
	
	var _updated2 = _interopRequireDefault(_updated);
	
	var _count = __webpack_require__(166);
	
	var _count2 = _interopRequireDefault(_count);
	
	var _lang = __webpack_require__(171);
	
	var _lang2 = _interopRequireDefault(_lang);
	
	var _model = __webpack_require__(173);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.firmwares', [_angularUiRouter2.default, _list2.default, _edit2.default, _add2.default, _nanoreader2.default, _updated2.default, _count2.default, _lang2.default, _model2.default]).config(_firmwares2.default).run(['$rootScope', function ($rootScope) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
	    if (next.name === 'logout' && current && current.name && !current.authenticate) {
	      next.referrer = current.name;
	    }
	  });
	}]).name;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $urlRouterProvider.when("/", "/firmwares/list");
	  $urlRouterProvider.when("/firmwares", "/firmwares/list");
	  $stateProvider.state('firmwares', {
	    url: '/firmwares?page',
	    template: __webpack_require__(144),
	    authenticate: true
	  }).state('firmwares.list', {
	    url: '/list',
	    template: __webpack_require__(145),
	    controller: 'FirmwaresListController',
	    controllerAs: 'firmwaresListCtrl'
	  }).state('firmwares.edit', {
	    url: '/edit/:id',
	    template: __webpack_require__(146),
	    controller: 'FirmwaresEditController',
	    controllerAs: 'firmwaresEdittCtrl'
	  }).state('firmwares.add', {
	    url: '/add',
	    template: __webpack_require__(147),
	    controller: 'FirmwaresAddController',
	    controllerAs: 'firmwaresAddCtrl'
	  }).state('firmwares.nanoreaderAdd', {
	    url: '/nanoreader/add',
	    template: __webpack_require__(148),
	    controller: 'FirmwaresNanoreaderAddController',
	    controllerAs: 'firmwaresNanoreaderAddCtrl'
	  }).state('firmwares.updated', {
	    url: '/updated',
	    template: __webpack_require__(149),
	    controller: 'FirmwaresUpdatedController',
	    controllerAs: 'firmwaresUpdatedCtrl'
	  }).state('firmwares.count', {
	    url: '/count',
	    template: __webpack_require__(150),
	    controller: 'FirmwaresUpdatedCountController',
	    controllerAs: 'firmwaresCountCtrl'
	  }).state('firmwares.lang', {
	    url: '/lang',
	    template: __webpack_require__(151),
	    controller: 'FirmwaresLangController',
	    controllerAs: 'firmwaresLangCtrl'
	  }).state('firmwares.model', {
	    url: '/model',
	    template: __webpack_require__(152),
	    controller: 'FirmwaresModelController',
	    controllerAs: 'firmwaresModelCtrl'
	  });
	}];

/***/ }),
/* 144 */
/***/ (function(module, exports) {

	module.exports = "<div ui-view></div>\n"

/***/ }),
/* 145 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-full\">\n  <div class=\"page-header\">\n    <a ui-sref=\"firmwares.add\" class=\"btn btn-primary pull-right\">添加</a>\n    <a ui-sref=\"firmwares.nanoreaderAdd\" class=\"btn btn-primary pull-right\" style=\"margin-right: 10px;\">添加NanoReader固件</a>\n    <a ui-sref=\"firmwares.updated\" class=\"btn btn-success pull-right\" style=\"margin-right: 10px;\">升级统计</a>\n    <h3>Firmwares</h3>\n  </div>\n  <div class=\"\">\n    <table class=\"table table-striped\">\n      <thead>\n        <tr>\n          <th style=\"width: 50px;\"></th>\n          <th>型号</th>\n          <th>版本信息</th>\n          <th style=\"width: 100px;\">语言</th>\n          <th style=\"width: 100px;\">升级方式</th>\n          <th>灰度数量</th>\n          <th>类型</th>\n          <th>日期</th>\n          <th>组</th>\n          <th class=\"ctrl-th\"></th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"firmware in firmwaresListCtrl.firmwares.list\">\n          <td>{{$index + 1}}</td>\n          <td>{{firmware.model}}</td>\n          <td>{{firmware.fingerprint}}</td>\n          <td><p style=\"display: block; width: 100px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;\">{{firmware.lang.join(',')}}</p></td>\n          <td>\n            <p ng-class=\"{'text-primary': firmware.parentFingerprint}\">{{firmware.parentFingerprint ? \"增量\" : \"全量\"}}</p>\n          </td>\n          <td>{{firmware.availableCount ? firmware.availableCount : '不限'}}</td>\n          <td>{{firmware.buildType}}</td>\n          <td>{{firmware.createdAt | date:'yyyy-MM-dd'}}</td>\n          <td>{{firmware.betaGroups | groupName: firmwaresListCtrl.betaGroups}}</td>\n          <td class=\"ctrl-td\">\n            <button ui-sref=\"firmwares.edit({id: firmware._id})\" class=\"btn btn-xs btn-success\">编辑</button>\n            <button ng-click=\"firmwaresListCtrl.delete(firmware._id)\" class=\"btn btn-xs btn-danger\">删除</button>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n\n    <div class=\"pagination-div\" ng-show=\"firmwaresListCtrl.firmwares.count > 0\">\n      <ul uib-pagination data-ng-if=\"firmwaresListCtrl.firmwares.count\" total-items=\"firmwaresListCtrl.firmwares.count\"\n        ng-model=\"firmwaresListCtrl.page\" max-size=\"5\" class=\"\" boundary-link-numbers=\"true\" rotate=\"false\"\n        ng-change=\"firmwaresListCtrl.pageChanged()\" items-per-page=\"firmwaresListCtrl.params.limit\" previous-text=\"上一页\"\n        next-text=\"下一页\"></ul>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 146 */
/***/ (function(module, exports) {

	module.exports = "\n<div class=\"container\">\n  <div class=\"page-header\">\n    <h1>添加</h1>\n  </div>\n  <div>\n    <form>\n      <div class=\"form-group\">\n        <label for=\"model\">型号<span class=\"text-danger\">(必需)</span></label>\n        <input type=\"model\" class=\"form-control\" ng-model=\"firmwaresEdittCtrl.firmware.model\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"submodel\">子型号</label>\n        <input type=\"submodel\" class=\"form-control\" ng-model=\"firmwaresEdittCtrl.firmware.submodel\">\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"brand\">品牌<span class=\"text-danger\">(必需)</span></label>\n        <input type=\"brand\" class=\"form-control\" ng-model=\"firmwaresEdittCtrl.firmware.brand\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"buildNumber\">编译版本号<span class=\"text-danger\">(必需)</span></label>\n        <input type=\"number\" class=\"form-control\" ng-model=\"firmwaresEdittCtrl.firmware.buildNumber\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"buildDisplayId\">显示版本号<span class=\"text-danger\">(自定义版本号，升级记录中展示)</span></label>\n        <input type=\"text\" class=\"form-control\" ng-model=\"firmwaresEdittCtrl.firmware.buildDisplayId\">\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"parentFingerprint\">升级目标版本（填写目标版本的fingerprint）</label>\n        <input type=\"fingerprint\" class=\"form-control\" ng-model=\"firmwaresEdittCtrl.firmware.parentFingerprint\">\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"buildType\">编译类型<span class=\"text-danger\">(必需)</span></label>\n        <input type=\"buildType\" class=\"form-control\" ng-model=\"firmwaresEdittCtrl.firmware.buildType\" required>\n      </div>\n\n\n      <div class=\"form-group\">\n        <label for=\"fingerprint\">指纹信息<span class=\"text-danger\">(必需)</span></label>\n        <input type=\"fingerprint\" class=\"form-control\" ng-model=\"firmwaresEdittCtrl.firmware.fingerprint\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"lang\">语言<span class=\"text-danger\">(必需,多种语言用|隔开)</span></label>\n        <input type=\"lang\" class=\"form-control\" ng-model=\"firmwaresEdittCtrl.firmware.lang\" ng-list=\"|\" ng-trim=\"true\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"md5\">MD5<span class=\"text-danger\">(必需)</span></label>\n        <input type=\"md5\" class=\"form-control\" ng-model=\"firmwaresEdittCtrl.firmware.md5\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"codecUsageMask\">Codec Usage Mask</label>\n        <input type=\"text\" class=\"form-control\" ng-model=\"firmwaresEdittCtrl.firmware.codecUsageMask\">\n      </div>\n\n      <!-- <div class=\"form-group\">\n        <label for=\"widthPixels\">屏幕宽<span class=\"text-danger\">(必需)</span></label>\n        <input type=\"number\" class=\"form-control\" ng-model=\"firmwaresEdittCtrl.firmware.widthPixels\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"heightPixels\">屏幕高<span class=\"text-danger\">(必需)</span></label>\n        <input type=\"number\" class=\"form-control\" ng-model=\"firmwaresEdittCtrl.firmware.heightPixels\" required>\n      </div> -->\n\n      <div class=\"form-group\">\n        <label for=\"size\">固件大小\n          <span class=\"text-danger\">(必需)</span>\n        </label>\n        <input type=\"number\" class=\"form-control\" ng-model=\"firmwaresEdittCtrl.firmware.size\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"deviceMAC\">目标设备MAC  <span class=\"text-danger\">（每行一个MAC）</span></label>\n        <textarea type=\"deviceMAC\" class=\"form-control\" ng-model=\"firmwaresEdittCtrl.firmware.deviceMAC\" ng-list=\"&#10;\" ng-trim=\"false\" rows=\"5\"></textarea>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"changeList\">变更信息\n          <span class=\"text-danger\">(必需)</span>\n        </label>\n        <summernote ng-if=\"!firmwaresEdittCtrl.firmware.changeListHtmlUrl\"\n          ng-model=\"firmwaresEdittCtrl.firmware.changeListHtml\" config=\"firmwaresEdittCtrl.summernoteConfig\" height=\"300\"></summernote>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"downloadUrlList\">下载地址</label>\n        <textarea type=\"downloadUrlList\" class=\"form-control\" ng-model=\"firmwaresEdittCtrl.firmware.downloadUrlList\" ng-list=\"&#10;\" ng-trim=\"false\" rows=\"5\"></textarea>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"changeListHtmlFile\">变更信息HTML文件</label>\n        <input type=\"file\" ngf-select ng-model=\"firmwaresEdittCtrl.changeListHtmlFile\" name=\"changeListHtmlFile\"\n          ngf-pattern=\"'.html,.htm'\" ngf-accept=\"'.html,.htm'\" accept=\".html,.htm\" class=\"form-control\">\n        <div class=\"progress\" ng-if=\"firmwaresEdittCtrl.changeListHtmlFile.progress\">\n          <div class=\"progress-bar\" role=\"progressbar\" ng-style=\"{width: firmwaresEdittCtrl.changeListHtmlFile.progress + '%'}\">\n            {{firmwaresEdittCtrl.changeListHtmlFile.progress}}%\n          </div>\n        </div>\n        <p class=\"help-block\" ng-if=\"firmwaresEdittCtrl.firmware.changeListHtmlUrl\">\n          <a ng-href=\"{{firmwaresEdittCtrl.firmware.changeListHtmlUrl}}\" target=\"_blank\">{{firmwaresEdittCtrl.firmware.changeListHtmlUrl}}</a>\n        </p>\n        <button type=\"button\" class=\"btn btn-default\" ng-disabled=\"!firmwaresEdittCtrl.changeListHtmlFile\"\n          ng-click=\"firmwaresEdittCtrl.uploadChangeListHtml(firmwaresEdittCtrl.changeListHtmlFile)\">上传HTML</button>\n        <button type=\"button\" class=\"btn btn-danger\" ng-if=\"firmwaresEdittCtrl.firmware.changeListHtmlUrl\"\n          ng-click=\"firmwaresEdittCtrl.deleteChangeListHtml()\">删除HTML</button>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"size\">灰度升级数量\n        </label>\n        <select class=\"form-control\" ng-model=\"firmwaresEdittCtrl.firmware.availableCount\" required=\"true\">\n          <option ng-repeat=\"c in firmwaresEdittCtrl.availableCountArr\" value=\"{{c.value}}\"\n            ng-selected=\"firmwaresEdittCtrl.firmware.availableCount === c.value\">{{c.name}}\n          </option>\n        </select>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"whitelistMAC\">灰度升级白名单 <span class=\"text-danger\">（每行一个MAC）</span></label>\n        <textarea type=\"whitelistMAC\" class=\"form-control\" ng-model=\"firmwaresEdittCtrl.firmware.whitelistMAC\" ng-list=\"&#10;\"\n          ng-trim=\"false\" rows=\"5\"></textarea>\n      </div>\n\n      <div class=\"form-group\">\n        <input type=\"checkbox\" name=\"form-control\" ng-model=\"firmwaresEdittCtrl.firmware.excludeGroups\"><span>排除组</span>\n      </div>\n\n      <div class=\"clearfix\">\n        <label for=\"\">测试组</label>\n        <ul class=\"betagroup-list\">\n          <li ng-repeat=\"group in firmwaresEdittCtrl.betaGroups\" class=\"\">\n            <input type=\"checkbox\"  name=\"betaGroups[]\" value=\"{{group._id}}\" ng-checked=\"firmwaresEdittCtrl.firmware.betaGroups.indexOf(group._id) > -1\" ng-click=\"firmwaresEdittCtrl.toggleSelection(group._id)\"><span>{{group.name}}</span>\n          </li>\n        </ul>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"\">升级配置</label><br>\n        <input type=\"checkbox\" name=\"form-control\" ng-model=\"firmwaresEdittCtrl.firmware.force\"><span>强制升级</span>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"\">数据清理</label><br>\n        <input type=\"checkbox\" name=\"form-control\" ng-model=\"firmwaresEdittCtrl.firmware.wipeData\"><span>升级时删除数据</span>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"\">Keybox</label><br>\n        <input type=\"checkbox\" name=\"form-control\" ng-model=\"firmwaresEdittCtrl.firmware.lockBootloader\"><span>仅限已锁定Bootloader的设备升级</span>\n      </div>\n\n      <button type=\"submit\" class=\"btn btn-success\" ng-click=\"firmwaresEdittCtrl.save()\">保存</button>\n      <button type=\"button\" class=\"btn btn-default\" ui-sref=\"^\">返回</button>\n    </form>\n  </div>\n</div>\n"

/***/ }),
/* 147 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n    <div class=\"page-header\">\n        <h1>添加</h1>\n    </div>\n    <div>\n        <form>\n            <div class=\"form-group\">\n                <label for=\"model\">型号\n                    <span class=\"text-danger\">(必需)</span>\n                </label>\n                <input type=\"model\" class=\"form-control\" ng-model=\"firmwaresAddCtrl.newFirmware.model\" required>\n            </div>\n\n            <div class=\"form-group\">\n                <label for=\"submodel\">子型号</label>\n                <input type=\"submodel\" class=\"form-control\" ng-model=\"firmwaresAddCtrl.newFirmware.submodel\">\n            </div>\n\n            <div class=\"form-group\">\n                <label for=\"brand\">品牌\n                    <span class=\"text-danger\">(必需)</span>\n                </label>\n                <input type=\"brand\" class=\"form-control\" ng-model=\"firmwaresAddCtrl.newFirmware.brand\" required>\n            </div>\n\n            <div class=\"form-group\">\n                <label for=\"buildNumber\">编译版本号\n                    <span class=\"text-danger\">(必需)</span>\n                </label>\n                <input type=\"number\" class=\"form-control\" ng-model=\"firmwaresAddCtrl.newFirmware.buildNumber\" required>\n            </div>\n\n            <div class=\"form-group\">\n                <label for=\"parentFingerprint\">升级目标版本（填写目标版本的fingerprint）</label>\n                <input type=\"fingerprint\" class=\"form-control\" ng-model=\"firmwaresAddCtrl.newFirmware.parentFingerprint\">\n            </div>\n\n            <div class=\"form-group\">\n                <label for=\"buildType\">编译类型\n                    <span class=\"text-danger\">(必需)</span>\n                </label>\n                <input type=\"buildType\" class=\"form-control\" ng-model=\"firmwaresAddCtrl.newFirmware.buildType\" required>\n            </div>\n\n\n            <div class=\"form-group\">\n                <label for=\"fingerprint\">指纹信息\n                    <span class=\"text-danger\">(必需)</span>\n                </label>\n                <input type=\"fingerprint\" class=\"form-control\" ng-model=\"firmwaresAddCtrl.newFirmware.fingerprint\" required>\n            </div>\n\n            <div class=\"form-group\">\n                <label for=\"lang\">语言\n                    <span class=\"text-danger\">(必需,多种语言用|隔开)</span>\n                </label>\n                <input type=\"lang\" class=\"form-control\" ng-model=\"firmwaresAddCtrl.newFirmware.lang\" ng-list=\"|\" required>\n            </div>\n\n            <div class=\"form-group\">\n                <label for=\"md5\">MD5\n                    <span class=\"text-danger\">(必需)</span>\n                </label>\n                <input type=\"md5\" class=\"form-control\" ng-model=\"firmwaresAddCtrl.newFirmware.md5\" required>\n            </div>\n\n            <div class=\"form-group\">\n                <label for=\"codecUsageMask\">Codec Usage Mask</label>\n                <input type=\"text\" class=\"form-control\" ng-model=\"firmwaresAddCtrl.newFirmware.codecUsageMask\">\n            </div>\n\n            <!-- <div class=\"form-group\">\n                <label for=\"widthPixels\">屏幕宽\n                    <span class=\"text-danger\">(必需)</span>\n                </label>\n                <input type=\"number\" class=\"form-control\" ng-model=\"firmwaresAddCtrl.newFirmware.widthPixels\" required>\n            </div>\n\n            <div class=\"form-group\">\n                <label for=\"heightPixels\">屏幕高\n                    <span class=\"text-danger\">(必需)</span>\n                </label>\n                <input type=\"number\" class=\"form-control\" ng-model=\"firmwaresAddCtrl.newFirmware.heightPixels\" required>\n            </div> -->\n\n            <div class=\"form-group\">\n                <label for=\"size\">固件大小\n                    <span class=\"text-danger\">(必需)</span>\n                </label>\n                <input type=\"number\" class=\"form-control\" ng-model=\"firmwaresAddCtrl.newFirmware.size\" required>\n            </div>\n\n            <div class=\"form-group\">\n                <label for=\"deviceMAC\">目标设备MAC\n                    <span class=\"text-danger\">（每行一个MAC）</span>\n                </label>\n                <textarea type=\"deviceMAC\" class=\"form-control\" ng-model=\"firmwaresAddCtrl.newFirmware.deviceMAC\" ng-list=\"&#10;\" ng-trim=\"false\"\n                    rows=\"5\"></textarea>\n            </div>\n\n            <div class=\"form-group\">\n                <label for=\"changeList\">变更信息\n                    <span class=\"text-danger\">(必需)</span>\n                </label>\n                <summernote ng-if=\"!firmwaresAddCtrl.newFirmware.changeListHtmlUrl\"\n                    ng-model=\"firmwaresAddCtrl.newFirmware.changeListHtml\" config=\"firmwaresAddCtrl.summernoteConfig\" height=\"300\"></summernote>\n            </div>\n\n            <div class=\"form-group\">\n                <label for=\"downloadUrlList\">下载地址</label>\n                <textarea type=\"downloadUrlList\" class=\"form-control\" ng-model=\"firmwaresAddCtrl.newFirmware.downloadUrlList\" ng-list=\"&#10;\"\n                    ng-trim=\"false\" rows=\"5\"></textarea>\n            </div>\n\n            <div class=\"form-group\">\n                <label for=\"changeListHtmlFile\">变更信息HTML文件</label>\n                <input type=\"file\" ngf-select ng-model=\"firmwaresAddCtrl.changeListHtmlFile\" name=\"changeListHtmlFile\"\n                    ngf-pattern=\"'.html,.htm'\" ngf-accept=\"'.html,.htm'\" accept=\".html,.htm\" class=\"form-control\">\n                <div class=\"progress\" ng-if=\"firmwaresAddCtrl.changeListHtmlFile.progress\">\n                    <div class=\"progress-bar\" role=\"progressbar\" ng-style=\"{width: firmwaresAddCtrl.changeListHtmlFile.progress + '%'}\">\n                        {{firmwaresAddCtrl.changeListHtmlFile.progress}}%\n                    </div>\n                </div>\n                <p class=\"help-block\" ng-if=\"firmwaresAddCtrl.newFirmware.changeListHtmlUrl\">\n                    <a ng-href=\"{{firmwaresAddCtrl.newFirmware.changeListHtmlUrl}}\" target=\"_blank\">{{firmwaresAddCtrl.newFirmware.changeListHtmlUrl}}</a>\n                </p>\n                <button type=\"button\" class=\"btn btn-default\" ng-disabled=\"!firmwaresAddCtrl.changeListHtmlFile\"\n                    ng-click=\"firmwaresAddCtrl.uploadChangeListHtml(firmwaresAddCtrl.changeListHtmlFile)\">上传HTML</button>\n            </div>\n            \n            <div class=\"form-group\">\n              <label for=\"size\">灰度升级数量\n              </label>\n              <input type=\"number\" class=\"form-control\" ng-model=\"firmwaresAddCtrl.newFirmware.availableCount\">\n            </div>\n\n            <div class=\"form-group\">\n              <label for=\"whitelistMAC\">灰度升级白名单\n                <span class=\"text-danger\">（每行一个MAC）</span>\n              </label>\n              <textarea type=\"whitelistMAC\" class=\"form-control\" ng-model=\"firmwaresAddCtrl.newFirmware.whitelistMAC\"\n                ng-list=\"&#10;\" ng-trim=\"false\" rows=\"5\"></textarea>\n            </div>\n\n            <div class=\"form-group\">\n                <input type=\"checkbox\" name=\"form-control\" ng-model=\"firmwaresAddCtrl.newFirmware.excludeGroups\"><span>排除组</span>\n            </div>\n\n            <div class=\"clearfix\">\n                <label for=\"\">测试组</label>\n                <ul class=\"betagroup-list\">\n                    <li ng-repeat=\"group in firmwaresAddCtrl.betaGroups\" class=\"\">\n                        <input type=\"checkbox\" name=\"betaGroups[]\" value=\"{{group._id}}\" ng-checked=\"firmwaresAddCtrl.newFirmware.betaGroups.indexOf(group._id) > -1\"\n                            ng-click=\"firmwaresAddCtrl.toggleSelection(group._id)\">\n                        <span>{{group.name}}</span>\n                    </li>\n                </ul>\n            </div>\n\n            <div class=\"form-group\">\n              <label for=\"\">升级配置</label><br>\n              <input type=\"checkbox\" name=\"form-control\" ng-model=\"firmwaresAddCtrl.newFirmware.force\">\n              <span>强制升级</span>\n            </div>\n\n            <div class=\"form-group\">\n              <label for=\"\">数据清理</label><br>\n              <input type=\"checkbox\" name=\"form-control\" ng-model=\"firmwaresAddCtrl.newFirmware.wipeData\">\n              <span>升级时删除数据</span>\n            </div>\n\n            <div class=\"form-group\">\n              <label for=\"\">Keybox</label><br>\n              <input type=\"checkbox\" name=\"form-control\" ng-model=\"firmwaresAddCtrl.newFirmware.lockBootloader\">\n              <span>仅限已锁定Bootloader的设备升级</span>\n            </div>\n\n            <button type=\"submit\" class=\"btn btn-success\" ng-click=\"firmwaresAddCtrl.save()\">保存</button>\n            <button type=\"button\" class=\"btn btn-default\" ui-sref=\"^\">返回</button>\n        </form>\n    </div>\n</div>"

/***/ }),
/* 148 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n    <div class=\"page-header\">\n        <h1>添加 NanoReader 固件</h1>\n    </div>\n    <div>\n        <form>\n            <div class=\"form-group\">\n                <label for=\"model\">型号 <span class=\"text-danger\">(必需)</span></label>\n                <input type=\"text\" class=\"form-control\" ng-model=\"firmwaresNanoreaderAddCtrl.newFirmware.model\" required>\n            </div>\n\n            <div class=\"form-group\">\n                <label for=\"buildNumber\">编译版本号 <span class=\"text-danger\">(必需)</span></label>\n                <input type=\"number\" class=\"form-control\" ng-model=\"firmwaresNanoreaderAddCtrl.newFirmware.buildNumber\" required>\n            </div>\n\n            <div class=\"form-group\">\n                <label for=\"buildDisplayId\">显示版本号 <span class=\"text-danger\">(自定义版本号，升级记录中展示)</span></label>\n                <input type=\"text\" class=\"form-control\" ng-model=\"firmwaresNanoreaderAddCtrl.newFirmware.buildDisplayId\">\n            </div>\n\n            <div class=\"form-group\">\n                <label for=\"buildType\">编译类型 <span class=\"text-danger\">(必需)</span></label>\n                <input type=\"text\" class=\"form-control\" ng-model=\"firmwaresNanoreaderAddCtrl.newFirmware.buildType\" required>\n            </div>\n\n            <div class=\"form-group\">\n                <label for=\"lang\">语言 <span class=\"text-danger\">(必需,多种语言用|隔开)</span></label>\n                <input type=\"text\" class=\"form-control\" ng-model=\"firmwaresNanoreaderAddCtrl.newFirmware.lang\" ng-list=\"|\" required>\n            </div>\n\n            <div class=\"form-group\">\n                <label>固件文件 <span class=\"text-danger\">(必需)</span></label>\n                <input type=\"file\" ngf-select ng-model=\"firmwaresNanoreaderAddCtrl.firmwareFile\" name=\"firmwareFile\" class=\"form-control\">\n                <div class=\"progress\" ng-if=\"firmwaresNanoreaderAddCtrl.firmwareFile.progress\">\n                    <div class=\"progress-bar\" role=\"progressbar\" ng-style=\"{width: firmwaresNanoreaderAddCtrl.firmwareFile.progress + '%'}\">\n                        {{firmwaresNanoreaderAddCtrl.firmwareFile.progress}}%\n                    </div>\n                </div>\n                <p class=\"help-block\" ng-if=\"firmwaresNanoreaderAddCtrl.firmwareUrl\">\n                    <a ng-href=\"{{firmwaresNanoreaderAddCtrl.firmwareUrl}}\" target=\"_blank\">{{firmwaresNanoreaderAddCtrl.firmwareUrl}}</a>\n                    <br>MD5: {{firmwaresNanoreaderAddCtrl.newFirmware.md5}} · 大小: {{firmwaresNanoreaderAddCtrl.newFirmware.size}} 字节\n                </p>\n                <button type=\"button\" class=\"btn btn-default\" ng-disabled=\"!firmwaresNanoreaderAddCtrl.firmwareFile\"\n                    ng-click=\"firmwaresNanoreaderAddCtrl.uploadFirmwareFile(firmwaresNanoreaderAddCtrl.firmwareFile)\">上传固件</button>\n            </div>\n\n            <div class=\"form-group\">\n                <label for=\"changeList\">变更信息 <span class=\"text-danger\">(必需)</span></label>\n                <summernote ng-model=\"firmwaresNanoreaderAddCtrl.newFirmware.changeListHtml\" config=\"firmwaresNanoreaderAddCtrl.summernoteConfig\" height=\"300\"></summernote>\n            </div>\n\n            <div class=\"form-group\">\n                <label for=\"availableCount\">灰度升级数量</label>\n                <input type=\"number\" class=\"form-control\" ng-model=\"firmwaresNanoreaderAddCtrl.newFirmware.availableCount\">\n            </div>\n\n            <div class=\"form-group\">\n                <label for=\"whitelistMAC\">灰度升级白名单 <span class=\"text-danger\">（每行一个MAC）</span></label>\n                <textarea class=\"form-control\" ng-model=\"firmwaresNanoreaderAddCtrl.newFirmware.whitelistMAC\"\n                    ng-list=\"&#10;\" ng-trim=\"false\" rows=\"5\"></textarea>\n            </div>\n\n            <div class=\"form-group\">\n                <label for=\"deviceMAC\">目标设备MAC <span class=\"text-danger\">（每行一个MAC）</span></label>\n                <textarea class=\"form-control\" ng-model=\"firmwaresNanoreaderAddCtrl.newFirmware.deviceMAC\"\n                    ng-list=\"&#10;\" ng-trim=\"false\" rows=\"5\"></textarea>\n            </div>\n\n            <div class=\"clearfix\">\n                <label>测试组</label>\n                <ul class=\"betagroup-list\">\n                    <li ng-repeat=\"group in firmwaresNanoreaderAddCtrl.betaGroups\">\n                        <input type=\"checkbox\" name=\"betaGroups[]\" value=\"{{group._id}}\"\n                            ng-checked=\"firmwaresNanoreaderAddCtrl.newFirmware.betaGroups.indexOf(group._id) > -1\"\n                            ng-click=\"firmwaresNanoreaderAddCtrl.toggleSelection(group._id)\">\n                        <span>{{group.name}}</span>\n                    </li>\n                </ul>\n            </div>\n\n            <div class=\"form-group\">\n                <label>升级配置</label><br>\n                <input type=\"checkbox\" ng-model=\"firmwaresNanoreaderAddCtrl.newFirmware.force\">\n                <span>强制升级</span>\n            </div>\n\n            <button type=\"submit\" class=\"btn btn-success\" ng-click=\"firmwaresNanoreaderAddCtrl.save()\">保存</button>\n            <button type=\"button\" class=\"btn btn-default\" ui-sref=\"^\">返回</button>\n        </form>\n    </div>\n</div>\n"

/***/ }),
/* 149 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-full\">\n  <div class=\"page-header\">\n    <a ui-sref=\"firmwares.model\" class=\"btn btn-success pull-right\" style=\"margin-right: 10px;\">型号分布统计</a>\n    <a ui-sref=\"firmwares.lang\" class=\"btn btn-success pull-right\" style=\"margin-right: 10px;\">语言分布统计</a>\n    <a ui-sref=\"firmwares.count\" class=\"btn btn-success pull-right\" style=\"margin-right: 10px;\">数量统计</a>\n    <a class=\"btn btn-default pull-right\" style=\"margin-right: 10px;\" ng-click=\"firmwaresUpdatedCtrl.getFirmwares(1)\">下载</a>\n    <a class=\"btn btn-default pull-right\" style=\"margin-right: 10px;\" ng-click=\"firmwaresUpdatedCtrl.getFirmwares(2)\">更新</a>\n    <h3>Firmwares</h3>\n  </div>\n  <div class=\"\">\n    <table class=\"table table-striped\">\n      <thead>\n        <tr>\n          <th style=\"width: 50px;\"></th>\n          <th>型号</th>\n          <th>MAC</th>\n          <th>Brand</th>\n          <th>版本信息</th>\n          <th style=\"width: 200px;\">语言</th>\n          <th>类型</th>\n          <th>日期</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"firmware in firmwaresUpdatedCtrl.firmwares.list\">\n          <td>{{$index + 1}}</td>\n          <td>{{firmware.model}}</td>\n          <td>{{firmware.deviceMAC}}</td>\n          <td>{{firmware.brand}}</td>\n          <td>{{firmware.fingerprint}}</td>\n          <td><p style=\"width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;\">{{firmware.lang.join(',')}}</p></td>\n          <td>{{firmware.fwType}}</td>\n          <td>{{firmware.createdAt | date:'yyyy-MM-dd'}}</td>\n        </tr>\n      </tbody>\n    </table>\n\n    <div class=\"pagination-div\" ng-show=\"firmwaresUpdatedCtrl.firmwares.count > 0\">\n      <ul uib-pagination data-ng-if=\"firmwaresUpdatedCtrl.firmwares.count\" total-items=\"firmwaresUpdatedCtrl.firmwares.count\"\n        ng-model=\"firmwaresUpdatedCtrl.page\" max-size=\"5\" class=\"\" boundary-link-numbers=\"true\" rotate=\"false\"\n        ng-change=\"firmwaresUpdatedCtrl.pageChanged()\" items-per-page=\"firmwaresUpdatedCtrl.params.limit\" previous-text=\"上一页\"\n        next-text=\"下一页\"></ul>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 150 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-full\">\n  <div class=\"page-header\">\n    <a ui-sref=\"firmwares.updated\" class=\"btn btn-default pull-right\" style=\"margin-right: 10px;\">返回</a>\n    <h3>Firmwares Version Count </h3>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-md-6\">\n      <h3>下载({{firmwaresCountCtrl.versionsDownload.count}})</h3>\n      <table class=\"table table-striped\">\n        <thead>\n          <tr>\n            <th style=\"width: 50px;\"></th>\n            <th>版本信息</th>\n            <th>数量</th>          \n          </tr>\n        </thead>\n        <tbody>\n          <tr ng-repeat=\"version in firmwaresCountCtrl.versionsDownload.list\">\n            <td>{{$index + 1}}</td>\n            <td>{{version.fingerprint}}</td>\n            <td>{{version.count}}</td>\n          </tr>\n        </tbody>\n      </table>\n    </div>\n    <div class=\"col-md-6\">\n      <h3>已更新({{firmwaresCountCtrl.versionsCurrent.count}})</h3>\n      <table class=\"table table-striped\">\n        <thead>\n          <tr>\n            <th style=\"width: 50px;\"></th>\n            <th>版本信息</th>\n            <th>数量</th>          \n          </tr>\n        </thead>\n        <tbody>\n          <tr ng-repeat=\"version in firmwaresCountCtrl.versionsCurrent.list\">\n            <td>{{$index + 1}}</td>\n            <td>{{version.fingerprint}}</td>\n            <td>{{version.count}}</td>\n          </tr>\n        </tbody>\n      </table>\n    </div>\n\n  </div>\n</div>\n"

/***/ }),
/* 151 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-full\">\n  <div class=\"page-header\">\n    <h3>语言分布统计</h3>\n  </div>\n  <div class=\"\">\n    <table class=\"table table-striped\">\n      <thead>\n        <tr>\n          <th style=\"width: 50px;\"></th>\n          <th>语言</th>\n          <th>数量</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"item in firmwaresLangCtrl.data\">\n          <td>{{$index + 1}}</td>\n          <td>{{item._id}}</td>\n          <td>{{item.count}}</td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 152 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-full\">\n  <div class=\"page-header\">\n    <form class=\"form-inline pull-right\">\n    <div class=\"input-group\">\n        <input type=\"text\" class=\"form-control\" placeholder=\"model\" aria-describedby=\"sizing-addon2\" ng-model=\"model\">\n        <span class=\"input-group-addon\" id=\"sizing-addon2\" ng-click=\"firmwaresModelCtrl.search(model)\">查询</span>\n      </div>\n      </form>\n    <h3>型号分布统计</h3>\n  </div>\n  <div class=\"\">\n    <table class=\"table table-striped\">\n      <thead>\n        <tr>\n          <th style=\"width: 50px;\"></th>\n          <th>型号</th>\n          <th>数量</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"item in firmwaresModelCtrl.data\">\n          <td>{{$index + 1}}</td>\n          <td>{{item._id}}</td>\n          <td>{{item.count}}</td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _list = __webpack_require__(154);
	
	var _list2 = _interopRequireDefault(_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.firmwares.list', []).controller('FirmwaresListController', _list2.default).name;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListController = function () {
	
	  /*@ngInject*/
	  ListController.$inject = ['$http', '$stateParams', '$state'];
	  function ListController($http, $stateParams, $state) {
	    (0, _classCallCheck3.default)(this, ListController);
	
	    this.$http = $http;
	    this.$stateParams = $stateParams;
	    this.$state = $state;
	
	    this.page = 1;
	    this.params = {
	      offset: this.page - 1,
	      limit: 20,
	      sortBy: 'createdAt',
	      order: -1
	    };
	  }
	
	  (0, _createClass3.default)(ListController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      if (this.$stateParams.page) {
	        this.page = this.$stateParams.page;
	      }
	      this.getBetaGroups();
	    }
	  }, {
	    key: 'getFirmwares',
	    value: function getFirmwares() {
	      var _this = this;
	
	      this.params.offset = (this.page - 1) * this.params.limit;
	      this.$http.get('/api/firmware', { params: this.params }).then(function (res) {
	        _this.firmwares = res.data;
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(id) {
	      var _this2 = this;
	
	      if (confirm("确定？")) {
	        this.$http.delete('/api/firmware/' + id).then(function (res) {
	          _this2.getFirmwares();
	        });
	      }
	    }
	  }, {
	    key: 'getBetaGroups',
	    value: function getBetaGroups() {
	      var _this3 = this;
	
	      this.$http.get('/api/betaGroups').then(function (res) {
	        _this3.betaGroups = res.data;
	        _this3.getFirmwares();
	      });
	    }
	  }, {
	    key: 'findGroups',
	    value: function findGroups(ids) {
	      var groups = this.betaGroups.find(function (item) {
	        return ids.indexOf(item._id) != -1;
	      });
	      return groups = groups.map(function (item) {
	        return item.name;
	      });
	    }
	  }, {
	    key: 'notify',
	    value: function notify(id) {
	      if (confirm("确定进行推送？")) {
	        this.$http.get('/api/firmware/' + id + '/notify').then(function (res) {
	          console.log(res);
	        });
	      }
	    }
	  }, {
	    key: 'pageChanged',
	    value: function pageChanged() {
	      this.$state.go('firmwares.list', { page: this.page });
	    }
	  }]);
	  return ListController;
	}();
	
	exports.default = ListController;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _edit = __webpack_require__(156);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.firmwares.edit', []).controller('FirmwaresEditController', _edit2.default).name;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(157);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _summernote = __webpack_require__(159);
	
	var _summernote2 = _interopRequireDefault(_summernote);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditController = function () {
	
	  /*@ngInject*/
	  EditController.$inject = ['$http', '$stateParams', '$state', 'toaster', 'Upload'];
	  function EditController($http, $stateParams, $state, toaster, Upload) {
	    (0, _classCallCheck3.default)(this, EditController);
	
	    this.$http = $http;
	    this.$stateParams = $stateParams;
	    this.$state = $state;
	    this.toaster = toaster;
	    this.Upload = Upload;
	    this.summernoteConfig = _summernote2.default;
	    this.availableCountArr = [{
	      value: 0,
	      name: '不限'
	    }, {
	      value: 10,
	      name: '10'
	    }, {
	      value: 20,
	      name: '20'
	    }, {
	      value: 50,
	      name: '50'
	    }, {
	      value: 100,
	      name: '100'
	    }, {
	      value: 200,
	      name: '200'
	    }, {
	      value: 300,
	      name: '300'
	    }, {
	      value: 400,
	      name: '400'
	    }, {
	      value: 500,
	      name: '500'
	    }, {
	      value: 600,
	      name: '600'
	    }, {
	      value: 700,
	      name: '700'
	    }, {
	      value: 800,
	      name: '800'
	    }, {
	      value: 900,
	      name: '900'
	    }, {
	      value: 1000,
	      name: '1000'
	    }, {
	      value: 2000,
	      name: '2000'
	    }, {
	      value: 3000,
	      name: '3000'
	    }, {
	      value: 4000,
	      name: '4000'
	    }, {
	      value: 5000,
	      name: '5000'
	    }, {
	      value: 6000,
	      name: '6000'
	    }];
	  }
	
	  (0, _createClass3.default)(EditController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getFirmware();
	      this.getBetaGroups();
	    }
	  }, {
	    key: 'getFirmware',
	    value: function getFirmware() {
	      var _this = this;
	
	      this.$http.get('/api/firmware/' + this.$stateParams.id).then(function (res) {
	        _this.firmware = res.data;
	        if (_this.isChangeListHtmlUrl(_this.firmware.changeListHtml) && !_this.firmware.changeListHtmlUrl) {
	          _this.firmware.changeListHtmlUrl = _this.firmware.changeListHtml;
	          _this.firmware.changeListHtml = '';
	        }
	        if (!_this.firmware.changeListHtml && !_this.firmware.changeListHtmlUrl && _this.firmware.changeList && _this.firmware.changeList.length) {
	          _this.firmware.changeListHtml = _this.firmware.changeList.join('<br>');
	        }
	      });
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this2 = this;
	
	      if (this.firmware.changeListHtml && !this.isChangeListHtmlUrl(this.firmware.changeListHtml)) {
	        var text = this.firmware.changeListHtml.replace(/<br\s*\/?>/gi, '\n').replace(/<\/p>/gi, '\n').replace(/<[^>]+>/g, '');
	        this.firmware.changeList = text.split('\n').filter(function (line) {
	          return line.trim().length > 0;
	        });
	      }
	      if (!this.checkData()) {
	        return;
	      }
	      if (this.firmware.buildDisplayId) {
	        this.firmware.buildDisplayId = this.firmware.buildDisplayId.trim();
	      }
	      this.$http.put('/api/firmware/' + this.$stateParams.id, this.firmware).then(function (res) {
	        _this2.$state.go('^');
	      });
	    }
	  }, {
	    key: 'getBetaGroups',
	    value: function getBetaGroups() {
	      var _this3 = this;
	
	      this.$http.get('/api/betaGroups').then(function (res) {
	        _this3.betaGroups = res.data;
	      });
	    }
	  }, {
	    key: 'uploadChangeListHtml',
	    value: function uploadChangeListHtml(file) {
	      var _this4 = this;
	
	      if (!file) {
	        return;
	      }
	      this.toaster.pop({
	        type: 'wait',
	        title: '正在上传HTML，请稍等...',
	        body: file.name,
	        timeout: 3000 * 1000
	      });
	
	      file.upload = this.Upload.upload({
	        url: '/api/firmware/uploadChangeListHtml',
	        file: file,
	        data: {
	          downloadUrlList: this.firmware.downloadUrlList
	        },
	        headers: {
	          'Content-Type': 'multipart/form-data'
	        }
	      });
	
	      file.upload.progress(function (evt) {
	        file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
	      });
	
	      file.upload.success(function (data, status, headers, config) {
	        _this4.toaster.clear();
	        _this4.firmware.changeListHtml = '';
	        _this4.firmware.changeListHtmlUrl = data.url;
	        _this4.toaster.pop('success', '上传成功', file.name);
	      });
	
	      file.upload.error(function (err) {
	        _this4.toaster.clear();
	        _this4.toaster.pop('error', '上传失败', (0, _stringify2.default)(err));
	      });
	    }
	  }, {
	    key: 'deleteChangeListHtml',
	    value: function deleteChangeListHtml() {
	      var _this5 = this;
	
	      if (!this.firmware.changeListHtmlUrl) {
	        return;
	      }
	      this.toaster.pop({
	        type: 'wait',
	        title: '正在删除HTML，请稍等...',
	        timeout: 3000 * 1000
	      });
	      this.$http.delete('/api/firmware/' + this.$stateParams.id + '/changeListHtml').then(function (res) {
	        _this5.toaster.clear();
	        _this5.firmware = res.data;
	        _this5.changeListHtmlFile = null;
	        _this5.toaster.pop('success', '删除成功');
	      }).catch(function (err) {
	        _this5.toaster.clear();
	        _this5.toaster.pop('error', '删除失败', (0, _stringify2.default)(err.data || err));
	      });
	    }
	  }, {
	    key: 'toggleSelection',
	    value: function toggleSelection(id) {
	      var idx = this.firmware.betaGroups.indexOf(id);
	
	      if (idx > -1) {
	        this.firmware.betaGroups.splice(idx, 1);
	      } else {
	        this.firmware.betaGroups.push(id);
	      }
	    }
	  }, {
	    key: 'checkStr',
	    value: function checkStr(str) {
	      if (str && typeof str == 'string') {
	        str = str.trim();
	      }
	      return str;
	    }
	  }, {
	    key: 'checkArr',
	    value: function checkArr(arr) {
	      var res = false;
	      if (!arr || !arr.forEach) {
	        return res;
	      }
	      arr.forEach(function (item) {
	        if (item.trim().length > 0) {
	          res = true;
	        }
	      });
	      return res;
	    }
	  }, {
	    key: 'isChangeListHtmlUrl',
	    value: function isChangeListHtmlUrl(html) {
	      return typeof html === 'string' && /^https?:\/\//i.test(html);
	    }
	  }, {
	    key: 'checkData',
	    value: function checkData() {
	      if (this.checkStr(this.firmware.model) && this.checkStr(this.firmware.brand) && this.firmware.buildNumber && this.checkStr(this.firmware.buildType) && this.checkStr(this.firmware.fingerprint) && this.checkStr(this.firmware.lang) && this.checkStr(this.firmware.md5) && this.firmware.size && (this.checkArr(this.firmware.changeList) || this.checkStr(this.firmware.changeListHtml) || this.checkStr(this.firmware.changeListHtmlUrl))) {
	        return true;
	      }
	
	      this.toaster.pop({
	        type: 'error',
	        title: '请填写必填项',
	        timeout: 3 * 1000
	      });
	      return false;
	    }
	  }]);
	  return EditController;
	}();
	
	exports.default = EditController;

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(158), __esModule: true };

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(8);
	var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
	module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
	  return $JSON.stringify.apply($JSON, arguments);
	};


/***/ }),
/* 159 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  toolbar: [['style', ['style']], ['font', ['bold', 'underline', 'clear']], ['fontname', ['fontname']], ['fontsize', ['fontsize']], ['color', ['color']], ['para', ['ul', 'ol', 'paragraph']], ['table', ['table']], ['insert', ['link', 'picture', 'video']], ['view', ['fullscreen', 'codeview', 'help']]],
	  fontSizes: ['10', '12', '14', '16', '18', '20', '24', '28', '32', '36']
	};

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _add = __webpack_require__(161);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.firmwares.add', []).controller('FirmwaresAddController', _add2.default).name;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(157);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _summernote = __webpack_require__(159);
	
	var _summernote2 = _interopRequireDefault(_summernote);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddController = function () {
	
	    /*@ngInject*/
	    AddController.$inject = ['$http', '$state', 'Upload', 'toaster'];
	    function AddController($http, $state, Upload, toaster) {
	        (0, _classCallCheck3.default)(this, AddController);
	
	        this.$http = $http;
	        this.$state = $state;
	        this.Upload = Upload;
	        this.toaster = toaster;
	        this.summernoteConfig = _summernote2.default;
	        this.newFirmware = {
	            betaGroups: []
	        };
	    }
	
	    (0, _createClass3.default)(AddController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.getBetaGroups();
	        }
	    }, {
	        key: 'save',
	        value: function save() {
	            var _this = this;
	
	            if (this.newFirmware.changeListHtml && !this.isChangeListHtmlUrl(this.newFirmware.changeListHtml)) {
	                var text = this.newFirmware.changeListHtml.replace(/<br\s*\/?>/gi, '\n').replace(/<\/p>/gi, '\n').replace(/<[^>]+>/g, '');
	                this.newFirmware.changeList = text.split('\n').filter(function (line) {
	                    return line.trim().length > 0;
	                });
	            }
	            if (!this.checkData()) {
	                return;
	            }
	            this.$http.post('/api/firmware', this.newFirmware).then(function (res) {
	                _this.$state.go('^');
	            });
	        }
	    }, {
	        key: 'getBetaGroups',
	        value: function getBetaGroups() {
	            var _this2 = this;
	
	            this.$http.get('/api/betaGroups').then(function (res) {
	                _this2.betaGroups = res.data;
	            });
	        }
	    }, {
	        key: 'uploadChangeListHtml',
	        value: function uploadChangeListHtml(file) {
	            var _this3 = this;
	
	            if (!file) {
	                return;
	            }
	            this.toaster.pop({
	                type: 'wait',
	                title: '正在上传HTML，请稍等...',
	                body: file.name,
	                timeout: 3000 * 1000
	            });
	
	            file.upload = this.Upload.upload({
	                url: '/api/firmware/uploadChangeListHtml',
	                file: file,
	                data: {
	                    downloadUrlList: this.newFirmware.downloadUrlList
	                },
	                headers: {
	                    'Content-Type': 'multipart/form-data'
	                }
	            });
	
	            file.upload.progress(function (evt) {
	                file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
	            });
	
	            file.upload.success(function (data, status, headers, config) {
	                _this3.toaster.clear();
	                _this3.newFirmware.changeListHtml = '';
	                _this3.newFirmware.changeListHtmlUrl = data.url;
	                _this3.toaster.pop('success', '上传成功', file.name);
	            });
	
	            file.upload.error(function (err) {
	                _this3.toaster.clear();
	                _this3.toaster.pop('error', '上传失败', (0, _stringify2.default)(err));
	            });
	        }
	    }, {
	        key: 'toggleSelection',
	        value: function toggleSelection(id) {
	            var idx = this.newFirmware.betaGroups.indexOf(id);
	
	            if (idx > -1) {
	                this.newFirmware.betaGroups.splice(idx, 1);
	            } else {
	                this.newFirmware.betaGroups.push(id);
	            }
	        }
	    }, {
	        key: 'checkStr',
	        value: function checkStr(str) {
	            if (str && typeof str == 'string') {
	                str = str.trim();
	            }
	            return str;
	        }
	    }, {
	        key: 'checkArr',
	        value: function checkArr(arr) {
	            var res = false;
	            if (!arr || !arr.forEach) {
	                return res;
	            }
	            arr.forEach(function (item) {
	                if (item.trim().length > 0) {
	                    res = true;
	                }
	            });
	            return res;
	        }
	    }, {
	        key: 'isChangeListHtmlUrl',
	        value: function isChangeListHtmlUrl(html) {
	            return typeof html === 'string' && /^https?:\/\//i.test(html);
	        }
	    }, {
	        key: 'checkData',
	        value: function checkData() {
	            if (this.checkStr(this.newFirmware.model) && this.checkStr(this.newFirmware.brand) && this.newFirmware.buildNumber && this.checkStr(this.newFirmware.buildType) && this.checkStr(this.newFirmware.fingerprint) && this.checkStr(this.newFirmware.lang) && this.checkStr(this.newFirmware.md5) && this.newFirmware.size && (this.checkArr(this.newFirmware.changeList) || this.checkStr(this.newFirmware.changeListHtml) || this.checkStr(this.newFirmware.changeListHtmlUrl))) {
	                return true;
	            }
	
	            this.toaster.pop({
	                type: 'error',
	                title: '请填写必填项',
	                timeout: 3 * 1000
	            });
	            return false;
	        }
	    }]);
	    return AddController;
	}();
	
	exports.default = AddController;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _nanoreader = __webpack_require__(163);
	
	var _nanoreader2 = _interopRequireDefault(_nanoreader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.firmwares.nanoreader', []).controller('FirmwaresNanoreaderAddController', _nanoreader2.default).name;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(157);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _summernote = __webpack_require__(159);
	
	var _summernote2 = _interopRequireDefault(_summernote);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NanoreaderAddController = function () {
	
	    /*@ngInject*/
	    NanoreaderAddController.$inject = ['$http', '$state', 'Upload', 'toaster'];
	    function NanoreaderAddController($http, $state, Upload, toaster) {
	        (0, _classCallCheck3.default)(this, NanoreaderAddController);
	
	        this.$http = $http;
	        this.$state = $state;
	        this.Upload = Upload;
	        this.toaster = toaster;
	        this.summernoteConfig = _summernote2.default;
	        this.newFirmware = {
	            betaGroups: [],
	            buildType: 'user',
	            fwType: 'nanoreader',
	            lang: ['zh_CN']
	        };
	    }
	
	    (0, _createClass3.default)(NanoreaderAddController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.getBetaGroups();
	        }
	    }, {
	        key: 'getBetaGroups',
	        value: function getBetaGroups() {
	            var _this = this;
	
	            this.$http.get('/api/betaGroups').then(function (res) {
	                _this.betaGroups = res.data;
	            });
	        }
	    }, {
	        key: 'uploadFirmwareFile',
	        value: function uploadFirmwareFile(file) {
	            var _this2 = this;
	
	            if (!file) {
	                return;
	            }
	            this.toaster.pop({
	                type: 'wait',
	                title: '正在上传固件，请稍等...',
	                body: file.name,
	                timeout: 3000 * 1000
	            });
	
	            file.upload = this.Upload.upload({
	                url: '/api/firmware/uploadFirmwareFile',
	                file: file,
	                headers: {
	                    'Content-Type': 'multipart/form-data'
	                }
	            });
	
	            file.upload.progress(function (evt) {
	                file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
	            });
	
	            file.upload.success(function (data, status, headers, config) {
	                _this2.toaster.clear();
	                _this2.newFirmware.downloadUrlList = [data.url];
	                _this2.newFirmware.md5 = data.md5;
	                _this2.newFirmware.size = data.size;
	                _this2.firmwareUrl = data.url;
	                _this2.toaster.pop('success', '上传成功', file.name);
	            });
	
	            file.upload.error(function (err) {
	                _this2.toaster.clear();
	                _this2.toaster.pop('error', '上传失败', (0, _stringify2.default)(err));
	            });
	        }
	    }, {
	        key: 'toggleSelection',
	        value: function toggleSelection(id) {
	            var idx = this.newFirmware.betaGroups.indexOf(id);
	            if (idx > -1) {
	                this.newFirmware.betaGroups.splice(idx, 1);
	            } else {
	                this.newFirmware.betaGroups.push(id);
	            }
	        }
	    }, {
	        key: 'genFingerprint',
	        value: function genFingerprint() {
	            return 'Onyx/' + this.newFirmware.model + '/' + this.newFirmware.buildNumber + ':' + this.newFirmware.buildType;
	        }
	    }, {
	        key: 'checkStr',
	        value: function checkStr(str) {
	            if (str && typeof str == 'string') {
	                str = str.trim();
	            }
	            return str;
	        }
	    }, {
	        key: 'checkData',
	        value: function checkData() {
	            if (this.checkStr(this.newFirmware.model) && this.newFirmware.buildNumber && this.checkStr(this.newFirmware.buildType) && this.newFirmware.lang && this.newFirmware.lang.length && this.checkStr(this.newFirmware.changeListHtml) && this.newFirmware.md5 && this.newFirmware.size && this.newFirmware.downloadUrlList && this.newFirmware.downloadUrlList.length) {
	                return true;
	            }
	            this.toaster.pop({
	                type: 'error',
	                title: '请填写必填项并上传固件文件',
	                timeout: 3 * 1000
	            });
	            return false;
	        }
	    }, {
	        key: 'save',
	        value: function save() {
	            var _this3 = this;
	
	            if (this.newFirmware.changeListHtml) {
	                var text = this.newFirmware.changeListHtml.replace(/<br\s*\/?>/gi, '\n').replace(/<\/p>/gi, '\n').replace(/<[^>]+>/g, '');
	                this.newFirmware.changeList = text.split('\n').filter(function (line) {
	                    return line.trim().length > 0;
	                });
	            }
	            if (!this.checkData()) {
	                return;
	            }
	            this.newFirmware.brand = 'Onyx';
	            this.newFirmware.fingerprint = this.genFingerprint();
	            this.newFirmware.fwType = 'nanoreader';
	            if (this.newFirmware.buildDisplayId) {
	                this.newFirmware.buildDisplayId = this.newFirmware.buildDisplayId.trim();
	            }
	            this.$http.post('/api/firmware', this.newFirmware).then(function (res) {
	                _this3.$state.go('^');
	            }).catch(function (err) {
	                _this3.toaster.pop('error', '保存失败', err && err.data && err.data.msg || '请稍后重试');
	            });
	        }
	    }]);
	    return NanoreaderAddController;
	}();
	
	exports.default = NanoreaderAddController;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _updated = __webpack_require__(165);
	
	var _updated2 = _interopRequireDefault(_updated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.firmwares.updated', []).controller('FirmwaresUpdatedController', _updated2.default).name;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UpdatedController = function () {
	
	  /*@ngInject*/
	  UpdatedController.$inject = ['$http', '$stateParams', '$state'];
	  function UpdatedController($http, $stateParams, $state) {
	    (0, _classCallCheck3.default)(this, UpdatedController);
	
	    this.$http = $http;
	    this.$stateParams = $stateParams;
	    this.$state = $state;
	
	    this.page = 1;
	    this.params = {
	      offset: this.page - 1,
	      limit: 20,
	      sortBy: 'createdAt',
	      order: -1,
	      type: 1
	    };
	  }
	
	  (0, _createClass3.default)(UpdatedController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      if (this.$stateParams.page) {
	        this.page = this.$stateParams.page;
	      }
	      this.getFirmwares();
	      this.getCount();
	    }
	  }, {
	    key: 'getFirmwares',
	    value: function getFirmwares(type) {
	      var _this = this;
	
	      if (type) {
	        this.params.type = +type || 1;
	      }
	      console.log(this.params);
	      this.params.offset = (this.page - 1) * this.params.limit;
	      this.$http.get('/api/firmware/updated', { params: this.params }).then(function (res) {
	        _this.firmwares = res.data;
	      });
	    }
	  }, {
	    key: 'getCount',
	    value: function getCount() {
	      var _this2 = this;
	
	      this.$http.get('/api/firmware/countFirmwareVersion').then(function (res) {
	        _this2.versions = res.data;
	      });
	    }
	  }, {
	    key: 'pageChanged',
	    value: function pageChanged() {
	      this.$state.go('firmwares.updated', { page: this.page });
	    }
	  }]);
	  return UpdatedController;
	}();
	
	exports.default = UpdatedController;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _count = __webpack_require__(167);
	
	var _count2 = _interopRequireDefault(_count);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.firmwares.updatedCount', []).controller('FirmwaresUpdatedCountController', _count2.default).name;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(168);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UpdatedCountController = function () {
	
	  /*@ngInject*/
	  UpdatedCountController.$inject = ['$http', '$stateParams', '$state'];
	  function UpdatedCountController($http, $stateParams, $state) {
	    (0, _classCallCheck3.default)(this, UpdatedCountController);
	
	    this.$http = $http;
	    this.$stateParams = $stateParams;
	    this.$state = $state;
	  }
	
	  (0, _createClass3.default)(UpdatedCountController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getCount();
	    }
	  }, {
	    key: 'getCount',
	    value: function getCount(type) {
	      var _this = this;
	
	      this.$http.get('/api/firmware/countFirmwareVersion').then(function (res) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = (0, _getIterator3.default)(res.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var item = _step.value;
	
	            if (item._id === 1) {
	              _this.versionsDownload = item;
	            } else if (item._id === 2) {
	              _this.versionsCurrent = item;
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      });
	    }
	  }]);
	  return UpdatedCountController;
	}();
	
	exports.default = UpdatedCountController;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(169), __esModule: true };

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(52);
	__webpack_require__(23);
	module.exports = __webpack_require__(170);


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(13);
	var get = __webpack_require__(117);
	module.exports = __webpack_require__(8).getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lang = __webpack_require__(172);
	
	var _lang2 = _interopRequireDefault(_lang);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.firmwares.lang', []).controller('FirmwaresLangController', _lang2.default).name;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LangController = function () {
	
	  /*@ngInject*/
	  LangController.$inject = ['$http', '$stateParams', '$state'];
	  function LangController($http, $stateParams, $state) {
	    (0, _classCallCheck3.default)(this, LangController);
	
	    this.$http = $http;
	    this.$stateParams = $stateParams;
	    this.$state = $state;
	  }
	
	  (0, _createClass3.default)(LangController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getCount();
	    }
	  }, {
	    key: 'getCount',
	    value: function getCount() {
	      var _this = this;
	
	      this.$http.get('/api/firmware/langStatistics').then(function (res) {
	        _this.data = res.data;
	      });
	    }
	  }]);
	  return LangController;
	}();
	
	exports.default = LangController;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _model = __webpack_require__(174);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.firmwares.model', []).controller('FirmwaresModelController', _model2.default).name;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LangController = function () {
	
	  /*@ngInject*/
	  LangController.$inject = ['$http', '$stateParams', '$state'];
	  function LangController($http, $stateParams, $state) {
	    (0, _classCallCheck3.default)(this, LangController);
	
	    this.$http = $http;
	    this.$stateParams = $stateParams;
	    this.$state = $state;
	  }
	
	  (0, _createClass3.default)(LangController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getCount();
	    }
	  }, {
	    key: 'getCount',
	    value: function getCount() {
	      var _this = this;
	
	      this.$http.get('/api/firmware/modelStatistics').then(function (res) {
	        _this.data = res.data;
	      });
	    }
	  }, {
	    key: 'search',
	    value: function search(model) {
	      var _this2 = this;
	
	      this.$http.get('/api/firmware/modelStatistics?model=' + model).then(function (res) {
	        _this2.data = res.data;
	      });
	    }
	  }]);
	  return LangController;
	}();
	
	exports.default = LangController;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(86);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _betausers = __webpack_require__(176);
	
	var _betausers2 = _interopRequireDefault(_betausers);
	
	var _list = __webpack_require__(181);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _edit = __webpack_require__(183);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _add = __webpack_require__(185);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.betausers', [_angularUiRouter2.default, _list2.default, _edit2.default, _add2.default]).config(_betausers2.default).run(['$rootScope', function ($rootScope) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
	    if (next.name === 'logout' && current && current.name && !current.authenticate) {
	      next.referrer = current.name;
	    }
	  });
	}]).name;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $urlRouterProvider.when("/betausers", "/betausers/list");
	  $stateProvider.state('betausers', {
	    url: '/betausers',
	    template: __webpack_require__(177),
	    authenticate: true
	  }).state('betausers.list', {
	    url: '/list',
	    template: __webpack_require__(178),
	    controller: 'BetaUsersListController',
	    controllerAs: 'betausersListCtrl'
	  }).state('betausers.edit', {
	    url: '/edit/:id',
	    template: __webpack_require__(179),
	    controller: 'BetaUsersEditController',
	    controllerAs: 'betausersEditCtrl'
	  }).state('betausers.add', {
	    url: '/add',
	    template: __webpack_require__(180),
	    controller: 'BetaUsersAddController',
	    controllerAs: 'betausersAddCtrl'
	  });
	}];

/***/ }),
/* 177 */
144,
/* 178 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"page-header\">\n    <button type=\"button\" name=\"button\" class=\"btn btn-success pull-right\" ui-sref=\"betausers.add\">添加</button>\n    <h3>BetaUser</h3>\n  </div>\n  <div class=\"\">\n    <table class=\"table table-striped\">\n      <thead>\n        <tr>\n          <th></th>\n          <th>型号</th>\n          <th>MAC</th>\n          <th>用户</th>\n          <th class=\"ctrl-th\"></th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"user in betausersListCtrl.betausers\">\n          <td>{{$index + 1}}</td>\n          <td>{{user.model}}</td>\n          <td>{{user.mac}}</td>\n          <td>{{user.name}}</td>\n          <td class=\"ctrl-td\">\n            <button ui-sref=\"betausers.edit({id: user._id})\" class=\"btn btn-xs btn-success\">编辑</button>\n            <button ng-click=\"betausersListCtrl.delete(user._id)\" class=\"btn btn-xs btn-danger\">删除</button>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 179 */
/***/ (function(module, exports) {

	module.exports = "\n<div class=\"container\">\n  <div class=\"page-header\">\n    <h1>编辑</h1>\n  </div>\n  <div>\n    <form>\n\n      <div class=\"form-group\">\n        <label for=\"model\">型号</label>\n        <input type=\"model\" class=\"form-control\" ng-model=\"betausersEditCtrl.betauser.model\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"mac\">MAC</label>\n        <input type=\"mac\" class=\"form-control\" ng-model=\"betausersEditCtrl.betauser.mac\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"name\">用户</label>\n        <input type=\"name\" class=\"form-control\" ng-model=\"betausersEditCtrl.betauser.name\">\n      </div>\n\n      <button type=\"submit\" class=\"btn btn-success\" ng-click=\"betausersEditCtrl.save()\">保存</button>\n    </form>\n  </div>\n</div>\n"

/***/ }),
/* 180 */
/***/ (function(module, exports) {

	module.exports = "\n<div class=\"container\">\n  <div class=\"page-header\">\n    <h1>添加</h1>\n  </div>\n  <div>\n    <form>\n\n      <div class=\"form-group\">\n        <label for=\"model\">型号</label>\n        <input type=\"model\" class=\"form-control\" ng-model=\"betausersAddCtrl.newUser.model\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"mac\">MAC</label>\n        <input type=\"mac\" class=\"form-control\" ng-model=\"betausersAddCtrl.newUser.mac\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"name\">用户</label>\n        <input type=\"name\" class=\"form-control\" ng-model=\"betausersAddCtrl.newUser.name\">\n      </div>\n\n      <button type=\"submit\" class=\"btn btn-success\" ng-click=\"betausersAddCtrl.save()\">保存</button>\n    </form>\n  </div>\n</div>\n"

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _list = __webpack_require__(182);
	
	var _list2 = _interopRequireDefault(_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.betausers.list', []).controller('BetaUsersListController', _list2.default).name;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListController = function () {
	
	  /*@ngInject*/
	  ListController.$inject = ['$http'];
	  function ListController($http) {
	    (0, _classCallCheck3.default)(this, ListController);
	
	    this.$http = $http;
	  }
	
	  (0, _createClass3.default)(ListController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getBetaUsers();
	    }
	  }, {
	    key: 'getBetaUsers',
	    value: function getBetaUsers() {
	      var _this = this;
	
	      this.$http.get('/api/betaUsers').then(function (res) {
	        _this.betausers = res.data;
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(id) {
	      var _this2 = this;
	
	      if (confirm("确定？")) {
	        this.$http.delete('/api/betaUsers/' + id).then(function (res) {
	          _this2.getBetaUsers();
	        });
	      }
	    }
	  }]);
	  return ListController;
	}();
	
	exports.default = ListController;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _edit = __webpack_require__(184);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.betausers.edit', []).controller('BetaUsersEditController', _edit2.default).name;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditController = function () {
	
	  /*@ngInject*/
	  EditController.$inject = ['$http', '$state', '$stateParams'];
	  function EditController($http, $state, $stateParams) {
	    (0, _classCallCheck3.default)(this, EditController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	  }
	
	  (0, _createClass3.default)(EditController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getBetaUser();
	    }
	  }, {
	    key: 'getBetaUser',
	    value: function getBetaUser() {
	      var _this = this;
	
	      this.$http.get('/api/betaUsers/' + this.$stateParams.id).then(function (res) {
	        _this.betauser = res.data;
	      });
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this2 = this;
	
	      this.$http.put('/api/betaUsers/' + this.$stateParams.id, this.betauser).then(function (res) {
	        _this2.$state.go('^');
	      });
	    }
	  }]);
	  return EditController;
	}();
	
	exports.default = EditController;

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _add = __webpack_require__(186);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.betausers.add', []).controller('BetaUsersAddController', _add2.default).name;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddController = function () {
	
	  /*@ngInject*/
	  AddController.$inject = ['$http', '$state'];
	  function AddController($http, $state) {
	    (0, _classCallCheck3.default)(this, AddController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.newUser = {};
	  }
	
	  (0, _createClass3.default)(AddController, [{
	    key: 'save',
	    value: function save() {
	      var _this = this;
	
	      this.$http.post('/api/betaUsers', this.newUser).then(function (res) {
	        _this.$state.go('^');
	      });
	    }
	  }]);
	  return AddController;
	}();
	
	exports.default = AddController;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(86);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _apps = __webpack_require__(188);
	
	var _apps2 = _interopRequireDefault(_apps);
	
	var _list = __webpack_require__(194);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _show = __webpack_require__(196);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _add = __webpack_require__(198);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _edit = __webpack_require__(204);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.apps', [_angularUiRouter2.default, _list2.default, _show2.default, _add2.default, _edit2.default]).config(_apps2.default).run(['$rootScope', function ($rootScope) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
	    if (next.name === 'logout' && current && current.name && !current.authenticate) {
	      next.referrer = current.name;
	    }
	  });
	}]).name;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $urlRouterProvider.when("/apps", "/apps/list");
	
	  $stateProvider.state('apps', {
	    url: '/apps',
	    template: __webpack_require__(189),
	    authenticate: true
	  }).state('apps.list', {
	    url: '/list?page',
	    template: __webpack_require__(190),
	    controller: 'AppsListController',
	    controllerAs: 'appsListCtrl',
	    authenticate: true
	  }).state('apps.show', {
	    url: '/show/:id',
	    template: __webpack_require__(191),
	    controller: 'AppsShowController',
	    controllerAs: 'appsShowCtrl',
	    authenticate: true
	  }).state('apps.add', {
	    url: '/add',
	    template: __webpack_require__(192),
	    controller: 'AppsAddController',
	    controllerAs: 'appsAddCtrl',
	    authenticate: true
	  }).state('apps.edit', {
	    url: '/edit/:id',
	    template: __webpack_require__(193),
	    controller: 'AppsEditController',
	    controllerAs: 'appsEditCtrl',
	    authenticate: true
	  });
	}];

/***/ }),
/* 189 */
/***/ (function(module, exports) {

	module.exports = "<div ui-view class=\"appstore\"></div>\n"

/***/ }),
/* 190 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"ctrl-panel\">\n    <a ui-sref=\"apps.add\" class=\"btn btn-primary pull-right\">添加</a>\n    <h3>应用升级</h3>\n  </div>\n\n  <div class=\"\">\n    <table class=\"table table-striped\">\n      <thead>\n        <tr>\n          <th>型号</th>\n          <th>包名</th>\n          <th>类型</th>\n          <th>版本号</th>\n          <th>发布渠道</th>\n          <th>平台</th>\n          <th>日期</th>\n          <th class=\"ctrl-th\"></th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"app in appsListCtrl.apps.list\">\n          <td>{{app.model}}</td>\n          <td>{{app.packageName}}</td>\n          <td>{{app.type}}</td>\n          <td>{{app.versionCode}}</td>\n          <td>{{app.channel}}</td>\n          <td>{{app.platform}}</td>\n          <td>{{app.createdAt | date:'yyyy-MM-dd'}}</td>\n          <td class=\"ctrl-td\">\n            <button ui-sref=\"apps.show({id: app._id})\" class=\"btn btn-xs btn-success\">详细</button>\n            <button ui-sref=\"apps.edit({id: app._id})\" class=\"btn btn-xs btn-primary\">编辑</button>\n            <button ng-click=\"appsListCtrl.deleteApp(app._id)\" class=\"btn btn-xs btn-danger\">删除</button>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n\n    <div class=\"pagination-div\" ng-show=\"appsListCtrl.apps.count > 0\">\n      <ul uib-pagination data-ng-if=\"appsListCtrl.apps.count\" total-items=\"appsListCtrl.apps.count\"\n        ng-model=\"appsListCtrl.page\" max-size=\"5\" class=\"\" boundary-link-numbers=\"true\" rotate=\"false\"\n        ng-change=\"appsListCtrl.pageChanged()\" items-per-page=\"appsListCtrl.params.limit\" previous-text=\"上一页\"\n        next-text=\"下一页\"></ul>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 191 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"page-header\">\n    <a ui-sref=\"apps.edit({id: appsShowCtrl.app._id})\" class=\"btn btn-primary pull-right\">编辑</a>\n    <h3>APP</h3>\n  </div>\n\n  <div class=\"\">\n    <table class=\"table table-condensed\">\n      <thead>\n        <tr>\n          <th>属性</th>\n          <th>值</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr>\n          <td>包名</td>\n          <td>{{appsShowCtrl.app.packageName}}</td>\n        </tr>\n        <tr>\n          <td>类型</td>\n          <td>{{appsShowCtrl.app.type}}</td>\n        </tr>\n        <tr>\n          <td>App发布渠道</td>\n          <td>{{appsShowCtrl.app.channel}}</td>\n        </tr>\n        <tr>\n          <td>版本号</td>\n          <td>{{appsShowCtrl.app.versionCode}}</td>\n        </tr>\n        <tr>\n          <td>平台</td>\n          <td>{{appsShowCtrl.app.platform}}</td>\n        </tr>\n        <tr>\n          <td>版本名称</td>\n          <td>{{appsShowCtrl.app.versionName}}</td>\n        </tr>\n        <tr>\n          <td>型号</td>\n          <td>{{appsShowCtrl.app.model}}</td>\n        </tr>\n        <tr>\n          <td>MAC</td>\n          <td>{{appsShowCtrl.app.deviceMAC.toString()}}</td>\n        </tr>\n        <tr>\n          <td>大小</td>\n          <td>{{appsShowCtrl.app.size}}</td>\n        </tr>\n        <tr>\n          <td>MD5</td>\n          <td>{{appsShowCtrl.app.md5}}</td>\n        </tr>\n        <tr>\n          <td>下载地址列表</td>\n          <td>{{appsShowCtrl.app.downloadUrlList.toString()}}</td>\n        </tr>\n        <tr>\n          <td>changeLogs</td>\n          <td>{{appsShowCtrl.app.changeLogs}}</td>\n        </tr>\n        <tr>\n          <td>创建日期</td>\n          <td>{{appsShowCtrl.app.createdAt | date:'yyyy-MM-dd'}}</td>\n        </tr>\n        <tr>\n          <td>更新日期</td>\n          <td>{{appsShowCtrl.app.updateAt | date:'yyyy-MM-dd'}}</td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 192 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <form>\n    <label>添加更新数据</label>\n    <div class=\"form-group\">\n      <label for=\"file\" class=\"text-danger\">文件 <span>(必需)</span></label>\n      <input type=\"file\" ngf-select ng-model=\"appsAddCtrl.file\" name=\"file\" required ngf-model-invalid=\"errorFile\" class=\"form-control\">\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"packageName\">App包名 <span class=\"text-danger\">(必需)</span></label>\n      <input type=\"packageName\" class=\"form-control\" ng-model=\"appsAddCtrl.newApp.packageName\" required>\n    </div>\n    <div class=\"form-group\">\n      <label for=\"type\">App类型，如release, debug 等 <span class=\"text-danger\">(必需)</span></label>\n      <input type=\"type\" class=\"form-control\" ng-model=\"appsAddCtrl.newApp.type\" required>\n    </div>\n    <div class=\"form-group\">\n      <label for=\"channel\">App发布渠道 <span class=\"text-danger\">(必需)</span></label>\n      <input type=\"channel\" class=\"form-control\" ng-model=\"appsAddCtrl.newApp.channel\" required>\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"versionCode\">App版本号 <span class=\"text-danger\">(必需)</span></label>\n      <input type=\"number\" class=\"form-control\" ng-model=\"appsAddCtrl.newApp.versionCode\" required>\n    </div>\n    <div class=\"form-group\">\n      <label for=\"platform\">平台 <span class=\"text-danger\">(必需)</span></label>\n      <input type=\"text\" class=\"form-control\" ng-model=\"appsAddCtrl.newApp.platform\" required>\n    </div>\n    <div class=\"form-group\">\n      <label for=\"versionName\">App版本名称</label>\n      <input type=\"versionName\" class=\"form-control\" ng-model=\"appsAddCtrl.newApp.versionName\">\n    </div>\n    <div class=\"form-group\">\n      <label for=\"model\">设备型号(注：对单个设备发布App时使用)</label>\n      <input type=\"model\" class=\"form-control\" ng-model=\"appsAddCtrl.newApp.model\">\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"changeLogs\">App包更新内容（zh_CN）</label>\n      <textarea type=\"changeLogs\" class=\"form-control\" ng-model=\"appsAddCtrl.newApp.changeLogs.zh_CN\" ng-list=\"&#10;\" ng-trim=\"false\" rows=\"5\"></textarea>\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"changeLogs\">App包更新内容（en_US）</label>\n      <textarea type=\"changeLogs\" class=\"form-control\" ng-model=\"appsAddCtrl.newApp.changeLogs.en_US\" ng-list=\"&#10;\" ng-trim=\"false\" rows=\"5\"></textarea>\n    </div>\n\n\n    <div class=\"form-group\">\n      <label for=\"deviceMAC\">目标设备MAC  <span class=\"text-danger\">（每行一个MAC）</span></label>\n      <textarea type=\"deviceMAC\" class=\"form-control\" ng-model=\"appsAddCtrl.newApp.deviceMAC\" rows=\"5\" ng-list=\"&#10;\" ng-trim=\"false\"></textarea>\n    </div>\n\n    <div class=\"form-group\">\n      <input type=\"checkbox\" name=\"form-control\" ng-model=\"appsAddCtrl.newApp.excludeGroups\"><span>排除组</span>\n    </div>\n\n    <div class=\"clearfix\">\n      <label for=\"\">测试组</label>\n      <ul class=\"betagroup-list\">\n        <li ng-repeat=\"group in appsAddCtrl.betaGroups\" class=\"\">\n          <input type=\"checkbox\" name=\"betaGroups[]\" value=\"{{group._id}}\" ng-checked=\"appsAddCtrl.newApp.betaGroups.indexOf(group._id) > -1\"\n            ng-click=\"appsAddCtrl.toggleSelection(group._id)\">\n          <span>{{group.name}}</span>\n        </li>\n      </ul>\n    </div>\n\n    <button type=\"submit\" class=\"btn btn-success\" ng-click=\"appsAddCtrl.update()\">保存</button>\n  </form>\n</div>\n"

/***/ }),
/* 193 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <form>\n    <label>更新数据</label>\n\n    <div class=\"form-group\">\n      <label for=\"packageName\">App包名 <span class=\"text-danger\">(必需)</span></label>\n      <input type=\"packageName\" class=\"form-control\" ng-model=\"appsEditCtrl.app.packageName\" required>\n    </div>\n    <div class=\"form-group\">\n      <label for=\"type\">App类型，如release, debug 等 <span class=\"text-danger\">(必需)</span></label>\n      <input type=\"type\" class=\"form-control\" ng-model=\"appsEditCtrl.app.type\" required>\n    </div>\n    <div class=\"form-group\">\n      <label for=\"channel\">App发布渠道 <span class=\"text-danger\">(必需)</span></label>\n      <input type=\"channel\" class=\"form-control\" ng-model=\"appsEditCtrl.app.channel\" required>\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"versionCode\">App版本号 <span class=\"text-danger\">(必需)</span></label>\n      <input type=\"number\" class=\"form-control\" ng-model=\"appsEditCtrl.app.versionCode\" required>\n    </div>\n    <div class=\"form-group\">\n      <label for=\"platform\">平台 <span class=\"text-danger\">(必需)</span></label>\n      <input type=\"text\" class=\"form-control\" ng-model=\"appsEditCtrl.app.platform\" required>\n    </div>\n    <div class=\"form-group\">\n      <label for=\"versionName\">App版本名称</label>\n      <input type=\"versionName\" class=\"form-control\" ng-model=\"appsEditCtrl.app.versionName\">\n    </div>\n    <div class=\"form-group\">\n      <label for=\"model\">设备型号(注：对单个设备发布App时使用)</label>\n      <input type=\"model\" class=\"form-control\" ng-model=\"appsEditCtrl.app.model\">\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"changeLogs\">App包更新内容（zh_CN）</label>\n      <textarea type=\"changeLogs\" class=\"form-control\" ng-model=\"appsEditCtrl.app.changeLogs.zh_CN\" ng-list=\"&#10;\" ng-trim=\"false\" rows=\"5\"></textarea>\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"changeLogs\">App包更新内容（en_US）</label>\n      <textarea type=\"changeLogs\" class=\"form-control\" ng-model=\"appsEditCtrl.app.changeLogs.en_US\" ng-list=\"&#10;\" ng-trim=\"false\" rows=\"5\"></textarea>\n    </div>\n\n\n    <div class=\"form-group\">\n      <label for=\"deviceMAC\">目标设备MAC  <span class=\"text-danger\">（每行一个MAC）</span></label>\n      <textarea type=\"deviceMAC\" class=\"form-control\" ng-model=\"appsEditCtrl.app.deviceMAC\" rows=\"5\" ng-list=\"&#10;\" ng-trim=\"false\"></textarea>\n    </div>\n\n    <div class=\"form-group\">\n      <input type=\"checkbox\" name=\"form-control\" ng-model=\"appsEditCtrl.app.excludeGroups\"><span>排除组</span>\n    </div>\n\n    <div class=\"clearfix\">\n      <label for=\"\">测试组</label>\n      <ul class=\"betagroup-list\">\n        <li ng-repeat=\"group in appsEditCtrl.betaGroups\" class=\"\">\n          <input type=\"checkbox\" name=\"betaGroups[]\" value=\"{{group._id}}\" ng-checked=\"appsEditCtrl.app.betaGroups.indexOf(group._id) > -1\"\n            ng-click=\"appsEditCtrl.toggleSelection(group._id)\">\n          <span>{{group.name}}</span>\n        </li>\n      </ul>\n    </div>\n\n    <button type=\"submit\" class=\"btn btn-success\" ng-click=\"appsEditCtrl.update()\">保存</button>\n  </form>\n</div>\n"

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _list = __webpack_require__(195);
	
	var _list2 = _interopRequireDefault(_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.apps.list', []).controller('AppsListController', _list2.default).name;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListController = function () {
	
	  /*@ngInject*/
	  ListController.$inject = ['$http', '$state', '$stateParams'];
	  function ListController($http, $state, $stateParams) {
	    (0, _classCallCheck3.default)(this, ListController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	
	    this.page = 1;
	    this.params = {
	      offset: this.page - 1,
	      limit: 20,
	      sortBy: 'createdAt',
	      order: -1
	    };
	  }
	
	  (0, _createClass3.default)(ListController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      if (this.$stateParams.page) {
	        this.page = this.$stateParams.page;
	      }
	      this.getApps();
	    }
	  }, {
	    key: 'getApps',
	    value: function getApps() {
	      var _this = this;
	
	      this.params.offset = (this.page - 1) * this.params.limit;
	      this.$http.get('/api/apps', { params: this.params }).then(function (response) {
	        _this.apps = response.data;
	      });
	    }
	  }, {
	    key: 'deleteApp',
	    value: function deleteApp(id) {
	      var _this2 = this;
	
	      if (confirm("确定？")) {
	        this.$http.delete('api/apps/' + id).then(function (response) {
	          _this2.getApps();
	        });
	      }
	    }
	  }, {
	    key: 'pageChanged',
	    value: function pageChanged() {
	      this.$state.go('apps.list', { page: this.page });
	    }
	  }]);
	  return ListController;
	}();
	
	exports.default = ListController;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _show = __webpack_require__(197);
	
	var _show2 = _interopRequireDefault(_show);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.apps.show', []).controller('AppsShowController', _show2.default).name;

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ShowController = function () {
	
	  /*@ngInject*/
	  ShowController.$inject = ['$http', '$stateParams'];
	  function ShowController($http, $stateParams) {
	    (0, _classCallCheck3.default)(this, ShowController);
	
	    this.$http = $http;
	    this.$stateParams = $stateParams;
	  }
	
	  (0, _createClass3.default)(ShowController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getApp(this.$stateParams.id);
	    }
	  }, {
	    key: 'getApp',
	    value: function getApp(id) {
	      var _this = this;
	
	      this.$http.get('/api/apps/' + id).then(function (response) {
	        _this.app = response.data;
	      });
	    }
	  }, {
	    key: 'deleteApp',
	    value: function deleteApp(app) {
	      var _this2 = this;
	
	      if (confirm("确定？")) {
	        this.$http.delete('api/apps/' + app._id).then(function (response) {
	          _this2.getApp();
	        });
	      }
	    }
	  }]);
	  return ShowController;
	}();
	
	exports.default = ShowController;

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _add = __webpack_require__(199);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.apps.add', []).controller('AppsAddController', _add2.default).name;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(157);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(200);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddController = function () {
	
	  /*@ngInject*/
	  AddController.$inject = ['$http', '$state', '$scope', 'Upload', 'toaster'];
	  function AddController($http, $state, $scope, Upload, toaster) {
	    (0, _classCallCheck3.default)(this, AddController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$scope = $scope;
	    this.Upload = Upload;
	    this.toaster = toaster;
	
	    this.newApp = {
	      platform: 'onyx',
	      channel: 'onyx',
	      type: 'release',
	      betaGroups: []
	    };
	  }
	
	  (0, _createClass3.default)(AddController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.$scope.$watch('appsAddCtrl.file', function (file) {
	        if (file !== undefined && file !== null) {
	          _this.uploadApk(file);
	        }
	      });
	
	      this.getBetaGroups();
	    }
	  }, {
	    key: 'uploadApk',
	    value: function uploadApk(file) {
	      var _this2 = this;
	
	      this.toaster.pop({
	        type: 'wait',
	        title: '正在上传APK，请稍等...',
	        body: file.name,
	        timeout: 3000 * 1000
	      });
	
	      file.upload = this.Upload.upload({
	        url: '/api/apps/uploadFile',
	        file: file,
	        headers: {
	          'Content-Type': 'multipart/form-data'
	        }
	      });
	
	      file.upload.progress(function (evt) {
	        file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
	      });
	
	      file.upload.success(function (data, status, headers, config) {
	        _this2.toaster.clear();
	        _this2.newApp = (0, _assign2.default)(_this2.newApp, data);
	        _this2.toaster.pop('success', '上传成功', file.name);
	      });
	
	      file.upload.error(function (err) {
	        _this2.toaster.clear();
	        _this2.toaster.pop('error', '上传失败', (0, _stringify2.default)(err));
	      });
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var _this3 = this;
	
	      if (!this.newApp._id) {
	        return;
	      }
	      this.newApp.type = this.newApp.type.toLowerCase();
	      this.newApp.channel = this.newApp.channel.toLowerCase();
	      this.newApp.platform = this.newApp.platform.toLowerCase();
	      this.newApp.deviceMAC = this.newApp.deviceMAC.map(function (mac) {
	        return mac.toLowerCase();
	      });
	
	      if (!this.checkData()) {
	        return;
	      }
	      this.$http.put('/api/apps/' + this.newApp._id, this.newApp).then(function (res) {
	        _this3.$state.go('apps');
	      });
	    }
	  }, {
	    key: 'getBetaGroups',
	    value: function getBetaGroups() {
	      var _this4 = this;
	
	      this.$http.get('/api/betaGroups').then(function (res) {
	        _this4.betaGroups = res.data;
	      });
	    }
	  }, {
	    key: 'toggleSelection',
	    value: function toggleSelection(id) {
	      var idx = this.newApp.betaGroups.indexOf(id);
	
	      if (idx > -1) {
	        this.newApp.betaGroups.splice(idx, 1);
	      } else {
	        this.newApp.betaGroups.push(id);
	      }
	    }
	  }, {
	    key: 'checkStr',
	    value: function checkStr(str) {
	      if (str) {
	        str = str.trim();
	      }
	      return str;
	    }
	  }, {
	    key: 'checkArr',
	    value: function checkArr(arr) {
	      var res = false;
	      arr.forEach(function (item) {
	        if (item.trim().length > 0) {
	          res = true;
	        }
	      });
	      return res;
	    }
	  }, {
	    key: 'checkData',
	    value: function checkData() {
	      if (this.checkStr(this.newApp.packageName) && this.checkStr(this.newApp.type) && this.checkStr(this.newApp.channel) && this.newApp.versionCode && this.checkStr(this.newApp.platform) && this.checkArr(this.newApp.changeLogs.zh_CN)) {
	        return true;
	      }
	
	      this.toaster.pop({
	        type: 'error',
	        title: '请填写必填项',
	        timeout: 3 * 1000
	      });
	      return false;
	    }
	  }]);
	  return AddController;
	}();
	
	exports.default = AddController;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(201), __esModule: true };

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(202);
	module.exports = __webpack_require__(8).Object.assign;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(6);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(203) });


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(35);
	var gOPS = __webpack_require__(63);
	var pIE = __webpack_require__(64);
	var toObject = __webpack_require__(51);
	var IObject = __webpack_require__(38);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(17)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _edit = __webpack_require__(205);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.apps.edit', []).controller('AppsEditController', _edit2.default).name;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconController = function () {
	
	  /*@ngInject*/
	  IconController.$inject = ['$http', '$state', '$stateParams', 'toaster'];
	  function IconController($http, $state, $stateParams, toaster) {
	    (0, _classCallCheck3.default)(this, IconController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.toaster = toaster;
	  }
	
	  (0, _createClass3.default)(IconController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getApp();
	      this.getBetaGroups();
	    }
	  }, {
	    key: 'getApp',
	    value: function getApp() {
	      var _this = this;
	
	      this.$http.get('/api/apps/' + this.$stateParams.id).then(function (response) {
	        _this.app = response.data;
	      });
	    }
	  }, {
	    key: 'checkStr',
	    value: function checkStr(str) {
	      if (str) {
	        str = str.trim();
	      }
	      return str;
	    }
	  }, {
	    key: 'checkArr',
	    value: function checkArr(arr) {
	      var res = false;
	      arr.forEach(function (item) {
	        if (item.trim().length > 0) {
	          res = true;
	        }
	      });
	      return res;
	    }
	  }, {
	    key: 'checkData',
	    value: function checkData() {
	      if (this.checkStr(this.app.packageName) && this.checkStr(this.app.type) && this.checkStr(this.app.channel) && this.app.versionCode && this.checkStr(this.app.platform) && this.checkArr(this.app.changeLogs.zh_CN)) {
	        return true;
	      }
	
	      this.toaster.pop({
	        type: 'error',
	        title: '请填写必填项',
	        timeout: 3 * 1000
	      });
	      return false;
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var _this2 = this;
	
	      this.app.type = this.app.type.toLowerCase();
	      this.app.channel = this.app.channel.toLowerCase();
	      this.app.platform = this.app.platform.toLowerCase();
	      this.app.deviceMAC = this.app.deviceMAC.map(function (mac) {
	        return mac.toLowerCase();
	      });
	      if (!this.checkData()) {
	        return;
	      }
	      this.$http.put('api/apps/' + this.app._id, this.app).then(function (response) {
	        _this2.$state.go('apps');
	      });
	    }
	  }, {
	    key: 'getBetaGroups',
	    value: function getBetaGroups() {
	      var _this3 = this;
	
	      this.$http.get('/api/betaGroups').then(function (res) {
	        _this3.betaGroups = res.data;
	      });
	    }
	  }, {
	    key: 'toggleSelection',
	    value: function toggleSelection(id) {
	      var idx = this.app.betaGroups.indexOf(id);
	
	      if (idx > -1) {
	        this.app.betaGroups.splice(idx, 1);
	      } else {
	        this.app.betaGroups.push(id);
	      }
	    }
	  }]);
	  return IconController;
	}();
	
	exports.default = IconController;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(86);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _jdOrder = __webpack_require__(207);
	
	var _jdOrder2 = _interopRequireDefault(_jdOrder);
	
	var _list = __webpack_require__(211);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _show = __webpack_require__(213);
	
	var _show2 = _interopRequireDefault(_show);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('onyxReadingRoomApp.jdOrder', [_angularUiRouter2.default, _list2.default, _show2.default]).config(_jdOrder2.default).run(['$rootScope', function ($rootScope) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
	    if (next.name === 'logout' && current && current.name && !current.authenticate) {
	      next.referrer = current.name;
	    }
	  });
	}]).name;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $urlRouterProvider.when("/jdOrder", "/jdOrder/list");
	
	  $stateProvider.state('jdOrder', {
	    url: '/jdOrder',
	    template: __webpack_require__(208),
	    authenticate: true
	  }).state('jdOrder.list', {
	    url: '/list?page',
	    template: __webpack_require__(209),
	    controller: 'JdOrderListController',
	    controllerAs: 'jdOrderListCtrl',
	    authenticate: true
	  }).state('jdOrder.show', {
	    url: '/show/:id',
	    template: __webpack_require__(210),
	    controller: 'JdOrderShowController',
	    controllerAs: 'jdOrderShowCtrl',
	    authenticate: true
	  });
	}];

/***/ }),
/* 208 */
189,
/* 209 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"\" style=\"margin: 20px 30px\">\n  <div class=\"ctrl-panel\">\n    <h3>京东用户订单信息</h3>\n  </div>\n\n  <div class=\"panel panel-default table-responsive\" style=\"margin: 15px;\">\n      <div class=\"panel-heading\">\n        订单查询\n        <span class=\"label label-info pull-right\" id=\"recordTotal\">{{jdOrderListCtrl.jdOrder.count}}</span>\n      </div>\n      <div class=\"panel-body\">\n        <div class=\"row\">\n          <div class=\"col-md-12 col-sm-12\">\n            <div class=\"form-inline no-margin\">\n              <div class=\"form-group\" style=\"margin: 5px;\">\n                用户pin\n                <input type=\"text\" style=\"width: 130px;\" class=\"form-control input-sm\" ng-model=\"jdOrderListCtrl.jdUserPin\">\n              </div>\n              <div class=\"form-group\" style=\"margin: 5px;\">\n                mac地址\n                <input type=\"text\" style=\"width: 130px;\" class=\"form-control input-sm\" ng-model=\"jdOrderListCtrl.mac\">\n              </div>\n              <div class=\"form-group\" style=\"margin: 5px;\">\n                订单号\n                <input type=\"text\" style=\"width: 130px;\" class=\"form-control input-sm\" ng-model=\"jdOrderListCtrl.orderId\">\n              </div>\n              <div class=\"form-group\" style=\"margin: 5px;\">\n                小说书号\n                <input type=\"text\" style=\"width: 130px;\" class=\"form-control input-sm\" ng-model=\"jdOrderListCtrl.novelBookId\">\n              </div>\n              <button type=\"submit\" class=\"btn btn-success\" ng-click=\"jdOrderListCtrl.getApps()\">查询</button>\n            </div>\n          </div>\n        </div><!-- /.row -->\n  </div><!-- /panel -->\n\n  <div class=\"\">\n    <table class=\"table table-striped\">\n      <thead>\n        <tr>\n          <th>用户pin</th>\n          <th>设备型号</th>\n          <th>系统版本</th>\n          <th>mac地址</th>\n          <th>订单号</th>\n          <th>订单类型</th>\n          <th>支付类型</th>\n          <th>书号列表</th>\n          <th>章节号列表</th>\n          <th>小说书号</th>\n          <th>vip号</th>\n          <th>des</th>\n          <th>总共支付</th>\n          <th>现金</th>\n          <th>阅豆</th>\n          <th>京豆</th>\n          <th>抵用券</th>\n          <th>支付日期</th>\n          <th class=\"ctrl-th\"></th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"app in jdOrderListCtrl.jdOrder.list\">\n          <td>{{app.jdUserPin}}</td>\n          <td>{{app.deviceModel}}</td>\n          <td>{{app.osVersion}}</td>\n          <td>{{app.mac}}</td>\n          <td>{{app.orderId}}</td>\n          <td>{{app.orderType}}</td>\n          <td>{{app.payType}}</td>\n          <td>{{app.publicationBookIdList}}</td>\n          <td>{{app.chapterIdList}}</td>\n          <td>{{app.novelBookId}}</td>\n          <td>{{app.vipKkuId}}</td>\n          <td>{{app.des}}</td>\n          <td>{{app.totalPayAmount}}</td>\n          <td>{{app.crash}}</td>\n          <td>{{app.yuedou}}</td>\n          <td>{{app.voucher}}</td>\n          <td>{{app.jingdou}}</td>\n          <td>{{app.createdAt | date:'yyyy-MM-dd'}}</td>\n          <td class=\"ctrl-td\">\n            <button ui-sref=\"jdOrder.show({id: app._id})\" class=\"btn btn-xs btn-success\">详细</button>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n  <div class=\"pagination-div\" ng-show=\"jdOrderListCtrl.jdOrder.count > 0\" style=\"margin-left: 20px\">\n    <ul uib-pagination data-ng-if=\"jdOrderListCtrl.jdOrder.count\" total-items=\"jdOrderListCtrl.jdOrder.count\" ng-model=\"jdOrderListCtrl.page\" max-size=\"5\" items-per-page=\"jdOrderListCtrl.pageCount\" class=\"\" boundary-link-numbers=\"true\" rotate=\"false\" ng-change=\"jdOrderListCtrl.pageChanged()\" previous-text=\"上一页\" next-text=\"下一页\"></ul>\n  </div>\n</div>\n"

/***/ }),
/* 210 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"page-header\">\n    <h3>京东用户订单信息</h3>\n  </div>\n\n  <div class=\"\">\n    <table class=\"table table-condensed\">\n      <thead>\n        <tr>\n          <th>属性</th>\n          <th>值</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr>\n          <td>用户pin</td>\n          <td>{{jdOrderShowCtrl.jdOrder.jdUserPin}}</td>\n        </tr>\n        <tr>\n          <td>设备型号</td>\n          <td>{{jdOrderShowCtrl.jdOrder.deviceModel}}</td>\n        </tr>\n        <tr>\n          <td>系统版本</td>\n          <td>{{jdOrderShowCtrl.jdOrder.osVersion}}</td>\n        </tr>\n        <tr>\n          <td>mac地址</td>\n          <td>{{jdOrderShowCtrl.jdOrder.mac}}</td>\n        </tr>\n        <tr>\n          <td>订单号</td>\n          <td>{{jdOrderShowCtrl.jdOrder.orderId}}</td>\n        </tr>\n        <tr>\n          <td>订单类型</td>\n          <td>{{jdOrderShowCtrl.jdOrder.orderType}}</td>\n        </tr>\n        <tr>\n          <td>支付类型</td>\n          <td>{{jdOrderShowCtrl.jdOrder.payType}}</td>\n        </tr>\n        <tr>\n          <td>书号列表</td>\n          <td>{{jdOrderShowCtrl.jdOrder.publicationBookIdList.toString()}}</td>\n        </tr>\n        <tr>\n          <td>章节号列表</td>\n          <td>{{jdOrderShowCtrl.jdOrder.chapterIdList.toString()}}</td>\n        </tr>\n        <tr>\n          <td>小说书号</td>\n          <td>{{jdOrderShowCtrl.jdOrder.novelBookId}}</td>\n        </tr>\n        <tr>\n          <td>vip号</td>\n          <td>{{jdOrderShowCtrl.jdOrder.vipKkuId}}</td>\n        </tr>\n        <tr>\n          <td>des</td>\n          <td>{{jdOrderShowCtrl.jdOrder.des}}</td>\n        </tr>\n        <tr>\n          <td>总共支付</td>\n          <td>{{jdOrderShowCtrl.jdOrder.totalPayAmount}}</td>\n        </tr>\n        <tr>\n          <td>现金</td>\n          <td>{{jdOrderShowCtrl.jdOrder.crash}}</td>\n        </tr>\n        <tr>\n          <td>阅豆</td>\n          <td>{{jdOrderShowCtrl.jdOrder.yuedou}}</td>\n        </tr>\n        <tr>\n          <td>京豆</td>\n          <td>{{jdOrderShowCtrl.jdOrder.jingdou}}</td>\n        </tr>\n        <tr>\n          <td>抵用券</td>\n          <td>{{jdOrderShowCtrl.jdOrder.voucher}}</td>\n        </tr>\n        <tr>\n          <td>支付日期</td>\n          <td>{{jdOrderShowCtrl.jdOrder.createdAt | date:'yyyy-MM-dd'}}</td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _list = __webpack_require__(212);
	
	var _list2 = _interopRequireDefault(_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('onyxReadingRoomApp.jdOrder.list', []).controller('JdOrderListController', _list2.default).name;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListController = function () {
	
	  /*@ngInject*/
	  ListController.$inject = ['$http', '$stateParams', '$state'];
	  function ListController($http, $stateParams, $state) {
	    (0, _classCallCheck3.default)(this, ListController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.pageCount = 10;
	    this.jdUserPin;
	    this.mac;
	    this.orderId;
	    this.novelBookId;
	  }
	
	  (0, _createClass3.default)(ListController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.page = this.$stateParams.page || 1;
	      this.getApps();
	    }
	  }, {
	    key: 'getApps',
	    value: function getApps() {
	      var _this = this;
	
	      var params = {
	        where: {
	          offset: (this.page - 1) * this.pageCount,
	          limit: this.pageCount,
	          sortBy: 'createdAt',
	          sortOrder: false,
	          jdUserPin: this.jdUserPin,
	          mac: this.mac,
	          orderId: this.orderId,
	          novelBookId: this.novelBookId
	        }
	      };
	      this.$http.get('/api/jdOrders', { params: params }).then(function (response) {
	        _this.jdOrder = response.data;
	      });
	    }
	  }, {
	    key: 'pageChanged',
	    value: function pageChanged() {
	      console.log(this.page);
	      this.$state.go('jdOrder.list', { page: this.page });
	    }
	  }]);
	  return ListController;
	}();
	
	exports.default = ListController;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _show = __webpack_require__(214);
	
	var _show2 = _interopRequireDefault(_show);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('onyxReadingRoomApp.jdOrder.show', []).controller('JdOrderShowController', _show2.default).name;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ShowController = function () {
	
	  /*@ngInject*/
	  ShowController.$inject = ['$http', '$stateParams'];
	  function ShowController($http, $stateParams) {
	    (0, _classCallCheck3.default)(this, ShowController);
	
	    this.$http = $http;
	    this.$stateParams = $stateParams;
	  }
	
	  (0, _createClass3.default)(ShowController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getApp(this.$stateParams.id);
	    }
	  }, {
	    key: 'getApp',
	    value: function getApp(id) {
	      var _this = this;
	
	      this.$http.get('/api/jdOrders/' + id).then(function (response) {
	        _this.jdOrder = response.data;
	        console.log(_this.jdOrder);
	      });
	    }
	  }]);
	  return ShowController;
	}();
	
	exports.default = ShowController;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(86);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _appstore = __webpack_require__(216);
	
	var _appstore2 = _interopRequireDefault(_appstore);
	
	var _list = __webpack_require__(224);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _show = __webpack_require__(226);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _add = __webpack_require__(228);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _edit = __webpack_require__(230);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _addConf = __webpack_require__(232);
	
	var _addConf2 = _interopRequireDefault(_addConf);
	
	var _editConf = __webpack_require__(234);
	
	var _editConf2 = _interopRequireDefault(_editConf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.appstore', [_angularUiRouter2.default, _list2.default, _show2.default, _edit2.default, _addConf2.default, _editConf2.default, _add2.default]).config(_appstore2.default).run(['$rootScope', function ($rootScope) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
	    if (next.name === 'logout' && current && current.name && !current.authenticate) {
	      next.referrer = current.name;
	    }
	  });
	}]).name;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $urlRouterProvider.when("/appstore", "/appstore/list");
	
	  $stateProvider.state('appstore', {
	    url: '/appstore',
	    template: __webpack_require__(217),
	    authenticate: true
	  }).state('appstore.list', {
	    url: '/list',
	    template: __webpack_require__(218),
	    controller: 'AppStoreListController',
	    controllerAs: 'asListCtrl'
	  }).state('appstore.show', {
	    url: '/show/:id',
	    template: __webpack_require__(219),
	    controller: 'AppStoreShowController',
	    controllerAs: 'asShowCtrl'
	  }).state('appstore.add', {
	    url: '/add',
	    template: __webpack_require__(220),
	    controller: 'AppStoreAddController',
	    controllerAs: 'asAddCtrl'
	  }).state('appstore.edit', {
	    url: '/edit/:id',
	    template: __webpack_require__(221),
	    controller: 'AppStoreEditController',
	    controllerAs: 'asEditCtrl'
	  }).state('appstore.addconf', {
	    url: '/addconf/:id',
	    template: __webpack_require__(222),
	    controller: 'AppStoreAddConfController',
	    controllerAs: 'asAddConfCtrl'
	  }).state('appstore.editconf', {
	    url: '/editconf/:id',
	    template: __webpack_require__(223),
	    controller: 'AppStoreEditConfController',
	    controllerAs: 'asEditConfCtrl'
	  });
	}];

/***/ }),
/* 217 */
189,
/* 218 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"ctrl-panel\">\n    <a ui-sref=\"appstore.add\" class=\"btn btn-primary pull-right\">添加</a>\n    <div class=\"form-group col-md-2 pull-right\">\n      <select class=\"form-control\" ng-model=\"asListCtrl.category\">\n        <option ng-repeat=\"c in asListCtrl.categories\" value=\"{{c.value}}\">{{c.name}}</option>\n      </select>\n    </div>\n    <h3>应用商城</h3>\n  </div>\n  <div class=\"row\">\n  <div class=\"col-sm-6 col-md-4\" ng-repeat=\"app in asListCtrl.apps.list\">\n    <div class=\"thumbnail\">\n      <div class=\"pull-left\">\n        <img src=\"{{app.coverUrl | appIconCheck}}\" class=\"app-icon\">\n      </div>\n      <div class=\"caption\">\n        <button type=\"button\" name=\"button\" class=\"btn btn-danger btn-xs pull-right\" ng-click=\"asListCtrl.deleteApp(app._id)\">删除</button>\n        <button type=\"button\" name=\"button\" class=\"btn btn-success btn-xs pull-right margin-right-10\" ui-sref=\"appstore.edit({id: app._id})\">编辑</button>\n        <div style=\"height: 50px;\">\n          <a ui-sref=\"appstore.show({id: app._id})\">\n            <h4 class=\"app-title\">{{app.name}}</h4>\n            <p class=\"app-title\">{{app.title}}</p>\n          </a>\n        </div>\n        <br>\n        <div ng-if=\"app.tags && app.tags.length\" style=\"float: left;\">\n          <span>标签:</span>&nbsp;\n          <span ng-repeat=\"tag in app.tags\">{{tag.name}}&nbsp;</span>\n        </div>\n        <div style=\"float: right;\">\n          <p><span>总量: {{app.virtualDownloadCount + app.downloadCount}}</span>&nbsp;<span>预设量: {{app.virtualDownloadCount}}</span></p>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n</div>\n"

/***/ }),
/* 219 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"app-detail\">\n    <img src=\"{{asShowCtrl.app.coverUrl}}\" alt=\"\" class=\"app-icon\" />\n    <strong>{{ asShowCtrl.app.name }}</strong>\n    <!-- <button type=\"button\" name=\"button\" class=\"btn btn-danger pull-right\">删除</button> -->\n    <button type=\"button\" name=\"button\" class=\"btn btn-default pull-right\" ui-sref=\"appstore.list\">返回</button>\n    <button type=\"button\" name=\"button\" class=\"btn btn-success pull-right margin-right-10\" ui-sref=\"appstore.edit({id: asShowCtrl.app._id})\">编辑</button>\n    <button type=\"button\" name=\"button\" class=\"btn btn-info pull-right margin-right-10\" ui-sref=\"appstore.addconf({id: asShowCtrl.app._id})\">添加配置</button>\n  </div>\n  <div class=\"well\">\n    {{ asShowCtrl.app.summary }}\n  </div>\n  <div class=\"well\">\n    <p>package: {{asShowCtrl.app.pkg}}</p>\n    <p>model: {{asShowCtrl.app.model.join('|')}}</p>\n    <p>lang: {{asShowCtrl.app.lang.join('|')}}</p>\n    <p>version: {{asShowCtrl.app.versionCode}}</p>\n    <p>size: {{asShowCtrl.app.size}}</p>\n    <p>url: {{asShowCtrl.app.storage.apk.local.url}}</p>\n  </div>\n  <div class=\"well\">\n    <h3>历史版本:</h3>\n    <ul>\n      <li ng-repeat=\"version in asShowCtrl.app.releases\">\n        <a>版本号： {{ version.versionCode }}, 更新时间： {{ version.createdAt | date:'yyyy-MM-dd' }}</a>\n      </li>\n    </ul>\n  </div>\n\n  <div ng-if=\"asShowCtrl.config.length > 0\">\n    <table class=\"table table-striped\">\n      <thead>\n        <tr>\n          <th style=\"width: 50px;\"></th>\n          <th>型号</th>\n          <th>应用版本</th>\n          <th>固件版本</th>\n          <th class=\"ctrl-th\"></th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"conf in asShowCtrl.config\">\n          <td>{{$index + 1}}</td>\n          <td>{{conf.model.join(',')}}</td>\n          <td>{{conf.versionCode}}</td>\n          <td>{{conf.firmwareVersion}}</td>\n          <td class=\"ctrl-td\">\n            <button ui-sref=\"appstore.editconf({id: conf._id})\" class=\"btn btn-xs btn-success\">编辑</button>\n            <button ng-click=\"asShowCtrl.deleteConf(conf._id)\" class=\"btn btn-xs btn-danger\">删除</button>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 220 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <form>\n    <label>添加应用</label>\n\n    <div class=\"form-group\">\n      <label for=\"name\">名字<span class=\"text-danger\">(必需)</span></label>\n      <input type=\"name\" class=\"form-control\" ng-model=\"asAddCtrl.newApp.name\" required>\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"title\">标题</label>\n      <input type=\"title\" class=\"form-control\" ng-model=\"asAddCtrl.newApp.title\">\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"model\">设备型号(多个型号用|分隔，如：C67ML|C87ML)</label>\n      <input type=\"model\" class=\"form-control\" ng-model=\"asAddCtrl.newApp.model\" ng-list=\"|\">\n    </div>\n\n    <div class=\"form-group\">\n      <input type=\"checkbox\" name=\"form-control\" ng-model=\"asAddCtrl.newApp.thirdParty\" ng-true-value=\"1\"\n        ng-false-value=\"0\"><span>第三方</span>\n    </div>\n\n    <div class=\"clearfix\">\n      <label for=\"models\">设备型号组</label>\n      <ul class=\"check-list\">\n        <li ng-repeat=\"group in asAddCtrl.groups\" class=\"\">\n            <input type=\"checkbox\" name=\"modelGroups[]\" value=\"{{group._id}}\" ng-checked=\"asAddCtrl.newApp.modelGroups.indexOf(group._id) > -1\"\n                ng-click=\"asAddCtrl.toggleSelection(group._id)\">\n            <span>{{group.name}}</span>\n        </li>\n      </ul>\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"excludeModel\">排除设备型号(多个型号用|分隔，如：C67ML|C87ML)</label>\n      <input type=\"excludeModel\" class=\"form-control\" ng-model=\"asAddCtrl.newApp.excludeModel\" ng-list=\"|\">\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"lang\">设备语言(多个语言用|分隔，如：zh_CN|en_US)</label>\n      <input type=\"lang\" class=\"form-control\" ng-model=\"asAddCtrl.newApp.lang\" ng-list=\"|\">\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"category\">分类</label>\n      <select class=\"form-control\" ng-model=\"asAddCtrl.newApp.category\">\n        <option ng-repeat=\"c in asAddCtrl.categories\" value=\"{{c.value}}\">{{c.name}}</option>\n      </select>\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"summary\">简介<span class=\"text-danger\">(必需)</span></label>\n      <textarea name=\"summary\" class=\"form-control\" rows=\"8\" cols=\"40\" ng-model=\"asAddCtrl.newApp.summary\" required></textarea>\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"file\" class=\"text-danger\">文件 <span>(必需)</span></label>\n      <input type=\"file\" ngf-select ng-model=\"asAddCtrl.file\" name=\"file\" required ngf-model-invalid=\"errorFile\" class=\"form-control\">\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"bucket\">区域</label>\n      <select class=\"form-control\" ng-model=\"asAddCtrl.newApp.bucket\">\n        <option value=\"onyx-app\">中国</option>\n        <option value=\"onyx-app-eu\">欧洲</option>\n      </select>\n    </div>\n\n    <div class=\"form-group\">\n      <input type=\"checkbox\" name=\"form-control\" ng-model=\"asAddCtrl.newApp.index\"><span>置顶</span>\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"deviceMAC\">目标设备MAC\n        <span class=\"text-danger\">（每行一个MAC）</span>\n      </label>\n      <textarea type=\"deviceMAC\" class=\"form-control\" ng-model=\"asAddCtrl.newApp.deviceMAC\" ng-list=\"&#10;\" ng-trim=\"false\" rows=\"5\"></textarea>\n    </div>\n\n    <button type=\"submit\" class=\"btn btn-success\" ng-click=\"asAddCtrl.uploadApk(asAddCtrl.file)\">保存</button>\n  </form>\n</div>\n"

/***/ }),
/* 221 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-6\">\n      <form>\n        <h3>更新应用</h3>\n\n        <div class=\"form-group\">\n          <label for=\"name\">名字<span class=\"text-danger\">(必需)</span></label>\n          <input type=\"name\" class=\"form-control\" ng-model=\"asEditCtrl.app.name\" required>\n        </div>\n\n        <div class=\"form-group\">\n          <label for=\"title\">标题</label>\n          <input type=\"title\" class=\"form-control\" ng-model=\"asEditCtrl.app.title\">\n        </div>\n\n        <div class=\"form-group\">\n          <label for=\"model\">设备型号(多个型号用|分隔，如：C67ML|C87ML)</label>\n          <input type=\"model\" class=\"form-control\" ng-model=\"asEditCtrl.app.model\" ng-list=\"|\">\n        </div>\n\n        <div class=\"form-group\">\n          <input type=\"checkbox\" name=\"form-control\" ng-model=\"asEditCtrl.app.thirdParty\" ng-true-value=\"1\"\n            ng-false-value=\"0\"><span>第三方</span>\n        </div>\n\n        <div class=\"clearfix\">\n        <label for=\"\">设备型号组</label>\n        <ul class=\"check-list\">\n          <li ng-repeat=\"group in asEditCtrl.groups\" class=\"\">\n              <input type=\"checkbox\" name=\"modelGroups[]\" value=\"{{group._id}}\" ng-checked=\"asEditCtrl.app.modelGroups.indexOf(group._id) > -1\"\n                  ng-click=\"asEditCtrl.toggleSelection(group._id)\">\n              <span>{{group.name}}</span>\n          </li>\n        </ul>\n      </div>\n\n        <div class=\"form-group\">\n          <label for=\"excludeModel\">排除设备型号(多个型号用|分隔，如：C67ML|C87ML)</label>\n          <input type=\"excludeModel\" class=\"form-control\" ng-model=\"asEditCtrl.app.excludeModel\" ng-list=\"|\">\n        </div>\n\n        <div class=\"form-group\">\n          <label for=\"lang\">设备语言(多个语言用|分隔，如：zh_CN|en_US)</label>\n          <input type=\"lang\" class=\"form-control\" ng-model=\"asEditCtrl.app.lang\" ng-list=\"|\">\n        </div>\n\n        <div class=\"clearfix\">\n          <label for=\"category\">分类</label>\n          <ul class=\"check-list\">\n            <li ng-repeat=\"c in asEditCtrl.categories\" class=\"\">\n                <input type=\"checkbox\" name=\"category[]\" value=\"{{c._id}}\" ng-checked=\"asEditCtrl.app.category.indexOf(c._id) > -1\"\n                    ng-click=\"asEditCtrl.toggleCategorySelection(c._id)\">\n                <span>{{c.name}}</span>\n            </li>\n          </ul>\n        </div>\n\n        <div class=\"clearfix\">\n          <label for=\"\">标签</label>\n          <ul class=\"check-list\">\n            <li ng-repeat=\"tag in asEditCtrl.tags\" class=\"\">\n                <input type=\"checkbox\" name=\"tags[]\" value=\"{{tag._id}}\" ng-checked=\"asEditCtrl.app.tags.indexOf(tag._id) > -1\"\n                    ng-click=\"asEditCtrl.toggleTagSelection(tag._id)\">\n                <span>{{tag.name}}</span>\n            </li>\n          </ul>\n        </div>\n\n        <div class=\"form-group\">\n          <label for=\"summary\">简介<span class=\"text-danger\">(必需)</span></label>\n          <textarea name=\"summary\" class=\"form-control\" rows=\"8\" cols=\"40\" ng-model=\"asEditCtrl.app.summary\" required></textarea>\n        </div>\n\n        <div class=\"form-group\">\n          <label for=\"downloadCount\">下载量</label>\n          <input type=\"number\" class=\"form-control\" ng-model=\"asEditCtrl.app.downloadCount\" disabled>\n        </div>\n\n        <div class=\"form-group\">\n          <label for=\"virtualDownloadCount\">预设量</label>\n          <input type=\"number\" class=\"form-control\" ng-model=\"asEditCtrl.app.virtualDownloadCount\">\n        </div>\n\n        <div class=\"form-group\">\n          <input type=\"checkbox\" name=\"form-control\" ng-model=\"asEditCtrl.app.index\"><span>置顶</span>\n        </div>\n\n        <!-- <div class=\"form-group\">\n          <input type=\"checkbox\" name=\"form-control\" ng-model=\"asEditCtrl.app.recommend\"><span>推荐</span>\n        </div> -->\n\n        <div class=\"form-group\">\n          <label for=\"deviceMAC\">目标设备MAC  <span class=\"text-danger\">（每行一个MAC）</span></label>\n          <textarea type=\"deviceMAC\" class=\"form-control\" ng-model=\"asEditCtrl.app.deviceMAC\" ng-list=\"&#10;\" ng-trim=\"false\" rows=\"5\"></textarea>\n        </div>\n\n        <button type=\"submit\" class=\"btn btn-success\" ng-click=\"asEditCtrl.update()\">保存</button>\n      </form>\n    </div>\n    <div class=\"col-xs-6\">\n      <h3>更新图标</h3>\n      <div class=\"form-group\">\n        <label for=\"file\">图标</label>\n        <input type=\"file\" ngf-select ng-model=\"asEditCtrl.file\" name=\"file\" required ngf-model-invalid=\"errorFile\" class=\"form-control\">\n      </div>\n      <div class=\"text-center\">\n        <img src=\"{{asEditCtrl.app.coverUrl}}\" class=\"app-icon\">\n      </div>\n      <br>\n      <div class=\"form-group\">\n        <label for=\"file\">彩色图标</label>\n        <input type=\"file\" ngf-select ng-model=\"asEditCtrl.colorFile\" name=\"colorFile\" required\n          ngf-model-invalid=\"errorFile\"\n          class=\"form-control\">\n      </div>\n      <div class=\"text-center\">\n        <img src=\"{{asEditCtrl.app.colorCoverUrl}}\" class=\"app-icon\">\n      </div>\n      <br>\n      <div class=\"form-group\">\n        <label for=\"file\">推广图</label>\n        <input type=\"file\" ngf-select ng-model=\"asEditCtrl.bannerFile\" name=\"bannerFile\" required\n          ngf-model-invalid=\"errorFile\"\n          class=\"form-control\">\n      </div>\n      <div class=\"text-center\">\n        <img src=\"{{asEditCtrl.app.banner}}\" class=\"app-banner\">\n      </div>\n      <br>\n      <h3>更新APK</h3>\n      <div class=\"form-group\">\n        <label for=\"file\">APK</label>\n        <input type=\"file\" ngf-select ng-model=\"asEditCtrl.apk\" name=\"apk\" ngf-model-invalid=\"errorFile\"\n          class=\"form-control\">\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 222 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n<h3>{{asAddConfCtrl.app.name}}</h3>\n<p>添加优化配置</p>\n  <form>\n    <div class=\"form-group\">\n      <label for=\"model\">设备型号(多个型号用|分隔，如：C67ML|C87ML)</label>\n      <input type=\"model\" class=\"form-control\" ng-model=\"asAddConfCtrl.newConf.model\" ng-list=\"|\">\n    </div>\n    <div class=\"form-group\">\n      <label for=\"firmwareVersion\">固件版本</label>\n      <input type=\"firmwareVersion\" class=\"form-control\" ng-model=\"asAddConfCtrl.newConf.firmwareVersion\">\n    </div>\n    <div class=\"form-group\">\n      <label for=\"pkg\">包名</label>\n      <input type=\"pkg\" class=\"form-control\" ng-model=\"asAddConfCtrl.newConf.pkg\" required>\n    </div>\n    <div class=\"form-group\">\n      <label for=\"versionCode\">应用版本</label>\n      <input type=\"versionCode\" class=\"form-control\" ng-model=\"asAddConfCtrl.newConf.versionCode\">\n    </div>\n    <div>\n      <label for=\"config\">配置</label>\n      <textarea name=\"config\" class=\"form-control\" rows=\"8\" cols=\"40\" ng-model=\"asAddConfCtrl.newConf.config\" required></textarea>\n    </div>\n\n    <button type=\"submit\" class=\"btn btn-success\" ng-click=\"asAddConfCtrl.add()\">保存</button>\n  </form>\n</div>"

/***/ }),
/* 223 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h3>{{asEditConfCtrl.app.name}}</h3>\n  <p>编辑优化配置</p>\n  <form>\n    <div class=\"form-group\">\n      <label for=\"model\">设备型号(多个型号用|分隔，如：C67ML|C87ML)</label>\n      <input type=\"model\" class=\"form-control\" ng-model=\"asEditConfCtrl.conf.model\" ng-list=\"|\">\n    </div>\n    <div class=\"form-group\">\n      <label for=\"firmwareVersion\">固件版本</label>\n      <input type=\"firmwareVersion\" class=\"form-control\" ng-model=\"asEditConfCtrl.conf.firmwareVersion\">\n    </div>\n    <div class=\"form-group\">\n      <label for=\"pkg\">包名</label>\n      <input type=\"pkg\" class=\"form-control\" ng-model=\"asEditConfCtrl.conf.pkg\" required>\n    </div>\n    <div class=\"form-group\">\n      <label for=\"versionCode\">应用版本</label>\n      <input type=\"versionCode\" class=\"form-control\" ng-model=\"asEditConfCtrl.conf.versionCode\">\n    </div>\n    <div>\n      <label for=\"config\">配置</label>\n      <textarea name=\"config\" class=\"form-control\" rows=\"8\" cols=\"40\" ng-model=\"asEditConfCtrl.conf.config\" required></textarea>\n    </div>\n\n    <button type=\"submit\" class=\"btn btn-success\" ng-click=\"asEditConfCtrl.save()\">保存</button>\n  </form>\n</div>"

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _list = __webpack_require__(225);
	
	var _list2 = _interopRequireDefault(_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.appstore.list', []).controller('AppStoreListController', _list2.default).name;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListController = function () {
	
	  /*@ngInject*/
	  ListController.$inject = ['$http', '$state', '$scope'];
	  function ListController($http, $state, $scope) {
	    (0, _classCallCheck3.default)(this, ListController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$scope = $scope;
	
	    this.category = '全部';
	  }
	
	  (0, _createClass3.default)(ListController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.$scope.$watch('asListCtrl.category', function (c) {
	        if (c !== undefined && c !== null) {
	          _this.getApps(c);
	        }
	      });
	
	      this.getCategories();
	    }
	  }, {
	    key: 'getApps',
	    value: function getApps(c) {
	      var _this2 = this;
	
	      var params = {
	        all: 1
	      };
	      if (c && c != '全部') {
	        params.category = c;
	      }
	      this.$http.get('/api/apks', { params: params }).then(function (response) {
	        _this2.apps = response.data;
	      });
	    }
	  }, {
	    key: 'deleteApp',
	    value: function deleteApp(id) {
	      var _this3 = this;
	
	      if (confirm("确定？")) {
	        this.$http.delete('api/apks/' + id).then(function (response) {
	          _this3.getApps(_this3.category);
	        });
	      }
	    }
	  }, {
	    key: 'getCategories',
	    value: function getCategories() {
	      var _this4 = this;
	
	      this.$http.get('/api/categories/app').then(function (res) {
	        _this4.categories = res.data.children;
	      });
	    }
	  }]);
	  return ListController;
	}();
	
	exports.default = ListController;

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _show = __webpack_require__(227);
	
	var _show2 = _interopRequireDefault(_show);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.appstore.show', []).controller('AppStoreShowController', _show2.default).name;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListController = function () {
	
	  /*@ngInject*/
	  ListController.$inject = ['$http', '$stateParams'];
	  function ListController($http, $stateParams) {
	    (0, _classCallCheck3.default)(this, ListController);
	
	    this.$http = $http;
	    this.$stateParams = $stateParams;
	  }
	
	  (0, _createClass3.default)(ListController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getApp(this.$stateParams.id);
	      this.getConfig(this.$stateParams.id);
	    }
	  }, {
	    key: 'getApp',
	    value: function getApp(id) {
	      var _this = this;
	
	      this.$http.get('/api/apks/' + id).then(function (response) {
	        _this.app = response.data;
	      });
	    }
	  }, {
	    key: 'deleteApp',
	    value: function deleteApp(app) {
	      var _this2 = this;
	
	      if (confirm("确定？")) {
	        this.$http.delete('api/apks/' + app._id).then(function (response) {
	          _this2.getApp();
	        });
	      }
	    }
	  }, {
	    key: 'getConfig',
	    value: function getConfig(id) {
	      var _this3 = this;
	
	      this.$http.get('/api/AppConfs', { params: { app: id } }).then(function (response) {
	        _this3.config = response.data;
	      });
	    }
	  }, {
	    key: 'deleteConf',
	    value: function deleteConf(id) {
	      var _this4 = this;
	
	      if (confirm("确定？")) {
	        this.$http.delete('api/AppConfs/' + id).then(function (response) {
	          _this4.getConfig(_this4.$stateParams.id);
	        });
	      }
	    }
	  }]);
	  return ListController;
	}();
	
	exports.default = ListController;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _add = __webpack_require__(229);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.appstore.add', []).controller('AppStoreAddController', _add2.default).name;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(157);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddController = function () {
	
	  /*@ngInject*/
	  AddController.$inject = ['$http', '$state', '$scope', 'Upload', 'toaster'];
	  function AddController($http, $state, $scope, Upload, toaster) {
	    (0, _classCallCheck3.default)(this, AddController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$scope = $scope;
	    this.Upload = Upload;
	    this.toaster = toaster;
	
	    this.newApp = {
	      modelGroups: []
	    };
	  }
	
	  (0, _createClass3.default)(AddController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getCategories();
	      this.getList();
	    }
	  }, {
	    key: 'uploadApk',
	    value: function uploadApk(file) {
	      var _this = this;
	
	      this.toaster.pop({
	        type: 'wait',
	        title: '正在上传APK，请稍等...',
	        body: file.name,
	        timeout: 3000 * 1000
	      });
	
	      file.upload = this.Upload.upload({
	        url: '/api/apks/uploadFile',
	        file: file,
	        data: this.newApp,
	        headers: {
	          'Content-Type': 'multipart/form-data'
	        }
	      });
	
	      file.upload.progress(function (evt) {
	        file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
	      });
	
	      file.upload.success(function (data, status, headers, config) {
	        _this.toaster.clear();
	        _this.$state.go('appstore.list');
	        _this.toaster.pop('success', '上传成功', file.name);
	      });
	
	      file.upload.error(function (err) {
	        _this.toaster.clear();
	        _this.toaster.pop('error', '上传失败', (0, _stringify2.default)(err));
	      });
	    }
	  }, {
	    key: 'getCategories',
	    value: function getCategories() {
	      var _this2 = this;
	
	      this.$http.get('/api/categories/appForWeb').then(function (res) {
	        _this2.categories = res.data.children;
	      });
	    }
	  }, {
	    key: 'getList',
	    value: function getList() {
	      var _this3 = this;
	
	      this.$http.get('/api/AppConfGroups').then(function (res) {
	        _this3.groups = res.data;
	      });
	    }
	  }, {
	    key: 'toggleSelection',
	    value: function toggleSelection(id) {
	      var idx = this.newApp.modelGroups.indexOf(id);
	      if (idx > -1) {
	        this.newApp.modelGroups.splice(idx, 1);
	      } else {
	        this.newApp.modelGroups.push(id);
	      }
	    }
	  }]);
	  return AddController;
	}();
	
	exports.default = AddController;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _edit = __webpack_require__(231);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.appstore.edit', []).controller('AppStoreEditController', _edit2.default).name;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(157);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconController = function () {
	
	  /*@ngInject*/
	  IconController.$inject = ['$http', '$state', '$stateParams', '$scope', 'toaster', 'Upload'];
	  function IconController($http, $state, $stateParams, $scope, toaster, Upload) {
	    (0, _classCallCheck3.default)(this, IconController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$scope = $scope;
	    this.toaster = toaster;
	    this.Upload = Upload;
	  }
	
	  (0, _createClass3.default)(IconController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.$scope.$watch('asEditCtrl.file', function (file) {
	        if (file !== undefined && file !== null) {
	          _this.uploadIcon(file);
	        }
	      });
	
	      this.$scope.$watch('asEditCtrl.colorFile', function (file) {
	        if (file !== undefined && file !== null) {
	          _this.uploadColorIcon(file);
	        }
	      });
	
	      this.$scope.$watch('asEditCtrl.bannerFile', function (file) {
	        if (file !== undefined && file !== null) {
	          _this.uploadBanner(file);
	        }
	      });
	
	      this.$scope.$watch('asEditCtrl.apk', function (file) {
	        if (file !== undefined && file !== null) {
	          _this.uploadApk(file);
	        }
	      });
	
	      this.getCategories();
	      this.getList();
	      this.getTags();
	    }
	  }, {
	    key: 'getApp',
	    value: function getApp() {
	      var _this2 = this;
	
	      this.$http.get('/api/apks/' + this.$stateParams.id).then(function (response) {
	        _this2.app = response.data;
	        _this2.app.index = !!_this2.app.index;
	        _this2.app.recommend = !!_this2.app.recommend;
	        _this2.app.tags = _this2.app.tags.map(function (item) {
	          return item._id;
	        });
	      });
	    }
	  }, {
	    key: 'uploadIcon',
	    value: function uploadIcon(file) {
	      var _this3 = this;
	
	      this.toaster.pop({
	        type: 'wait',
	        title: '正在上传图标，请稍等...',
	        body: file.name,
	        timeout: 3000 * 1000
	      });
	
	      file.upload = this.Upload.upload({
	        url: '/api/apks/' + this.app._id + '/uploadIcon',
	        file: file,
	        data: this.app,
	        headers: {
	          'Content-Type': 'multipart/form-data'
	        }
	      });
	
	      file.upload.progress(function (evt) {
	        file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
	      });
	
	      file.upload.success(function (data, status, headers, config) {
	        _this3.toaster.clear();
	        _this3.getApp();
	        _this3.toaster.pop('success', '上传成功', file.name);
	      });
	
	      file.upload.error(function (err) {
	        _this3.toaster.clear();
	        _this3.toaster.pop('error', '上传失败', (0, _stringify2.default)(err));
	      });
	    }
	  }, {
	    key: 'uploadColorIcon',
	    value: function uploadColorIcon(file) {
	      var _this4 = this;
	
	      this.toaster.pop({
	        type: 'wait',
	        title: '正在上传图标，请稍等...',
	        body: file.name,
	        timeout: 3000 * 1000
	      });
	
	      file.upload = this.Upload.upload({
	        url: '/api/apks/' + this.app._id + '/uploadColorIcon',
	        file: file,
	        data: this.app,
	        headers: {
	          'Content-Type': 'multipart/form-data'
	        }
	      });
	
	      file.upload.progress(function (evt) {
	        file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
	      });
	
	      file.upload.success(function (data, status, headers, config) {
	        _this4.toaster.clear();
	        _this4.getApp();
	        _this4.toaster.pop('success', '上传成功', file.name);
	      });
	
	      file.upload.error(function (err) {
	        _this4.toaster.clear();
	        _this4.toaster.pop('error', '上传失败', (0, _stringify2.default)(err));
	      });
	    }
	  }, {
	    key: 'uploadBanner',
	    value: function uploadBanner(file) {
	      var _this5 = this;
	
	      this.toaster.pop({
	        type: 'wait',
	        title: '正在上传图，请稍等...',
	        body: file.name,
	        timeout: 3000 * 1000
	      });
	
	      file.upload = this.Upload.upload({
	        url: '/api/apks/' + this.app._id + '/uploadBanner',
	        file: file,
	        data: this.app,
	        headers: {
	          'Content-Type': 'multipart/form-data'
	        }
	      });
	
	      file.upload.progress(function (evt) {
	        file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
	      });
	
	      file.upload.success(function (data, status, headers, config) {
	        _this5.toaster.clear();
	        _this5.getApp();
	        _this5.toaster.pop('success', '上传成功', file.name);
	      });
	
	      file.upload.error(function (err) {
	        _this5.toaster.clear();
	        _this5.toaster.pop('error', '上传失败', (0, _stringify2.default)(err));
	      });
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var _this6 = this;
	
	      this.$http.put('api/apks/' + this.app._id, this.app).then(function (response) {
	        _this6.$state.go('appstore');
	      });
	    }
	  }, {
	    key: 'getCategories',
	    value: function getCategories() {
	      var _this7 = this;
	
	      this.$http.get('/api/categories/appForWeb').then(function (res) {
	        _this7.categories = res.data.children;
	        _this7.getApp();
	      });
	    }
	  }, {
	    key: 'uploadApk',
	    value: function uploadApk(file) {
	      var _this8 = this;
	
	      this.toaster.pop({
	        type: 'wait',
	        title: '正在上传APK，请稍等...',
	        body: file.name,
	        timeout: 3000 * 1000
	      });
	
	      file.upload = this.Upload.upload({
	        url: '/api/apks/' + this.app._id + '/updateApk',
	        file: file,
	        data: this.app,
	        headers: {
	          'Content-Type': 'multipart/form-data'
	        }
	      });
	
	      file.upload.progress(function (evt) {
	        file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
	      });
	
	      file.upload.success(function (data, status, headers, config) {
	        _this8.toaster.clear();
	        _this8.getApp();
	        _this8.toaster.pop('success', '上传成功', file.name);
	      });
	
	      file.upload.error(function (err) {
	        _this8.toaster.clear();
	        _this8.toaster.pop('error', '上传失败', (0, _stringify2.default)(err));
	      });
	    }
	  }, {
	    key: 'getList',
	    value: function getList() {
	      var _this9 = this;
	
	      this.$http.get('/api/AppConfGroups').then(function (res) {
	        _this9.groups = res.data;
	      });
	    }
	  }, {
	    key: 'getTags',
	    value: function getTags() {
	      var _this10 = this;
	
	      this.$http.get('/api/tags', {}).then(function (response) {
	        _this10.tags = response.data;
	      });
	    }
	  }, {
	    key: 'toggleSelection',
	    value: function toggleSelection(id) {
	      var idx = this.app.modelGroups.indexOf(id);
	      if (idx > -1) {
	        this.app.modelGroups.splice(idx, 1);
	      } else {
	        this.app.modelGroups.push(id);
	      }
	    }
	  }, {
	    key: 'toggleTagSelection',
	    value: function toggleTagSelection(id) {
	      var idx = this.app.tags.indexOf(id);
	      if (idx > -1) {
	        this.app.tags.splice(idx, 1);
	      } else {
	        this.app.tags.push(id);
	      }
	    }
	  }, {
	    key: 'toggleCategorySelection',
	    value: function toggleCategorySelection(id) {
	      var idx = this.app.category.indexOf(id);
	      if (idx > -1) {
	        this.app.category.splice(idx, 1);
	      } else {
	        this.app.category.push(id);
	      }
	    }
	  }]);
	  return IconController;
	}();
	
	exports.default = IconController;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _addConf = __webpack_require__(233);
	
	var _addConf2 = _interopRequireDefault(_addConf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('onyxReadingRoomApp.appstore.addconf', []).controller('AppStoreAddConfController', _addConf2.default).name;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddConfController = function () {
	
	  /*@ngInject*/
	  AddConfController.$inject = ['$http', '$state', '$stateParams'];
	  function AddConfController($http, $state, $stateParams) {
	    (0, _classCallCheck3.default)(this, AddConfController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.newConf = {};
	  }
	
	  (0, _createClass3.default)(AddConfController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getApp();
	    }
	  }, {
	    key: 'getApp',
	    value: function getApp() {
	      var _this = this;
	
	      this.$http.get('/api/apks/' + this.$stateParams.id).then(function (response) {
	        _this.app = response.data;
	        _this.newConf.pkg = _this.app.pkg;
	        _this.newConf.versionCode = _this.app.versionCode;
	      });
	    }
	  }, {
	    key: 'add',
	    value: function add() {
	      var _this2 = this;
	
	      this.newConf.app = this.$stateParams.id;
	      this.$http.post('api/AppConfs', this.newConf).then(function (response) {
	        _this2.$state.go('appstore.show', { id: _this2.$stateParams.id });
	      });
	    }
	  }]);
	  return AddConfController;
	}();
	
	exports.default = AddConfController;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _editConf = __webpack_require__(235);
	
	var _editConf2 = _interopRequireDefault(_editConf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('onyxReadingRoomApp.appstore.editconf', []).controller('AppStoreEditConfController', _editConf2.default).name;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddConfController = function () {
	
	  /*@ngInject*/
	  AddConfController.$inject = ['$http', '$state', '$stateParams'];
	  function AddConfController($http, $state, $stateParams) {
	    (0, _classCallCheck3.default)(this, AddConfController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	  }
	
	  (0, _createClass3.default)(AddConfController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getConf(this.$stateParams.id);
	    }
	  }, {
	    key: 'getApp',
	    value: function getApp(id) {
	      var _this = this;
	
	      this.$http.get('/api/apks/' + id).then(function (response) {
	        _this.app = response.data;
	      });
	    }
	  }, {
	    key: 'getConf',
	    value: function getConf(id) {
	      var _this2 = this;
	
	      this.$http.get('/api/AppConfs/' + id).then(function (response) {
	        _this2.conf = response.data;
	        _this2.getApp(_this2.conf.app);
	      });
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this3 = this;
	
	      this.$http.put('api/AppConfs/' + this.$stateParams.id, this.conf).then(function (response) {
	        _this3.$state.go('appstore.show', {
	          id: _this3.conf.app
	        });
	      });
	    }
	  }]);
	  return AddConfController;
	}();
	
	exports.default = AddConfController;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.appIconCheckFilter = appIconCheckFilter;
	var angular = __webpack_require__(78);
	
	/*@ngInject*/
	function appIconCheckFilter() {
	  return function (input) {
	    return input !== '' && input !== undefined ? input : '/assets/images/app.png';
	  };
	}
	
	exports.default = angular.module('updateServerApp.appIconCheck', []).filter('appIconCheck', appIconCheckFilter).name;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(86);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _waveforms = __webpack_require__(238);
	
	var _waveforms2 = _interopRequireDefault(_waveforms);
	
	var _list = __webpack_require__(243);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _edit = __webpack_require__(245);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _add = __webpack_require__(247);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.waveforms', [_angularUiRouter2.default, _list2.default, _edit2.default, _add2.default]).config(_waveforms2.default).run(['$rootScope', function ($rootScope) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
	    if (next.name === 'logout' && current && current.name && !current.authenticate) {
	      next.referrer = current.name;
	    }
	  });
	}]).name;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $urlRouterProvider.when("/waveforms", "/waveforms/list");
	  $stateProvider.state('waveforms', {
	    url: '/waveforms',
	    template: __webpack_require__(239),
	    authenticate: true
	  }).state('waveforms.list', {
	    url: '/list',
	    template: __webpack_require__(240),
	    controller: 'WaveformsListController',
	    controllerAs: 'waveformsListCtrl'
	  }).state('waveforms.edit', {
	    url: '/edit/:id',
	    template: __webpack_require__(241),
	    controller: 'WaveformsEditController',
	    controllerAs: 'waveformsEditCtrl'
	  }).state('waveforms.add', {
	    url: '/add',
	    template: __webpack_require__(242),
	    controller: 'WaveformsAddController',
	    controllerAs: 'waveformsAddCtrl'
	  });
	}];

/***/ }),
/* 239 */
144,
/* 240 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"page-header\">\n    <a ui-sref=\"waveforms.add\" class=\"btn btn-primary pull-right\">添加</a>\n    <h3>Waveform</h3>\n  </div>\n  <div class=\"\">\n    <table class=\"table table-striped\">\n      <thead>\n        <tr>\n          <th></th>\n          <th>型号</th>\n          <th>日期</th>\n          <th class=\"ctrl-th\"></th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"firmware in waveformsListCtrl.waveforms\">\n          <td>{{$index + 1}}</td>\n          <td>{{firmware.model}}</td>\n          <td>{{firmware.createdAt | date:'yyyy-MM-dd'}}</td>\n          <td class=\"ctrl-td\">\n            <button ui-sref=\"waveforms.edit({id: firmware._id})\" class=\"btn btn-xs btn-success\">编辑</button>\n            <button ng-click=\"waveformsListCtrl.delete(firmware._id)\" class=\"btn btn-xs btn-danger\">删除</button>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 241 */
/***/ (function(module, exports) {

	module.exports = "\n<div class=\"container\">\n  <div class=\"page-header\">\n    <h1>更新</h1>\n  </div>\n  <div>\n    <form>\n      <div class=\"form-group\">\n        <label for=\"model\">型号\n          <span class=\"text-danger\">(必需)</span>\n        </label>\n        <input type=\"model\" class=\"form-control\" ng-model=\"waveformsEditCtrl.waveform.model\" required>\n      </div>\n    \n      <div class=\"form-group\">\n        <label for=\"brand\">sys_panel_barcode\n        </label>\n        <input type=\"brand\" class=\"form-control\" ng-model=\"waveformsEditCtrl.waveform.sysPanelBarcode\">\n      </div>\n    \n      <div class=\"form-group\">\n        <label for=\"brand\">sys_panel _nvm_ver\n        </label>\n        <input type=\"brand\" class=\"form-control\" ng-model=\"waveformsEditCtrl.waveform.sysPanelNvmVer\">\n      </div>\n    \n      <div class=\"form-group\">\n        <label for=\"brand\">sys_panel_partno\n        </label>\n        <input type=\"brand\" class=\"form-control\" ng-model=\"waveformsEditCtrl.waveform.sysPanelPartno\">\n      </div>\n    \n      <div class=\"form-group\">\n        <label for=\"brand\">sys_panel_vcom\n        </label>\n        <input type=\"brand\" class=\"form-control\" ng-model=\"waveformsEditCtrl.waveform.sysPanelVcom\">\n      </div>\n    \n      <div class=\"form-group\">\n        <label for=\"brand\">sys_panel_wf_version\n        </label>\n        <input type=\"brand\" class=\"form-control\" ng-model=\"waveformsEditCtrl.waveform.sysPanelWfVersion\">\n      </div>\n    \n      <button type=\"submit\" class=\"btn btn-success\" ng-click=\"waveformsEditCtrl.save()\">保存</button>\n      <button type=\"button\" class=\"btn btn-default\" ui-sref=\"^\">返回</button>\n    </form>\n  </div>\n</div>\n"

/***/ }),
/* 242 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n    <div class=\"page-header\">\n        <h1>添加</h1>\n    </div>\n    <div>\n        <form>\n            <div class=\"form-group\">\n                <label for=\"file\" class=\"text-danger\">文件\n                    <span>(必需)</span>\n                </label>\n                <input type=\"file\" ngf-select ng-model=\"waveformsAddCtrl.file\" name=\"file\" required ngf-model-invalid=\"errorFile\" class=\"form-control\">\n            </div>\n\n            <div class=\"form-group\">\n                <label for=\"model\">型号\n                    <span class=\"text-danger\">(必需)</span>\n                </label>\n                <input type=\"model\" class=\"form-control\" ng-model=\"waveformsAddCtrl.newWaveform.model\" required>\n            </div>\n\n            <div class=\"form-group\">\n                <label for=\"brand\">sys_panel_barcode\n                </label>\n                <input type=\"brand\" class=\"form-control\" ng-model=\"waveformsAddCtrl.newWaveform.sysPanelBarcode\">\n            </div>\n\n            <div class=\"form-group\">\n                <label for=\"brand\">sys_panel _nvm_ver\n                </label>\n                <input type=\"brand\" class=\"form-control\" ng-model=\"waveformsAddCtrl.newWaveform.sysPanelNvmVer\">\n            </div>\n\n            <div class=\"form-group\">\n                <label for=\"brand\">sys_panel_partno\n                </label>\n                <input type=\"brand\" class=\"form-control\" ng-model=\"waveformsAddCtrl.newWaveform.sysPanelPartno\">\n            </div>\n\n            <div class=\"form-group\">\n                <label for=\"brand\">sys_panel_vcom\n                </label>\n                <input type=\"brand\" class=\"form-control\" ng-model=\"waveformsAddCtrl.newWaveform.sysPanelVcom\">\n            </div>\n\n            <div class=\"form-group\">\n                <label for=\"brand\">sys_panel_wf_version\n                </label>\n                <input type=\"brand\" class=\"form-control\" ng-model=\"waveformsAddCtrl.newWaveform.sysPanelWfVersion\">\n            </div>\n\n            <button type=\"submit\" class=\"btn btn-success\" ng-click=\"waveformsAddCtrl.uploadFile(waveformsAddCtrl.file)\">保存</button>\n            <button type=\"button\" class=\"btn btn-default\" ui-sref=\"^\">返回</button>\n        </form>\n    </div>\n</div>"

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _list = __webpack_require__(244);
	
	var _list2 = _interopRequireDefault(_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.waveforms.list', []).controller('WaveformsListController', _list2.default).name;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListController = function () {
	
	  /*@ngInject*/
	  ListController.$inject = ['$http'];
	  function ListController($http) {
	    (0, _classCallCheck3.default)(this, ListController);
	
	    this.$http = $http;
	  }
	
	  (0, _createClass3.default)(ListController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getWaveforms();
	    }
	  }, {
	    key: 'getWaveforms',
	    value: function getWaveforms() {
	      var _this = this;
	
	      this.$http.get('/api/waveforms').then(function (res) {
	        _this.waveforms = res.data;
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(id) {
	      var _this2 = this;
	
	      if (confirm("确定？")) {
	        this.$http.delete('/api/waveforms/' + id).then(function (res) {
	          _this2.getWaveforms();
	        });
	      }
	    }
	  }]);
	  return ListController;
	}();
	
	exports.default = ListController;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _edit = __webpack_require__(246);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.waveforms.edit', []).controller('WaveformsEditController', _edit2.default).name;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditController = function () {
	
	  /*@ngInject*/
	  EditController.$inject = ['$http', '$stateParams', '$state'];
	  function EditController($http, $stateParams, $state) {
	    (0, _classCallCheck3.default)(this, EditController);
	
	    this.$http = $http;
	    this.$stateParams = $stateParams;
	    this.$state = $state;
	  }
	
	  (0, _createClass3.default)(EditController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getWaveform();
	    }
	  }, {
	    key: 'getWaveform',
	    value: function getWaveform() {
	      var _this = this;
	
	      this.$http.get('/api/waveforms/' + this.$stateParams.id).then(function (res) {
	        _this.waveform = res.data;
	      });
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this2 = this;
	
	      this.$http.put('/api/waveforms/' + this.$stateParams.id, this.waveform).then(function (res) {
	        _this2.$state.go('^');
	      });
	    }
	  }]);
	  return EditController;
	}();
	
	exports.default = EditController;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _add = __webpack_require__(248);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.waveforms.add', []).controller('WaveformsAddController', _add2.default).name;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(157);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddController = function () {
	
	    /*@ngInject*/
	    AddController.$inject = ['$http', '$state', 'Upload', 'toaster'];
	    function AddController($http, $state, Upload, toaster) {
	        (0, _classCallCheck3.default)(this, AddController);
	
	        this.$http = $http;
	        this.$state = $state;
	        this.Upload = Upload;
	        this.toaster = toaster;
	
	        this.newWaveform = {};
	    }
	
	    (0, _createClass3.default)(AddController, [{
	        key: 'uploadFile',
	        value: function uploadFile(file) {
	            var _this = this;
	
	            console.log(this.newWaveform);
	            this.toaster.pop({
	                type: 'wait',
	                title: '正在上传，请稍等...',
	                body: file.name,
	                timeout: 3000 * 1000
	            });
	
	            file.upload = this.Upload.upload({
	                url: '/api/waveforms/uploadFile',
	                file: file,
	                data: this.newWaveform,
	                headers: {
	                    'Content-Type': 'multipart/form-data'
	                }
	            });
	
	            file.upload.progress(function (evt) {
	                file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
	            });
	
	            file.upload.success(function (data, status, headers, config) {
	                _this.toaster.clear();
	                _this.$state.go('^');
	                _this.toaster.pop('success', '上传成功', file.name);
	            });
	
	            file.upload.error(function (err) {
	                _this.toaster.clear();
	                _this.toaster.pop('error', '上传失败', (0, _stringify2.default)(err));
	            });
	        }
	    }]);
	    return AddController;
	}();
	
	exports.default = AddController;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(86);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _booklist = __webpack_require__(250);
	
	var _booklist2 = _interopRequireDefault(_booklist);
	
	var _list = __webpack_require__(256);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _add = __webpack_require__(258);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _edit = __webpack_require__(260);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _show = __webpack_require__(262);
	
	var _show2 = _interopRequireDefault(_show);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.booklist', [_angularUiRouter2.default, _list2.default, _add2.default, _edit2.default, _show2.default]).config(_booklist2.default).run(['$rootScope', function ($rootScope) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
	    if (next.name === 'logout' && current && current.name && !current.authenticate) {
	      next.referrer = current.name;
	    }
	  });
	}]).name;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $urlRouterProvider.when("/booklist", "/booklist/list");
	  $stateProvider.state('booklist', {
	    url: '/booklist',
	    template: __webpack_require__(251),
	    authenticate: true
	  }).state('booklist.list', {
	    url: '/list',
	    template: __webpack_require__(252),
	    controller: 'BookListController',
	    controllerAs: 'BListCtrl'
	  }).state('booklist.add', {
	    url: '/add',
	    template: __webpack_require__(253),
	    controller: 'BookListAddController',
	    controllerAs: 'BListAddCtrl'
	  }).state('booklist.edit', {
	    url: '/edit/:id',
	    template: __webpack_require__(254),
	    controller: 'BookListEditController',
	    controllerAs: 'BListEditCtrl'
	  }).state('booklist.show', {
	    url: '/show/:id',
	    template: __webpack_require__(255),
	    controller: 'BookListShowController',
	    controllerAs: 'BListShowCtrl'
	  });
	}];

/***/ }),
/* 251 */
144,
/* 252 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"page-header\">\n    <a ui-sref=\"booklist.add\" class=\"btn btn-primary pull-right\">添加</a>\n    <h3>书单</h3>\n  </div>\n  <div class=\"\">\n    <table class=\"table table-striped\">\n      <thead>\n        <tr>\n          <th style=\"width: 50px;\"></th>\n          <th></th>\n          <th>书单</th>\n          <th>数量</th>\n          <th class=\"ctrl-th\"></th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"book in BListCtrl.books\">\n          <td>{{$index + 1}}</td>\n          <td><img src=\"{{book.pic_address}}\" alt=\"\" class=\"table-list-cover\"></td>\n          <td>{{book.show_name}}</td>\n          <td>{{book.count}}</td>\n          <td class=\"ctrl-td\">\n            <button ui-sref=\"booklist.show({id: book._id})\" class=\"btn btn-xs btn-primary\">详细</button>\n            <button ui-sref=\"booklist.edit({id: book._id})\" class=\"btn btn-xs btn-success\">编辑</button>\n            <button ng-click=\"BListCtrl.delete(book._id)\" class=\"btn btn-xs btn-danger\">删除</button>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 253 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n    <div class=\"page-header\">\n        <h1>添加</h1>\n    </div>\n    <div>\n        <form>\n            <div class=\"form-group\">\n                <label for=\"show_name\">书单名\n                    <span class=\"text-danger\">(必需)</span>\n                </label>\n                <input type=\"show_name\" class=\"form-control\" ng-model=\"BListAddCtrl.newList.show_name\" required>\n            </div>\n            <div class=\"form-group\">\n                <label for=\"note\">简介\n                    <span class=\"text-danger\">(必需)</span>\n                </label>\n                <input type=\"note\" class=\"form-control\" ng-model=\"BListAddCtrl.newList.note\" required>\n            </div>\n\n            <button type=\"submit\" class=\"btn btn-success\" ng-click=\"BListAddCtrl.save()\">保存</button>\n            <button type=\"button\" class=\"btn btn-default\" ui-sref=\"^\">返回</button>\n        </form>\n    </div>\n</div>"

/***/ }),
/* 254 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-6\">\n      <div class=\"page-header\">\n        <h1>编辑</h1>\n      </div>\n      <form>\n        <div class=\"form-group\">\n          <label for=\"show_name\">书单名\n            <span class=\"text-danger\">(必需)</span>\n          </label>\n          <input type=\"show_name\" class=\"form-control\" ng-model=\"BListEditCtrl.booklist.show_name\" required>\n        </div>\n\n        <div class=\"form-group\">\n          <label for=\"note\">简介\n            <span class=\"text-danger\">(必需)</span>\n          </label>\n          <input type=\"note\" class=\"form-control\" ng-model=\"BListEditCtrl.booklist.note\" required>\n        </div>\n\n\n        <button type=\"submit\" class=\"btn btn-success\" ng-click=\"BListEditCtrl.save()\">保存</button>\n        <button type=\"button\" class=\"btn btn-default\" ui-sref=\"^\">返回</button>\n      </form>\n    </div>\n\n    <div class=\"col-xs-6\">\n      <div class=\"page-header\">\n        <h1>更新封面</h1>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"file\">图标</label>\n        <input type=\"file\" ngf-select ng-model=\"BListEditCtrl.file\" name=\"file\" required ngf-model-invalid=\"errorFile\" class=\"form-control\">\n      </div>\n      <div class=\"text-center\">\n        <img src=\"{{BListEditCtrl.booklist.pic_address}}\">\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 255 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"page-header\">\n    <!-- <a ui-sref=\"booklist.edit({id: BListShowCtrl.booklist._id})\" class=\"btn btn-primary pull-right\">编辑</a> -->\n    <form class=\"col-md-4 pull-right\">\n      <div class=\"input-group\">\n        <input type=\"text\" class=\"form-control\" placeholder=\"book id\" aria-describedby=\"sizing-addon2\" ng-model=\"book_id\">\n        <span class=\"input-group-addon\" id=\"sizing-addon2\" ng-click=\"BListShowCtrl.addBook(book_id)\">添加</span>\n      </div>\n    </form>\n    <h3>{{BListShowCtrl.booklist.show_name}}</h3>\n  </div>\n\n  <div class=\"book-list\">\n    <div class=\"media\" ng-repeat=\"book in BListShowCtrl.booklist.items\">\n      <div class=\"media-left media-middle\">\n        <a href=\"#\">\n          <img class=\"media-object\" src=\"{{book.image_url}}\" alt=\"...\">\n        </a>\n      </div>\n      <div class=\"media-body\">\n        <h4 class=\"media-heading\">{{book.name}}</h4>\n        <p>{{book.author}}</p>\n        <p>{{book.publisher}}</p>\n        <p>{{book.publish_time}}</p>\n        <p>{{book.info}}</p>\n      </div>\n    </div>\n  </div>\n</div>\n\n \n"

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _list = __webpack_require__(257);
	
	var _list2 = _interopRequireDefault(_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.booklist.list', []).controller('BookListController', _list2.default).name;

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListController = function () {
	
	  /*@ngInject*/
	  ListController.$inject = ['$http'];
	  function ListController($http) {
	    (0, _classCallCheck3.default)(this, ListController);
	
	    this.$http = $http;
	  }
	
	  (0, _createClass3.default)(ListController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getBookList();
	    }
	  }, {
	    key: 'getBookList',
	    value: function getBookList() {
	      var _this = this;
	
	      this.$http.get('/api/booklists').then(function (res) {
	        _this.books = res.data.data;
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(id) {
	      var _this2 = this;
	
	      if (confirm("确定？")) {
	        this.$http.delete('/api/booklists/' + id).then(function (res) {
	          _this2.getBookList();
	        });
	      }
	    }
	  }]);
	  return ListController;
	}();
	
	exports.default = ListController;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _add = __webpack_require__(259);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.booklist.add', []).controller('BookListAddController', _add2.default).name;

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddController = function () {
	
	    /*@ngInject*/
	    AddController.$inject = ['$http', '$state'];
	    function AddController($http, $state) {
	        (0, _classCallCheck3.default)(this, AddController);
	
	        this.$http = $http;
	        this.$state = $state;
	        this.newList = {};
	    }
	
	    (0, _createClass3.default)(AddController, [{
	        key: 'save',
	        value: function save() {
	            var _this = this;
	
	            this.$http.post('/api/booklists', this.newList).then(function (res) {
	                _this.$state.go('^');
	            });
	        }
	    }]);
	    return AddController;
	}();
	
	exports.default = AddController;

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _edit = __webpack_require__(261);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.booklist.edit', []).controller('BookListEditController', _edit2.default).name;

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(157);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditController = function () {
	
	  /*@ngInject*/
	  EditController.$inject = ['$http', '$stateParams', '$state', '$scope', 'toaster', 'Upload'];
	  function EditController($http, $stateParams, $state, $scope, toaster, Upload) {
	    (0, _classCallCheck3.default)(this, EditController);
	
	    this.$http = $http;
	    this.$stateParams = $stateParams;
	    this.$state = $state;
	    this.$scope = $scope;
	    this.toaster = toaster;
	    this.Upload = Upload;
	  }
	
	  (0, _createClass3.default)(EditController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.getBookList();
	
	      this.$scope.$watch('BListEditCtrl.file', function (file) {
	        if (file !== undefined && file !== null) {
	          _this.uploadCover(file);
	        }
	      });
	    }
	  }, {
	    key: 'getBookList',
	    value: function getBookList() {
	      var _this2 = this;
	
	      this.$http.get('/api/booklists/' + this.$stateParams.id).then(function (res) {
	        _this2.booklist = res.data.data;
	      });
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this3 = this;
	
	      this.$http.put('/api/booklists/' + this.$stateParams.id, this.booklist).then(function (res) {
	        _this3.$state.go('^');
	      });
	    }
	  }, {
	    key: 'uploadCover',
	    value: function uploadCover(file) {
	      var _this4 = this;
	
	      this.toaster.pop({
	        type: 'wait',
	        title: '正在上传封面，请稍等...',
	        body: file.name,
	        timeout: 3000 * 1000
	      });
	
	      file.upload = this.Upload.upload({
	        url: '/api/booklists/' + this.booklist._id + '/uploadCover',
	        file: file,
	        data: this.booklist,
	        headers: {
	          'Content-Type': 'multipart/form-data'
	        }
	      });
	
	      file.upload.progress(function (evt) {
	        file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
	      });
	
	      file.upload.success(function (data, status, headers, config) {
	        _this4.toaster.clear();
	        _this4.getBookList();
	        _this4.toaster.pop('success', '上传成功', file.name);
	      });
	
	      file.upload.error(function (err) {
	        _this4.toaster.clear();
	        _this4.toaster.pop('error', '上传失败', (0, _stringify2.default)(err));
	      });
	    }
	  }]);
	  return EditController;
	}();
	
	exports.default = EditController;

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _show = __webpack_require__(263);
	
	var _show2 = _interopRequireDefault(_show);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.booklist.show', []).controller('BookListShowController', _show2.default).name;

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ShowController = function () {
	
	  /*@ngInject*/
	  ShowController.$inject = ['$http', '$stateParams', '$state'];
	  function ShowController($http, $stateParams, $state) {
	    (0, _classCallCheck3.default)(this, ShowController);
	
	    this.$http = $http;
	    this.$stateParams = $stateParams;
	    this.$state = $state;
	  }
	
	  (0, _createClass3.default)(ShowController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getBookList();
	    }
	  }, {
	    key: 'getBookList',
	    value: function getBookList() {
	      var _this = this;
	
	      this.$http.get('/api/booklists/' + this.$stateParams.id).then(function (res) {
	        _this.booklist = res.data.data;
	      });
	    }
	  }, {
	    key: 'addBook',
	    value: function addBook(bookId) {
	      var _this2 = this;
	
	      var data = {
	        ids: [bookId]
	      };
	      this.$http.post('/api/booklists/' + this.$stateParams.id + '/addBook', data).then(function (res) {
	        _this2.getBookList();
	      });
	    }
	  }]);
	  return ShowController;
	}();
	
	exports.default = ShowController;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(86);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _appconfs = __webpack_require__(265);
	
	var _appconfs2 = _interopRequireDefault(_appconfs);
	
	var _list = __webpack_require__(273);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _show = __webpack_require__(275);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _add = __webpack_require__(277);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _edit = __webpack_require__(283);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _code = __webpack_require__(289);
	
	var _code2 = _interopRequireDefault(_code);
	
	var _import = __webpack_require__(291);
	
	var _import2 = _interopRequireDefault(_import);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('onyxReadingRoomApp.appconfs', [_angularUiRouter2.default, _list2.default, _code2.default, _show2.default, _add2.default, _edit2.default, _import2.default]).config(_appconfs2.default).run(['$rootScope', function ($rootScope) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
	    if (next.name === 'logout' && current && current.name && !current.authenticate) {
	      next.referrer = current.name;
	    }
	  });
	}]).name;

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $urlRouterProvider.when("/appconfs", "/appconfs/list");
	  $urlRouterProvider.when("/codeappconfs", "/codeappconfs/code");
	
	  $stateProvider.state('appconfs', {
	    url: '/appconfs',
	    template: __webpack_require__(266),
	    authenticate: true
	  }).state('appconfs.list', {
	    url: '/list',
	    template: __webpack_require__(267),
	    controller: 'AppConfsListController',
	    controllerAs: 'acListCtrl',
	    authenticate: true
	  }).state('appconfs.code', {
	    url: '/code',
	    template: __webpack_require__(268),
	    controller: 'AppConfsCodeController',
	    controllerAs: 'acCodeCtrl',
	    authenticate: true
	  }).state('appconfs.show', {
	    url: '/show/:id',
	    template: __webpack_require__(269),
	    controller: 'AppConfsShowController',
	    controllerAs: 'acShowCtrl',
	    authenticate: true
	  }).state('appconfs.add', {
	    url: '/add',
	    template: __webpack_require__(270),
	    controller: 'AppConfsAddController',
	    controllerAs: 'acAddCtrl',
	    authenticate: true
	  }).state('appconfs.edit', {
	    url: '/edit/:id',
	    template: __webpack_require__(271),
	    controller: 'AppConfsEditController',
	    controllerAs: 'acEditCtrl',
	    authenticate: true
	  }).state('appconfs.import', {
	    url: '/import',
	    template: __webpack_require__(272),
	    controller: 'AppConfsImportController',
	    controllerAs: 'acImportCtrl',
	    authenticate: true
	  });
	
	  $stateProvider.state('codeappconfs', {
	    url: '/codeappconfs',
	    template: __webpack_require__(266),
	    authenticate: true
	  }).state('codeappconfs.code', {
	    url: '/code',
	    template: __webpack_require__(268),
	    controller: 'AppConfsCodeController',
	    controllerAs: 'acCodeCtrl',
	    authenticate: true
	  }).state('codeappconfs.show', {
	    url: '/show/:id',
	    template: __webpack_require__(269),
	    controller: 'AppConfsShowController',
	    controllerAs: 'acShowCtrl',
	    authenticate: true
	  }).state('codeappconfs.add', {
	    url: '/add/:type',
	    template: __webpack_require__(270),
	    controller: 'AppConfsAddController',
	    controllerAs: 'acAddCtrl',
	    authenticate: true
	  }).state('codeappconfs.edit', {
	    url: '/edit/:id',
	    template: __webpack_require__(271),
	    controller: 'AppConfsEditController',
	    controllerAs: 'acEditCtrl',
	    authenticate: true
	  });
	}];

/***/ }),
/* 266 */
144,
/* 267 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-full\">\n  <div class=\"ctrl-panel\">\n    <a ui-sref=\"appconfs.import\" class=\"btn btn-primary pull-right\" style=\"margin-right: 10px;\">导入</a>\n    <a ui-sref=\"appconfs.add\" class=\"btn btn-success pull-right\" style=\"margin-right: 10px;\">添加</a>\n    <!-- <a ui-sref=\"group.list\" class=\"btn btn-success pull-right\" style=\"margin-right: 100px;\">添加设备分组</a> -->\n    <a ui-sref=\"appconfgroups.list\" class=\"btn btn-success pull-right\" style=\"margin-right: 100px;\">添加设备类型组</a>\n    <h3>应用配置</h3>\n  </div>\n\n  <div class=\"\">\n    <table class=\"table table-striped\">\n      <thead>\n        <tr>\n          <th></th>\n          <th></th>\n          <th>应用名</th>\n          <!-- <th>型号</th> -->\n          <th>设备类型组</th>\n          <th>包名</th>\n          <!-- <th>应用版本</th>\n          <th>固件版本</th> -->\n          <th class=\"ctrl-th\"></th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"app in acListCtrl.confs\" >\n          <td>{{$index + 1}}</td>\n          <td><img src=\"{{app.icon}}\" width=\"30\"></td>\n          <td>{{app.name}}</td>\n          <!-- <td>{{app.model.join(',')}}</td> -->\n          <td>\n              <ul style=\"list-style:none;\">\n                  <li ng-repeat=\"group in app.groups\">\n                      <span >{{group.name}}</span>\n                  </li>\n              </ul>\n          </td>\n          <td>{{app.pkg}}</td>\n          <!-- <td>{{app.versionCode}}</td>\n          <td>{{app.firmwareVersion}}</td> -->\n          <td class=\"ctrl-td\">\n            <button ui-sref=\"appconfs.show({id: app._id})\" class=\"btn btn-xs btn-success\">详细</button>\n            <button ui-sref=\"appconfs.edit({id: app._id})\" class=\"btn btn-xs btn-primary\">编辑</button>\n            <button ng-click=\"acListCtrl.delete(app._id)\" class=\"btn btn-xs btn-danger\">删除</button>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 268 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-full\">\n  <div class=\"ctrl-panel\">\n    <a ui-sref=\"codeappconfs.add({type: 1})\" class=\"btn btn-success pull-right\" style=\"margin-right: 10px;\">添加</a>\n    <h3>应用配置</h3>\n  </div>\n\n  <div class=\"\">\n    <table class=\"table table-striped\">\n      <thead>\n        <tr>\n          <th></th>\n          <th></th>\n          <th>优化码</th>\n          <th>推荐人</th>\n          <th>应用名</th>\n          <th>优化名称</th>\n          <th>设备类型组</th>\n          <th>包名</th>\n          <th>创建时间</th>\n          <th>更新时间</th>\n          <th>参数相同优化码</th>\n          <th>版本</th>\n          <th class=\"ctrl-th\"></th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"app in acCodeCtrl.confs\" >\n          <td>{{$index + 1}}</td>\n          <td><img src=\"{{app.icon}}\" width=\"30\"></td>\n          <td>{{app.code}}</td>\n          <td>{{app.recommendedBy}}</td>\n          <td>{{app.name}}</td>\n          <td>{{app.optName}}</td>\n          <td>\n              <ul style=\"list-style:none;\">\n                  <li ng-repeat=\"group in app.groups\">\n                      <span >{{group.name}}</span>\n                  </li>\n              </ul>\n          </td>\n          <td>{{app.pkg}}</td>\n          <td>{{app.createdAt | date:'yyyy-MM-dd'}}</td>\n          <td>{{app.updatedAt | date:'yyyy-MM-dd'}}</td>\n          <td>{{app.sameCode.join(\",\")}}</td>\n          <td>{{app.version}}</td>\n          <td class=\"ctrl-td\">\n            <button ui-sref=\"codeappconfs.show({id: app._id})\" class=\"btn btn-xs btn-success\">详细</button>\n            <button ui-sref=\"codeappconfs.edit({id: app._id})\" class=\"btn btn-xs btn-primary\">编辑</button>\n            <button ng-click=\"acCodeCtrl.delete(app._id)\" class=\"btn btn-xs btn-danger\">删除</button>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 269 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"page-header\">\n    <a ui-sref=\"appconfs.edit({id: acShowCtrl.conf._id})\" class=\"btn btn-primary pull-right\">编辑</a>\n    <h3>配置</h3>\n  </div>\n\n  <div class=\"\">\n    <table class=\"table table-condensed\">\n      <thead>\n        <tr>\n          <th>属性</th>\n          <th>值</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr>\n          <td>图标</td>\n          <td>\n            <img src=\"{{acShowCtrl.conf.icon}}\" alt=\"\" srcset=\"\">\n            <br>\n            {{acShowCtrl.conf.icon}}\n          </td>\n        </tr>\n        <tr>\n          <td>大神码</td>\n          <td>{{acShowCtrl.conf.code}}</td>\n        </tr>\n        <tr>\n          <td>应用名</td>\n          <td>{{acShowCtrl.conf.name}}</td>\n        </tr>\n        <tr>\n          <td>推荐人</td>\n          <td>{{acShowCtrl.conf.recommendedBy}}</td>\n        </tr>\n        <tr>\n          <td>优化名</td>\n          <td>{{acShowCtrl.conf.optName}}</td>\n        </tr>\n        <tr>\n          <td style=\"line-height: 38px;\">型号</td>\n          <!-- <td>{{acShowCtrl.conf.model.join(',')}}</td> -->\n          <td>\n              <ul class=\"check-list\">\n                  <li ng-repeat=\"group in acShowCtrl.conf.groups\" class=\"\">\n                      <span>{{group.name}}</span>\n                  </li>\n              </ul>\n          </td>\n        </tr>\n        <tr>\n          <td>包名</td>\n          <td>{{acShowCtrl.conf.pkg}}</td>\n        </tr>\n        <tr>\n          <td>应用版本</td>\n          <td>{{acShowCtrl.conf.versionCode}}</td>\n        </tr>\n        <tr>\n          <td>固件版本</td>\n          <td>{{acShowCtrl.conf.firmwareVersion}}</td>\n        </tr>\n        <tr>\n          <td>配置</td>\n          <td>{{acShowCtrl.conf.config}}</td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 270 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h3>添加优化配置</h3>\n  <form>\n    <div class=\"form-group\" ng-if=\"acAddCtrl.type === 1\">\n      <label for=\"name\">大神码</label>\n      <input type=\"name\" class=\"form-control\" ng-model=\"acAddCtrl.newConf.code\" maxlength=\"4\" ng-change=\"acAddCtrl.getTmpConf()\">\n    </div>\n    <div class=\"form-group\">\n      <label for=\"name\">应用名</label>\n      <input type=\"name\" class=\"form-control\" ng-model=\"acAddCtrl.newConf.name\">\n      <p class=\"help-block waring-msg\" ng-show=\"acAddCtrl.existConfs\">\n        已配置应用: {{acAddCtrl.existConfs}}\n      </p>\n    </div>\n    <div class=\"form-group\" ng-if=\"acAddCtrl.type === 1\">\n      <label for=\"name\">推荐人</label>\n      <input type=\"name\" class=\"form-control\" ng-model=\"acAddCtrl.newConf.recommendedBy\" ng-change=\"acAddCtrl.getTmpConf()\">\n      <p class=\"help-block error-msg\" ng-show=\"acAddCtrl.isRepeat\">\n        推荐人重复\n      </p>\n    </div>\n    <div class=\"form-group\" ng-if=\"acAddCtrl.type === 1\">\n      <label for=\"name\">优化名</label>\n      <input type=\"name\" class=\"form-control\" ng-model=\"acAddCtrl.newConf.optName\">\n    </div>\n    <!-- <div class=\"form-group\">\n      <label for=\"model\">设备型号(多个型号用|分隔，如：C67ML|C87ML)</label>\n      <input type=\"model\" class=\"form-control\" ng-model=\"acAddCtrl.newConf.model\" ng-list=\"|\">\n    </div> -->\n    <div class=\"clearfix\">\n      <label for=\"models\">设备型号组</label>\n      <ul class=\"check-list\">\n        <li ng-repeat=\"group in acAddCtrl.groups\" class=\"\">\n            <input type=\"checkbox\" name=\"models[]\" value=\"{{group._id}}\" ng-checked=\"acAddCtrl.newConf.groups.indexOf(group._id) > -1\"\n                ng-click=\"acAddCtrl.toggleSelection(group._id)\">\n            <span>{{group.name}}</span>\n        </li>\n      </ul>\n    </div>\n    <div class=\"form-group\">\n      <label for=\"firmwareVersion\">固件版本</label>\n      <input type=\"firmwareVersion\" class=\"form-control\" ng-model=\"acAddCtrl.newConf.firmwareVersion\">\n    </div>\n    <div class=\"form-group\">\n      <label for=\"pkg\">包名</label>\n      <input type=\"pkg\" class=\"form-control\" ng-model=\"acAddCtrl.newConf.pkg\" required ng-change=\"acAddCtrl.getTmpConf()\">\n    </div>\n    <div class=\"form-group\">\n      <label for=\"versionCode\">应用版本</label>\n      <input type=\"number\" class=\"form-control\" ng-model=\"acAddCtrl.newConf.versionCode\">\n    </div>\n    <div>\n      <label for=\"config\">配置</label>\n      <textarea name=\"config\" class=\"form-control\" rows=\"8\" cols=\"40\" ng-model=\"acAddCtrl.newConf.config\" required></textarea>\n    </div>\n\n    <button type=\"submit\" class=\"btn btn-success\" style=\"margin-top: 20px;\" ng-click=\"acAddCtrl.add()\">保存</button>\n  </form>\n\n  <div class=\"col-xs-12\">\n    <h3>配置</h3>\n    <div class=\"clearfix\">\n      <ul class=\"check-list\">\n        <li ng-repeat=\"flag in acAddCtrl.flags\" class=\"\">\n            <input type=\"checkbox\" name=\"flags[]\" value=\"{{flag.value}}\" ng-checked=\"acAddCtrl.newConf.flags.indexOf(flag.value) > -1\"\n                ng-click=\"acAddCtrl.toggleFlagsSelection(flag.value)\">\n            <span>{{flag.label}}</span>\n        </li>\n      </ul>\n    </div>\n    <form>\n      <fieldset ng-repeat=\"group in acAddCtrl.configForm\">\n        <legend>{{group.groupTitle}}</legend>\n        <!-- <div ng-repeat=\"item in group.items\" class=\"form-group\">\n          <input type=\"checkbox\" name=\"form-control\" ng-change=\"acAddCtrl.updateConfigData()\" ng-model=\"item.enable\"><span style=\"margin-left: 10px;\">{{item.label}}</span>\n          <input ng-if=\"item.type === 'number'\" type=\"number\" min=\"{{item.range[0]}}\" max=\"{{item.range[1]}}\" ng-change=\"acAddCtrl.updateConfigData()\" name=\"form-control\" ng-disabled=\"!item.enable\" ng-model=\"item.value\">\n          <select ng-if=\"item.type === 'select'\" style=\"display: inline-block; width: 150px\" class=\"form-control\" ng-change=\"acAddCtrl.updateConfigData()\" ng-disabled=\"!item.enable\" ng-model=\"item.value\">\n            <option ng-repeat=\"val in item.range\" value=\"{{val.value}}\">{{val.label}}</option>\n          </select>\n          <button ng-if=\"item.type === 'boolean' && item.range === undefined\" type=\"button\"  ng-class=\"{ 'btn-success': item.value, 'btn-default': !item.value }\" class=\"btn\" ng-change=\"acAddCtrl.updateConfigData()\" name=\"form-control\" ng-disabled=\"!item.enable\" ng-model=\"item.value\" uib-btn-checkbox btn-checkbox-true=\"true\" btn-checkbox-false=\"false\">\n            {{!!item.value}}\n          </button>\n          <button ng-if=\"item.type === 'boolean' && item.range && item.range.length\" type=\"button\"  ng-class=\"{ 'btn-success': item.value === item.range[1], 'btn-default': (!item.value || item.value === item.range[0]) }\" class=\"btn\" ng-change=\"acEditCtrl.updateConfigData()\" name=\"form-control\" ng-disabled=\"!item.enable\" ng-model=\"item.value\" uib-btn-checkbox btn-checkbox-true=\"item.range[0]\" btn-checkbox-false=\"item.range[1]\">\n            {{(!item.value || item.value === item.range[0]) ? false : true}}\n          </button>\n        </div> -->\n\n\n        <div ng-repeat=\"item in group.items\" class=\"form-group\" ng-if=\"!item.flag || acAddCtrl.newConf.flags.indexOf(item.flag) > -1\">\n          <input type=\"checkbox\" name=\"form-control\" ng-model=\"item.enable\" ng-change=\"acAddCtrl.updateDefaultConfigData(item, item.enable)\"><span style=\"margin-left: 10px;\">{{item.label}}</span>\n          <input ng-if=\"item.type === 'number'\" type=\"number\" min=\"{{item.range[0]}}\" max=\"{{item.range[1]}}\" name=\"form-control\" ng-disabled=\"!item.enable\" ng-model=\"$parent.acAddCtrl.newAppConfig[item.key]\">\n          <select ng-if=\"item.type === 'select'\" style=\"display: inline-block; width: 150px\" class=\"form-control\" ng-disabled=\"!item.enable\" ng-model=\"$parent.acAddCtrl.newAppConfig[item.key]\">\n            <option ng-repeat=\"val in item.range\" value=\"{{val.value}}\">{{val.label}}</option>\n          </select>\n          <div ng-if=\"item.type === 'select' && $parent.acAddCtrl.newAppConfig[item.key] && item.enable\">\n            <div ng-if=\"acAddCtrl.selectedItem($parent.acAddCtrl.newAppConfig[item.key], item).associationAttributes\">\n              <div ng-repeat=\"a in acAddCtrl.selectedItem($parent.acAddCtrl.newAppConfig[item.key], item).associationAttributes\" class=\"form-group\">\n                <div ng-repeat=\"b in a.attr\" class=\"form-group\">\n                  <span style=\"margin-left: 10px;\">{{b.label}}</span>\n                  <input ng-if=\"b.type === 'number'\" type=\"number\" name=\"form-control\" ng-model=\"$parent.acAddCtrl.newAppConfig[b.key]\">\n                </div>\n              </div>\n            </div>\n          </div>\n          <button ng-if=\"item.type === 'boolean' && item.range === undefined\" type=\"button\"  ng-class=\"{ 'btn-success': $parent.acAddCtrl.newAppConfig[item.key], 'btn-default': !$parent.acAddCtrl.newAppConfig[item.key] }\" class=\"btn\" name=\"form-control\" ng-disabled=\"!item.enable\" ng-model=\"$parent.acAddCtrl.newAppConfig[item.key]\" uib-btn-checkbox btn-checkbox-true=\"true\" btn-checkbox-false=\"false\">\n            {{!!$parent.acAddCtrl.newAppConfig[item.key]}}\n          </button>\n          <button ng-if=\"item.type === 'boolean' && item.range && item.range.length\" type=\"button\"  ng-class=\"{ 'btn-success': item.value === item.range[1], 'btn-default': (!item.value || item.value === item.range[0]) }\" class=\"btn\" name=\"form-control\" ng-disabled=\"!item.enable\" ng-model=\"$parent.acAddCtrl.newAppConfig[item.key]\" uib-btn-checkbox btn-checkbox-true=\"item.range[0]\" btn-checkbox-false=\"item.range[1]\">\n            {{(!item.value || item.value === item.range[0]) ? false : true}}\n          </button>\n        </div>\n      </fieldset>\n    </form>\n  </div>\n</div>"

/***/ }),
/* 271 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h3>编辑优化配置</h3>\n<div class=\"col-xs-6\">\n  <form>\n    <div class=\"form-group\" ng-if=\"acEditCtrl.conf.type === 1\">\n      <label for=\"name\">大神码</label>\n      <input type=\"name\" class=\"form-control\" ng-model=\"acEditCtrl.conf.code\" maxlength=\"4\" ng-change=\"acEditCtrl.getTmpConf()\">\n    </div>\n    <div class=\"form-group\">\n      <label for=\"name\">应用名</label>\n      <input type=\"name\" class=\"form-control\" ng-model=\"acEditCtrl.conf.name\">\n      <p class=\"help-block waring-msg\" ng-show=\"acEditCtrl.existConfs\">\n        已配置应用: {{acEditCtrl.existConfs}}\n      </p>\n    </div>\n    <div class=\"form-group\" ng-if=\"acEditCtrl.conf.type === 1\">\n      <label for=\"name\">推荐人</label>\n      <input type=\"name\" class=\"form-control\" ng-model=\"acEditCtrl.conf.recommendedBy\" ng-change=\"acEditCtrl.getTmpConf()\">\n      <p class=\"help-block error-msg\" ng-show=\"acEditCtrl.isRepeat\">\n        推荐人重复\n      </p>\n    </div>\n    <div class=\"form-group\" ng-if=\"acEditCtrl.conf.type === 1\">\n      <label for=\"name\">优化名</label>\n      <input type=\"name\" class=\"form-control\" ng-model=\"acEditCtrl.conf.optName\">\n    </div>\n    <!-- <div class=\"form-group\">\n      <label for=\"model\">设备型号(多个型号用|分隔，如：C67ML|C87ML)</label>\n      <input type=\"model\" class=\"form-control\" ng-model=\"acEditCtrl.conf.model\" ng-list=\"|\">\n    </div> -->\n    <div class=\"clearfix\">\n        <label for=\"\">设备型号组</label>\n        <ul class=\"check-list\">\n          <li ng-repeat=\"group in acEditCtrl.groups\" class=\"\">\n              <input type=\"checkbox\" name=\"groups[]\" value=\"{{group._id}}\" ng-checked=\"acEditCtrl.conf.groups.indexOf(group._id) > -1\"\n                  ng-click=\"acEditCtrl.toggleSelection(group._id)\">\n              <span>{{group.name}}</span>\n          </li>\n        </ul>\n      </div>\n    <div class=\"form-group\">\n      <label for=\"firmwareVersion\">固件版本</label>\n      <input type=\"firmwareVersion\" class=\"form-control\" ng-model=\"acEditCtrl.conf.firmwareVersion\">\n    </div>\n    <div class=\"form-group\">\n      <label for=\"pkg\">包名</label>\n      <input type=\"pkg\" class=\"form-control\" ng-model=\"acEditCtrl.conf.pkg\" required ng-change=\"acEditCtrl.getTmpConf()\">\n    </div>\n    <div class=\"form-group\">\n      <label for=\"versionCode\">应用版本</label>\n      <input type=\"number\" class=\"form-control\" ng-model=\"acEditCtrl.conf.versionCode\">\n    </div>\n    <div>\n      <label for=\"config\">配置</label>\n      <textarea name=\"config\" class=\"form-control\" rows=\"8\" cols=\"40\" ng-model=\"acEditCtrl.conf.config\" required></textarea>\n    </div>\n\n    <button type=\"submit\" class=\"btn btn-success\" style=\"margin-top: 20px;\" ng-click=\"acEditCtrl.save()\" ng-disabled=\"acEditCtrl.isRepeat\">保存</button>\n  </form>\n</div>\n<div class=\"col-xs-6\">\n  <h3>更新图标</h3>\n  <div class=\"form-group\">\n    <label for=\"file\">图标</label>\n    <input type=\"file\" ngf-select ng-model=\"acEditCtrl.file\" name=\"file\" required ngf-model-invalid=\"errorFile\" class=\"form-control\">\n  </div>\n  <div class=\"text-center\">\n    <img src=\"{{acEditCtrl.conf.icon}}\" class=\"app-icon\">\n  </div>\n</div>\n<div class=\"col-xs-12\">\n  <h3>配置</h3>\n\n  <div class=\"clearfix\">\n    <ul class=\"check-list\">\n      <li ng-repeat=\"flag in acEditCtrl.flags\" class=\"\">\n          <input type=\"checkbox\" name=\"flags[]\" value=\"{{flag.value}}\" ng-checked=\"acEditCtrl.conf.flags.indexOf(flag.value) > -1\"\n              ng-click=\"acEditCtrl.toggleFlagsSelection(flag.value)\">\n          <span>{{flag.label}}</span>\n      </li>\n    </ul>\n  </div>\n\n  <form>\n    <fieldset ng-repeat=\"group in acEditCtrl.configForm\">\n      <legend>{{group.groupTitle}}</legend>\n      <!-- <div ng-repeat=\"item in group.items\" class=\"form-group\">\n        <input type=\"checkbox\" name=\"form-control\" ng-change=\"acEditCtrl.updateConfigData()\" ng-model=\"item.enable\"><span style=\"margin-left: 10px;\">{{item.label}}</span>\n        <input ng-if=\"item.type === 'number'\" type=\"number\" min=\"{{item.range[0]}}\" max=\"{{item.range[1]}}\" ng-change=\"acEditCtrl.updateConfigData()\" name=\"form-control\" ng-disabled=\"!item.enable\" ng-model=\"item.value\">\n        <select ng-if=\"item.type === 'select'\" style=\"display: inline-block; width: 150px\" class=\"form-control\" ng-change=\"acEditCtrl.updateConfigData()\" ng-disabled=\"!item.enable\" ng-model=\"item.value\">\n          <option ng-repeat=\"val in item.range\" value=\"{{val.value}}\">{{val.label}}</option>\n        </select>\n        <button ng-if=\"item.type === 'boolean' && item.range === undefined\" type=\"button\"  ng-class=\"{ 'btn-success': item.value, 'btn-default': !item.value }\" class=\"btn\" ng-change=\"acEditCtrl.updateConfigData()\" name=\"form-control\" ng-disabled=\"!item.enable\" ng-model=\"item.value\" uib-btn-checkbox btn-checkbox-true=\"true\" btn-checkbox-false=\"false\">\n          {{!!item.value}}\n        </button>\n        <button ng-if=\"item.type === 'boolean' && item.range && item.range.length\" type=\"button\"  ng-class=\"{ 'btn-success': item.value === item.range[1], 'btn-default': (!item.value || item.value === item.range[0]) }\" class=\"btn\" ng-change=\"acEditCtrl.updateConfigData()\" name=\"form-control\" ng-disabled=\"!item.enable\" ng-model=\"item.value\" uib-btn-checkbox btn-checkbox-true=\"item.range[0]\" btn-checkbox-false=\"item.range[1]\">\n          {{(!item.value || item.value === item.range[0]) ? false : true}}\n        </button>\n      </div> -->\n\n      <div ng-repeat=\"item in group.items\" class=\"form-group\" ng-if=\"!item.flag || acEditCtrl.conf.flags.indexOf(item.flag) > -1\">\n        <input type=\"checkbox\" name=\"form-control\" ng-model=\"item.enable\" ng-change=\"acEditCtrl.updateDefaultConfigData(item, item.enable)\"><span style=\"margin-left: 10px;\">{{item.label}}</span>\n        <input ng-if=\"item.type === 'number'\" type=\"number\" min=\"{{item.range[0]}}\" max=\"{{item.range[1]}}\" name=\"form-control\" ng-disabled=\"!item.enable\" ng-model=\"$parent.acEditCtrl.newAppConfig[item.key]\">\n        <select ng-if=\"item.type === 'select'\" style=\"display: inline-block; width: 150px\" class=\"form-control\" ng-disabled=\"!item.enable\" ng-model=\"$parent.acEditCtrl.newAppConfig[item.key]\">\n          <option ng-repeat=\"val in item.range\" value=\"{{val.value}}\">{{val.label}}</option>\n        </select>\n        <div ng-if=\"item.type === 'select' && $parent.acEditCtrl.newAppConfig[item.key] && item.enable\">\n          <div ng-if=\"acEditCtrl.selectedItem($parent.acEditCtrl.newAppConfig[item.key], item).associationAttributes\">\n            <div ng-repeat=\"a in acEditCtrl.selectedItem($parent.acEditCtrl.newAppConfig[item.key], item).associationAttributes\" class=\"form-group\">\n              <div ng-repeat=\"b in a.attr\" class=\"form-group\">\n                <span style=\"margin-left: 10px;\">{{b.label}}</span>\n                <input ng-if=\"b.type === 'number'\" type=\"number\" name=\"form-control\" ng-model=\"$parent.acEditCtrl.newAppConfig[b.key]\">\n              </div>\n            </div>\n          </div>\n        </div>\n        <button ng-if=\"item.type === 'boolean' && item.range === undefined\" type=\"button\"  ng-class=\"{ 'btn-success': $parent.acEditCtrl.newAppConfig[item.key], 'btn-default': !$parent.acEditCtrl.newAppConfig[item.key] }\" class=\"btn\" name=\"form-control\" ng-disabled=\"!item.enable\" ng-model=\"$parent.acEditCtrl.newAppConfig[item.key]\" uib-btn-checkbox btn-checkbox-true=\"true\" btn-checkbox-false=\"false\">\n          {{!!$parent.acEditCtrl.newAppConfig[item.key]}}\n        </button>\n        <button ng-if=\"item.type === 'boolean' && item.range && item.range.length\" type=\"button\"  ng-class=\"{ 'btn-success': item.value === item.range[1], 'btn-default': (!item.value || item.value === item.range[0]) }\" class=\"btn\" name=\"form-control\" ng-disabled=\"!item.enable\" ng-model=\"$parent.acEditCtrl.newAppConfig[item.key]\" uib-btn-checkbox btn-checkbox-true=\"item.range[0]\" btn-checkbox-false=\"item.range[1]\">\n          {{(!item.value || item.value === item.range[0]) ? false : true}}\n        </button>\n      </div>\n    </fieldset>\n  </form>\n</div>\n</div>\n"

/***/ }),
/* 272 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h3>导入</h3>\n  <form>\n    <div class=\"form-group\">\n      <label for=\"file\" class=\"text-danger\">文件 <span>(必需)</span></label>\n      <input type=\"file\" ngf-select ng-model=\"acImportCtrl.file\" name=\"file\" required ngf-model-invalid=\"errorFile\" class=\"form-control\">\n    </div>\n    <!-- <div class=\"form-group\">\n      <label for=\"model\">设备型号(多个型号用|分隔，如：C67ML|C87ML)</label>\n      <input type=\"model\" class=\"form-control\" ng-model=\"acImportCtrl.newConf.model\" ng-list=\"|\">\n    </div> -->\n    <div class=\"clearfix\">\n        <label for=\"models\">设备型号</label>\n        <ul class=\"check-list\">\n          <li ng-repeat=\"group in acImportCtrl.groups\" class=\"\">\n              <input type=\"checkbox\" name=\"models[]\" value=\"{{group._id}}\" ng-checked=\"acImportCtrl.newConf.groups.indexOf(group._id) > -1\"\n                  ng-click=\"acImportCtrl.toggleSelection(group._id)\">\n              <span>{{group.name}}</span>\n          </li>\n        </ul>\n      </div>\n    <div class=\"form-group\">\n      <label for=\"firmwareVersion\">固件版本</label>\n      <input type=\"firmwareVersion\" class=\"form-control\" ng-model=\"acImportCtrl.newConf.firmwareVersion\">\n    </div>\n    \n    <button type=\"submit\" class=\"btn btn-success\" ng-click=\"acImportCtrl.upload(acImportCtrl.file)\">保存</button>\n  </form>\n</div>"

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _list = __webpack_require__(274);
	
	var _list2 = _interopRequireDefault(_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('onyxReadingRoomApp.appconfs.list', []).controller('AppConfsListController', _list2.default).name;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListController = function () {
	
	  /*@ngInject*/
	  ListController.$inject = ['$http', '$state'];
	  function ListController($http, $state) {
	    (0, _classCallCheck3.default)(this, ListController);
	
	    this.$http = $http;
	    this.$state = $state;
	  }
	
	  (0, _createClass3.default)(ListController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getConfs();
	    }
	  }, {
	    key: 'getConfs',
	    value: function getConfs() {
	      var _this = this;
	
	      this.$http.get('/api/AppConfs', { params: { type: 0 } }).then(function (response) {
	        _this.confs = response.data;
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(id) {
	      var _this2 = this;
	
	      if (confirm("确定？")) {
	        this.$http.delete('api/AppConfs/' + id).then(function (response) {
	          _this2.getConfs();
	        });
	      }
	    }
	  }]);
	  return ListController;
	}();
	
	exports.default = ListController;

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _show = __webpack_require__(276);
	
	var _show2 = _interopRequireDefault(_show);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('onyxReadingRoomApp.appconfs.show', []).controller('AppConfsShowController', _show2.default).name;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ShowController = function () {
	
	  /*@ngInject*/
	  ShowController.$inject = ['$http', '$stateParams'];
	  function ShowController($http, $stateParams) {
	    (0, _classCallCheck3.default)(this, ShowController);
	
	    this.$http = $http;
	    this.$stateParams = $stateParams;
	  }
	
	  (0, _createClass3.default)(ShowController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getConf(this.$stateParams.id);
	    }
	  }, {
	    key: 'getConf',
	    value: function getConf(id) {
	      var _this = this;
	
	      this.$http.get('/api/AppConfs/' + id).then(function (response) {
	        _this.conf = response.data;
	      });
	    }
	  }]);
	  return ShowController;
	}();
	
	exports.default = ShowController;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _add = __webpack_require__(278);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('onyxReadingRoomApp.appconfs.add', []).controller('AppConfsAddController', _add2.default).name;

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(279);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _assign = __webpack_require__(200);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getIterator2 = __webpack_require__(168);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _stringify = __webpack_require__(157);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(282);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddController = function () {
	
	  /*@ngInject*/
	  AddController.$inject = ['$http', '$state', '$stateParams', '$scope', '$parse'];
	  function AddController($http, $state, $stateParams, $scope, $parse) {
	    (0, _classCallCheck3.default)(this, AddController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$scope = $scope;
	    this.$parse = $parse;
	    this.newConf = {
	      groups: []
	    };
	
	    this.newAppConfig = {};
	    this.appConfig = {};
	
	    this.configForm = [{
	      groupTitle: '',
	      items: [{
	        key: 'dpiConfig.dpi',
	        label: 'DPI设置',
	        enable: false,
	        value: 350,
	        range: [200, 640],
	        type: 'number'
	      }, {
	        key: 'dpiConfig.enable',
	        label: 'APP原始DPI（关闭DPI配置）',
	        enable: false,
	        type: 'boolean',
	        value: false
	      }, {
	        key: 'extraConfig.allowSplashScreen',
	        label: '移除启动动画',
	        enable: false,
	        type: 'boolean',
	        value: false
	      }, {
	        key: 'extraConfig.forceFullScreen',
	        label: '强制全屏',
	        enable: false,
	        type: 'boolean',
	        value: false
	      }, {
	        key: 'extraConfig.fullPMAccess',
	        label: '后台持续运行',
	        enable: false,
	        type: 'boolean',
	        value: false
	      }, {
	        key: 'globalActivityConfig.displayConfig.enhance',
	        label: '显示增强',
	        enable: false,
	        type: 'boolean',
	        value: false
	      }, {
	        key: 'globalActivityConfig.displayConfig.ditherThreshold',
	        label: '高对比度',
	        enable: false,
	        value: 255,
	        range: [128, 255],
	        type: 'boolean'
	      }, {
	        key: 'globalActivityConfig.noteConfig.enable',
	        label: '手写优化',
	        enable: false,
	        type: 'boolean',
	        value: false
	      }, {
	        key: 'globalActivityConfig.noteConfig.globalStrokeStyle.strokeWidth',
	        label: '线宽',
	        enable: false,
	        value: 3,
	        range: [0.5, 20],
	        type: 'number'
	      }, {
	        key: 'globalActivityConfig.paintConfig.antiAlisingType',
	        label: '消除字体锯齿',
	        enable: false,
	        value: 0,
	        range: [0, 100],
	        type: 'number'
	      }, {
	        key: 'globalActivityConfig.paintConfig.fillContrast',
	        label: '背景颜色',
	        enable: false,
	        value: 1,
	        range: [0, 255],
	        type: 'number'
	      }, {
	        key: 'globalActivityConfig.paintConfig.iconContrast',
	        label: '图标颜色',
	        enable: false,
	        value: 1,
	        range: [0, 255],
	        type: 'number'
	      }, {
	        key: 'globalActivityConfig.paintConfig.imgEAC',
	        label: '封面颜色',
	        enable: false,
	        type: 'boolean',
	        value: false
	      }, {
	        key: 'globalActivityConfig.paintConfig.textBold',
	        label: '标题字体加粗',
	        enable: false,
	        type: 'boolean',
	        value: false
	      }, {
	        key: 'globalActivityConfig.paintConfig.textEACType',
	        label: '文字描边',
	        enable: false,
	        value: 0,
	        range: [0, 3],
	        type: 'number'
	      }, {
	        key: 'globalActivityConfig.refreshConfig.animationDuration',
	        label: '动画过滤时间',
	        enable: false,
	        value: 50,
	        range: [0, 3000],
	        type: 'number'
	      }, {
	        key: 'globalActivityConfig.refreshConfig.antiFlicker',
	        label: '防闪烁',
	        enable: false,
	        value: 10,
	        range: [0, 32],
	        type: 'number'
	      }, {
	        key: 'globalActivityConfig.refreshConfig.gcInterval',
	        label: '按点击次数全刷',
	        enable: false,
	        value: 20,
	        range: [0, 50],
	        type: 'number'
	      }, {
	        key: 'globalActivityConfig.refreshConfig.useGCForNewSurface',
	        label: '页面切换时全刷',
	        enable: false,
	        type: 'boolean',
	        value: false
	      }, {
	        key: 'globalCSSConfig.fontBold',
	        label: '网页文字加粗',
	        enable: false,
	        type: 'boolean',
	        value: false
	      }, {
	        key: 'globalCSSConfig.fontColor',
	        label: '网页文字颜色',
	        enable: false,
	        value: 0,
	        range: [0, 255],
	        type: 'number'
	      }, {
	        key: 'globalCSSConfig.fontSize',
	        label: '网页字号',
	        enable: false,
	        value: 100,
	        range: [100, 120],
	        type: 'number'
	      }, {
	        key: 'keyboardConfig.pageKeyMode',
	        label: '侧键定义',
	        enable: false,
	        value: '',
	        range: [{
	          label: "翻页",
	          value: 0
	        }, {
	          label: "音量",
	          value: 1
	        }, {
	          label: "滚屏手势",
	          value: 2
	        }],
	        type: 'select'
	      }, {
	        key: 'rotationConfig.enable',
	        label: '强制旋转',
	        enable: false,
	        type: 'boolean',
	        value: false
	      }, {
	        key: 'scrollArgs.endYPercent',
	        label: '结束位置',
	        enable: false,
	        value: 0.8,
	        range: [0, 100],
	        type: 'number'
	      }, {
	        key: 'scrollArgs.startYPercent',
	        label: '起始位置',
	        enable: false,
	        value: 0.2,
	        range: [0, 100],
	        type: 'number'
	      }, {
	        key: 'scrollArgs.startYPercent',
	        label: '起始位置',
	        enable: false,
	        value: 0.2,
	        range: [0, 100],
	        type: 'number'
	      }, {
	        key: 'scrollArgs.startYPercent',
	        label: '起始位置',
	        enable: false,
	        value: 0.2,
	        range: [0, 100],
	        type: 'number'
	      }, {
	        key: 'globalActivityConfig.displayConfig.contrast',
	        label: '深色增强',
	        enable: false,
	        type: 'number'
	      }, {
	        key: 'globalActivityConfig.displayConfig.monoLevel',
	        flag: 'black_white_screen',
	        label: '浅色过滤',
	        enable: false,
	        type: 'number'
	      }, {
	        key: 'globalActivityConfig.displayConfig.cfaColorBrightness',
	        flag: 'color_screen',
	        label: '色彩亮度',
	        enable: false,
	        type: 'number'
	      }, {
	        key: 'globalActivityConfig.displayConfig.cfaColorSaturation',
	        flag: 'color_screen',
	        label: '鲜艳度增强',
	        enable: false,
	        type: 'number'
	      }, {
	        key: 'globalActivityConfig.refreshConfig.refreshModeIndex',
	        label: '刷新模式',
	        enable: false,
	        value: '',
	        range: [{
	          label: "净清",
	          value: 'refresh_mode_1'
	        }, {
	          label: "标准",
	          value: 'refresh_mode_2'
	        }, {
	          label: "极速",
	          value: 'refresh_mode_3'
	        }],
	        type: 'select'
	      }]
	    }], this.specialConfig = {
	      updateModePad: {
	        '1': {
	          "turbo": 0,
	          "updateMode": 0
	        },
	        '2': {
	          "turbo": 2,
	          "updateMode": 2
	        },
	        '3': {
	          "turbo": 4,
	          "updateMode": 2
	        },
	        '4': {
	          "turbo": 5,
	          "updateMode": 2
	        },
	        '5': {
	          "turbo": 0,
	          "updateMode": 3
	        }
	      },
	      updateModePadEink: {
	        '1': {
	          "turbo": 0,
	          "updateMode": 0
	        },
	        '2': {
	          "turbo": 0,
	          "updateMode": 2
	        },
	        '3': {
	          "turbo": 2,
	          "updateMode": 2
	        },
	        '4': {
	          "turbo": 3,
	          "updateMode": 2
	        },
	        '5': {
	          "turbo": 0,
	          "updateMode": 3
	        }
	      },
	      updateModePhone: {
	        '1': {
	          "turbo": 0,
	          "updateMode": 0
	        },
	        '2': {
	          "turbo": 0,
	          "updateMode": 2
	        },
	        '3': {
	          "turbo": 1,
	          "updateMode": 2
	        },
	        '4': {
	          "turbo": 2,
	          "updateMode": 2
	        },
	        '5': {
	          "turbo": 0,
	          "updateMode": 3
	        }
	      },
	      updateModeEink: {
	        '1': {
	          updateMode: 0
	        },
	        '2': {
	          updateMode: 3
	        },
	        '3': {
	          updateMode: 2
	        },
	        '4': {
	          updateMode: 1
	        },
	        '5': {
	          updateMode: 4
	        }
	      }
	    };
	    this.tmpConf = null;
	    this.isRepeat = false;
	    this.type = 0;
	    this.existConfs = null;
	
	    this.flags = [{
	      label: '彩屏',
	      value: 'color_screen'
	    }, {
	      label: '黑白屏',
	      value: 'black_white_screen'
	    }, {
	      label: '手机',
	      value: 'phone'
	    }, {
	      label: '平板',
	      value: 'pad'
	    }];
	  }
	
	  (0, _createClass3.default)(AddController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.type = this.$stateParams.type ? +this.$stateParams.type : this.type;
	      this.getList();
	
	      this.$scope.$watchCollection('acAddCtrl.newAppConfig', function (newVal, oldVal) {
	        _this.updateAppConfig();
	      });
	    }
	  }, {
	    key: 'transformConfigArray',
	    value: function transformConfigArray(configArray) {
	      var _this2 = this;
	
	      var transformedObject = {};
	
	      configArray.forEach(function (config) {
	        if (!config.enable) {
	          return;
	        }
	        var keys = config.key.split('.');
	        var currentLevel = transformedObject;
	
	        for (var i = 0; i < keys.length; i++) {
	          if (i === keys.length - 1) {
	            if (_this2.specialConfig[keys[i]] && _this2.specialConfig[keys[i]][config.value]) {
	              var tmpObj = _this2.specialConfig[keys[i]][config.value];
	              for (var key in tmpObj) {
	                currentLevel[key] = tmpObj[key];
	              }
	              currentLevel['rename'] = keys[i];
	            } else {
	              currentLevel[keys[i]] = config.value;
	            }
	          } else {
	            currentLevel[keys[i]] = currentLevel[keys[i]] || {};
	            currentLevel = currentLevel[keys[i]];
	          }
	        }
	      });
	
	      return transformedObject;
	    }
	  }, {
	    key: 'updateConfigData',
	    value: function updateConfigData() {
	      var obj = {};
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(this.configForm), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var group = _step.value;
	
	          var res = this.transformConfigArray(group.items);
	          obj = (0, _assign2.default)(obj, res);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      if ((0, _stringify2.default)(obj) !== this.newConf.config) {
	        this.newConf.config = (0, _stringify2.default)(obj);
	      }
	    }
	  }, {
	    key: 'updateDefaultConfigData',
	    value: function updateDefaultConfigData(data, checked) {
	      if (!checked) {
	        delete this.newAppConfig[data.key];
	      } else {
	        if (data.value !== '' || data.value !== undefined) {
	          this.newAppConfig[data.key] = data.value;
	        }
	      }
	      this.updateAppConfig();
	    }
	  }, {
	    key: 'updateAppConfig',
	    value: function updateAppConfig() {
	      this.appConfig = {};
	      for (var key in this.newAppConfig) {
	        this.setNestedProperty(key, this.newAppConfig[key]);
	      }
	      if ((0, _keys2.default)(this.appConfig).length) {
	        this.newConf.config = (0, _stringify2.default)(this.appConfig, null, 4);
	      } else {
	        this.newConf.config = '';
	      }
	    }
	  }, {
	    key: 'setNestedProperty',
	    value: function setNestedProperty(path, value) {
	      var setter = this.$parse(path).assign;
	
	      if (angular.isFunction(setter)) {
	        this.ensurePathExists(this.appConfig, path);
	
	        setter(this.appConfig, value);
	      } else {
	        console.error("不能设置嵌套属性：", path);
	      }
	    }
	  }, {
	    key: 'getNestedProperty',
	    value: function getNestedProperty(path) {
	      var getter = this.$parse(path);
	      try {
	        return getter(this.newAppConfig);
	      } catch (error) {
	        this.setNestedProperty(path, undefined);
	        return undefined;
	      }
	    }
	  }, {
	    key: 'ensurePathExists',
	    value: function ensurePathExists(obj, path) {
	      var parts = path.split('.');
	      var current = obj;
	
	      for (var i = 0; i < parts.length - 1; i++) {
	        var part = parts[i];
	
	        if (current[part] === undefined || current[part] === null) {
	          current[part] = {};
	        }
	
	        current = current[part];
	      }
	    }
	  }, {
	    key: 'selectedItem',
	    value: function selectedItem(key, data) {
	      var item = data.range.find(function (a) {
	        return a.value === key;
	      });
	      if (!item) {
	        return;
	      }
	      if (item.associationAttributes) {
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = (0, _getIterator3.default)(item.associationAttributes), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var attrItem = _step2.value;
	            var _iteratorNormalCompletion3 = true;
	            var _didIteratorError3 = false;
	            var _iteratorError3 = undefined;
	
	            try {
	              for (var _iterator3 = (0, _getIterator3.default)(attrItem.attr), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                var a = _step3.value;
	
	                this.newAppConfig[a.key] = a.value;
	              }
	            } catch (err) {
	              _didIteratorError3 = true;
	              _iteratorError3 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                  _iterator3.return();
	                }
	              } finally {
	                if (_didIteratorError3) {
	                  throw _iteratorError3;
	                }
	              }
	            }
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	              _iterator2.return();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	      }
	      return item;
	    }
	  }, {
	    key: 'add',
	    value: function add() {
	      var _this3 = this;
	
	      this.newConf.type = this.type;
	      this.$http.post('api/AppConfs', this.newConf).then(function (response) {
	        if (_this3.type) {
	          _this3.$state.go('codeappconfs');
	        } else {
	          _this3.$state.go('appconfs');
	        }
	      });
	    }
	  }, {
	    key: 'getList',
	    value: function getList() {
	      var _this4 = this;
	
	      this.$http.get('/api/AppConfGroups').then(function (res) {
	        _this4.groups = res.data;
	      });
	    }
	  }, {
	    key: 'toggleSelection',
	    value: function toggleSelection(id) {
	      var idx = this.newConf.groups.indexOf(id);
	      if (idx > -1) {
	        this.newConf.groups.splice(idx, 1);
	      } else {
	        this.newConf.groups.push(id);
	      }
	    }
	  }, {
	    key: 'toggleFlagsSelection',
	    value: function toggleFlagsSelection(val) {
	      if (!this.newConf.flags) {
	        this.newConf.flags = [];
	      }
	      var flags = this.newConf.flags.indexOf(val);
	      if (flags > -1) {
	        this.newConf.flags.splice(flags, 1);
	      } else {
	        this.newConf.flags.push(val);
	      }
	    }
	  }, {
	    key: 'getTmpConf',
	    value: function getTmpConf() {
	      var _this5 = this;
	
	      var code = this.newConf.code;
	      var pkg = this.newConf.pkg;
	      var recommendedBy = this.newConf.recommendedBy;
	
	      var params = {};
	
	      if (code.length === 4) {
	        params.code = code;
	      }
	
	      if (pkg && recommendedBy) {
	        params.pkg = pkg;
	        params.recommendedBy = recommendedBy;
	      }
	
	      if ((0, _keys2.default)(params).length === 0) {
	        return;
	      }
	
	      this.$http.post('/api/AppConfs/getConf', params).then(function (response) {
	        _this5.checkRecommendedByRepeat(response.data);
	      }).catch(function (err) {
	        console.log(err);
	        _this5.tmpConf = null;
	      });
	    }
	  }, {
	    key: 'checkRecommendedByRepeat',
	    value: function checkRecommendedByRepeat(conf) {
	      var confByCode = conf.findByCode;
	      var confByRecommend = conf.findByRecommend;
	
	      if (confByCode && confByCode.length) {
	        this.newConf.recommendedBy = confByCode[0].recommendedBy;
	        this.existConfs = confByCode.map(function (item) {
	          return item.name;
	        }).join(',');
	      }
	
	      if (confByRecommend && confByRecommend.code !== this.newConf.code && confByRecommend.pkg === this.newConf.pkg && confByRecommend.recommendedBy === this.newConf.recommendedBy) {
	        this.isRepeat = true;
	      } else {
	        this.isRepeat = false;
	      }
	    }
	  }]);
	  return AddController;
	}();
	
	exports.default = AddController;

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(280), __esModule: true };

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(281);
	module.exports = __webpack_require__(8).Object.keys;


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(51);
	var $keys = __webpack_require__(35);
	
	__webpack_require__(75)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 282 */,
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _edit = __webpack_require__(284);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('onyxReadingRoomApp.appconfs.edit', []).controller('AppConfsEditController', _edit2.default).name;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(200);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _stringify = __webpack_require__(157);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _values = __webpack_require__(285);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _keys = __webpack_require__(279);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _toConsumableArray2 = __webpack_require__(110);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getIterator2 = __webpack_require__(168);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddConfController = function () {
	
	  /*@ngInject*/
	  AddConfController.$inject = ['$http', '$state', '$stateParams', '$scope', 'toaster', 'Upload', '$parse'];
	  function AddConfController($http, $state, $stateParams, $scope, toaster, Upload, $parse) {
	    (0, _classCallCheck3.default)(this, AddConfController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$scope = $scope;
	    this.toaster = toaster;
	    this.Upload = Upload;
	    this.$parse = $parse;
	    this.configForm = [{
	      groupTitle: '',
	      items: [{
	        key: 'dpiConfig.dpi',
	        label: 'DPI设置',
	        enable: false,
	        value: 350,
	        range: [200, 640],
	        type: 'number'
	      }, {
	        key: 'dpiConfig.enable',
	        label: 'APP原始DPI（关闭DPI配置）',
	        enable: false,
	        type: 'boolean',
	        value: false
	      }, {
	        key: 'extraConfig.allowSplashScreen',
	        label: '移除启动动画',
	        enable: false,
	        type: 'boolean',
	        value: false
	      }, {
	        key: 'extraConfig.forceFullScreen',
	        label: '强制全屏',
	        enable: false,
	        type: 'boolean',
	        value: false
	      }, {
	        key: 'extraConfig.fullPMAccess',
	        label: '后台持续运行',
	        enable: false,
	        type: 'boolean',
	        value: false
	      }, {
	        key: 'globalActivityConfig.displayConfig.enhance',
	        label: '显示增强',
	        enable: false,
	        type: 'boolean',
	        value: false
	      }, {
	        key: 'globalActivityConfig.displayConfig.ditherThreshold',
	        label: '高对比度',
	        enable: false,
	        value: 255,
	        range: [128, 255],
	        type: 'boolean'
	      }, {
	        key: 'globalActivityConfig.noteConfig.enable',
	        label: '手写优化',
	        enable: false,
	        type: 'boolean',
	        value: false
	      }, {
	        key: 'globalActivityConfig.noteConfig.globalStrokeStyle.strokeWidth',
	        label: '线宽',
	        enable: false,
	        value: 3,
	        range: [0.5, 20],
	        type: 'number'
	      }, {
	        key: 'globalActivityConfig.paintConfig.antiAlisingType',
	        label: '消除字体锯齿',
	        enable: false,
	        value: 0,
	        range: [0, 100],
	        type: 'number'
	      }, {
	        key: 'globalActivityConfig.paintConfig.fillContrast',
	        label: '背景颜色',
	        enable: false,
	        value: 1,
	        range: [0, 255],
	        type: 'number'
	      }, {
	        key: 'globalActivityConfig.paintConfig.iconContrast',
	        label: '图标颜色',
	        enable: false,
	        value: 1,
	        range: [0, 255],
	        type: 'number'
	      }, {
	        key: 'globalActivityConfig.paintConfig.imgEAC',
	        label: '封面颜色',
	        enable: false,
	        type: 'boolean',
	        value: false
	      }, {
	        key: 'globalActivityConfig.paintConfig.textBold',
	        label: '标题字体加粗',
	        enable: false,
	        type: 'boolean',
	        value: false
	      }, {
	        key: 'globalActivityConfig.paintConfig.textEACType',
	        label: '文字描边',
	        enable: false,
	        value: 0,
	        range: [0, 3],
	        type: 'number'
	      }, {
	        key: 'globalActivityConfig.refreshConfig.animationDuration',
	        label: '动画过滤时间',
	        enable: false,
	        value: 50,
	        range: [0, 3000],
	        type: 'number'
	      }, {
	        key: 'globalActivityConfig.refreshConfig.antiFlicker',
	        label: '防闪烁',
	        enable: false,
	        value: 10,
	        range: [0, 32],
	        type: 'number'
	      }, {
	        key: 'globalActivityConfig.refreshConfig.gcInterval',
	        label: '按点击次数全刷',
	        enable: false,
	        value: 20,
	        range: [0, 50],
	        type: 'number'
	      }, {
	        key: 'globalActivityConfig.refreshConfig.useGCForNewSurface',
	        label: '页面切换时全刷',
	        enable: false,
	        type: 'boolean',
	        value: false
	      }, {
	        key: 'globalCSSConfig.fontBold',
	        label: '网页文字加粗',
	        enable: false,
	        type: 'boolean',
	        value: false
	      }, {
	        key: 'globalCSSConfig.fontColor',
	        label: '网页文字颜色',
	        enable: false,
	        value: 0,
	        range: [0, 255],
	        type: 'number'
	      }, {
	        key: 'globalCSSConfig.fontSize',
	        label: '网页字号',
	        enable: false,
	        value: 100,
	        range: [100, 120],
	        type: 'number'
	      }, {
	        key: 'keyboardConfig.pageKeyMode',
	        label: '侧键定义',
	        enable: false,
	        value: '',
	        range: [{
	          label: "翻页",
	          value: 0
	        }, {
	          label: "音量",
	          value: 1
	        }, {
	          label: "滚屏手势",
	          value: 2
	        }],
	        type: 'select'
	      }, {
	        key: 'rotationConfig.enable',
	        label: '强制旋转',
	        enable: false,
	        type: 'boolean',
	        value: false
	      }, {
	        key: 'scrollArgs.endYPercent',
	        label: '结束位置',
	        enable: false,
	        value: 0.8,
	        range: [0, 100],
	        type: 'number'
	      }, {
	        key: 'scrollArgs.startYPercent',
	        label: '起始位置',
	        enable: false,
	        value: 0.2,
	        range: [0, 100],
	        type: 'number'
	      }, {
	        key: 'globalActivityConfig.displayConfig.contrast',
	        label: '深色增强',
	        enable: false,
	        type: 'number'
	      }, {
	        key: 'globalActivityConfig.displayConfig.monoLevel',
	        flag: 'black_white_screen',
	        label: '浅色过滤',
	        enable: false,
	        type: 'number'
	      }, {
	        key: 'globalActivityConfig.displayConfig.cfaColorBrightness',
	        flag: 'color_screen',
	        label: '色彩亮度',
	        enable: false,
	        type: 'number'
	      }, {
	        key: 'globalActivityConfig.displayConfig.cfaColorSaturation',
	        flag: 'color_screen',
	        label: '鲜艳度增强',
	        enable: false,
	        type: 'number'
	      }, {
	        key: 'globalActivityConfig.refreshConfig.refreshModeIndex',
	        label: '刷新模式',
	        enable: false,
	        value: '',
	        range: [{
	          label: "净清",
	          value: 'refresh_mode_1'
	        }, {
	          label: "标准",
	          value: 'refresh_mode_2'
	        }, {
	          label: "极速",
	          value: 'refresh_mode_3'
	        }],
	        type: 'select'
	      }]
	    }], this.specialConfig = {
	      updateModePad: {
	        '1': {
	          "turbo": 0,
	          "updateMode": 0
	        },
	        '2': {
	          "turbo": 2,
	          "updateMode": 2
	        },
	        '3': {
	          "turbo": 4,
	          "updateMode": 2
	        },
	        '4': {
	          "turbo": 5,
	          "updateMode": 2
	        },
	        '5': {
	          "turbo": 0,
	          "updateMode": 3
	        }
	      },
	      updateModePadEink: {
	        '1': {
	          "turbo": 0,
	          "updateMode": 0
	        },
	        '2': {
	          "turbo": 0,
	          "updateMode": 2
	        },
	        '3': {
	          "turbo": 2,
	          "updateMode": 2
	        },
	        '4': {
	          "turbo": 3,
	          "updateMode": 2
	        },
	        '5': {
	          "turbo": 0,
	          "updateMode": 3
	        }
	      },
	      updateModePhone: {
	        '1': {
	          "turbo": 0,
	          "updateMode": 0
	        },
	        '2': {
	          "turbo": 0,
	          "updateMode": 2
	        },
	        '3': {
	          "turbo": 1,
	          "updateMode": 2
	        },
	        '4': {
	          "turbo": 2,
	          "updateMode": 2
	        },
	        '5': {
	          "turbo": 0,
	          "updateMode": 3
	        }
	      },
	      updateModeEink: {
	        '1': {
	          updateMode: 0
	        },
	        '2': {
	          updateMode: 3
	        },
	        '3': {
	          updateMode: 2
	        },
	        '4': {
	          updateMode: 1
	        },
	        '5': {
	          updateMode: 4
	        }
	      }
	    };
	    this.tmpConf = null;
	    this.isRepeat = false;
	    this.existConfs = null;
	    this.newAppConfig = {};
	    this.appConfig = {};
	
	    this.flags = [{
	      label: '彩屏',
	      value: 'color_screen'
	    }, {
	      label: '黑白屏',
	      value: 'black_white_screen'
	    }, {
	      label: '手机',
	      value: 'phone'
	    }, {
	      label: '平板',
	      value: 'pad'
	    }];
	  }
	
	  (0, _createClass3.default)(AddConfController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.getConf(this.$stateParams.id);
	      this.getList();
	
	      this.$scope.$watch('acEditCtrl.file', function (file) {
	        if (file !== undefined && file !== null) {
	          _this.uploadIcon(file);
	        }
	      });
	
	      this.$scope.$watchCollection('acEditCtrl.newAppConfig', function (newVal, oldVal) {
	        _this.updateAppConfig();
	      });
	    }
	  }, {
	    key: 'transformConfigArray',
	    value: function transformConfigArray(configArray) {
	      var _this2 = this;
	
	      var transformedObject = {};
	
	      configArray.forEach(function (config) {
	        if (!config.enable) {
	          return;
	        }
	        var keys = config.key.split('.');
	        var currentLevel = transformedObject;
	
	        for (var i = 0; i < keys.length; i++) {
	          if (i === keys.length - 1) {
	            if (_this2.specialConfig[keys[i]] && _this2.specialConfig[keys[i]][config.value]) {
	              var tmpObj = _this2.specialConfig[keys[i]][config.value];
	              for (var key in tmpObj) {
	                currentLevel[key] = tmpObj[key];
	              }
	              currentLevel['rename'] = keys[i];
	            } else {
	              currentLevel[keys[i]] = config.value;
	            }
	          } else {
	            currentLevel[keys[i]] = currentLevel[keys[i]] || {};
	            currentLevel = currentLevel[keys[i]];
	          }
	        }
	      });
	
	      return transformedObject;
	    }
	  }, {
	    key: 'updateConfigArray',
	    value: function updateConfigArray(configArray, nestedObject) {
	      this.appConfig = nestedObject;
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(configArray), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var item = _step.value;
	
	          var val = this.getNestedProperty(item.key);
	          if (val) {
	            item.enable = true;
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return configArray;
	    }
	  }, {
	    key: 'updateConfigArray1',
	    value: function updateConfigArray1(configArray, nestedObject) {
	      var _this3 = this;
	
	      var findValue = function findValue(keys, obj) {
	        return keys.reduce(function (o, k) {
	          return o && o[k] !== undefined ? o[k] : undefined;
	        }, obj);
	      };
	
	      var findSpecialValue = function findSpecialValue(keys, obj) {
	        var renameKeys = [].concat((0, _toConsumableArray3.default)(keys));
	        renameKeys[renameKeys.length - 1] = 'rename';
	        var exist = findValue(renameKeys, obj);
	        if (!exist || exist !== keys[keys.length - 1]) {
	          return undefined;
	        }
	        var specialConfig = _this3.specialConfig[keys[keys.length - 1]];
	        var subKeys = (0, _keys2.default)((0, _values2.default)(specialConfig)[0]);
	        var tmpObj = {};
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = (0, _getIterator3.default)(subKeys), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var key = _step2.value;
	
	            var tmpKeys = [].concat((0, _toConsumableArray3.default)(keys));
	            tmpKeys[tmpKeys.length - 1] = key;
	            var value = findValue(tmpKeys, obj);
	            tmpObj[key] = value;
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	              _iterator2.return();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	
	        var res = void 0;
	        var _iteratorNormalCompletion3 = true;
	        var _didIteratorError3 = false;
	        var _iteratorError3 = undefined;
	
	        try {
	          for (var _iterator3 = (0, _getIterator3.default)((0, _keys2.default)(specialConfig)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	            var _key = _step3.value;
	
	            if (_.isEqual(specialConfig[_key], tmpObj)) {
	              res = _key;
	              break;
	            }
	          }
	        } catch (err) {
	          _didIteratorError3 = true;
	          _iteratorError3 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion3 && _iterator3.return) {
	              _iterator3.return();
	            }
	          } finally {
	            if (_didIteratorError3) {
	              throw _iteratorError3;
	            }
	          }
	        }
	
	        return res;
	      };
	
	      configArray.forEach(function (config) {
	        var keys = config.key.split('.');
	        var value = void 0;
	        if (_this3.specialConfig[keys[keys.length - 1]]) {
	          value = findSpecialValue(keys, nestedObject);
	        } else {
	          value = findValue(keys, nestedObject);
	        }
	
	        if (value !== undefined) {
	          config.enable = true;
	        }
	      });
	
	      return configArray;
	    }
	  }, {
	    key: 'updateConfigData',
	    value: function updateConfigData() {
	      var obj = {};
	      var _iteratorNormalCompletion4 = true;
	      var _didIteratorError4 = false;
	      var _iteratorError4 = undefined;
	
	      try {
	        for (var _iterator4 = (0, _getIterator3.default)(this.configForm), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	          var group = _step4.value;
	
	          var res = this.transformConfigArray(group.items);
	          obj = (0, _assign2.default)(obj, res);
	        }
	      } catch (err) {
	        _didIteratorError4 = true;
	        _iteratorError4 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion4 && _iterator4.return) {
	            _iterator4.return();
	          }
	        } finally {
	          if (_didIteratorError4) {
	            throw _iteratorError4;
	          }
	        }
	      }
	
	      if ((0, _stringify2.default)(obj) !== this.conf.config) {
	        this.conf.config = (0, _stringify2.default)(obj);
	      }
	    }
	  }, {
	    key: 'loadDefaultValue',
	    value: function loadDefaultValue() {
	      if (!this.conf.config) {
	        return;
	      }
	
	      var config = JSON.parse(this.conf.config);
	      var _iteratorNormalCompletion5 = true;
	      var _didIteratorError5 = false;
	      var _iteratorError5 = undefined;
	
	      try {
	        for (var _iterator5 = (0, _getIterator3.default)(this.configForm), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	          var group = _step5.value;
	
	          group.items = this.updateConfigArray(group.items, config);
	        }
	      } catch (err) {
	        _didIteratorError5 = true;
	        _iteratorError5 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion5 && _iterator5.return) {
	            _iterator5.return();
	          }
	        } finally {
	          if (_didIteratorError5) {
	            throw _iteratorError5;
	          }
	        }
	      }
	
	      this.initNewAppConfig();
	    }
	  }, {
	    key: 'initNewAppConfig',
	    value: function initNewAppConfig() {
	      this.newAppConfig = {};
	
	      this.appConfig = JSON.parse(this.conf.config);
	      var _iteratorNormalCompletion6 = true;
	      var _didIteratorError6 = false;
	      var _iteratorError6 = undefined;
	
	      try {
	        for (var _iterator6 = (0, _getIterator3.default)(this.configForm), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	          var group = _step6.value;
	          var _iteratorNormalCompletion7 = true;
	          var _didIteratorError7 = false;
	          var _iteratorError7 = undefined;
	
	          try {
	            for (var _iterator7 = (0, _getIterator3.default)(group.items), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
	              var item = _step7.value;
	
	              if (item.enable) {
	                this.newAppConfig[item.key] = this.getNestedProperty(item.key);
	              }
	            }
	          } catch (err) {
	            _didIteratorError7 = true;
	            _iteratorError7 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion7 && _iterator7.return) {
	                _iterator7.return();
	              }
	            } finally {
	              if (_didIteratorError7) {
	                throw _iteratorError7;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError6 = true;
	        _iteratorError6 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion6 && _iterator6.return) {
	            _iterator6.return();
	          }
	        } finally {
	          if (_didIteratorError6) {
	            throw _iteratorError6;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'getConf',
	    value: function getConf(id) {
	      var _this4 = this;
	
	      this.$http.get('/api/AppConfs/' + id).then(function (response) {
	        _this4.conf = response.data;
	        _this4.conf.groups = _this4.conf.groups.map(function (item) {
	          return item._id;
	        });
	        _this4.loadDefaultValue();
	
	        if (_this4.conf.code) {
	          _this4.getTmpConf();
	        }
	      });
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this5 = this;
	
	      this.$http.put('api/AppConfs/' + this.$stateParams.id, this.conf).then(function (response) {
	        if (_this5.conf.code) {
	          _this5.$state.go('codeappconfs');
	        } else {
	          _this5.$state.go('appconfs');
	        }
	      });
	    }
	  }, {
	    key: 'uploadIcon',
	    value: function uploadIcon(file) {
	      var _this6 = this;
	
	      this.toaster.pop({
	        type: 'wait',
	        title: '正在上传图标，请稍等...',
	        body: file.name,
	        timeout: 3000 * 1000
	      });
	
	      file.upload = this.Upload.upload({
	        url: '/api/AppConfs/' + this.conf._id + '/uploadIcon',
	        file: file,
	        data: this.conf,
	        headers: {
	          'Content-Type': 'multipart/form-data'
	        }
	      });
	
	      file.upload.progress(function (evt) {
	        file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
	      });
	
	      file.upload.success(function (data, status, headers, config) {
	        _this6.toaster.clear();
	        _this6.getConf(_this6.$stateParams.id);
	        _this6.toaster.pop('success', '上传成功', file.name);
	      });
	
	      file.upload.error(function (err) {
	        _this6.toaster.clear();
	        _this6.toaster.pop('error', '上传失败', (0, _stringify2.default)(err));
	      });
	    }
	  }, {
	    key: 'getList',
	    value: function getList() {
	      var _this7 = this;
	
	      this.$http.get('/api/AppConfGroups').then(function (res) {
	        _this7.groups = res.data;
	      });
	    }
	  }, {
	    key: 'toggleSelection',
	    value: function toggleSelection(id) {
	      var idx = this.conf.groups.indexOf(id);
	      if (idx > -1) {
	        this.conf.groups.splice(idx, 1);
	      } else {
	        this.conf.groups.push(id);
	      }
	    }
	  }, {
	    key: 'toggleFlagsSelection',
	    value: function toggleFlagsSelection(val) {
	      if (!this.conf.flags) {
	        this.conf.flags = [];
	      }
	      var flags = this.conf.flags.indexOf(val);
	      if (flags > -1) {
	        this.conf.flags.splice(flags, 1);
	      } else {
	        this.conf.flags.push(val);
	      }
	    }
	  }, {
	    key: 'getConfByCode',
	    value: function getConfByCode() {
	      var _this8 = this;
	
	      var code = this.conf.code;
	      if (code.length !== 4) {
	        return;
	      }
	
	      var params = {
	        code: code
	      };
	
	      this.$http.get('/api/AppConfs/getConfByCode', { params: params }).then(function (response) {
	        _this8.tmpConf = response.data;
	      }).catch(function (err) {
	        console.log(err);
	        _this8.tmpConf = null;
	      });
	    }
	  }, {
	    key: 'checkRecommendedBy',
	    value: function checkRecommendedBy() {
	      var _this9 = this;
	
	      var pkg = this.conf.pkg;
	      var recommendedBy = this.conf.recommendedBy;
	
	      var params = {
	        pkg: pkg,
	        recommendedBy: recommendedBy
	      };
	
	      this.$http.get('/api/AppConfs/checkRecommendedBy', { params: params }).then(function (response) {
	        var tmpConf = response.data;
	        if (tmpConf.code !== _this9.conf.code && tmpConf.pkg === _this9.conf.pkg && tmpConf.recommendedBy === _this9.conf.recommendedBy) {
	          _this9.isRepeat = true;
	        }
	      }).catch(function (err) {
	        console.log(err);
	        _this9.isRepeat = false;
	      });
	    }
	  }, {
	    key: 'getTmpConf',
	    value: function getTmpConf() {
	      var _this10 = this;
	
	      var code = this.conf.code;
	      var pkg = this.conf.pkg;
	      var recommendedBy = this.conf.recommendedBy;
	
	      var params = {};
	
	      if (code.length === 4) {
	        params.code = code;
	      }
	
	      if (pkg && recommendedBy) {
	        params.pkg = pkg;
	        params.recommendedBy = recommendedBy;
	      }
	
	      if ((0, _keys2.default)(params).length === 0) {
	        return;
	      }
	
	      this.$http.post('/api/AppConfs/getConf', params).then(function (response) {
	        _this10.checkRecommendedByRepeat(response.data);
	      }).catch(function (err) {
	        console.log(err);
	        _this10.tmpConf = null;
	      });
	    }
	  }, {
	    key: 'checkRecommendedByRepeat',
	    value: function checkRecommendedByRepeat(conf) {
	      var _this11 = this;
	
	      var confByCode = conf.findByCode;
	      var confByRecommend = conf.findByRecommend;
	
	      if (confByCode && confByCode.length) {
	        this.existConfs = confByCode.filter(function (item) {
	          return item.pkg != _this11.conf.pkg;
	        }).map(function (item) {
	          return item.name;
	        }).join(',');
	      }
	
	      if (confByRecommend && confByRecommend.code !== this.conf.code && confByRecommend.pkg === this.conf.pkg && confByRecommend.recommendedBy === this.conf.recommendedBy) {
	        this.isRepeat = true;
	      } else {
	        this.isRepeat = false;
	      }
	    }
	  }, {
	    key: 'updateDefaultConfigData',
	    value: function updateDefaultConfigData(data, checked) {
	      if (!checked) {
	        delete this.newAppConfig[data.key];
	      } else {
	        if (data.value !== '' || data.value !== undefined) {
	          this.newAppConfig[data.key] = data.value;
	        }
	      }
	      this.updateAppConfig();
	    }
	  }, {
	    key: 'updateAppConfig',
	    value: function updateAppConfig() {
	      if (!this.conf) {
	        return;
	      }
	      this.appConfig = {};
	      for (var key in this.newAppConfig) {
	        this.setNestedProperty(key, this.newAppConfig[key]);
	      }
	      if ((0, _keys2.default)(this.appConfig).length) {
	        this.conf.config = (0, _stringify2.default)(this.appConfig, null, 4);
	      } else {
	        this.conf.config = '';
	      }
	    }
	  }, {
	    key: 'setNestedProperty',
	    value: function setNestedProperty(path, value) {
	      var setter = this.$parse(path).assign;
	
	      if (angular.isFunction(setter)) {
	        this.ensurePathExists(this.appConfig, path);
	
	        setter(this.appConfig, value);
	      } else {
	        console.error("不能设置嵌套属性：", path);
	      }
	    }
	  }, {
	    key: 'getNestedProperty',
	    value: function getNestedProperty(path) {
	      var getter = this.$parse(path);
	      try {
	        return getter(this.appConfig);
	      } catch (error) {
	        this.setNestedProperty(path, undefined);
	        return undefined;
	      }
	    }
	  }, {
	    key: 'ensurePathExists',
	    value: function ensurePathExists(obj, path) {
	      var parts = path.split('.');
	      var current = obj;
	
	      for (var i = 0; i < parts.length - 1; i++) {
	        var part = parts[i];
	
	        if (current[part] === undefined || current[part] === null) {
	          current[part] = {};
	        }
	
	        current = current[part];
	      }
	    }
	  }, {
	    key: 'selectedItem',
	    value: function selectedItem(key, data) {
	      var item = data.range.find(function (a) {
	        return a.value === key;
	      });
	      if (!item) {
	        return;
	      }
	      if (item.associationAttributes) {
	        var _iteratorNormalCompletion8 = true;
	        var _didIteratorError8 = false;
	        var _iteratorError8 = undefined;
	
	        try {
	          for (var _iterator8 = (0, _getIterator3.default)(item.associationAttributes), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
	            var attrItem = _step8.value;
	            var _iteratorNormalCompletion9 = true;
	            var _didIteratorError9 = false;
	            var _iteratorError9 = undefined;
	
	            try {
	              for (var _iterator9 = (0, _getIterator3.default)(attrItem.attr), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
	                var a = _step9.value;
	
	                this.newAppConfig[a.key] = a.value;
	              }
	            } catch (err) {
	              _didIteratorError9 = true;
	              _iteratorError9 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion9 && _iterator9.return) {
	                  _iterator9.return();
	                }
	              } finally {
	                if (_didIteratorError9) {
	                  throw _iteratorError9;
	                }
	              }
	            }
	          }
	        } catch (err) {
	          _didIteratorError8 = true;
	          _iteratorError8 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion8 && _iterator8.return) {
	              _iterator8.return();
	            }
	          } finally {
	            if (_didIteratorError8) {
	              throw _iteratorError8;
	            }
	          }
	        }
	      }
	      return item;
	    }
	  }]);
	  return AddConfController;
	}();
	
	exports.default = AddConfController;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(286), __esModule: true };

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(287);
	module.exports = __webpack_require__(8).Object.values;


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(6);
	var $values = __webpack_require__(288)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	var getKeys = __webpack_require__(35);
	var toIObject = __webpack_require__(37);
	var isEnum = __webpack_require__(64).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) if (isEnum.call(O, key = keys[i++])) {
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _code = __webpack_require__(290);
	
	var _code2 = _interopRequireDefault(_code);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('onyxReadingRoomApp.appconfs.code', []).controller('AppConfsCodeController', _code2.default).name;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CodeController = function () {
	
	  /*@ngInject*/
	  CodeController.$inject = ['$http', '$state'];
	  function CodeController($http, $state) {
	    (0, _classCallCheck3.default)(this, CodeController);
	
	    this.$http = $http;
	    this.$state = $state;
	  }
	
	  (0, _createClass3.default)(CodeController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getConfs();
	    }
	  }, {
	    key: 'getConfs',
	    value: function getConfs() {
	      var _this = this;
	
	      this.$http.get('/api/AppConfs', { params: { type: 1 } }).then(function (response) {
	        _this.confs = response.data;
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(id) {
	      var _this2 = this;
	
	      if (confirm("确定？")) {
	        this.$http.delete('api/AppConfs/' + id).then(function (response) {
	          _this2.getConfs();
	        });
	      }
	    }
	  }]);
	  return CodeController;
	}();
	
	exports.default = CodeController;

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _import = __webpack_require__(292);
	
	var _import2 = _interopRequireDefault(_import);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('onyxReadingRoomApp.appconfs.import', []).controller('AppConfsImportController', _import2.default).name;

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(157);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImportController = function () {
	
	  /*@ngInject*/
	  ImportController.$inject = ['$http', '$state', 'Upload', 'toaster'];
	  function ImportController($http, $state, Upload, toaster) {
	    (0, _classCallCheck3.default)(this, ImportController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.Upload = Upload;
	    this.toaster = toaster;
	
	    this.newConf = {
	      groups: []
	    };
	  }
	
	  (0, _createClass3.default)(ImportController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getList();
	    }
	  }, {
	    key: 'upload',
	    value: function upload(file) {
	      var _this = this;
	
	      if (!file) {
	        return;
	      }
	      this.toaster.pop({
	        type: 'wait',
	        title: '正在上传，请稍等...',
	        body: file.name,
	        timeout: 3000 * 1000
	      });
	
	      file.upload = this.Upload.upload({
	        url: '/api/AppConfs/import',
	        file: file,
	        data: this.newConf,
	        headers: {
	          'Content-Type': 'multipart/form-data'
	        }
	      });
	
	      file.upload.progress(function (evt) {
	        file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
	      });
	
	      file.upload.success(function (data, status, headers, config) {
	        _this.$state.go('appconfs.list');
	        _this.toaster.clear();
	        _this.toaster.pop('success', '上传成功', file.name);
	      });
	
	      file.upload.error(function (err) {
	        _this.toaster.clear();
	        _this.toaster.pop('error', '上传失败', (0, _stringify2.default)(err));
	      });
	    }
	  }, {
	    key: 'getList',
	    value: function getList() {
	      var _this2 = this;
	
	      this.$http.get('/api/AppConfGroups').then(function (res) {
	        _this2.groups = res.data;
	      });
	    }
	  }, {
	    key: 'toggleSelection',
	    value: function toggleSelection(id) {
	      var idx = this.newConf.groups.indexOf(id);
	      if (idx > -1) {
	        this.newConf.groups.splice(idx, 1);
	      } else {
	        this.newConf.groups.push(id);
	      }
	    }
	  }]);
	  return ImportController;
	}();
	
	exports.default = ImportController;

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(86);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _betagroups = __webpack_require__(294);
	
	var _betagroups2 = _interopRequireDefault(_betagroups);
	
	var _list = __webpack_require__(302);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _edit = __webpack_require__(304);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _add = __webpack_require__(306);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _show = __webpack_require__(308);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _adduser = __webpack_require__(310);
	
	var _adduser2 = _interopRequireDefault(_adduser);
	
	var _import = __webpack_require__(312);
	
	var _import2 = _interopRequireDefault(_import);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.betagroups', [_angularUiRouter2.default, _list2.default, _edit2.default, _add2.default, _show2.default, _adduser2.default, _import2.default]).config(_betagroups2.default).run(['$rootScope', function ($rootScope) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
	    if (next.name === 'logout' && current && current.name && !current.authenticate) {
	      next.referrer = current.name;
	    }
	  });
	}]).name;

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $urlRouterProvider.when("/betagroups", "/betagroups/list");
	  $stateProvider.state('betagroups', {
	    url: '/betagroups',
	    template: __webpack_require__(295),
	    authenticate: true
	  }).state('betagroups.list', {
	    url: '/list',
	    template: __webpack_require__(296),
	    controller: 'BetaGroupsListController',
	    controllerAs: 'betagroupsListCtrl'
	  }).state('betagroups.edit', {
	    url: '/edit/:id',
	    template: __webpack_require__(297),
	    controller: 'BetaGroupsEditController',
	    controllerAs: 'betagroupsEditCtrl'
	  }).state('betagroups.add', {
	    url: '/add',
	    template: __webpack_require__(298),
	    controller: 'BetaGroupsAddController',
	    controllerAs: 'betagroupsAddCtrl'
	  }).state('betagroups.show', {
	    url: '/show/:id',
	    template: __webpack_require__(299),
	    controller: 'BetaGroupsShowController',
	    controllerAs: 'betagroupsShowCtrl'
	  }).state('betagroups.adduser', {
	    url: '/:id/adduser',
	    template: __webpack_require__(300),
	    controller: 'BetaGroupsAddUserController',
	    controllerAs: 'betagroupsAddUserCtrl'
	  }).state('betagroups.import', {
	    url: '/:id/import',
	    template: __webpack_require__(301),
	    controller: 'BetaGroupsImportController',
	    controllerAs: 'betagroupsImportCtrl'
	  });
	}];

/***/ }),
/* 295 */
144,
/* 296 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"page-header\">\n    <button type=\"button\" name=\"button\" class=\"btn btn-success pull-right\" ui-sref=\"betagroups.add\">添加</button>\n    <h3>测试组</h3>\n  </div>\n  <div class=\"\">\n    <table class=\"table table-striped\">\n      <thead>\n        <tr>\n          <th></th>\n          <th>名字</th>\n          <th>人数</th>\n          <th class=\"ctrl-th\"></th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"group in betagroupsListCtrl.betagroups\">\n          <td>{{$index + 1}}</td>\n          <td>{{group.name}}</td>\n          <td>{{group.userCount}}</td>\n          <td class=\"ctrl-td\">\n            <button ui-sref=\"betagroups.show({id: group._id})\" class=\"btn btn-xs btn-success\">详细</button>\n            <button ui-sref=\"betagroups.edit({id: group._id})\" class=\"btn btn-xs btn-success\">编辑</button>\n            <button ng-click=\"betagroupsListCtrl.delete(group._id)\" class=\"btn btn-xs btn-danger\">删除</button>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 297 */
/***/ (function(module, exports) {

	module.exports = "\n<div class=\"container\">\n  <div class=\"page-header\">\n    <h1>编辑</h1>\n  </div>\n  <div>\n    <form>\n\n      <div class=\"form-group\">\n        <label for=\"name\">组名</label>\n        <input type=\"name\" class=\"form-control\" ng-model=\"betagroupsEditCtrl.betagroup.name\" required>\n      </div>\n\n      <button type=\"submit\" class=\"btn btn-success\" ng-click=\"betagroupsEditCtrl.save()\">保存</button>\n    </form>\n  </div>\n</div>\n"

/***/ }),
/* 298 */
/***/ (function(module, exports) {

	module.exports = "\n<div class=\"container\">\n  <div class=\"page-header\">\n    <h1>添加</h1>\n  </div>\n  <div>\n    <form>\n\n      <div class=\"form-group\">\n        <label for=\"name\">组名</label>\n        <input type=\"name\" class=\"form-control\" ng-model=\"betagroupsAddCtrl.newGroup.name\" required>\n      </div>\n\n      <button type=\"submit\" class=\"btn btn-success\" ng-click=\"betagroupsAddCtrl.save()\">保存</button>\n    </form>\n  </div>\n</div>\n"

/***/ }),
/* 299 */
/***/ (function(module, exports) {

	module.exports = "\n<div class=\"container\">\n  <div class=\"page-header\">\n    <button type=\"button\" name=\"button\" class=\"btn btn-success pull-right\" ui-sref=\"betagroups.adduser({id: betagroupsShowCtrl.betagroup._id})\">添加用户</button>\n    <button type=\"button\" name=\"button\" class=\"btn btn-info pull-right margin-r-10\" ui-sref=\"betagroups.import({id: betagroupsShowCtrl.betagroup._id})\">导入用户</button>\n    <button type=\"button\" name=\"button\" class=\"btn btn-danger pull-right margin-r-10\" ng-click=\"betagroupsShowCtrl.batchRemove()\" ng-disabled=\"betagroupsShowCtrl.selection.length == 0\">删除</button>\n    <div class=\"btn-group pull-right margin-r-10\" uib-dropdown>\n      <button type=\"button\" name=\"button\" class=\"btn btn-primary\" uib-dropdown-toggle ng-disabled=\"betagroupsShowCtrl.selection.length == 0\">移动</button>\n      <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"single-button\">\n        <li role=\"menuitem\" ng-repeat=\"item in betagroupsShowCtrl.betaGroups\"><a ng-click=\"betagroupsShowCtrl.batchMove(item._id)\">{{item.name}}</a></li>\n      </ul>\n    </div>\n    <h1>{{betagroupsShowCtrl.betagroup.name}}</h1>\n  </div>\n  <div class=\"\">\n    <table class=\"table table-striped\">\n      <thead>\n        <tr>\n          <th></th>\n          <th></th>\n          <th>型号</th>\n          <th>MAC</th>\n          <th>用户</th>\n          <th>设备SN</th>\n          <th>文石SN</th>\n          <th class=\"ctrl-th\"></th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"user in betagroupsShowCtrl.betagroup.users\">\n          <td><input type=\"checkbox\" value=\"{{user._id}}\" ng-checked=\"betagroupsShowCtrl.selection.indexOf(user._id) > -1\"\n            ng-click=\"betagroupsShowCtrl.toggleSelection(user._id)\"></td>\n          <td>{{$index + 1}}</td>\n          <td>{{user.model}}</td>\n          <td>{{user.mac}}</td>\n          <td>{{user.name}}</td>\n          <td>{{user.deviceSN}}</td>\n          <td>{{user.onyxSN}}</td>\n          <td class=\"ctrl-td\">\n            <button ui-sref=\"betausers.edit({id: user._id})\" class=\"btn btn-xs btn-success\">编辑</button>\n            <button ng-click=\"betagroupsShowCtrl.remove(user._id)\" class=\"btn btn-xs btn-danger\">删除</button>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 300 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"page-header\">\n    <h1>添加</h1>\n  </div>\n  <div>\n    <form>\n\n      <div class=\"form-group\">\n        <label for=\"model\">型号</label>\n        <input type=\"model\" class=\"form-control\" ng-model=\"betagroupsAddUserCtrl.newUser.model\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"mac\">MAC</label>\n        <input type=\"mac\" class=\"form-control\" ng-model=\"betagroupsAddUserCtrl.newUser.mac\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"name\">用户</label>\n        <input type=\"name\" class=\"form-control\" ng-model=\"betagroupsAddUserCtrl.newUser.name\">\n      </div>\n\n      <button type=\"submit\" class=\"btn btn-success\" ng-click=\"betagroupsAddUserCtrl.save()\">保存</button>\n    </form>\n  </div>\n</div>"

/***/ }),
/* 301 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <form>\n    <label>导入数据</label>\n    <div class=\"form-group\">\n      <label for=\"file\" class=\"text-danger\">文件 <span>(必需, 支持格式xlsx,xls,txt)</span></label>\n      <input type=\"file\" ngf-select ng-model=\"betagroupsImportCtrl.file\" name=\"file\" required ngf-model-invalid=\"errorFile\" class=\"form-control\">\n    </div>\n\n    <button type=\"submit\" class=\"btn btn-success\" ng-click=\"betagroupsImportCtrl.upload(betagroupsImportCtrl.file)\">保存</button>\n  </form>\n</div>\n"

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _list = __webpack_require__(303);
	
	var _list2 = _interopRequireDefault(_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.betagroups.list', []).controller('BetaGroupsListController', _list2.default).name;

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListController = function () {
	
	  /*@ngInject*/
	  ListController.$inject = ['$http'];
	  function ListController($http) {
	    (0, _classCallCheck3.default)(this, ListController);
	
	    this.$http = $http;
	  }
	
	  (0, _createClass3.default)(ListController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getBetaGroups();
	    }
	  }, {
	    key: 'getBetaGroups',
	    value: function getBetaGroups() {
	      var _this = this;
	
	      this.$http.get('/api/betaGroups').then(function (res) {
	        _this.betagroups = res.data;
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(id) {
	      var _this2 = this;
	
	      if (confirm("确定？")) {
	        this.$http.delete('/api/betaGroups/' + id).then(function (res) {
	          _this2.getBetaGroups();
	        });
	      }
	    }
	  }]);
	  return ListController;
	}();
	
	exports.default = ListController;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _edit = __webpack_require__(305);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.betagroups.edit', []).controller('BetaGroupsEditController', _edit2.default).name;

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditController = function () {
	
	  /*@ngInject*/
	  EditController.$inject = ['$http', '$state', '$stateParams'];
	  function EditController($http, $state, $stateParams) {
	    (0, _classCallCheck3.default)(this, EditController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	  }
	
	  (0, _createClass3.default)(EditController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getBetaGroup();
	    }
	  }, {
	    key: 'getBetaGroup',
	    value: function getBetaGroup() {
	      var _this = this;
	
	      this.$http.get('/api/betaGroups/' + this.$stateParams.id).then(function (res) {
	        _this.betagroup = res.data;
	      });
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this2 = this;
	
	      this.$http.put('/api/betaGroups/' + this.$stateParams.id, this.betagroup).then(function (res) {
	        _this2.$state.go('^');
	      });
	    }
	  }]);
	  return EditController;
	}();
	
	exports.default = EditController;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _add = __webpack_require__(307);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.betagroups.add', []).controller('BetaGroupsAddController', _add2.default).name;

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddController = function () {
	
	  /*@ngInject*/
	  AddController.$inject = ['$http', '$state'];
	  function AddController($http, $state) {
	    (0, _classCallCheck3.default)(this, AddController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.newGroup = {};
	  }
	
	  (0, _createClass3.default)(AddController, [{
	    key: 'save',
	    value: function save() {
	      var _this = this;
	
	      this.$http.post('/api/betaGroups', this.newGroup).then(function (res) {
	        _this.$state.go('^');
	      });
	    }
	  }]);
	  return AddController;
	}();
	
	exports.default = AddController;

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _show = __webpack_require__(309);
	
	var _show2 = _interopRequireDefault(_show);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.betagroups.show', []).controller('BetaGroupsShowController', _show2.default).name;

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditController = function () {
	
	  /*@ngInject*/
	  EditController.$inject = ['$http', '$state', '$stateParams'];
	  function EditController($http, $state, $stateParams) {
	    (0, _classCallCheck3.default)(this, EditController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.selection = [];
	  }
	
	  (0, _createClass3.default)(EditController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getBetaGroup();
	      this.getBetaGroups();
	    }
	  }, {
	    key: 'getBetaGroup',
	    value: function getBetaGroup() {
	      var _this = this;
	
	      this.$http.get('/api/betaGroups/' + this.$stateParams.id).then(function (res) {
	        _this.betagroup = res.data;
	      });
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this2 = this;
	
	      this.$http.put('/api/betaGroups/' + this.$stateParams.id, this.betagroup).then(function (res) {
	        _this2.$state.go('^');
	      });
	    }
	  }, {
	    key: 'remove',
	    value: function remove(id) {
	      var _this3 = this;
	
	      this.$http.post('/api/betaGroups/' + this.$stateParams.id + '/removeUser', { users: [id] }).then(function (res) {
	        _this3.getBetaGroup();
	      });
	    }
	  }, {
	    key: 'toggleSelection',
	    value: function toggleSelection(id) {
	      var idx = this.selection.indexOf(id);
	      if (idx > -1) {
	        this.selection.splice(idx, 1);
	      } else {
	        this.selection.push(id);
	      }
	    }
	  }, {
	    key: 'batchRemove',
	    value: function batchRemove() {
	      var _this4 = this;
	
	      if (confirm("确定？")) {
	        this.$http.post('/api/betaGroups/' + this.$stateParams.id + '/removeUser', {
	          users: this.selection
	        }).then(function (res) {
	          _this4.getBetaGroup();
	        });
	      }
	    }
	  }, {
	    key: 'batchMove',
	    value: function batchMove(id) {
	      var _this5 = this;
	
	      if (confirm("确定？")) {
	        var params = {
	          users: this.selection,
	          from: this.$stateParams.id,
	          to: id
	        };
	        this.$http.post('/api/betaGroups/moveUsers', params).then(function (res) {
	          _this5.getBetaGroup();
	        });
	      }
	    }
	  }, {
	    key: 'getBetaGroups',
	    value: function getBetaGroups() {
	      var _this6 = this;
	
	      this.$http.get('/api/betaGroups').then(function (res) {
	        _this6.betaGroups = res.data;
	      });
	    }
	  }]);
	  return EditController;
	}();
	
	exports.default = EditController;

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _adduser = __webpack_require__(311);
	
	var _adduser2 = _interopRequireDefault(_adduser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.betagroups.adduser', []).controller('BetaGroupsAddUserController', _adduser2.default).name;

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddUserController = function () {
	
	  /*@ngInject*/
	  AddUserController.$inject = ['$http', '$state', '$stateParams'];
	  function AddUserController($http, $state, $stateParams) {
	    (0, _classCallCheck3.default)(this, AddUserController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.newUser = {};
	  }
	
	  (0, _createClass3.default)(AddUserController, [{
	    key: 'save',
	    value: function save() {
	      var _this = this;
	
	      this.$http.post('/api/betaGroups/' + this.$stateParams.id + '/adduser', this.newUser).then(function (res) {
	        _this.$state.go('betagroups.show', { id: _this.$stateParams.id });
	      });
	    }
	  }]);
	  return AddUserController;
	}();
	
	exports.default = AddUserController;

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _import = __webpack_require__(313);
	
	var _import2 = _interopRequireDefault(_import);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.betagroups.import', []).controller('BetaGroupsImportController', _import2.default).name;

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(157);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImportController = function () {
	
	  /*@ngInject*/
	  ImportController.$inject = ['$http', '$state', '$stateParams', '$scope', 'Upload', 'toaster'];
	  function ImportController($http, $state, $stateParams, $scope, Upload, toaster) {
	    (0, _classCallCheck3.default)(this, ImportController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$scope = $scope;
	    this.Upload = Upload;
	    this.toaster = toaster;
	  }
	
	  (0, _createClass3.default)(ImportController, [{
	    key: 'upload',
	    value: function upload(file) {
	      var _this = this;
	
	      this.toaster.pop({
	        type: 'wait',
	        title: '正在导入，请稍等...',
	        body: file.name,
	        timeout: 3000 * 1000
	      });
	
	      file.upload = this.Upload.upload({
	        url: '/api/betaGroups/' + this.$stateParams.id + '/import',
	        file: file,
	        headers: {
	          'Content-Type': 'multipart/form-data'
	        }
	      });
	
	      file.upload.progress(function (evt) {
	        file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
	      });
	
	      file.upload.success(function (data, status, headers, config) {
	        _this.toaster.clear();
	        _this.toaster.pop('success', '导入成功', file.name);
	        _this.$state.go('betagroups.show', { id: _this.$stateParams.id });
	      });
	
	      file.upload.error(function (err) {
	        _this.toaster.clear();
	        _this.toaster.pop('error', '导入失败', (0, _stringify2.default)(err));
	      });
	    }
	  }]);
	  return ImportController;
	}();
	
	exports.default = ImportController;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.groupNameFilter = groupNameFilter;
	var angular = __webpack_require__(78);
	
	/*@ngInject*/
	function groupNameFilter() {
	  return function (ids, groups) {
	    var g = groups.filter(function (item) {
	      return ids.indexOf(item._id) != -1;
	    });
	    return g = g.map(function (item) {
	      return item.name;
	    }).join(',');
	  };
	}
	
	exports.default = angular.module('updateServerApp.groupName', []).filter('groupName', groupNameFilter).name;

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(86);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _usermanual = __webpack_require__(316);
	
	var _usermanual2 = _interopRequireDefault(_usermanual);
	
	var _list = __webpack_require__(321);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _add = __webpack_require__(323);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _edit = __webpack_require__(325);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.usermanual', [_angularUiRouter2.default, _list2.default, _add2.default, _edit2.default]).config(_usermanual2.default).run(['$rootScope', function ($rootScope) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
	    if (next.name === 'logout' && current && current.name && !current.authenticate) {
	      next.referrer = current.name;
	    }
	  });
	}]).name;

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $urlRouterProvider.when("/usermanual", "/usermanual/list");
	  $stateProvider.state('usermanual', {
	    url: '/usermanual',
	    template: __webpack_require__(317),
	    authenticate: true
	  }).state('usermanual.list', {
	    url: '/list',
	    template: __webpack_require__(318),
	    controller: 'UsermanualListController',
	    controllerAs: 'umListCtrl'
	  }).state('usermanual.add', {
	    url: '/add',
	    template: __webpack_require__(319),
	    controller: 'UsermanualAddController',
	    controllerAs: 'umAddCtrl'
	  }).state('usermanual.edit', {
	    url: '/edit/:id',
	    template: __webpack_require__(320),
	    controller: 'UsermanualEditController',
	    controllerAs: 'umEditCtrl'
	  });
	}];

/***/ }),
/* 317 */
144,
/* 318 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"page-header\">\n    <a ui-sref=\"usermanual.add\" class=\"btn btn-primary pull-right\">添加</a>\n    <h3>用户手册</h3>\n  </div>\n  <div class=\"\">\n    <table class=\"table table-striped\">\n      <thead>\n        <tr>\n          <th style=\"width: 50px;\"></th>\n          <th>型号</th>\n          <th>语言</th>\n          <th>文件</th>\n          <th>更新时间</th>\n          <th class=\"ctrl-th\"></th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"manual in umListCtrl.manuals\">\n          <td>{{$index + 1}}</td>\n          <td>{{manual.model}}</td>\n          <td>{{manual.lang}}</td>\n          <td><a href=\"{{manual.file.path}}\" target=\"_blank\"><span class=\"glyphicon glyphicon-paperclip\"></span></a></td>\n          <td>{{manual.updatedAt | date:'yyyy-MM-dd'}}</td>\n          <td class=\"ctrl-td\">\n            <a href=\"http://manual.onyx-international.cn/{{manual.model}}/{{manual.lang}}/index.html\" target=\"_blank\" class=\"btn btn-xs btn-success\">查看</a>\n            <a ui-sref=\"usermanual.edit({id: manual._id})\" class=\"btn btn-xs btn-primary\">编辑</a>\n            <button ng-click=\"umListCtrl.delete(manual._id)\" class=\"btn btn-xs btn-danger\">删除</button>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 319 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"page-header\">\n    <h1>添加</h1>\n  </div>\n  <div>\n    <form>\n      <div class=\"form-group\">\n        <label for=\"model\">型号\n          <span class=\"text-danger\">(必需)</span>\n        </label>\n        <input type=\"model\" class=\"form-control\" ng-model=\"umAddCtrl.newManual.model\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"lang\">语言\n          <span class=\"text-danger\">(必需)</span>\n        </label>\n        <input type=\"lang\" class=\"form-control\" ng-model=\"umAddCtrl.newManual.lang\">\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"file\"\">文件\n          <span class=\"text-danger\">(必需)</span>\n        </label>\n        <input type=\"file\" ngf-select ng-model=\"file\" name=\"file\" required ngf-model-invalid=\"errorFile\" class=\"form-control\">\n      </div>\n\n      <button type=\"submit\" class=\"btn btn-success\" ng-click=\"umAddCtrl.upload(file)\">保存</button>\n      <button type=\"button\" class=\"btn btn-default\" ui-sref=\"^\">返回</button>\n    </form>\n  </div>\n</div>"

/***/ }),
/* 320 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"page-header\">\n    <h1>添加</h1>\n  </div>\n  <div>\n    <form>\n      <div class=\"form-group\">\n        <label for=\"model\">型号\n          <span class=\"text-danger\">(必需)</span>\n        </label>\n        <input type=\"model\" class=\"form-control\" ng-model=\"umEditCtrl.manual.model\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"lang\">语言\n          <span class=\"text-danger\">(必需)</span>\n        </label>\n        <input type=\"lang\" class=\"form-control\" ng-model=\"umEditCtrl.manual.lang\">\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"file\"\">文件\n          <span class=\" text-danger\">(必需)</span>\n        </label>\n        <input type=\"file\" ngf-select ng-model=\"file\" name=\"file\" required ngf-model-invalid=\"errorFile\" class=\"form-control\">\n      </div>\n\n      <button type=\"submit\" class=\"btn btn-success\" ng-click=\"umEditCtrl.upload(file)\">保存</button>\n      <button type=\"button\" class=\"btn btn-default\" ui-sref=\"^\">返回</button>\n    </form>\n  </div>\n</div>"

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _list = __webpack_require__(322);
	
	var _list2 = _interopRequireDefault(_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.usermanual.list', []).controller('UsermanualListController', _list2.default).name;

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListController = function () {
	
	  /*@ngInject*/
	  ListController.$inject = ['$http'];
	  function ListController($http) {
	    (0, _classCallCheck3.default)(this, ListController);
	
	    this.$http = $http;
	  }
	
	  (0, _createClass3.default)(ListController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getUserManual();
	    }
	  }, {
	    key: 'getUserManual',
	    value: function getUserManual() {
	      var _this = this;
	
	      this.$http.get('/api/UserManuals').then(function (res) {
	        _this.manuals = res.data;
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(id) {
	      var _this2 = this;
	
	      if (confirm("确定？")) {
	        this.$http.delete('/api/UserManuals/' + id).then(function (res) {
	          _this2.getUserManual();
	        });
	      }
	    }
	  }]);
	  return ListController;
	}();
	
	exports.default = ListController;

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _add = __webpack_require__(324);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.usermanual.add', []).controller('UsermanualAddController', _add2.default).name;

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(157);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddController = function () {
	
	  /*@ngInject*/
	  AddController.$inject = ['$http', '$state', '$scope', 'Upload', 'toaster'];
	  function AddController($http, $state, $scope, Upload, toaster) {
	    (0, _classCallCheck3.default)(this, AddController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$scope = $scope;
	    this.Upload = Upload;
	    this.toaster = toaster;
	
	    this.newManual = {};
	  }
	
	  (0, _createClass3.default)(AddController, [{
	    key: 'upload',
	    value: function upload(file) {
	      var _this = this;
	
	      this.toaster.pop({
	        type: 'wait',
	        title: '正在上传，请稍等...',
	        body: file.name,
	        timeout: 3000 * 1000
	      });
	
	      file.upload = this.Upload.upload({
	        url: '/api/UserManuals/upload',
	        file: file,
	        data: this.newManual,
	        headers: {
	          'Content-Type': 'multipart/form-data'
	        }
	      });
	
	      file.upload.progress(function (evt) {
	        file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
	      });
	
	      file.upload.success(function (data, status, headers, config) {
	        _this.toaster.clear();
	        _this.$state.go('usermanual');
	        _this.toaster.pop('success', '上传成功', file.name);
	      });
	
	      file.upload.error(function (err) {
	        _this.toaster.clear();
	        _this.toaster.pop('error', '上传失败', (0, _stringify2.default)(err));
	      });
	    }
	  }]);
	  return AddController;
	}();
	
	exports.default = AddController;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _edit = __webpack_require__(326);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.usermanual.edit', []).controller('UsermanualEditController', _edit2.default).name;

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(157);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddController = function () {
	
	  /*@ngInject*/
	  AddController.$inject = ['$http', '$state', '$scope', 'Upload', 'toaster', '$stateParams'];
	  function AddController($http, $state, $scope, Upload, toaster, $stateParams) {
	    (0, _classCallCheck3.default)(this, AddController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$scope = $scope;
	    this.Upload = Upload;
	    this.toaster = toaster;
	    this.$stateParams = $stateParams;
	
	    this.manual = {};
	  }
	
	  (0, _createClass3.default)(AddController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getUserManual(this.$stateParams.id);
	    }
	  }, {
	    key: 'getUserManual',
	    value: function getUserManual(id) {
	      var _this = this;
	
	      this.$http.get('/api/UserManuals/' + id).then(function (res) {
	        _this.manual = res.data;
	      });
	    }
	  }, {
	    key: 'upload',
	    value: function upload(file) {
	      var _this2 = this;
	
	      this.toaster.pop({
	        type: 'wait',
	        title: '正在上传，请稍等...',
	        body: file.name,
	        timeout: 3000 * 1000
	      });
	
	      file.upload = this.Upload.upload({
	        url: '/api/UserManuals/upload',
	        file: file,
	        data: this.manual,
	        headers: {
	          'Content-Type': 'multipart/form-data'
	        }
	      });
	
	      file.upload.progress(function (evt) {
	        file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
	      });
	
	      file.upload.success(function (data, status, headers, config) {
	        _this2.toaster.clear();
	        _this2.$state.go('usermanual');
	        _this2.toaster.pop('success', '上传成功', file.name);
	      });
	
	      file.upload.error(function (err) {
	        _this2.toaster.clear();
	        _this2.toaster.pop('error', '上传失败', (0, _stringify2.default)(err));
	      });
	    }
	  }]);
	  return AddController;
	}();
	
	exports.default = AddController;

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(86);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _dictionaries = __webpack_require__(328);
	
	var _dictionaries2 = _interopRequireDefault(_dictionaries);
	
	var _list = __webpack_require__(333);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _edit = __webpack_require__(335);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _add = __webpack_require__(337);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.dictionaries', [_angularUiRouter2.default, _list2.default, _edit2.default, _add2.default]).config(_dictionaries2.default).run(['$rootScope', function ($rootScope) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
	    if (next.name === 'logout' && current && current.name && !current.authenticate) {
	      next.referrer = current.name;
	    }
	  });
	}]).name;

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $urlRouterProvider.when("/dictionaries", "/dictionaries/list");
	  $stateProvider.state('dictionaries', {
	    url: '/dictionaries',
	    template: __webpack_require__(329),
	    authenticate: true
	  }).state('dictionaries.list', {
	    url: '/list',
	    template: __webpack_require__(330),
	    controller: 'DictionariesListController',
	    controllerAs: 'dictListCtrl'
	  }).state('dictionaries.edit', {
	    url: '/edit/:id',
	    template: __webpack_require__(331),
	    controller: 'DictionariesEditController',
	    controllerAs: 'dictEdittCtrl'
	  }).state('dictionaries.add', {
	    url: '/add',
	    template: __webpack_require__(332),
	    controller: 'DictionariesAddController',
	    controllerAs: 'dictAddCtrl'
	  });
	}];

/***/ }),
/* 329 */
144,
/* 330 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"page-header\">\n    <a ui-sref=\"dictionaries.add\" class=\"btn btn-primary pull-right\">添加</a>\n    <h3>字典</h3>\n  </div>\n  <div class=\"\">\n    <table class=\"table table-striped\">\n      <thead>\n        <tr>\n          <th style=\"width: 50px;\"></th>\n          <th>标题</th>\n          <th>名字</th>\n          <th>平台</th>\n          <th>源语言</th>\n          <th>目标语言</th>\n          <th>语言</th>\n          <th class=\"ctrl-th\"></th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"dict in dictListCtrl.dicts.list\">\n          <td>{{$index + 1}}</td>\n          <td>{{dict.title}}</td>\n          <td>{{dict.name}}</td>\n          <td>{{dict.distributeChannel}}</td>\n          <td>{{dict.sourceLanguage}}</td>\n          <td>{{dict.targetLanguage}}</td>          \n          <td>{{dict.lang.join('\\\\')}}</td>          \n          <td class=\"ctrl-td\">\n            <button ui-sref=\"dictionaries.edit({id: dict._id})\" class=\"btn btn-xs btn-success\">编辑</button>\n            <button ng-click=\"dictListCtrl.delete(dict._id)\" class=\"btn btn-xs btn-danger\">删除</button>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 331 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <form>\n    <label>添加更新数据</label>\n    <div class=\"form-group\">\n      <label for=\"title\">标题 <span class=\"text-danger\">(必需)</span></label>\n      <input type=\"title\" class=\"form-control\" ng-model=\"dictEdittCtrl.dict.title\" required>\n    </div>\n    <div class=\"form-group\">\n      <label for=\"name\">名称 <span class=\"text-danger\">(必需)</span></label>\n      <input type=\"name\" class=\"form-control\" ng-model=\"dictEdittCtrl.dict.name\" required>\n    </div>\n    <div class=\"form-group\">\n      <label for=\"sourceLanguage\">源语言 <span class=\"text-danger\">(必需)</span></label>\n      <input type=\"sourceLanguage\" class=\"form-control\" ng-model=\"dictEdittCtrl.dict.sourceLanguage\" required>\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"targetLanguage\">目标语言 <span class=\"text-danger\">(必需)</span></label>\n      <input type=\"targetLanguage\" class=\"form-control\" ng-model=\"dictEdittCtrl.dict.targetLanguage\" required>\n    </div>\n    <div class=\"form-group\">\n      <label for=\"lang\">语言\n        <span class=\"text-danger\">(多种语言用\\隔开)</span>\n      </label>\n      <input type=\"lang\" class=\"form-control\" ng-model=\"dictEdittCtrl.dict.lang\" ng-list=\"\\\">\n    </div>\n    <div class=\"form-group\">\n      <label for=\"summary\">摘要</label>\n      <input type=\"summary\" class=\"form-control\" ng-model=\"dictEdittCtrl.dict.summary\">\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"description\">描述</label>\n      <input type=\"description\" class=\"form-control\" ng-model=\"dictEdittCtrl.dict.description\">\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"company\">公司名称</label>\n      <input type=\"company\" class=\"form-control\" ng-model=\"dictEdittCtrl.dict.company\">\n    </div>\n\n\n    <div class=\"form-group\">\n      <label for=\"officialComment\">官方评论</label>\n      <input type=\"officialComment\" class=\"form-control\" ng-model=\"dictEdittCtrl.dict.officialComment\">\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"textContent\">文本内容</label>\n      <input type=\"textContent\" class=\"form-control\" ng-model=\"dictEdittCtrl.dict.textContent\">\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"consumer\">消费端代码,(默认值为0,代表onyx)</label>\n      <input type=\"number\" class=\"form-control\" ng-model=\"dictEdittCtrl.dict.consumer\">\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"distributeChannel\">发布渠道</label>\n      <input type=\"distributeChannel\" class=\"form-control\" ng-model=\"dictEdittCtrl.dict.distributeChannel\" ng-list>\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"category\">产品类别id列表</label>\n      <input type=\"category\" class=\"form-control\" ng-model=\"dictEdittCtrl.dict.category\" ng-list>\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"tags\">产品标签列表</label>\n      <input type=\"tags\" class=\"form-control\" ng-model=\"dictEdittCtrl.dict.tags\" ng-list>\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"wordCount\">词数</label>\n      <input type=\"number\" class=\"form-control\" ng-model=\"dictEdittCtrl.dict.wordCount\">\n    </div>\n\n    <button type=\"submit\" class=\"btn btn-success\" ng-click=\"dictEdittCtrl.updateDict(dictEdittCtrl.dict)\">保存</button>\n  </form>\n\n</div>\n"

/***/ }),
/* 332 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <form>\n    <label>添加更新数据</label>\n    <div class=\"form-group\">\n      <label for=\"title\">标题 <span class=\"text-danger\">(必需)</span></label>\n      <input type=\"title\" class=\"form-control\" ng-model=\"dictAddCtrl.newDict.title\" required>\n    </div>\n    <div class=\"form-group\">\n      <label for=\"name\">名称 <span class=\"text-danger\">(必需)</span></label>\n      <input type=\"name\" class=\"form-control\" ng-model=\"dictAddCtrl.newDict.name\" required>\n    </div>\n    <div class=\"form-group\">\n      <label for=\"sourceLanguage\">源语言 <span class=\"text-danger\">(必需)</span></label>\n      <input type=\"sourceLanguage\" class=\"form-control\" ng-model=\"dictAddCtrl.newDict.sourceLanguage\" required>\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"targetLanguage\">目标语言 <span class=\"text-danger\">(必需)</span></label>\n      <input type=\"targetLanguage\" class=\"form-control\" ng-model=\"dictAddCtrl.newDict.targetLanguage\" required>\n    </div>\n    <div class=\"form-group\">\n      <label for=\"lang\">语言\n        <span class=\"text-danger\">(多种语言用\\隔开)</span>\n      </label>\n      <input type=\"lang\" class=\"form-control\" ng-model=\"dictAddCtrl.newDict.lang\" ng-list=\"\\\">\n    </div>\n    <div class=\"form-group\">\n      <label for=\"summary\">摘要</label>\n      <input type=\"summary\" class=\"form-control\" ng-model=\"dictAddCtrl.newDict.summary\">\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"description\">描述</label>\n      <input type=\"description\" class=\"form-control\" ng-model=\"dictAddCtrl.newDict.description\">\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"company\">公司名称</label>\n      <input type=\"company\" class=\"form-control\" ng-model=\"dictAddCtrl.newDict.company\">\n    </div>\n\n\n    <div class=\"form-group\">\n      <label for=\"officialComment\">官方评论</label>\n      <input type=\"officialComment\" class=\"form-control\" ng-model=\"dictAddCtrl.newDict.officialComment\">\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"textContent\">文本内容</label>\n      <input type=\"textContent\" class=\"form-control\" ng-model=\"dictAddCtrl.newDict.textContent\">\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"consumer\">消费端代码,(默认值为0,代表onyx)</label>\n      <input type=\"number\" class=\"form-control\" ng-model=\"dictAddCtrl.newDict.consumer\">\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"distributeChannel\">发布渠道</label>\n      <input type=\"distributeChannel\" class=\"form-control\" ng-model=\"dictAddCtrl.newDict.distributeChannel\" ng-list>\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"category\">产品类别id列表</label>\n      <input type=\"category\" class=\"form-control\" ng-model=\"dictAddCtrl.newDict.category\" ng-list>\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"tags\">产品标签列表</label>\n      <input type=\"tags\" class=\"form-control\" ng-model=\"dictAddCtrl.newDict.tags\" ng-list>\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"wordCount\">词数</label>\n      <input type=\"number\" class=\"form-control\" ng-model=\"dictAddCtrl.newDict.wordCount\">\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"file\">文件 <span class=\"text-danger\">(必需)</span></label>\n      <input type=\"file\" ngf-select ng-model=\"dictAddCtrl.dictFile\" name=\"file\" required ngf-model-invalid=\"errorFile\"\n        class=\"form-control\">\n    </div>\n\n    <button type=\"submit\" class=\"btn btn-success\" ng-click=\"dictAddCtrl.addDict(dictAddCtrl.dictFile)\">保存</button>\n  </form>\n\n</div>\n"

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _list = __webpack_require__(334);
	
	var _list2 = _interopRequireDefault(_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.dictionaries.list', []).controller('DictionariesListController', _list2.default).name;

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListController = function () {
	
	  /*@ngInject*/
	  ListController.$inject = ['$http'];
	  function ListController($http) {
	    (0, _classCallCheck3.default)(this, ListController);
	
	    this.$http = $http;
	  }
	
	  (0, _createClass3.default)(ListController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getDicts();
	    }
	  }, {
	    key: 'getDicts',
	    value: function getDicts() {
	      var _this = this;
	
	      this.$http.get('/api/1/dictionaries').then(function (res) {
	        _this.dicts = res.data;
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(id) {
	      var _this2 = this;
	
	      if (confirm("确定？")) {
	        this.$http.delete('/api/1/dictionary/' + id).then(function (res) {
	          _this2.getDicts();
	        });
	      }
	    }
	  }]);
	  return ListController;
	}();
	
	exports.default = ListController;

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _edit = __webpack_require__(336);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.Dictionaries.edit', []).controller('DictionariesEditController', _edit2.default).name;

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditController = function () {
	
	  /*@ngInject*/
	  EditController.$inject = ['$http', '$stateParams', '$state'];
	  function EditController($http, $stateParams, $state) {
	    (0, _classCallCheck3.default)(this, EditController);
	
	    this.$http = $http;
	    this.$stateParams = $stateParams;
	    this.$state = $state;
	  }
	
	  (0, _createClass3.default)(EditController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getDict(this.$stateParams.id);
	    }
	  }, {
	    key: 'getDict',
	    value: function getDict(id) {
	      var _this = this;
	
	      this.$http.get('/api/1/dictionary/' + id + '/show').then(function (response) {
	        _this.dict = response.data;
	      });
	    }
	  }, {
	    key: 'updateDict',
	    value: function updateDict(dict) {
	      var _this2 = this;
	
	      this.$http.put('/api/1/dictionary/' + dict._id, this.dict).then(function (response) {
	        _this2.$state.go('dictionaries.list');
	      });
	    }
	  }]);
	  return EditController;
	}();
	
	exports.default = EditController;

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _add = __webpack_require__(338);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.dictionaries.add', []).controller('DictionariesAddController', _add2.default).name;

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(157);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddController = function () {
	
	  /*@ngInject*/
	  AddController.$inject = ['$http', '$state', '$timeout', '$scope', 'Upload', 'toaster'];
	  function AddController($http, $state, $timeout, $scope, Upload, toaster) {
	    (0, _classCallCheck3.default)(this, AddController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$timeout = $timeout;
	    this.Upload = Upload;
	    this.$scope = $scope;
	    this.toaster = toaster;
	
	    this.newDict = {};
	  }
	
	  (0, _createClass3.default)(AddController, [{
	    key: 'addDict',
	    value: function addDict(file) {
	      var _this = this;
	
	      this.toaster.pop({
	        type: 'wait',
	        title: '正在上传',
	        body: file.name,
	        timeout: 3000 * 1000
	      });
	      file.upload = this.Upload.upload({
	        url: '/api/1/dictionary/uploadAndSave',
	        file: file,
	        data: this.newDict,
	        headers: {
	          'Content-Type': 'multipart/form-data'
	        }
	      });
	
	      file.upload.progress(function (evt) {
	        file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
	      });
	
	      file.upload.success(function (data, status, headers, config) {
	        _this.toaster.clear();
	        _this.toaster.pop('success', '上传成功', file.name);
	        _this.$state.go('dictionaries.list');
	      });
	
	      file.upload.error(function (err) {
	        _this.toaster.clear();
	        _this.toaster.pop('error', '上传失败', (0, _stringify2.default)(err));
	      });
	    }
	  }]);
	  return AddController;
	}();
	
	exports.default = AddController;

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(86);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _devices = __webpack_require__(340);
	
	var _devices2 = _interopRequireDefault(_devices);
	
	var _confirm = __webpack_require__(346);
	
	var _confirm2 = _interopRequireDefault(_confirm);
	
	var _list = __webpack_require__(348);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _import = __webpack_require__(350);
	
	var _import2 = _interopRequireDefault(_import);
	
	var _history = __webpack_require__(352);
	
	var _history2 = _interopRequireDefault(_history);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.devices', [_angularUiRouter2.default, _confirm2.default, _list2.default, _import2.default, _history2.default]).config(_devices2.default).run(['$rootScope', function ($rootScope) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
	    if (next.name === 'logout' && current && current.name && !current.authenticate) {
	      next.referrer = current.name;
	    }
	  });
	}]).name;

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $urlRouterProvider.when('/devices', '/devices/list');
	  $stateProvider.state('devices', {
	    url: '/devices',
	    template: __webpack_require__(341),
	    authenticate: true
	  }).state('devices.confirm', {
	    url: '/confirm?code',
	    template: __webpack_require__(342),
	    controller: 'DevicesConfirmController',
	    controllerAs: 'DConfirmCtrl'
	  }).state('devices.list', {
	    url: '/list?page',
	    template: __webpack_require__(343),
	    controller: 'DevicesListController',
	    controllerAs: 'DListCtrl'
	  }).state('devices.import', {
	    url: '/import',
	    template: __webpack_require__(344),
	    controller: 'DevicesImportController',
	    controllerAs: 'DImportCtrl',
	    authenticate: true
	  }).state('devices.history', {
	    url: '/history?page',
	    template: __webpack_require__(345),
	    controller: 'DevicesHistoryController',
	    controllerAs: 'DHistoryCtrl',
	    authenticate: true
	  });
	}];

/***/ }),
/* 341 */
144,
/* 342 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div>\n    <h1 style=\"text-align: center;\">{{DConfirmCtrl.message}}</h1>\n  </div>\n</div>"

/***/ }),
/* 343 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-full\">\n  <div class=\"page-header\">\n    <a ui-sref=\"devices.history\" class=\"btn btn-success pull-right\" style=\"margin-left: 20px;\">变更历史</a>\n    <a ui-sref=\"devices.import\" class=\"btn btn-primary pull-right\">导入</a>\n    <form class=\"form-inline pull-right\" style=\"margin-right: 20px;\">\n      <div class=\"input-group\">\n        <input type=\"text\" class=\"form-control\" placeholder=\"text\" aria-describedby=\"sizing-addon2\" ng-model=\"text\">\n        <span class=\"input-group-addon\" id=\"sizing-addon2\" ng-click=\"DListCtrl.search(text)\">查询</span>\n      </div>\n    </form>\n    <h3>设备</h3>\n  </div>\n  <div class=\"\">\n    <table class=\"table table-striped\">\n      <thead>\n        <tr>\n          <th style=\"width: 50px;\"></th>\n          <th>型号</th>\n          <th>MAC</th>\n          <th>CPU</th>\n          <th>SN</th>\n          <th>时间</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"device in DListCtrl.devices.docs\">\n          <td>{{$index + 1}}</td>\n          <td>{{device.model}}</td>\n          <td>{{device.mac}}</td>\n          <td>{{device.cpu}}</td>\n          <td>{{device.deviceSN}}</td>\n          <td>{{device.createdAt | date:'yyyy-MM-dd'}}</td>\n        </tr>\n      </tbody>\n    </table>\n\n    <div class=\"pagination-div\" ng-show=\"DListCtrl.devices.total > 0\">\n      <ul uib-pagination data-ng-if=\"DListCtrl.devices.total\" total-items=\"DListCtrl.devices.total\"\n        ng-model=\"DListCtrl.page\" max-size=\"5\" class=\"\" boundary-link-numbers=\"true\" rotate=\"false\"\n        ng-change=\"DListCtrl.pageChanged()\" items-per-page=\"DListCtrl.params.limit\" previous-text=\"上一页\"\n        next-text=\"下一页\"></ul>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 344 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h3>导入</h3>\n  <form>\n    <div class=\"form-group\">\n      <label for=\"file\" class=\"text-danger\">文件 <span>(必需)</span></label>\n      <input type=\"file\" ngf-select ng-model=\"DImportCtrl.file\" name=\"file\" required ngf-model-invalid=\"errorFile\" class=\"form-control\">\n    </div>\n    \n    <button type=\"submit\" class=\"btn btn-success\" ng-click=\"DImportCtrl.upload(DImportCtrl.file)\">导入</button>\n  </form>\n</div>"

/***/ }),
/* 345 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-full\">\n  <div class=\"page-header\">\n    <!-- <form class=\"form-inline pull-right\" style=\"margin-right: 20px;\">\n      <div class=\"input-group\">\n        <input type=\"text\" class=\"form-control\" placeholder=\"text\" aria-describedby=\"sizing-addon2\" ng-model=\"text\">\n        <span class=\"input-group-addon\" id=\"sizing-addon2\" ng-click=\"DHistoryCtrl.search(text)\">查询</span>\n      </div>\n    </form> -->\n    <h3>变更历史</h3>\n  </div>\n  <div class=\"\">\n    <table class=\"table table-striped\">\n      <thead>\n        <tr>\n          <th style=\"width: 50px;\"></th>\n          <th>型号</th>\n          <th>MAC</th>\n          <th>CPU</th>\n          <th>旧SN</th>\n          <th>新SN</th>\n          <th>时间</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"device in DHistoryCtrl.devices.list\">\n          <td>{{$index + 1}}</td>\n          <td>{{device.model}}</td>\n          <td>{{device.mac}}</td>\n          <td>{{device.cpu}}</td>\n          <td>{{device.oldDeviceSN}}</td>\n          <td>{{device.deviceSN}}</td>\n          <td>{{device.createdAt | date:'yyyy-MM-dd'}}</td>\n        </tr>\n      </tbody>\n    </table>\n\n    <div class=\"pagination-div\" ng-show=\"DHistoryCtrl.devices.count > 0\">\n      <ul uib-pagination data-ng-if=\"DHistoryCtrl.devices.count\" total-items=\"DHistoryCtrl.devices.count\"\n        ng-model=\"DHistoryCtrl.page\" max-size=\"5\" class=\"\" boundary-link-numbers=\"true\" rotate=\"false\"\n        ng-change=\"DHistoryCtrl.pageChanged()\" items-per-page=\"DHistoryCtrl.params.pageSize\" previous-text=\"上一页\"\n        next-text=\"下一页\"></ul>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _confirm = __webpack_require__(347);
	
	var _confirm2 = _interopRequireDefault(_confirm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.devices.confirm', []).controller('DevicesConfirmController', _confirm2.default).name;

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConfirmController = function () {
	
	  /*@ngInject*/
	  ConfirmController.$inject = ['$http', '$stateParams', '$state', '$rootScope'];
	  function ConfirmController($http, $stateParams, $state, $rootScope) {
	    (0, _classCallCheck3.default)(this, ConfirmController);
	
	    this.$http = $http;
	    this.$stateParams = $stateParams;
	    this.$state = $state;
	    this.$rootScope = $rootScope;
	    this.$rootScope.public_page = true;
	  }
	
	  (0, _createClass3.default)(ConfirmController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.confirm();
	    }
	  }, {
	    key: 'confirm',
	    value: function confirm() {
	      var _this = this;
	
	      this.$http.get('/api/devices/confirm?code=' + this.$stateParams.code).then(function (res) {
	        _this.message = res.data.data.msg;
	      });
	    }
	  }]);
	  return ConfirmController;
	}();
	
	exports.default = ConfirmController;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _list = __webpack_require__(349);
	
	var _list2 = _interopRequireDefault(_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.devices.list', []).controller('DevicesListController', _list2.default).name;

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListController = function () {
	
	  /*@ngInject*/
	  ListController.$inject = ['$http', '$stateParams', '$state'];
	  function ListController($http, $stateParams, $state) {
	    (0, _classCallCheck3.default)(this, ListController);
	
	    this.$http = $http;
	    this.$stateParams = $stateParams;
	    this.$state = $state;
	
	    this.page = 1;
	    this.params = {
	      offset: this.page - 1,
	      limit: 100,
	      sortBy: 'createdAt',
	      order: -1
	    };
	  }
	
	  (0, _createClass3.default)(ListController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      if (this.$stateParams.page) {
	        this.page = this.$stateParams.page;
	      }
	      this.getDevices();
	    }
	  }, {
	    key: 'getDevices',
	    value: function getDevices() {
	      var _this = this;
	
	      this.params.offset = (this.page - 1) * this.params.limit;
	      this.$http.get('/api/devices', { params: this.params }).then(function (res) {
	        _this.devices = res.data.data;
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(id) {
	      var _this2 = this;
	
	      if (confirm('确定？')) {
	        this.$http.delete('/api/devices/' + id).then(function (res) {
	          _this2.getDevices();
	        });
	      }
	    }
	  }, {
	    key: 'pageChanged',
	    value: function pageChanged() {
	      this.$state.go('devices.list', { page: this.page });
	    }
	  }, {
	    key: 'search',
	    value: function search(text) {
	      var _this3 = this;
	
	      this.$http.get('/api/devices/search?search=' + text).then(function (res) {
	        _this3.devices = res.data.data;
	      });
	    }
	  }]);
	  return ListController;
	}();
	
	exports.default = ListController;

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _import = __webpack_require__(351);
	
	var _import2 = _interopRequireDefault(_import);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.devices.import', []).controller('DevicesImportController', _import2.default).name;

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(157);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImportController = function () {
	
	  /*@ngInject*/
	  ImportController.$inject = ['$http', '$state', 'Upload', 'toaster'];
	  function ImportController($http, $state, Upload, toaster) {
	    (0, _classCallCheck3.default)(this, ImportController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.Upload = Upload;
	    this.toaster = toaster;
	  }
	
	  (0, _createClass3.default)(ImportController, [{
	    key: 'upload',
	    value: function upload(file) {
	      var _this = this;
	
	      if (!file) {
	        return;
	      }
	      this.toaster.pop({
	        type: 'wait',
	        title: '正在上传，请稍等...',
	        body: file.name,
	        timeout: 3000 * 1000
	      });
	
	      file.upload = this.Upload.upload({
	        url: '/api/devices/import',
	        file: file,
	        data: this.newConf,
	        headers: {
	          'Content-Type': 'multipart/form-data'
	        }
	      });
	
	      file.upload.progress(function (evt) {
	        file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
	      });
	
	      file.upload.success(function (data, status, headers, config) {
	        _this.$state.go('devices.list');
	        _this.toaster.clear();
	        _this.toaster.pop('success', '上传成功', file.name);
	      });
	
	      file.upload.error(function (err) {
	        _this.toaster.clear();
	        _this.toaster.pop('error', '上传失败', (0, _stringify2.default)(err));
	      });
	    }
	  }]);
	  return ImportController;
	}();
	
	exports.default = ImportController;

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _history = __webpack_require__(353);
	
	var _history2 = _interopRequireDefault(_history);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.devices.history', []).controller('DevicesHistoryController', _history2.default).name;

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HistoryController = function () {
	
	  /*@ngInject*/
	  HistoryController.$inject = ['$http', '$stateParams', '$state'];
	  function HistoryController($http, $stateParams, $state) {
	    (0, _classCallCheck3.default)(this, HistoryController);
	
	    this.$http = $http;
	    this.$stateParams = $stateParams;
	    this.$state = $state;
	
	    this.page = 1;
	    this.params = {
	      offset: this.page - 1,
	      pageSize: 100,
	      sortBy: 'createdAt',
	      order: -1
	    };
	  }
	
	  (0, _createClass3.default)(HistoryController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      if (this.$stateParams.page) {
	        this.page = this.$stateParams.page;
	      }
	      if (this.$stateParams.pageSize) {
	        this.params.pageSize = this.$stateParams.pageSize;
	      }
	      this.getDevices();
	    }
	  }, {
	    key: 'getDevices',
	    value: function getDevices() {
	      var _this = this;
	
	      this.params.offset = (this.page - 1) * this.params.pageSize;
	      this.params.page = this.page;
	      this.$http.get('/api/devices/getGenHistory', { params: this.params }).then(function (res) {
	        _this.devices = res.data.data;
	      });
	    }
	  }, {
	    key: 'pageChanged',
	    value: function pageChanged() {
	      this.$state.go('devices.history', { page: this.page, pageSize: this.params.pageSize });
	    }
	  }]);
	  return HistoryController;
	}();
	
	exports.default = HistoryController;

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(86);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _myscripts = __webpack_require__(355);
	
	var _myscripts2 = _interopRequireDefault(_myscripts);
	
	var _list = __webpack_require__(364);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _show = __webpack_require__(366);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _add = __webpack_require__(368);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _edit = __webpack_require__(370);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _active = __webpack_require__(372);
	
	var _active2 = _interopRequireDefault(_active);
	
	var _model = __webpack_require__(374);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _addModel = __webpack_require__(376);
	
	var _addModel2 = _interopRequireDefault(_addModel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.myscripts', [_angularUiRouter2.default, _list2.default, _show2.default, _add2.default, _edit2.default, _active2.default, _model2.default, _addModel2.default]).config(_myscripts2.default).run(['$rootScope', function ($rootScope) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
	    if (next.name === 'logout' && current && current.name && !current.authenticate) {
	      next.referrer = current.name;
	    }
	  });
	}]).name;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $urlRouterProvider.when('/myscripts', '/myscripts/list');
	
	  $stateProvider.state('myscripts', {
	    url: '/myscripts',
	    template: __webpack_require__(356),
	    authenticate: true
	  }).state('myscripts.list', {
	    url: '/list',
	    template: __webpack_require__(357),
	    controller: 'MyScriptsListController',
	    controllerAs: 'msListCtrl'
	  }).state('myscripts.show', {
	    url: '/show/:id',
	    template: __webpack_require__(358),
	    controller: 'MyScriptsShowController',
	    controllerAs: 'msShowCtrl'
	  }).state('myscripts.add', {
	    url: '/add',
	    template: __webpack_require__(359),
	    controller: 'MyScriptsAddController',
	    controllerAs: 'msAddCtrl'
	  }).state('myscripts.edit', {
	    url: '/edit/:id',
	    template: __webpack_require__(360),
	    controller: 'MyScriptsEditController',
	    controllerAs: 'msEditCtrl'
	  }).state('myscripts.active', {
	    url: '/active',
	    template: __webpack_require__(361),
	    controller: 'MyScriptsActiveController',
	    controllerAs: 'msActiveCtrl'
	  }).state('myscripts.model', {
	    url: '/model',
	    template: __webpack_require__(362),
	    controller: 'MyScriptsModelController',
	    controllerAs: 'msModelCtrl'
	  }).state('myscripts.addModel', {
	    url: '/addModel',
	    template: __webpack_require__(363),
	    controller: 'MyScriptsAddModelController',
	    controllerAs: 'msAddModelCtrl'
	  });
	}];

/***/ }),
/* 356 */
144,
/* 357 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"ctrl-panel\">\n    <a ui-sref=\"myscripts.add\" class=\"btn btn-primary pull-right\">添加</a>\n    <a ui-sref=\"myscripts.active\" class=\"btn btn-success pull-right margin-right-10\">激活列表</a>\n    <a ui-sref=\"myscripts.model\" class=\"btn btn-primary pull-right margin-right-10\">允许型号</a>\n    <div class=\"form-group col-md-2 pull-right\">\n      <select class=\"form-control\" ng-model=\"msListCtrl.version\">\n        <option ng-repeat=\"c in msListCtrl.versions\" value=\"{{c.value}}\">{{c.name}}</option>\n      </select>\n    </div>\n    <h3>MyScripts数据</h3>\n  </div>\n\n  <div class=\"\">\n    <table class=\"table table-striped\">\n      <thead>\n        <tr>\n          <th>语言</th>\n          <th>版本</th>\n          <th>MD5</th>\n          <th>下载地址</th>\n          <th class=\"ctrl-th\"></th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"item in msListCtrl.data\">\n          <td>{{item.lang}}</td>\n          <td>{{item.version}}</td>\n          <td>{{item.md5}}</td>\n          <td>{{item.url}}</td>\n          <td class=\"ctrl-td\">\n            <button ui-sref=\"myscripts.edit({id: item._id})\" class=\"btn btn-xs btn-primary\">编辑</button>\n            <button ng-click=\"msListCtrl.delete(item._id)\" class=\"btn btn-xs btn-danger\">删除</button>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 358 */
141,
/* 359 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <form>\n    <label>添加</label>\n\n    <div class=\"form-group\">\n      <label for=\"lang\">语言<span class=\"text-danger\">(必需)</span></label>\n      <input type=\"lang\" class=\"form-control\" ng-model=\"msAddCtrl.newData.lang\" required>\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"version\">版本<span class=\"text-danger\">(必需)</span></label>\n      <input type=\"number\" class=\"form-control\" ng-model=\"msAddCtrl.newData.version\">\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"file\" class=\"text-danger\">文件 <span>(必需)</span></label>\n      <input type=\"file\" ngf-select ng-model=\"msAddCtrl.file\" name=\"file\" required ngf-model-invalid=\"errorFile\" class=\"form-control\">\n    </div>\n\n    <button type=\"submit\" class=\"btn btn-success\" ng-click=\"msAddCtrl.upload(msAddCtrl.file)\">保存</button>\n  </form>\n</div>\n"

/***/ }),
/* 360 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <form>\n    <label>更新</label>\n\n    <div class=\"form-group\">\n      <label for=\"lang\">语言<span class=\"text-danger\">(必需)</span></label>\n      <input type=\"lang\" class=\"form-control\" ng-model=\"msEditCtrl.data.lang\" required>\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"version\">版本<span class=\"text-danger\">(必需)</span></label>\n      <input type=\"number\" class=\"form-control\" ng-model=\"msEditCtrl.data.version\">\n    </div>\n\n\n    <button type=\"submit\" class=\"btn btn-success\" ng-click=\"msEditCtrl.update()\">保存</button>\n  </form>\n</div>\n"

/***/ }),
/* 361 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"ctrl-panel\">\n    <h3>MyScripts激活列表</h3>\n    <p>总数: {{msActiveCtrl.data.count}}</p>\n  </div>\n\n  <div class=\"\">\n    <table class=\"table table-striped\">\n      <thead>\n        <tr>\n          <th>型号</th>\n          <th>MAC</th>\n          <th>FINGERPRINT</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"item in msActiveCtrl.data.list\">\n          <td>{{item.model}}</td>\n          <td>{{item.mac}}</td>\n          <td>{{item.fingerprint}}</td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n\n<div class=\"pagination\" ng-show=\"msActiveCtrl.data.count > 0\">\n  <ul uib-pagination data-ng-if=\"msActiveCtrl.data.count\" total-items=\"msActiveCtrl.data.count\" ng-model=\"msActiveCtrl.page\"\n    max-size=\"10\" class=\"\" boundary-link-numbers=\"true\" rotate=\"false\" ng-change=\"msActiveCtrl.pageChanged()\"\n    items-per-page=\"msActiveCtrl.limit\" previous-text=\"上一页\" next-text=\"下一页\"></ul>\n</div>\n</div>"

/***/ }),
/* 362 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"ctrl-panel\">\n    <a ui-sref=\"myscripts.addModel\" class=\"btn btn-primary pull-right\">添加</a>\n    <h3>允许激活MyScripts的型号</h3>\n  </div>\n\n  <div class=\"\">\n    <table class=\"table table-striped\">\n      <thead>\n        <tr>\n          <th>型号</th>\n          <th>fingerprint</th>\n          <th class=\"ctrl-th\"></th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"item in msModelCtrl.data\">\n          <td>{{item.model}}</td>\n          <td style=\"white-space: pre;\">{{item.fingerprints.join('\\r\\n')}}</td>\n          <td class=\"ctrl-td\">\n            <button ng-click=\"msModelCtrl.delete(item._id)\" class=\"btn btn-xs btn-danger\">删除</button>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 363 */
/***/ (function(module, exports) {

	module.exports = "\n<div class=\"container\">\n  <div class=\"page-header\">\n    <h1>添加</h1>\n  </div>\n  <div>\n    <form>\n\n      <div class=\"form-group\">\n        <label for=\"name\">型号</label>\n        <input type=\"name\" class=\"form-control\" ng-model=\"msAddModelCtrl.newModel.model\" required>\n      </div>\n\n      <div class=\"form-group\">\n          <label for=\"fingerprints\">fingerprint\n              <span class=\"text-danger\">（每行一条记录）</span>\n          </label>\n          <textarea type=\"fingerprints\" class=\"form-control\" ng-model=\"msAddModelCtrl.newModel.fingerprints\" ng-list=\"&#10;\" ng-trim=\"false\"\n              rows=\"5\"></textarea>\n        </div>\n\n      <button type=\"submit\" class=\"btn btn-success\" ng-click=\"msAddModelCtrl.save()\">保存</button>\n    </form>\n  </div>\n</div>\n"

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _list = __webpack_require__(365);
	
	var _list2 = _interopRequireDefault(_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.myscripts.list', []).controller('MyScriptsListController', _list2.default).name;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListController = function () {
	
	  /*@ngInject*/
	  ListController.$inject = ['$http', '$state', '$scope'];
	  function ListController($http, $state, $scope) {
	    (0, _classCallCheck3.default)(this, ListController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$scope = $scope;
	    this.versions = [{
	      value: 1.2,
	      name: '1.2'
	    }, {
	      value: 1.5,
	      name: '1.5'
	    }, {
	      value: 2.1,
	      name: '2.1'
	    }, {
	      value: 2.3,
	      name: '2.3'
	    }, {
	      value: 2.4,
	      name: '2.4'
	    }, {
	      value: 2.5,
	      name: '2.5'
	    }, {
	      value: 2.6,
	      name: '2.6'
	    }, {
	      value: 2.7,
	      name: '2.7'
	    }, {
	      value: 2.8,
	      name: '2.8'
	    }, {
	      value: 2.9,
	      name: '2.9'
	    }, {
	      value: 3.0,
	      name: '3.0'
	    }];
	    this.version = 2.3;
	  }
	
	  (0, _createClass3.default)(ListController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.$scope.$watch('msListCtrl.version', function (c) {
	        if (c !== undefined && c !== null) {
	          _this.getData();
	        }
	      });
	
	      this.getData();
	    }
	  }, {
	    key: 'getData',
	    value: function getData() {
	      var _this2 = this;
	
	      this.$http.get('/api/myscripts?version=' + this.version).then(function (res) {
	        _this2.data = res.data;
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(id) {
	      var _this3 = this;
	
	      if (confirm('确定？')) {
	        this.$http.delete('api/myscripts/' + id).then(function (response) {
	          _this3.getData();
	        });
	      }
	    }
	  }]);
	  return ListController;
	}();
	
	exports.default = ListController;

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _show = __webpack_require__(367);
	
	var _show2 = _interopRequireDefault(_show);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.myscripts.show', []).controller('MyScriptsShowController', _show2.default).name;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ShowController = function () {
	
	  /*@ngInject*/
	  ShowController.$inject = ['$http', '$state', '$stateParams'];
	  function ShowController($http, $state, $stateParams) {
	    (0, _classCallCheck3.default)(this, ShowController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	  }
	
	  (0, _createClass3.default)(ShowController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getData(this.$stateParams.id);
	    }
	  }, {
	    key: 'getData',
	    value: function getData(id) {
	      var _this = this;
	
	      this.$http.get('/api/myscripts/' + id).then(function (res) {
	        _this.data = res.data;
	      });
	    }
	  }]);
	  return ShowController;
	}();
	
	exports.default = ShowController;

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _add = __webpack_require__(369);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.myscripts.add', []).controller('MyScriptsAddController', _add2.default).name;

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(157);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddController = function () {
	
	  /*@ngInject*/
	  AddController.$inject = ['$http', '$state', 'Upload', 'toaster'];
	  function AddController($http, $state, Upload, toaster) {
	    (0, _classCallCheck3.default)(this, AddController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.Upload = Upload;
	    this.toaster = toaster;
	
	    this.newData = {};
	  }
	
	  (0, _createClass3.default)(AddController, [{
	    key: 'upload',
	    value: function upload(file) {
	      var _this = this;
	
	      this.toaster.pop({
	        type: 'wait',
	        title: '正在上传APK，请稍等...',
	        body: file.name,
	        timeout: 3000 * 1000
	      });
	
	      file.upload = this.Upload.upload({
	        url: '/api/myscripts/upload',
	        file: file,
	        data: this.newData,
	        headers: {
	          'Content-Type': 'multipart/form-data'
	        }
	      });
	
	      file.upload.progress(function (evt) {
	        file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
	      });
	
	      file.upload.success(function (data, status, headers, config) {
	        _this.toaster.clear();
	        _this.$state.go('myscripts.list');
	        _this.toaster.pop('success', '上传成功', file.name);
	      });
	
	      file.upload.error(function (err) {
	        _this.toaster.clear();
	        _this.toaster.pop('error', '上传失败', (0, _stringify2.default)(err));
	      });
	    }
	  }]);
	  return AddController;
	}();
	
	exports.default = AddController;

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _edit = __webpack_require__(371);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.myscripts.edit', []).controller('MyScriptsEditController', _edit2.default).name;

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditController = function () {
	
	  /*@ngInject*/
	  EditController.$inject = ['$http', '$state', '$stateParams'];
	  function EditController($http, $state, $stateParams) {
	    (0, _classCallCheck3.default)(this, EditController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	  }
	
	  (0, _createClass3.default)(EditController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getData(this.$stateParams.id);
	    }
	  }, {
	    key: 'getData',
	    value: function getData(id) {
	      var _this = this;
	
	      this.$http.get('/api/myscripts/' + id).then(function (res) {
	        _this.data = res.data;
	      });
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var _this2 = this;
	
	      this.$http.put('api/myscripts/' + this.$stateParams.id, this.data).then(function (res) {
	        _this2.$state.go('myscripts.list');
	      });
	    }
	  }]);
	  return EditController;
	}();
	
	exports.default = EditController;

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _active = __webpack_require__(373);
	
	var _active2 = _interopRequireDefault(_active);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.myscripts.active', []).controller('MyScriptsActiveController', _active2.default).name;

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActiveController = function () {
	
	  /*@ngInject*/
	  ActiveController.$inject = ['$http', '$stateParams'];
	  function ActiveController($http, $stateParams) {
	    (0, _classCallCheck3.default)(this, ActiveController);
	
	    this.$http = $http;
	    this.$stateParams = $stateParams;
	
	    this.limit = 50;
	    this.page = 1;
	  }
	
	  (0, _createClass3.default)(ActiveController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.page = this.$stateParams.page || 1;
	      this.getData();
	    }
	  }, {
	    key: 'getData',
	    value: function getData() {
	      var _this = this;
	
	      var params = {
	        page: this.page,
	        limit: this.limit
	      };
	      this.$http.get('/api/myScriptActives', { params: params }).then(function (res) {
	        console.log('===============');
	        _this.data = res.data;
	      });
	    }
	  }, {
	    key: 'pageChanged',
	    value: function pageChanged() {
	      this.getData();
	    }
	  }]);
	  return ActiveController;
	}();
	
	exports.default = ActiveController;

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _model = __webpack_require__(375);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.myscripts.model', []).controller('MyScriptsModelController', _model2.default).name;

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModelController = function () {
	
	  /*@ngInject*/
	  ModelController.$inject = ['$http', '$state', '$scope'];
	  function ModelController($http, $state, $scope) {
	    (0, _classCallCheck3.default)(this, ModelController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$scope = $scope;
	  }
	
	  (0, _createClass3.default)(ModelController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getData();
	    }
	  }, {
	    key: 'getData',
	    value: function getData() {
	      var _this = this;
	
	      this.$http.get('/api/myScriptModels').then(function (res) {
	        _this.data = res.data;
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(id) {
	      var _this2 = this;
	
	      if (confirm('确定？')) {
	        this.$http.delete('api/myScriptModels/' + id).then(function (response) {
	          _this2.getData();
	        });
	      }
	    }
	  }]);
	  return ModelController;
	}();
	
	exports.default = ModelController;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _addModel = __webpack_require__(377);
	
	var _addModel2 = _interopRequireDefault(_addModel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.myscripts.addmodel', []).controller('MyScriptsAddModelController', _addModel2.default).name;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddModelController = function () {
	
	  /*@ngInject*/
	  AddModelController.$inject = ['$http', '$state'];
	  function AddModelController($http, $state) {
	    (0, _classCallCheck3.default)(this, AddModelController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.newModel = {};
	  }
	
	  (0, _createClass3.default)(AddModelController, [{
	    key: 'save',
	    value: function save() {
	      var _this = this;
	
	      this.$http.post('/api/myScriptModels', this.newModel).then(function (res) {
	        _this.$state.go('myscripts.model');
	      });
	    }
	  }]);
	  return AddModelController;
	}();
	
	exports.default = AddModelController;

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(86);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _categories = __webpack_require__(379);
	
	var _categories2 = _interopRequireDefault(_categories);
	
	var _list = __webpack_require__(385);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _show = __webpack_require__(387);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _add = __webpack_require__(389);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _edit = __webpack_require__(391);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.categories', [_angularUiRouter2.default, _list2.default, _show2.default, _add2.default, _edit2.default]).config(_categories2.default).run(['$rootScope', function ($rootScope) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
	    if (next.name === 'logout' && current && current.name && !current.authenticate) {
	      next.referrer = current.name;
	    }
	  });
	}]).name;

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $urlRouterProvider.when("/categories", "/categories/list");
	
	  $stateProvider.state('categories', {
	    url: '/categories',
	    template: __webpack_require__(380),
	    authenticate: true
	  }).state('categories.list', {
	    url: '/list?category',
	    template: __webpack_require__(381),
	    controller: 'CategoriesListController',
	    controllerAs: 'cListCtrl'
	  }).state('categories.add', {
	    url: '/add',
	    template: __webpack_require__(382),
	    controller: 'CategoriesAddController',
	    controllerAs: 'cAddCtrl'
	  }).state('categories.edit', {
	    url: '/edit/:id',
	    template: __webpack_require__(383),
	    controller: 'CategoriesEditController',
	    controllerAs: 'cEditCtrl'
	  }).state('categories.show', {
	    url: '/show/:id',
	    template: __webpack_require__(384),
	    controller: 'CategoriesShowController',
	    controllerAs: 'cShowCtrl'
	  });
	}];

/***/ }),
/* 380 */
/***/ (function(module, exports) {

	module.exports = "<div ui-view ></div>\n"

/***/ }),
/* 381 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"page-header\">\n    <!-- <form class=\"form-inline pull-right\">\n      <p class=\"input-group\">\n        <input type=\"text\" class=\"form-control\" placeholder=\"\" ng-model=\"cListCtrl.name\">\n        <span class=\"input-group-btn\">\n          <button type=\"submit\" class=\"btn btn-success\" ng-click=\"cListCtrl.add()\">添加</button>\n        </span>\n      </p>\n    </form> -->\n    <h3>分类</h3>\n  </div>\n  <div class=\"\">\n    <table class=\"table table-striped\">\n      <thead>\n        <tr>\n          <th></th>\n          <th>名称</th>\n          <th class=\"ctrl-th\"></th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"c in cListCtrl.categories\">\n          <td>{{$index + 1}}</td>\n          <td>{{c.name}}</td>\n          <td class=\"ctrl-td\">\n            <button ui-sref=\"categories.show({id: c._id})\" class=\"btn btn-xs btn-success\">详细</button>\n            <button ui-sref=\"categories.edit({id: c._id})\" class=\"btn btn-xs btn-success\">编辑</button>\n            <button ng-click=\"cListCtrl.delete(c._id)\" class=\"btn btn-xs btn-danger\">删除</button>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 382 */
/***/ (function(module, exports) {

	module.exports = ""

/***/ }),
/* 383 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"page-header\">\n    <h1>编辑</h1>\n  </div>\n  <div>\n    <form>\n      <div class=\"form-group\">\n        <label for=\"name\">名称\n          <span class=\"text-danger\">(必需)</span>\n        </label>\n        <input type=\"name\" class=\"form-control\" ng-model=\"cEditCtrl.category.name\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"model\">多语言(zh_CN:中文)</label><button class=\"btn btn-success btn-sm lang-add\" ng-click=\"cEditCtrl.addLang()\">添加</button>\n        <div ng-repeat=\"lang in cEditCtrl.langs\" class=\"row lang-input\">\n          <div class=\"col-md-6\">\n            <input type=\"model\" class=\"form-control\" ng-model=\"lang[0]\">\n          </div>\n          <div class=\"col-md-6\">\n            <input type=\"model\" class=\"form-control\" ng-model=\"lang[1]\">\n          </div>\n        </div>\n      </div>\n\n      <div class=\"clearfix\">\n        <label for=\"\">设备型号组</label>\n        <ul class=\"check-list\">\n          <li ng-repeat=\"group in cEditCtrl.groups\" class=\"\">\n            <input type=\"checkbox\" name=\"modelGroups[]\" value=\"{{group._id}}\"\n              ng-checked=\"cEditCtrl.category.modelGroups.indexOf(group._id) > -1\"\n              ng-click=\"cEditCtrl.toggleSelection(group._id)\">\n            <span>{{group.name}}</span>\n          </li>\n        </ul>\n      </div>\n\n      <button type=\"submit\" class=\"btn btn-success\" ng-click=\"cEditCtrl.save()\">保存</button>\n      <button type=\"button\" class=\"btn btn-default\" ui-sref=\"^\">返回</button>\n    </form>\n  </div>\n</div>"

/***/ }),
/* 384 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"page-header\">\n    \n    <form class=\"form-inline pull-right\">\n      <p class=\"input-group\">\n        <input type=\"text\" class=\"form-control\" placeholder=\"\" ng-model=\"cShowCtrl.name\">\n        <span class=\"input-group-btn\">\n          <button type=\"submit\" class=\"btn btn-success\" ng-click=\"cShowCtrl.addChild()\">添加</button>\n        </span>\n      </p>\n    </form>\n    <h3>{{cShowCtrl.category.name}}</h3>\n\n  </div>\n  <div class=\"\">\n    <table class=\"table table-striped\">\n      <thead>\n        <tr>\n          <th></th>\n          <th>名称</th>\n          <th class=\"ctrl-th\"></th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"c in cShowCtrl.category.children\">\n          <td>{{$index + 1}}</td>\n          <td>{{c.name}}</td>\n          <td class=\"ctrl-td\">\n            <button ui-sref=\"categories.show({id: c._id})\" class=\"btn btn-xs btn-success\">详细</button>\n            <button ui-sref=\"categories.edit({id: c._id})\" class=\"btn btn-xs btn-success\">编辑</button>\n            <button ng-click=\"cShowCtrl.delete(c._id)\" class=\"btn btn-xs btn-danger\">删除</button>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _list = __webpack_require__(386);
	
	var _list2 = _interopRequireDefault(_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.categories.list', []).controller('CategoriesListController', _list2.default).name;

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListController = function () {
	
	  /*@ngInject*/
	  ListController.$inject = ['$http', '$state', '$stateParams'];
	  function ListController($http, $state, $stateParams) {
	    (0, _classCallCheck3.default)(this, ListController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	  }
	
	  (0, _createClass3.default)(ListController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var c = this.$stateParams.category;
	      this.getCategories(c);
	    }
	  }, {
	    key: 'getCategories',
	    value: function getCategories(c) {
	      var _this = this;
	
	      var params = {};
	      if (c) {
	        params.category = c;
	      }
	      this.$http.get('/api/categories', { params: params }).then(function (response) {
	        _this.categories = response.data;
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(id) {
	      var _this2 = this;
	
	      if (confirm("确定？")) {
	        this.$http.delete('/api/categories/' + id).then(function (response) {
	          _this2.getApps(_this2.category);
	        });
	      }
	    }
	  }]);
	  return ListController;
	}();
	
	exports.default = ListController;

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _show = __webpack_require__(388);
	
	var _show2 = _interopRequireDefault(_show);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.categories.show', []).controller('CategoriesShowController', _show2.default).name;

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListController = function () {
	
	  /*@ngInject*/
	  ListController.$inject = ['$http', '$state', '$stateParams'];
	  function ListController($http, $state, $stateParams) {
	    (0, _classCallCheck3.default)(this, ListController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	  }
	
	  (0, _createClass3.default)(ListController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getCategory(this.$stateParams.id);
	    }
	  }, {
	    key: 'getCategory',
	    value: function getCategory(id) {
	      var _this = this;
	
	      this.$http.get('/api/categories/' + id).then(function (response) {
	        _this.category = response.data;
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(id) {
	      var _this2 = this;
	
	      if (confirm("确定？")) {
	        this.$http.delete('/api/categories/' + id).then(function (response) {
	          _this2.getCategory(_this2.category._id);
	        });
	      }
	    }
	  }, {
	    key: 'addChild',
	    value: function addChild() {
	      var _this3 = this;
	
	      if (!this.name.trim()) {
	        alert("名称不能为空");
	      }
	      var data = {
	        name: this.name,
	        parent: this.category._id
	      };
	      this.$http.post('/api/categories', data).then(function (res) {
	        _this3.getCategory(_this3.category._id);
	      });
	    }
	  }]);
	  return ListController;
	}();
	
	exports.default = ListController;

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _add = __webpack_require__(390);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.categories.add', []).controller('CategoriesAddController', _add2.default).name;

/***/ }),
/* 390 */
/***/ (function(module, exports) {

	"use strict";

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _edit = __webpack_require__(392);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.categories.edit', []).controller('CategoriesEditController', _edit2.default).name;

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _entries = __webpack_require__(393);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditController = function () {
	
	  /*@ngInject*/
	  EditController.$inject = ['$http', '$state', '$stateParams'];
	  function EditController($http, $state, $stateParams) {
	    (0, _classCallCheck3.default)(this, EditController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.langs = [];
	  }
	
	  (0, _createClass3.default)(EditController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getList();
	      this.getCategories();
	    }
	  }, {
	    key: 'getCategories',
	    value: function getCategories() {
	      var _this = this;
	
	      this.$http.get('/api/categories/' + this.$stateParams.id).then(function (res) {
	        _this.category = res.data;
	        if (_this.category.langs) {
	          _this.langs = (0, _entries2.default)(_this.category.langs);
	        }
	      });
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this2 = this;
	
	      this.langs.forEach(function (lang) {
	        if (!_this2.category.langs) {
	          _this2.category.langs = {};
	        }
	        _this2.category.langs[lang[0]] = lang[1];
	      });
	
	      this.$http.put('/api/categories/' + this.category._id, this.category).then(function (res) {
	        _this2.$state.go('categories');
	      });
	    }
	  }, {
	    key: 'addLang',
	    value: function addLang() {
	      this.langs.push(new Array(2));
	    }
	  }, {
	    key: 'getList',
	    value: function getList() {
	      var _this3 = this;
	
	      this.$http.get('/api/AppConfGroups').then(function (res) {
	        _this3.groups = res.data;
	      });
	    }
	  }, {
	    key: 'toggleSelection',
	    value: function toggleSelection(id) {
	      var idx = this.category.modelGroups.indexOf(id);
	      if (idx > -1) {
	        this.category.modelGroups.splice(idx, 1);
	      } else {
	        this.category.modelGroups.push(id);
	      }
	    }
	  }]);
	  return EditController;
	}();
	
	exports.default = EditController;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(394), __esModule: true };

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(395);
	module.exports = __webpack_require__(8).Object.entries;


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(6);
	var $entries = __webpack_require__(288)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(86);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _carousel = __webpack_require__(397);
	
	var _carousel2 = _interopRequireDefault(_carousel);
	
	var _list = __webpack_require__(403);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _show = __webpack_require__(405);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _add = __webpack_require__(407);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _edit = __webpack_require__(409);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.carousel', [_angularUiRouter2.default, _list2.default, _show2.default, _add2.default, _edit2.default]).config(_carousel2.default).run(['$rootScope', function ($rootScope) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
	    if (next.name === 'logout' && current && current.name && !current.authenticate) {
	      next.referrer = current.name;
	    }
	  });
	}]).name;

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $urlRouterProvider.when("/carousel", "/carousel/list");
	
	  $stateProvider.state('carousel', {
	    url: '/carousel',
	    template: __webpack_require__(398),
	    authenticate: true
	  }).state('carousel.list', {
	    url: '/list?category',
	    template: __webpack_require__(399),
	    controller: 'CarouselListController',
	    controllerAs: 'clCtrl'
	  }).state('carousel.add', {
	    url: '/add',
	    template: __webpack_require__(400),
	    controller: 'CarouselAddController',
	    controllerAs: 'caCtrl'
	  }).state('carousel.edit', {
	    url: '/edit/:id',
	    template: __webpack_require__(401),
	    controller: 'CarouselEditController',
	    controllerAs: 'ceCtrl'
	  }).state('carousel.show', {
	    url: '/show/:id',
	    template: __webpack_require__(402),
	    controller: 'CarouselShowController',
	    controllerAs: 'csCtrl'
	  });
	}];

/***/ }),
/* 398 */
144,
/* 399 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"page-header\">\n    <a ui-sref=\"carousel.add\" class=\"btn btn-primary pull-right\">Add</a>\n    <h3>Carousel</h3>\n  </div>\n  <div class=\"\">\n    <table class=\"table table-striped\">\n      <thead>\n        <tr>\n          <th></th>\n          <th>Model</th>\n          <th>Title</th>\n          <th class=\"ctrl-th\"></th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"c in clCtrl.carousels\">\n          <td>{{$index + 1}}</td>\n          <td>{{c.model}}</td>\n          <td>{{c.title}}</td>\n          <td class=\"ctrl-td\">\n            <button ui-sref=\"carousel.show({id: c._id})\" class=\"btn btn-xs btn-success\">Detail</button>\n            <button ui-sref=\"carousel.edit({id: c._id})\" class=\"btn btn-xs btn-primary\">Edit</button>\n            <button ng-click=\"clCtrl.delete(c._id)\" class=\"btn btn-xs btn-danger\">Delete</button>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 400 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"page-header\">\n    <h1>Add</h1>\n  </div>\n  <div>\n    <form>\n      <div class=\"form-group\">\n        <label for=\"model\">Model\n          <span class=\"text-danger\">(required)</span>\n        </label>\n        <input type=\"model\" class=\"form-control\" ng-model=\"caCtrl.newCarouse.model\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"model\">Title</label>\n        <input type=\"model\" class=\"form-control\" ng-model=\"caCtrl.newCarouse.title\">\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"timeout\">Delay(s)</label>\n        <input type=\"number\" class=\"form-control\" ng-model=\"caCtrl.newCarouse.timeout\">\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"deviceWidth\">Screen Width\n          <span class=\"text-danger\">(required)</span>\n        </label>\n        <input type=\"number\" class=\"form-control\" ng-model=\"caCtrl.newCarouse.deviceWidth\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"deviceHeight\">Screen Height\n          <span class=\"text-danger\">(required)</span>\n        </label>\n        <input type=\"number\" class=\"form-control\" ng-model=\"caCtrl.newCarouse.deviceHeight\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"lines\">Rows\n          <span class=\"text-danger\">(required)</span>\n        </label>\n        <input type=\"number\" class=\"form-control\" ng-model=\"caCtrl.newCarouse.lines\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"devices\">Device MAC\n          <span class=\"text-danger\">（One MAC per line）</span>\n        </label>\n        <textarea type=\"devices\" class=\"form-control\" ng-model=\"caCtrl.newCarouse.devices\" ng-list=\"&#10;\"\n          ng-trim=\"false\" rows=\"5\"></textarea>\n      </div>\n\n      <button type=\"submit\" class=\"btn btn-success\" ng-click=\"caCtrl.save()\">Save</button>\n      <button type=\"button\" class=\"btn btn-default\" ui-sref=\"^\">Back</button>\n    </form>\n  </div>\n</div>"

/***/ }),
/* 401 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"page-header\">\n    <h1>Edit</h1>\n  </div>\n  <div>\n    <form>\n      <div class=\"form-group\">\n        <label for=\"model\">Model\n          <span class=\"text-danger\">(required)</span>\n        </label>\n        <input type=\"model\" class=\"form-control\" ng-model=\"ceCtrl.carousel.model\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"model\">Title</label>\n        <input type=\"model\" class=\"form-control\" ng-model=\"ceCtrl.carousel.title\">\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"timeout\">Delay(s)</label>\n        <input type=\"number\" class=\"form-control\" ng-model=\"ceCtrl.carousel.timeout\">\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"deviceWidth\">Screen Width\n          <span class=\"text-danger\">(required)</span>\n        </label>\n        <input type=\"number\" class=\"form-control\" ng-model=\"ceCtrl.carousel.deviceWidth\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"deviceHeight\">Screen Height\n          <span class=\"text-danger\">(required)</span>\n        </label>\n        <input type=\"number\" class=\"form-control\" ng-model=\"ceCtrl.carousel.deviceHeight\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"lines\">Rows\n          <span class=\"text-danger\">(required)</span>\n        </label>\n        <input type=\"number\" class=\"form-control\" ng-model=\"ceCtrl.carousel.lines\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"devices\">Device MAC\n          <span class=\"text-danger\">（One MAC per line）</span>\n        </label>\n        <textarea type=\"devices\" class=\"form-control\" ng-model=\"ceCtrl.carousel.devices\" ng-list=\"&#10;\" ng-trim=\"false\"\n          rows=\"5\"></textarea>\n      </div>\n\n      <button type=\"submit\" class=\"btn btn-success\" ng-click=\"ceCtrl.save()\">Save</button>\n      <button type=\"button\" class=\"btn btn-default\" ui-sref=\"^\">Back</button>\n    </form>\n  </div>\n</div>"

/***/ }),
/* 402 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"page-header\">\n    <a ui-sref=\"carousel.edit({id: csCtrl.carousel._id})\" class=\"btn btn-primary pull-right\">Edit</a>\n    <label class=\"btn btn-success pull-right margin-right-10\">\n      Upload <input type=\"file\" ngf-select ng-model=\"csCtrl.file\" style=\"display: none !important;\">\n    </label>\n    <h3>Detail</h3>\n  </div>\n\n  <div class=\"\">\n    <table class=\"table table-condensed\">\n      <thead>\n        <tr>\n          <th>Attributes</th>\n          <th>Value</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr>\n          <td>Model</td>\n          <td>{{csCtrl.carousel.model}}</td>\n        </tr>\n        <tr>\n          <td>Title</td>\n          <td>{{csCtrl.carousel.type}}</td>\n        </tr>\n        <tr>\n          <td>Delay(s)</td>\n          <td>{{csCtrl.carousel.timeout}}</td>\n        </tr>\n        <tr>\n          <td>Screen Width</td>\n          <td>{{csCtrl.carousel.deviceWidth}}</td>\n        </tr>\n        <tr>\n          <td>Screen Height</td>\n          <td>{{csCtrl.carousel.deviceHeight}}</td>\n        </tr>\n        <tr>\n          <td>Rows</td>\n          <td>{{csCtrl.carousel.lines}}</td>\n        </tr>\n        <tr>\n          <td>Device MAC</td>\n          <td>{{csCtrl.carousel.devices.join(',')}}</td>\n        </tr>\n      </tbody>\n    </table>\n    <div>\n      <h3>Image</h3>\n      <div class=\"well\" ng-repeat=\"item in csCtrl.carousel.list\">\n        <button class=\"btn btn-danger btn-sm pull-right\" ng-click=\"csCtrl.deleteImg(item._id)\">Delete</button>\n        <h4>Origin Image：</h4>\n        <img src=\"{{item.file.path}}\" alt=\"\" width=\"200\">\n        <hr>\n        <h4>Device：</h4>\n        <div class=\"row\">\n          <div class=\"col-md-6 img-item\" ng-repeat=\"d in item.imgMap\">\n            <div class=\"input-group\">\n              <input type=\"text\" class=\"form-control\" ng-model=\"d.mac\" placeholder=\"mac\">\n              <span class=\"input-group-btn\">\n                <button class=\"btn btn-success\" type=\"button\" ng-click=\"csCtrl.update()\">Set</button>\n              </span>\n            </div>\n            <img src=\"{{d.img}}\" alt=\"\" width=\"200\">\n          </div>\n        </div>\n\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _list = __webpack_require__(404);
	
	var _list2 = _interopRequireDefault(_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.carousel.list', []).controller('CarouselListController', _list2.default).name;

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListController = function () {
	
	  /*@ngInject*/
	  ListController.$inject = ['$http'];
	  function ListController($http) {
	    (0, _classCallCheck3.default)(this, ListController);
	
	    this.$http = $http;
	  }
	
	  (0, _createClass3.default)(ListController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getCarousels();
	    }
	  }, {
	    key: 'getCarousels',
	    value: function getCarousels() {
	      var _this = this;
	
	      this.$http.get('/api/carousels').then(function (res) {
	        _this.carousels = res.data;
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(id) {
	      var _this2 = this;
	
	      if (confirm("确定？")) {
	        this.$http.delete('/api/carousels/' + id).then(function (res) {
	          _this2.getCarousels();
	        });
	      }
	    }
	  }]);
	  return ListController;
	}();
	
	exports.default = ListController;

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _show = __webpack_require__(406);
	
	var _show2 = _interopRequireDefault(_show);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.carousel.show', []).controller('CarouselShowController', _show2.default).name;

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(157);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ShowController = function () {
	
	  /*@ngInject*/
	  ShowController.$inject = ['$http', '$stateParams', '$scope', 'Upload', 'toaster', '$state'];
	  function ShowController($http, $stateParams, $scope, Upload, toaster, $state) {
	    (0, _classCallCheck3.default)(this, ShowController);
	
	    this.$http = $http;
	    this.$stateParams = $stateParams;
	    this.$scope = $scope;
	    this.Upload = Upload;
	    this.toaster = toaster;
	    this.$state = $state;
	  }
	
	  (0, _createClass3.default)(ShowController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.getCarousel(this.$stateParams.id);
	
	      this.$scope.$watch('csCtrl.file', function (file) {
	        console.log(file);
	        if (file !== undefined && file !== null) {
	          _this.uploadImage(file);
	        }
	      });
	    }
	  }, {
	    key: 'getCarousel',
	    value: function getCarousel(id) {
	      var _this2 = this;
	
	      this.$http.get('/api/carousels/' + id).then(function (res) {
	        _this2.carousel = res.data;
	      });
	    }
	  }, {
	    key: 'uploadImage',
	    value: function uploadImage(file) {
	      var _this3 = this;
	
	      this.toaster.pop({
	        type: 'wait',
	        title: '正在上传，请稍等...',
	        body: file.name,
	        timeout: 3000 * 1000
	      });
	
	      file.upload = this.Upload.upload({
	        url: '/api/carousels/' + this.$stateParams.id + '/uploadFile',
	        file: file,
	        headers: {
	          'Content-Type': 'multipart/form-data'
	        }
	      });
	
	      file.upload.progress(function (evt) {
	        file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
	      });
	
	      file.upload.success(function (data, status, headers, config) {
	        _this3.toaster.clear();
	        _this3.carousel = data;
	        _this3.toaster.pop('success', '上传成功', file.name);
	      });
	
	      file.upload.error(function (err) {
	        _this3.toaster.clear();
	        _this3.toaster.pop('error', '上传失败', (0, _stringify2.default)(err));
	      });
	    }
	  }, {
	    key: 'deleteImg',
	    value: function deleteImg(id) {
	      var _this4 = this;
	
	      this.$http.get('/api/carousels/' + this.$stateParams.id + '/removeItem', { params: { item: id } }).then(function (res) {
	        _this4.carousel = res.data;
	      });
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var _this5 = this;
	
	      this.$http.put('/api/carousels/' + this.carousel._id, this.carousel).then(function (res) {
	        _this5.$state.go('carousel.show', {
	          id: res.data._id
	        });
	      });
	    }
	  }]);
	  return ShowController;
	}();
	
	exports.default = ShowController;

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _add = __webpack_require__(408);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.carousel.add', []).controller('CarouselAddController', _add2.default).name;

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddController = function () {
	
	  /*@ngInject*/
	  AddController.$inject = ['$http', '$state', 'toaster'];
	  function AddController($http, $state, toaster) {
	    (0, _classCallCheck3.default)(this, AddController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.toaster = toaster;
	
	    this.newCarouse = {};
	  }
	
	  (0, _createClass3.default)(AddController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this = this;
	
	      if (!this.checkData()) {
	        return;
	      }
	      this.$http.post('/api/carousels', this.newCarouse).then(function (res) {
	        _this.$state.go('carousel.show', { id: res.data._id });
	      });
	    }
	  }, {
	    key: 'checkStr',
	    value: function checkStr(str) {
	      if (str && typeof str == 'string') {
	        str = str.trim();
	      }
	      return str;
	    }
	  }, {
	    key: 'checkArr',
	    value: function checkArr(arr) {
	      var res = false;
	      arr.forEach(function (item) {
	        if (item.trim().length > 0) {
	          res = true;
	        }
	      });
	      return res;
	    }
	  }, {
	    key: 'checkData',
	    value: function checkData() {
	      console.log(this.newCarouse);
	      if (this.checkStr(this.newCarouse.model) && this.newCarouse.deviceWidth && this.newCarouse.deviceHeight && this.checkArr(this.newCarouse.devices)) {
	        return true;
	      }
	
	      this.toaster.pop({
	        type: 'error',
	        title: '请填写必填项',
	        timeout: 3 * 1000
	      });
	      return false;
	    }
	  }]);
	  return AddController;
	}();
	
	exports.default = AddController;

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _edit = __webpack_require__(410);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.carousel.edit', []).controller('CarouselEditController', _edit2.default).name;

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditController = function () {
	
	  /*@ngInject*/
	  EditController.$inject = ['$http', '$state', 'toaster', '$stateParams'];
	  function EditController($http, $state, toaster, $stateParams) {
	    (0, _classCallCheck3.default)(this, EditController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.toaster = toaster;
	    this.$stateParams = $stateParams;
	  }
	
	  (0, _createClass3.default)(EditController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getCarousel();
	    }
	  }, {
	    key: 'getCarousel',
	    value: function getCarousel() {
	      var _this = this;
	
	      this.$http.get('/api/carousels/' + this.$stateParams.id).then(function (res) {
	        _this.carousel = res.data;
	      });
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this2 = this;
	
	      if (!this.checkData()) {
	        return;
	      }
	      this.$http.put('/api/carousels/' + this.carousel._id, this.carousel).then(function (res) {
	        _this2.$state.go('carousel.show', {
	          id: res.data._id
	        });
	      });
	    }
	  }, {
	    key: 'checkStr',
	    value: function checkStr(str) {
	      if (str && typeof str == 'string') {
	        str = str.trim();
	      }
	      return str;
	    }
	  }, {
	    key: 'checkArr',
	    value: function checkArr(arr) {
	      var res = false;
	      arr.forEach(function (item) {
	        if (item.trim().length > 0) {
	          res = true;
	        }
	      });
	      return res;
	    }
	  }, {
	    key: 'checkData',
	    value: function checkData() {
	      if (this.checkStr(this.carousel.model) && this.carousel.deviceWidth && this.carousel.deviceHeight && this.checkArr(this.carousel.devices)) {
	        return true;
	      }
	
	      this.toaster.pop({
	        type: 'error',
	        title: '请填写必填项',
	        timeout: 3 * 1000
	      });
	      return false;
	    }
	  }]);
	  return EditController;
	}();
	
	exports.default = EditController;

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(86);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _writeTpl = __webpack_require__(412);
	
	var _writeTpl2 = _interopRequireDefault(_writeTpl);
	
	var _list = __webpack_require__(417);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _add = __webpack_require__(419);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _edit = __webpack_require__(421);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.writetpl', [_angularUiRouter2.default, _list2.default, _add2.default, _edit2.default]).config(_writeTpl2.default).run(['$rootScope', function ($rootScope) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
	    if (next.name === 'logout' && current && current.name && !current.authenticate) {
	      next.referrer = current.name;
	    }
	  });
	}]).name;

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $urlRouterProvider.when("/writetpl", "/writetpl/list");
	
	  $stateProvider.state('writetpl', {
	    url: '/writetpl',
	    template: __webpack_require__(413),
	    authenticate: true
	  }).state('writetpl.list', {
	    url: '/list',
	    template: __webpack_require__(414),
	    controller: 'WriteTplListController',
	    controllerAs: 'wtListCtrl'
	  }).state('writetpl.add', {
	    url: '/add',
	    template: __webpack_require__(415),
	    controller: 'WriteTplAddController',
	    controllerAs: 'wtAddCtrl'
	  }).state('writetpl.edit', {
	    url: '/edit/:id',
	    template: __webpack_require__(416),
	    controller: 'WriteTplEditController',
	    controllerAs: 'wtEditCtrl'
	  });
	}];

/***/ }),
/* 413 */
144,
/* 414 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"ctrl-panel\">\n    <a ui-sref=\"writetpl.add\" class=\"btn btn-primary pull-right\">添加</a>\n    <h3>手写模板</h3>\n  </div>\n\n  <div class=\"\">\n    <div class=\"row\">\n      <div class=\"col-sm-4 col-md-3\" ng-repeat=\"tpl in wtListCtrl.templates.list\">\n        <div class=\"thumbnail\">\n          <img src=\"{{tpl.file.url}}\" alt=\"...\" class=\"thumbnail-img\">\n          <div class=\"caption\">\n            <h3 class=\"truncate\">{{tpl.title}}</h3>\n            <p class=\"truncate\">型号: {{tpl.model.join('\\\\')}}</p>\n            <p class=\"truncate\">语言: {{tpl.lang.join('\\\\')}}</p>\n            <p>尺寸: {{tpl.dpiW}}x{{tpl.dpiH}}</p>\n            <p>\n              <a class=\"btn btn-primary btn-sm\" role=\"button\" ui-sref=\"writetpl.edit({id: tpl._id})\">编辑</a> \n              <a class=\"btn btn-danger btn-sm\" role=\"button\" ng-click=\"wtListCtrl.delete(tpl._id)\">删除</a>\n            </p>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 415 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <form>\n    <label>添加</label>\n\n    <div class=\"form-group\">\n      <label for=\"file\" class=\"text-danger\">文件 <span>(必需)</span></label>\n      <input type=\"file\" ngf-select ng-model=\"wtAddCtrl.file\" name=\"file\" required ngf-model-invalid=\"errorFile\" class=\"form-control\">\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"title\">标题 <span class=\"text-danger\">(必需)</span></label>\n      <input type=\"string\" class=\"form-control\" ng-model=\"wtAddCtrl.newTpl.title\" required>\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"title\">型号 <span class=\"text-danger\">(多型号用\\隔开)</span></label>\n      <input type=\"string\" class=\"form-control\" ng-model=\"wtAddCtrl.newTpl.model\" ng-list=\"\\\">\n    </div>\n    \n    <div class=\"form-group\">\n      <label for=\"lang\">语言\n        <span class=\"text-danger\">(多种语言用\\隔开)</span>\n      </label>\n      <input type=\"lang\" class=\"form-control\" ng-model=\"wtAddCtrl.newTpl.lang\" ng-list=\"\\\">\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"dpiW\">宽</label>\n      <input type=\"number\" class=\"form-control\" ng-model=\"wtAddCtrl.newTpl.dpiW\" >\n    </div>\n    <div class=\"form-group\">\n      <label for=\"dpiH\">高</label>\n      <input type=\"number\" class=\"form-control\" ng-model=\"wtAddCtrl.newTpl.dpiH\" >\n    </div>\n\n\n    <button type=\"submit\" class=\"btn btn-success\" ng-click=\"wtAddCtrl.upload(wtAddCtrl.file)\">保存</button>\n  </form>\n</div>\n"

/***/ }),
/* 416 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <form>\n    <label>更新</label>\n\n    <div class=\"form-group\">\n      <label for=\"title\">标题 <span class=\"text-danger\">(必需)</span></label>\n      <input type=\"string\" class=\"form-control\" ng-model=\"wtEditCtrl.template.title\" required>\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"title\">型号 <span class=\"text-danger\">(多型号用\\隔开)</span></label>\n      <input type=\"string\" class=\"form-control\" ng-model=\"wtEditCtrl.template.model\" ng-list=\"\\\" >\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"lang\">语言\n        <span class=\"text-danger\">(多种语言用\\隔开)</span>\n      </label>\n      <input type=\"lang\" class=\"form-control\" ng-model=\"wtEditCtrl.template.lang\" ng-list=\"\\\" >\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"dpiW\">宽</label>\n      <input type=\"number\" class=\"form-control\" ng-model=\"wtEditCtrl.template.dpiW\" >\n    </div>\n    <div class=\"form-group\">\n      <label for=\"dpiH\">高</label>\n      <input type=\"number\" class=\"form-control\" ng-model=\"wtEditCtrl.template.dpiH\" >\n    </div>\n\n\n    <button type=\"submit\" class=\"btn btn-success\" ng-click=\"wtEditCtrl.update()\">保存</button>\n  </form>\n</div>\n"

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _list = __webpack_require__(418);
	
	var _list2 = _interopRequireDefault(_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.writetpl.list', []).controller('WriteTplListController', _list2.default).name;

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListController = function () {
	
	  /*@ngInject*/
	  ListController.$inject = ['$http', '$state'];
	  function ListController($http, $state) {
	    (0, _classCallCheck3.default)(this, ListController);
	
	    this.$http = $http;
	    this.$state = $state;
	  }
	
	  (0, _createClass3.default)(ListController, [{
	    key: '$onInit',
	    value: function $onInit() {
	
	      this.getTemplates();
	    }
	  }, {
	    key: 'getTemplates',
	    value: function getTemplates() {
	      var _this = this;
	
	      this.$http.get('/api/writeTemplates').then(function (res) {
	        _this.templates = res.data;
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(id) {
	      var _this2 = this;
	
	      if (confirm("确定？")) {
	        this.$http.delete('api/writeTemplates/' + id).then(function (response) {
	          _this2.getTemplates();
	        });
	      }
	    }
	  }]);
	  return ListController;
	}();
	
	exports.default = ListController;

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _add = __webpack_require__(420);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.writetpl.add', []).controller('WriteTplAddController', _add2.default).name;

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(157);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddController = function () {
	
	  /*@ngInject*/
	  AddController.$inject = ['$http', '$state', 'Upload', 'toaster'];
	  function AddController($http, $state, Upload, toaster) {
	    (0, _classCallCheck3.default)(this, AddController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.Upload = Upload;
	    this.toaster = toaster;
	
	    this.newTpl = {};
	  }
	
	  (0, _createClass3.default)(AddController, [{
	    key: 'upload',
	    value: function upload(file) {
	      var _this = this;
	
	      this.toaster.pop({
	        type: 'wait',
	        title: '正在上传，请稍等...',
	        timeout: 3000 * 1000
	      });
	
	      file.upload = this.Upload.upload({
	        url: '/api/writeTemplates',
	        file: file,
	        data: this.newTpl,
	        headers: {
	          'Content-Type': 'multipart/form-data'
	        }
	      });
	
	      file.upload.progress(function (evt) {
	        file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
	      });
	
	      file.upload.success(function (data, status, headers, config) {
	        _this.toaster.clear();
	        _this.toaster.pop('success', '上传成功', file.name);
	        _this.$state.go('writetpl.list');
	      });
	
	      file.upload.error(function (err) {
	        _this.toaster.clear();
	        _this.toaster.pop('error', '上传失败', (0, _stringify2.default)(err));
	      });
	    }
	  }]);
	  return AddController;
	}();
	
	exports.default = AddController;

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _edit = __webpack_require__(422);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.writetpl.edit', []).controller('WriteTplEditController', _edit2.default).name;

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditController = function () {
	
	  /*@ngInject*/
	  EditController.$inject = ['$http', '$state', '$stateParams'];
	  function EditController($http, $state, $stateParams) {
	    (0, _classCallCheck3.default)(this, EditController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	  }
	
	  (0, _createClass3.default)(EditController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getTemplate(this.$stateParams.id);
	    }
	  }, {
	    key: 'getTemplate',
	    value: function getTemplate(id) {
	      var _this = this;
	
	      this.$http.get('/api/writeTemplates/' + id).then(function (res) {
	        _this.template = res.data;
	      });
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var _this2 = this;
	
	      this.$http.put('/api/writeTemplates/' + this.$stateParams.id, this.template).then(function (res) {
	        _this2.$state.go('writetpl.list');
	      });
	    }
	  }]);
	  return EditController;
	}();
	
	exports.default = EditController;

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(86);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _screenSaver = __webpack_require__(424);
	
	var _screenSaver2 = _interopRequireDefault(_screenSaver);
	
	var _list = __webpack_require__(430);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _add = __webpack_require__(432);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _edit = __webpack_require__(434);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _show = __webpack_require__(436);
	
	var _show2 = _interopRequireDefault(_show);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.screensaver', [_angularUiRouter2.default, _list2.default, _add2.default, _edit2.default, _show2.default]).config(_screenSaver2.default).run(['$rootScope', function ($rootScope) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
	    if (next.name === 'logout' && current && current.name && !current.authenticate) {
	      next.referrer = current.name;
	    }
	  });
	}]).name;

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $urlRouterProvider.when("/screensavers", "/screensavers/list");
	
	  $stateProvider.state('screensavers', {
	    url: '/screensavers',
	    template: __webpack_require__(425),
	    authenticate: true
	  }).state('screensavers.list', {
	    url: '/list',
	    template: __webpack_require__(426),
	    controller: 'ScreenSaverListController',
	    controllerAs: 'ssListCtrl'
	  }).state('screensavers.add', {
	    url: '/add',
	    template: __webpack_require__(427),
	    controller: 'ScreenSaverAddController',
	    controllerAs: 'ssAddCtrl'
	  }).state('screensavers.edit', {
	    url: '/edit/:id',
	    template: __webpack_require__(428),
	    controller: 'ScreenSaverEditController',
	    controllerAs: 'ssEditCtrl'
	  }).state('screensavers.show', {
	    url: '/show/:id',
	    template: __webpack_require__(429),
	    controller: 'ScreenSaverShowController',
	    controllerAs: 'ssShowCtrl'
	  });
	}];

/***/ }),
/* 425 */
144,
/* 426 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"ctrl-panel\">\n    <a ui-sref=\"screensavers.add\" class=\"btn btn-primary pull-right\">添加</a>\n    <h3>屏保</h3>\n  </div>\n\n  <div class=\"\">\n    <div class=\"row\">\n      <div class=\"col-sm-4 col-md-3\" ng-repeat=\"saver in ssListCtrl.screenSavers.list\">\n        <div class=\"thumbnail\">\n          <img src=\"{{saver.files[0].url}}\" alt=\"...\" class=\"thumbnail-img\">\n          <div class=\"caption\">\n            <h3>{{saver.title}}</h3>\n            <p class=\"truncate\">型号：{{saver.model.join('\\\\')}}</p>\n            <p class=\"truncate\">语言：{{saver.lang.join('\\\\')}}</p>\n            <p>数量：{{saver.files.length}}</p>\n            <p>\n              <a class=\"btn btn-success btn-sm\" role=\"button\" ui-sref=\"screensavers.show({id: saver._id})\">详细</a>\n              <a class=\"btn btn-primary btn-sm\" role=\"button\" ui-sref=\"screensavers.edit({id: saver._id})\">编辑</a>\n              <a class=\"btn btn-danger btn-sm\" role=\"button\" ng-click=\"ssListCtrl.delete(saver._id)\">删除</a>\n            </p>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 427 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <form>\n    <label>添加</label>\n\n    <div class=\"form-group\">\n      <label for=\"files\" class=\"text-danger\">文件 <span>(必需)</span></label>\n      <input type=\"file\" ngf-select ngf-multiple=\"true\" ng-model=\"ssAddCtrl.files\" name=\"files\" required ngf-model-invalid=\"errorFile\" class=\"form-control\">\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"title\">标题 <span class=\"text-danger\">(必需)</span></label>\n      <input type=\"string\" class=\"form-control\" ng-model=\"ssAddCtrl.newSaver.title\" required>\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"model\">型号 <span class=\"text-danger\">(多型号用\\隔开)</span></label>\n      <input type=\"string\" class=\"form-control\" ng-model=\"ssAddCtrl.newSaver.model\" ng-list=\"\\\">\n    </div>\n\n    <div class=\"clearfix\">\n      <label for=\"models\">设备型号组</label>\n      <ul class=\"check-list\">\n        <li ng-repeat=\"group in ssAddCtrl.groups\" class=\"\">\n            <input type=\"checkbox\" name=\"modelGroups[]\" value=\"{{group._id}}\" ng-checked=\"ssAddCtrl.newSaver.modelGroups.indexOf(group._id) > -1\"\n                ng-click=\"ssAddCtrl.toggleSelection(group._id)\">\n            <span>{{group.name}}</span>\n        </li>\n      </ul>\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"lang\">语言\n        <span class=\"text-danger\">(必需,多种语言用\\隔开)</span>\n      </label>\n      <input type=\"lang\" class=\"form-control\" ng-model=\"ssAddCtrl.newSaver.lang\" ng-list=\"\\\" required>\n    </div>\n\n\n    <button type=\"submit\" class=\"btn btn-success\" ng-click=\"ssAddCtrl.upload(ssAddCtrl.files)\">保存</button>\n  </form>\n</div>\n"

/***/ }),
/* 428 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <form>\n    <label>添加</label>\n\n    <div class=\"form-group\">\n      <label for=\"title\">标题 <span class=\"text-danger\">(必需)</span></label>\n      <input type=\"string\" class=\"form-control\" ng-model=\"ssEditCtrl.saver.title\" required>\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"model\">型号 <span class=\"text-danger\">(多型号用\\隔开)</span></label>\n      <input type=\"string\" class=\"form-control\" ng-model=\"ssEditCtrl.saver.model\" ng-list=\"\\\">\n    </div>\n\n    <div class=\"clearfix\">\n        <label for=\"\">设备型号组</label>\n        <ul class=\"check-list\">\n          <li ng-repeat=\"group in ssEditCtrl.groups\" class=\"\">\n              <input type=\"checkbox\" name=\"modelGroups[]\" value=\"{{group._id}}\" ng-checked=\"ssEditCtrl.saver.modelGroups.indexOf(group._id) > -1\"\n                  ng-click=\"ssEditCtrl.toggleSelection(group._id)\">\n              <span>{{group.name}}</span>\n          </li>\n        </ul>\n      </div>\n\n    <div class=\"form-group\">\n      <label for=\"lang\">语言\n        <span class=\"text-danger\">(必需,多种语言用\\隔开)</span>\n      </label>\n      <input type=\"lang\" class=\"form-control\" ng-model=\"ssEditCtrl.saver.lang\" ng-list=\"\\\" required>\n    </div>\n\n\n    <button type=\"submit\" class=\"btn btn-success\" ng-click=\"ssEditCtrl.update()\">保存</button>\n  </form>\n</div>\n"

/***/ }),
/* 429 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"ctrl-panel\">\n    <h3>{{ssShowCtrl.saver.title}}</h3>\n    <p>型号：{{ssShowCtrl.saver.model}}</p>\n  </div>\n\n  <div class=\"\">\n    <div class=\"row\">\n      <div class=\"col-sm-4 col-md-3\" ng-repeat=\"img in ssShowCtrl.saver.files\">\n        <div class=\"thumbnail\">\n          <img src=\"{{img.url}}\" alt=\"...\">\n          <div class=\"caption\">\n            <h3>{{img.originalname}}</h3>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _list = __webpack_require__(431);
	
	var _list2 = _interopRequireDefault(_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.screensaver.list', []).controller('ScreenSaverListController', _list2.default).name;

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListController = function () {
	
	  /*@ngInject*/
	  ListController.$inject = ['$http', '$state'];
	  function ListController($http, $state) {
	    (0, _classCallCheck3.default)(this, ListController);
	
	    this.$http = $http;
	    this.$state = $state;
	  }
	
	  (0, _createClass3.default)(ListController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getScreenSaver();
	    }
	  }, {
	    key: 'getScreenSaver',
	    value: function getScreenSaver() {
	      var _this = this;
	
	      this.$http.get('/api/screenSavers').then(function (res) {
	        _this.screenSavers = res.data;
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(id) {
	      var _this2 = this;
	
	      if (confirm("确定？")) {
	        this.$http.delete('api/screenSavers/' + id).then(function (response) {
	          _this2.getScreenSaver();
	        });
	      }
	    }
	  }]);
	  return ListController;
	}();
	
	exports.default = ListController;

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _add = __webpack_require__(433);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.screensaver.add', []).controller('ScreenSaverAddController', _add2.default).name;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(157);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(200);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddController = function () {
	
	  /*@ngInject*/
	  AddController.$inject = ['$http', '$state', 'Upload', 'toaster'];
	  function AddController($http, $state, Upload, toaster) {
	    (0, _classCallCheck3.default)(this, AddController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.Upload = Upload;
	    this.toaster = toaster;
	
	    this.newSaver = {
	      modelGroups: []
	    };
	  }
	
	  (0, _createClass3.default)(AddController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getList();
	    }
	  }, {
	    key: 'upload',
	    value: function upload(files) {
	      var _this = this;
	
	      this.toaster.pop({
	        type: 'wait',
	        title: '正在上传，请稍等...',
	        timeout: 3000 * 1000
	      });
	
	      var upload = this.Upload.upload({
	        url: '/api/screenSavers',
	        arrayKey: '',
	        data: (0, _assign2.default)({ files: files }, this.newSaver),
	        headers: {
	          'Content-Type': 'multipart/form-data'
	        }
	      });
	
	      upload.progress(function (evt) {
	        progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
	      });
	
	      upload.success(function (data, status, headers, config) {
	        _this.toaster.clear();
	        _this.toaster.pop('success', '上传成功');
	        _this.$state.go('screensavers.list');
	      });
	
	      upload.error(function (err) {
	        _this.toaster.clear();
	        _this.toaster.pop('error', '上传失败', (0, _stringify2.default)(err));
	      });
	    }
	  }, {
	    key: 'getList',
	    value: function getList() {
	      var _this2 = this;
	
	      this.$http.get('/api/AppConfGroups').then(function (res) {
	        _this2.groups = res.data;
	      });
	    }
	  }, {
	    key: 'toggleSelection',
	    value: function toggleSelection(id) {
	      var idx = this.newSaver.modelGroups.indexOf(id);
	      if (idx > -1) {
	        this.newSaver.modelGroups.splice(idx, 1);
	      } else {
	        this.newSaver.modelGroups.push(id);
	      }
	    }
	  }]);
	  return AddController;
	}();
	
	exports.default = AddController;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _edit = __webpack_require__(435);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.screensaver.edit', []).controller('ScreenSaverEditController', _edit2.default).name;

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditController = function () {
	
	  /*@ngInject*/
	  EditController.$inject = ['$http', '$state', '$stateParams'];
	  function EditController($http, $state, $stateParams) {
	    (0, _classCallCheck3.default)(this, EditController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	  }
	
	  (0, _createClass3.default)(EditController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getList();
	      this.getScreenSaver(this.$stateParams.id);
	    }
	  }, {
	    key: 'getScreenSaver',
	    value: function getScreenSaver(id) {
	      var _this = this;
	
	      this.$http.get('/api/screenSavers/' + id).then(function (res) {
	        _this.saver = res.data;
	      });
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var _this2 = this;
	
	      this.$http.put('/api/screenSavers/' + this.$stateParams.id, this.saver).then(function (res) {
	        _this2.$state.go('screensavers.list');
	      });
	    }
	  }, {
	    key: 'getList',
	    value: function getList() {
	      var _this3 = this;
	
	      this.$http.get('/api/AppConfGroups').then(function (res) {
	        _this3.groups = res.data;
	      });
	    }
	  }, {
	    key: 'toggleSelection',
	    value: function toggleSelection(id) {
	      var idx = this.saver.modelGroups.indexOf(id);
	      if (idx > -1) {
	        this.saver.modelGroups.splice(idx, 1);
	      } else {
	        this.saver.modelGroups.push(id);
	      }
	    }
	  }]);
	  return EditController;
	}();
	
	exports.default = EditController;

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _show = __webpack_require__(437);
	
	var _show2 = _interopRequireDefault(_show);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.screensaver.show', []).controller('ScreenSaverShowController', _show2.default).name;

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditController = function () {
	
	  /*@ngInject*/
	  EditController.$inject = ['$http', '$state', '$stateParams'];
	  function EditController($http, $state, $stateParams) {
	    (0, _classCallCheck3.default)(this, EditController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	  }
	
	  (0, _createClass3.default)(EditController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getScreenSaver(this.$stateParams.id);
	    }
	  }, {
	    key: 'getScreenSaver',
	    value: function getScreenSaver(id) {
	      var _this = this;
	
	      this.$http.get('/api/screenSavers/' + id).then(function (res) {
	        _this.saver = res.data;
	      });
	    }
	  }]);
	  return EditController;
	}();
	
	exports.default = EditController;

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(86);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _appconfgroups = __webpack_require__(439);
	
	var _appconfgroups2 = _interopRequireDefault(_appconfgroups);
	
	var _list = __webpack_require__(446);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _edit = __webpack_require__(448);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _add = __webpack_require__(450);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _show = __webpack_require__(452);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _addmodel = __webpack_require__(454);
	
	var _addmodel2 = _interopRequireDefault(_addmodel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.appconfgroups', [_angularUiRouter2.default, _list2.default, _edit2.default, _add2.default, _show2.default, _addmodel2.default]).config(_appconfgroups2.default).run(['$rootScope', function ($rootScope) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
	    if (next.name === 'logout' && current && current.name && !current.authenticate) {
	      next.referrer = current.name;
	    }
	  });
	}]).name;

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $urlRouterProvider.when("/appconfgroups", "/appconfgroups/list");
	  $stateProvider.state('appconfgroups', {
	    url: '/appconfgroups',
	    template: __webpack_require__(440),
	    authenticate: true
	  }).state('appconfgroups.list', {
	    url: '/list',
	    template: __webpack_require__(441),
	    controller: 'AppConfGroupsListController',
	    controllerAs: 'appconfgroupsListCtrl'
	  }).state('appconfgroups.edit', {
	    url: '/edit/:id',
	    template: __webpack_require__(442),
	    controller: 'AppConfGroupsEditController',
	    controllerAs: 'appconfgroupsEditCtrl'
	  }).state('appconfgroups.add', {
	    url: '/add',
	    template: __webpack_require__(443),
	    controller: 'AppConfGroupsAddController',
	    controllerAs: 'appconfgroupsAddCtrl'
	  }).state('appconfgroups.show', {
	    url: '/show/:id',
	    template: __webpack_require__(444),
	    controller: 'AppConfGroupsShowController',
	    controllerAs: 'appconfgroupsShowCtrl'
	  }).state('appconfgroups.addmodel', {
	    url: '/:id/addmodel',
	    template: __webpack_require__(445),
	    controller: 'AppConfGroupsAddModelController',
	    controllerAs: 'appconfgroupsAddModelCtrl'
	  });
	}];

/***/ }),
/* 440 */
144,
/* 441 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"page-header\">\n    <button type=\"button\" name=\"button\" class=\"btn btn-success pull-right\" ui-sref=\"appconfgroups.add\">添加</button>\n    <!-- <a ui-sref=\"group.list\" class=\"btn btn-primary pull-right\" style=\"margin-right: 100px;\">设备类型管理</a> -->\n    <h3>设备组</h3>\n  </div>\n  <div class=\"\">\n    <table class=\"table table-striped\">\n      <thead>\n        <tr>\n          <th></th>\n          <th>组名</th>\n          <!-- <th>设备类型数</th> -->\n          <th>设备类型</th>\n          <th class=\"ctrl-th\">操作</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"group in appconfgroupsListCtrl.list\">\n          <td>{{$index + 1}}</td>\n          <td>{{group.name}}</td>\n          <!-- <td>{{group.modelCount}}</td> -->\n          <td>{{group.models.join(',')}}</td>\n          <td class=\"ctrl-td\">\n            <!-- <button ui-sref=\"appconfgroups.show({id: group._id})\" class=\"btn btn-xs btn-success\">详细</button> -->\n            <button ui-sref=\"appconfgroups.edit({id: group._id})\" class=\"btn btn-xs btn-success\">编辑</button>\n            <button ng-click=\"appconfgroupsListCtrl.delete(group._id)\" class=\"btn btn-xs btn-danger\">删除</button>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 442 */
/***/ (function(module, exports) {

	module.exports = "\n<div class=\"container\">\n  <div class=\"page-header\">\n    <h1>编辑</h1>\n  </div>\n  <div>\n    <form>\n      <div class=\"form-group\">\n        <label for=\"name\">组名</label>\n        <input type=\"name\" class=\"form-control\" ng-model=\"appconfgroupsEditCtrl.one.name\" required>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"model\">设备型号(多个型号用|分隔，如：C67ML|C87ML)</label>\n        <input type=\"model\" class=\"form-control\" ng-model=\"appconfgroupsEditCtrl.one.models\" ng-list=\"|\">\n      </div>\n      <button type=\"submit\" class=\"btn btn-success\" ng-click=\"appconfgroupsEditCtrl.save()\">保存</button>\n    </form>\n  </div>\n</div>\n"

/***/ }),
/* 443 */
/***/ (function(module, exports) {

	module.exports = "\n<div class=\"container\">\n  <div class=\"page-header\">\n    <h1>添加</h1>\n  </div>\n  <div>\n    <form>\n\n      <div class=\"form-group\">\n        <label for=\"model\">组名\n            <span class=\"text-danger\">(必需)</span>\n        </label>\n        <input type=\"name\" class=\"form-control\" ng-model=\"appconfgroupsAddCtrl.one.name\" required>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"model\">设备型号(多个型号用|分隔，如：C67ML|C87ML)</label>\n        <input type=\"model\" class=\"form-control\" ng-model=\"appconfgroupsAddCtrl.one.models\" ng-list=\"|\">\n      </div>\n      <button type=\"submit\" class=\"btn btn-success\" ng-click=\"appconfgroupsAddCtrl.save()\">保存</button>\n    </form>\n  </div>\n</div>\n"

/***/ }),
/* 444 */
/***/ (function(module, exports) {

	module.exports = "\n<div class=\"container\">\n  <div class=\"page-header\">\n    <button type=\"button\" name=\"button\" class=\"btn btn-success pull-right\" ui-sref=\"appconfgroups.addmodel({id: appconfgroupsShowCtrl.one._id})\">添加组设备类型</button>\n    <button type=\"button\" name=\"button\" class=\"btn btn-danger pull-right margin-r-10\" ng-click=\"appconfgroupsShowCtrl.batchRemove()\" ng-disabled=\"appconfgroupsShowCtrl.selection.length == 0\">删除</button>\n    <div class=\"btn-group pull-right margin-r-10\" uib-dropdown>\n      <button type=\"button\" name=\"button\" class=\"btn btn-primary\" uib-dropdown-toggle ng-disabled=\"appconfgroupsShowCtrl.selection.length == 0\">移动</button>\n      <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"single-button\">\n        <li role=\"menuitem\" ng-repeat=\"item in appconfgroupsShowCtrl.list\"><a ng-click=\"appconfgroupsShowCtrl.batchMove(item._id)\">{{item.name}}</a></li>\n      </ul>\n    </div>\n    <h1>{{appconfgroupsShowCtrl.one.name}}</h1>\n  </div>\n  <div class=\"\">\n    <table class=\"table table-striped\">\n      <thead>\n        <tr>\n          <th>选择</th>\n          <th>列号</th>\n          <th>设备类型组</th>\n          <th class=\"ctrl-th\">操作</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"item in appconfgroupsShowCtrl.one.models\">\n          <td><input type=\"checkbox\" value=\"{{item._id}}\" ng-checked=\"appconfgroupsShowCtrl.selection.indexOf(item._id) > -1\"\n            ng-click=\"appconfgroupsShowCtrl.toggleSelection(item._id)\"></td>\n          <td>{{$index + 1}}</td>\n          <td>{{item.name}}</td>\n          <td class=\"ctrl-td\">\n            <!-- <button ui-sref=\"appconfgroups.edit({id: item._id})\" class=\"btn btn-xs btn-success\">编辑</button> -->\n            <button ng-click=\"appconfgroupsShowCtrl.remove(item._id)\" class=\"btn btn-xs btn-danger\">删除</button>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 445 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"page-header\">\n    <h1>添加</h1>\n  </div>\n  <div>\n    <form>\n      <div class=\"clearfix\">\n          <label for=\"models\">设备型号</label>\n          <ul class=\"check-list\">\n            <li ng-repeat=\"group in appconfgroupsAddModelCtrl.list\" class=\"\">\n                <input type=\"checkbox\" name=\"models[]\" value=\"{{group._id}}\" ng-checked=\"appconfgroupsAddModelCtrl.one.models.indexOf(group._id) > -1\"\n                    ng-click=\"appconfgroupsAddModelCtrl.toggleSelection(group._id)\">\n                <span>{{group.name}}</span>\n            </li>\n          </ul>\n        </div>\n      <button type=\"submit\" class=\"btn btn-success\" ng-click=\"appconfgroupsAddModelCtrl.save()\">保存</button>\n    </form>\n  </div>\n</div>"

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _list = __webpack_require__(447);
	
	var _list2 = _interopRequireDefault(_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.appconfgroups.list', []).controller('AppConfGroupsListController', _list2.default).name;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListController = function () {
	
	  /*@ngInject*/
	  ListController.$inject = ['$http'];
	  function ListController($http) {
	    (0, _classCallCheck3.default)(this, ListController);
	
	    this.$http = $http;
	  }
	
	  (0, _createClass3.default)(ListController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getList();
	    }
	  }, {
	    key: 'getList',
	    value: function getList() {
	      var _this = this;
	
	      this.$http.get('/api/AppConfGroups').then(function (res) {
	        _this.list = res.data;
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(id) {
	      var _this2 = this;
	
	      if (confirm("确定？")) {
	        this.$http.delete('/api/AppConfGroups/' + id).then(function (res) {
	          _this2.getList();
	        });
	      }
	    }
	  }]);
	  return ListController;
	}();
	
	exports.default = ListController;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _edit = __webpack_require__(449);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.appconfgroups.edit', []).controller('AppConfGroupsEditController', _edit2.default).name;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditController = function () {
	
	  /*@ngInject*/
	  EditController.$inject = ['$http', '$state', '$stateParams'];
	  function EditController($http, $state, $stateParams) {
	    (0, _classCallCheck3.default)(this, EditController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	  }
	
	  (0, _createClass3.default)(EditController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getOne();
	    }
	  }, {
	    key: 'getOne',
	    value: function getOne() {
	      var _this = this;
	
	      this.$http.get('/api/AppConfGroups/' + this.$stateParams.id).then(function (res) {
	        _this.one = res.data;
	      });
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this2 = this;
	
	      this.$http.put('/api/AppConfGroups/' + this.$stateParams.id, this.one).then(function (res) {
	        _this2.$state.go('^');
	      });
	    }
	  }]);
	  return EditController;
	}();
	
	exports.default = EditController;

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _add = __webpack_require__(451);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.appconfgroups.add', []).controller('AppConfGroupsAddController', _add2.default).name;

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddController = function () {
	
	  /*@ngInject*/
	  AddController.$inject = ['$http', '$state'];
	  function AddController($http, $state) {
	    (0, _classCallCheck3.default)(this, AddController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.one = {};
	  }
	
	  (0, _createClass3.default)(AddController, [{
	    key: 'save',
	    value: function save() {
	      var _this = this;
	
	      this.$http.post('/api/AppConfGroups', this.one).then(function (res) {
	        _this.$state.go('^');
	      });
	    }
	  }]);
	  return AddController;
	}();
	
	exports.default = AddController;

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _show = __webpack_require__(453);
	
	var _show2 = _interopRequireDefault(_show);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.appconfgroups.show', []).controller('AppConfGroupsShowController', _show2.default).name;

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditController = function () {
	
	  /*@ngInject*/
	  EditController.$inject = ['$http', '$state', '$stateParams'];
	  function EditController($http, $state, $stateParams) {
	    (0, _classCallCheck3.default)(this, EditController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.selection = [];
	  }
	
	  (0, _createClass3.default)(EditController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getOne();
	      this.getList();
	    }
	  }, {
	    key: 'getOne',
	    value: function getOne() {
	      var _this = this;
	
	      this.$http.get('/api/AppConfGroups/' + this.$stateParams.id).then(function (res) {
	        _this.one = res.data;
	      });
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this2 = this;
	
	      this.$http.put('/api/AppConfGroups/' + this.$stateParams.id, this.one).then(function (res) {
	        _this2.$state.go('^');
	      });
	    }
	  }, {
	    key: 'remove',
	    value: function remove(id) {
	      var _this3 = this;
	
	      if (confirm("确定？")) {
	        this.$http.post('/api/AppConfGroups/' + this.$stateParams.id + '/removeModel', { models: [id] }).then(function (res) {
	          _this3.getOne();
	        });
	      }
	    }
	  }, {
	    key: 'toggleSelection',
	    value: function toggleSelection(id) {
	      var idx = this.selection.indexOf(id);
	      if (idx > -1) {
	        this.selection.splice(idx, 1);
	      } else {
	        this.selection.push(id);
	      }
	    }
	  }, {
	    key: 'batchRemove',
	    value: function batchRemove() {
	      var _this4 = this;
	
	      if (confirm("确定？")) {
	        this.$http.post('/api/AppConfGroups/' + this.$stateParams.id + '/removeModel', {
	          models: this.selection
	        }).then(function (res) {
	          _this4.getOne();
	        });
	      }
	    }
	  }, {
	    key: 'batchMove',
	    value: function batchMove(id) {
	      var _this5 = this;
	
	      if (confirm("确定？")) {
	        var params = {
	          models: this.selection,
	          from: this.$stateParams.id,
	          to: id
	        };
	        this.$http.post('/api/AppConfGroups/moveModels', params).then(function (res) {
	          _this5.getOne();
	        });
	      }
	    }
	  }, {
	    key: 'getList',
	    value: function getList() {
	      var _this6 = this;
	
	      this.$http.get('/api/AppConfGroups').then(function (res) {
	        _this6.list = res.data;
	      });
	    }
	  }]);
	  return EditController;
	}();
	
	exports.default = EditController;

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _addmodel = __webpack_require__(455);
	
	var _addmodel2 = _interopRequireDefault(_addmodel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.appconfgroups.addmodel', []).controller('AppConfGroupsAddModelController', _addmodel2.default).name;

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddModelController = function () {
	
	  /*@ngInject*/
	  AddModelController.$inject = ['$http', '$state', '$stateParams'];
	  function AddModelController($http, $state, $stateParams) {
	    (0, _classCallCheck3.default)(this, AddModelController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.list = [];
	    this.one = {
	      models: []
	    };
	  }
	
	  (0, _createClass3.default)(AddModelController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getList();
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this = this;
	
	      this.$http.post('/api/AppConfGroups/' + this.$stateParams.id + '/addModel', this.one).then(function (res) {
	        _this.$state.go('appconfgroups.show', { id: _this.$stateParams.id });
	      });
	    }
	  }, {
	    key: 'getList',
	    value: function getList() {
	      var _this2 = this;
	
	      this.$http.get('/api/groups/').then(function (response) {
	        _this2.list = response.data;
	      });
	    }
	  }, {
	    key: 'toggleSelection',
	    value: function toggleSelection(id) {
	      var idx = this.one.models.indexOf(id);
	      if (idx > -1) {
	        this.one.models.splice(idx, 1);
	      } else {
	        this.one.models.push(id);
	      }
	      console.log("----toggleSelection-----one---->", this.one);
	    }
	  }]);
	  return AddModelController;
	}();
	
	exports.default = AddModelController;

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(86);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _tutorial = __webpack_require__(457);
	
	var _tutorial2 = _interopRequireDefault(_tutorial);
	
	var _list = __webpack_require__(462);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _add = __webpack_require__(464);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _edit = __webpack_require__(466);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.tutorial', [_angularUiRouter2.default, _list2.default, _add2.default, _edit2.default]).config(_tutorial2.default).run(['$rootScope', function ($rootScope) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
	    if (next.name === 'logout' && current && current.name && !current.authenticate) {
	      next.referrer = current.name;
	    }
	  });
	}]).name;

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $urlRouterProvider.when("/tutorial", "/tutorial/list");
	  $stateProvider.state('tutorial', {
	    url: '/tutorial',
	    template: __webpack_require__(458),
	    authenticate: true
	  }).state('tutorial.list', {
	    url: '/list',
	    template: __webpack_require__(459),
	    controller: 'TutorialListController',
	    controllerAs: 'tListCtrl'
	  }).state('tutorial.add', {
	    url: '/add',
	    template: __webpack_require__(460),
	    controller: 'TutorialAddController',
	    controllerAs: 'tAddCtrl'
	  }).state('tutorial.edit', {
	    url: '/edit/:id',
	    template: __webpack_require__(461),
	    controller: 'TutorialEditController',
	    controllerAs: 'tEditCtrl'
	  });
	}];

/***/ }),
/* 458 */
144,
/* 459 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-full\">\n  <div class=\"page-header\">\n    <a ui-sref=\"tutorial.add\" class=\"btn btn-primary pull-right\">添加</a>\n    <h3>用户手册</h3>\n  </div>\n  <div class=\"\">\n    <table class=\"table table-striped\">\n      <thead>\n        <tr>\n          <th style=\"width: 50px;\"></th>\n          <th>标题</th>\n          <th>型号</th>\n          <th>语言</th>\n          <th>文件</th>\n          <th>更新时间</th>\n          <th class=\"ctrl-th\"></th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"tutorial in tListCtrl.tutorials\">\n          <td>{{$index + 1}}</td>\n          <td>{{tutorial.title}}</td>\n          <td>{{tutorial.model.join('\\\\')}}</td>\n          <td>{{tutorial.lang.join('\\\\')}}</td>\n          <td><a href=\"{{tutorial.file.path}}\" target=\"_blank\"><span class=\"glyphicon glyphicon-paperclip\"></span></a></td>\n          <td>{{tutorial.updatedAt | date:'yyyy-MM-dd'}}</td>\n          <td class=\"ctrl-td\">\n            <a ui-sref=\"tutorial.edit({id: tutorial._id})\" class=\"btn btn-xs btn-primary\">编辑</a>\n            <button ng-click=\"tListCtrl.delete(tutorial._id)\" class=\"btn btn-xs btn-danger\">删除</button>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 460 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"page-header\">\n    <h1>添加</h1>\n  </div>\n  <div>\n    <form>\n      <div class=\"form-group\">\n        <label for=\"model\">型号\n          <span class=\"text-danger\">(必需)</span>\n          <span class=\"text-danger\">(必需, 多型号用\\隔开)</span>\n        </label>\n        <input type=\"model\" class=\"form-control\" ng-model=\"tAddCtrl.newTutorial.model\" ng-list=\"\\\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"lang\">语言\n          <span class=\"text-danger\">(必需)</span>\n          <span class=\"text-danger\">(必需,多种语言用\\隔开)</span>\n        </label>\n        <input type=\"lang\" class=\"form-control\" ng-model=\"tAddCtrl.newTutorial.lang\" ng-list=\"\\\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"lang\">地区\n          <span class=\"text-danger\">(必需)</span>\n        </label>\n<select class=\"form-control\" ng-model=\"tAddCtrl.newTutorial.bucket\">\n          <option value=\"onyx-firmware\">大陆</option>\n          <option value=\"onyx-firmware-eu\">欧洲</option>\n          <option value=\"onyx-firmware-hk\">香港</option>\n        </select>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"model\">标题</label>\n        <input type=\"model\" class=\"form-control\" ng-model=\"tAddCtrl.newTutorial.title\">\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"file\"\">文件\n          <span class=\"text-danger\">(必需)</span>\n        </label>\n        <input type=\"file\" ngf-select ng-model=\"file\" name=\"file\" required ngf-model-invalid=\"errorFile\" class=\"form-control\">\n      </div>\n\n      <button type=\"submit\" class=\"btn btn-success\" ng-click=\"tAddCtrl.upload(file)\">保存</button>\n      <button type=\"button\" class=\"btn btn-default\" ui-sref=\"^\">返回</button>\n    </form>\n  </div>\n</div>"

/***/ }),
/* 461 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"page-header\">\n    <h1>添加</h1>\n  </div>\n  <div>\n    <form>\n      <div class=\"form-group\">\n        <label for=\"model\">型号\n          <span class=\"text-danger\">(必需)</span>\n          <span class=\"text-danger\">(必需, 多型号用\\隔开)</span>\n        </label>\n        <input type=\"model\" class=\"form-control\" ng-model=\"tEditCtrl.tutorial.model\" ng-list=\"\\\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"lang\">语言\n          <span class=\"text-danger\">(必需)</span>\n          <span class=\"text-danger\">(必需,多种语言用\\隔开)</span>\n        </label>\n        <input type=\"lang\" class=\"form-control\" ng-model=\"tEditCtrl.tutorial.lang\" ng-list=\"\\\" required>\n      </div>\n\n\n      <div class=\"form-group\">\n        <label for=\"model\">标题</label>\n        <input type=\"model\" class=\"form-control\" ng-model=\"tEditCtrl.tutorial.title\">\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"file\"\">文件</label>\n        <input type=\"file\" ngf-select ng-model=\"tEditCtrl.file\" name=\"file\" ngf-model-invalid=\"errorFile\"\n          class=\"form-control\">\n      </div>\n\n      <button type=\"submit\" class=\"btn btn-success\" ng-click=\"tEditCtrl.update()\">保存</button>\n      <button type=\"button\" class=\"btn btn-default\" ui-sref=\"^\">返回</button>\n    </form>\n  </div>\n</div>"

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _list = __webpack_require__(463);
	
	var _list2 = _interopRequireDefault(_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.tutorial.list', []).controller('TutorialListController', _list2.default).name;

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListController = function () {
	
	  /*@ngInject*/
	  ListController.$inject = ['$http'];
	  function ListController($http) {
	    (0, _classCallCheck3.default)(this, ListController);
	
	    this.$http = $http;
	  }
	
	  (0, _createClass3.default)(ListController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getTutorial();
	    }
	  }, {
	    key: 'getTutorial',
	    value: function getTutorial() {
	      var _this = this;
	
	      this.$http.get('/api/tutorials').then(function (res) {
	        _this.tutorials = res.data;
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(id) {
	      var _this2 = this;
	
	      if (confirm("确定？")) {
	        this.$http.delete('/api/tutorials/' + id).then(function (res) {
	          _this2.getTutorial();
	        });
	      }
	    }
	  }]);
	  return ListController;
	}();
	
	exports.default = ListController;

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _add = __webpack_require__(465);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.tutorial.add', []).controller('TutorialAddController', _add2.default).name;

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(157);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddController = function () {
	
	  /*@ngInject*/
	  AddController.$inject = ['$http', '$state', '$scope', 'Upload', 'toaster'];
	  function AddController($http, $state, $scope, Upload, toaster) {
	    (0, _classCallCheck3.default)(this, AddController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$scope = $scope;
	    this.Upload = Upload;
	    this.toaster = toaster;
	
	    this.newTutorial = {};
	  }
	
	  (0, _createClass3.default)(AddController, [{
	    key: 'upload',
	    value: function upload(file) {
	      var _this = this;
	
	      this.toaster.pop({
	        type: 'wait',
	        title: '正在上传，请稍等...',
	        body: file.name,
	        timeout: 3000 * 1000
	      });
	
	      file.upload = this.Upload.upload({
	        url: '/api/tutorials/upload',
	        file: file,
	        data: this.newTutorial,
	        headers: {
	          'Content-Type': 'multipart/form-data'
	        }
	      });
	
	      file.upload.progress(function (evt) {
	        file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
	      });
	
	      file.upload.success(function (data, status, headers, config) {
	        _this.toaster.clear();
	        _this.$state.go('tutorial');
	        _this.toaster.pop('success', '上传成功', file.name);
	      });
	
	      file.upload.error(function (err) {
	        _this.toaster.clear();
	        _this.toaster.pop('error', '上传失败', (0, _stringify2.default)(err));
	      });
	    }
	  }]);
	  return AddController;
	}();
	
	exports.default = AddController;

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _edit = __webpack_require__(467);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.tutorial.edit', []).controller('TutorialEditController', _edit2.default).name;

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(157);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddController = function () {
	
	  /*@ngInject*/
	  AddController.$inject = ['$http', '$state', '$scope', 'Upload', 'toaster', '$stateParams'];
	  function AddController($http, $state, $scope, Upload, toaster, $stateParams) {
	    (0, _classCallCheck3.default)(this, AddController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$scope = $scope;
	    this.Upload = Upload;
	    this.toaster = toaster;
	    this.$stateParams = $stateParams;
	
	    this.tutorial = {};
	  }
	
	  (0, _createClass3.default)(AddController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.getTutorials(this.$stateParams.id);
	
	      this.$scope.$watch('tEditCtrl.file', function (file) {
	        if (file !== undefined && file !== null) {
	          _this.upload(file);
	        }
	      });
	    }
	  }, {
	    key: 'getTutorials',
	    value: function getTutorials(id) {
	      var _this2 = this;
	
	      this.$http.get('/api/tutorials/' + id).then(function (res) {
	        _this2.tutorial = res.data;
	      });
	    }
	  }, {
	    key: 'upload',
	    value: function upload(file) {
	      var _this3 = this;
	
	      this.toaster.pop({
	        type: 'wait',
	        title: '正在上传，请稍等...',
	        body: file.name,
	        timeout: 3000 * 1000
	      });
	
	      file.upload = this.Upload.upload({
	        url: '/api/tutorials/upload',
	        file: file,
	        data: this.tutorial,
	        headers: {
	          'Content-Type': 'multipart/form-data'
	        }
	      });
	
	      file.upload.progress(function (evt) {
	        file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
	      });
	
	      file.upload.success(function (data, status, headers, config) {
	        _this3.toaster.clear();
	        _this3.$state.go('tutorial');
	        _this3.toaster.pop('success', '上传成功', file.name);
	      });
	
	      file.upload.error(function (err) {
	        _this3.toaster.clear();
	        _this3.toaster.pop('error', '上传失败', (0, _stringify2.default)(err));
	      });
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var _this4 = this;
	
	      this.$http.put('/api/tutorials/' + this.$stateParams.id, this.tutorial).then(function (res) {
	        _this4.$state.go('tutorial');
	      });
	    }
	  }]);
	  return AddController;
	}();
	
	exports.default = AddController;

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(86);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _peripheral = __webpack_require__(469);
	
	var _peripheral2 = _interopRequireDefault(_peripheral);
	
	var _list = __webpack_require__(475);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _add = __webpack_require__(477);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _edit = __webpack_require__(479);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.peripheral', [_angularUiRouter2.default, _list2.default, _add2.default, _edit2.default]).config(_peripheral2.default).run(['$rootScope', function ($rootScope) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
	    if (next.name === 'logout' && current && current.name && !current.authenticate) {
	      next.referrer = current.name;
	    }
	  });
	}]).name;

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $urlRouterProvider.when("/peripheral", "/peripheral/list");
	
	  $stateProvider.state('peripheral', {
	    url: '/peripheral',
	    template: __webpack_require__(470),
	    authenticate: true
	  }).state('peripheral.list', {
	    url: '/list',
	    template: __webpack_require__(471),
	    controller: 'PeripheralListController',
	    controllerAs: 'pListCtrl'
	  }).state('peripheral.show', {
	    url: '/show/:id',
	    template: __webpack_require__(472),
	    controller: 'PeripheralShowController',
	    controllerAs: 'pShowCtrl'
	  }).state('peripheral.add', {
	    url: '/add',
	    template: __webpack_require__(473),
	    controller: 'PeripheralAddController',
	    controllerAs: 'pAddCtrl'
	  }).state('peripheral.edit', {
	    url: '/edit/:id',
	    template: __webpack_require__(474),
	    controller: 'PeripheralEditController',
	    controllerAs: 'pEditCtrl'
	  });
	}];

/***/ }),
/* 470 */
144,
/* 471 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"ctrl-panel\">\n    <a ui-sref=\"peripheral.add\" class=\"btn btn-primary pull-right\">添加</a>\n    <h3>外设固件</h3>\n  </div>\n\n  <div class=\"\">\n    <table class=\"table table-striped\">\n      <thead>\n        <tr>\n          <th>型号</th>\n          <th>版本</th>\n          <th>更新时间</th>\n          <th class=\"ctrl-th\"></th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"item in pListCtrl.data\">\n          <td>{{item.model}}</td>\n          <td>{{item.buildNumber}}</td>\n          <td>{{item.createdAt | date:'yyyy-MM-dd'}}</td>\n          <td class=\"ctrl-td\">\n            <button ui-sref=\"peripheral.edit({id: item._id})\" class=\"btn btn-xs btn-primary\">编辑</button>\n            <button ng-click=\"pListCtrl.delete(item._id)\" class=\"btn btn-xs btn-danger\">删除</button>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 472 */
382,
/* 473 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"page-header\">\n    <h1>添加</h1>\n  </div>\n  <div>\n    <form>\n      <div class=\"form-group\">\n        <label for=\"model\">型号\n          <span class=\"text-danger\">(必需)</span>\n        </label>\n        <input type=\"model\" class=\"form-control\" ng-model=\"pAddCtrl.newFirmware.model\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"version\">固件版本号\n          <span class=\"text-danger\">(必需)</span>\n        </label>\n        <input type=\"version\" class=\"form-control\" ng-model=\"pAddCtrl.newFirmware.version\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"buildNumber\">升级版本号（会根据固件版本号自动补充）\n          <span class=\"text-danger\">(必需)</span>\n        </label>\n        <input type=\"buildNumber\" class=\"form-control\" ng-model=\"pAddCtrl.newFirmware.buildNumber\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"manufacturer\">制造商</label>\n        <input type=\"manufacturer\" class=\"form-control\" ng-model=\"pAddCtrl.newFirmware.manufacturer\" >\n      </div>\n\n       <div class=\"form-group\">\n         <label for=\"deviceMAC\">目标设备MAC\n           <span class=\"text-danger\">（每行一个MAC）</span>\n         </label>\n         <textarea type=\"deviceMAC\" class=\"form-control\" ng-model=\"pAddCtrl.newFirmware.deviceMAC\"\n           ng-list=\"&#10;\" ng-trim=\"false\" rows=\"5\"></textarea>\n       </div>\n\n       <div class=\"form-group\">\n         <label for=\"changeList\">变更信息\n           <span class=\"text-danger\">(必需)</span>\n         </label>\n         <textarea type=\"changeList\" class=\"form-control\" ng-model=\"pAddCtrl.newFirmware.changeList\"\n           ng-list=\"&#10;\" ng-trim=\"false\" rows=\"5\" ng-required=\"true\"></textarea>\n       </div>\n\n      <div class=\"form-group\">\n        <label for=\"file\"\">文件\n          <span class=\" text-danger\">(必需)</span>\n        </label>\n        <input type=\"file\" ngf-select ng-model=\"file\" name=\"file\" required ngf-model-invalid=\"errorFile\"\n          class=\"form-control\">\n      </div>\n\n      <button type=\"submit\" class=\"btn btn-success\" ng-click=\"pAddCtrl.upload(file)\">保存</button>\n      <button type=\"button\" class=\"btn btn-default\" ui-sref=\"^\">返回</button>\n    </form>\n  </div>\n</div>"

/***/ }),
/* 474 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"page-header\">\n    <h1>编辑</h1>\n  </div>\n  <div>\n    <form>\n      <div class=\"form-group\">\n        <label for=\"model\">型号\n          <span class=\"text-danger\">(必需)</span>\n        </label>\n        <input type=\"model\" class=\"form-control\" ng-model=\"pEditCtrl.data.model\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"version\">固件版本号\n          <span class=\"text-danger\">(必需)</span>\n        </label>\n        <input type=\"version\" class=\"form-control\" ng-model=\"pEditCtrl.data.version\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"buildNumber\">升级版本号（会根据固件版本号自动补充）\n          <span class=\"text-danger\">(必需)</span>\n        </label>\n        <input type=\"buildNumber\" class=\"form-control\" ng-model=\"pEditCtrl.data.buildNumber\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"manufacturer\">制造商</label>\n        <input type=\"manufacturer\" class=\"form-control\" ng-model=\"pEditCtrl.data.manufacturer\">\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"deviceMAC\">目标设备MAC\n          <span class=\"text-danger\">（每行一个MAC）</span>\n        </label>\n        <textarea type=\"deviceMAC\" class=\"form-control\" ng-model=\"pEditCtrl.data.deviceMAC\" ng-list=\"&#10;\"\n          ng-trim=\"false\" rows=\"5\"></textarea>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"changeList\">变更信息\n          <span class=\"text-danger\">(必需)</span>\n        </label>\n        <textarea type=\"changeList\" class=\"form-control\" ng-model=\"pEditCtrl.data.changeList\" ng-list=\"&#10;\"\n          ng-trim=\"false\" rows=\"5\" ng-required=\"true\"></textarea>\n      </div>\n\n      <button type=\"submit\" class=\"btn btn-success\" ng-click=\"pEditCtrl.update()\">保存</button>\n      <button type=\"button\" class=\"btn btn-default\" ui-sref=\"^\">返回</button>\n    </form>\n  </div>\n</div>"

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _list = __webpack_require__(476);
	
	var _list2 = _interopRequireDefault(_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.peripheral.list', []).controller('PeripheralListController', _list2.default).name;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListController = function () {
	
	  /*@ngInject*/
	  ListController.$inject = ['$http'];
	  function ListController($http) {
	    (0, _classCallCheck3.default)(this, ListController);
	
	    this.$http = $http;
	  }
	
	  (0, _createClass3.default)(ListController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getData();
	    }
	  }, {
	    key: 'getData',
	    value: function getData() {
	      var _this = this;
	
	      this.$http.get('/api/peripherals').then(function (res) {
	        _this.data = res.data;
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(id) {
	      var _this2 = this;
	
	      if (confirm("确定？")) {
	        this.$http.delete('/api/peripherals/' + id).then(function (res) {
	          _this2.getData();
	        });
	      }
	    }
	  }]);
	  return ListController;
	}();
	
	exports.default = ListController;

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _add = __webpack_require__(478);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.peripheral.add', []).controller('PeripheralAddController', _add2.default).name;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(157);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddController = function () {
	
	  /*@ngInject*/
	  AddController.$inject = ['$http', '$state', '$scope', 'Upload', 'toaster'];
	  function AddController($http, $state, $scope, Upload, toaster) {
	    (0, _classCallCheck3.default)(this, AddController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$scope = $scope;
	    this.Upload = Upload;
	    this.toaster = toaster;
	
	    this.newFirmware = {};
	  }
	
	  (0, _createClass3.default)(AddController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.$scope.$watch('pAddCtrl.newFirmware.version', function (version) {
	        if (version !== undefined && version !== null && version) {
	          _this.newFirmware.buildNumber = parseInt(version.replace(/\./g, ''));
	        }
	      });
	    }
	  }, {
	    key: 'upload',
	    value: function upload(file) {
	      var _this2 = this;
	
	      this.toaster.pop({
	        type: 'wait',
	        title: '正在上传，请稍等...',
	        body: file.name,
	        timeout: 3000 * 1000
	      });
	
	      file.upload = this.Upload.upload({
	        url: '/api/peripherals/uploadFile',
	        file: file,
	        data: this.newFirmware,
	        headers: {
	          'Content-Type': 'multipart/form-data'
	        }
	      });
	
	      file.upload.progress(function (evt) {
	        file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
	      });
	
	      file.upload.success(function (data, status, headers, config) {
	        _this2.toaster.clear();
	        _this2.$state.go('peripheral');
	        _this2.toaster.pop('success', '上传成功', file.name);
	      });
	
	      file.upload.error(function (err) {
	        _this2.toaster.clear();
	        _this2.toaster.pop('error', '上传失败', (0, _stringify2.default)(err));
	      });
	    }
	  }]);
	  return AddController;
	}();
	
	exports.default = AddController;

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _edit = __webpack_require__(480);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.peripheral.edit', []).controller('PeripheralEditController', _edit2.default).name;

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddController = function () {
	
	  /*@ngInject*/
	  AddController.$inject = ['$http', '$state', '$stateParams', '$scope'];
	  function AddController($http, $state, $stateParams, $scope) {
	    (0, _classCallCheck3.default)(this, AddController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$scope = $scope;
	
	    this.data = {};
	  }
	
	  (0, _createClass3.default)(AddController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.getPeripheral(this.$stateParams.id);
	
	      this.$scope.$watch('pEditCtrl.data.version', function (version) {
	        if (version !== undefined && version !== null && version) {
	          _this.data.buildNumber = parseInt(version.replace(/\./g, ''));
	        }
	      });
	    }
	  }, {
	    key: 'getPeripheral',
	    value: function getPeripheral(id) {
	      var _this2 = this;
	
	      this.$http.get('/api/peripherals/' + id).then(function (res) {
	        _this2.data = res.data;
	      });
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var _this3 = this;
	
	      this.$http.put('/api/peripherals/' + this.$stateParams.id, this.data).then(function (res) {
	        _this3.$state.go('peripheral');
	      });
	    }
	  }]);
	  return AddController;
	}();
	
	exports.default = AddController;

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(86);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _fonts = __webpack_require__(482);
	
	var _fonts2 = _interopRequireDefault(_fonts);
	
	var _list = __webpack_require__(487);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _edit = __webpack_require__(489);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _add = __webpack_require__(491);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.fonts', [_angularUiRouter2.default, _list2.default, _edit2.default, _add2.default]).config(_fonts2.default).run(['$rootScope', function ($rootScope) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
	    if (next.name === 'logout' && current && current.name && !current.authenticate) {
	      next.referrer = current.name;
	    }
	  });
	}]).name;

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $urlRouterProvider.when("/fonts", "/fonts/list");
	  $stateProvider.state('fonts', {
	    url: '/fonts?page',
	    template: __webpack_require__(483),
	    authenticate: true
	  }).state('fonts.list', {
	    url: '/list',
	    template: __webpack_require__(484),
	    controller: 'FontsListController',
	    controllerAs: 'fontsListCtrl'
	  }).state('fonts.edit', {
	    url: '/edit/:id',
	    template: __webpack_require__(485),
	    controller: 'FontsEditController',
	    controllerAs: 'fontsEditCtrl'
	  }).state('fonts.add', {
	    url: '/add',
	    template: __webpack_require__(486),
	    controller: 'FontsAddController',
	    controllerAs: 'fontsAddCtrl'
	  });
	}];

/***/ }),
/* 483 */
144,
/* 484 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-full\">\n  <div class=\"page-header\">\n    <a ui-sref=\"fonts.add\" class=\"btn btn-primary pull-right\">添加</a>\n    <h3>字体</h3>\n  </div>\n  <div class=\"\">\n    <table class=\"table table-striped\">\n      <thead>\n        <tr>\n          <th style=\"width: 50px;\"></th>\n          <th>名字</th>\n          <th>型号</th>\n          <th>语言</th>\n          <th>组</th>\n          <th>日期</th>\n          <th class=\"ctrl-th\"></th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"font in fontsListCtrl.fonts.list\">\n          <td>{{$index + 1}}</td>\n          <td>{{font.title}}</td>\n          <td>{{font.model.join('\\\\')}}</td>\n          <td>{{font.lang.join('\\\\')}}</td>\n          <td>\n            {{font.modelGroups}}\n          </td>\n          <td>{{font.createdAt | date:'yyyy-MM-dd'}}</td>\n          <td class=\"ctrl-td\">\n            <button ui-sref=\"fonts.edit({id: font._id})\" class=\"btn btn-xs btn-success\">编辑</button>\n            <button ng-click=\"fontsListCtrl.delete(font._id)\" class=\"btn btn-xs btn-danger\">删除</button>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n\n    <div class=\"pagination-div\" ng-show=\"fontsListCtrl.fonts.count > 0\">\n      <ul uib-pagination data-ng-if=\"fontsListCtrl.fonts.count\" total-items=\"fontsListCtrl.fonts.count\"\n        ng-model=\"fontsListCtrl.page\" max-size=\"5\" class=\"\" boundary-link-numbers=\"true\" rotate=\"false\"\n        ng-change=\"fontsListCtrl.pageChanged()\" items-per-page=\"fontsListCtrl.params.limit\" previous-text=\"上一页\"\n        next-text=\"下一页\"></ul>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 485 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"page-header\">\n    <h1>编辑</h1>\n  </div>\n  <div>\n    <form>\n      <div class=\"form-group\">\n        <label for=\"model\">标题</label>\n        <input type=\"model\" class=\"form-control\" ng-model=\"fontsEditCtrl.font.title\">\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"model\">型号 <span class=\"text-danger\">(多型号用\\隔开)</span></label>\n        <input type=\"string\" class=\"form-control\" ng-model=\"fontsEditCtrl.font.model\" ng-list=\"\\\">\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"lang\">语言\n          <span class=\"text-danger\">(多种语言用\\隔开)</span>\n        </label>\n        <input type=\"lang\" class=\"form-control\" ng-model=\"fontsEditCtrl.font.lang\" ng-list=\"\\\">\n      </div>\n\n      <div class=\"clearfix\">\n        <label for=\"\">设备型号组</label>\n        <ul class=\"check-list\">\n          <li ng-repeat=\"group in fontsEditCtrl.groups\" class=\"\">\n              <input type=\"checkbox\" name=\"modelGroups[]\" value=\"{{group._id}}\" ng-checked=\"fontsEditCtrl.font.modelGroups.indexOf(group._id) > -1\"\n                  ng-click=\"fontsEditCtrl.toggleSelection(group._id)\">\n              <span>{{group.name}}</span>\n          </li>\n        </ul>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"file\"\">文件\n        </label>\n        <input type=\"file\" ngf-select ng-model=\"file\" name=\"file\" ngf-model-invalid=\"errorFile\"\n          class=\"form-control\">\n      </div>\n\n      <button type=\"submit\" class=\"btn btn-success\" ng-click=\"fontsEditCtrl.upload(file)\">保存</button>\n      <button type=\"button\" class=\"btn btn-default\" ui-sref=\"^\">返回</button>\n    </form>\n  </div>\n</div>"

/***/ }),
/* 486 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"page-header\">\n    <h1>添加</h1>\n  </div>\n  <div>\n    <form>\n      <div class=\"form-group\">\n        <label for=\"title\">标题</label>\n        <input type=\"title\" class=\"form-control\" ng-model=\"fontsAddCtrl.newFont.title\">\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"model\">型号 <span class=\"text-danger\">(多型号用\\隔开)</span></label>\n        <input type=\"string\" class=\"form-control\" ng-model=\"fontsAddCtrl.newFont.model\" ng-list=\"\\\">\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"lang\">语言\n          <span class=\"text-danger\">(多种语言用\\隔开)</span>\n        </label>\n        <input type=\"lang\" class=\"form-control\" ng-model=\"fontsAddCtrl.newFont.lang\" ng-list=\"\\\" >\n      </div>\n\n      <div class=\"clearfix\">\n        <label for=\"models\">设备型号组</label>\n        <ul class=\"check-list\">\n          <li ng-repeat=\"group in fontsAddCtrl.groups\" class=\"\">\n              <input type=\"checkbox\" name=\"modelGroups[]\" value=\"{{group._id}}\" ng-checked=\"fontsAddCtrl.newFont.modelGroups.indexOf(group._id) > -1\"\n                  ng-click=\"fontsAddCtrl.toggleSelection(group._id)\">\n              <span>{{group.name}}</span>\n          </li>\n        </ul>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"file\"\">文件\n          <span class=\" text-danger\">(必需)</span>\n        </label>\n        <input type=\"file\" ngf-select ng-model=\"file\" name=\"file\" required ngf-model-invalid=\"errorFile\"\n          class=\"form-control\">\n      </div>\n\n      <button type=\"submit\" class=\"btn btn-success\" ng-click=\"fontsAddCtrl.upload(file)\">保存</button>\n      <button type=\"button\" class=\"btn btn-default\" ui-sref=\"^\">返回</button>\n    </form>\n  </div>\n</div>"

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _list = __webpack_require__(488);
	
	var _list2 = _interopRequireDefault(_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.fonts.list', []).controller('FontsListController', _list2.default).name;

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListController = function () {
	
	  /*@ngInject*/
	  ListController.$inject = ['$http', '$stateParams', '$state'];
	  function ListController($http, $stateParams, $state) {
	    (0, _classCallCheck3.default)(this, ListController);
	
	    this.$http = $http;
	    this.$stateParams = $stateParams;
	    this.$state = $state;
	
	    this.page = 1;
	    this.params = {
	      offset: this.page - 1,
	      limit: 20,
	      sortBy: 'createdAt',
	      order: -1,
	      group: 1
	    };
	  }
	
	  (0, _createClass3.default)(ListController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      if (this.$stateParams.page) {
	        this.page = this.$stateParams.page;
	      }
	      this.getFonts();
	    }
	  }, {
	    key: 'getFonts',
	    value: function getFonts() {
	      var _this = this;
	
	      this.params.offset = (this.page - 1) * this.params.limit;
	      this.$http.get('/api/fonts', {
	        params: this.params
	      }).then(function (res) {
	        _this.fonts = res.data;
	        _this.fonts.list = _this.fonts.list.map(function (item) {
	          if (item.modelGroups) {
	            item.modelGroups = item.modelGroups.map(function (a) {
	              return a.name;
	            }).join(',');
	          }
	          return item;
	        });
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(id) {
	      var _this2 = this;
	
	      if (confirm("确定？")) {
	        this.$http.delete('/api/fonts/' + id).then(function (res) {
	          _this2.getFonts();
	        });
	      }
	    }
	  }, {
	    key: 'pageChanged',
	    value: function pageChanged() {
	      this.$state.go('fonts.list', {
	        page: this.page
	      });
	    }
	  }]);
	  return ListController;
	}();
	
	exports.default = ListController;

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _edit = __webpack_require__(490);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.fonts.edit', []).controller('FontsEditController', _edit2.default).name;

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(157);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddController = function () {
	
	  /*@ngInject*/
	  AddController.$inject = ['$http', '$state', '$scope', 'Upload', 'toaster', '$stateParams'];
	  function AddController($http, $state, $scope, Upload, toaster, $stateParams) {
	    (0, _classCallCheck3.default)(this, AddController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$scope = $scope;
	    this.Upload = Upload;
	    this.toaster = toaster;
	    this.$stateParams = $stateParams;
	
	    this.font = {};
	  }
	
	  (0, _createClass3.default)(AddController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getFont(this.$stateParams.id);
	      this.getList();
	    }
	  }, {
	    key: 'getFont',
	    value: function getFont(id) {
	      var _this = this;
	
	      this.$http.get('/api/fonts/' + id).then(function (res) {
	        _this.font = res.data;
	      });
	    }
	  }, {
	    key: 'upload',
	    value: function upload(file) {
	      var _this2 = this;
	
	      if (!file) {
	        this.update();
	        return;
	      }
	      this.toaster.pop({
	        type: 'wait',
	        title: '正在上传，请稍等...',
	        body: file.name,
	        timeout: 3000 * 1000
	      });
	
	      file.upload = this.Upload.upload({
	        url: '/api/fonts/uploadFile',
	        file: file,
	        data: this.font,
	        headers: {
	          'Content-Type': 'multipart/form-data'
	        }
	      });
	
	      file.upload.progress(function (evt) {
	        file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
	      });
	
	      file.upload.success(function (data, status, headers, config) {
	        _this2.toaster.clear();
	        _this2.$state.go('fonts');
	        _this2.toaster.pop('success', '上传成功', file.name);
	      });
	
	      file.upload.error(function (err) {
	        _this2.toaster.clear();
	        _this2.toaster.pop('error', '上传失败', (0, _stringify2.default)(err));
	      });
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var _this3 = this;
	
	      this.$http.put('/api/fonts/' + this.$stateParams.id, this.font).then(function (res) {
	        _this3.$state.go('fonts');
	      });
	    }
	  }, {
	    key: 'getList',
	    value: function getList() {
	      var _this4 = this;
	
	      this.$http.get('/api/AppConfGroups').then(function (res) {
	        _this4.groups = res.data;
	      });
	    }
	  }, {
	    key: 'toggleSelection',
	    value: function toggleSelection(id) {
	      var idx = this.font.modelGroups.indexOf(id);
	      if (idx > -1) {
	        this.font.modelGroups.splice(idx, 1);
	      } else {
	        this.font.modelGroups.push(id);
	      }
	    }
	  }]);
	  return AddController;
	}();
	
	exports.default = AddController;

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _add = __webpack_require__(492);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.fonts.add', []).controller('FontsAddController', _add2.default).name;

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(157);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddController = function () {
	
	  /*@ngInject*/
	  AddController.$inject = ['$http', '$state', '$scope', 'Upload', 'toaster'];
	  function AddController($http, $state, $scope, Upload, toaster) {
	    (0, _classCallCheck3.default)(this, AddController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$scope = $scope;
	    this.Upload = Upload;
	    this.toaster = toaster;
	
	    this.newFont = {};
	  }
	
	  (0, _createClass3.default)(AddController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getList();
	    }
	  }, {
	    key: 'upload',
	    value: function upload(file) {
	      var _this = this;
	
	      this.toaster.pop({
	        type: 'wait',
	        title: '正在上传，请稍等...',
	        body: file.name,
	        timeout: 3000 * 1000
	      });
	
	      file.upload = this.Upload.upload({
	        url: '/api/fonts/uploadFile',
	        file: file,
	        data: this.newFont,
	        headers: {
	          'Content-Type': 'multipart/form-data'
	        }
	      });
	
	      file.upload.progress(function (evt) {
	        file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
	      });
	
	      file.upload.success(function (data, status, headers, config) {
	        _this.toaster.clear();
	        _this.$state.go('fonts');
	        _this.toaster.pop('success', '上传成功', file.name);
	      });
	
	      file.upload.error(function (err) {
	        _this.toaster.clear();
	        _this.toaster.pop('error', '上传失败', (0, _stringify2.default)(err));
	      });
	    }
	  }, {
	    key: 'getList',
	    value: function getList() {
	      var _this2 = this;
	
	      this.$http.get('/api/AppConfGroups').then(function (res) {
	        _this2.groups = res.data;
	      });
	    }
	  }, {
	    key: 'toggleSelection',
	    value: function toggleSelection(id) {
	      var idx = this.newFont.modelGroups.indexOf(id);
	      if (idx > -1) {
	        this.newFont.modelGroups.splice(idx, 1);
	      } else {
	        this.newFont.modelGroups.push(id);
	      }
	    }
	  }]);
	  return AddController;
	}();
	
	exports.default = AddController;

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(86);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _devicecert = __webpack_require__(494);
	
	var _devicecert2 = _interopRequireDefault(_devicecert);
	
	var _list = __webpack_require__(499);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _edit = __webpack_require__(501);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _add = __webpack_require__(503);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.devicecert', [_angularUiRouter2.default, _list2.default, _edit2.default, _add2.default]).config(_devicecert2.default).run(['$rootScope', function ($rootScope) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
	    if (next.name === 'logout' && current && current.name && !current.authenticate) {
	      next.referrer = current.name;
	    }
	  });
	}]).name;

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $urlRouterProvider.when("/devicecert", "/devicecert/list");
	  $stateProvider.state('devicecert', {
	    url: '/devicecert?page',
	    template: __webpack_require__(495),
	    authenticate: true
	  }).state('devicecert.list', {
	    url: '/list',
	    template: __webpack_require__(496),
	    controller: 'DeviceCertListController',
	    controllerAs: 'devicecertListCtrl'
	  }).state('devicecert.edit', {
	    url: '/edit/:id',
	    template: __webpack_require__(497),
	    controller: 'DeviceCertEditController',
	    controllerAs: 'devicecertEditCtrl'
	  }).state('devicecert.add', {
	    url: '/add',
	    template: __webpack_require__(498),
	    controller: 'DeviceCertAddController',
	    controllerAs: 'devicecertAddCtrl'
	  });
	}];

/***/ }),
/* 495 */
144,
/* 496 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-full\">\n  <div class=\"page-header\">\n    <a ui-sref=\"devicecert.add\" class=\"btn btn-primary pull-right\">添加</a>\n    <h3>设备认证</h3>\n  </div>\n  <div class=\"\">\n    <table class=\"table table-striped\">\n      <thead>\n        <tr>\n          <th style=\"width: 50px;\"></th>\n          <th>型号</th>\n          <th>语言</th>\n          <th>日期</th>\n          <th class=\"ctrl-th\"></th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"cert in devicecertListCtrl.list.list\">\n          <td>{{$index + 1}}</td>\n          <td>{{cert.model.join('\\\\')}}</td>\n          <td>{{cert.lang.join('\\\\')}}</td>\n          <td>{{cert.createdAt | date:'yyyy-MM-dd'}}</td>\n          <td class=\"ctrl-td\">\n            <button ui-sref=\"devicecert.edit({id: cert._id})\" class=\"btn btn-xs btn-success\">编辑</button>\n            <button ng-click=\"devicecertListCtrl.delete(cert._id)\" class=\"btn btn-xs btn-danger\">删除</button>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n\n    <div class=\"pagination-div\" ng-show=\"devicecertListCtrl.list.count > 0\">\n      <ul uib-pagination data-ng-if=\"devicecertListCtrl.list.count\" total-items=\"devicecertListCtrl.list.count\"\n        ng-model=\"devicecertListCtrl.page\" max-size=\"5\" class=\"\" boundary-link-numbers=\"true\" rotate=\"false\"\n        ng-change=\"devicecertListCtrl.pageChanged()\" items-per-page=\"devicecertListCtrl.params.limit\" previous-text=\"上一页\"\n        next-text=\"下一页\"></ul>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 497 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"page-header\">\n    <h1>编辑</h1>\n  </div>\n  <div>\n    <form>\n\n      <div class=\"form-group\">\n        <label for=\"model\">型号 <span class=\"text-danger\">(多型号用\\隔开)</span></label>\n        <input type=\"string\" class=\"form-control\" ng-model=\"devicecertEditCtrl.cert.model\" ng-list=\"\\\">\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"lang\">语言\n          <span class=\"text-danger\">(多种语言用\\隔开)</span>\n        </label>\n        <input type=\"lang\" class=\"form-control\" ng-model=\"devicecertEditCtrl.cert.lang\" ng-list=\"\\\">\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"file\"\">文件\n        </label>\n        <input type=\"file\" ngf-select ng-model=\"file\" name=\"file\" ngf-model-invalid=\"errorFile\"\n          class=\"form-control\">\n      </div>\n\n      <button type=\"submit\" class=\"btn btn-success\" ng-click=\"devicecertEditCtrl.upload(file)\">保存</button>\n      <button type=\"button\" class=\"btn btn-default\" ui-sref=\"^\">返回</button>\n    </form>\n  </div>\n</div>"

/***/ }),
/* 498 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"page-header\">\n    <h1>添加</h1>\n  </div>\n  <div>\n    <form>\n      <div class=\"form-group\">\n        <label for=\"model\">型号 <span class=\"text-danger\">(多型号用\\隔开)</span></label>\n        <input type=\"string\" class=\"form-control\" ng-model=\"devicecertAddCtrl.newCert.model\" ng-list=\"\\\">\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"lang\">语言\n          <span class=\"text-danger\">(多种语言用\\隔开)</span>\n        </label>\n        <input type=\"lang\" class=\"form-control\" ng-model=\"devicecertAddCtrl.newCert.lang\" ng-list=\"\\\" >\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"file\"\">文件\n          <span class=\" text-danger\">(必需)</span>\n        </label>\n        <input type=\"file\" ngf-select ng-model=\"file\" name=\"file\" required ngf-model-invalid=\"errorFile\"\n          class=\"form-control\">\n      </div>\n\n      <button type=\"submit\" class=\"btn btn-success\" ng-click=\"devicecertAddCtrl.upload(file)\">保存</button>\n      <button type=\"button\" class=\"btn btn-default\" ui-sref=\"^\">返回</button>\n    </form>\n  </div>\n</div>"

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _list = __webpack_require__(500);
	
	var _list2 = _interopRequireDefault(_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.devicecert.list', []).controller('DeviceCertListController', _list2.default).name;

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListController = function () {
	
	  /*@ngInject*/
	  ListController.$inject = ['$http', '$stateParams', '$state'];
	  function ListController($http, $stateParams, $state) {
	    (0, _classCallCheck3.default)(this, ListController);
	
	    this.$http = $http;
	    this.$stateParams = $stateParams;
	    this.$state = $state;
	
	    this.page = 1;
	    this.params = {
	      offset: this.page - 1,
	      limit: 20,
	      sortBy: 'createdAt',
	      order: -1
	    };
	  }
	
	  (0, _createClass3.default)(ListController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      if (this.$stateParams.page) {
	        this.page = this.$stateParams.page;
	      }
	      this.getCert();
	    }
	  }, {
	    key: 'getCert',
	    value: function getCert() {
	      var _this = this;
	
	      this.params.offset = (this.page - 1) * this.params.limit;
	      this.$http.get('/api/DeviceCerts', {
	        params: this.params
	      }).then(function (res) {
	        _this.list = res.data;
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(id) {
	      var _this2 = this;
	
	      if (confirm("确定？")) {
	        this.$http.delete('/api/DeviceCerts/' + id).then(function (res) {
	          _this2.getCert();
	        });
	      }
	    }
	  }, {
	    key: 'pageChanged',
	    value: function pageChanged() {
	      this.$state.go('devicecert.list', {
	        page: this.page
	      });
	    }
	  }]);
	  return ListController;
	}();
	
	exports.default = ListController;

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _edit = __webpack_require__(502);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.devicecert.edit', []).controller('DeviceCertEditController', _edit2.default).name;

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(157);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddController = function () {
	
	  /*@ngInject*/
	  AddController.$inject = ['$http', '$state', '$scope', 'Upload', 'toaster', '$stateParams'];
	  function AddController($http, $state, $scope, Upload, toaster, $stateParams) {
	    (0, _classCallCheck3.default)(this, AddController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$scope = $scope;
	    this.Upload = Upload;
	    this.toaster = toaster;
	    this.$stateParams = $stateParams;
	
	    this.cert = {};
	  }
	
	  (0, _createClass3.default)(AddController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getCert(this.$stateParams.id);
	    }
	  }, {
	    key: 'getCert',
	    value: function getCert(id) {
	      var _this = this;
	
	      this.$http.get('/api/DeviceCerts/' + id).then(function (res) {
	        _this.cert = res.data;
	      });
	    }
	  }, {
	    key: 'upload',
	    value: function upload(file) {
	      var _this2 = this;
	
	      if (!file) {
	        this.update();
	        return;
	      }
	      this.toaster.pop({
	        type: 'wait',
	        title: '正在上传，请稍等...',
	        body: file.name,
	        timeout: 3000 * 1000
	      });
	
	      file.upload = this.Upload.upload({
	        url: '/api/DeviceCerts/uploadFile',
	        file: file,
	        data: this.cert,
	        headers: {
	          'Content-Type': 'multipart/form-data'
	        }
	      });
	
	      file.upload.progress(function (evt) {
	        file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
	      });
	
	      file.upload.success(function (data, status, headers, config) {
	        _this2.toaster.clear();
	        _this2.$state.go('devicecert');
	        _this2.toaster.pop('success', '上传成功', file.name);
	      });
	
	      file.upload.error(function (err) {
	        _this2.toaster.clear();
	        _this2.toaster.pop('error', '上传失败', (0, _stringify2.default)(err));
	      });
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var _this3 = this;
	
	      this.$http.put('/api/DeviceCerts/' + this.$stateParams.id, this.cert).then(function (res) {
	        _this3.$state.go('devicecert');
	      });
	    }
	  }]);
	  return AddController;
	}();
	
	exports.default = AddController;

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _add = __webpack_require__(504);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.devicecert.add', []).controller('DeviceCertAddController', _add2.default).name;

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(157);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddController = function () {
	
	  /*@ngInject*/
	  AddController.$inject = ['$http', '$state', '$scope', 'Upload', 'toaster'];
	  function AddController($http, $state, $scope, Upload, toaster) {
	    (0, _classCallCheck3.default)(this, AddController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$scope = $scope;
	    this.Upload = Upload;
	    this.toaster = toaster;
	
	    this.newCert = {};
	  }
	
	  (0, _createClass3.default)(AddController, [{
	    key: 'upload',
	    value: function upload(file) {
	      var _this = this;
	
	      this.toaster.pop({
	        type: 'wait',
	        title: '正在上传，请稍等...',
	        body: file.name,
	        timeout: 3000 * 1000
	      });
	
	      file.upload = this.Upload.upload({
	        url: '/api/DeviceCerts/uploadFile',
	        file: file,
	        data: this.newCert,
	        headers: {
	          'Content-Type': 'multipart/form-data'
	        }
	      });
	
	      file.upload.progress(function (evt) {
	        file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
	      });
	
	      file.upload.success(function (data, status, headers, config) {
	        _this.toaster.clear();
	        _this.$state.go('devicecert');
	        _this.toaster.pop('success', '上传成功', file.name);
	      });
	
	      file.upload.error(function (err) {
	        _this.toaster.clear();
	        _this.toaster.pop('error', '上传失败', (0, _stringify2.default)(err));
	      });
	    }
	  }]);
	  return AddController;
	}();
	
	exports.default = AddController;

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(86);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _tpFirmwares = __webpack_require__(506);
	
	var _tpFirmwares2 = _interopRequireDefault(_tpFirmwares);
	
	var _list = __webpack_require__(511);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _add = __webpack_require__(513);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _edit = __webpack_require__(515);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.tpFirmwares', [_angularUiRouter2.default, _list2.default, _add2.default, _edit2.default]).config(_tpFirmwares2.default).run(['$rootScope', function ($rootScope) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
	    if (next.name === 'logout' && current && current.name && !current.authenticate) {
	      next.referrer = current.name;
	    }
	  });
	}]).name;

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $urlRouterProvider.when("/tpFirmwares", "/tpFirmwares/list");
	
	  $stateProvider.state('tpFirmwares', {
	    url: '/tpFirmwares',
	    template: __webpack_require__(507),
	    authenticate: true
	  }).state('tpFirmwares.list', {
	    url: '/list',
	    template: __webpack_require__(508),
	    controller: 'TpFirmwaresListController',
	    controllerAs: 'tpListCtrl'
	  }).state('tpFirmwares.add', {
	    url: '/add',
	    template: __webpack_require__(509),
	    controller: 'TpFirmwaresAddController',
	    controllerAs: 'tpAddCtrl'
	  }).state('tpFirmwares.edit', {
	    url: '/edit/:id',
	    template: __webpack_require__(510),
	    controller: 'TpFirmwaresEditController',
	    controllerAs: 'tpEditCtrl'
	  });
	}];

/***/ }),
/* 507 */
144,
/* 508 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"ctrl-panel\">\n    <a ui-sref=\"tpFirmwares.add\" class=\"btn btn-primary pull-right\">添加</a>\n    <h3>外设固件</h3>\n  </div>\n\n  <div class=\"\">\n    <table class=\"table table-striped\">\n      <thead>\n        <tr>\n          <th>device name</th>\n          <th>firmware ver</th>\n          <th>magic word</th>\n          <th>manufacturer</th>\n          <th>panel type</th>\n          <th>product id</th>\n          <th>touch name</th>\n          <th class=\"ctrl-th\"></th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"item in tpListCtrl.data\">\n          <td>{{item.device_name}}</td>\n          <td>{{item.firmware_ver}}</td>\n          <td>{{item.magic_word}}</td>\n          <td>{{item.manufacturer}}</td>\n          <td>{{item.panel_type}}</td>\n          <td>{{item.product_id}}</td>\n          <td>{{item.touch_name}}</td>\n          <td>{{item.createdAt | date:'yyyy-MM-dd'}}</td>\n          <td class=\"ctrl-td\">\n            <button ui-sref=\"tpFirmwares.edit({id: item._id})\" class=\"btn btn-xs btn-primary\">编辑</button>\n            <button ng-click=\"tpListCtrl.delete(item._id)\" class=\"btn btn-xs btn-danger\">删除</button>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 509 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"page-header\">\n    <h1>添加</h1>\n  </div>\n  <div>\n    <form>\n      <div class=\"form-group\">\n        <label for=\"device_name\">device name\n          <span class=\"text-danger\">(必需)</span>\n        </label>\n        <input type=\"device_name\" class=\"form-control\" ng-model=\"tpAddCtrl.newFirmware.device_name\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"firmware_ver\">firmware ver\n          <span class=\"text-danger\">(必需)</span>\n        </label>\n        <input type=\"firmware_ver\" class=\"form-control\" ng-model=\"tpAddCtrl.newFirmware.firmware_ver\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"magic_word\">magic word\n          <span class=\"text-danger\">(必需)</span>\n        </label>\n        <input type=\"magic_word\" class=\"form-control\" ng-model=\"tpAddCtrl.newFirmware.magic_word\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"manufacturer\">manufacturer\n          <span class=\"text-danger\">(必需)</span>\n        </label>\n        <input type=\"manufacturer\" class=\"form-control\" ng-model=\"tpAddCtrl.newFirmware.manufacturer\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"panel_type\">panel type\n          <span class=\"text-danger\">(必需)</span>\n        </label>\n        <input type=\"panel_type\" class=\"form-control\" ng-model=\"tpAddCtrl.newFirmware.panel_type\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"product_id\">product id\n          <span class=\"text-danger\">(必需)</span>\n        </label>\n        <input type=\"product_id\" class=\"form-control\" ng-model=\"tpAddCtrl.newFirmware.product_id\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"touch_name\">touch name\n          <span class=\"text-danger\">(必需)</span>\n        </label>\n        <input type=\"touch_name\" class=\"form-control\" ng-model=\"tpAddCtrl.newFirmware.touch_name\" required>\n      </div>\n\n\n      <div class=\"form-group\">\n        <label for=\"file\">文件\n          <span class=\" text-danger\">(必需)</span>\n        </label>\n        <input type=\"file\" ngf-select ng-model=\"file\" name=\"file\" required ngf-model-invalid=\"errorFile\"\n          class=\"form-control\">\n      </div>\n\n      <button type=\"submit\" class=\"btn btn-success\" ng-click=\"tpAddCtrl.upload(file)\">保存</button>\n      <button type=\"button\" class=\"btn btn-default\" ui-sref=\"^\">返回</button>\n    </form>\n  </div>\n</div>"

/***/ }),
/* 510 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"page-header\">\n    <h1>编辑</h1>\n  </div>\n  <div>\n    <form>\n      <div class=\"form-group\">\n      <label for=\"device_name\">device name\n        <span class=\"text-danger\">(必需)</span>\n      </label>\n      <input type=\"device_name\" class=\"form-control\" ng-model=\"tpEditCtrl.firmware.device_name\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"firmware_ver\">firmware ver\n          <span class=\"text-danger\">(必需)</span>\n        </label>\n        <input type=\"firmware_ver\" class=\"form-control\" ng-model=\"tpEditCtrl.firmware.firmware_ver\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"magic_word\">magic word\n          <span class=\"text-danger\">(必需)</span>\n        </label>\n        <input type=\"magic_word\" class=\"form-control\" ng-model=\"tpEditCtrl.firmware.magic_word\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"manufacturer\">manufacturer\n          <span class=\"text-danger\">(必需)</span>\n        </label>\n        <input type=\"manufacturer\" class=\"form-control\" ng-model=\"tpEditCtrl.firmware.manufacturer\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"panel_type\">panel type\n          <span class=\"text-danger\">(必需)</span>\n        </label>\n        <input type=\"panel_type\" class=\"form-control\" ng-model=\"tpEditCtrl.firmware.panel_type\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"product_id\">product id\n          <span class=\"text-danger\">(必需)</span>\n        </label>\n        <input type=\"product_id\" class=\"form-control\" ng-model=\"tpEditCtrl.firmware.product_id\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"touch_name\">touch name\n          <span class=\"text-danger\">(必需)</span>\n        </label>\n        <input type=\"touch_name\" class=\"form-control\" ng-model=\"tpEditCtrl.firmware.touch_name\" required>\n      </div>\n\n      <button type=\"submit\" class=\"btn btn-success\" ng-click=\"tpEditCtrl.update()\">保存</button>\n      <button type=\"button\" class=\"btn btn-default\" ui-sref=\"^\">返回</button>\n    </form>\n  </div>\n</div>"

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _list = __webpack_require__(512);
	
	var _list2 = _interopRequireDefault(_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.tpFirmwares.list', []).controller('TpFirmwaresListController', _list2.default).name;

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListController = function () {
	
	  /*@ngInject*/
	  ListController.$inject = ['$http'];
	  function ListController($http) {
	    (0, _classCallCheck3.default)(this, ListController);
	
	    this.$http = $http;
	  }
	
	  (0, _createClass3.default)(ListController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getData();
	    }
	  }, {
	    key: 'getData',
	    value: function getData() {
	      var _this = this;
	
	      this.$http.get('/api/tpFirmwares').then(function (res) {
	        _this.data = res.data;
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(id) {
	      var _this2 = this;
	
	      if (confirm("确定？")) {
	        this.$http.delete('/api/tpFirmwares/' + id).then(function (res) {
	          _this2.getData();
	        });
	      }
	    }
	  }]);
	  return ListController;
	}();
	
	exports.default = ListController;

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _add = __webpack_require__(514);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.tpFirmwares.add', []).controller('TpFirmwaresAddController', _add2.default).name;

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(157);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddController = function () {
	
	  /*@ngInject*/
	  AddController.$inject = ['$http', '$state', '$scope', 'Upload', 'toaster'];
	  function AddController($http, $state, $scope, Upload, toaster) {
	    (0, _classCallCheck3.default)(this, AddController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$scope = $scope;
	    this.Upload = Upload;
	    this.toaster = toaster;
	
	    this.newFirmware = {};
	  }
	
	  (0, _createClass3.default)(AddController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: 'upload',
	    value: function upload(file) {
	      var _this = this;
	
	      this.toaster.pop({
	        type: 'wait',
	        title: '正在上传，请稍等...',
	        body: file.name,
	        timeout: 3000 * 1000
	      });
	
	      file.upload = this.Upload.upload({
	        url: '/api/tpFirmwares/uploadFile',
	        file: file,
	        data: this.newFirmware,
	        headers: {
	          'Content-Type': 'multipart/form-data'
	        }
	      });
	
	      file.upload.progress(function (evt) {
	        file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
	      });
	
	      file.upload.success(function (data, status, headers, config) {
	        _this.toaster.clear();
	        _this.$state.go('tpFirmwares');
	        _this.toaster.pop('success', '上传成功', file.name);
	      });
	
	      file.upload.error(function (err) {
	        _this.toaster.clear();
	        _this.toaster.pop('error', '上传失败', (0, _stringify2.default)(err));
	      });
	    }
	  }]);
	  return AddController;
	}();
	
	exports.default = AddController;

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _edit = __webpack_require__(516);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.tpFirmwares.edit', []).controller('TpFirmwaresEditController', _edit2.default).name;

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddController = function () {
	
	  /*@ngInject*/
	  AddController.$inject = ['$http', '$state', '$stateParams', '$scope'];
	  function AddController($http, $state, $stateParams, $scope) {
	    (0, _classCallCheck3.default)(this, AddController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$scope = $scope;
	
	    this.firmware = {};
	  }
	
	  (0, _createClass3.default)(AddController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getTpFirmwares(this.$stateParams.id);
	    }
	  }, {
	    key: 'getTpFirmwares',
	    value: function getTpFirmwares(id) {
	      var _this = this;
	
	      this.$http.get('/api/tpFirmwares/' + id).then(function (res) {
	        _this.firmware = res.data;
	      });
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var _this2 = this;
	
	      this.$http.put('/api/tpFirmwares/' + this.$stateParams.id, this.firmware).then(function (res) {
	        _this2.$state.go('tpFirmwares');
	      });
	    }
	  }]);
	  return AddController;
	}();
	
	exports.default = AddController;

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(86);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _monitor = __webpack_require__(518);
	
	var _monitor2 = _interopRequireDefault(_monitor);
	
	var _list = __webpack_require__(523);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _add = __webpack_require__(525);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _edit = __webpack_require__(527);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.monitor', [_angularUiRouter2.default, _list2.default, _add2.default, _edit2.default]).config(_monitor2.default).run(['$rootScope', function ($rootScope) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
	    if (next.name === 'logout' && current && current.name && !current.authenticate) {
	      next.referrer = current.name;
	    }
	  });
	}]).name;

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $urlRouterProvider.when("/monitor", "/monitor/list");
	
	  $stateProvider.state('monitor', {
	    url: '/monitor',
	    template: __webpack_require__(519),
	    authenticate: true
	  }).state('monitor.list', {
	    url: '/list',
	    template: __webpack_require__(520),
	    controller: 'MonitorListController',
	    controllerAs: 'monitorListCtrl'
	  }).state('monitor.add', {
	    url: '/add',
	    template: __webpack_require__(521),
	    controller: 'MonitorAddController',
	    controllerAs: 'monitorAddCtrl'
	  }).state('monitor.edit', {
	    url: '/edit/:id',
	    template: __webpack_require__(522),
	    controller: 'MonitorEditController',
	    controllerAs: 'monitorEditCtrl'
	  });
	}];

/***/ }),
/* 519 */
144,
/* 520 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"ctrl-panel\">\n    <a ui-sref=\"monitor.add\" class=\"btn btn-primary pull-right\">添加</a>\n    <h3>显示器固件</h3>\n  </div>\n\n  <div class=\"\">\n    <table class=\"table table-striped\">\n      <thead>\n        <tr>\n          <th>型号</th>\n          <th>版本</th>\n          <th>更新时间</th>\n          <th class=\"ctrl-th\"></th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"item in monitorListCtrl.data\">\n          <td>{{item.model}}</td>\n          <td>{{item.version}}</td>\n          <td>{{item.createdAt | date:'yyyy-MM-dd'}}</td>\n          <td class=\"ctrl-td\">\n            <button ui-sref=\"monitor.edit({id: item._id})\" class=\"btn btn-xs btn-primary\">编辑</button>\n            <button ng-click=\"monitorListCtrl.delete(item._id)\" class=\"btn btn-xs btn-danger\">删除</button>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 521 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"page-header\">\n    <h1>添加</h1>\n  </div>\n  <div>\n    <form>\n      <div class=\"form-group\">\n        <label for=\"model\">型号\n          <span class=\"text-danger\">(必需)</span>\n        </label>\n        <input type=\"model\" class=\"form-control\" ng-model=\"monitorAddCtrl.newFirmware.model\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"version\">FPGA固件版本号\n          <span class=\"text-danger\">(必需)</span>\n        </label>\n        <input type=\"number\" class=\"form-control\" ng-model=\"monitorAddCtrl.newFirmware.version\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"version\">RTD固件版本号</label>\n        <input type=\"number\" class=\"form-control\" ng-model=\"monitorAddCtrl.newFirmware.rtdVersion\" required>\n      </div>\n\n       <div class=\"form-group\">\n         <label for=\"logs\">变更信息\n           <span class=\"text-danger\">(必需 zh)</span>\n         </label>\n         <textarea type=\"logs\" class=\"form-control\" ng-model=\"monitorAddCtrl.newFirmware.logs.zh\"\n           ng-list=\"&#10;\" ng-trim=\"false\" rows=\"5\" ng-required=\"true\"></textarea>\n       </div>\n\n\n       <div class=\"form-group\">\n         <label for=\"logs\">变更信息\n           <span class=\"text-danger\">(必需 en)</span>\n         </label>\n         <textarea type=\"logs\" class=\"form-control\" ng-model=\"monitorAddCtrl.newFirmware.logs.en\"\n           ng-list=\"&#10;\" ng-trim=\"false\" rows=\"5\" ng-required=\"true\"></textarea>\n       </div>\n\n       <div class=\"form-group\">\n                <label for=\"clientIds\">目标客户端\n                    <span class=\"text-danger\">（每行一个客户端id）</span>\n                </label>\n                <textarea type=\"clientIds\" class=\"form-control\" ng-model=\"monitorAddCtrl.newFirmware.clientIds\" ng-list=\"&#10;\" ng-trim=\"false\"\n                    rows=\"5\"></textarea>\n        </div>\n\n      <div class=\"form-group\">\n        <label for=\"file\">文件\n          <span class=\" text-danger\">(必需, 请打包成zip压缩包上传)</span>\n        </label>\n        <input type=\"file\" ngf-select ng-model=\"file\" name=\"file\" required ngf-model-invalid=\"errorFile\"\n          class=\"form-control\">\n      </div>\n\n      <button type=\"submit\" class=\"btn btn-success\" ng-click=\"monitorAddCtrl.upload(file)\">保存</button>\n      <button type=\"button\" class=\"btn btn-default\" ui-sref=\"^\">返回</button>\n    </form>\n  </div>\n</div>"

/***/ }),
/* 522 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"page-header\">\n    <h1>编辑</h1>\n  </div>\n  <div>\n    <form>\n      <div class=\"form-group\">\n        <label for=\"model\">型号\n          <span class=\"text-danger\">(必需)</span>\n        </label>\n        <input type=\"model\" class=\"form-control\" ng-model=\"monitorEditCtrl.data.model\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"version\">FPGA固件版本号\n          <span class=\"text-danger\">(必需)</span>\n        </label>\n        <input type=\"number\" class=\"form-control\" ng-model=\"monitorEditCtrl.data.version\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"version\">RTD固件版本号</label>\n        <input type=\"number\" class=\"form-control\" ng-model=\"monitorEditCtrl.data.rtdVersion\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"logs\">变更信息\n          <span class=\"text-danger\">(必需 zh)</span>\n        </label>\n        <textarea type=\"logs\" class=\"form-control\" ng-model=\"monitorEditCtrl.data.logs.zh\" ng-list=\"&#10;\"\n          ng-trim=\"false\" rows=\"5\" ng-required=\"true\"></textarea>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"logs\">变更信息\n          <span class=\"text-danger\">(必需 en)</span>\n        </label>\n        <textarea type=\"logs\" class=\"form-control\" ng-model=\"monitorEditCtrl.data.logs.en\" ng-list=\"&#10;\"\n          ng-trim=\"false\" rows=\"5\" ng-required=\"true\"></textarea>\n      </div>\n\n      <div class=\"form-group\">\n                <label for=\"clientIds\">目标客户端\n                    <span class=\"text-danger\">（每行一个客户端id）</span>\n                </label>\n                <textarea type=\"clientIds\" class=\"form-control\" ng-model=\"monitorEditCtrl.data.clientIds\" ng-list=\"&#10;\" ng-trim=\"false\"\n                    rows=\"5\"></textarea>\n        </div>\n\n      <button type=\"submit\" class=\"btn btn-success\" ng-click=\"monitorEditCtrl.update()\">保存</button>\n      <button type=\"button\" class=\"btn btn-default\" ui-sref=\"^\">返回</button>\n    </form>\n  </div>\n</div>"

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _list = __webpack_require__(524);
	
	var _list2 = _interopRequireDefault(_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.monitor.list', []).controller('MonitorListController', _list2.default).name;

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListController = function () {
	
	  /*@ngInject*/
	  ListController.$inject = ['$http'];
	  function ListController($http) {
	    (0, _classCallCheck3.default)(this, ListController);
	
	    this.$http = $http;
	  }
	
	  (0, _createClass3.default)(ListController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getData();
	    }
	  }, {
	    key: 'getData',
	    value: function getData() {
	      var _this = this;
	
	      this.$http.get('/api/monitors').then(function (res) {
	        _this.data = res.data;
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(id) {
	      var _this2 = this;
	
	      if (confirm("确定？")) {
	        this.$http.delete('/api/monitors/' + id).then(function (res) {
	          _this2.getData();
	        });
	      }
	    }
	  }]);
	  return ListController;
	}();
	
	exports.default = ListController;

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _add = __webpack_require__(526);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.monitor.add', []).controller('MonitorAddController', _add2.default).name;

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(157);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddController = function () {
	
	  /*@ngInject*/
	  AddController.$inject = ['$http', '$state', '$scope', 'Upload', 'toaster'];
	  function AddController($http, $state, $scope, Upload, toaster) {
	    (0, _classCallCheck3.default)(this, AddController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$scope = $scope;
	    this.Upload = Upload;
	    this.toaster = toaster;
	
	    this.newFirmware = {};
	  }
	
	  (0, _createClass3.default)(AddController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: 'upload',
	    value: function upload(file) {
	      var _this = this;
	
	      this.toaster.pop({
	        type: 'wait',
	        title: '正在上传，请稍等...',
	        body: file.name,
	        timeout: 3000 * 1000
	      });
	
	      file.upload = this.Upload.upload({
	        url: '/api/monitors/uploadFile',
	        file: file,
	        data: this.newFirmware,
	        headers: {
	          'Content-Type': 'multipart/form-data'
	        }
	      });
	
	      file.upload.progress(function (evt) {
	        file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
	      });
	
	      file.upload.success(function (data, status, headers, config) {
	        _this.toaster.clear();
	        _this.$state.go('monitor');
	        _this.toaster.pop('success', '上传成功', file.name);
	      });
	
	      file.upload.error(function (err) {
	        _this.toaster.clear();
	        _this.toaster.pop('error', '上传失败', (0, _stringify2.default)(err));
	      });
	    }
	  }]);
	  return AddController;
	}();
	
	exports.default = AddController;

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _edit = __webpack_require__(528);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.monitor.edit', []).controller('MonitorEditController', _edit2.default).name;

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddController = function () {
	
	  /*@ngInject*/
	  AddController.$inject = ['$http', '$state', '$stateParams', '$scope'];
	  function AddController($http, $state, $stateParams, $scope) {
	    (0, _classCallCheck3.default)(this, AddController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$scope = $scope;
	
	    this.data = {};
	  }
	
	  (0, _createClass3.default)(AddController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getMonitor(this.$stateParams.id);
	    }
	  }, {
	    key: 'getMonitor',
	    value: function getMonitor(id) {
	      var _this = this;
	
	      this.$http.get('/api/monitors/' + id).then(function (res) {
	        _this.data = res.data;
	      });
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var _this2 = this;
	
	      this.$http.put('/api/monitors/' + this.$stateParams.id, this.data).then(function (res) {
	        _this2.$state.go('monitor');
	      });
	    }
	  }]);
	  return AddController;
	}();
	
	exports.default = AddController;

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(86);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _keyboard = __webpack_require__(530);
	
	var _keyboard2 = _interopRequireDefault(_keyboard);
	
	var _list = __webpack_require__(535);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _add = __webpack_require__(537);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.keyboard', [_angularUiRouter2.default, _list2.default, _add2.default]).config(_keyboard2.default).run(['$rootScope', function ($rootScope) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
	    if (next.name === 'logout' && current && current.name && !current.authenticate) {
	      next.referrer = current.name;
	    }
	  });
	}]).name;

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $urlRouterProvider.when('/keyboard', '/keyboard/list');
	  $stateProvider.state('keyboard', {
	    url: '/keyboard',
	    template: __webpack_require__(531),
	    authenticate: true
	  }).state('keyboard.list', {
	    url: '/list',
	    template: __webpack_require__(532),
	    controller: 'KeyboardListController',
	    controllerAs: 'kbListCtrl'
	  }).state('keyboard.edit', {
	    url: '/edit/:id',
	    template: __webpack_require__(533),
	    controller: 'KeyboardEditController',
	    controllerAs: 'kbEdittCtrl'
	  }).state('keyboard.add', {
	    url: '/add',
	    template: __webpack_require__(534),
	    controller: 'KeyboardAddController',
	    controllerAs: 'kbAddCtrl'
	  });
	}];

/***/ }),
/* 531 */
144,
/* 532 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"page-header\">\n    <a ui-sref=\"keyboard.add\" class=\"btn btn-primary pull-right\">添加</a>\n    <h3>输入法数据</h3>\n  </div>\n  <div class=\"\">\n    <table class=\"table table-striped\">\n      <thead>\n        <tr>\n          <th style=\"width: 50px;\"></th>\n          <th>名字</th>\n          <th class=\"ctrl-th\"></th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"item in kbListCtrl.list.list\">\n          <td>{{$index + 1}}</td>\n          <td>{{item.name}}</td>\n          <td class=\"ctrl-td\">\n            <button ng-click=\"kbListCtrl.delete(item._id)\" class=\"btn btn-xs btn-danger\">删除</button>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 533 */
382,
/* 534 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <form>\n    <label>添加数据</label>\n    <div class=\"form-group\">\n      <label for=\"file\">文件 <span class=\"text-danger\">(必需)</span></label>\n      <input type=\"file\" ngf-select ng-model=\"kbAddCtrl.kbFile\" name=\"file\" required ngf-model-invalid=\"errorFile\"\n        class=\"form-control\">\n    </div>\n\n    <button type=\"submit\" class=\"btn btn-success\" ng-click=\"kbAddCtrl.addData(kbAddCtrl.kbFile)\">保存</button>\n  </form>\n\n</div>\n"

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _list = __webpack_require__(536);
	
	var _list2 = _interopRequireDefault(_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.keyboard.list', []).controller('KeyboardListController', _list2.default).name;

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListController = function () {
	
	  /*@ngInject*/
	  ListController.$inject = ['$http'];
	  function ListController($http) {
	    (0, _classCallCheck3.default)(this, ListController);
	
	    this.$http = $http;
	  }
	
	  (0, _createClass3.default)(ListController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getList();
	    }
	  }, {
	    key: 'getList',
	    value: function getList() {
	      var _this = this;
	
	      this.$http.get('/api/1/keyboard').then(function (res) {
	        _this.list = res.data;
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(id) {
	      var _this2 = this;
	
	      if (confirm('确定？')) {
	        this.$http.delete('/api/1/keyboard/' + id).then(function (res) {
	          _this2.getList();
	        });
	      }
	    }
	  }]);
	  return ListController;
	}();
	
	exports.default = ListController;

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _add = __webpack_require__(538);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.keyboard.add', []).controller('KeyboardAddController', _add2.default).name;

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(157);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddController = function () {
	
	  /*@ngInject*/
	  AddController.$inject = ['$http', '$state', '$timeout', '$scope', 'Upload', 'toaster'];
	  function AddController($http, $state, $timeout, $scope, Upload, toaster) {
	    (0, _classCallCheck3.default)(this, AddController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$timeout = $timeout;
	    this.Upload = Upload;
	    this.$scope = $scope;
	    this.toaster = toaster;
	
	    this.newData = {};
	  }
	
	  (0, _createClass3.default)(AddController, [{
	    key: 'addData',
	    value: function addData(file) {
	      var _this = this;
	
	      this.toaster.pop({
	        type: 'wait',
	        title: '正在上传',
	        body: file.name,
	        timeout: 3000 * 1000
	      });
	      file.upload = this.Upload.upload({
	        url: '/api/1/keyboard',
	        file: file,
	        data: this.newData,
	        headers: {
	          'Content-Type': 'multipart/form-data'
	        }
	      });
	
	      file.upload.progress(function (evt) {
	        file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
	      });
	
	      file.upload.success(function (data, status, headers, config) {
	        _this.toaster.clear();
	        _this.toaster.pop('success', '上传成功', file.name);
	        _this.$state.go('keyboard.list');
	      });
	
	      file.upload.error(function (err) {
	        _this.toaster.clear();
	        _this.toaster.pop('error', '上传失败', (0, _stringify2.default)(err));
	      });
	    }
	  }]);
	  return AddController;
	}();
	
	exports.default = AddController;

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(86);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _deviceconfigs = __webpack_require__(540);
	
	var _deviceconfigs2 = _interopRequireDefault(_deviceconfigs);
	
	var _list = __webpack_require__(546);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _show = __webpack_require__(548);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _add = __webpack_require__(550);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _edit = __webpack_require__(552);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('onyxReadingRoomApp.deviceconfigs', [_angularUiRouter2.default, _list2.default, _show2.default, _add2.default, _edit2.default]).config(_deviceconfigs2.default).run(['$rootScope', function ($rootScope) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
	    if (next.name === 'logout' && current && current.name && !current.authenticate) {
	      next.referrer = current.name;
	    }
	  });
	}]).name;

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $urlRouterProvider.when('/deviceconfigs', '/deviceconfigs/list');
	
	  $stateProvider.state('deviceconfigs', {
	    url: '/deviceconfigs',
	    template: __webpack_require__(541),
	    authenticate: true
	  }).state('deviceconfigs.list', {
	    url: '/list',
	    template: __webpack_require__(542),
	    controller: 'DeviceConfigsListController',
	    controllerAs: 'dcListCtrl',
	    authenticate: true
	  }).state('deviceconfigs.show', {
	    url: '/show/:id',
	    template: __webpack_require__(543),
	    controller: 'DeviceConfigsShowController',
	    controllerAs: 'dcShowCtrl',
	    authenticate: true
	  }).state('deviceconfigs.add', {
	    url: '/add',
	    template: __webpack_require__(544),
	    controller: 'DeviceConfigsAddController',
	    controllerAs: 'dcAddCtrl',
	    authenticate: true
	  }).state('deviceconfigs.edit', {
	    url: '/edit/:id',
	    template: __webpack_require__(545),
	    controller: 'DeviceConfigsEditController',
	    controllerAs: 'dcEditCtrl',
	    authenticate: true
	  });
	}];

/***/ }),
/* 541 */
/***/ (function(module, exports) {

	module.exports = "<div ui-view></div>"

/***/ }),
/* 542 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-full\">\n  <div class=\"ctrl-panel\">\n    <h3>设备配置</h3>\n  </div>\n\n  <div class=\"\">\n    <table class=\"table table-striped\">\n      <thead>\n        <tr>\n          <th></th>\n          <th>名称</th>\n          <th>型号</th>\n          <th>固件版本</th>\n          <th>分类</th>\n          <th class=\"ctrl-th\"></th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"conf in dcListCtrl.confs\" >\n          <td>{{$index + 1}}</td>\n          <td>{{conf.name}}</td>\n          <td>{{conf.model.join(',')}}</td>\n          <td>{{conf.firmwareVersion}}</td>\n          <td>{{conf.category}}</td>\n          <td class=\"ctrl-td\">\n            <button ui-sref=\"deviceconfigs.show({id: conf._id})\" class=\"btn btn-xs btn-success\">详细</button>\n            <button ui-sref=\"deviceconfigs.edit({id: conf._id})\" class=\"btn btn-xs btn-primary\">编辑</button>\n            <button ng-click=\"dcListCtrl.delete(conf._id)\" class=\"btn btn-xs btn-danger\">删除</button>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 543 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"page-header\">\n    <a ui-sref=\"deviceconfigs.edit({id: dcShowCtrl.conf._id})\" class=\"btn btn-primary pull-right\">编辑</a>\n    <h3>配置</h3>\n  </div>\n\n  <div class=\"\">\n    <table class=\"table table-condensed\">\n      <thead>\n        <tr>\n          <th>属性</th>\n          <th>值</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr>\n          <td>名称</td>\n          <td>{{dcShowCtrl.conf.name}}</td>\n        </tr>\n        <tr>\n          <td style=\"line-height: 38px;\">型号</td>\n          <td>{{dcShowCtrl.conf.model.join(',')}}</td>\n        </tr>\n        <tr>\n          <td>固件版本</td>\n          <td>{{dcShowCtrl.conf.firmwareVersion}}</td>\n        </tr>\n        <tr>\n          <td>分类</td>\n          <td>{{dcShowCtrl.conf.category}}</td>\n        </tr>\n        <tr>\n          <td>配置</td>\n          <td>{{dcShowCtrl.conf.config}}</td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 544 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h3>添加配置</h3>\n  <form>\n    <div class=\"form-group\">\n      <label for=\"name\">名称</label>\n      <input type=\"name\" class=\"form-control\" ng-model=\"dcAddCtrl.newConf.name\">\n    </div>\n    <div class=\"form-group\">\n      <label for=\"model\">设备型号(多个型号用|分隔，如：C67ML|C87ML)</label>\n      <input type=\"model\" class=\"form-control\" ng-model=\"dcAddCtrl.newConf.model\" ng-list=\"|\">\n    </div>\n    <div class=\"form-group\">\n      <label for=\"firmwareVersion\">固件版本</label>\n      <input type=\"number\" class=\"form-control\" ng-model=\"dcAddCtrl.newConf.firmwareVersion\">\n    </div>\n    <div class=\"form-group\">\n      <label for=\"category\">分类</label>\n      <input type=\"category\" class=\"form-control\" ng-model=\"dcAddCtrl.newConf.category\">\n    </div>\n    <div>\n      <label for=\"config\">配置</label>\n      <textarea name=\"config\" class=\"form-control\" rows=\"8\" cols=\"40\" ng-model=\"dcAddCtrl.newConf.config\" required></textarea>\n    </div>\n\n    <button type=\"submit\" class=\"btn btn-success\" ng-click=\"dcAddCtrl.add()\">保存</button>\n  </form>\n</div>"

/***/ }),
/* 545 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h3>优化配置</h3>\n  <div class=\"col-xs-6\">\n    <form>\n      <div class=\"form-group\">\n        <label for=\"name\">名称</label>\n        <input type=\"name\" class=\"form-control\" ng-model=\"dcEditCtrl.conf.name\">\n      </div>\n      <div class=\"form-group\">\n        <label for=\"model\">设备型号(多个型号用|分隔，如：C67ML|C87ML)</label>\n        <input type=\"model\" class=\"form-control\" ng-model=\"dcEditCtrl.conf.model\" ng-list=\"|\">\n      </div>\n      <div class=\"form-group\">\n        <label for=\"firmwareVersion\">固件版本</label>\n        <input type=\"number\" class=\"form-control\" ng-model=\"dcEditCtrl.conf.firmwareVersion\">\n      </div>\n      <div class=\"form-group\">\n        <label for=\"category\">分类</label>\n        <input type=\"category\" class=\"form-control\" ng-model=\"dcEditCtrl.conf.category\">\n      </div>\n      <div>\n        <label for=\"config\">配置</label>\n        <textarea name=\"config\" class=\"form-control\" rows=\"8\" cols=\"40\" ng-model=\"dcEditCtrl.conf.config\"\n          required></textarea>\n      </div>\n\n      <button type=\"submit\" class=\"btn btn-success\" ng-click=\"dcEditCtrl.save()\">保存</button>\n    </form>\n  </div>\n</div>\n"

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _list = __webpack_require__(547);
	
	var _list2 = _interopRequireDefault(_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('onyxReadingRoomApp.deviceconfigs.list', []).controller('DeviceConfigsListController', _list2.default).name;

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListController = function () {
	
	  /*@ngInject*/
	  ListController.$inject = ['$http', '$state'];
	  function ListController($http, $state) {
	    (0, _classCallCheck3.default)(this, ListController);
	
	    this.$http = $http;
	    this.$state = $state;
	  }
	
	  (0, _createClass3.default)(ListController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getConfs();
	    }
	  }, {
	    key: 'getConfs',
	    value: function getConfs() {
	      var _this = this;
	
	      this.$http.get('/api/deviceconfigs').then(function (response) {
	        _this.confs = response.data;
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(id) {
	      var _this2 = this;
	
	      if (confirm('确定？')) {
	        this.$http.delete('api/deviceconfigs/' + id).then(function (response) {
	          _this2.getConfs();
	        });
	      }
	    }
	  }]);
	  return ListController;
	}();
	
	exports.default = ListController;

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _show = __webpack_require__(549);
	
	var _show2 = _interopRequireDefault(_show);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('onyxReadingRoomApp.deviceconfigs.show', []).controller('DeviceConfigsShowController', _show2.default).name;

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ShowController = function () {
	
	  /*@ngInject*/
	  ShowController.$inject = ['$http', '$stateParams'];
	  function ShowController($http, $stateParams) {
	    (0, _classCallCheck3.default)(this, ShowController);
	
	    this.$http = $http;
	    this.$stateParams = $stateParams;
	  }
	
	  (0, _createClass3.default)(ShowController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getConf(this.$stateParams.id);
	    }
	  }, {
	    key: 'getConf',
	    value: function getConf(id) {
	      var _this = this;
	
	      this.$http.get('/api/deviceconfigs/' + id).then(function (response) {
	        _this.conf = response.data;
	      });
	    }
	  }]);
	  return ShowController;
	}();
	
	exports.default = ShowController;

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _add = __webpack_require__(551);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('onyxReadingRoomApp.deviceconfigs.add', []).controller('DeviceConfigsAddController', _add2.default).name;

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddController = function () {
	
	  /*@ngInject*/
	  AddController.$inject = ['$http', '$state'];
	  function AddController($http, $state) {
	    (0, _classCallCheck3.default)(this, AddController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.newConf = {};
	  }
	
	  (0, _createClass3.default)(AddController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: 'add',
	    value: function add() {
	      var _this = this;
	
	      this.$http.post('api/deviceconfigs', this.newConf).then(function (response) {
	        _this.$state.go('deviceconfigs');
	      });
	    }
	  }]);
	  return AddController;
	}();
	
	exports.default = AddController;

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _edit = __webpack_require__(553);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('onyxReadingRoomApp.deviceconfigs.edit', []).controller('DeviceConfigsEditController', _edit2.default).name;

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddConfController = function () {
	
	  /*@ngInject*/
	  AddConfController.$inject = ['$http', '$state', '$stateParams', '$scope', 'toaster'];
	  function AddConfController($http, $state, $stateParams, $scope, toaster) {
	    (0, _classCallCheck3.default)(this, AddConfController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$scope = $scope;
	    this.toaster = toaster;
	  }
	
	  (0, _createClass3.default)(AddConfController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getConf(this.$stateParams.id);
	    }
	  }, {
	    key: 'getConf',
	    value: function getConf(id) {
	      var _this = this;
	
	      this.$http.get('/api/deviceconfigs/' + id).then(function (response) {
	        _this.conf = response.data;
	      });
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this2 = this;
	
	      this.$http.put('api/deviceconfigs/' + this.$stateParams.id, this.conf).then(function (response) {
	        _this2.$state.go('deviceconfigs.show', {
	          id: _this2.$stateParams.id
	        });
	      });
	    }
	  }]);
	  return AddConfController;
	}();
	
	exports.default = AddConfController;

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(86);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _tags = __webpack_require__(555);
	
	var _tags2 = _interopRequireDefault(_tags);
	
	var _list = __webpack_require__(559);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _edit = __webpack_require__(561);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.tags', [_angularUiRouter2.default, _list2.default, _edit2.default]).config(_tags2.default).run(['$rootScope', function ($rootScope) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
	    if (next.name === 'logout' && current && current.name && !current.authenticate) {
	      next.referrer = current.name;
	    }
	  });
	}]).name;

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $urlRouterProvider.when("/tags", "/tags/list");
	
	  $stateProvider.state('tags', {
	    url: '/tags',
	    template: __webpack_require__(556),
	    authenticate: true
	  }).state('tags.list', {
	    url: '/list',
	    template: __webpack_require__(557),
	    controller: 'TagsListController',
	    controllerAs: 'tagsListCtrl'
	  }).state('tags.edit', {
	    url: '/edit/:id',
	    template: __webpack_require__(558),
	    controller: 'TagsEditController',
	    controllerAs: 'tagsEditCtrl'
	  });
	}];

/***/ }),
/* 556 */
380,
/* 557 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"page-header\">\n    <form class=\"form-inline pull-right\">\n      <p class=\"input-group\">\n        <input type=\"text\" class=\"form-control\" placeholder=\"\" ng-model=\"tagsListCtrl.name\">\n        <span class=\"input-group-btn\">\n          <button type=\"submit\" class=\"btn btn-success\" ng-click=\"tagsListCtrl.addTag()\">添加</button>\n        </span>\n      </p>\n    </form>\n    <h3>标签</h3>\n  </div>\n  <div class=\"\">\n    <table class=\"table table-striped\">\n      <thead>\n        <tr>\n          <th width=\"100\"></th>\n          <th>名称</th>\n          <th class=\"ctrl-th\"></th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"c in tagsListCtrl.tags\">\n          <td>{{$index + 1}}</td>\n          <td>{{c.name}}</td>\n          <td class=\"ctrl-td\">\n            <button ui-sref=\"tags.edit({id: c._id})\" class=\"btn btn-xs btn-success\">编辑</button>\n            <button ng-click=\"tagsListCtrl.delete(c._id)\" class=\"btn btn-xs btn-danger\">删除</button>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 558 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"page-header\">\n    <h1>编辑</h1>\n  </div>\n  <div>\n    <form>\n      <div class=\"form-group\">\n        <label for=\"name\">名称\n          <span class=\"text-danger\">(必需)</span>\n        </label>\n        <input type=\"name\" class=\"form-control\" ng-model=\"tagsEditCtrl.tag.name\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"model\">多语言(zh_CN:中文)</label><button class=\"btn btn-success btn-sm lang-add\" ng-click=\"tagsEditCtrl.addLang()\">添加</button>\n        <div ng-repeat=\"lang in tagsEditCtrl.langs\" class=\"row lang-input\">\n          <div class=\"col-md-6\">\n            <input type=\"model\" class=\"form-control\" ng-model=\"lang[0]\">\n          </div>\n          <div class=\"col-md-6\">\n            <input type=\"model\" class=\"form-control\" ng-model=\"lang[1]\">\n          </div>\n        </div>\n      </div>\n\n      <button type=\"submit\" class=\"btn btn-success\" ng-click=\"tagsEditCtrl.save()\">保存</button>\n      <button type=\"button\" class=\"btn btn-default\" ui-sref=\"^\">返回</button>\n    </form>\n  </div>\n</div>"

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _list = __webpack_require__(560);
	
	var _list2 = _interopRequireDefault(_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.tags.list', []).controller('TagsListController', _list2.default).name;

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListController = function () {
	
	  /*@ngInject*/
	  ListController.$inject = ['$http', '$state', '$stateParams'];
	  function ListController($http, $state, $stateParams) {
	    (0, _classCallCheck3.default)(this, ListController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	  }
	
	  (0, _createClass3.default)(ListController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getTags();
	    }
	  }, {
	    key: 'getTags',
	    value: function getTags() {
	      var _this = this;
	
	      var params = {};
	      this.$http.get('/api/tags', { params: params }).then(function (response) {
	        _this.tags = response.data;
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(id) {
	      var _this2 = this;
	
	      if (confirm("确定？")) {
	        this.$http.delete('/api/tags/' + id).then(function (response) {
	          _this2.getTags();
	        });
	      }
	    }
	  }, {
	    key: 'addTag',
	    value: function addTag() {
	      var _this3 = this;
	
	      if (!this.name.trim()) {
	        alert("名称不能为空");
	      }
	      var data = {
	        name: this.name
	      };
	      this.$http.post('/api/tags', data).then(function (res) {
	        _this3.getTags();
	      });
	    }
	  }]);
	  return ListController;
	}();
	
	exports.default = ListController;

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(78);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _edit = __webpack_require__(562);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('updateServerApp.tags.edit', []).controller('TagsEditController', _edit2.default).name;

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _entries = __webpack_require__(393);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _classCallCheck2 = __webpack_require__(120);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(129);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditController = function () {
	
	  /*@ngInject*/
	  EditController.$inject = ['$http', '$state', '$stateParams'];
	  function EditController($http, $state, $stateParams) {
	    (0, _classCallCheck3.default)(this, EditController);
	
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.langs = [];
	  }
	
	  (0, _createClass3.default)(EditController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getTag();
	    }
	  }, {
	    key: 'getTag',
	    value: function getTag() {
	      var _this = this;
	
	      this.$http.get('/api/tags/' + this.$stateParams.id).then(function (res) {
	        _this.tag = res.data;
	        if (_this.tag.langs) {
	          _this.langs = (0, _entries2.default)(_this.tag.langs);
	        }
	      });
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this2 = this;
	
	      this.langs.forEach(function (lang) {
	        if (!_this2.tag.langs) {
	          _this2.tag.langs = {};
	        }
	        _this2.tag.langs[lang[0]] = lang[1];
	      });
	
	      this.$http.put('/api/tags/' + this.tag._id, this.tag).then(function (res) {
	        _this2.$state.go('tags');
	      });
	    }
	  }, {
	    key: 'addLang',
	    value: function addLang() {
	      this.langs.push(new Array(2));
	    }
	  }]);
	  return EditController;
	}();
	
	exports.default = EditController;

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(564);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(96)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./app.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./app.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(95)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * Bootstrap v3.3.7 (http://getbootstrap.com)\n * Copyright 2011-2016 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n *//*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{font-size:2em;margin:.67em 0}mark{background:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{box-sizing:content-box;height:0}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{color:inherit;font:inherit;margin:0}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}input{line-height:normal}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-appearance:textfield;box-sizing:content-box}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}textarea{overflow:auto}optgroup{font-weight:700}table{border-collapse:collapse;border-spacing:0}td,th{padding:0}/*! Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css */@media print{*,:after,:before{background:transparent!important;color:#000!important;box-shadow:none!important;text-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}abbr[title]:after{content:\" (\" attr(title) \")\"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}.navbar{display:none}.btn>.caret,.dropup>.btn>.caret{border-top-color:#000!important}.label{border:1px solid #000}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #ddd!important}}@font-face{font-family:Glyphicons Halflings;src:url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.eot\");src:url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.eot?#iefix\") format(\"embedded-opentype\"),url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.woff2\") format(\"woff2\"),url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.woff\") format(\"woff\"),url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.ttf\") format(\"truetype\"),url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.svg#glyphicons_halflingsregular\") format(\"svg\")}.glyphicon{position:relative;top:1px;display:inline-block;font-family:Glyphicons Halflings;font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.glyphicon-asterisk:before{content:\"*\"}.glyphicon-plus:before{content:\"+\"}.glyphicon-eur:before,.glyphicon-euro:before{content:\"\\20AC\"}.glyphicon-minus:before{content:\"\\2212\"}.glyphicon-cloud:before{content:\"\\2601\"}.glyphicon-envelope:before{content:\"\\2709\"}.glyphicon-pencil:before{content:\"\\270F\"}.glyphicon-glass:before{content:\"\\E001\"}.glyphicon-music:before{content:\"\\E002\"}.glyphicon-search:before{content:\"\\E003\"}.glyphicon-heart:before{content:\"\\E005\"}.glyphicon-star:before{content:\"\\E006\"}.glyphicon-star-empty:before{content:\"\\E007\"}.glyphicon-user:before{content:\"\\E008\"}.glyphicon-film:before{content:\"\\E009\"}.glyphicon-th-large:before{content:\"\\E010\"}.glyphicon-th:before{content:\"\\E011\"}.glyphicon-th-list:before{content:\"\\E012\"}.glyphicon-ok:before{content:\"\\E013\"}.glyphicon-remove:before{content:\"\\E014\"}.glyphicon-zoom-in:before{content:\"\\E015\"}.glyphicon-zoom-out:before{content:\"\\E016\"}.glyphicon-off:before{content:\"\\E017\"}.glyphicon-signal:before{content:\"\\E018\"}.glyphicon-cog:before{content:\"\\E019\"}.glyphicon-trash:before{content:\"\\E020\"}.glyphicon-home:before{content:\"\\E021\"}.glyphicon-file:before{content:\"\\E022\"}.glyphicon-time:before{content:\"\\E023\"}.glyphicon-road:before{content:\"\\E024\"}.glyphicon-download-alt:before{content:\"\\E025\"}.glyphicon-download:before{content:\"\\E026\"}.glyphicon-upload:before{content:\"\\E027\"}.glyphicon-inbox:before{content:\"\\E028\"}.glyphicon-play-circle:before{content:\"\\E029\"}.glyphicon-repeat:before{content:\"\\E030\"}.glyphicon-refresh:before{content:\"\\E031\"}.glyphicon-list-alt:before{content:\"\\E032\"}.glyphicon-lock:before{content:\"\\E033\"}.glyphicon-flag:before{content:\"\\E034\"}.glyphicon-headphones:before{content:\"\\E035\"}.glyphicon-volume-off:before{content:\"\\E036\"}.glyphicon-volume-down:before{content:\"\\E037\"}.glyphicon-volume-up:before{content:\"\\E038\"}.glyphicon-qrcode:before{content:\"\\E039\"}.glyphicon-barcode:before{content:\"\\E040\"}.glyphicon-tag:before{content:\"\\E041\"}.glyphicon-tags:before{content:\"\\E042\"}.glyphicon-book:before{content:\"\\E043\"}.glyphicon-bookmark:before{content:\"\\E044\"}.glyphicon-print:before{content:\"\\E045\"}.glyphicon-camera:before{content:\"\\E046\"}.glyphicon-font:before{content:\"\\E047\"}.glyphicon-bold:before{content:\"\\E048\"}.glyphicon-italic:before{content:\"\\E049\"}.glyphicon-text-height:before{content:\"\\E050\"}.glyphicon-text-width:before{content:\"\\E051\"}.glyphicon-align-left:before{content:\"\\E052\"}.glyphicon-align-center:before{content:\"\\E053\"}.glyphicon-align-right:before{content:\"\\E054\"}.glyphicon-align-justify:before{content:\"\\E055\"}.glyphicon-list:before{content:\"\\E056\"}.glyphicon-indent-left:before{content:\"\\E057\"}.glyphicon-indent-right:before{content:\"\\E058\"}.glyphicon-facetime-video:before{content:\"\\E059\"}.glyphicon-picture:before{content:\"\\E060\"}.glyphicon-map-marker:before{content:\"\\E062\"}.glyphicon-adjust:before{content:\"\\E063\"}.glyphicon-tint:before{content:\"\\E064\"}.glyphicon-edit:before{content:\"\\E065\"}.glyphicon-share:before{content:\"\\E066\"}.glyphicon-check:before{content:\"\\E067\"}.glyphicon-move:before{content:\"\\E068\"}.glyphicon-step-backward:before{content:\"\\E069\"}.glyphicon-fast-backward:before{content:\"\\E070\"}.glyphicon-backward:before{content:\"\\E071\"}.glyphicon-play:before{content:\"\\E072\"}.glyphicon-pause:before{content:\"\\E073\"}.glyphicon-stop:before{content:\"\\E074\"}.glyphicon-forward:before{content:\"\\E075\"}.glyphicon-fast-forward:before{content:\"\\E076\"}.glyphicon-step-forward:before{content:\"\\E077\"}.glyphicon-eject:before{content:\"\\E078\"}.glyphicon-chevron-left:before{content:\"\\E079\"}.glyphicon-chevron-right:before{content:\"\\E080\"}.glyphicon-plus-sign:before{content:\"\\E081\"}.glyphicon-minus-sign:before{content:\"\\E082\"}.glyphicon-remove-sign:before{content:\"\\E083\"}.glyphicon-ok-sign:before{content:\"\\E084\"}.glyphicon-question-sign:before{content:\"\\E085\"}.glyphicon-info-sign:before{content:\"\\E086\"}.glyphicon-screenshot:before{content:\"\\E087\"}.glyphicon-remove-circle:before{content:\"\\E088\"}.glyphicon-ok-circle:before{content:\"\\E089\"}.glyphicon-ban-circle:before{content:\"\\E090\"}.glyphicon-arrow-left:before{content:\"\\E091\"}.glyphicon-arrow-right:before{content:\"\\E092\"}.glyphicon-arrow-up:before{content:\"\\E093\"}.glyphicon-arrow-down:before{content:\"\\E094\"}.glyphicon-share-alt:before{content:\"\\E095\"}.glyphicon-resize-full:before{content:\"\\E096\"}.glyphicon-resize-small:before{content:\"\\E097\"}.glyphicon-exclamation-sign:before{content:\"\\E101\"}.glyphicon-gift:before{content:\"\\E102\"}.glyphicon-leaf:before{content:\"\\E103\"}.glyphicon-fire:before{content:\"\\E104\"}.glyphicon-eye-open:before{content:\"\\E105\"}.glyphicon-eye-close:before{content:\"\\E106\"}.glyphicon-warning-sign:before{content:\"\\E107\"}.glyphicon-plane:before{content:\"\\E108\"}.glyphicon-calendar:before{content:\"\\E109\"}.glyphicon-random:before{content:\"\\E110\"}.glyphicon-comment:before{content:\"\\E111\"}.glyphicon-magnet:before{content:\"\\E112\"}.glyphicon-chevron-up:before{content:\"\\E113\"}.glyphicon-chevron-down:before{content:\"\\E114\"}.glyphicon-retweet:before{content:\"\\E115\"}.glyphicon-shopping-cart:before{content:\"\\E116\"}.glyphicon-folder-close:before{content:\"\\E117\"}.glyphicon-folder-open:before{content:\"\\E118\"}.glyphicon-resize-vertical:before{content:\"\\E119\"}.glyphicon-resize-horizontal:before{content:\"\\E120\"}.glyphicon-hdd:before{content:\"\\E121\"}.glyphicon-bullhorn:before{content:\"\\E122\"}.glyphicon-bell:before{content:\"\\E123\"}.glyphicon-certificate:before{content:\"\\E124\"}.glyphicon-thumbs-up:before{content:\"\\E125\"}.glyphicon-thumbs-down:before{content:\"\\E126\"}.glyphicon-hand-right:before{content:\"\\E127\"}.glyphicon-hand-left:before{content:\"\\E128\"}.glyphicon-hand-up:before{content:\"\\E129\"}.glyphicon-hand-down:before{content:\"\\E130\"}.glyphicon-circle-arrow-right:before{content:\"\\E131\"}.glyphicon-circle-arrow-left:before{content:\"\\E132\"}.glyphicon-circle-arrow-up:before{content:\"\\E133\"}.glyphicon-circle-arrow-down:before{content:\"\\E134\"}.glyphicon-globe:before{content:\"\\E135\"}.glyphicon-wrench:before{content:\"\\E136\"}.glyphicon-tasks:before{content:\"\\E137\"}.glyphicon-filter:before{content:\"\\E138\"}.glyphicon-briefcase:before{content:\"\\E139\"}.glyphicon-fullscreen:before{content:\"\\E140\"}.glyphicon-dashboard:before{content:\"\\E141\"}.glyphicon-paperclip:before{content:\"\\E142\"}.glyphicon-heart-empty:before{content:\"\\E143\"}.glyphicon-link:before{content:\"\\E144\"}.glyphicon-phone:before{content:\"\\E145\"}.glyphicon-pushpin:before{content:\"\\E146\"}.glyphicon-usd:before{content:\"\\E148\"}.glyphicon-gbp:before{content:\"\\E149\"}.glyphicon-sort:before{content:\"\\E150\"}.glyphicon-sort-by-alphabet:before{content:\"\\E151\"}.glyphicon-sort-by-alphabet-alt:before{content:\"\\E152\"}.glyphicon-sort-by-order:before{content:\"\\E153\"}.glyphicon-sort-by-order-alt:before{content:\"\\E154\"}.glyphicon-sort-by-attributes:before{content:\"\\E155\"}.glyphicon-sort-by-attributes-alt:before{content:\"\\E156\"}.glyphicon-unchecked:before{content:\"\\E157\"}.glyphicon-expand:before{content:\"\\E158\"}.glyphicon-collapse-down:before{content:\"\\E159\"}.glyphicon-collapse-up:before{content:\"\\E160\"}.glyphicon-log-in:before{content:\"\\E161\"}.glyphicon-flash:before{content:\"\\E162\"}.glyphicon-log-out:before{content:\"\\E163\"}.glyphicon-new-window:before{content:\"\\E164\"}.glyphicon-record:before{content:\"\\E165\"}.glyphicon-save:before{content:\"\\E166\"}.glyphicon-open:before{content:\"\\E167\"}.glyphicon-saved:before{content:\"\\E168\"}.glyphicon-import:before{content:\"\\E169\"}.glyphicon-export:before{content:\"\\E170\"}.glyphicon-send:before{content:\"\\E171\"}.glyphicon-floppy-disk:before{content:\"\\E172\"}.glyphicon-floppy-saved:before{content:\"\\E173\"}.glyphicon-floppy-remove:before{content:\"\\E174\"}.glyphicon-floppy-save:before{content:\"\\E175\"}.glyphicon-floppy-open:before{content:\"\\E176\"}.glyphicon-credit-card:before{content:\"\\E177\"}.glyphicon-transfer:before{content:\"\\E178\"}.glyphicon-cutlery:before{content:\"\\E179\"}.glyphicon-header:before{content:\"\\E180\"}.glyphicon-compressed:before{content:\"\\E181\"}.glyphicon-earphone:before{content:\"\\E182\"}.glyphicon-phone-alt:before{content:\"\\E183\"}.glyphicon-tower:before{content:\"\\E184\"}.glyphicon-stats:before{content:\"\\E185\"}.glyphicon-sd-video:before{content:\"\\E186\"}.glyphicon-hd-video:before{content:\"\\E187\"}.glyphicon-subtitles:before{content:\"\\E188\"}.glyphicon-sound-stereo:before{content:\"\\E189\"}.glyphicon-sound-dolby:before{content:\"\\E190\"}.glyphicon-sound-5-1:before{content:\"\\E191\"}.glyphicon-sound-6-1:before{content:\"\\E192\"}.glyphicon-sound-7-1:before{content:\"\\E193\"}.glyphicon-copyright-mark:before{content:\"\\E194\"}.glyphicon-registration-mark:before{content:\"\\E195\"}.glyphicon-cloud-download:before{content:\"\\E197\"}.glyphicon-cloud-upload:before{content:\"\\E198\"}.glyphicon-tree-conifer:before{content:\"\\E199\"}.glyphicon-tree-deciduous:before{content:\"\\E200\"}.glyphicon-cd:before{content:\"\\E201\"}.glyphicon-save-file:before{content:\"\\E202\"}.glyphicon-open-file:before{content:\"\\E203\"}.glyphicon-level-up:before{content:\"\\E204\"}.glyphicon-copy:before{content:\"\\E205\"}.glyphicon-paste:before{content:\"\\E206\"}.glyphicon-alert:before{content:\"\\E209\"}.glyphicon-equalizer:before{content:\"\\E210\"}.glyphicon-king:before{content:\"\\E211\"}.glyphicon-queen:before{content:\"\\E212\"}.glyphicon-pawn:before{content:\"\\E213\"}.glyphicon-bishop:before{content:\"\\E214\"}.glyphicon-knight:before{content:\"\\E215\"}.glyphicon-baby-formula:before{content:\"\\E216\"}.glyphicon-tent:before{content:\"\\26FA\"}.glyphicon-blackboard:before{content:\"\\E218\"}.glyphicon-bed:before{content:\"\\E219\"}.glyphicon-apple:before{content:\"\\F8FF\"}.glyphicon-erase:before{content:\"\\E221\"}.glyphicon-hourglass:before{content:\"\\231B\"}.glyphicon-lamp:before{content:\"\\E223\"}.glyphicon-duplicate:before{content:\"\\E224\"}.glyphicon-piggy-bank:before{content:\"\\E225\"}.glyphicon-scissors:before{content:\"\\E226\"}.glyphicon-bitcoin:before,.glyphicon-btc:before,.glyphicon-xbt:before{content:\"\\E227\"}.glyphicon-jpy:before,.glyphicon-yen:before{content:\"\\A5\"}.glyphicon-rub:before,.glyphicon-ruble:before{content:\"\\20BD\"}.glyphicon-scale:before{content:\"\\E230\"}.glyphicon-ice-lolly:before{content:\"\\E231\"}.glyphicon-ice-lolly-tasted:before{content:\"\\E232\"}.glyphicon-education:before{content:\"\\E233\"}.glyphicon-option-horizontal:before{content:\"\\E234\"}.glyphicon-option-vertical:before{content:\"\\E235\"}.glyphicon-menu-hamburger:before{content:\"\\E236\"}.glyphicon-modal-window:before{content:\"\\E237\"}.glyphicon-oil:before{content:\"\\E238\"}.glyphicon-grain:before{content:\"\\E239\"}.glyphicon-sunglasses:before{content:\"\\E240\"}.glyphicon-text-size:before{content:\"\\E241\"}.glyphicon-text-color:before{content:\"\\E242\"}.glyphicon-text-background:before{content:\"\\E243\"}.glyphicon-object-align-top:before{content:\"\\E244\"}.glyphicon-object-align-bottom:before{content:\"\\E245\"}.glyphicon-object-align-horizontal:before{content:\"\\E246\"}.glyphicon-object-align-left:before{content:\"\\E247\"}.glyphicon-object-align-vertical:before{content:\"\\E248\"}.glyphicon-object-align-right:before{content:\"\\E249\"}.glyphicon-triangle-right:before{content:\"\\E250\"}.glyphicon-triangle-left:before{content:\"\\E251\"}.glyphicon-triangle-bottom:before{content:\"\\E252\"}.glyphicon-triangle-top:before{content:\"\\E253\"}.glyphicon-console:before{content:\"\\E254\"}.glyphicon-superscript:before{content:\"\\E255\"}.glyphicon-subscript:before{content:\"\\E256\"}.glyphicon-menu-left:before{content:\"\\E257\"}.glyphicon-menu-right:before{content:\"\\E258\"}.glyphicon-menu-down:before{content:\"\\E259\"}.glyphicon-menu-up:before{content:\"\\E260\"}*,:after,:before{box-sizing:border-box}html{font-size:10px;-webkit-tap-highlight-color:transparent}body{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;line-height:1.428571429;color:#333;background-color:#fff}button,input,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}a{color:#337ab7;text-decoration:none}a:focus,a:hover{color:#23527c;text-decoration:underline}a:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}figure{margin:0}img{vertical-align:middle}.img-responsive{display:block;max-width:100%;height:auto}.img-rounded{border-radius:6px}.img-thumbnail{padding:4px;line-height:1.428571429;background-color:#fff;border:1px solid #ddd;border-radius:4px;transition:all .2s ease-in-out;display:inline-block;max-width:100%;height:auto}.img-circle{border-radius:50%}hr{margin-top:20px;margin-bottom:20px;border:0;border-top:1px solid #eee}[role=button]{cursor:pointer}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{font-family:inherit;font-weight:500;line-height:1.1;color:inherit}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-weight:400;line-height:1;color:#777}.h1,.h2,.h3,h1,h2,h3{margin-top:20px;margin-bottom:10px}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small{font-size:65%}.h4,.h5,.h6,h4,h5,h6{margin-top:10px;margin-bottom:10px}.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-size:75%}.h1,h1{font-size:36px}.h2,h2{font-size:30px}.h3,h3{font-size:24px}.h4,h4{font-size:18px}.h5,h5{font-size:14px}.h6,h6{font-size:12px}p{margin:0 0 10px}.lead{margin-bottom:20px;font-size:16px;font-weight:300;line-height:1.4}@media (min-width:768px){.lead{font-size:21px}}.small,small{font-size:85%}.mark,mark{background-color:#fcf8e3;padding:.2em}.text-left{text-align:left}.text-right{text-align:right}.text-center{text-align:center}.text-justify{text-align:justify}.text-nowrap{white-space:nowrap}.text-lowercase{text-transform:lowercase}.initialism,.text-uppercase{text-transform:uppercase}.text-capitalize{text-transform:capitalize}.text-muted{color:#777}.text-primary{color:#337ab7}a.text-primary:focus,a.text-primary:hover{color:#286090}.text-success{color:#3c763d}a.text-success:focus,a.text-success:hover{color:#2b542c}.text-info{color:#31708f}a.text-info:focus,a.text-info:hover{color:#245269}.text-warning{color:#8a6d3b}a.text-warning:focus,a.text-warning:hover{color:#66512c}.text-danger{color:#a94442}a.text-danger:focus,a.text-danger:hover{color:#843534}.bg-primary{color:#fff;background-color:#337ab7}a.bg-primary:focus,a.bg-primary:hover{background-color:#286090}.bg-success{background-color:#dff0d8}a.bg-success:focus,a.bg-success:hover{background-color:#c1e2b3}.bg-info{background-color:#d9edf7}a.bg-info:focus,a.bg-info:hover{background-color:#afd9ee}.bg-warning{background-color:#fcf8e3}a.bg-warning:focus,a.bg-warning:hover{background-color:#f7ecb5}.bg-danger{background-color:#f2dede}a.bg-danger:focus,a.bg-danger:hover{background-color:#e4b9b9}.page-header{padding-bottom:9px;margin:40px 0 20px;border-bottom:1px solid #eee}ol,ul{margin-top:0;margin-bottom:10px}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}.list-inline,.list-unstyled{padding-left:0;list-style:none}.list-inline{margin-left:-5px}.list-inline>li{display:inline-block;padding-left:5px;padding-right:5px}dl{margin-top:0;margin-bottom:20px}dd,dt{line-height:1.428571429}dt{font-weight:700}dd{margin-left:0}.dl-horizontal dd:after,.dl-horizontal dd:before{content:\" \";display:table}.dl-horizontal dd:after{clear:both}@media (min-width:768px){.dl-horizontal dt{float:left;width:160px;clear:left;text-align:right;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.dl-horizontal dd{margin-left:180px}}abbr[data-original-title],abbr[title]{cursor:help;border-bottom:1px dotted #777}.initialism{font-size:90%}blockquote{padding:10px 20px;margin:0 0 20px;font-size:17.5px;border-left:5px solid #eee}blockquote ol:last-child,blockquote p:last-child,blockquote ul:last-child{margin-bottom:0}blockquote .small,blockquote footer,blockquote small{display:block;font-size:80%;line-height:1.428571429;color:#777}blockquote .small:before,blockquote footer:before,blockquote small:before{content:\"\\2014   \\A0\"}.blockquote-reverse,blockquote.pull-right{padding-right:15px;padding-left:0;border-right:5px solid #eee;border-left:0;text-align:right}.blockquote-reverse .small:before,.blockquote-reverse footer:before,.blockquote-reverse small:before,blockquote.pull-right .small:before,blockquote.pull-right footer:before,blockquote.pull-right small:before{content:\"\"}.blockquote-reverse .small:after,.blockquote-reverse footer:after,.blockquote-reverse small:after,blockquote.pull-right .small:after,blockquote.pull-right footer:after,blockquote.pull-right small:after{content:\"\\A0   \\2014\"}address{margin-bottom:20px;font-style:normal;line-height:1.428571429}code,kbd,pre,samp{font-family:Menlo,Monaco,Consolas,Courier New,monospace}code{color:#c7254e;background-color:#f9f2f4;border-radius:4px}code,kbd{padding:2px 4px;font-size:90%}kbd{color:#fff;background-color:#333;border-radius:3px;box-shadow:inset 0 -1px 0 rgba(0,0,0,.25)}kbd kbd{padding:0;font-size:100%;font-weight:700;box-shadow:none}pre{display:block;padding:9.5px;margin:0 0 10px;font-size:13px;line-height:1.428571429;word-break:break-all;word-wrap:break-word;color:#333;background-color:#f5f5f5;border:1px solid #ccc;border-radius:4px}pre code{padding:0;font-size:inherit;color:inherit;white-space:pre-wrap;background-color:transparent;border-radius:0}.pre-scrollable{max-height:340px;overflow-y:scroll}.container{margin-right:auto;margin-left:auto;padding-left:15px;padding-right:15px}.container:after,.container:before{content:\" \";display:table}.container:after{clear:both}@media (min-width:768px){.container{width:750px}}@media (min-width:992px){.container{width:970px}}@media (min-width:1200px){.container{width:1170px}}.container-fluid{margin-right:auto;margin-left:auto;padding-left:15px;padding-right:15px}.container-fluid:after,.container-fluid:before{content:\" \";display:table}.container-fluid:after{clear:both}.row{margin-left:-15px;margin-right:-15px}.row:after,.row:before{content:\" \";display:table}.row:after{clear:both}.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{position:relative;min-height:1px;padding-left:15px;padding-right:15px}.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{float:left}.col-xs-1{width:8.3333333333%}.col-xs-2{width:16.6666666667%}.col-xs-3{width:25%}.col-xs-4{width:33.3333333333%}.col-xs-5{width:41.6666666667%}.col-xs-6{width:50%}.col-xs-7{width:58.3333333333%}.col-xs-8{width:66.6666666667%}.col-xs-9{width:75%}.col-xs-10{width:83.3333333333%}.col-xs-11{width:91.6666666667%}.col-xs-12{width:100%}.col-xs-pull-0{right:auto}.col-xs-pull-1{right:8.3333333333%}.col-xs-pull-2{right:16.6666666667%}.col-xs-pull-3{right:25%}.col-xs-pull-4{right:33.3333333333%}.col-xs-pull-5{right:41.6666666667%}.col-xs-pull-6{right:50%}.col-xs-pull-7{right:58.3333333333%}.col-xs-pull-8{right:66.6666666667%}.col-xs-pull-9{right:75%}.col-xs-pull-10{right:83.3333333333%}.col-xs-pull-11{right:91.6666666667%}.col-xs-pull-12{right:100%}.col-xs-push-0{left:auto}.col-xs-push-1{left:8.3333333333%}.col-xs-push-2{left:16.6666666667%}.col-xs-push-3{left:25%}.col-xs-push-4{left:33.3333333333%}.col-xs-push-5{left:41.6666666667%}.col-xs-push-6{left:50%}.col-xs-push-7{left:58.3333333333%}.col-xs-push-8{left:66.6666666667%}.col-xs-push-9{left:75%}.col-xs-push-10{left:83.3333333333%}.col-xs-push-11{left:91.6666666667%}.col-xs-push-12{left:100%}.col-xs-offset-0{margin-left:0}.col-xs-offset-1{margin-left:8.3333333333%}.col-xs-offset-2{margin-left:16.6666666667%}.col-xs-offset-3{margin-left:25%}.col-xs-offset-4{margin-left:33.3333333333%}.col-xs-offset-5{margin-left:41.6666666667%}.col-xs-offset-6{margin-left:50%}.col-xs-offset-7{margin-left:58.3333333333%}.col-xs-offset-8{margin-left:66.6666666667%}.col-xs-offset-9{margin-left:75%}.col-xs-offset-10{margin-left:83.3333333333%}.col-xs-offset-11{margin-left:91.6666666667%}.col-xs-offset-12{margin-left:100%}@media (min-width:768px){.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12{float:left}.col-sm-1{width:8.3333333333%}.col-sm-2{width:16.6666666667%}.col-sm-3{width:25%}.col-sm-4{width:33.3333333333%}.col-sm-5{width:41.6666666667%}.col-sm-6{width:50%}.col-sm-7{width:58.3333333333%}.col-sm-8{width:66.6666666667%}.col-sm-9{width:75%}.col-sm-10{width:83.3333333333%}.col-sm-11{width:91.6666666667%}.col-sm-12{width:100%}.col-sm-pull-0{right:auto}.col-sm-pull-1{right:8.3333333333%}.col-sm-pull-2{right:16.6666666667%}.col-sm-pull-3{right:25%}.col-sm-pull-4{right:33.3333333333%}.col-sm-pull-5{right:41.6666666667%}.col-sm-pull-6{right:50%}.col-sm-pull-7{right:58.3333333333%}.col-sm-pull-8{right:66.6666666667%}.col-sm-pull-9{right:75%}.col-sm-pull-10{right:83.3333333333%}.col-sm-pull-11{right:91.6666666667%}.col-sm-pull-12{right:100%}.col-sm-push-0{left:auto}.col-sm-push-1{left:8.3333333333%}.col-sm-push-2{left:16.6666666667%}.col-sm-push-3{left:25%}.col-sm-push-4{left:33.3333333333%}.col-sm-push-5{left:41.6666666667%}.col-sm-push-6{left:50%}.col-sm-push-7{left:58.3333333333%}.col-sm-push-8{left:66.6666666667%}.col-sm-push-9{left:75%}.col-sm-push-10{left:83.3333333333%}.col-sm-push-11{left:91.6666666667%}.col-sm-push-12{left:100%}.col-sm-offset-0{margin-left:0}.col-sm-offset-1{margin-left:8.3333333333%}.col-sm-offset-2{margin-left:16.6666666667%}.col-sm-offset-3{margin-left:25%}.col-sm-offset-4{margin-left:33.3333333333%}.col-sm-offset-5{margin-left:41.6666666667%}.col-sm-offset-6{margin-left:50%}.col-sm-offset-7{margin-left:58.3333333333%}.col-sm-offset-8{margin-left:66.6666666667%}.col-sm-offset-9{margin-left:75%}.col-sm-offset-10{margin-left:83.3333333333%}.col-sm-offset-11{margin-left:91.6666666667%}.col-sm-offset-12{margin-left:100%}}@media (min-width:992px){.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12{float:left}.col-md-1{width:8.3333333333%}.col-md-2{width:16.6666666667%}.col-md-3{width:25%}.col-md-4{width:33.3333333333%}.col-md-5{width:41.6666666667%}.col-md-6{width:50%}.col-md-7{width:58.3333333333%}.col-md-8{width:66.6666666667%}.col-md-9{width:75%}.col-md-10{width:83.3333333333%}.col-md-11{width:91.6666666667%}.col-md-12{width:100%}.col-md-pull-0{right:auto}.col-md-pull-1{right:8.3333333333%}.col-md-pull-2{right:16.6666666667%}.col-md-pull-3{right:25%}.col-md-pull-4{right:33.3333333333%}.col-md-pull-5{right:41.6666666667%}.col-md-pull-6{right:50%}.col-md-pull-7{right:58.3333333333%}.col-md-pull-8{right:66.6666666667%}.col-md-pull-9{right:75%}.col-md-pull-10{right:83.3333333333%}.col-md-pull-11{right:91.6666666667%}.col-md-pull-12{right:100%}.col-md-push-0{left:auto}.col-md-push-1{left:8.3333333333%}.col-md-push-2{left:16.6666666667%}.col-md-push-3{left:25%}.col-md-push-4{left:33.3333333333%}.col-md-push-5{left:41.6666666667%}.col-md-push-6{left:50%}.col-md-push-7{left:58.3333333333%}.col-md-push-8{left:66.6666666667%}.col-md-push-9{left:75%}.col-md-push-10{left:83.3333333333%}.col-md-push-11{left:91.6666666667%}.col-md-push-12{left:100%}.col-md-offset-0{margin-left:0}.col-md-offset-1{margin-left:8.3333333333%}.col-md-offset-2{margin-left:16.6666666667%}.col-md-offset-3{margin-left:25%}.col-md-offset-4{margin-left:33.3333333333%}.col-md-offset-5{margin-left:41.6666666667%}.col-md-offset-6{margin-left:50%}.col-md-offset-7{margin-left:58.3333333333%}.col-md-offset-8{margin-left:66.6666666667%}.col-md-offset-9{margin-left:75%}.col-md-offset-10{margin-left:83.3333333333%}.col-md-offset-11{margin-left:91.6666666667%}.col-md-offset-12{margin-left:100%}}@media (min-width:1200px){.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12{float:left}.col-lg-1{width:8.3333333333%}.col-lg-2{width:16.6666666667%}.col-lg-3{width:25%}.col-lg-4{width:33.3333333333%}.col-lg-5{width:41.6666666667%}.col-lg-6{width:50%}.col-lg-7{width:58.3333333333%}.col-lg-8{width:66.6666666667%}.col-lg-9{width:75%}.col-lg-10{width:83.3333333333%}.col-lg-11{width:91.6666666667%}.col-lg-12{width:100%}.col-lg-pull-0{right:auto}.col-lg-pull-1{right:8.3333333333%}.col-lg-pull-2{right:16.6666666667%}.col-lg-pull-3{right:25%}.col-lg-pull-4{right:33.3333333333%}.col-lg-pull-5{right:41.6666666667%}.col-lg-pull-6{right:50%}.col-lg-pull-7{right:58.3333333333%}.col-lg-pull-8{right:66.6666666667%}.col-lg-pull-9{right:75%}.col-lg-pull-10{right:83.3333333333%}.col-lg-pull-11{right:91.6666666667%}.col-lg-pull-12{right:100%}.col-lg-push-0{left:auto}.col-lg-push-1{left:8.3333333333%}.col-lg-push-2{left:16.6666666667%}.col-lg-push-3{left:25%}.col-lg-push-4{left:33.3333333333%}.col-lg-push-5{left:41.6666666667%}.col-lg-push-6{left:50%}.col-lg-push-7{left:58.3333333333%}.col-lg-push-8{left:66.6666666667%}.col-lg-push-9{left:75%}.col-lg-push-10{left:83.3333333333%}.col-lg-push-11{left:91.6666666667%}.col-lg-push-12{left:100%}.col-lg-offset-0{margin-left:0}.col-lg-offset-1{margin-left:8.3333333333%}.col-lg-offset-2{margin-left:16.6666666667%}.col-lg-offset-3{margin-left:25%}.col-lg-offset-4{margin-left:33.3333333333%}.col-lg-offset-5{margin-left:41.6666666667%}.col-lg-offset-6{margin-left:50%}.col-lg-offset-7{margin-left:58.3333333333%}.col-lg-offset-8{margin-left:66.6666666667%}.col-lg-offset-9{margin-left:75%}.col-lg-offset-10{margin-left:83.3333333333%}.col-lg-offset-11{margin-left:91.6666666667%}.col-lg-offset-12{margin-left:100%}}table{background-color:transparent}caption{padding-top:8px;padding-bottom:8px;color:#777}caption,th{text-align:left}.table{width:100%;max-width:100%;margin-bottom:20px}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:8px;line-height:1.428571429;vertical-align:top;border-top:1px solid #ddd}.table>thead>tr>th{vertical-align:bottom;border-bottom:2px solid #ddd}.table>caption+thead>tr:first-child>td,.table>caption+thead>tr:first-child>th,.table>colgroup+thead>tr:first-child>td,.table>colgroup+thead>tr:first-child>th,.table>thead:first-child>tr:first-child>td,.table>thead:first-child>tr:first-child>th{border-top:0}.table>tbody+tbody{border-top:2px solid #ddd}.table .table{background-color:#fff}.table-condensed>tbody>tr>td,.table-condensed>tbody>tr>th,.table-condensed>tfoot>tr>td,.table-condensed>tfoot>tr>th,.table-condensed>thead>tr>td,.table-condensed>thead>tr>th{padding:5px}.table-bordered,.table-bordered>tbody>tr>td,.table-bordered>tbody>tr>th,.table-bordered>tfoot>tr>td,.table-bordered>tfoot>tr>th,.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border:1px solid #ddd}.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border-bottom-width:2px}.table-striped>tbody>tr:nth-of-type(odd){background-color:#f9f9f9}.table-hover>tbody>tr:hover{background-color:#f5f5f5}table col[class*=col-]{position:static;float:none;display:table-column}table td[class*=col-],table th[class*=col-]{position:static;float:none;display:table-cell}.table>tbody>tr.active>td,.table>tbody>tr.active>th,.table>tbody>tr>td.active,.table>tbody>tr>th.active,.table>tfoot>tr.active>td,.table>tfoot>tr.active>th,.table>tfoot>tr>td.active,.table>tfoot>tr>th.active,.table>thead>tr.active>td,.table>thead>tr.active>th,.table>thead>tr>td.active,.table>thead>tr>th.active{background-color:#f5f5f5}.table-hover>tbody>tr.active:hover>td,.table-hover>tbody>tr.active:hover>th,.table-hover>tbody>tr:hover>.active,.table-hover>tbody>tr>td.active:hover,.table-hover>tbody>tr>th.active:hover{background-color:#e8e8e8}.table>tbody>tr.success>td,.table>tbody>tr.success>th,.table>tbody>tr>td.success,.table>tbody>tr>th.success,.table>tfoot>tr.success>td,.table>tfoot>tr.success>th,.table>tfoot>tr>td.success,.table>tfoot>tr>th.success,.table>thead>tr.success>td,.table>thead>tr.success>th,.table>thead>tr>td.success,.table>thead>tr>th.success{background-color:#dff0d8}.table-hover>tbody>tr.success:hover>td,.table-hover>tbody>tr.success:hover>th,.table-hover>tbody>tr:hover>.success,.table-hover>tbody>tr>td.success:hover,.table-hover>tbody>tr>th.success:hover{background-color:#d0e9c6}.table>tbody>tr.info>td,.table>tbody>tr.info>th,.table>tbody>tr>td.info,.table>tbody>tr>th.info,.table>tfoot>tr.info>td,.table>tfoot>tr.info>th,.table>tfoot>tr>td.info,.table>tfoot>tr>th.info,.table>thead>tr.info>td,.table>thead>tr.info>th,.table>thead>tr>td.info,.table>thead>tr>th.info{background-color:#d9edf7}.table-hover>tbody>tr.info:hover>td,.table-hover>tbody>tr.info:hover>th,.table-hover>tbody>tr:hover>.info,.table-hover>tbody>tr>td.info:hover,.table-hover>tbody>tr>th.info:hover{background-color:#c4e3f3}.table>tbody>tr.warning>td,.table>tbody>tr.warning>th,.table>tbody>tr>td.warning,.table>tbody>tr>th.warning,.table>tfoot>tr.warning>td,.table>tfoot>tr.warning>th,.table>tfoot>tr>td.warning,.table>tfoot>tr>th.warning,.table>thead>tr.warning>td,.table>thead>tr.warning>th,.table>thead>tr>td.warning,.table>thead>tr>th.warning{background-color:#fcf8e3}.table-hover>tbody>tr.warning:hover>td,.table-hover>tbody>tr.warning:hover>th,.table-hover>tbody>tr:hover>.warning,.table-hover>tbody>tr>td.warning:hover,.table-hover>tbody>tr>th.warning:hover{background-color:#faf2cc}.table>tbody>tr.danger>td,.table>tbody>tr.danger>th,.table>tbody>tr>td.danger,.table>tbody>tr>th.danger,.table>tfoot>tr.danger>td,.table>tfoot>tr.danger>th,.table>tfoot>tr>td.danger,.table>tfoot>tr>th.danger,.table>thead>tr.danger>td,.table>thead>tr.danger>th,.table>thead>tr>td.danger,.table>thead>tr>th.danger{background-color:#f2dede}.table-hover>tbody>tr.danger:hover>td,.table-hover>tbody>tr.danger:hover>th,.table-hover>tbody>tr:hover>.danger,.table-hover>tbody>tr>td.danger:hover,.table-hover>tbody>tr>th.danger:hover{background-color:#ebcccc}.table-responsive{overflow-x:auto;min-height:.01%}@media screen and (max-width:767px){.table-responsive{width:100%;margin-bottom:15px;overflow-y:hidden;-ms-overflow-style:-ms-autohiding-scrollbar;border:1px solid #ddd}.table-responsive>.table{margin-bottom:0}.table-responsive>.table>tbody>tr>td,.table-responsive>.table>tbody>tr>th,.table-responsive>.table>tfoot>tr>td,.table-responsive>.table>tfoot>tr>th,.table-responsive>.table>thead>tr>td,.table-responsive>.table>thead>tr>th{white-space:nowrap}.table-responsive>.table-bordered{border:0}.table-responsive>.table-bordered>tbody>tr>td:first-child,.table-responsive>.table-bordered>tbody>tr>th:first-child,.table-responsive>.table-bordered>tfoot>tr>td:first-child,.table-responsive>.table-bordered>tfoot>tr>th:first-child,.table-responsive>.table-bordered>thead>tr>td:first-child,.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.table-responsive>.table-bordered>tbody>tr>td:last-child,.table-responsive>.table-bordered>tbody>tr>th:last-child,.table-responsive>.table-bordered>tfoot>tr>td:last-child,.table-responsive>.table-bordered>tfoot>tr>th:last-child,.table-responsive>.table-bordered>thead>tr>td:last-child,.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.table-responsive>.table-bordered>tbody>tr:last-child>td,.table-responsive>.table-bordered>tbody>tr:last-child>th,.table-responsive>.table-bordered>tfoot>tr:last-child>td,.table-responsive>.table-bordered>tfoot>tr:last-child>th{border-bottom:0}}fieldset{margin:0;min-width:0}fieldset,legend{padding:0;border:0}legend{display:block;width:100%;margin-bottom:20px;font-size:21px;line-height:inherit;color:#333;border-bottom:1px solid #e5e5e5}label{display:inline-block;max-width:100%;margin-bottom:5px;font-weight:700}input[type=search]{box-sizing:border-box}input[type=checkbox],input[type=radio]{margin:4px 0 0;margin-top:1px\\9;line-height:normal}input[type=file]{display:block}input[type=range]{display:block;width:100%}select[multiple],select[size]{height:auto}input[type=checkbox]:focus,input[type=file]:focus,input[type=radio]:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}output{padding-top:7px}.form-control,output{display:block;font-size:14px;line-height:1.428571429;color:#555}.form-control{width:100%;height:34px;padding:6px 12px;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.075);transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}.form-control:focus{border-color:#66afe9;outline:0;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.form-control::-moz-placeholder{color:#999;opacity:1}.form-control:-ms-input-placeholder{color:#999}.form-control::-webkit-input-placeholder{color:#999}.form-control::-ms-expand{border:0;background-color:transparent}.form-control[disabled],.form-control[readonly],fieldset[disabled] .form-control{background-color:#eee;opacity:1}.form-control[disabled],fieldset[disabled] .form-control{cursor:not-allowed}textarea.form-control{height:auto}input[type=search]{-webkit-appearance:none}@media screen and (-webkit-min-device-pixel-ratio:0){input[type=date].form-control,input[type=datetime-local].form-control,input[type=month].form-control,input[type=time].form-control{line-height:34px}.input-group-sm>.input-group-btn>input[type=date].btn,.input-group-sm>.input-group-btn>input[type=datetime-local].btn,.input-group-sm>.input-group-btn>input[type=month].btn,.input-group-sm>.input-group-btn>input[type=time].btn,.input-group-sm>input[type=date].form-control,.input-group-sm>input[type=date].input-group-addon,.input-group-sm>input[type=datetime-local].form-control,.input-group-sm>input[type=datetime-local].input-group-addon,.input-group-sm>input[type=month].form-control,.input-group-sm>input[type=month].input-group-addon,.input-group-sm>input[type=time].form-control,.input-group-sm>input[type=time].input-group-addon,.input-group-sm input[type=date],.input-group-sm input[type=datetime-local],.input-group-sm input[type=month],.input-group-sm input[type=time],input[type=date].input-sm,input[type=datetime-local].input-sm,input[type=month].input-sm,input[type=time].input-sm{line-height:30px}.input-group-lg>.input-group-btn>input[type=date].btn,.input-group-lg>.input-group-btn>input[type=datetime-local].btn,.input-group-lg>.input-group-btn>input[type=month].btn,.input-group-lg>.input-group-btn>input[type=time].btn,.input-group-lg>input[type=date].form-control,.input-group-lg>input[type=date].input-group-addon,.input-group-lg>input[type=datetime-local].form-control,.input-group-lg>input[type=datetime-local].input-group-addon,.input-group-lg>input[type=month].form-control,.input-group-lg>input[type=month].input-group-addon,.input-group-lg>input[type=time].form-control,.input-group-lg>input[type=time].input-group-addon,.input-group-lg input[type=date],.input-group-lg input[type=datetime-local],.input-group-lg input[type=month],.input-group-lg input[type=time],input[type=date].input-lg,input[type=datetime-local].input-lg,input[type=month].input-lg,input[type=time].input-lg{line-height:46px}}.form-group{margin-bottom:15px}.checkbox,.radio{position:relative;display:block;margin-top:10px;margin-bottom:10px}.checkbox label,.radio label{min-height:20px;padding-left:20px;margin-bottom:0;font-weight:400;cursor:pointer}.checkbox-inline input[type=checkbox],.checkbox input[type=checkbox],.radio-inline input[type=radio],.radio input[type=radio]{position:absolute;margin-left:-20px;margin-top:4px\\9}.checkbox+.checkbox,.radio+.radio{margin-top:-5px}.checkbox-inline,.radio-inline{position:relative;display:inline-block;padding-left:20px;margin-bottom:0;vertical-align:middle;font-weight:400;cursor:pointer}.checkbox-inline+.checkbox-inline,.radio-inline+.radio-inline{margin-top:0;margin-left:10px}.checkbox-inline.disabled,.checkbox.disabled label,.radio-inline.disabled,.radio.disabled label,fieldset[disabled] .checkbox-inline,fieldset[disabled] .checkbox label,fieldset[disabled] .radio-inline,fieldset[disabled] .radio label,fieldset[disabled] input[type=checkbox],fieldset[disabled] input[type=radio],input[type=checkbox].disabled,input[type=checkbox][disabled],input[type=radio].disabled,input[type=radio][disabled]{cursor:not-allowed}.form-control-static{padding-top:7px;padding-bottom:7px;margin-bottom:0;min-height:34px}.form-control-static.input-lg,.form-control-static.input-sm,.input-group-lg>.form-control-static.form-control,.input-group-lg>.form-control-static.input-group-addon,.input-group-lg>.input-group-btn>.form-control-static.btn,.input-group-sm>.form-control-static.form-control,.input-group-sm>.form-control-static.input-group-addon,.input-group-sm>.input-group-btn>.form-control-static.btn{padding-left:0;padding-right:0}.input-group-sm>.form-control,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.btn,.input-sm{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.input-group-sm>.input-group-btn>select.btn,.input-group-sm>select.form-control,.input-group-sm>select.input-group-addon,select.input-sm{height:30px;line-height:30px}.input-group-sm>.input-group-btn>select[multiple].btn,.input-group-sm>.input-group-btn>textarea.btn,.input-group-sm>select[multiple].form-control,.input-group-sm>select[multiple].input-group-addon,.input-group-sm>textarea.form-control,.input-group-sm>textarea.input-group-addon,select[multiple].input-sm,textarea.input-sm{height:auto}.form-group-sm .form-control{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.form-group-sm select.form-control{height:30px;line-height:30px}.form-group-sm select[multiple].form-control,.form-group-sm textarea.form-control{height:auto}.form-group-sm .form-control-static{height:30px;min-height:32px;padding:6px 10px;font-size:12px;line-height:1.5}.input-group-lg>.form-control,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.btn,.input-lg{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.input-group-lg>.input-group-btn>select.btn,.input-group-lg>select.form-control,.input-group-lg>select.input-group-addon,select.input-lg{height:46px;line-height:46px}.input-group-lg>.input-group-btn>select[multiple].btn,.input-group-lg>.input-group-btn>textarea.btn,.input-group-lg>select[multiple].form-control,.input-group-lg>select[multiple].input-group-addon,.input-group-lg>textarea.form-control,.input-group-lg>textarea.input-group-addon,select[multiple].input-lg,textarea.input-lg{height:auto}.form-group-lg .form-control{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.form-group-lg select.form-control{height:46px;line-height:46px}.form-group-lg select[multiple].form-control,.form-group-lg textarea.form-control{height:auto}.form-group-lg .form-control-static{height:46px;min-height:38px;padding:11px 16px;font-size:18px;line-height:1.3333333}.has-feedback{position:relative}.has-feedback .form-control{padding-right:42.5px}.form-control-feedback{position:absolute;top:0;right:0;z-index:2;display:block;width:34px;height:34px;line-height:34px;text-align:center;pointer-events:none}.form-group-lg .form-control+.form-control-feedback,.input-group-lg+.form-control-feedback,.input-group-lg>.form-control+.form-control-feedback,.input-group-lg>.input-group-addon+.form-control-feedback,.input-group-lg>.input-group-btn>.btn+.form-control-feedback,.input-lg+.form-control-feedback{width:46px;height:46px;line-height:46px}.form-group-sm .form-control+.form-control-feedback,.input-group-sm+.form-control-feedback,.input-group-sm>.form-control+.form-control-feedback,.input-group-sm>.input-group-addon+.form-control-feedback,.input-group-sm>.input-group-btn>.btn+.form-control-feedback,.input-sm+.form-control-feedback{width:30px;height:30px;line-height:30px}.has-success .checkbox,.has-success .checkbox-inline,.has-success.checkbox-inline label,.has-success.checkbox label,.has-success .control-label,.has-success .help-block,.has-success .radio,.has-success .radio-inline,.has-success.radio-inline label,.has-success.radio label{color:#3c763d}.has-success .form-control{border-color:#3c763d;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-success .form-control:focus{border-color:#2b542c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168}.has-success .input-group-addon{color:#3c763d;border-color:#3c763d;background-color:#dff0d8}.has-success .form-control-feedback{color:#3c763d}.has-warning .checkbox,.has-warning .checkbox-inline,.has-warning.checkbox-inline label,.has-warning.checkbox label,.has-warning .control-label,.has-warning .help-block,.has-warning .radio,.has-warning .radio-inline,.has-warning.radio-inline label,.has-warning.radio label{color:#8a6d3b}.has-warning .form-control{border-color:#8a6d3b;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-warning .form-control:focus{border-color:#66512c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b}.has-warning .input-group-addon{color:#8a6d3b;border-color:#8a6d3b;background-color:#fcf8e3}.has-warning .form-control-feedback{color:#8a6d3b}.has-error .checkbox,.has-error .checkbox-inline,.has-error.checkbox-inline label,.has-error.checkbox label,.has-error .control-label,.has-error .help-block,.has-error .radio,.has-error .radio-inline,.has-error.radio-inline label,.has-error.radio label{color:#a94442}.has-error .form-control{border-color:#a94442;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-error .form-control:focus{border-color:#843534;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483}.has-error .input-group-addon{color:#a94442;border-color:#a94442;background-color:#f2dede}.has-error .form-control-feedback{color:#a94442}.has-feedback label~.form-control-feedback{top:25px}.has-feedback label.sr-only~.form-control-feedback{top:0}.help-block{display:block;margin-top:5px;margin-bottom:10px;color:#737373}@media (min-width:768px){.form-inline .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-static{display:inline-block}.form-inline .input-group{display:inline-table;vertical-align:middle}.form-inline .input-group .form-control,.form-inline .input-group .input-group-addon,.form-inline .input-group .input-group-btn{width:auto}.form-inline .input-group>.form-control{width:100%}.form-inline .control-label{margin-bottom:0;vertical-align:middle}.form-inline .checkbox,.form-inline .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.form-inline .checkbox label,.form-inline .radio label{padding-left:0}.form-inline .checkbox input[type=checkbox],.form-inline .radio input[type=radio]{position:relative;margin-left:0}.form-inline .has-feedback .form-control-feedback{top:0}}.form-horizontal .checkbox,.form-horizontal .checkbox-inline,.form-horizontal .radio,.form-horizontal .radio-inline{margin-top:0;margin-bottom:0;padding-top:7px}.form-horizontal .checkbox,.form-horizontal .radio{min-height:27px}.form-horizontal .form-group{margin-left:-15px;margin-right:-15px}.form-horizontal .form-group:after,.form-horizontal .form-group:before{content:\" \";display:table}.form-horizontal .form-group:after{clear:both}@media (min-width:768px){.form-horizontal .control-label{text-align:right;margin-bottom:0;padding-top:7px}}.form-horizontal .has-feedback .form-control-feedback{right:15px}@media (min-width:768px){.form-horizontal .form-group-lg .control-label{padding-top:11px;font-size:18px}}@media (min-width:768px){.form-horizontal .form-group-sm .control-label{padding-top:6px;font-size:12px}}.btn{display:inline-block;margin-bottom:0;font-weight:400;text-align:center;vertical-align:middle;touch-action:manipulation;cursor:pointer;background-image:none;border:1px solid transparent;white-space:nowrap;padding:6px 12px;font-size:14px;line-height:1.428571429;border-radius:4px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.btn.active.focus,.btn.active:focus,.btn.focus,.btn:active.focus,.btn:active:focus,.btn:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}.btn.focus,.btn:focus,.btn:hover{color:#333;text-decoration:none}.btn.active,.btn:active{outline:0;background-image:none;box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn.disabled,.btn[disabled],fieldset[disabled] .btn{cursor:not-allowed;opacity:.65;filter:alpha(opacity=65);box-shadow:none}a.btn.disabled,fieldset[disabled] a.btn{pointer-events:none}.btn-default{color:#333;background-color:#fff;border-color:#ccc}.btn-default.focus,.btn-default:focus{color:#333;background-color:#e6e6e6;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.btn-default:hover,.open>.btn-default.dropdown-toggle{color:#333;background-color:#e6e6e6;border-color:#adadad}.btn-default.active.focus,.btn-default.active:focus,.btn-default.active:hover,.btn-default:active.focus,.btn-default:active:focus,.btn-default:active:hover,.open>.btn-default.dropdown-toggle.focus,.open>.btn-default.dropdown-toggle:focus,.open>.btn-default.dropdown-toggle:hover{color:#333;background-color:#d4d4d4;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.open>.btn-default.dropdown-toggle{background-image:none}.btn-default.disabled.focus,.btn-default.disabled:focus,.btn-default.disabled:hover,.btn-default[disabled].focus,.btn-default[disabled]:focus,.btn-default[disabled]:hover,fieldset[disabled] .btn-default.focus,fieldset[disabled] .btn-default:focus,fieldset[disabled] .btn-default:hover{background-color:#fff;border-color:#ccc}.btn-default .badge{color:#fff;background-color:#333}.btn-primary{color:#fff;background-color:#337ab7;border-color:#2e6da4}.btn-primary.focus,.btn-primary:focus{color:#fff;background-color:#286090;border-color:#122b40}.btn-primary.active,.btn-primary:active,.btn-primary:hover,.open>.btn-primary.dropdown-toggle{color:#fff;background-color:#286090;border-color:#204d74}.btn-primary.active.focus,.btn-primary.active:focus,.btn-primary.active:hover,.btn-primary:active.focus,.btn-primary:active:focus,.btn-primary:active:hover,.open>.btn-primary.dropdown-toggle.focus,.open>.btn-primary.dropdown-toggle:focus,.open>.btn-primary.dropdown-toggle:hover{color:#fff;background-color:#204d74;border-color:#122b40}.btn-primary.active,.btn-primary:active,.open>.btn-primary.dropdown-toggle{background-image:none}.btn-primary.disabled.focus,.btn-primary.disabled:focus,.btn-primary.disabled:hover,.btn-primary[disabled].focus,.btn-primary[disabled]:focus,.btn-primary[disabled]:hover,fieldset[disabled] .btn-primary.focus,fieldset[disabled] .btn-primary:focus,fieldset[disabled] .btn-primary:hover{background-color:#337ab7;border-color:#2e6da4}.btn-primary .badge{color:#337ab7;background-color:#fff}.btn-success{color:#fff;background-color:#5cb85c;border-color:#4cae4c}.btn-success.focus,.btn-success:focus{color:#fff;background-color:#449d44;border-color:#255625}.btn-success.active,.btn-success:active,.btn-success:hover,.open>.btn-success.dropdown-toggle{color:#fff;background-color:#449d44;border-color:#398439}.btn-success.active.focus,.btn-success.active:focus,.btn-success.active:hover,.btn-success:active.focus,.btn-success:active:focus,.btn-success:active:hover,.open>.btn-success.dropdown-toggle.focus,.open>.btn-success.dropdown-toggle:focus,.open>.btn-success.dropdown-toggle:hover{color:#fff;background-color:#398439;border-color:#255625}.btn-success.active,.btn-success:active,.open>.btn-success.dropdown-toggle{background-image:none}.btn-success.disabled.focus,.btn-success.disabled:focus,.btn-success.disabled:hover,.btn-success[disabled].focus,.btn-success[disabled]:focus,.btn-success[disabled]:hover,fieldset[disabled] .btn-success.focus,fieldset[disabled] .btn-success:focus,fieldset[disabled] .btn-success:hover{background-color:#5cb85c;border-color:#4cae4c}.btn-success .badge{color:#5cb85c;background-color:#fff}.btn-info{color:#fff;background-color:#5bc0de;border-color:#46b8da}.btn-info.focus,.btn-info:focus{color:#fff;background-color:#31b0d5;border-color:#1b6d85}.btn-info.active,.btn-info:active,.btn-info:hover,.open>.btn-info.dropdown-toggle{color:#fff;background-color:#31b0d5;border-color:#269abc}.btn-info.active.focus,.btn-info.active:focus,.btn-info.active:hover,.btn-info:active.focus,.btn-info:active:focus,.btn-info:active:hover,.open>.btn-info.dropdown-toggle.focus,.open>.btn-info.dropdown-toggle:focus,.open>.btn-info.dropdown-toggle:hover{color:#fff;background-color:#269abc;border-color:#1b6d85}.btn-info.active,.btn-info:active,.open>.btn-info.dropdown-toggle{background-image:none}.btn-info.disabled.focus,.btn-info.disabled:focus,.btn-info.disabled:hover,.btn-info[disabled].focus,.btn-info[disabled]:focus,.btn-info[disabled]:hover,fieldset[disabled] .btn-info.focus,fieldset[disabled] .btn-info:focus,fieldset[disabled] .btn-info:hover{background-color:#5bc0de;border-color:#46b8da}.btn-info .badge{color:#5bc0de;background-color:#fff}.btn-warning{color:#fff;background-color:#f0ad4e;border-color:#eea236}.btn-warning.focus,.btn-warning:focus{color:#fff;background-color:#ec971f;border-color:#985f0d}.btn-warning.active,.btn-warning:active,.btn-warning:hover,.open>.btn-warning.dropdown-toggle{color:#fff;background-color:#ec971f;border-color:#d58512}.btn-warning.active.focus,.btn-warning.active:focus,.btn-warning.active:hover,.btn-warning:active.focus,.btn-warning:active:focus,.btn-warning:active:hover,.open>.btn-warning.dropdown-toggle.focus,.open>.btn-warning.dropdown-toggle:focus,.open>.btn-warning.dropdown-toggle:hover{color:#fff;background-color:#d58512;border-color:#985f0d}.btn-warning.active,.btn-warning:active,.open>.btn-warning.dropdown-toggle{background-image:none}.btn-warning.disabled.focus,.btn-warning.disabled:focus,.btn-warning.disabled:hover,.btn-warning[disabled].focus,.btn-warning[disabled]:focus,.btn-warning[disabled]:hover,fieldset[disabled] .btn-warning.focus,fieldset[disabled] .btn-warning:focus,fieldset[disabled] .btn-warning:hover{background-color:#f0ad4e;border-color:#eea236}.btn-warning .badge{color:#f0ad4e;background-color:#fff}.btn-danger{color:#fff;background-color:#d9534f;border-color:#d43f3a}.btn-danger.focus,.btn-danger:focus{color:#fff;background-color:#c9302c;border-color:#761c19}.btn-danger.active,.btn-danger:active,.btn-danger:hover,.open>.btn-danger.dropdown-toggle{color:#fff;background-color:#c9302c;border-color:#ac2925}.btn-danger.active.focus,.btn-danger.active:focus,.btn-danger.active:hover,.btn-danger:active.focus,.btn-danger:active:focus,.btn-danger:active:hover,.open>.btn-danger.dropdown-toggle.focus,.open>.btn-danger.dropdown-toggle:focus,.open>.btn-danger.dropdown-toggle:hover{color:#fff;background-color:#ac2925;border-color:#761c19}.btn-danger.active,.btn-danger:active,.open>.btn-danger.dropdown-toggle{background-image:none}.btn-danger.disabled.focus,.btn-danger.disabled:focus,.btn-danger.disabled:hover,.btn-danger[disabled].focus,.btn-danger[disabled]:focus,.btn-danger[disabled]:hover,fieldset[disabled] .btn-danger.focus,fieldset[disabled] .btn-danger:focus,fieldset[disabled] .btn-danger:hover{background-color:#d9534f;border-color:#d43f3a}.btn-danger .badge{color:#d9534f;background-color:#fff}.btn-link{color:#337ab7;font-weight:400;border-radius:0}.btn-link,.btn-link.active,.btn-link:active,.btn-link[disabled],fieldset[disabled] .btn-link{background-color:transparent;box-shadow:none}.btn-link,.btn-link:active,.btn-link:focus,.btn-link:hover{border-color:transparent}.btn-link:focus,.btn-link:hover{color:#23527c;text-decoration:underline;background-color:transparent}.btn-link[disabled]:focus,.btn-link[disabled]:hover,fieldset[disabled] .btn-link:focus,fieldset[disabled] .btn-link:hover{color:#777;text-decoration:none}.btn-group-lg>.btn,.btn-lg{padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.btn-group-sm>.btn,.btn-sm{padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.btn-group-xs>.btn,.btn-xs{padding:1px 5px;font-size:12px;line-height:1.5;border-radius:3px}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:5px}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}.fade{opacity:0;transition:opacity .15s linear}.fade.in{opacity:1}.collapse{display:none}.collapse.in{display:block}tr.collapse.in{display:table-row}tbody.collapse.in{display:table-row-group}.collapsing{position:relative;height:0;overflow:hidden;transition-property:height,visibility;transition-duration:.35s;transition-timing-function:ease}.caret{display:inline-block;width:0;height:0;margin-left:2px;vertical-align:middle;border-top:4px dashed;border-top:4px solid\\9;border-right:4px solid transparent;border-left:4px solid transparent}.dropdown,.dropup{position:relative}.dropdown-toggle:focus{outline:0}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:160px;padding:5px 0;margin:2px 0 0;list-style:none;font-size:14px;text-align:left;background-color:#fff;border:1px solid #ccc;border:1px solid rgba(0,0,0,.15);border-radius:4px;box-shadow:0 6px 12px rgba(0,0,0,.175);background-clip:padding-box}.dropdown-menu.pull-right{right:0;left:auto}.dropdown-menu .divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.dropdown-menu>li>a{display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.428571429;color:#333;white-space:nowrap}.dropdown-menu>li>a:focus,.dropdown-menu>li>a:hover{text-decoration:none;color:#262626;background-color:#f5f5f5}.dropdown-menu>.active>a,.dropdown-menu>.active>a:focus,.dropdown-menu>.active>a:hover{color:#fff;text-decoration:none;outline:0;background-color:#337ab7}.dropdown-menu>.disabled>a,.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{color:#777}.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{text-decoration:none;background-color:transparent;background-image:none;filter:progid:DXImageTransform.Microsoft.gradient(enabled = false);cursor:not-allowed}.open>.dropdown-menu{display:block}.open>a{outline:0}.dropdown-menu-right{left:auto;right:0}.dropdown-menu-left{left:0;right:auto}.dropdown-header{display:block;padding:3px 20px;font-size:12px;line-height:1.428571429;color:#777;white-space:nowrap}.dropdown-backdrop{position:fixed;left:0;right:0;bottom:0;top:0;z-index:990}.pull-right>.dropdown-menu{right:0;left:auto}.dropup .caret,.navbar-fixed-bottom .dropdown .caret{border-top:0;border-bottom:4px dashed;border-bottom:4px solid\\9;content:\"\"}.dropup .dropdown-menu,.navbar-fixed-bottom .dropdown .dropdown-menu{top:auto;bottom:100%;margin-bottom:2px}@media (min-width:768px){.navbar-right .dropdown-menu{right:0;left:auto}.navbar-right .dropdown-menu-left{left:0;right:auto}}.btn-group,.btn-group-vertical{position:relative;display:inline-block;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;float:left}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:hover,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus,.btn-group>.btn:hover{z-index:2}.btn-group .btn+.btn,.btn-group .btn+.btn-group,.btn-group .btn-group+.btn,.btn-group .btn-group+.btn-group{margin-left:-1px}.btn-toolbar{margin-left:-5px}.btn-toolbar:after,.btn-toolbar:before{content:\" \";display:table}.btn-toolbar:after{clear:both}.btn-toolbar .btn,.btn-toolbar .btn-group,.btn-toolbar .input-group{float:left}.btn-toolbar>.btn,.btn-toolbar>.btn-group,.btn-toolbar>.input-group{margin-left:5px}.btn-group>.btn:not(:first-child):not(:last-child):not(.dropdown-toggle){border-radius:0}.btn-group>.btn:first-child{margin-left:0}.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle){border-bottom-right-radius:0;border-top-right-radius:0}.btn-group>.btn:last-child:not(:first-child),.btn-group>.dropdown-toggle:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0}.btn-group>.btn-group{float:left}.btn-group>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-top-right-radius:0}.btn-group>.btn-group:last-child:not(:first-child)>.btn:first-child{border-bottom-left-radius:0;border-top-left-radius:0}.btn-group .dropdown-toggle:active,.btn-group.open .dropdown-toggle{outline:0}.btn-group>.btn+.dropdown-toggle{padding-left:8px;padding-right:8px}.btn-group-lg.btn-group>.btn+.dropdown-toggle,.btn-group>.btn-lg+.dropdown-toggle{padding-left:12px;padding-right:12px}.btn-group.open .dropdown-toggle{box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn-group.open .dropdown-toggle.btn-link{box-shadow:none}.btn .caret{margin-left:0}.btn-group-lg>.btn .caret,.btn-lg .caret{border-width:5px 5px 0;border-bottom-width:0}.dropup .btn-group-lg>.btn .caret,.dropup .btn-lg .caret{border-width:0 5px 5px}.btn-group-vertical>.btn,.btn-group-vertical>.btn-group,.btn-group-vertical>.btn-group>.btn{display:block;float:none;width:100%;max-width:100%}.btn-group-vertical>.btn-group:after,.btn-group-vertical>.btn-group:before{content:\" \";display:table}.btn-group-vertical>.btn-group:after{clear:both}.btn-group-vertical>.btn-group>.btn{float:none}.btn-group-vertical>.btn+.btn,.btn-group-vertical>.btn+.btn-group,.btn-group-vertical>.btn-group+.btn,.btn-group-vertical>.btn-group+.btn-group{margin-top:-1px;margin-left:0}.btn-group-vertical>.btn:not(:first-child):not(:last-child){border-radius:0}.btn-group-vertical>.btn:first-child:not(:last-child){border-top-right-radius:4px;border-top-left-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn:last-child:not(:first-child){border-top-right-radius:0;border-top-left-radius:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}.btn-group-vertical>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group-vertical>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group-vertical>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-right-radius:0;border-top-left-radius:0}.btn-group-justified{display:table;width:100%;table-layout:fixed;border-collapse:separate}.btn-group-justified>.btn,.btn-group-justified>.btn-group{float:none;display:table-cell;width:1%}.btn-group-justified>.btn-group .btn{width:100%}.btn-group-justified>.btn-group .dropdown-menu{left:auto}[data-toggle=buttons]>.btn-group>.btn input[type=checkbox],[data-toggle=buttons]>.btn-group>.btn input[type=radio],[data-toggle=buttons]>.btn input[type=checkbox],[data-toggle=buttons]>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;display:table;border-collapse:separate}.input-group[class*=col-]{float:none;padding-left:0;padding-right:0}.input-group .form-control{position:relative;z-index:2;float:left;width:100%;margin-bottom:0}.input-group .form-control:focus{z-index:3}.input-group-addon,.input-group-btn,.input-group .form-control{display:table-cell}.input-group-addon:not(:first-child):not(:last-child),.input-group-btn:not(:first-child):not(:last-child),.input-group .form-control:not(:first-child):not(:last-child){border-radius:0}.input-group-addon,.input-group-btn{width:1%;white-space:nowrap;vertical-align:middle}.input-group-addon{padding:6px 12px;font-size:14px;font-weight:400;line-height:1;color:#555;text-align:center;background-color:#eee;border:1px solid #ccc;border-radius:4px}.input-group-addon.input-sm,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.input-group-addon.btn{padding:5px 10px;font-size:12px;border-radius:3px}.input-group-addon.input-lg,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.input-group-addon.btn{padding:10px 16px;font-size:18px;border-radius:6px}.input-group-addon input[type=checkbox],.input-group-addon input[type=radio]{margin-top:0}.input-group-addon:first-child,.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group>.btn,.input-group-btn:first-child>.dropdown-toggle,.input-group-btn:last-child>.btn-group:not(:last-child)>.btn,.input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group .form-control:first-child{border-bottom-right-radius:0;border-top-right-radius:0}.input-group-addon:first-child{border-right:0}.input-group-addon:last-child,.input-group-btn:first-child>.btn-group:not(:first-child)>.btn,.input-group-btn:first-child>.btn:not(:first-child),.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group>.btn,.input-group-btn:last-child>.dropdown-toggle,.input-group .form-control:last-child{border-bottom-left-radius:0;border-top-left-radius:0}.input-group-addon:last-child{border-left:0}.input-group-btn{font-size:0;white-space:nowrap}.input-group-btn,.input-group-btn>.btn{position:relative}.input-group-btn>.btn+.btn{margin-left:-1px}.input-group-btn>.btn:active,.input-group-btn>.btn:focus,.input-group-btn>.btn:hover{z-index:2}.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group{margin-right:-1px}.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group{z-index:2;margin-left:-1px}.nav{margin-bottom:0;padding-left:0;list-style:none}.nav:after,.nav:before{content:\" \";display:table}.nav:after{clear:both}.nav>li,.nav>li>a{position:relative;display:block}.nav>li>a{padding:10px 15px}.nav>li>a:focus,.nav>li>a:hover{text-decoration:none;background-color:#eee}.nav>li.disabled>a{color:#777}.nav>li.disabled>a:focus,.nav>li.disabled>a:hover{color:#777;text-decoration:none;background-color:transparent;cursor:not-allowed}.nav .open>a,.nav .open>a:focus,.nav .open>a:hover{background-color:#eee;border-color:#337ab7}.nav .nav-divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.nav>li>a>img{max-width:none}.nav-tabs{border-bottom:1px solid #ddd}.nav-tabs>li{float:left;margin-bottom:-1px}.nav-tabs>li>a{margin-right:2px;line-height:1.428571429;border:1px solid transparent;border-radius:4px 4px 0 0}.nav-tabs>li>a:hover{border-color:#eee #eee #ddd}.nav-tabs>li.active>a,.nav-tabs>li.active>a:focus,.nav-tabs>li.active>a:hover{color:#555;background-color:#fff;border:1px solid #ddd;border-bottom-color:transparent;cursor:default}.nav-pills>li{float:left}.nav-pills>li>a{border-radius:4px}.nav-pills>li+li{margin-left:2px}.nav-pills>li.active>a,.nav-pills>li.active>a:focus,.nav-pills>li.active>a:hover{color:#fff;background-color:#337ab7}.nav-stacked>li{float:none}.nav-stacked>li+li{margin-top:2px;margin-left:0}.nav-justified,.nav-tabs.nav-justified{width:100%}.nav-justified>li,.nav-tabs.nav-justified>li{float:none}.nav-justified>li>a,.nav-tabs.nav-justified>li>a{text-align:center;margin-bottom:5px}.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-justified>li,.nav-tabs.nav-justified>li{display:table-cell;width:1%}.nav-justified>li>a,.nav-tabs.nav-justified>li>a{margin-bottom:0}}.nav-tabs-justified,.nav-tabs.nav-justified{border-bottom:0}.nav-tabs-justified>li>a,.nav-tabs.nav-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover,.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs-justified>li>a,.nav-tabs.nav-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover,.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border-bottom-color:#fff}}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-right-radius:0;border-top-left-radius:0}.navbar{position:relative;min-height:50px;margin-bottom:20px;border:1px solid transparent}.navbar:after,.navbar:before{content:\" \";display:table}.navbar:after{clear:both}@media (min-width:768px){.navbar{border-radius:4px}}.navbar-header:after,.navbar-header:before{content:\" \";display:table}.navbar-header:after{clear:both}@media (min-width:768px){.navbar-header{float:left}}.navbar-collapse{overflow-x:visible;padding-right:15px;padding-left:15px;border-top:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1);-webkit-overflow-scrolling:touch}.navbar-collapse:after,.navbar-collapse:before{content:\" \";display:table}.navbar-collapse:after{clear:both}.navbar-collapse.in{overflow-y:auto}@media (min-width:768px){.navbar-collapse{width:auto;border-top:0;box-shadow:none}.navbar-collapse.collapse{display:block!important;height:auto!important;padding-bottom:0;overflow:visible!important}.navbar-collapse.in{overflow-y:visible}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse,.navbar-static-top .navbar-collapse{padding-left:0;padding-right:0}}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:340px}@media (max-device-width:480px) and (orientation:landscape){.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:200px}}.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:-15px;margin-left:-15px}@media (min-width:768px){.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:0;margin-left:0}}.navbar-static-top{z-index:1000;border-width:0 0 1px}@media (min-width:768px){.navbar-static-top{border-radius:0}}.navbar-fixed-bottom,.navbar-fixed-top{position:fixed;right:0;left:0;z-index:1030}@media (min-width:768px){.navbar-fixed-bottom,.navbar-fixed-top{border-radius:0}}.navbar-fixed-top{top:0;border-width:0 0 1px}.navbar-fixed-bottom{bottom:0;margin-bottom:0;border-width:1px 0 0}.navbar-brand{float:left;padding:15px;font-size:18px;line-height:20px;height:50px}.navbar-brand:focus,.navbar-brand:hover{text-decoration:none}.navbar-brand>img{display:block}@media (min-width:768px){.navbar>.container-fluid .navbar-brand,.navbar>.container .navbar-brand{margin-left:-15px}}.navbar-toggle{position:relative;float:right;margin-right:15px;padding:9px 10px;margin-top:8px;margin-bottom:8px;background-color:transparent;background-image:none;border:1px solid transparent;border-radius:4px}.navbar-toggle:focus{outline:0}.navbar-toggle .icon-bar{display:block;width:22px;height:2px;border-radius:1px}.navbar-toggle .icon-bar+.icon-bar{margin-top:4px}@media (min-width:768px){.navbar-toggle{display:none}}.navbar-nav{margin:7.5px -15px}.navbar-nav>li>a{padding-top:10px;padding-bottom:10px;line-height:20px}@media (max-width:767px){.navbar-nav .open .dropdown-menu{position:static;float:none;width:auto;margin-top:0;background-color:transparent;border:0;box-shadow:none}.navbar-nav .open .dropdown-menu .dropdown-header,.navbar-nav .open .dropdown-menu>li>a{padding:5px 15px 5px 25px}.navbar-nav .open .dropdown-menu>li>a{line-height:20px}.navbar-nav .open .dropdown-menu>li>a:focus,.navbar-nav .open .dropdown-menu>li>a:hover{background-image:none}}@media (min-width:768px){.navbar-nav{float:left;margin:0}.navbar-nav>li{float:left}.navbar-nav>li>a{padding-top:15px;padding-bottom:15px}}.navbar-form{margin:8px -15px;padding:10px 15px;border-top:1px solid transparent;border-bottom:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1),0 1px 0 hsla(0,0%,100%,.1)}@media (min-width:768px){.navbar-form .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.navbar-form .form-control{display:inline-block;width:auto;vertical-align:middle}.navbar-form .form-control-static{display:inline-block}.navbar-form .input-group{display:inline-table;vertical-align:middle}.navbar-form .input-group .form-control,.navbar-form .input-group .input-group-addon,.navbar-form .input-group .input-group-btn{width:auto}.navbar-form .input-group>.form-control{width:100%}.navbar-form .control-label{margin-bottom:0;vertical-align:middle}.navbar-form .checkbox,.navbar-form .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.navbar-form .checkbox label,.navbar-form .radio label{padding-left:0}.navbar-form .checkbox input[type=checkbox],.navbar-form .radio input[type=radio]{position:relative;margin-left:0}.navbar-form .has-feedback .form-control-feedback{top:0}}@media (max-width:767px){.navbar-form .form-group{margin-bottom:5px}.navbar-form .form-group:last-child{margin-bottom:0}}@media (min-width:768px){.navbar-form{width:auto;border:0;margin-left:0;margin-right:0;padding-top:0;padding-bottom:0;box-shadow:none}}.navbar-nav>li>.dropdown-menu{margin-top:0;border-top-right-radius:0;border-top-left-radius:0}.navbar-fixed-bottom .navbar-nav>li>.dropdown-menu{margin-bottom:0;border-top-right-radius:4px;border-top-left-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.navbar-btn{margin-top:8px;margin-bottom:8px}.btn-group-sm>.navbar-btn.btn,.navbar-btn.btn-sm{margin-top:10px;margin-bottom:10px}.btn-group-xs>.navbar-btn.btn,.navbar-btn.btn-xs{margin-top:14px;margin-bottom:14px}.navbar-text{margin-top:15px;margin-bottom:15px}@media (min-width:768px){.navbar-text{float:left;margin-left:15px;margin-right:15px}}@media (min-width:768px){.navbar-left{float:left!important}.navbar-right{float:right!important;margin-right:-15px}.navbar-right~.navbar-right{margin-right:0}}.navbar-default{background-color:#f8f8f8;border-color:#e7e7e7}.navbar-default .navbar-brand{color:#777}.navbar-default .navbar-brand:focus,.navbar-default .navbar-brand:hover{color:#5e5e5e;background-color:transparent}.navbar-default .navbar-nav>li>a,.navbar-default .navbar-text{color:#777}.navbar-default .navbar-nav>li>a:focus,.navbar-default .navbar-nav>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav>.active>a,.navbar-default .navbar-nav>.active>a:focus,.navbar-default .navbar-nav>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav>.disabled>a,.navbar-default .navbar-nav>.disabled>a:focus,.navbar-default .navbar-nav>.disabled>a:hover{color:#ccc;background-color:transparent}.navbar-default .navbar-toggle{border-color:#ddd}.navbar-default .navbar-toggle:focus,.navbar-default .navbar-toggle:hover{background-color:#ddd}.navbar-default .navbar-toggle .icon-bar{background-color:#888}.navbar-default .navbar-collapse,.navbar-default .navbar-form{border-color:#e7e7e7}.navbar-default .navbar-nav>.open>a,.navbar-default .navbar-nav>.open>a:focus,.navbar-default .navbar-nav>.open>a:hover{background-color:#e7e7e7;color:#555}@media (max-width:767px){.navbar-default .navbar-nav .open .dropdown-menu>li>a{color:#777}.navbar-default .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav .open .dropdown-menu>.active>a,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#ccc;background-color:transparent}}.navbar-default .navbar-link{color:#777}.navbar-default .navbar-link:hover{color:#333}.navbar-default .btn-link{color:#777}.navbar-default .btn-link:focus,.navbar-default .btn-link:hover{color:#333}.navbar-default .btn-link[disabled]:focus,.navbar-default .btn-link[disabled]:hover,fieldset[disabled] .navbar-default .btn-link:focus,fieldset[disabled] .navbar-default .btn-link:hover{color:#ccc}.navbar-inverse{background-color:#222;border-color:#090909}.navbar-inverse .navbar-brand{color:#9d9d9d}.navbar-inverse .navbar-brand:focus,.navbar-inverse .navbar-brand:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>li>a,.navbar-inverse .navbar-text{color:#9d9d9d}.navbar-inverse .navbar-nav>li>a:focus,.navbar-inverse .navbar-nav>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>.active>a,.navbar-inverse .navbar-nav>.active>a:focus,.navbar-inverse .navbar-nav>.active>a:hover{color:#fff;background-color:#090909}.navbar-inverse .navbar-nav>.disabled>a,.navbar-inverse .navbar-nav>.disabled>a:focus,.navbar-inverse .navbar-nav>.disabled>a:hover{color:#444;background-color:transparent}.navbar-inverse .navbar-toggle{border-color:#333}.navbar-inverse .navbar-toggle:focus,.navbar-inverse .navbar-toggle:hover{background-color:#333}.navbar-inverse .navbar-toggle .icon-bar{background-color:#fff}.navbar-inverse .navbar-collapse,.navbar-inverse .navbar-form{border-color:#101010}.navbar-inverse .navbar-nav>.open>a,.navbar-inverse .navbar-nav>.open>a:focus,.navbar-inverse .navbar-nav>.open>a:hover{background-color:#090909;color:#fff}@media (max-width:767px){.navbar-inverse .navbar-nav .open .dropdown-menu>.dropdown-header{border-color:#090909}.navbar-inverse .navbar-nav .open .dropdown-menu .divider{background-color:#090909}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a{color:#9d9d9d}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:hover{color:#fff;background-color:#090909}.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#444;background-color:transparent}}.navbar-inverse .navbar-link{color:#9d9d9d}.navbar-inverse .navbar-link:hover{color:#fff}.navbar-inverse .btn-link{color:#9d9d9d}.navbar-inverse .btn-link:focus,.navbar-inverse .btn-link:hover{color:#fff}.navbar-inverse .btn-link[disabled]:focus,.navbar-inverse .btn-link[disabled]:hover,fieldset[disabled] .navbar-inverse .btn-link:focus,fieldset[disabled] .navbar-inverse .btn-link:hover{color:#444}.breadcrumb{padding:8px 15px;margin-bottom:20px;list-style:none;background-color:#f5f5f5;border-radius:4px}.breadcrumb>li{display:inline-block}.breadcrumb>li+li:before{content:\"/\\A0\";padding:0 5px;color:#ccc}.breadcrumb>.active{color:#777}.pagination{display:inline-block;padding-left:0;margin:20px 0;border-radius:4px}.pagination>li{display:inline}.pagination>li>a,.pagination>li>span{position:relative;float:left;padding:6px 12px;line-height:1.428571429;text-decoration:none;color:#337ab7;background-color:#fff;border:1px solid #ddd;margin-left:-1px}.pagination>li:first-child>a,.pagination>li:first-child>span{margin-left:0;border-bottom-left-radius:4px;border-top-left-radius:4px}.pagination>li:last-child>a,.pagination>li:last-child>span{border-bottom-right-radius:4px;border-top-right-radius:4px}.pagination>li>a:focus,.pagination>li>a:hover,.pagination>li>span:focus,.pagination>li>span:hover{z-index:2;color:#23527c;background-color:#eee;border-color:#ddd}.pagination>.active>a,.pagination>.active>a:focus,.pagination>.active>a:hover,.pagination>.active>span,.pagination>.active>span:focus,.pagination>.active>span:hover{z-index:3;color:#fff;background-color:#337ab7;border-color:#337ab7;cursor:default}.pagination>.disabled>a,.pagination>.disabled>a:focus,.pagination>.disabled>a:hover,.pagination>.disabled>span,.pagination>.disabled>span:focus,.pagination>.disabled>span:hover{color:#777;background-color:#fff;border-color:#ddd;cursor:not-allowed}.pagination-lg>li>a,.pagination-lg>li>span{padding:10px 16px;font-size:18px;line-height:1.3333333}.pagination-lg>li:first-child>a,.pagination-lg>li:first-child>span{border-bottom-left-radius:6px;border-top-left-radius:6px}.pagination-lg>li:last-child>a,.pagination-lg>li:last-child>span{border-bottom-right-radius:6px;border-top-right-radius:6px}.pagination-sm>li>a,.pagination-sm>li>span{padding:5px 10px;font-size:12px;line-height:1.5}.pagination-sm>li:first-child>a,.pagination-sm>li:first-child>span{border-bottom-left-radius:3px;border-top-left-radius:3px}.pagination-sm>li:last-child>a,.pagination-sm>li:last-child>span{border-bottom-right-radius:3px;border-top-right-radius:3px}.pager{padding-left:0;margin:20px 0;list-style:none;text-align:center}.pager:after,.pager:before{content:\" \";display:table}.pager:after{clear:both}.pager li{display:inline}.pager li>a,.pager li>span{display:inline-block;padding:5px 14px;background-color:#fff;border:1px solid #ddd;border-radius:15px}.pager li>a:focus,.pager li>a:hover{text-decoration:none;background-color:#eee}.pager .next>a,.pager .next>span{float:right}.pager .previous>a,.pager .previous>span{float:left}.pager .disabled>a,.pager .disabled>a:focus,.pager .disabled>a:hover,.pager .disabled>span{color:#777;background-color:#fff;cursor:not-allowed}.label{display:inline;padding:.2em .6em .3em;font-size:75%;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25em}.label:empty{display:none}.btn .label{position:relative;top:-1px}a.label:focus,a.label:hover{color:#fff;text-decoration:none;cursor:pointer}.label-default{background-color:#777}.label-default[href]:focus,.label-default[href]:hover{background-color:#5e5e5e}.label-primary{background-color:#337ab7}.label-primary[href]:focus,.label-primary[href]:hover{background-color:#286090}.label-success{background-color:#5cb85c}.label-success[href]:focus,.label-success[href]:hover{background-color:#449d44}.label-info{background-color:#5bc0de}.label-info[href]:focus,.label-info[href]:hover{background-color:#31b0d5}.label-warning{background-color:#f0ad4e}.label-warning[href]:focus,.label-warning[href]:hover{background-color:#ec971f}.label-danger{background-color:#d9534f}.label-danger[href]:focus,.label-danger[href]:hover{background-color:#c9302c}.badge{display:inline-block;min-width:10px;padding:3px 7px;font-size:12px;font-weight:700;color:#fff;line-height:1;vertical-align:middle;white-space:nowrap;text-align:center;background-color:#777;border-radius:10px}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.btn-group-xs>.btn .badge,.btn-xs .badge{top:0;padding:1px 5px}.list-group-item.active>.badge,.nav-pills>.active>a>.badge{color:#337ab7;background-color:#fff}.list-group-item>.badge{float:right}.list-group-item>.badge+.badge{margin-right:5px}.nav-pills>li>a>.badge{margin-left:3px}a.badge:focus,a.badge:hover{color:#fff;text-decoration:none;cursor:pointer}.jumbotron{padding-top:30px;padding-bottom:30px;margin-bottom:30px;background-color:#eee}.jumbotron,.jumbotron .h1,.jumbotron h1{color:inherit}.jumbotron p{margin-bottom:15px;font-size:21px;font-weight:200}.jumbotron>hr{border-top-color:#d5d5d5}.container-fluid .jumbotron,.container .jumbotron{border-radius:6px;padding-left:15px;padding-right:15px}.jumbotron .container{max-width:100%}@media screen and (min-width:768px){.jumbotron{padding-top:48px;padding-bottom:48px}.container-fluid .jumbotron,.container .jumbotron{padding-left:60px;padding-right:60px}.jumbotron .h1,.jumbotron h1{font-size:63px}}.thumbnail{display:block;padding:4px;margin-bottom:20px;line-height:1.428571429;background-color:#fff;border:1px solid #ddd;border-radius:4px;transition:border .2s ease-in-out}.thumbnail>img,.thumbnail a>img{display:block;max-width:100%;height:auto;margin-left:auto;margin-right:auto}.thumbnail .caption{padding:9px;color:#333}a.thumbnail.active,a.thumbnail:focus,a.thumbnail:hover{border-color:#337ab7}.alert{padding:15px;margin-bottom:20px;border:1px solid transparent;border-radius:4px}.alert h4{margin-top:0;color:inherit}.alert .alert-link{font-weight:700}.alert>p,.alert>ul{margin-bottom:0}.alert>p+p{margin-top:5px}.alert-dismissable,.alert-dismissible{padding-right:35px}.alert-dismissable .close,.alert-dismissible .close{position:relative;top:-2px;right:-21px;color:inherit}.alert-success{background-color:#dff0d8;border-color:#d6e9c6;color:#3c763d}.alert-success hr{border-top-color:#c9e2b3}.alert-success .alert-link{color:#2b542c}.alert-info{background-color:#d9edf7;border-color:#bce8f1;color:#31708f}.alert-info hr{border-top-color:#a6e1ec}.alert-info .alert-link{color:#245269}.alert-warning{background-color:#fcf8e3;border-color:#faebcc;color:#8a6d3b}.alert-warning hr{border-top-color:#f7e1b5}.alert-warning .alert-link{color:#66512c}.alert-danger{background-color:#f2dede;border-color:#ebccd1;color:#a94442}.alert-danger hr{border-top-color:#e4b9c0}.alert-danger .alert-link{color:#843534}@keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}.progress{overflow:hidden;height:20px;margin-bottom:20px;background-color:#f5f5f5;border-radius:4px;box-shadow:inset 0 1px 2px rgba(0,0,0,.1)}.progress-bar{float:left;width:0;height:100%;font-size:12px;line-height:20px;color:#fff;text-align:center;background-color:#337ab7;box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);transition:width .6s ease}.progress-bar-striped,.progress-striped .progress-bar{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:40px 40px}.progress-bar.active,.progress.active .progress-bar{animation:progress-bar-stripes 2s linear infinite}.progress-bar-success{background-color:#5cb85c}.progress-striped .progress-bar-success{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-info{background-color:#5bc0de}.progress-striped .progress-bar-info{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-warning{background-color:#f0ad4e}.progress-striped .progress-bar-warning{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-danger{background-color:#d9534f}.progress-striped .progress-bar-danger{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.media{margin-top:15px}.media:first-child{margin-top:0}.media,.media-body{zoom:1;overflow:hidden}.media-body{width:10000px}.media-object{display:block}.media-object.img-thumbnail{max-width:none}.media-right,.media>.pull-right{padding-left:10px}.media-left,.media>.pull-left{padding-right:10px}.media-body,.media-left,.media-right{display:table-cell;vertical-align:top}.media-middle{vertical-align:middle}.media-bottom{vertical-align:bottom}.media-heading{margin-top:0;margin-bottom:5px}.media-list{padding-left:0;list-style:none}.list-group{margin-bottom:20px;padding-left:0}.list-group-item{position:relative;display:block;padding:10px 15px;margin-bottom:-1px;background-color:#fff;border:1px solid #ddd}.list-group-item:first-child{border-top-right-radius:4px;border-top-left-radius:4px}.list-group-item:last-child{margin-bottom:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}a.list-group-item,button.list-group-item{color:#555}a.list-group-item .list-group-item-heading,button.list-group-item .list-group-item-heading{color:#333}a.list-group-item:focus,a.list-group-item:hover,button.list-group-item:focus,button.list-group-item:hover{text-decoration:none;color:#555;background-color:#f5f5f5}button.list-group-item{width:100%;text-align:left}.list-group-item.disabled,.list-group-item.disabled:focus,.list-group-item.disabled:hover{background-color:#eee;color:#777;cursor:not-allowed}.list-group-item.disabled .list-group-item-heading,.list-group-item.disabled:focus .list-group-item-heading,.list-group-item.disabled:hover .list-group-item-heading{color:inherit}.list-group-item.disabled .list-group-item-text,.list-group-item.disabled:focus .list-group-item-text,.list-group-item.disabled:hover .list-group-item-text{color:#777}.list-group-item.active,.list-group-item.active:focus,.list-group-item.active:hover{z-index:2;color:#fff;background-color:#337ab7;border-color:#337ab7}.list-group-item.active .list-group-item-heading,.list-group-item.active .list-group-item-heading>.small,.list-group-item.active .list-group-item-heading>small,.list-group-item.active:focus .list-group-item-heading,.list-group-item.active:focus .list-group-item-heading>.small,.list-group-item.active:focus .list-group-item-heading>small,.list-group-item.active:hover .list-group-item-heading,.list-group-item.active:hover .list-group-item-heading>.small,.list-group-item.active:hover .list-group-item-heading>small{color:inherit}.list-group-item.active .list-group-item-text,.list-group-item.active:focus .list-group-item-text,.list-group-item.active:hover .list-group-item-text{color:#c7ddef}.list-group-item-success{color:#3c763d;background-color:#dff0d8}a.list-group-item-success,button.list-group-item-success{color:#3c763d}a.list-group-item-success .list-group-item-heading,button.list-group-item-success .list-group-item-heading{color:inherit}a.list-group-item-success:focus,a.list-group-item-success:hover,button.list-group-item-success:focus,button.list-group-item-success:hover{color:#3c763d;background-color:#d0e9c6}a.list-group-item-success.active,a.list-group-item-success.active:focus,a.list-group-item-success.active:hover,button.list-group-item-success.active,button.list-group-item-success.active:focus,button.list-group-item-success.active:hover{color:#fff;background-color:#3c763d;border-color:#3c763d}.list-group-item-info{color:#31708f;background-color:#d9edf7}a.list-group-item-info,button.list-group-item-info{color:#31708f}a.list-group-item-info .list-group-item-heading,button.list-group-item-info .list-group-item-heading{color:inherit}a.list-group-item-info:focus,a.list-group-item-info:hover,button.list-group-item-info:focus,button.list-group-item-info:hover{color:#31708f;background-color:#c4e3f3}a.list-group-item-info.active,a.list-group-item-info.active:focus,a.list-group-item-info.active:hover,button.list-group-item-info.active,button.list-group-item-info.active:focus,button.list-group-item-info.active:hover{color:#fff;background-color:#31708f;border-color:#31708f}.list-group-item-warning{color:#8a6d3b;background-color:#fcf8e3}a.list-group-item-warning,button.list-group-item-warning{color:#8a6d3b}a.list-group-item-warning .list-group-item-heading,button.list-group-item-warning .list-group-item-heading{color:inherit}a.list-group-item-warning:focus,a.list-group-item-warning:hover,button.list-group-item-warning:focus,button.list-group-item-warning:hover{color:#8a6d3b;background-color:#faf2cc}a.list-group-item-warning.active,a.list-group-item-warning.active:focus,a.list-group-item-warning.active:hover,button.list-group-item-warning.active,button.list-group-item-warning.active:focus,button.list-group-item-warning.active:hover{color:#fff;background-color:#8a6d3b;border-color:#8a6d3b}.list-group-item-danger{color:#a94442;background-color:#f2dede}a.list-group-item-danger,button.list-group-item-danger{color:#a94442}a.list-group-item-danger .list-group-item-heading,button.list-group-item-danger .list-group-item-heading{color:inherit}a.list-group-item-danger:focus,a.list-group-item-danger:hover,button.list-group-item-danger:focus,button.list-group-item-danger:hover{color:#a94442;background-color:#ebcccc}a.list-group-item-danger.active,a.list-group-item-danger.active:focus,a.list-group-item-danger.active:hover,button.list-group-item-danger.active,button.list-group-item-danger.active:focus,button.list-group-item-danger.active:hover{color:#fff;background-color:#a94442;border-color:#a94442}.list-group-item-heading{margin-top:0;margin-bottom:5px}.list-group-item-text{margin-bottom:0;line-height:1.3}.panel{margin-bottom:20px;background-color:#fff;border:1px solid transparent;border-radius:4px;box-shadow:0 1px 1px rgba(0,0,0,.05)}.panel-body{padding:15px}.panel-body:after,.panel-body:before{content:\" \";display:table}.panel-body:after{clear:both}.panel-heading{padding:10px 15px;border-bottom:1px solid transparent;border-top-right-radius:3px;border-top-left-radius:3px}.panel-heading>.dropdown .dropdown-toggle,.panel-title{color:inherit}.panel-title{margin-top:0;margin-bottom:0;font-size:16px}.panel-title>.small,.panel-title>.small>a,.panel-title>a,.panel-title>small,.panel-title>small>a{color:inherit}.panel-footer{padding:10px 15px;background-color:#f5f5f5;border-top:1px solid #ddd;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.list-group,.panel>.panel-collapse>.list-group{margin-bottom:0}.panel>.list-group .list-group-item,.panel>.panel-collapse>.list-group .list-group-item{border-width:1px 0;border-radius:0}.panel>.list-group:first-child .list-group-item:first-child,.panel>.panel-collapse>.list-group:first-child .list-group-item:first-child{border-top:0;border-top-right-radius:3px;border-top-left-radius:3px}.panel>.list-group:last-child .list-group-item:last-child,.panel>.panel-collapse>.list-group:last-child .list-group-item:last-child{border-bottom:0;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.panel-heading+.panel-collapse>.list-group .list-group-item:first-child{border-top-right-radius:0;border-top-left-radius:0}.list-group+.panel-footer,.panel-heading+.list-group .list-group-item:first-child{border-top-width:0}.panel>.panel-collapse>.table,.panel>.table,.panel>.table-responsive>.table{margin-bottom:0}.panel>.panel-collapse>.table caption,.panel>.table-responsive>.table caption,.panel>.table caption{padding-left:15px;padding-right:15px}.panel>.table-responsive:first-child>.table:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child,.panel>.table:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child,.panel>.table:first-child>thead:first-child>tr:first-child{border-top-right-radius:3px;border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table:first-child>thead:first-child>tr:first-child th:first-child{border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table:first-child>thead:first-child>tr:first-child th:last-child{border-top-right-radius:3px}.panel>.table-responsive:last-child>.table:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child,.panel>.table:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child{border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:first-child{border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:last-child{border-bottom-right-radius:3px}.panel>.panel-body+.table,.panel>.panel-body+.table-responsive,.panel>.table+.panel-body,.panel>.table-responsive+.panel-body{border-top:1px solid #ddd}.panel>.table>tbody:first-child>tr:first-child td,.panel>.table>tbody:first-child>tr:first-child th{border-top:0}.panel>.table-bordered,.panel>.table-responsive>.table-bordered{border:0}.panel>.table-bordered>tbody>tr>td:first-child,.panel>.table-bordered>tbody>tr>th:first-child,.panel>.table-bordered>tfoot>tr>td:first-child,.panel>.table-bordered>tfoot>tr>th:first-child,.panel>.table-bordered>thead>tr>td:first-child,.panel>.table-bordered>thead>tr>th:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:first-child,.panel>.table-responsive>.table-bordered>thead>tr>td:first-child,.panel>.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.panel>.table-bordered>tbody>tr>td:last-child,.panel>.table-bordered>tbody>tr>th:last-child,.panel>.table-bordered>tfoot>tr>td:last-child,.panel>.table-bordered>tfoot>tr>th:last-child,.panel>.table-bordered>thead>tr>td:last-child,.panel>.table-bordered>thead>tr>th:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:last-child,.panel>.table-responsive>.table-bordered>thead>tr>td:last-child,.panel>.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.panel>.table-bordered>tbody>tr:first-child>td,.panel>.table-bordered>tbody>tr:first-child>th,.panel>.table-bordered>tbody>tr:last-child>td,.panel>.table-bordered>tbody>tr:last-child>th,.panel>.table-bordered>tfoot>tr:last-child>td,.panel>.table-bordered>tfoot>tr:last-child>th,.panel>.table-bordered>thead>tr:first-child>td,.panel>.table-bordered>thead>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>th,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>td,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>th,.panel>.table-responsive>.table-bordered>thead>tr:first-child>td,.panel>.table-responsive>.table-bordered>thead>tr:first-child>th{border-bottom:0}.panel>.table-responsive{border:0;margin-bottom:0}.panel-group{margin-bottom:20px}.panel-group .panel{margin-bottom:0;border-radius:4px}.panel-group .panel+.panel{margin-top:5px}.panel-group .panel-heading{border-bottom:0}.panel-group .panel-heading+.panel-collapse>.list-group,.panel-group .panel-heading+.panel-collapse>.panel-body{border-top:1px solid #ddd}.panel-group .panel-footer{border-top:0}.panel-group .panel-footer+.panel-collapse .panel-body{border-bottom:1px solid #ddd}.panel-default{border-color:#ddd}.panel-default>.panel-heading{color:#333;background-color:#f5f5f5;border-color:#ddd}.panel-default>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ddd}.panel-default>.panel-heading .badge{color:#f5f5f5;background-color:#333}.panel-default>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ddd}.panel-primary{border-color:#337ab7}.panel-primary>.panel-heading{color:#fff;background-color:#337ab7;border-color:#337ab7}.panel-primary>.panel-heading+.panel-collapse>.panel-body{border-top-color:#337ab7}.panel-primary>.panel-heading .badge{color:#337ab7;background-color:#fff}.panel-primary>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#337ab7}.panel-success{border-color:#d6e9c6}.panel-success>.panel-heading{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.panel-success>.panel-heading+.panel-collapse>.panel-body{border-top-color:#d6e9c6}.panel-success>.panel-heading .badge{color:#dff0d8;background-color:#3c763d}.panel-success>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#d6e9c6}.panel-info{border-color:#bce8f1}.panel-info>.panel-heading{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.panel-info>.panel-heading+.panel-collapse>.panel-body{border-top-color:#bce8f1}.panel-info>.panel-heading .badge{color:#d9edf7;background-color:#31708f}.panel-info>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#bce8f1}.panel-warning{border-color:#faebcc}.panel-warning>.panel-heading{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.panel-warning>.panel-heading+.panel-collapse>.panel-body{border-top-color:#faebcc}.panel-warning>.panel-heading .badge{color:#fcf8e3;background-color:#8a6d3b}.panel-warning>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#faebcc}.panel-danger{border-color:#ebccd1}.panel-danger>.panel-heading{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.panel-danger>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ebccd1}.panel-danger>.panel-heading .badge{color:#f2dede;background-color:#a94442}.panel-danger>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ebccd1}.embed-responsive{position:relative;display:block;height:0;padding:0;overflow:hidden}.embed-responsive .embed-responsive-item,.embed-responsive embed,.embed-responsive iframe,.embed-responsive object,.embed-responsive video{position:absolute;top:0;left:0;bottom:0;height:100%;width:100%;border:0}.embed-responsive-16by9{padding-bottom:56.25%}.embed-responsive-4by3{padding-bottom:75%}.well{min-height:20px;padding:19px;margin-bottom:20px;background-color:#f5f5f5;border:1px solid #e3e3e3;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.05)}.well blockquote{border-color:#ddd;border-color:rgba(0,0,0,.15)}.well-lg{padding:24px;border-radius:6px}.well-sm{padding:9px;border-radius:3px}.close{float:right;font-size:21px;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.2;filter:alpha(opacity=20)}.close:focus,.close:hover{color:#000;text-decoration:none;cursor:pointer;opacity:.5;filter:alpha(opacity=50)}button.close{padding:0;cursor:pointer;background:transparent;border:0;-webkit-appearance:none}.modal,.modal-open{overflow:hidden}.modal{display:none;position:fixed;top:0;right:0;bottom:0;left:0;z-index:1050;-webkit-overflow-scrolling:touch;outline:0}.modal.fade .modal-dialog{transform:translateY(-25%);transition:transform .3s ease-out}.modal.in .modal-dialog{transform:translate(0)}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal-dialog{position:relative;width:auto;margin:10px}.modal-content{position:relative;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.2);border-radius:6px;box-shadow:0 3px 9px rgba(0,0,0,.5);background-clip:padding-box;outline:0}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:#000}.modal-backdrop.fade{opacity:0;filter:alpha(opacity=0)}.modal-backdrop.in{opacity:.5;filter:alpha(opacity=50)}.modal-header{padding:15px;border-bottom:1px solid #e5e5e5}.modal-header:after,.modal-header:before{content:\" \";display:table}.modal-header:after{clear:both}.modal-header .close{margin-top:-2px}.modal-title{margin:0;line-height:1.428571429}.modal-body{position:relative;padding:15px}.modal-footer{padding:15px;text-align:right;border-top:1px solid #e5e5e5}.modal-footer:after,.modal-footer:before{content:\" \";display:table}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:768px){.modal-dialog{width:600px;margin:30px auto}.modal-content{box-shadow:0 5px 15px rgba(0,0,0,.5)}.modal-sm{width:300px}}@media (min-width:992px){.modal-lg{width:900px}}.tooltip{position:absolute;z-index:1070;display:block;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-style:normal;font-weight:400;letter-spacing:normal;line-break:auto;line-height:1.428571429;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;white-space:normal;word-break:normal;word-spacing:normal;word-wrap:normal;font-size:12px;opacity:0;filter:alpha(opacity=0)}.tooltip.in{opacity:.9;filter:alpha(opacity=90)}.tooltip.top{margin-top:-3px;padding:5px 0}.tooltip.right{margin-left:3px;padding:0 5px}.tooltip.bottom{margin-top:3px;padding:5px 0}.tooltip.left{margin-left:-3px;padding:0 5px}.tooltip-inner{max-width:200px;padding:3px 8px;color:#fff;text-align:center;background-color:#000;border-radius:4px}.tooltip-arrow{position:absolute;width:0;height:0;border-color:transparent;border-style:solid}.tooltip.top .tooltip-arrow{bottom:0;left:50%;margin-left:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-left .tooltip-arrow{right:5px}.tooltip.top-left .tooltip-arrow,.tooltip.top-right .tooltip-arrow{bottom:0;margin-bottom:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-right .tooltip-arrow{left:5px}.tooltip.right .tooltip-arrow{top:50%;left:0;margin-top:-5px;border-width:5px 5px 5px 0;border-right-color:#000}.tooltip.left .tooltip-arrow{top:50%;right:0;margin-top:-5px;border-width:5px 0 5px 5px;border-left-color:#000}.tooltip.bottom .tooltip-arrow{top:0;left:50%;margin-left:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-left .tooltip-arrow{top:0;right:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-right .tooltip-arrow{top:0;left:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.popover{position:absolute;top:0;left:0;z-index:1060;display:none;max-width:276px;padding:1px;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-style:normal;font-weight:400;letter-spacing:normal;line-break:auto;line-height:1.428571429;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;white-space:normal;word-break:normal;word-spacing:normal;word-wrap:normal;font-size:14px;background-color:#fff;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.2);border-radius:6px;box-shadow:0 5px 10px rgba(0,0,0,.2)}.popover.top{margin-top:-10px}.popover.right{margin-left:10px}.popover.bottom{margin-top:10px}.popover.left{margin-left:-10px}.popover-title{margin:0;padding:8px 14px;font-size:14px;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-radius:5px 5px 0 0}.popover-content{padding:9px 14px}.popover>.arrow,.popover>.arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid}.popover>.arrow{border-width:11px}.popover>.arrow:after{border-width:10px;content:\"\"}.popover.top>.arrow{left:50%;margin-left:-11px;border-bottom-width:0;border-top-color:#999;border-top-color:rgba(0,0,0,.25);bottom:-11px}.popover.top>.arrow:after{content:\" \";bottom:1px;margin-left:-10px;border-bottom-width:0;border-top-color:#fff}.popover.right>.arrow{top:50%;left:-11px;margin-top:-11px;border-left-width:0;border-right-color:#999;border-right-color:rgba(0,0,0,.25)}.popover.right>.arrow:after{content:\" \";left:1px;bottom:-10px;border-left-width:0;border-right-color:#fff}.popover.bottom>.arrow{left:50%;margin-left:-11px;border-top-width:0;border-bottom-color:#999;border-bottom-color:rgba(0,0,0,.25);top:-11px}.popover.bottom>.arrow:after{content:\" \";top:1px;margin-left:-10px;border-top-width:0;border-bottom-color:#fff}.popover.left>.arrow{top:50%;right:-11px;margin-top:-11px;border-right-width:0;border-left-color:#999;border-left-color:rgba(0,0,0,.25)}.popover.left>.arrow:after{content:\" \";right:1px;border-right-width:0;border-left-color:#fff;bottom:-10px}.carousel,.carousel-inner{position:relative}.carousel-inner{overflow:hidden;width:100%}.carousel-inner>.item{display:none;position:relative;transition:left .6s ease-in-out}.carousel-inner>.item>a>img,.carousel-inner>.item>img{display:block;max-width:100%;height:auto;line-height:1}@media (-webkit-transform-3d),(transform-3d){.carousel-inner>.item{transition:transform .6s ease-in-out;-webkit-backface-visibility:hidden;backface-visibility:hidden;perspective:1000px}.carousel-inner>.item.active.right,.carousel-inner>.item.next{transform:translate3d(100%,0,0);left:0}.carousel-inner>.item.active.left,.carousel-inner>.item.prev{transform:translate3d(-100%,0,0);left:0}.carousel-inner>.item.active,.carousel-inner>.item.next.left,.carousel-inner>.item.prev.right{transform:translateZ(0);left:0}}.carousel-inner>.active,.carousel-inner>.next,.carousel-inner>.prev{display:block}.carousel-inner>.active{left:0}.carousel-inner>.next,.carousel-inner>.prev{position:absolute;top:0;width:100%}.carousel-inner>.next{left:100%}.carousel-inner>.prev{left:-100%}.carousel-inner>.next.left,.carousel-inner>.prev.right{left:0}.carousel-inner>.active.left{left:-100%}.carousel-inner>.active.right{left:100%}.carousel-control{position:absolute;top:0;left:0;bottom:0;width:15%;opacity:.5;filter:alpha(opacity=50);font-size:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6);background-color:transparent}.carousel-control.left{background-image:linear-gradient(90deg,rgba(0,0,0,.5) 0,rgba(0,0,0,.0001));background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#80000000\",endColorstr=\"#00000000\",GradientType=1)}.carousel-control.right{left:auto;right:0;background-image:linear-gradient(90deg,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5));background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#00000000\",endColorstr=\"#80000000\",GradientType=1)}.carousel-control:focus,.carousel-control:hover{outline:0;color:#fff;text-decoration:none;opacity:.9;filter:alpha(opacity=90)}.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{position:absolute;top:50%;margin-top:-10px;z-index:5;display:inline-block}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{left:50%;margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{right:50%;margin-right:-10px}.carousel-control .icon-next,.carousel-control .icon-prev{width:20px;height:20px;line-height:1;font-family:serif}.carousel-control .icon-prev:before{content:\"\\2039\"}.carousel-control .icon-next:before{content:\"\\203A\"}.carousel-indicators{position:absolute;bottom:10px;left:50%;z-index:15;width:60%;margin-left:-30%;padding-left:0;list-style:none;text-align:center}.carousel-indicators li{display:inline-block;width:10px;height:10px;margin:1px;text-indent:-999px;border:1px solid #fff;border-radius:10px;cursor:pointer;background-color:#000\\9;background-color:transparent}.carousel-indicators .active{margin:0;width:12px;height:12px;background-color:#fff}.carousel-caption{position:absolute;left:15%;right:15%;bottom:20px;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6)}.carousel-caption .btn{text-shadow:none}@media screen and (min-width:768px){.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{width:30px;height:30px;margin-top:-10px;font-size:30px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{margin-right:-10px}.carousel-caption{left:20%;right:20%;padding-bottom:30px}.carousel-indicators{bottom:20px}}.clearfix:after,.clearfix:before{content:\" \";display:table}.clearfix:after{clear:both}.center-block{display:block;margin-left:auto;margin-right:auto}.pull-right{float:right!important}.pull-left{float:left!important}.hide{display:none!important}.show{display:block!important}.invisible{visibility:hidden}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.hidden{display:none!important}.affix{position:fixed}@-ms-viewport{width:device-width}.visible-lg,.visible-lg-block,.visible-lg-inline,.visible-lg-inline-block,.visible-md,.visible-md-block,.visible-md-inline,.visible-md-inline-block,.visible-sm,.visible-sm-block,.visible-sm-inline,.visible-sm-inline-block,.visible-xs,.visible-xs-block,.visible-xs-inline,.visible-xs-inline-block{display:none!important}@media (max-width:767px){.visible-xs{display:block!important}table.visible-xs{display:table!important}tr.visible-xs{display:table-row!important}td.visible-xs,th.visible-xs{display:table-cell!important}}@media (max-width:767px){.visible-xs-block{display:block!important}}@media (max-width:767px){.visible-xs-inline{display:inline!important}}@media (max-width:767px){.visible-xs-inline-block{display:inline-block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm{display:block!important}table.visible-sm{display:table!important}tr.visible-sm{display:table-row!important}td.visible-sm,th.visible-sm{display:table-cell!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-block{display:block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline{display:inline!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline-block{display:inline-block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md{display:block!important}table.visible-md{display:table!important}tr.visible-md{display:table-row!important}td.visible-md,th.visible-md{display:table-cell!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-block{display:block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline{display:inline!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline-block{display:inline-block!important}}@media (min-width:1200px){.visible-lg{display:block!important}table.visible-lg{display:table!important}tr.visible-lg{display:table-row!important}td.visible-lg,th.visible-lg{display:table-cell!important}}@media (min-width:1200px){.visible-lg-block{display:block!important}}@media (min-width:1200px){.visible-lg-inline{display:inline!important}}@media (min-width:1200px){.visible-lg-inline-block{display:inline-block!important}}@media (max-width:767px){.hidden-xs{display:none!important}}@media (min-width:768px) and (max-width:991px){.hidden-sm{display:none!important}}@media (min-width:992px) and (max-width:1199px){.hidden-md{display:none!important}}@media (min-width:1200px){.hidden-lg{display:none!important}}.visible-print{display:none!important}@media print{.visible-print{display:block!important}table.visible-print{display:table!important}tr.visible-print{display:table-row!important}td.visible-print,th.visible-print{display:table-cell!important}}.visible-print-block{display:none!important}@media print{.visible-print-block{display:block!important}}.visible-print-inline{display:none!important}@media print{.visible-print-inline{display:inline!important}}.visible-print-inline-block{display:none!important}@media print{.visible-print-inline-block{display:inline-block!important}}@media print{.hidden-print{display:none!important}}/*!\n *  Font Awesome 4.7.0 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\n */@font-face{font-family:FontAwesome;src:url(\"/assets/fonts/font-awesome//fontawesome-webfont.eot?v=4.7.0\");src:url(\"/assets/fonts/font-awesome//fontawesome-webfont.eot?#iefix&v=4.7.0\") format(\"embedded-opentype\"),url(\"/assets/fonts/font-awesome//fontawesome-webfont.woff2?v=4.7.0\") format(\"woff2\"),url(\"/assets/fonts/font-awesome//fontawesome-webfont.woff?v=4.7.0\") format(\"woff\"),url(\"/assets/fonts/font-awesome//fontawesome-webfont.ttf?v=4.7.0\") format(\"truetype\"),url(\"/assets/fonts/font-awesome//fontawesome-webfont.svg?v=4.7.0#fontawesomeregular\") format(\"svg\");font-weight:400;font-style:normal}.fa{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.fa-lg{font-size:1.3333333333em;line-height:.75em;vertical-align:-15%}.fa-2x{font-size:2em}.fa-3x{font-size:3em}.fa-4x{font-size:4em}.fa-5x{font-size:5em}.fa-fw{width:1.2857142857em;text-align:center}.fa-ul{padding-left:0;margin-left:2.1428571429em;list-style-type:none}.fa-ul>li{position:relative}.fa-li{position:absolute;left:-2.1428571429em;width:2.1428571429em;top:.1428571429em;text-align:center}.fa-li.fa-lg{left:-1.8571428571em}.fa-border{padding:.2em .25em .15em;border:.08em solid #eee;border-radius:.1em}.fa-pull-left{float:left}.fa-pull-right{float:right}.fa.fa-pull-left{margin-right:.3em}.fa.fa-pull-right{margin-left:.3em}.pull-right{float:right}.pull-left{float:left}.fa.pull-left{margin-right:.3em}.fa.pull-right{margin-left:.3em}.fa-spin{animation:fa-spin 2s infinite linear}.fa-pulse{animation:fa-spin 1s infinite steps(8)}@keyframes fa-spin{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.fa-rotate-90{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";transform:rotate(90deg)}.fa-rotate-180{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";transform:rotate(180deg)}.fa-rotate-270{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";transform:rotate(270deg)}.fa-flip-horizontal{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";transform:scaleX(-1)}.fa-flip-vertical{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";transform:scaleY(-1)}:root .fa-flip-horizontal,:root .fa-flip-vertical,:root .fa-rotate-90,:root .fa-rotate-180,:root .fa-rotate-270{filter:none}.fa-stack{position:relative;display:inline-block;width:2em;height:2em;line-height:2em;vertical-align:middle}.fa-stack-1x,.fa-stack-2x{position:absolute;left:0;width:100%;text-align:center}.fa-stack-1x{line-height:inherit}.fa-stack-2x{font-size:2em}.fa-inverse{color:#fff}.fa-glass:before{content:\"\\F000\"}.fa-music:before{content:\"\\F001\"}.fa-search:before{content:\"\\F002\"}.fa-envelope-o:before{content:\"\\F003\"}.fa-heart:before{content:\"\\F004\"}.fa-star:before{content:\"\\F005\"}.fa-star-o:before{content:\"\\F006\"}.fa-user:before{content:\"\\F007\"}.fa-film:before{content:\"\\F008\"}.fa-th-large:before{content:\"\\F009\"}.fa-th:before{content:\"\\F00A\"}.fa-th-list:before{content:\"\\F00B\"}.fa-check:before{content:\"\\F00C\"}.fa-close:before,.fa-remove:before,.fa-times:before{content:\"\\F00D\"}.fa-search-plus:before{content:\"\\F00E\"}.fa-search-minus:before{content:\"\\F010\"}.fa-power-off:before{content:\"\\F011\"}.fa-signal:before{content:\"\\F012\"}.fa-cog:before,.fa-gear:before{content:\"\\F013\"}.fa-trash-o:before{content:\"\\F014\"}.fa-home:before{content:\"\\F015\"}.fa-file-o:before{content:\"\\F016\"}.fa-clock-o:before{content:\"\\F017\"}.fa-road:before{content:\"\\F018\"}.fa-download:before{content:\"\\F019\"}.fa-arrow-circle-o-down:before{content:\"\\F01A\"}.fa-arrow-circle-o-up:before{content:\"\\F01B\"}.fa-inbox:before{content:\"\\F01C\"}.fa-play-circle-o:before{content:\"\\F01D\"}.fa-repeat:before,.fa-rotate-right:before{content:\"\\F01E\"}.fa-refresh:before{content:\"\\F021\"}.fa-list-alt:before{content:\"\\F022\"}.fa-lock:before{content:\"\\F023\"}.fa-flag:before{content:\"\\F024\"}.fa-headphones:before{content:\"\\F025\"}.fa-volume-off:before{content:\"\\F026\"}.fa-volume-down:before{content:\"\\F027\"}.fa-volume-up:before{content:\"\\F028\"}.fa-qrcode:before{content:\"\\F029\"}.fa-barcode:before{content:\"\\F02A\"}.fa-tag:before{content:\"\\F02B\"}.fa-tags:before{content:\"\\F02C\"}.fa-book:before{content:\"\\F02D\"}.fa-bookmark:before{content:\"\\F02E\"}.fa-print:before{content:\"\\F02F\"}.fa-camera:before{content:\"\\F030\"}.fa-font:before{content:\"\\F031\"}.fa-bold:before{content:\"\\F032\"}.fa-italic:before{content:\"\\F033\"}.fa-text-height:before{content:\"\\F034\"}.fa-text-width:before{content:\"\\F035\"}.fa-align-left:before{content:\"\\F036\"}.fa-align-center:before{content:\"\\F037\"}.fa-align-right:before{content:\"\\F038\"}.fa-align-justify:before{content:\"\\F039\"}.fa-list:before{content:\"\\F03A\"}.fa-dedent:before,.fa-outdent:before{content:\"\\F03B\"}.fa-indent:before{content:\"\\F03C\"}.fa-video-camera:before{content:\"\\F03D\"}.fa-image:before,.fa-photo:before,.fa-picture-o:before{content:\"\\F03E\"}.fa-pencil:before{content:\"\\F040\"}.fa-map-marker:before{content:\"\\F041\"}.fa-adjust:before{content:\"\\F042\"}.fa-tint:before{content:\"\\F043\"}.fa-edit:before,.fa-pencil-square-o:before{content:\"\\F044\"}.fa-share-square-o:before{content:\"\\F045\"}.fa-check-square-o:before{content:\"\\F046\"}.fa-arrows:before{content:\"\\F047\"}.fa-step-backward:before{content:\"\\F048\"}.fa-fast-backward:before{content:\"\\F049\"}.fa-backward:before{content:\"\\F04A\"}.fa-play:before{content:\"\\F04B\"}.fa-pause:before{content:\"\\F04C\"}.fa-stop:before{content:\"\\F04D\"}.fa-forward:before{content:\"\\F04E\"}.fa-fast-forward:before{content:\"\\F050\"}.fa-step-forward:before{content:\"\\F051\"}.fa-eject:before{content:\"\\F052\"}.fa-chevron-left:before{content:\"\\F053\"}.fa-chevron-right:before{content:\"\\F054\"}.fa-plus-circle:before{content:\"\\F055\"}.fa-minus-circle:before{content:\"\\F056\"}.fa-times-circle:before{content:\"\\F057\"}.fa-check-circle:before{content:\"\\F058\"}.fa-question-circle:before{content:\"\\F059\"}.fa-info-circle:before{content:\"\\F05A\"}.fa-crosshairs:before{content:\"\\F05B\"}.fa-times-circle-o:before{content:\"\\F05C\"}.fa-check-circle-o:before{content:\"\\F05D\"}.fa-ban:before{content:\"\\F05E\"}.fa-arrow-left:before{content:\"\\F060\"}.fa-arrow-right:before{content:\"\\F061\"}.fa-arrow-up:before{content:\"\\F062\"}.fa-arrow-down:before{content:\"\\F063\"}.fa-mail-forward:before,.fa-share:before{content:\"\\F064\"}.fa-expand:before{content:\"\\F065\"}.fa-compress:before{content:\"\\F066\"}.fa-plus:before{content:\"\\F067\"}.fa-minus:before{content:\"\\F068\"}.fa-asterisk:before{content:\"\\F069\"}.fa-exclamation-circle:before{content:\"\\F06A\"}.fa-gift:before{content:\"\\F06B\"}.fa-leaf:before{content:\"\\F06C\"}.fa-fire:before{content:\"\\F06D\"}.fa-eye:before{content:\"\\F06E\"}.fa-eye-slash:before{content:\"\\F070\"}.fa-exclamation-triangle:before,.fa-warning:before{content:\"\\F071\"}.fa-plane:before{content:\"\\F072\"}.fa-calendar:before{content:\"\\F073\"}.fa-random:before{content:\"\\F074\"}.fa-comment:before{content:\"\\F075\"}.fa-magnet:before{content:\"\\F076\"}.fa-chevron-up:before{content:\"\\F077\"}.fa-chevron-down:before{content:\"\\F078\"}.fa-retweet:before{content:\"\\F079\"}.fa-shopping-cart:before{content:\"\\F07A\"}.fa-folder:before{content:\"\\F07B\"}.fa-folder-open:before{content:\"\\F07C\"}.fa-arrows-v:before{content:\"\\F07D\"}.fa-arrows-h:before{content:\"\\F07E\"}.fa-bar-chart-o:before,.fa-bar-chart:before{content:\"\\F080\"}.fa-twitter-square:before{content:\"\\F081\"}.fa-facebook-square:before{content:\"\\F082\"}.fa-camera-retro:before{content:\"\\F083\"}.fa-key:before{content:\"\\F084\"}.fa-cogs:before,.fa-gears:before{content:\"\\F085\"}.fa-comments:before{content:\"\\F086\"}.fa-thumbs-o-up:before{content:\"\\F087\"}.fa-thumbs-o-down:before{content:\"\\F088\"}.fa-star-half:before{content:\"\\F089\"}.fa-heart-o:before{content:\"\\F08A\"}.fa-sign-out:before{content:\"\\F08B\"}.fa-linkedin-square:before{content:\"\\F08C\"}.fa-thumb-tack:before{content:\"\\F08D\"}.fa-external-link:before{content:\"\\F08E\"}.fa-sign-in:before{content:\"\\F090\"}.fa-trophy:before{content:\"\\F091\"}.fa-github-square:before{content:\"\\F092\"}.fa-upload:before{content:\"\\F093\"}.fa-lemon-o:before{content:\"\\F094\"}.fa-phone:before{content:\"\\F095\"}.fa-square-o:before{content:\"\\F096\"}.fa-bookmark-o:before{content:\"\\F097\"}.fa-phone-square:before{content:\"\\F098\"}.fa-twitter:before{content:\"\\F099\"}.fa-facebook-f:before,.fa-facebook:before{content:\"\\F09A\"}.fa-github:before{content:\"\\F09B\"}.fa-unlock:before{content:\"\\F09C\"}.fa-credit-card:before{content:\"\\F09D\"}.fa-feed:before,.fa-rss:before{content:\"\\F09E\"}.fa-hdd-o:before{content:\"\\F0A0\"}.fa-bullhorn:before{content:\"\\F0A1\"}.fa-bell:before{content:\"\\F0F3\"}.fa-certificate:before{content:\"\\F0A3\"}.fa-hand-o-right:before{content:\"\\F0A4\"}.fa-hand-o-left:before{content:\"\\F0A5\"}.fa-hand-o-up:before{content:\"\\F0A6\"}.fa-hand-o-down:before{content:\"\\F0A7\"}.fa-arrow-circle-left:before{content:\"\\F0A8\"}.fa-arrow-circle-right:before{content:\"\\F0A9\"}.fa-arrow-circle-up:before{content:\"\\F0AA\"}.fa-arrow-circle-down:before{content:\"\\F0AB\"}.fa-globe:before{content:\"\\F0AC\"}.fa-wrench:before{content:\"\\F0AD\"}.fa-tasks:before{content:\"\\F0AE\"}.fa-filter:before{content:\"\\F0B0\"}.fa-briefcase:before{content:\"\\F0B1\"}.fa-arrows-alt:before{content:\"\\F0B2\"}.fa-group:before,.fa-users:before{content:\"\\F0C0\"}.fa-chain:before,.fa-link:before{content:\"\\F0C1\"}.fa-cloud:before{content:\"\\F0C2\"}.fa-flask:before{content:\"\\F0C3\"}.fa-cut:before,.fa-scissors:before{content:\"\\F0C4\"}.fa-copy:before,.fa-files-o:before{content:\"\\F0C5\"}.fa-paperclip:before{content:\"\\F0C6\"}.fa-floppy-o:before,.fa-save:before{content:\"\\F0C7\"}.fa-square:before{content:\"\\F0C8\"}.fa-bars:before,.fa-navicon:before,.fa-reorder:before{content:\"\\F0C9\"}.fa-list-ul:before{content:\"\\F0CA\"}.fa-list-ol:before{content:\"\\F0CB\"}.fa-strikethrough:before{content:\"\\F0CC\"}.fa-underline:before{content:\"\\F0CD\"}.fa-table:before{content:\"\\F0CE\"}.fa-magic:before{content:\"\\F0D0\"}.fa-truck:before{content:\"\\F0D1\"}.fa-pinterest:before{content:\"\\F0D2\"}.fa-pinterest-square:before{content:\"\\F0D3\"}.fa-google-plus-square:before{content:\"\\F0D4\"}.fa-google-plus:before{content:\"\\F0D5\"}.fa-money:before{content:\"\\F0D6\"}.fa-caret-down:before{content:\"\\F0D7\"}.fa-caret-up:before{content:\"\\F0D8\"}.fa-caret-left:before{content:\"\\F0D9\"}.fa-caret-right:before{content:\"\\F0DA\"}.fa-columns:before{content:\"\\F0DB\"}.fa-sort:before,.fa-unsorted:before{content:\"\\F0DC\"}.fa-sort-desc:before,.fa-sort-down:before{content:\"\\F0DD\"}.fa-sort-asc:before,.fa-sort-up:before{content:\"\\F0DE\"}.fa-envelope:before{content:\"\\F0E0\"}.fa-linkedin:before{content:\"\\F0E1\"}.fa-rotate-left:before,.fa-undo:before{content:\"\\F0E2\"}.fa-gavel:before,.fa-legal:before{content:\"\\F0E3\"}.fa-dashboard:before,.fa-tachometer:before{content:\"\\F0E4\"}.fa-comment-o:before{content:\"\\F0E5\"}.fa-comments-o:before{content:\"\\F0E6\"}.fa-bolt:before,.fa-flash:before{content:\"\\F0E7\"}.fa-sitemap:before{content:\"\\F0E8\"}.fa-umbrella:before{content:\"\\F0E9\"}.fa-clipboard:before,.fa-paste:before{content:\"\\F0EA\"}.fa-lightbulb-o:before{content:\"\\F0EB\"}.fa-exchange:before{content:\"\\F0EC\"}.fa-cloud-download:before{content:\"\\F0ED\"}.fa-cloud-upload:before{content:\"\\F0EE\"}.fa-user-md:before{content:\"\\F0F0\"}.fa-stethoscope:before{content:\"\\F0F1\"}.fa-suitcase:before{content:\"\\F0F2\"}.fa-bell-o:before{content:\"\\F0A2\"}.fa-coffee:before{content:\"\\F0F4\"}.fa-cutlery:before{content:\"\\F0F5\"}.fa-file-text-o:before{content:\"\\F0F6\"}.fa-building-o:before{content:\"\\F0F7\"}.fa-hospital-o:before{content:\"\\F0F8\"}.fa-ambulance:before{content:\"\\F0F9\"}.fa-medkit:before{content:\"\\F0FA\"}.fa-fighter-jet:before{content:\"\\F0FB\"}.fa-beer:before{content:\"\\F0FC\"}.fa-h-square:before{content:\"\\F0FD\"}.fa-plus-square:before{content:\"\\F0FE\"}.fa-angle-double-left:before{content:\"\\F100\"}.fa-angle-double-right:before{content:\"\\F101\"}.fa-angle-double-up:before{content:\"\\F102\"}.fa-angle-double-down:before{content:\"\\F103\"}.fa-angle-left:before{content:\"\\F104\"}.fa-angle-right:before{content:\"\\F105\"}.fa-angle-up:before{content:\"\\F106\"}.fa-angle-down:before{content:\"\\F107\"}.fa-desktop:before{content:\"\\F108\"}.fa-laptop:before{content:\"\\F109\"}.fa-tablet:before{content:\"\\F10A\"}.fa-mobile-phone:before,.fa-mobile:before{content:\"\\F10B\"}.fa-circle-o:before{content:\"\\F10C\"}.fa-quote-left:before{content:\"\\F10D\"}.fa-quote-right:before{content:\"\\F10E\"}.fa-spinner:before{content:\"\\F110\"}.fa-circle:before{content:\"\\F111\"}.fa-mail-reply:before,.fa-reply:before{content:\"\\F112\"}.fa-github-alt:before{content:\"\\F113\"}.fa-folder-o:before{content:\"\\F114\"}.fa-folder-open-o:before{content:\"\\F115\"}.fa-smile-o:before{content:\"\\F118\"}.fa-frown-o:before{content:\"\\F119\"}.fa-meh-o:before{content:\"\\F11A\"}.fa-gamepad:before{content:\"\\F11B\"}.fa-keyboard-o:before{content:\"\\F11C\"}.fa-flag-o:before{content:\"\\F11D\"}.fa-flag-checkered:before{content:\"\\F11E\"}.fa-terminal:before{content:\"\\F120\"}.fa-code:before{content:\"\\F121\"}.fa-mail-reply-all:before,.fa-reply-all:before{content:\"\\F122\"}.fa-star-half-empty:before,.fa-star-half-full:before,.fa-star-half-o:before{content:\"\\F123\"}.fa-location-arrow:before{content:\"\\F124\"}.fa-crop:before{content:\"\\F125\"}.fa-code-fork:before{content:\"\\F126\"}.fa-chain-broken:before,.fa-unlink:before{content:\"\\F127\"}.fa-question:before{content:\"\\F128\"}.fa-info:before{content:\"\\F129\"}.fa-exclamation:before{content:\"\\F12A\"}.fa-superscript:before{content:\"\\F12B\"}.fa-subscript:before{content:\"\\F12C\"}.fa-eraser:before{content:\"\\F12D\"}.fa-puzzle-piece:before{content:\"\\F12E\"}.fa-microphone:before{content:\"\\F130\"}.fa-microphone-slash:before{content:\"\\F131\"}.fa-shield:before{content:\"\\F132\"}.fa-calendar-o:before{content:\"\\F133\"}.fa-fire-extinguisher:before{content:\"\\F134\"}.fa-rocket:before{content:\"\\F135\"}.fa-maxcdn:before{content:\"\\F136\"}.fa-chevron-circle-left:before{content:\"\\F137\"}.fa-chevron-circle-right:before{content:\"\\F138\"}.fa-chevron-circle-up:before{content:\"\\F139\"}.fa-chevron-circle-down:before{content:\"\\F13A\"}.fa-html5:before{content:\"\\F13B\"}.fa-css3:before{content:\"\\F13C\"}.fa-anchor:before{content:\"\\F13D\"}.fa-unlock-alt:before{content:\"\\F13E\"}.fa-bullseye:before{content:\"\\F140\"}.fa-ellipsis-h:before{content:\"\\F141\"}.fa-ellipsis-v:before{content:\"\\F142\"}.fa-rss-square:before{content:\"\\F143\"}.fa-play-circle:before{content:\"\\F144\"}.fa-ticket:before{content:\"\\F145\"}.fa-minus-square:before{content:\"\\F146\"}.fa-minus-square-o:before{content:\"\\F147\"}.fa-level-up:before{content:\"\\F148\"}.fa-level-down:before{content:\"\\F149\"}.fa-check-square:before{content:\"\\F14A\"}.fa-pencil-square:before{content:\"\\F14B\"}.fa-external-link-square:before{content:\"\\F14C\"}.fa-share-square:before{content:\"\\F14D\"}.fa-compass:before{content:\"\\F14E\"}.fa-caret-square-o-down:before,.fa-toggle-down:before{content:\"\\F150\"}.fa-caret-square-o-up:before,.fa-toggle-up:before{content:\"\\F151\"}.fa-caret-square-o-right:before,.fa-toggle-right:before{content:\"\\F152\"}.fa-eur:before,.fa-euro:before{content:\"\\F153\"}.fa-gbp:before{content:\"\\F154\"}.fa-dollar:before,.fa-usd:before{content:\"\\F155\"}.fa-inr:before,.fa-rupee:before{content:\"\\F156\"}.fa-cny:before,.fa-jpy:before,.fa-rmb:before,.fa-yen:before{content:\"\\F157\"}.fa-rouble:before,.fa-rub:before,.fa-ruble:before{content:\"\\F158\"}.fa-krw:before,.fa-won:before{content:\"\\F159\"}.fa-bitcoin:before,.fa-btc:before{content:\"\\F15A\"}.fa-file:before{content:\"\\F15B\"}.fa-file-text:before{content:\"\\F15C\"}.fa-sort-alpha-asc:before{content:\"\\F15D\"}.fa-sort-alpha-desc:before{content:\"\\F15E\"}.fa-sort-amount-asc:before{content:\"\\F160\"}.fa-sort-amount-desc:before{content:\"\\F161\"}.fa-sort-numeric-asc:before{content:\"\\F162\"}.fa-sort-numeric-desc:before{content:\"\\F163\"}.fa-thumbs-up:before{content:\"\\F164\"}.fa-thumbs-down:before{content:\"\\F165\"}.fa-youtube-square:before{content:\"\\F166\"}.fa-youtube:before{content:\"\\F167\"}.fa-xing:before{content:\"\\F168\"}.fa-xing-square:before{content:\"\\F169\"}.fa-youtube-play:before{content:\"\\F16A\"}.fa-dropbox:before{content:\"\\F16B\"}.fa-stack-overflow:before{content:\"\\F16C\"}.fa-instagram:before{content:\"\\F16D\"}.fa-flickr:before{content:\"\\F16E\"}.fa-adn:before{content:\"\\F170\"}.fa-bitbucket:before{content:\"\\F171\"}.fa-bitbucket-square:before{content:\"\\F172\"}.fa-tumblr:before{content:\"\\F173\"}.fa-tumblr-square:before{content:\"\\F174\"}.fa-long-arrow-down:before{content:\"\\F175\"}.fa-long-arrow-up:before{content:\"\\F176\"}.fa-long-arrow-left:before{content:\"\\F177\"}.fa-long-arrow-right:before{content:\"\\F178\"}.fa-apple:before{content:\"\\F179\"}.fa-windows:before{content:\"\\F17A\"}.fa-android:before{content:\"\\F17B\"}.fa-linux:before{content:\"\\F17C\"}.fa-dribbble:before{content:\"\\F17D\"}.fa-skype:before{content:\"\\F17E\"}.fa-foursquare:before{content:\"\\F180\"}.fa-trello:before{content:\"\\F181\"}.fa-female:before{content:\"\\F182\"}.fa-male:before{content:\"\\F183\"}.fa-gittip:before,.fa-gratipay:before{content:\"\\F184\"}.fa-sun-o:before{content:\"\\F185\"}.fa-moon-o:before{content:\"\\F186\"}.fa-archive:before{content:\"\\F187\"}.fa-bug:before{content:\"\\F188\"}.fa-vk:before{content:\"\\F189\"}.fa-weibo:before{content:\"\\F18A\"}.fa-renren:before{content:\"\\F18B\"}.fa-pagelines:before{content:\"\\F18C\"}.fa-stack-exchange:before{content:\"\\F18D\"}.fa-arrow-circle-o-right:before{content:\"\\F18E\"}.fa-arrow-circle-o-left:before{content:\"\\F190\"}.fa-caret-square-o-left:before,.fa-toggle-left:before{content:\"\\F191\"}.fa-dot-circle-o:before{content:\"\\F192\"}.fa-wheelchair:before{content:\"\\F193\"}.fa-vimeo-square:before{content:\"\\F194\"}.fa-try:before,.fa-turkish-lira:before{content:\"\\F195\"}.fa-plus-square-o:before{content:\"\\F196\"}.fa-space-shuttle:before{content:\"\\F197\"}.fa-slack:before{content:\"\\F198\"}.fa-envelope-square:before{content:\"\\F199\"}.fa-wordpress:before{content:\"\\F19A\"}.fa-openid:before{content:\"\\F19B\"}.fa-bank:before,.fa-institution:before,.fa-university:before{content:\"\\F19C\"}.fa-graduation-cap:before,.fa-mortar-board:before{content:\"\\F19D\"}.fa-yahoo:before{content:\"\\F19E\"}.fa-google:before{content:\"\\F1A0\"}.fa-reddit:before{content:\"\\F1A1\"}.fa-reddit-square:before{content:\"\\F1A2\"}.fa-stumbleupon-circle:before{content:\"\\F1A3\"}.fa-stumbleupon:before{content:\"\\F1A4\"}.fa-delicious:before{content:\"\\F1A5\"}.fa-digg:before{content:\"\\F1A6\"}.fa-pied-piper-pp:before{content:\"\\F1A7\"}.fa-pied-piper-alt:before{content:\"\\F1A8\"}.fa-drupal:before{content:\"\\F1A9\"}.fa-joomla:before{content:\"\\F1AA\"}.fa-language:before{content:\"\\F1AB\"}.fa-fax:before{content:\"\\F1AC\"}.fa-building:before{content:\"\\F1AD\"}.fa-child:before{content:\"\\F1AE\"}.fa-paw:before{content:\"\\F1B0\"}.fa-spoon:before{content:\"\\F1B1\"}.fa-cube:before{content:\"\\F1B2\"}.fa-cubes:before{content:\"\\F1B3\"}.fa-behance:before{content:\"\\F1B4\"}.fa-behance-square:before{content:\"\\F1B5\"}.fa-steam:before{content:\"\\F1B6\"}.fa-steam-square:before{content:\"\\F1B7\"}.fa-recycle:before{content:\"\\F1B8\"}.fa-automobile:before,.fa-car:before{content:\"\\F1B9\"}.fa-cab:before,.fa-taxi:before{content:\"\\F1BA\"}.fa-tree:before{content:\"\\F1BB\"}.fa-spotify:before{content:\"\\F1BC\"}.fa-deviantart:before{content:\"\\F1BD\"}.fa-soundcloud:before{content:\"\\F1BE\"}.fa-database:before{content:\"\\F1C0\"}.fa-file-pdf-o:before{content:\"\\F1C1\"}.fa-file-word-o:before{content:\"\\F1C2\"}.fa-file-excel-o:before{content:\"\\F1C3\"}.fa-file-powerpoint-o:before{content:\"\\F1C4\"}.fa-file-image-o:before,.fa-file-photo-o:before,.fa-file-picture-o:before{content:\"\\F1C5\"}.fa-file-archive-o:before,.fa-file-zip-o:before{content:\"\\F1C6\"}.fa-file-audio-o:before,.fa-file-sound-o:before{content:\"\\F1C7\"}.fa-file-movie-o:before,.fa-file-video-o:before{content:\"\\F1C8\"}.fa-file-code-o:before{content:\"\\F1C9\"}.fa-vine:before{content:\"\\F1CA\"}.fa-codepen:before{content:\"\\F1CB\"}.fa-jsfiddle:before{content:\"\\F1CC\"}.fa-life-bouy:before,.fa-life-buoy:before,.fa-life-ring:before,.fa-life-saver:before,.fa-support:before{content:\"\\F1CD\"}.fa-circle-o-notch:before{content:\"\\F1CE\"}.fa-ra:before,.fa-rebel:before,.fa-resistance:before{content:\"\\F1D0\"}.fa-empire:before,.fa-ge:before{content:\"\\F1D1\"}.fa-git-square:before{content:\"\\F1D2\"}.fa-git:before{content:\"\\F1D3\"}.fa-hacker-news:before,.fa-y-combinator-square:before,.fa-yc-square:before{content:\"\\F1D4\"}.fa-tencent-weibo:before{content:\"\\F1D5\"}.fa-qq:before{content:\"\\F1D6\"}.fa-wechat:before,.fa-weixin:before{content:\"\\F1D7\"}.fa-paper-plane:before,.fa-send:before{content:\"\\F1D8\"}.fa-paper-plane-o:before,.fa-send-o:before{content:\"\\F1D9\"}.fa-history:before{content:\"\\F1DA\"}.fa-circle-thin:before{content:\"\\F1DB\"}.fa-header:before{content:\"\\F1DC\"}.fa-paragraph:before{content:\"\\F1DD\"}.fa-sliders:before{content:\"\\F1DE\"}.fa-share-alt:before{content:\"\\F1E0\"}.fa-share-alt-square:before{content:\"\\F1E1\"}.fa-bomb:before{content:\"\\F1E2\"}.fa-futbol-o:before,.fa-soccer-ball-o:before{content:\"\\F1E3\"}.fa-tty:before{content:\"\\F1E4\"}.fa-binoculars:before{content:\"\\F1E5\"}.fa-plug:before{content:\"\\F1E6\"}.fa-slideshare:before{content:\"\\F1E7\"}.fa-twitch:before{content:\"\\F1E8\"}.fa-yelp:before{content:\"\\F1E9\"}.fa-newspaper-o:before{content:\"\\F1EA\"}.fa-wifi:before{content:\"\\F1EB\"}.fa-calculator:before{content:\"\\F1EC\"}.fa-paypal:before{content:\"\\F1ED\"}.fa-google-wallet:before{content:\"\\F1EE\"}.fa-cc-visa:before{content:\"\\F1F0\"}.fa-cc-mastercard:before{content:\"\\F1F1\"}.fa-cc-discover:before{content:\"\\F1F2\"}.fa-cc-amex:before{content:\"\\F1F3\"}.fa-cc-paypal:before{content:\"\\F1F4\"}.fa-cc-stripe:before{content:\"\\F1F5\"}.fa-bell-slash:before{content:\"\\F1F6\"}.fa-bell-slash-o:before{content:\"\\F1F7\"}.fa-trash:before{content:\"\\F1F8\"}.fa-copyright:before{content:\"\\F1F9\"}.fa-at:before{content:\"\\F1FA\"}.fa-eyedropper:before{content:\"\\F1FB\"}.fa-paint-brush:before{content:\"\\F1FC\"}.fa-birthday-cake:before{content:\"\\F1FD\"}.fa-area-chart:before{content:\"\\F1FE\"}.fa-pie-chart:before{content:\"\\F200\"}.fa-line-chart:before{content:\"\\F201\"}.fa-lastfm:before{content:\"\\F202\"}.fa-lastfm-square:before{content:\"\\F203\"}.fa-toggle-off:before{content:\"\\F204\"}.fa-toggle-on:before{content:\"\\F205\"}.fa-bicycle:before{content:\"\\F206\"}.fa-bus:before{content:\"\\F207\"}.fa-ioxhost:before{content:\"\\F208\"}.fa-angellist:before{content:\"\\F209\"}.fa-cc:before{content:\"\\F20A\"}.fa-ils:before,.fa-shekel:before,.fa-sheqel:before{content:\"\\F20B\"}.fa-meanpath:before{content:\"\\F20C\"}.fa-buysellads:before{content:\"\\F20D\"}.fa-connectdevelop:before{content:\"\\F20E\"}.fa-dashcube:before{content:\"\\F210\"}.fa-forumbee:before{content:\"\\F211\"}.fa-leanpub:before{content:\"\\F212\"}.fa-sellsy:before{content:\"\\F213\"}.fa-shirtsinbulk:before{content:\"\\F214\"}.fa-simplybuilt:before{content:\"\\F215\"}.fa-skyatlas:before{content:\"\\F216\"}.fa-cart-plus:before{content:\"\\F217\"}.fa-cart-arrow-down:before{content:\"\\F218\"}.fa-diamond:before{content:\"\\F219\"}.fa-ship:before{content:\"\\F21A\"}.fa-user-secret:before{content:\"\\F21B\"}.fa-motorcycle:before{content:\"\\F21C\"}.fa-street-view:before{content:\"\\F21D\"}.fa-heartbeat:before{content:\"\\F21E\"}.fa-venus:before{content:\"\\F221\"}.fa-mars:before{content:\"\\F222\"}.fa-mercury:before{content:\"\\F223\"}.fa-intersex:before,.fa-transgender:before{content:\"\\F224\"}.fa-transgender-alt:before{content:\"\\F225\"}.fa-venus-double:before{content:\"\\F226\"}.fa-mars-double:before{content:\"\\F227\"}.fa-venus-mars:before{content:\"\\F228\"}.fa-mars-stroke:before{content:\"\\F229\"}.fa-mars-stroke-v:before{content:\"\\F22A\"}.fa-mars-stroke-h:before{content:\"\\F22B\"}.fa-neuter:before{content:\"\\F22C\"}.fa-genderless:before{content:\"\\F22D\"}.fa-facebook-official:before{content:\"\\F230\"}.fa-pinterest-p:before{content:\"\\F231\"}.fa-whatsapp:before{content:\"\\F232\"}.fa-server:before{content:\"\\F233\"}.fa-user-plus:before{content:\"\\F234\"}.fa-user-times:before{content:\"\\F235\"}.fa-bed:before,.fa-hotel:before{content:\"\\F236\"}.fa-viacoin:before{content:\"\\F237\"}.fa-train:before{content:\"\\F238\"}.fa-subway:before{content:\"\\F239\"}.fa-medium:before{content:\"\\F23A\"}.fa-y-combinator:before,.fa-yc:before{content:\"\\F23B\"}.fa-optin-monster:before{content:\"\\F23C\"}.fa-opencart:before{content:\"\\F23D\"}.fa-expeditedssl:before{content:\"\\F23E\"}.fa-battery-4:before,.fa-battery-full:before,.fa-battery:before{content:\"\\F240\"}.fa-battery-3:before,.fa-battery-three-quarters:before{content:\"\\F241\"}.fa-battery-2:before,.fa-battery-half:before{content:\"\\F242\"}.fa-battery-1:before,.fa-battery-quarter:before{content:\"\\F243\"}.fa-battery-0:before,.fa-battery-empty:before{content:\"\\F244\"}.fa-mouse-pointer:before{content:\"\\F245\"}.fa-i-cursor:before{content:\"\\F246\"}.fa-object-group:before{content:\"\\F247\"}.fa-object-ungroup:before{content:\"\\F248\"}.fa-sticky-note:before{content:\"\\F249\"}.fa-sticky-note-o:before{content:\"\\F24A\"}.fa-cc-jcb:before{content:\"\\F24B\"}.fa-cc-diners-club:before{content:\"\\F24C\"}.fa-clone:before{content:\"\\F24D\"}.fa-balance-scale:before{content:\"\\F24E\"}.fa-hourglass-o:before{content:\"\\F250\"}.fa-hourglass-1:before,.fa-hourglass-start:before{content:\"\\F251\"}.fa-hourglass-2:before,.fa-hourglass-half:before{content:\"\\F252\"}.fa-hourglass-3:before,.fa-hourglass-end:before{content:\"\\F253\"}.fa-hourglass:before{content:\"\\F254\"}.fa-hand-grab-o:before,.fa-hand-rock-o:before{content:\"\\F255\"}.fa-hand-paper-o:before,.fa-hand-stop-o:before{content:\"\\F256\"}.fa-hand-scissors-o:before{content:\"\\F257\"}.fa-hand-lizard-o:before{content:\"\\F258\"}.fa-hand-spock-o:before{content:\"\\F259\"}.fa-hand-pointer-o:before{content:\"\\F25A\"}.fa-hand-peace-o:before{content:\"\\F25B\"}.fa-trademark:before{content:\"\\F25C\"}.fa-registered:before{content:\"\\F25D\"}.fa-creative-commons:before{content:\"\\F25E\"}.fa-gg:before{content:\"\\F260\"}.fa-gg-circle:before{content:\"\\F261\"}.fa-tripadvisor:before{content:\"\\F262\"}.fa-odnoklassniki:before{content:\"\\F263\"}.fa-odnoklassniki-square:before{content:\"\\F264\"}.fa-get-pocket:before{content:\"\\F265\"}.fa-wikipedia-w:before{content:\"\\F266\"}.fa-safari:before{content:\"\\F267\"}.fa-chrome:before{content:\"\\F268\"}.fa-firefox:before{content:\"\\F269\"}.fa-opera:before{content:\"\\F26A\"}.fa-internet-explorer:before{content:\"\\F26B\"}.fa-television:before,.fa-tv:before{content:\"\\F26C\"}.fa-contao:before{content:\"\\F26D\"}.fa-500px:before{content:\"\\F26E\"}.fa-amazon:before{content:\"\\F270\"}.fa-calendar-plus-o:before{content:\"\\F271\"}.fa-calendar-minus-o:before{content:\"\\F272\"}.fa-calendar-times-o:before{content:\"\\F273\"}.fa-calendar-check-o:before{content:\"\\F274\"}.fa-industry:before{content:\"\\F275\"}.fa-map-pin:before{content:\"\\F276\"}.fa-map-signs:before{content:\"\\F277\"}.fa-map-o:before{content:\"\\F278\"}.fa-map:before{content:\"\\F279\"}.fa-commenting:before{content:\"\\F27A\"}.fa-commenting-o:before{content:\"\\F27B\"}.fa-houzz:before{content:\"\\F27C\"}.fa-vimeo:before{content:\"\\F27D\"}.fa-black-tie:before{content:\"\\F27E\"}.fa-fonticons:before{content:\"\\F280\"}.fa-reddit-alien:before{content:\"\\F281\"}.fa-edge:before{content:\"\\F282\"}.fa-credit-card-alt:before{content:\"\\F283\"}.fa-codiepie:before{content:\"\\F284\"}.fa-modx:before{content:\"\\F285\"}.fa-fort-awesome:before{content:\"\\F286\"}.fa-usb:before{content:\"\\F287\"}.fa-product-hunt:before{content:\"\\F288\"}.fa-mixcloud:before{content:\"\\F289\"}.fa-scribd:before{content:\"\\F28A\"}.fa-pause-circle:before{content:\"\\F28B\"}.fa-pause-circle-o:before{content:\"\\F28C\"}.fa-stop-circle:before{content:\"\\F28D\"}.fa-stop-circle-o:before{content:\"\\F28E\"}.fa-shopping-bag:before{content:\"\\F290\"}.fa-shopping-basket:before{content:\"\\F291\"}.fa-hashtag:before{content:\"\\F292\"}.fa-bluetooth:before{content:\"\\F293\"}.fa-bluetooth-b:before{content:\"\\F294\"}.fa-percent:before{content:\"\\F295\"}.fa-gitlab:before{content:\"\\F296\"}.fa-wpbeginner:before{content:\"\\F297\"}.fa-wpforms:before{content:\"\\F298\"}.fa-envira:before{content:\"\\F299\"}.fa-universal-access:before{content:\"\\F29A\"}.fa-wheelchair-alt:before{content:\"\\F29B\"}.fa-question-circle-o:before{content:\"\\F29C\"}.fa-blind:before{content:\"\\F29D\"}.fa-audio-description:before{content:\"\\F29E\"}.fa-volume-control-phone:before{content:\"\\F2A0\"}.fa-braille:before{content:\"\\F2A1\"}.fa-assistive-listening-systems:before{content:\"\\F2A2\"}.fa-american-sign-language-interpreting:before,.fa-asl-interpreting:before{content:\"\\F2A3\"}.fa-deaf:before,.fa-deafness:before,.fa-hard-of-hearing:before{content:\"\\F2A4\"}.fa-glide:before{content:\"\\F2A5\"}.fa-glide-g:before{content:\"\\F2A6\"}.fa-sign-language:before,.fa-signing:before{content:\"\\F2A7\"}.fa-low-vision:before{content:\"\\F2A8\"}.fa-viadeo:before{content:\"\\F2A9\"}.fa-viadeo-square:before{content:\"\\F2AA\"}.fa-snapchat:before{content:\"\\F2AB\"}.fa-snapchat-ghost:before{content:\"\\F2AC\"}.fa-snapchat-square:before{content:\"\\F2AD\"}.fa-pied-piper:before{content:\"\\F2AE\"}.fa-first-order:before{content:\"\\F2B0\"}.fa-yoast:before{content:\"\\F2B1\"}.fa-themeisle:before{content:\"\\F2B2\"}.fa-google-plus-circle:before,.fa-google-plus-official:before{content:\"\\F2B3\"}.fa-fa:before,.fa-font-awesome:before{content:\"\\F2B4\"}.fa-handshake-o:before{content:\"\\F2B5\"}.fa-envelope-open:before{content:\"\\F2B6\"}.fa-envelope-open-o:before{content:\"\\F2B7\"}.fa-linode:before{content:\"\\F2B8\"}.fa-address-book:before{content:\"\\F2B9\"}.fa-address-book-o:before{content:\"\\F2BA\"}.fa-address-card:before,.fa-vcard:before{content:\"\\F2BB\"}.fa-address-card-o:before,.fa-vcard-o:before{content:\"\\F2BC\"}.fa-user-circle:before{content:\"\\F2BD\"}.fa-user-circle-o:before{content:\"\\F2BE\"}.fa-user-o:before{content:\"\\F2C0\"}.fa-id-badge:before{content:\"\\F2C1\"}.fa-drivers-license:before,.fa-id-card:before{content:\"\\F2C2\"}.fa-drivers-license-o:before,.fa-id-card-o:before{content:\"\\F2C3\"}.fa-quora:before{content:\"\\F2C4\"}.fa-free-code-camp:before{content:\"\\F2C5\"}.fa-telegram:before{content:\"\\F2C6\"}.fa-thermometer-4:before,.fa-thermometer-full:before,.fa-thermometer:before{content:\"\\F2C7\"}.fa-thermometer-3:before,.fa-thermometer-three-quarters:before{content:\"\\F2C8\"}.fa-thermometer-2:before,.fa-thermometer-half:before{content:\"\\F2C9\"}.fa-thermometer-1:before,.fa-thermometer-quarter:before{content:\"\\F2CA\"}.fa-thermometer-0:before,.fa-thermometer-empty:before{content:\"\\F2CB\"}.fa-shower:before{content:\"\\F2CC\"}.fa-bath:before,.fa-bathtub:before,.fa-s15:before{content:\"\\F2CD\"}.fa-podcast:before{content:\"\\F2CE\"}.fa-window-maximize:before{content:\"\\F2D0\"}.fa-window-minimize:before{content:\"\\F2D1\"}.fa-window-restore:before{content:\"\\F2D2\"}.fa-times-rectangle:before,.fa-window-close:before{content:\"\\F2D3\"}.fa-times-rectangle-o:before,.fa-window-close-o:before{content:\"\\F2D4\"}.fa-bandcamp:before{content:\"\\F2D5\"}.fa-grav:before{content:\"\\F2D6\"}.fa-etsy:before{content:\"\\F2D7\"}.fa-imdb:before{content:\"\\F2D8\"}.fa-ravelry:before{content:\"\\F2D9\"}.fa-eercast:before{content:\"\\F2DA\"}.fa-microchip:before{content:\"\\F2DB\"}.fa-snowflake-o:before{content:\"\\F2DC\"}.fa-superpowers:before{content:\"\\F2DD\"}.fa-wpexplorer:before{content:\"\\F2DE\"}.fa-meetup:before{content:\"\\F2E0\"}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}.browserupgrade{margin:.2em 0;background:#ccc;color:#000;padding:.2em 0}.container-full{padding-left:20px;padding-right:20px}.trash{color:#d15b47}.user-list li{display:flex;border:none;border-bottom:1px solid #d3d3d3;margin-bottom:0}.user-list li:last-child{border-bottom:none}.user-list li .user-info{flex-grow:1}.user-list li .trash{display:flex;align-items:center;text-decoration:none}.error-msg{color:red}.waring-msg{color:coral}.appstore .app-icon{width:60px!important;height:60px!important;margin-right:10px}.appstore .app-banner{max-width:600px!important}.appstore .thumbnail{padding:10px!important}.appstore .app-detail{margin-top:20px;margin-bottom:20px}.appstore .caption{background:#fff;height:120px}.margin-r-10,.margin-right-10{margin-right:10px}.book-list .media-object,.table-list-cover{width:100px;height:auto}.img-item{text-align:center}.check-list{list-style:none;padding:5px}.check-list li{padding:5px;display:inline-block;float:left}.ctrl-td,.ctrl-th{width:150px!important}.betagroup-list{list-style:none;padding:5px}.betagroup-list li{padding:5px;display:inline-block;float:left}.pagination,.pagination-div{text-align:center}.lang-input{padding:5px 20px}.lang-add{margin-left:20px}.thumbnail-img{widows:250px!important;height:340px!important}.truncate{width:220px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}footer.footer{text-align:center;padding:30px 0;margin-top:70px;border-top:1px solid #e5e5e5}.modal-danger .modal-header,.modal-info .modal-header,.modal-primary .modal-header,.modal-success .modal-header,.modal-warning .modal-header{color:#fff;border-radius:5px 5px 0 0}.modal-primary .modal-header{background:#337ab7}.modal-info .modal-header{background:#5bc0de}.modal-success .modal-header{background:#5cb85c}.modal-warning .modal-header{background:#f0ad4e}.modal-danger .modal-header{background:#d9534f}", ""]);
	
	// exports


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/*!
	 * Bootstrap v3.3.7 (http://getbootstrap.com)
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under the MIT license
	 */
	
	if (typeof jQuery === 'undefined') {
	  throw new Error('Bootstrap\'s JavaScript requires jQuery')
	}
	
	+function ($) {
	  'use strict';
	  var version = $.fn.jquery.split(' ')[0].split('.')
	  if ((version[0] < 2 && version[1] < 9) || (version[0] == 1 && version[1] == 9 && version[2] < 1) || (version[0] > 3)) {
	    throw new Error('Bootstrap\'s JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4')
	  }
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: transition.js v3.3.7
	 * http://getbootstrap.com/javascript/#transitions
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
	  // ============================================================
	
	  function transitionEnd() {
	    var el = document.createElement('bootstrap')
	
	    var transEndEventNames = {
	      WebkitTransition : 'webkitTransitionEnd',
	      MozTransition    : 'transitionend',
	      OTransition      : 'oTransitionEnd otransitionend',
	      transition       : 'transitionend'
	    }
	
	    for (var name in transEndEventNames) {
	      if (el.style[name] !== undefined) {
	        return { end: transEndEventNames[name] }
	      }
	    }
	
	    return false // explicit for ie8 (  ._.)
	  }
	
	  // http://blog.alexmaccaw.com/css-transitions
	  $.fn.emulateTransitionEnd = function (duration) {
	    var called = false
	    var $el = this
	    $(this).one('bsTransitionEnd', function () { called = true })
	    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
	    setTimeout(callback, duration)
	    return this
	  }
	
	  $(function () {
	    $.support.transition = transitionEnd()
	
	    if (!$.support.transition) return
	
	    $.event.special.bsTransitionEnd = {
	      bindType: $.support.transition.end,
	      delegateType: $.support.transition.end,
	      handle: function (e) {
	        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
	      }
	    }
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: alert.js v3.3.7
	 * http://getbootstrap.com/javascript/#alerts
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // ALERT CLASS DEFINITION
	  // ======================
	
	  var dismiss = '[data-dismiss="alert"]'
	  var Alert   = function (el) {
	    $(el).on('click', dismiss, this.close)
	  }
	
	  Alert.VERSION = '3.3.7'
	
	  Alert.TRANSITION_DURATION = 150
	
	  Alert.prototype.close = function (e) {
	    var $this    = $(this)
	    var selector = $this.attr('data-target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    var $parent = $(selector === '#' ? [] : selector)
	
	    if (e) e.preventDefault()
	
	    if (!$parent.length) {
	      $parent = $this.closest('.alert')
	    }
	
	    $parent.trigger(e = $.Event('close.bs.alert'))
	
	    if (e.isDefaultPrevented()) return
	
	    $parent.removeClass('in')
	
	    function removeElement() {
	      // detach from parent, fire event then clean up data
	      $parent.detach().trigger('closed.bs.alert').remove()
	    }
	
	    $.support.transition && $parent.hasClass('fade') ?
	      $parent
	        .one('bsTransitionEnd', removeElement)
	        .emulateTransitionEnd(Alert.TRANSITION_DURATION) :
	      removeElement()
	  }
	
	
	  // ALERT PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.alert')
	
	      if (!data) $this.data('bs.alert', (data = new Alert(this)))
	      if (typeof option == 'string') data[option].call($this)
	    })
	  }
	
	  var old = $.fn.alert
	
	  $.fn.alert             = Plugin
	  $.fn.alert.Constructor = Alert
	
	
	  // ALERT NO CONFLICT
	  // =================
	
	  $.fn.alert.noConflict = function () {
	    $.fn.alert = old
	    return this
	  }
	
	
	  // ALERT DATA-API
	  // ==============
	
	  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close)
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: button.js v3.3.7
	 * http://getbootstrap.com/javascript/#buttons
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // BUTTON PUBLIC CLASS DEFINITION
	  // ==============================
	
	  var Button = function (element, options) {
	    this.$element  = $(element)
	    this.options   = $.extend({}, Button.DEFAULTS, options)
	    this.isLoading = false
	  }
	
	  Button.VERSION  = '3.3.7'
	
	  Button.DEFAULTS = {
	    loadingText: 'loading...'
	  }
	
	  Button.prototype.setState = function (state) {
	    var d    = 'disabled'
	    var $el  = this.$element
	    var val  = $el.is('input') ? 'val' : 'html'
	    var data = $el.data()
	
	    state += 'Text'
	
	    if (data.resetText == null) $el.data('resetText', $el[val]())
	
	    // push to event loop to allow forms to submit
	    setTimeout($.proxy(function () {
	      $el[val](data[state] == null ? this.options[state] : data[state])
	
	      if (state == 'loadingText') {
	        this.isLoading = true
	        $el.addClass(d).attr(d, d).prop(d, true)
	      } else if (this.isLoading) {
	        this.isLoading = false
	        $el.removeClass(d).removeAttr(d).prop(d, false)
	      }
	    }, this), 0)
	  }
	
	  Button.prototype.toggle = function () {
	    var changed = true
	    var $parent = this.$element.closest('[data-toggle="buttons"]')
	
	    if ($parent.length) {
	      var $input = this.$element.find('input')
	      if ($input.prop('type') == 'radio') {
	        if ($input.prop('checked')) changed = false
	        $parent.find('.active').removeClass('active')
	        this.$element.addClass('active')
	      } else if ($input.prop('type') == 'checkbox') {
	        if (($input.prop('checked')) !== this.$element.hasClass('active')) changed = false
	        this.$element.toggleClass('active')
	      }
	      $input.prop('checked', this.$element.hasClass('active'))
	      if (changed) $input.trigger('change')
	    } else {
	      this.$element.attr('aria-pressed', !this.$element.hasClass('active'))
	      this.$element.toggleClass('active')
	    }
	  }
	
	
	  // BUTTON PLUGIN DEFINITION
	  // ========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.button')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.button', (data = new Button(this, options)))
	
	      if (option == 'toggle') data.toggle()
	      else if (option) data.setState(option)
	    })
	  }
	
	  var old = $.fn.button
	
	  $.fn.button             = Plugin
	  $.fn.button.Constructor = Button
	
	
	  // BUTTON NO CONFLICT
	  // ==================
	
	  $.fn.button.noConflict = function () {
	    $.fn.button = old
	    return this
	  }
	
	
	  // BUTTON DATA-API
	  // ===============
	
	  $(document)
	    .on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	      var $btn = $(e.target).closest('.btn')
	      Plugin.call($btn, 'toggle')
	      if (!($(e.target).is('input[type="radio"], input[type="checkbox"]'))) {
	        // Prevent double click on radios, and the double selections (so cancellation) on checkboxes
	        e.preventDefault()
	        // The target component still receive the focus
	        if ($btn.is('input,button')) $btn.trigger('focus')
	        else $btn.find('input:visible,button:visible').first().trigger('focus')
	      }
	    })
	    .on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	      $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type))
	    })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: carousel.js v3.3.7
	 * http://getbootstrap.com/javascript/#carousel
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // CAROUSEL CLASS DEFINITION
	  // =========================
	
	  var Carousel = function (element, options) {
	    this.$element    = $(element)
	    this.$indicators = this.$element.find('.carousel-indicators')
	    this.options     = options
	    this.paused      = null
	    this.sliding     = null
	    this.interval    = null
	    this.$active     = null
	    this.$items      = null
	
	    this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this))
	
	    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element
	      .on('mouseenter.bs.carousel', $.proxy(this.pause, this))
	      .on('mouseleave.bs.carousel', $.proxy(this.cycle, this))
	  }
	
	  Carousel.VERSION  = '3.3.7'
	
	  Carousel.TRANSITION_DURATION = 600
	
	  Carousel.DEFAULTS = {
	    interval: 5000,
	    pause: 'hover',
	    wrap: true,
	    keyboard: true
	  }
	
	  Carousel.prototype.keydown = function (e) {
	    if (/input|textarea/i.test(e.target.tagName)) return
	    switch (e.which) {
	      case 37: this.prev(); break
	      case 39: this.next(); break
	      default: return
	    }
	
	    e.preventDefault()
	  }
	
	  Carousel.prototype.cycle = function (e) {
	    e || (this.paused = false)
	
	    this.interval && clearInterval(this.interval)
	
	    this.options.interval
	      && !this.paused
	      && (this.interval = setInterval($.proxy(this.next, this), this.options.interval))
	
	    return this
	  }
	
	  Carousel.prototype.getItemIndex = function (item) {
	    this.$items = item.parent().children('.item')
	    return this.$items.index(item || this.$active)
	  }
	
	  Carousel.prototype.getItemForDirection = function (direction, active) {
	    var activeIndex = this.getItemIndex(active)
	    var willWrap = (direction == 'prev' && activeIndex === 0)
	                || (direction == 'next' && activeIndex == (this.$items.length - 1))
	    if (willWrap && !this.options.wrap) return active
	    var delta = direction == 'prev' ? -1 : 1
	    var itemIndex = (activeIndex + delta) % this.$items.length
	    return this.$items.eq(itemIndex)
	  }
	
	  Carousel.prototype.to = function (pos) {
	    var that        = this
	    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'))
	
	    if (pos > (this.$items.length - 1) || pos < 0) return
	
	    if (this.sliding)       return this.$element.one('slid.bs.carousel', function () { that.to(pos) }) // yes, "slid"
	    if (activeIndex == pos) return this.pause().cycle()
	
	    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos))
	  }
	
	  Carousel.prototype.pause = function (e) {
	    e || (this.paused = true)
	
	    if (this.$element.find('.next, .prev').length && $.support.transition) {
	      this.$element.trigger($.support.transition.end)
	      this.cycle(true)
	    }
	
	    this.interval = clearInterval(this.interval)
	
	    return this
	  }
	
	  Carousel.prototype.next = function () {
	    if (this.sliding) return
	    return this.slide('next')
	  }
	
	  Carousel.prototype.prev = function () {
	    if (this.sliding) return
	    return this.slide('prev')
	  }
	
	  Carousel.prototype.slide = function (type, next) {
	    var $active   = this.$element.find('.item.active')
	    var $next     = next || this.getItemForDirection(type, $active)
	    var isCycling = this.interval
	    var direction = type == 'next' ? 'left' : 'right'
	    var that      = this
	
	    if ($next.hasClass('active')) return (this.sliding = false)
	
	    var relatedTarget = $next[0]
	    var slideEvent = $.Event('slide.bs.carousel', {
	      relatedTarget: relatedTarget,
	      direction: direction
	    })
	    this.$element.trigger(slideEvent)
	    if (slideEvent.isDefaultPrevented()) return
	
	    this.sliding = true
	
	    isCycling && this.pause()
	
	    if (this.$indicators.length) {
	      this.$indicators.find('.active').removeClass('active')
	      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)])
	      $nextIndicator && $nextIndicator.addClass('active')
	    }
	
	    var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction }) // yes, "slid"
	    if ($.support.transition && this.$element.hasClass('slide')) {
	      $next.addClass(type)
	      $next[0].offsetWidth // force reflow
	      $active.addClass(direction)
	      $next.addClass(direction)
	      $active
	        .one('bsTransitionEnd', function () {
	          $next.removeClass([type, direction].join(' ')).addClass('active')
	          $active.removeClass(['active', direction].join(' '))
	          that.sliding = false
	          setTimeout(function () {
	            that.$element.trigger(slidEvent)
	          }, 0)
	        })
	        .emulateTransitionEnd(Carousel.TRANSITION_DURATION)
	    } else {
	      $active.removeClass('active')
	      $next.addClass('active')
	      this.sliding = false
	      this.$element.trigger(slidEvent)
	    }
	
	    isCycling && this.cycle()
	
	    return this
	  }
	
	
	  // CAROUSEL PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.carousel')
	      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option == 'object' && option)
	      var action  = typeof option == 'string' ? option : options.slide
	
	      if (!data) $this.data('bs.carousel', (data = new Carousel(this, options)))
	      if (typeof option == 'number') data.to(option)
	      else if (action) data[action]()
	      else if (options.interval) data.pause().cycle()
	    })
	  }
	
	  var old = $.fn.carousel
	
	  $.fn.carousel             = Plugin
	  $.fn.carousel.Constructor = Carousel
	
	
	  // CAROUSEL NO CONFLICT
	  // ====================
	
	  $.fn.carousel.noConflict = function () {
	    $.fn.carousel = old
	    return this
	  }
	
	
	  // CAROUSEL DATA-API
	  // =================
	
	  var clickHandler = function (e) {
	    var href
	    var $this   = $(this)
	    var $target = $($this.attr('data-target') || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '')) // strip for ie7
	    if (!$target.hasClass('carousel')) return
	    var options = $.extend({}, $target.data(), $this.data())
	    var slideIndex = $this.attr('data-slide-to')
	    if (slideIndex) options.interval = false
	
	    Plugin.call($target, options)
	
	    if (slideIndex) {
	      $target.data('bs.carousel').to(slideIndex)
	    }
	
	    e.preventDefault()
	  }
	
	  $(document)
	    .on('click.bs.carousel.data-api', '[data-slide]', clickHandler)
	    .on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler)
	
	  $(window).on('load', function () {
	    $('[data-ride="carousel"]').each(function () {
	      var $carousel = $(this)
	      Plugin.call($carousel, $carousel.data())
	    })
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: collapse.js v3.3.7
	 * http://getbootstrap.com/javascript/#collapse
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	/* jshint latedef: false */
	
	+function ($) {
	  'use strict';
	
	  // COLLAPSE PUBLIC CLASS DEFINITION
	  // ================================
	
	  var Collapse = function (element, options) {
	    this.$element      = $(element)
	    this.options       = $.extend({}, Collapse.DEFAULTS, options)
	    this.$trigger      = $('[data-toggle="collapse"][href="#' + element.id + '"],' +
	                           '[data-toggle="collapse"][data-target="#' + element.id + '"]')
	    this.transitioning = null
	
	    if (this.options.parent) {
	      this.$parent = this.getParent()
	    } else {
	      this.addAriaAndCollapsedClass(this.$element, this.$trigger)
	    }
	
	    if (this.options.toggle) this.toggle()
	  }
	
	  Collapse.VERSION  = '3.3.7'
	
	  Collapse.TRANSITION_DURATION = 350
	
	  Collapse.DEFAULTS = {
	    toggle: true
	  }
	
	  Collapse.prototype.dimension = function () {
	    var hasWidth = this.$element.hasClass('width')
	    return hasWidth ? 'width' : 'height'
	  }
	
	  Collapse.prototype.show = function () {
	    if (this.transitioning || this.$element.hasClass('in')) return
	
	    var activesData
	    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing')
	
	    if (actives && actives.length) {
	      activesData = actives.data('bs.collapse')
	      if (activesData && activesData.transitioning) return
	    }
	
	    var startEvent = $.Event('show.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    if (actives && actives.length) {
	      Plugin.call(actives, 'hide')
	      activesData || actives.data('bs.collapse', null)
	    }
	
	    var dimension = this.dimension()
	
	    this.$element
	      .removeClass('collapse')
	      .addClass('collapsing')[dimension](0)
	      .attr('aria-expanded', true)
	
	    this.$trigger
	      .removeClass('collapsed')
	      .attr('aria-expanded', true)
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.$element
	        .removeClass('collapsing')
	        .addClass('collapse in')[dimension]('')
	      this.transitioning = 0
	      this.$element
	        .trigger('shown.bs.collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    var scrollSize = $.camelCase(['scroll', dimension].join('-'))
	
	    this.$element
	      .one('bsTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize])
	  }
	
	  Collapse.prototype.hide = function () {
	    if (this.transitioning || !this.$element.hasClass('in')) return
	
	    var startEvent = $.Event('hide.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    var dimension = this.dimension()
	
	    this.$element[dimension](this.$element[dimension]())[0].offsetHeight
	
	    this.$element
	      .addClass('collapsing')
	      .removeClass('collapse in')
	      .attr('aria-expanded', false)
	
	    this.$trigger
	      .addClass('collapsed')
	      .attr('aria-expanded', false)
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.transitioning = 0
	      this.$element
	        .removeClass('collapsing')
	        .addClass('collapse')
	        .trigger('hidden.bs.collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    this.$element
	      [dimension](0)
	      .one('bsTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)
	  }
	
	  Collapse.prototype.toggle = function () {
	    this[this.$element.hasClass('in') ? 'hide' : 'show']()
	  }
	
	  Collapse.prototype.getParent = function () {
	    return $(this.options.parent)
	      .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
	      .each($.proxy(function (i, element) {
	        var $element = $(element)
	        this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element)
	      }, this))
	      .end()
	  }
	
	  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
	    var isOpen = $element.hasClass('in')
	
	    $element.attr('aria-expanded', isOpen)
	    $trigger
	      .toggleClass('collapsed', !isOpen)
	      .attr('aria-expanded', isOpen)
	  }
	
	  function getTargetFromTrigger($trigger) {
	    var href
	    var target = $trigger.attr('data-target')
	      || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7
	
	    return $(target)
	  }
	
	
	  // COLLAPSE PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.collapse')
	      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
	      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false
	      if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.collapse
	
	  $.fn.collapse             = Plugin
	  $.fn.collapse.Constructor = Collapse
	
	
	  // COLLAPSE NO CONFLICT
	  // ====================
	
	  $.fn.collapse.noConflict = function () {
	    $.fn.collapse = old
	    return this
	  }
	
	
	  // COLLAPSE DATA-API
	  // =================
	
	  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
	    var $this   = $(this)
	
	    if (!$this.attr('data-target')) e.preventDefault()
	
	    var $target = getTargetFromTrigger($this)
	    var data    = $target.data('bs.collapse')
	    var option  = data ? 'toggle' : $this.data()
	
	    Plugin.call($target, option)
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: dropdown.js v3.3.7
	 * http://getbootstrap.com/javascript/#dropdowns
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // DROPDOWN CLASS DEFINITION
	  // =========================
	
	  var backdrop = '.dropdown-backdrop'
	  var toggle   = '[data-toggle="dropdown"]'
	  var Dropdown = function (element) {
	    $(element).on('click.bs.dropdown', this.toggle)
	  }
	
	  Dropdown.VERSION = '3.3.7'
	
	  function getParent($this) {
	    var selector = $this.attr('data-target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    var $parent = selector && $(selector)
	
	    return $parent && $parent.length ? $parent : $this.parent()
	  }
	
	  function clearMenus(e) {
	    if (e && e.which === 3) return
	    $(backdrop).remove()
	    $(toggle).each(function () {
	      var $this         = $(this)
	      var $parent       = getParent($this)
	      var relatedTarget = { relatedTarget: this }
	
	      if (!$parent.hasClass('open')) return
	
	      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return
	
	      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))
	
	      if (e.isDefaultPrevented()) return
	
	      $this.attr('aria-expanded', 'false')
	      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget))
	    })
	  }
	
	  Dropdown.prototype.toggle = function (e) {
	    var $this = $(this)
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    clearMenus()
	
	    if (!isActive) {
	      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
	        // if mobile we use a backdrop because click events don't delegate
	        $(document.createElement('div'))
	          .addClass('dropdown-backdrop')
	          .insertAfter($(this))
	          .on('click', clearMenus)
	      }
	
	      var relatedTarget = { relatedTarget: this }
	      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))
	
	      if (e.isDefaultPrevented()) return
	
	      $this
	        .trigger('focus')
	        .attr('aria-expanded', 'true')
	
	      $parent
	        .toggleClass('open')
	        .trigger($.Event('shown.bs.dropdown', relatedTarget))
	    }
	
	    return false
	  }
	
	  Dropdown.prototype.keydown = function (e) {
	    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return
	
	    var $this = $(this)
	
	    e.preventDefault()
	    e.stopPropagation()
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    if (!isActive && e.which != 27 || isActive && e.which == 27) {
	      if (e.which == 27) $parent.find(toggle).trigger('focus')
	      return $this.trigger('click')
	    }
	
	    var desc = ' li:not(.disabled):visible a'
	    var $items = $parent.find('.dropdown-menu' + desc)
	
	    if (!$items.length) return
	
	    var index = $items.index(e.target)
	
	    if (e.which == 38 && index > 0)                 index--         // up
	    if (e.which == 40 && index < $items.length - 1) index++         // down
	    if (!~index)                                    index = 0
	
	    $items.eq(index).trigger('focus')
	  }
	
	
	  // DROPDOWN PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.dropdown')
	
	      if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
	      if (typeof option == 'string') data[option].call($this)
	    })
	  }
	
	  var old = $.fn.dropdown
	
	  $.fn.dropdown             = Plugin
	  $.fn.dropdown.Constructor = Dropdown
	
	
	  // DROPDOWN NO CONFLICT
	  // ====================
	
	  $.fn.dropdown.noConflict = function () {
	    $.fn.dropdown = old
	    return this
	  }
	
	
	  // APPLY TO STANDARD DROPDOWN ELEMENTS
	  // ===================================
	
	  $(document)
	    .on('click.bs.dropdown.data-api', clearMenus)
	    .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
	    .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
	    .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
	    .on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown)
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: modal.js v3.3.7
	 * http://getbootstrap.com/javascript/#modals
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // MODAL CLASS DEFINITION
	  // ======================
	
	  var Modal = function (element, options) {
	    this.options             = options
	    this.$body               = $(document.body)
	    this.$element            = $(element)
	    this.$dialog             = this.$element.find('.modal-dialog')
	    this.$backdrop           = null
	    this.isShown             = null
	    this.originalBodyPad     = null
	    this.scrollbarWidth      = 0
	    this.ignoreBackdropClick = false
	
	    if (this.options.remote) {
	      this.$element
	        .find('.modal-content')
	        .load(this.options.remote, $.proxy(function () {
	          this.$element.trigger('loaded.bs.modal')
	        }, this))
	    }
	  }
	
	  Modal.VERSION  = '3.3.7'
	
	  Modal.TRANSITION_DURATION = 300
	  Modal.BACKDROP_TRANSITION_DURATION = 150
	
	  Modal.DEFAULTS = {
	    backdrop: true,
	    keyboard: true,
	    show: true
	  }
	
	  Modal.prototype.toggle = function (_relatedTarget) {
	    return this.isShown ? this.hide() : this.show(_relatedTarget)
	  }
	
	  Modal.prototype.show = function (_relatedTarget) {
	    var that = this
	    var e    = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })
	
	    this.$element.trigger(e)
	
	    if (this.isShown || e.isDefaultPrevented()) return
	
	    this.isShown = true
	
	    this.checkScrollbar()
	    this.setScrollbar()
	    this.$body.addClass('modal-open')
	
	    this.escape()
	    this.resize()
	
	    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))
	
	    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
	      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
	        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
	      })
	    })
	
	    this.backdrop(function () {
	      var transition = $.support.transition && that.$element.hasClass('fade')
	
	      if (!that.$element.parent().length) {
	        that.$element.appendTo(that.$body) // don't move modals dom position
	      }
	
	      that.$element
	        .show()
	        .scrollTop(0)
	
	      that.adjustDialog()
	
	      if (transition) {
	        that.$element[0].offsetWidth // force reflow
	      }
	
	      that.$element.addClass('in')
	
	      that.enforceFocus()
	
	      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })
	
	      transition ?
	        that.$dialog // wait for modal to slide in
	          .one('bsTransitionEnd', function () {
	            that.$element.trigger('focus').trigger(e)
	          })
	          .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
	        that.$element.trigger('focus').trigger(e)
	    })
	  }
	
	  Modal.prototype.hide = function (e) {
	    if (e) e.preventDefault()
	
	    e = $.Event('hide.bs.modal')
	
	    this.$element.trigger(e)
	
	    if (!this.isShown || e.isDefaultPrevented()) return
	
	    this.isShown = false
	
	    this.escape()
	    this.resize()
	
	    $(document).off('focusin.bs.modal')
	
	    this.$element
	      .removeClass('in')
	      .off('click.dismiss.bs.modal')
	      .off('mouseup.dismiss.bs.modal')
	
	    this.$dialog.off('mousedown.dismiss.bs.modal')
	
	    $.support.transition && this.$element.hasClass('fade') ?
	      this.$element
	        .one('bsTransitionEnd', $.proxy(this.hideModal, this))
	        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
	      this.hideModal()
	  }
	
	  Modal.prototype.enforceFocus = function () {
	    $(document)
	      .off('focusin.bs.modal') // guard against infinite focus loop
	      .on('focusin.bs.modal', $.proxy(function (e) {
	        if (document !== e.target &&
	            this.$element[0] !== e.target &&
	            !this.$element.has(e.target).length) {
	          this.$element.trigger('focus')
	        }
	      }, this))
	  }
	
	  Modal.prototype.escape = function () {
	    if (this.isShown && this.options.keyboard) {
	      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
	        e.which == 27 && this.hide()
	      }, this))
	    } else if (!this.isShown) {
	      this.$element.off('keydown.dismiss.bs.modal')
	    }
	  }
	
	  Modal.prototype.resize = function () {
	    if (this.isShown) {
	      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
	    } else {
	      $(window).off('resize.bs.modal')
	    }
	  }
	
	  Modal.prototype.hideModal = function () {
	    var that = this
	    this.$element.hide()
	    this.backdrop(function () {
	      that.$body.removeClass('modal-open')
	      that.resetAdjustments()
	      that.resetScrollbar()
	      that.$element.trigger('hidden.bs.modal')
	    })
	  }
	
	  Modal.prototype.removeBackdrop = function () {
	    this.$backdrop && this.$backdrop.remove()
	    this.$backdrop = null
	  }
	
	  Modal.prototype.backdrop = function (callback) {
	    var that = this
	    var animate = this.$element.hasClass('fade') ? 'fade' : ''
	
	    if (this.isShown && this.options.backdrop) {
	      var doAnimate = $.support.transition && animate
	
	      this.$backdrop = $(document.createElement('div'))
	        .addClass('modal-backdrop ' + animate)
	        .appendTo(this.$body)
	
	      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
	        if (this.ignoreBackdropClick) {
	          this.ignoreBackdropClick = false
	          return
	        }
	        if (e.target !== e.currentTarget) return
	        this.options.backdrop == 'static'
	          ? this.$element[0].focus()
	          : this.hide()
	      }, this))
	
	      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow
	
	      this.$backdrop.addClass('in')
	
	      if (!callback) return
	
	      doAnimate ?
	        this.$backdrop
	          .one('bsTransitionEnd', callback)
	          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
	        callback()
	
	    } else if (!this.isShown && this.$backdrop) {
	      this.$backdrop.removeClass('in')
	
	      var callbackRemove = function () {
	        that.removeBackdrop()
	        callback && callback()
	      }
	      $.support.transition && this.$element.hasClass('fade') ?
	        this.$backdrop
	          .one('bsTransitionEnd', callbackRemove)
	          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
	        callbackRemove()
	
	    } else if (callback) {
	      callback()
	    }
	  }
	
	  // these following methods are used to handle overflowing modals
	
	  Modal.prototype.handleUpdate = function () {
	    this.adjustDialog()
	  }
	
	  Modal.prototype.adjustDialog = function () {
	    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight
	
	    this.$element.css({
	      paddingLeft:  !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
	      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
	    })
	  }
	
	  Modal.prototype.resetAdjustments = function () {
	    this.$element.css({
	      paddingLeft: '',
	      paddingRight: ''
	    })
	  }
	
	  Modal.prototype.checkScrollbar = function () {
	    var fullWindowWidth = window.innerWidth
	    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
	      var documentElementRect = document.documentElement.getBoundingClientRect()
	      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
	    }
	    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
	    this.scrollbarWidth = this.measureScrollbar()
	  }
	
	  Modal.prototype.setScrollbar = function () {
	    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
	    this.originalBodyPad = document.body.style.paddingRight || ''
	    if (this.bodyIsOverflowing) this.$body.css('padding-right', bodyPad + this.scrollbarWidth)
	  }
	
	  Modal.prototype.resetScrollbar = function () {
	    this.$body.css('padding-right', this.originalBodyPad)
	  }
	
	  Modal.prototype.measureScrollbar = function () { // thx walsh
	    var scrollDiv = document.createElement('div')
	    scrollDiv.className = 'modal-scrollbar-measure'
	    this.$body.append(scrollDiv)
	    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
	    this.$body[0].removeChild(scrollDiv)
	    return scrollbarWidth
	  }
	
	
	  // MODAL PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option, _relatedTarget) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.modal')
	      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
	      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
	      if (typeof option == 'string') data[option](_relatedTarget)
	      else if (options.show) data.show(_relatedTarget)
	    })
	  }
	
	  var old = $.fn.modal
	
	  $.fn.modal             = Plugin
	  $.fn.modal.Constructor = Modal
	
	
	  // MODAL NO CONFLICT
	  // =================
	
	  $.fn.modal.noConflict = function () {
	    $.fn.modal = old
	    return this
	  }
	
	
	  // MODAL DATA-API
	  // ==============
	
	  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
	    var $this   = $(this)
	    var href    = $this.attr('href')
	    var $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, ''))) // strip for ie7
	    var option  = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())
	
	    if ($this.is('a')) e.preventDefault()
	
	    $target.one('show.bs.modal', function (showEvent) {
	      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
	      $target.one('hidden.bs.modal', function () {
	        $this.is(':visible') && $this.trigger('focus')
	      })
	    })
	    Plugin.call($target, option, this)
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: tooltip.js v3.3.7
	 * http://getbootstrap.com/javascript/#tooltip
	 * Inspired by the original jQuery.tipsy by Jason Frame
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // TOOLTIP PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Tooltip = function (element, options) {
	    this.type       = null
	    this.options    = null
	    this.enabled    = null
	    this.timeout    = null
	    this.hoverState = null
	    this.$element   = null
	    this.inState    = null
	
	    this.init('tooltip', element, options)
	  }
	
	  Tooltip.VERSION  = '3.3.7'
	
	  Tooltip.TRANSITION_DURATION = 150
	
	  Tooltip.DEFAULTS = {
	    animation: true,
	    placement: 'top',
	    selector: false,
	    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
	    trigger: 'hover focus',
	    title: '',
	    delay: 0,
	    html: false,
	    container: false,
	    viewport: {
	      selector: 'body',
	      padding: 0
	    }
	  }
	
	  Tooltip.prototype.init = function (type, element, options) {
	    this.enabled   = true
	    this.type      = type
	    this.$element  = $(element)
	    this.options   = this.getOptions(options)
	    this.$viewport = this.options.viewport && $($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : (this.options.viewport.selector || this.options.viewport))
	    this.inState   = { click: false, hover: false, focus: false }
	
	    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
	      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!')
	    }
	
	    var triggers = this.options.trigger.split(' ')
	
	    for (var i = triggers.length; i--;) {
	      var trigger = triggers[i]
	
	      if (trigger == 'click') {
	        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
	      } else if (trigger != 'manual') {
	        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
	        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'
	
	        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
	        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
	      }
	    }
	
	    this.options.selector ?
	      (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
	      this.fixTitle()
	  }
	
	  Tooltip.prototype.getDefaults = function () {
	    return Tooltip.DEFAULTS
	  }
	
	  Tooltip.prototype.getOptions = function (options) {
	    options = $.extend({}, this.getDefaults(), this.$element.data(), options)
	
	    if (options.delay && typeof options.delay == 'number') {
	      options.delay = {
	        show: options.delay,
	        hide: options.delay
	      }
	    }
	
	    return options
	  }
	
	  Tooltip.prototype.getDelegateOptions = function () {
	    var options  = {}
	    var defaults = this.getDefaults()
	
	    this._options && $.each(this._options, function (key, value) {
	      if (defaults[key] != value) options[key] = value
	    })
	
	    return options
	  }
	
	  Tooltip.prototype.enter = function (obj) {
	    var self = obj instanceof this.constructor ?
	      obj : $(obj.currentTarget).data('bs.' + this.type)
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
	      $(obj.currentTarget).data('bs.' + this.type, self)
	    }
	
	    if (obj instanceof $.Event) {
	      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true
	    }
	
	    if (self.tip().hasClass('in') || self.hoverState == 'in') {
	      self.hoverState = 'in'
	      return
	    }
	
	    clearTimeout(self.timeout)
	
	    self.hoverState = 'in'
	
	    if (!self.options.delay || !self.options.delay.show) return self.show()
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'in') self.show()
	    }, self.options.delay.show)
	  }
	
	  Tooltip.prototype.isInStateTrue = function () {
	    for (var key in this.inState) {
	      if (this.inState[key]) return true
	    }
	
	    return false
	  }
	
	  Tooltip.prototype.leave = function (obj) {
	    var self = obj instanceof this.constructor ?
	      obj : $(obj.currentTarget).data('bs.' + this.type)
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
	      $(obj.currentTarget).data('bs.' + this.type, self)
	    }
	
	    if (obj instanceof $.Event) {
	      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false
	    }
	
	    if (self.isInStateTrue()) return
	
	    clearTimeout(self.timeout)
	
	    self.hoverState = 'out'
	
	    if (!self.options.delay || !self.options.delay.hide) return self.hide()
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'out') self.hide()
	    }, self.options.delay.hide)
	  }
	
	  Tooltip.prototype.show = function () {
	    var e = $.Event('show.bs.' + this.type)
	
	    if (this.hasContent() && this.enabled) {
	      this.$element.trigger(e)
	
	      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
	      if (e.isDefaultPrevented() || !inDom) return
	      var that = this
	
	      var $tip = this.tip()
	
	      var tipId = this.getUID(this.type)
	
	      this.setContent()
	      $tip.attr('id', tipId)
	      this.$element.attr('aria-describedby', tipId)
	
	      if (this.options.animation) $tip.addClass('fade')
	
	      var placement = typeof this.options.placement == 'function' ?
	        this.options.placement.call(this, $tip[0], this.$element[0]) :
	        this.options.placement
	
	      var autoToken = /\s?auto?\s?/i
	      var autoPlace = autoToken.test(placement)
	      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'
	
	      $tip
	        .detach()
	        .css({ top: 0, left: 0, display: 'block' })
	        .addClass(placement)
	        .data('bs.' + this.type, this)
	
	      this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element)
	      this.$element.trigger('inserted.bs.' + this.type)
	
	      var pos          = this.getPosition()
	      var actualWidth  = $tip[0].offsetWidth
	      var actualHeight = $tip[0].offsetHeight
	
	      if (autoPlace) {
	        var orgPlacement = placement
	        var viewportDim = this.getPosition(this.$viewport)
	
	        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top'    :
	                    placement == 'top'    && pos.top    - actualHeight < viewportDim.top    ? 'bottom' :
	                    placement == 'right'  && pos.right  + actualWidth  > viewportDim.width  ? 'left'   :
	                    placement == 'left'   && pos.left   - actualWidth  < viewportDim.left   ? 'right'  :
	                    placement
	
	        $tip
	          .removeClass(orgPlacement)
	          .addClass(placement)
	      }
	
	      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)
	
	      this.applyPlacement(calculatedOffset, placement)
	
	      var complete = function () {
	        var prevHoverState = that.hoverState
	        that.$element.trigger('shown.bs.' + that.type)
	        that.hoverState = null
	
	        if (prevHoverState == 'out') that.leave(that)
	      }
	
	      $.support.transition && this.$tip.hasClass('fade') ?
	        $tip
	          .one('bsTransitionEnd', complete)
	          .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
	        complete()
	    }
	  }
	
	  Tooltip.prototype.applyPlacement = function (offset, placement) {
	    var $tip   = this.tip()
	    var width  = $tip[0].offsetWidth
	    var height = $tip[0].offsetHeight
	
	    // manually read margins because getBoundingClientRect includes difference
	    var marginTop = parseInt($tip.css('margin-top'), 10)
	    var marginLeft = parseInt($tip.css('margin-left'), 10)
	
	    // we must check for NaN for ie 8/9
	    if (isNaN(marginTop))  marginTop  = 0
	    if (isNaN(marginLeft)) marginLeft = 0
	
	    offset.top  += marginTop
	    offset.left += marginLeft
	
	    // $.fn.offset doesn't round pixel values
	    // so we use setOffset directly with our own function B-0
	    $.offset.setOffset($tip[0], $.extend({
	      using: function (props) {
	        $tip.css({
	          top: Math.round(props.top),
	          left: Math.round(props.left)
	        })
	      }
	    }, offset), 0)
	
	    $tip.addClass('in')
	
	    // check to see if placing tip in new offset caused the tip to resize itself
	    var actualWidth  = $tip[0].offsetWidth
	    var actualHeight = $tip[0].offsetHeight
	
	    if (placement == 'top' && actualHeight != height) {
	      offset.top = offset.top + height - actualHeight
	    }
	
	    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)
	
	    if (delta.left) offset.left += delta.left
	    else offset.top += delta.top
	
	    var isVertical          = /top|bottom/.test(placement)
	    var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
	    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'
	
	    $tip.offset(offset)
	    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
	  }
	
	  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
	    this.arrow()
	      .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
	      .css(isVertical ? 'top' : 'left', '')
	  }
	
	  Tooltip.prototype.setContent = function () {
	    var $tip  = this.tip()
	    var title = this.getTitle()
	
	    $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title)
	    $tip.removeClass('fade in top bottom left right')
	  }
	
	  Tooltip.prototype.hide = function (callback) {
	    var that = this
	    var $tip = $(this.$tip)
	    var e    = $.Event('hide.bs.' + this.type)
	
	    function complete() {
	      if (that.hoverState != 'in') $tip.detach()
	      if (that.$element) { // TODO: Check whether guarding this code with this `if` is really necessary.
	        that.$element
	          .removeAttr('aria-describedby')
	          .trigger('hidden.bs.' + that.type)
	      }
	      callback && callback()
	    }
	
	    this.$element.trigger(e)
	
	    if (e.isDefaultPrevented()) return
	
	    $tip.removeClass('in')
	
	    $.support.transition && $tip.hasClass('fade') ?
	      $tip
	        .one('bsTransitionEnd', complete)
	        .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
	      complete()
	
	    this.hoverState = null
	
	    return this
	  }
	
	  Tooltip.prototype.fixTitle = function () {
	    var $e = this.$element
	    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
	      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
	    }
	  }
	
	  Tooltip.prototype.hasContent = function () {
	    return this.getTitle()
	  }
	
	  Tooltip.prototype.getPosition = function ($element) {
	    $element   = $element || this.$element
	
	    var el     = $element[0]
	    var isBody = el.tagName == 'BODY'
	
	    var elRect    = el.getBoundingClientRect()
	    if (elRect.width == null) {
	      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
	      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })
	    }
	    var isSvg = window.SVGElement && el instanceof window.SVGElement
	    // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.
	    // See https://github.com/twbs/bootstrap/issues/20280
	    var elOffset  = isBody ? { top: 0, left: 0 } : (isSvg ? null : $element.offset())
	    var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }
	    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null
	
	    return $.extend({}, elRect, scroll, outerDims, elOffset)
	  }
	
	  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
	    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :
	           placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
	           placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
	        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }
	
	  }
	
	  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
	    var delta = { top: 0, left: 0 }
	    if (!this.$viewport) return delta
	
	    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
	    var viewportDimensions = this.getPosition(this.$viewport)
	
	    if (/right|left/.test(placement)) {
	      var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
	      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
	      if (topEdgeOffset < viewportDimensions.top) { // top overflow
	        delta.top = viewportDimensions.top - topEdgeOffset
	      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
	        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
	      }
	    } else {
	      var leftEdgeOffset  = pos.left - viewportPadding
	      var rightEdgeOffset = pos.left + viewportPadding + actualWidth
	      if (leftEdgeOffset < viewportDimensions.left) { // left overflow
	        delta.left = viewportDimensions.left - leftEdgeOffset
	      } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow
	        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
	      }
	    }
	
	    return delta
	  }
	
	  Tooltip.prototype.getTitle = function () {
	    var title
	    var $e = this.$element
	    var o  = this.options
	
	    title = $e.attr('data-original-title')
	      || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)
	
	    return title
	  }
	
	  Tooltip.prototype.getUID = function (prefix) {
	    do prefix += ~~(Math.random() * 1000000)
	    while (document.getElementById(prefix))
	    return prefix
	  }
	
	  Tooltip.prototype.tip = function () {
	    if (!this.$tip) {
	      this.$tip = $(this.options.template)
	      if (this.$tip.length != 1) {
	        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!')
	      }
	    }
	    return this.$tip
	  }
	
	  Tooltip.prototype.arrow = function () {
	    return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
	  }
	
	  Tooltip.prototype.enable = function () {
	    this.enabled = true
	  }
	
	  Tooltip.prototype.disable = function () {
	    this.enabled = false
	  }
	
	  Tooltip.prototype.toggleEnabled = function () {
	    this.enabled = !this.enabled
	  }
	
	  Tooltip.prototype.toggle = function (e) {
	    var self = this
	    if (e) {
	      self = $(e.currentTarget).data('bs.' + this.type)
	      if (!self) {
	        self = new this.constructor(e.currentTarget, this.getDelegateOptions())
	        $(e.currentTarget).data('bs.' + this.type, self)
	      }
	    }
	
	    if (e) {
	      self.inState.click = !self.inState.click
	      if (self.isInStateTrue()) self.enter(self)
	      else self.leave(self)
	    } else {
	      self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
	    }
	  }
	
	  Tooltip.prototype.destroy = function () {
	    var that = this
	    clearTimeout(this.timeout)
	    this.hide(function () {
	      that.$element.off('.' + that.type).removeData('bs.' + that.type)
	      if (that.$tip) {
	        that.$tip.detach()
	      }
	      that.$tip = null
	      that.$arrow = null
	      that.$viewport = null
	      that.$element = null
	    })
	  }
	
	
	  // TOOLTIP PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.tooltip')
	      var options = typeof option == 'object' && option
	
	      if (!data && /destroy|hide/.test(option)) return
	      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.tooltip
	
	  $.fn.tooltip             = Plugin
	  $.fn.tooltip.Constructor = Tooltip
	
	
	  // TOOLTIP NO CONFLICT
	  // ===================
	
	  $.fn.tooltip.noConflict = function () {
	    $.fn.tooltip = old
	    return this
	  }
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: popover.js v3.3.7
	 * http://getbootstrap.com/javascript/#popovers
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // POPOVER PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Popover = function (element, options) {
	    this.init('popover', element, options)
	  }
	
	  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')
	
	  Popover.VERSION  = '3.3.7'
	
	  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
	    placement: 'right',
	    trigger: 'click',
	    content: '',
	    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
	  })
	
	
	  // NOTE: POPOVER EXTENDS tooltip.js
	  // ================================
	
	  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)
	
	  Popover.prototype.constructor = Popover
	
	  Popover.prototype.getDefaults = function () {
	    return Popover.DEFAULTS
	  }
	
	  Popover.prototype.setContent = function () {
	    var $tip    = this.tip()
	    var title   = this.getTitle()
	    var content = this.getContent()
	
	    $tip.find('.popover-title')[this.options.html ? 'html' : 'text'](title)
	    $tip.find('.popover-content').children().detach().end()[ // we use append for html objects to maintain js events
	      this.options.html ? (typeof content == 'string' ? 'html' : 'append') : 'text'
	    ](content)
	
	    $tip.removeClass('fade top bottom left right in')
	
	    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
	    // this manually by checking the contents.
	    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
	  }
	
	  Popover.prototype.hasContent = function () {
	    return this.getTitle() || this.getContent()
	  }
	
	  Popover.prototype.getContent = function () {
	    var $e = this.$element
	    var o  = this.options
	
	    return $e.attr('data-content')
	      || (typeof o.content == 'function' ?
	            o.content.call($e[0]) :
	            o.content)
	  }
	
	  Popover.prototype.arrow = function () {
	    return (this.$arrow = this.$arrow || this.tip().find('.arrow'))
	  }
	
	
	  // POPOVER PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.popover')
	      var options = typeof option == 'object' && option
	
	      if (!data && /destroy|hide/.test(option)) return
	      if (!data) $this.data('bs.popover', (data = new Popover(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.popover
	
	  $.fn.popover             = Plugin
	  $.fn.popover.Constructor = Popover
	
	
	  // POPOVER NO CONFLICT
	  // ===================
	
	  $.fn.popover.noConflict = function () {
	    $.fn.popover = old
	    return this
	  }
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: scrollspy.js v3.3.7
	 * http://getbootstrap.com/javascript/#scrollspy
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // SCROLLSPY CLASS DEFINITION
	  // ==========================
	
	  function ScrollSpy(element, options) {
	    this.$body          = $(document.body)
	    this.$scrollElement = $(element).is(document.body) ? $(window) : $(element)
	    this.options        = $.extend({}, ScrollSpy.DEFAULTS, options)
	    this.selector       = (this.options.target || '') + ' .nav li > a'
	    this.offsets        = []
	    this.targets        = []
	    this.activeTarget   = null
	    this.scrollHeight   = 0
	
	    this.$scrollElement.on('scroll.bs.scrollspy', $.proxy(this.process, this))
	    this.refresh()
	    this.process()
	  }
	
	  ScrollSpy.VERSION  = '3.3.7'
	
	  ScrollSpy.DEFAULTS = {
	    offset: 10
	  }
	
	  ScrollSpy.prototype.getScrollHeight = function () {
	    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
	  }
	
	  ScrollSpy.prototype.refresh = function () {
	    var that          = this
	    var offsetMethod  = 'offset'
	    var offsetBase    = 0
	
	    this.offsets      = []
	    this.targets      = []
	    this.scrollHeight = this.getScrollHeight()
	
	    if (!$.isWindow(this.$scrollElement[0])) {
	      offsetMethod = 'position'
	      offsetBase   = this.$scrollElement.scrollTop()
	    }
	
	    this.$body
	      .find(this.selector)
	      .map(function () {
	        var $el   = $(this)
	        var href  = $el.data('target') || $el.attr('href')
	        var $href = /^#./.test(href) && $(href)
	
	        return ($href
	          && $href.length
	          && $href.is(':visible')
	          && [[$href[offsetMethod]().top + offsetBase, href]]) || null
	      })
	      .sort(function (a, b) { return a[0] - b[0] })
	      .each(function () {
	        that.offsets.push(this[0])
	        that.targets.push(this[1])
	      })
	  }
	
	  ScrollSpy.prototype.process = function () {
	    var scrollTop    = this.$scrollElement.scrollTop() + this.options.offset
	    var scrollHeight = this.getScrollHeight()
	    var maxScroll    = this.options.offset + scrollHeight - this.$scrollElement.height()
	    var offsets      = this.offsets
	    var targets      = this.targets
	    var activeTarget = this.activeTarget
	    var i
	
	    if (this.scrollHeight != scrollHeight) {
	      this.refresh()
	    }
	
	    if (scrollTop >= maxScroll) {
	      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i)
	    }
	
	    if (activeTarget && scrollTop < offsets[0]) {
	      this.activeTarget = null
	      return this.clear()
	    }
	
	    for (i = offsets.length; i--;) {
	      activeTarget != targets[i]
	        && scrollTop >= offsets[i]
	        && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1])
	        && this.activate(targets[i])
	    }
	  }
	
	  ScrollSpy.prototype.activate = function (target) {
	    this.activeTarget = target
	
	    this.clear()
	
	    var selector = this.selector +
	      '[data-target="' + target + '"],' +
	      this.selector + '[href="' + target + '"]'
	
	    var active = $(selector)
	      .parents('li')
	      .addClass('active')
	
	    if (active.parent('.dropdown-menu').length) {
	      active = active
	        .closest('li.dropdown')
	        .addClass('active')
	    }
	
	    active.trigger('activate.bs.scrollspy')
	  }
	
	  ScrollSpy.prototype.clear = function () {
	    $(this.selector)
	      .parentsUntil(this.options.target, '.active')
	      .removeClass('active')
	  }
	
	
	  // SCROLLSPY PLUGIN DEFINITION
	  // ===========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.scrollspy')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.scrollspy', (data = new ScrollSpy(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.scrollspy
	
	  $.fn.scrollspy             = Plugin
	  $.fn.scrollspy.Constructor = ScrollSpy
	
	
	  // SCROLLSPY NO CONFLICT
	  // =====================
	
	  $.fn.scrollspy.noConflict = function () {
	    $.fn.scrollspy = old
	    return this
	  }
	
	
	  // SCROLLSPY DATA-API
	  // ==================
	
	  $(window).on('load.bs.scrollspy.data-api', function () {
	    $('[data-spy="scroll"]').each(function () {
	      var $spy = $(this)
	      Plugin.call($spy, $spy.data())
	    })
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: tab.js v3.3.7
	 * http://getbootstrap.com/javascript/#tabs
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // TAB CLASS DEFINITION
	  // ====================
	
	  var Tab = function (element) {
	    // jscs:disable requireDollarBeforejQueryAssignment
	    this.element = $(element)
	    // jscs:enable requireDollarBeforejQueryAssignment
	  }
	
	  Tab.VERSION = '3.3.7'
	
	  Tab.TRANSITION_DURATION = 150
	
	  Tab.prototype.show = function () {
	    var $this    = this.element
	    var $ul      = $this.closest('ul:not(.dropdown-menu)')
	    var selector = $this.data('target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    if ($this.parent('li').hasClass('active')) return
	
	    var $previous = $ul.find('.active:last a')
	    var hideEvent = $.Event('hide.bs.tab', {
	      relatedTarget: $this[0]
	    })
	    var showEvent = $.Event('show.bs.tab', {
	      relatedTarget: $previous[0]
	    })
	
	    $previous.trigger(hideEvent)
	    $this.trigger(showEvent)
	
	    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return
	
	    var $target = $(selector)
	
	    this.activate($this.closest('li'), $ul)
	    this.activate($target, $target.parent(), function () {
	      $previous.trigger({
	        type: 'hidden.bs.tab',
	        relatedTarget: $this[0]
	      })
	      $this.trigger({
	        type: 'shown.bs.tab',
	        relatedTarget: $previous[0]
	      })
	    })
	  }
	
	  Tab.prototype.activate = function (element, container, callback) {
	    var $active    = container.find('> .active')
	    var transition = callback
	      && $.support.transition
	      && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length)
	
	    function next() {
	      $active
	        .removeClass('active')
	        .find('> .dropdown-menu > .active')
	          .removeClass('active')
	        .end()
	        .find('[data-toggle="tab"]')
	          .attr('aria-expanded', false)
	
	      element
	        .addClass('active')
	        .find('[data-toggle="tab"]')
	          .attr('aria-expanded', true)
	
	      if (transition) {
	        element[0].offsetWidth // reflow for transition
	        element.addClass('in')
	      } else {
	        element.removeClass('fade')
	      }
	
	      if (element.parent('.dropdown-menu').length) {
	        element
	          .closest('li.dropdown')
	            .addClass('active')
	          .end()
	          .find('[data-toggle="tab"]')
	            .attr('aria-expanded', true)
	      }
	
	      callback && callback()
	    }
	
	    $active.length && transition ?
	      $active
	        .one('bsTransitionEnd', next)
	        .emulateTransitionEnd(Tab.TRANSITION_DURATION) :
	      next()
	
	    $active.removeClass('in')
	  }
	
	
	  // TAB PLUGIN DEFINITION
	  // =====================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.tab')
	
	      if (!data) $this.data('bs.tab', (data = new Tab(this)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.tab
	
	  $.fn.tab             = Plugin
	  $.fn.tab.Constructor = Tab
	
	
	  // TAB NO CONFLICT
	  // ===============
	
	  $.fn.tab.noConflict = function () {
	    $.fn.tab = old
	    return this
	  }
	
	
	  // TAB DATA-API
	  // ============
	
	  var clickHandler = function (e) {
	    e.preventDefault()
	    Plugin.call($(this), 'show')
	  }
	
	  $(document)
	    .on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler)
	    .on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler)
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: affix.js v3.3.7
	 * http://getbootstrap.com/javascript/#affix
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // AFFIX CLASS DEFINITION
	  // ======================
	
	  var Affix = function (element, options) {
	    this.options = $.extend({}, Affix.DEFAULTS, options)
	
	    this.$target = $(this.options.target)
	      .on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this))
	      .on('click.bs.affix.data-api',  $.proxy(this.checkPositionWithEventLoop, this))
	
	    this.$element     = $(element)
	    this.affixed      = null
	    this.unpin        = null
	    this.pinnedOffset = null
	
	    this.checkPosition()
	  }
	
	  Affix.VERSION  = '3.3.7'
	
	  Affix.RESET    = 'affix affix-top affix-bottom'
	
	  Affix.DEFAULTS = {
	    offset: 0,
	    target: window
	  }
	
	  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
	    var scrollTop    = this.$target.scrollTop()
	    var position     = this.$element.offset()
	    var targetHeight = this.$target.height()
	
	    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false
	
	    if (this.affixed == 'bottom') {
	      if (offsetTop != null) return (scrollTop + this.unpin <= position.top) ? false : 'bottom'
	      return (scrollTop + targetHeight <= scrollHeight - offsetBottom) ? false : 'bottom'
	    }
	
	    var initializing   = this.affixed == null
	    var colliderTop    = initializing ? scrollTop : position.top
	    var colliderHeight = initializing ? targetHeight : height
	
	    if (offsetTop != null && scrollTop <= offsetTop) return 'top'
	    if (offsetBottom != null && (colliderTop + colliderHeight >= scrollHeight - offsetBottom)) return 'bottom'
	
	    return false
	  }
	
	  Affix.prototype.getPinnedOffset = function () {
	    if (this.pinnedOffset) return this.pinnedOffset
	    this.$element.removeClass(Affix.RESET).addClass('affix')
	    var scrollTop = this.$target.scrollTop()
	    var position  = this.$element.offset()
	    return (this.pinnedOffset = position.top - scrollTop)
	  }
	
	  Affix.prototype.checkPositionWithEventLoop = function () {
	    setTimeout($.proxy(this.checkPosition, this), 1)
	  }
	
	  Affix.prototype.checkPosition = function () {
	    if (!this.$element.is(':visible')) return
	
	    var height       = this.$element.height()
	    var offset       = this.options.offset
	    var offsetTop    = offset.top
	    var offsetBottom = offset.bottom
	    var scrollHeight = Math.max($(document).height(), $(document.body).height())
	
	    if (typeof offset != 'object')         offsetBottom = offsetTop = offset
	    if (typeof offsetTop == 'function')    offsetTop    = offset.top(this.$element)
	    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element)
	
	    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom)
	
	    if (this.affixed != affix) {
	      if (this.unpin != null) this.$element.css('top', '')
	
	      var affixType = 'affix' + (affix ? '-' + affix : '')
	      var e         = $.Event(affixType + '.bs.affix')
	
	      this.$element.trigger(e)
	
	      if (e.isDefaultPrevented()) return
	
	      this.affixed = affix
	      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null
	
	      this.$element
	        .removeClass(Affix.RESET)
	        .addClass(affixType)
	        .trigger(affixType.replace('affix', 'affixed') + '.bs.affix')
	    }
	
	    if (affix == 'bottom') {
	      this.$element.offset({
	        top: scrollHeight - height - offsetBottom
	      })
	    }
	  }
	
	
	  // AFFIX PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.affix')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.affix', (data = new Affix(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.affix
	
	  $.fn.affix             = Plugin
	  $.fn.affix.Constructor = Affix
	
	
	  // AFFIX NO CONFLICT
	  // =================
	
	  $.fn.affix.noConflict = function () {
	    $.fn.affix = old
	    return this
	  }
	
	
	  // AFFIX DATA-API
	  // ==============
	
	  $(window).on('load', function () {
	    $('[data-spy="affix"]').each(function () {
	      var $spy = $(this)
	      var data = $spy.data()
	
	      data.offset = data.offset || {}
	
	      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom
	      if (data.offsetTop    != null) data.offset.top    = data.offsetTop
	
	      Plugin.call($spy, data)
	    })
	  })
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	var _keys = __webpack_require__(279);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(76);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(function (global, factory) {
	    ( false ? 'undefined' : (0, _typeof3.default)(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(567)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.jQuery);
	})(undefined, function ($$1) {
	    'use strict';
	
	    $$1 = $$1 && $$1.hasOwnProperty('default') ? $$1['default'] : $$1;
	
	    var Renderer = function () {
	        function Renderer(markup, children, options, callback) {
	            this.markup = markup;
	            this.children = children;
	            this.options = options;
	            this.callback = callback;
	        }
	        Renderer.prototype.render = function ($parent) {
	            var $node = $$1(this.markup);
	            if (this.options && this.options.contents) {
	                $node.html(this.options.contents);
	            }
	            if (this.options && this.options.className) {
	                $node.addClass(this.options.className);
	            }
	            if (this.options && this.options.data) {
	                $$1.each(this.options.data, function (k, v) {
	                    $node.attr('data-' + k, v);
	                });
	            }
	            if (this.options && this.options.click) {
	                $node.on('click', this.options.click);
	            }
	            if (this.children) {
	                var $container_1 = $node.find('.note-children-container');
	                this.children.forEach(function (child) {
	                    child.render($container_1.length ? $container_1 : $node);
	                });
	            }
	            if (this.callback) {
	                this.callback($node, this.options);
	            }
	            if (this.options && this.options.callback) {
	                this.options.callback($node);
	            }
	            if ($parent) {
	                $parent.append($node);
	            }
	            return $node;
	        };
	        return Renderer;
	    }();
	    var renderer = {
	        create: function create(markup, callback) {
	            return function () {
	                var options = (0, _typeof3.default)(arguments[1]) === 'object' ? arguments[1] : arguments[0];
	                var children = $$1.isArray(arguments[0]) ? arguments[0] : [];
	                if (options && options.children) {
	                    children = options.children;
	                }
	                return new Renderer(markup, children, options, callback);
	            };
	        }
	    };
	
	    var editor = renderer.create('<div class="note-editor note-frame panel"/>');
	    var toolbar = renderer.create('<div class="note-toolbar-wrapper panel-default"><div class="note-toolbar panel-heading"></div></div>');
	    var editingArea = renderer.create('<div class="note-editing-area"/>');
	    var codable = renderer.create('<textarea class="note-codable"/>');
	    var editable = renderer.create('<div class="note-editable" contentEditable="true"/>');
	    var statusbar = renderer.create(['<div class="note-statusbar">', '  <div class="note-resizebar">', '    <div class="note-icon-bar"/>', '    <div class="note-icon-bar"/>', '    <div class="note-icon-bar"/>', '  </div>', '</div>'].join(''));
	    var airEditor = renderer.create('<div class="note-editor"/>');
	    var airEditable = renderer.create('<div class="note-editable" contentEditable="true"/>');
	    var buttonGroup = renderer.create('<div class="note-btn-group btn-group">');
	    var dropdown = renderer.create('<div class="dropdown-menu">', function ($node, options) {
	        var markup = $$1.isArray(options.items) ? options.items.map(function (item) {
	            var value = typeof item === 'string' ? item : item.value || '';
	            var content = options.template ? options.template(item) : item;
	            var option = (typeof item === 'undefined' ? 'undefined' : (0, _typeof3.default)(item)) === 'object' ? item.option : undefined;
	            var dataValue = 'data-value="' + value + '"';
	            var dataOption = option !== undefined ? ' data-option="' + option + '"' : '';
	            return '<li><a href="#" ' + (dataValue + dataOption) + '>' + content + '</a></li>';
	        }).join('') : options.items;
	        $node.html(markup);
	    });
	    var dropdownButtonContents = function dropdownButtonContents(contents, options) {
	        return contents + ' ' + icon(options.icons.caret, 'span');
	    };
	    var dropdownCheck = renderer.create('<div class="dropdown-menu note-check">', function ($node, options) {
	        var markup = $$1.isArray(options.items) ? options.items.map(function (item) {
	            var value = typeof item === 'string' ? item : item.value || '';
	            var content = options.template ? options.template(item) : item;
	            return '<li><a href="#" data-value="' + value + '">' + icon(options.checkClassName) + ' ' + content + '</a></li>';
	        }).join('') : options.items;
	        $node.html(markup);
	    });
	    var palette = renderer.create('<div class="note-color-palette"/>', function ($node, options) {
	        var contents = [];
	        for (var row = 0, rowSize = options.colors.length; row < rowSize; row++) {
	            var eventName = options.eventName;
	            var colors = options.colors[row];
	            var buttons = [];
	            for (var col = 0, colSize = colors.length; col < colSize; col++) {
	                var color = colors[col];
	                buttons.push(['<button type="button" class="note-color-btn"', 'style="background-color:', color, '" ', 'data-event="', eventName, '" ', 'data-value="', color, '" ', 'title="', color, '" ', 'data-toggle="button" tabindex="-1"></button>'].join(''));
	            }
	            contents.push('<div class="note-color-row">' + buttons.join('') + '</div>');
	        }
	        $node.html(contents.join(''));
	        if (options.tooltip) {
	            $node.find('.note-color-btn').tooltip({
	                container: options.container,
	                trigger: 'hover',
	                placement: 'bottom'
	            });
	        }
	    });
	    var dialog = renderer.create('<div class="modal" aria-hidden="false" tabindex="-1"/>', function ($node, options) {
	        if (options.fade) {
	            $node.addClass('fade');
	        }
	        $node.html(['<div class="modal-dialog">', '  <div class="modal-content">', options.title ? '    <div class="modal-header">' + '      <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>' + '      <h4 class="modal-title">' + options.title + '</h4>' + '    </div>' : '', '    <div class="modal-body">' + options.body + '</div>', options.footer ? '    <div class="modal-footer">' + options.footer + '</div>' : '', '  </div>', '</div>'].join(''));
	    });
	    var popover = renderer.create(['<div class="note-popover popover in">', '  <div class="arrow"/>', '  <div class="popover-content note-children-container"/>', '</div>'].join(''), function ($node, options) {
	        var direction = typeof options.direction !== 'undefined' ? options.direction : 'bottom';
	        $node.addClass(direction);
	        if (options.hideArrow) {
	            $node.find('.arrow').hide();
	        }
	    });
	    var checkbox = renderer.create('<div class="checkbox"></div>', function ($node, options) {
	        $node.html([' <label' + (options.id ? ' for="' + options.id + '"' : '') + '>', ' <input type="checkbox"' + (options.id ? ' id="' + options.id + '"' : ''), (options.checked ? ' checked' : '') + '/>', options.text ? options.text : '', '</label>'].join(''));
	    });
	    var icon = function icon(iconClassName, tagName) {
	        tagName = tagName || 'i';
	        return '<' + tagName + ' class="' + iconClassName + '"/>';
	    };
	    var ui = {
	        editor: editor,
	        toolbar: toolbar,
	        editingArea: editingArea,
	        codable: codable,
	        editable: editable,
	        statusbar: statusbar,
	        airEditor: airEditor,
	        airEditable: airEditable,
	        buttonGroup: buttonGroup,
	        dropdown: dropdown,
	        dropdownButtonContents: dropdownButtonContents,
	        dropdownCheck: dropdownCheck,
	        palette: palette,
	        dialog: dialog,
	        popover: popover,
	        checkbox: checkbox,
	        icon: icon,
	        options: {},
	        button: function button($node, options) {
	            return renderer.create('<button type="button" class="note-btn btn btn-default btn-sm" tabindex="-1">', function ($node, options) {
	                if (options && options.tooltip) {
	                    $node.attr({
	                        title: options.tooltip
	                    }).tooltip({
	                        container: options.container,
	                        trigger: 'hover',
	                        placement: 'bottom'
	                    });
	                }
	            })($node, options);
	        },
	        toggleBtn: function toggleBtn($btn, isEnable) {
	            $btn.toggleClass('disabled', !isEnable);
	            $btn.attr('disabled', !isEnable);
	        },
	        toggleBtnActive: function toggleBtnActive($btn, isActive) {
	            $btn.toggleClass('active', isActive);
	        },
	        onDialogShown: function onDialogShown($dialog, handler) {
	            $dialog.one('shown.bs.modal', handler);
	        },
	        onDialogHidden: function onDialogHidden($dialog, handler) {
	            $dialog.one('hidden.bs.modal', handler);
	        },
	        showDialog: function showDialog($dialog) {
	            $dialog.modal('show');
	        },
	        hideDialog: function hideDialog($dialog) {
	            $dialog.modal('hide');
	        },
	        createLayout: function createLayout($note, options) {
	            var $editor = (options.airMode ? ui.airEditor([ui.editingArea([ui.airEditable()])]) : ui.editor([ui.toolbar(), ui.editingArea([ui.codable(), ui.editable()]), ui.statusbar()])).render();
	            $editor.insertAfter($note);
	            return {
	                note: $note,
	                editor: $editor,
	                toolbar: $editor.find('.note-toolbar'),
	                editingArea: $editor.find('.note-editing-area'),
	                editable: $editor.find('.note-editable'),
	                codable: $editor.find('.note-codable'),
	                statusbar: $editor.find('.note-statusbar')
	            };
	        },
	        removeLayout: function removeLayout($note, layoutInfo) {
	            $note.html(layoutInfo.editable.html());
	            layoutInfo.editor.remove();
	            $note.show();
	        }
	    };
	
	    function eq(itemA) {
	        return function (itemB) {
	            return itemA === itemB;
	        };
	    }
	    function eq2(itemA, itemB) {
	        return itemA === itemB;
	    }
	    function peq2(propName) {
	        return function (itemA, itemB) {
	            return itemA[propName] === itemB[propName];
	        };
	    }
	    function ok() {
	        return true;
	    }
	    function fail() {
	        return false;
	    }
	    function not(f) {
	        return function () {
	            return !f.apply(f, arguments);
	        };
	    }
	    function and(fA, fB) {
	        return function (item) {
	            return fA(item) && fB(item);
	        };
	    }
	    function self(a) {
	        return a;
	    }
	    function invoke(obj, method) {
	        return function () {
	            return obj[method].apply(obj, arguments);
	        };
	    }
	    var idCounter = 0;
	
	    function uniqueId(prefix) {
	        var id = ++idCounter + '';
	        return prefix ? prefix + id : id;
	    }
	
	    function rect2bnd(rect) {
	        var $document = $(document);
	        return {
	            top: rect.top + $document.scrollTop(),
	            left: rect.left + $document.scrollLeft(),
	            width: rect.right - rect.left,
	            height: rect.bottom - rect.top
	        };
	    }
	
	    function invertObject(obj) {
	        var inverted = {};
	        for (var key in obj) {
	            if (obj.hasOwnProperty(key)) {
	                inverted[obj[key]] = key;
	            }
	        }
	        return inverted;
	    }
	
	    function namespaceToCamel(namespace, prefix) {
	        prefix = prefix || '';
	        return prefix + namespace.split('.').map(function (name) {
	            return name.substring(0, 1).toUpperCase() + name.substring(1);
	        }).join('');
	    }
	
	    function debounce(func, wait, immediate) {
	        var _this = this;
	        var timeout;
	        return function () {
	            var context = _this;
	            var args = arguments;
	            var later = function later() {
	                timeout = null;
	                if (!immediate) {
	                    func.apply(context, args);
	                }
	            };
	            var callNow = immediate && !timeout;
	            clearTimeout(timeout);
	            timeout = setTimeout(later, wait);
	            if (callNow) {
	                func.apply(context, args);
	            }
	        };
	    }
	    var func = {
	        eq: eq,
	        eq2: eq2,
	        peq2: peq2,
	        ok: ok,
	        fail: fail,
	        self: self,
	        not: not,
	        and: and,
	        invoke: invoke,
	        uniqueId: uniqueId,
	        rect2bnd: rect2bnd,
	        invertObject: invertObject,
	        namespaceToCamel: namespaceToCamel,
	        debounce: debounce
	    };
	
	    function head(array) {
	        return array[0];
	    }
	
	    function last(array) {
	        return array[array.length - 1];
	    }
	
	    function initial(array) {
	        return array.slice(0, array.length - 1);
	    }
	
	    function tail(array) {
	        return array.slice(1);
	    }
	
	    function find(array, pred) {
	        for (var idx = 0, len = array.length; idx < len; idx++) {
	            var item = array[idx];
	            if (pred(item)) {
	                return item;
	            }
	        }
	    }
	
	    function all(array, pred) {
	        for (var idx = 0, len = array.length; idx < len; idx++) {
	            if (!pred(array[idx])) {
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function indexOf(array, item) {
	        return $$1.inArray(item, array);
	    }
	
	    function contains(array, item) {
	        return indexOf(array, item) !== -1;
	    }
	
	    function sum(array, fn) {
	        fn = fn || func.self;
	        return array.reduce(function (memo, v) {
	            return memo + fn(v);
	        }, 0);
	    }
	
	    function from(collection) {
	        var result = [];
	        var length = collection.length;
	        var idx = -1;
	        while (++idx < length) {
	            result[idx] = collection[idx];
	        }
	        return result;
	    }
	
	    function isEmpty$1(array) {
	        return !array || !array.length;
	    }
	
	    function clusterBy(array, fn) {
	        if (!array.length) {
	            return [];
	        }
	        var aTail = tail(array);
	        return aTail.reduce(function (memo, v) {
	            var aLast = last(memo);
	            if (fn(last(aLast), v)) {
	                aLast[aLast.length] = v;
	            } else {
	                memo[memo.length] = [v];
	            }
	            return memo;
	        }, [[head(array)]]);
	    }
	
	    function compact(array) {
	        var aResult = [];
	        for (var idx = 0, len = array.length; idx < len; idx++) {
	            if (array[idx]) {
	                aResult.push(array[idx]);
	            }
	        }
	        return aResult;
	    }
	
	    function unique(array) {
	        var results = [];
	        for (var idx = 0, len = array.length; idx < len; idx++) {
	            if (!contains(results, array[idx])) {
	                results.push(array[idx]);
	            }
	        }
	        return results;
	    }
	
	    function next(array, item) {
	        var idx = indexOf(array, item);
	        if (idx === -1) {
	            return null;
	        }
	        return array[idx + 1];
	    }
	
	    function prev(array, item) {
	        var idx = indexOf(array, item);
	        if (idx === -1) {
	            return null;
	        }
	        return array[idx - 1];
	    }
	
	    var lists = {
	        head: head,
	        last: last,
	        initial: initial,
	        tail: tail,
	        prev: prev,
	        next: next,
	        find: find,
	        contains: contains,
	        all: all,
	        sum: sum,
	        from: from,
	        isEmpty: isEmpty$1,
	        clusterBy: clusterBy,
	        compact: compact,
	        unique: unique
	    };
	
	    var isSupportAmd = "function" === 'function' && __webpack_require__(77);
	    function isFontInstalled(fontName) {
	        var testFontName = fontName === 'Comic Sans MS' ? 'Courier New' : 'Comic Sans MS';
	        var $tester = $$1('<div>').css({
	            position: 'absolute',
	            left: '-9999px',
	            top: '-9999px',
	            fontSize: '200px'
	        }).text('mmmmmmmmmwwwwwww').appendTo(document.body);
	        var originalWidth = $tester.css('fontFamily', testFontName).width();
	        var width = $tester.css('fontFamily', fontName + ',' + testFontName).width();
	        $tester.remove();
	        return originalWidth !== width;
	    }
	    var userAgent = navigator.userAgent;
	    var isMSIE = /MSIE|Trident/i.test(userAgent);
	    var browserVersion;
	    if (isMSIE) {
	        var matches = /MSIE (\d+[.]\d+)/.exec(userAgent);
	        if (matches) {
	            browserVersion = parseFloat(matches[1]);
	        }
	        matches = /Trident\/.*rv:([0-9]{1,}[.0-9]{0,})/.exec(userAgent);
	        if (matches) {
	            browserVersion = parseFloat(matches[1]);
	        }
	    }
	    var isEdge = /Edge\/\d+/.test(userAgent);
	    var hasCodeMirror = !!window.CodeMirror;
	
	    var isSupportTouch = 'ontouchstart' in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
	
	    var inputEventName = isMSIE || isEdge ? 'DOMCharacterDataModified DOMSubtreeModified DOMNodeInserted' : 'input';
	
	    var env = {
	        isMac: navigator.appVersion.indexOf('Mac') > -1,
	        isMSIE: isMSIE,
	        isEdge: isEdge,
	        isFF: !isEdge && /firefox/i.test(userAgent),
	        isPhantom: /PhantomJS/i.test(userAgent),
	        isWebkit: !isEdge && /webkit/i.test(userAgent),
	        isChrome: !isEdge && /chrome/i.test(userAgent),
	        isSafari: !isEdge && /safari/i.test(userAgent),
	        browserVersion: browserVersion,
	        jqueryVersion: parseFloat($$1.fn.jquery),
	        isSupportAmd: isSupportAmd,
	        isSupportTouch: isSupportTouch,
	        hasCodeMirror: hasCodeMirror,
	        isFontInstalled: isFontInstalled,
	        isW3CRangeSupport: !!document.createRange,
	        inputEventName: inputEventName
	    };
	
	    var NBSP_CHAR = String.fromCharCode(160);
	    var ZERO_WIDTH_NBSP_CHAR = '\uFEFF';
	
	    function isEditable(node) {
	        return node && $$1(node).hasClass('note-editable');
	    }
	
	    function isControlSizing(node) {
	        return node && $$1(node).hasClass('note-control-sizing');
	    }
	
	    function makePredByNodeName(nodeName) {
	        nodeName = nodeName.toUpperCase();
	        return function (node) {
	            return node && node.nodeName.toUpperCase() === nodeName;
	        };
	    }
	
	    function isText(node) {
	        return node && node.nodeType === 3;
	    }
	
	    function isElement(node) {
	        return node && node.nodeType === 1;
	    }
	
	    function isVoid(node) {
	        return node && /^BR|^IMG|^HR|^IFRAME|^BUTTON|^INPUT/.test(node.nodeName.toUpperCase());
	    }
	    function isPara(node) {
	        if (isEditable(node)) {
	            return false;
	        }
	
	        return node && /^DIV|^P|^LI|^H[1-7]/.test(node.nodeName.toUpperCase());
	    }
	    function isHeading(node) {
	        return node && /^H[1-7]/.test(node.nodeName.toUpperCase());
	    }
	    var isPre = makePredByNodeName('PRE');
	    var isLi = makePredByNodeName('LI');
	    function isPurePara(node) {
	        return isPara(node) && !isLi(node);
	    }
	    var isTable = makePredByNodeName('TABLE');
	    var isData = makePredByNodeName('DATA');
	    function isInline(node) {
	        return !isBodyContainer(node) && !isList(node) && !isHr(node) && !isPara(node) && !isTable(node) && !isBlockquote(node) && !isData(node);
	    }
	    function isList(node) {
	        return node && /^UL|^OL/.test(node.nodeName.toUpperCase());
	    }
	    var isHr = makePredByNodeName('HR');
	    function isCell(node) {
	        return node && /^TD|^TH/.test(node.nodeName.toUpperCase());
	    }
	    var isBlockquote = makePredByNodeName('BLOCKQUOTE');
	    function isBodyContainer(node) {
	        return isCell(node) || isBlockquote(node) || isEditable(node);
	    }
	    var isAnchor = makePredByNodeName('A');
	    function isParaInline(node) {
	        return isInline(node) && !!ancestor(node, isPara);
	    }
	    function isBodyInline(node) {
	        return isInline(node) && !ancestor(node, isPara);
	    }
	    var isBody = makePredByNodeName('BODY');
	
	    function isClosestSibling(nodeA, nodeB) {
	        return nodeA.nextSibling === nodeB || nodeA.previousSibling === nodeB;
	    }
	
	    function withClosestSiblings(node, pred) {
	        pred = pred || func.ok;
	        var siblings = [];
	        if (node.previousSibling && pred(node.previousSibling)) {
	            siblings.push(node.previousSibling);
	        }
	        siblings.push(node);
	        if (node.nextSibling && pred(node.nextSibling)) {
	            siblings.push(node.nextSibling);
	        }
	        return siblings;
	    }
	
	    var blankHTML = env.isMSIE && env.browserVersion < 11 ? '&nbsp;' : '<br>';
	
	    function nodeLength(node) {
	        if (isText(node)) {
	            return node.nodeValue.length;
	        }
	        if (node) {
	            return node.childNodes.length;
	        }
	        return 0;
	    }
	
	    function isEmpty(node) {
	        var len = nodeLength(node);
	        if (len === 0) {
	            return true;
	        } else if (!isText(node) && len === 1 && node.innerHTML === blankHTML) {
	            return true;
	        } else if (lists.all(node.childNodes, isText) && node.innerHTML === '') {
	            return true;
	        }
	        return false;
	    }
	
	    function paddingBlankHTML(node) {
	        if (!isVoid(node) && !nodeLength(node)) {
	            node.innerHTML = blankHTML;
	        }
	    }
	
	    function ancestor(node, pred) {
	        while (node) {
	            if (pred(node)) {
	                return node;
	            }
	            if (isEditable(node)) {
	                break;
	            }
	            node = node.parentNode;
	        }
	        return null;
	    }
	
	    function singleChildAncestor(node, pred) {
	        node = node.parentNode;
	        while (node) {
	            if (nodeLength(node) !== 1) {
	                break;
	            }
	            if (pred(node)) {
	                return node;
	            }
	            if (isEditable(node)) {
	                break;
	            }
	            node = node.parentNode;
	        }
	        return null;
	    }
	
	    function listAncestor(node, pred) {
	        pred = pred || func.fail;
	        var ancestors = [];
	        ancestor(node, function (el) {
	            if (!isEditable(el)) {
	                ancestors.push(el);
	            }
	            return pred(el);
	        });
	        return ancestors;
	    }
	
	    function lastAncestor(node, pred) {
	        var ancestors = listAncestor(node);
	        return lists.last(ancestors.filter(pred));
	    }
	
	    function commonAncestor(nodeA, nodeB) {
	        var ancestors = listAncestor(nodeA);
	        for (var n = nodeB; n; n = n.parentNode) {
	            if ($$1.inArray(n, ancestors) > -1) {
	                return n;
	            }
	        }
	        return null;
	    }
	
	    function listPrev(node, pred) {
	        pred = pred || func.fail;
	        var nodes = [];
	        while (node) {
	            if (pred(node)) {
	                break;
	            }
	            nodes.push(node);
	            node = node.previousSibling;
	        }
	        return nodes;
	    }
	
	    function listNext(node, pred) {
	        pred = pred || func.fail;
	        var nodes = [];
	        while (node) {
	            if (pred(node)) {
	                break;
	            }
	            nodes.push(node);
	            node = node.nextSibling;
	        }
	        return nodes;
	    }
	
	    function listDescendant(node, pred) {
	        var descendants = [];
	        pred = pred || func.ok;
	
	        (function fnWalk(current) {
	            if (node !== current && pred(current)) {
	                descendants.push(current);
	            }
	            for (var idx = 0, len = current.childNodes.length; idx < len; idx++) {
	                fnWalk(current.childNodes[idx]);
	            }
	        })(node);
	        return descendants;
	    }
	
	    function wrap(node, wrapperName) {
	        var parent = node.parentNode;
	        var wrapper = $$1('<' + wrapperName + '>')[0];
	        parent.insertBefore(wrapper, node);
	        wrapper.appendChild(node);
	        return wrapper;
	    }
	
	    function insertAfter(node, preceding) {
	        var next = preceding.nextSibling;
	        var parent = preceding.parentNode;
	        if (next) {
	            parent.insertBefore(node, next);
	        } else {
	            parent.appendChild(node);
	        }
	        return node;
	    }
	
	    function appendChildNodes(node, aChild) {
	        $$1.each(aChild, function (idx, child) {
	            node.appendChild(child);
	        });
	        return node;
	    }
	
	    function isLeftEdgePoint(point) {
	        return point.offset === 0;
	    }
	
	    function isRightEdgePoint(point) {
	        return point.offset === nodeLength(point.node);
	    }
	
	    function isEdgePoint(point) {
	        return isLeftEdgePoint(point) || isRightEdgePoint(point);
	    }
	
	    function isLeftEdgeOf(node, ancestor) {
	        while (node && node !== ancestor) {
	            if (position(node) !== 0) {
	                return false;
	            }
	            node = node.parentNode;
	        }
	        return true;
	    }
	
	    function isRightEdgeOf(node, ancestor) {
	        if (!ancestor) {
	            return false;
	        }
	        while (node && node !== ancestor) {
	            if (position(node) !== nodeLength(node.parentNode) - 1) {
	                return false;
	            }
	            node = node.parentNode;
	        }
	        return true;
	    }
	
	    function isLeftEdgePointOf(point, ancestor) {
	        return isLeftEdgePoint(point) && isLeftEdgeOf(point.node, ancestor);
	    }
	
	    function isRightEdgePointOf(point, ancestor) {
	        return isRightEdgePoint(point) && isRightEdgeOf(point.node, ancestor);
	    }
	
	    function position(node) {
	        var offset = 0;
	        while (node = node.previousSibling) {
	            offset += 1;
	        }
	        return offset;
	    }
	    function hasChildren(node) {
	        return !!(node && node.childNodes && node.childNodes.length);
	    }
	
	    function prevPoint(point, isSkipInnerOffset) {
	        var node;
	        var offset;
	        if (point.offset === 0) {
	            if (isEditable(point.node)) {
	                return null;
	            }
	            node = point.node.parentNode;
	            offset = position(point.node);
	        } else if (hasChildren(point.node)) {
	            node = point.node.childNodes[point.offset - 1];
	            offset = nodeLength(node);
	        } else {
	            node = point.node;
	            offset = isSkipInnerOffset ? 0 : point.offset - 1;
	        }
	        return {
	            node: node,
	            offset: offset
	        };
	    }
	
	    function nextPoint(point, isSkipInnerOffset) {
	        var node, offset;
	        if (nodeLength(point.node) === point.offset) {
	            if (isEditable(point.node)) {
	                return null;
	            }
	            node = point.node.parentNode;
	            offset = position(point.node) + 1;
	        } else if (hasChildren(point.node)) {
	            node = point.node.childNodes[point.offset];
	            offset = 0;
	        } else {
	            node = point.node;
	            offset = isSkipInnerOffset ? nodeLength(point.node) : point.offset + 1;
	        }
	        return {
	            node: node,
	            offset: offset
	        };
	    }
	
	    function isSamePoint(pointA, pointB) {
	        return pointA.node === pointB.node && pointA.offset === pointB.offset;
	    }
	
	    function isVisiblePoint(point) {
	        if (isText(point.node) || !hasChildren(point.node) || isEmpty(point.node)) {
	            return true;
	        }
	        var leftNode = point.node.childNodes[point.offset - 1];
	        var rightNode = point.node.childNodes[point.offset];
	        if ((!leftNode || isVoid(leftNode)) && (!rightNode || isVoid(rightNode))) {
	            return true;
	        }
	        return false;
	    }
	
	    function prevPointUntil(point, pred) {
	        while (point) {
	            if (pred(point)) {
	                return point;
	            }
	            point = prevPoint(point);
	        }
	        return null;
	    }
	
	    function nextPointUntil(point, pred) {
	        while (point) {
	            if (pred(point)) {
	                return point;
	            }
	            point = nextPoint(point);
	        }
	        return null;
	    }
	
	    function isCharPoint(point) {
	        if (!isText(point.node)) {
	            return false;
	        }
	        var ch = point.node.nodeValue.charAt(point.offset - 1);
	        return ch && ch !== ' ' && ch !== NBSP_CHAR;
	    }
	
	    function walkPoint(startPoint, endPoint, handler, isSkipInnerOffset) {
	        var point = startPoint;
	        while (point) {
	            handler(point);
	            if (isSamePoint(point, endPoint)) {
	                break;
	            }
	            var isSkipOffset = isSkipInnerOffset && startPoint.node !== point.node && endPoint.node !== point.node;
	            point = nextPoint(point, isSkipOffset);
	        }
	    }
	
	    function makeOffsetPath(ancestor, node) {
	        var ancestors = listAncestor(node, func.eq(ancestor));
	        return ancestors.map(position).reverse();
	    }
	
	    function fromOffsetPath(ancestor, offsets) {
	        var current = ancestor;
	        for (var i = 0, len = offsets.length; i < len; i++) {
	            if (current.childNodes.length <= offsets[i]) {
	                current = current.childNodes[current.childNodes.length - 1];
	            } else {
	                current = current.childNodes[offsets[i]];
	            }
	        }
	        return current;
	    }
	
	    function splitNode(point, options) {
	        var isSkipPaddingBlankHTML = options && options.isSkipPaddingBlankHTML;
	        var isNotSplitEdgePoint = options && options.isNotSplitEdgePoint;
	
	        if (isEdgePoint(point) && (isText(point.node) || isNotSplitEdgePoint)) {
	            if (isLeftEdgePoint(point)) {
	                return point.node;
	            } else if (isRightEdgePoint(point)) {
	                return point.node.nextSibling;
	            }
	        }
	
	        if (isText(point.node)) {
	            return point.node.splitText(point.offset);
	        } else {
	            var childNode = point.node.childNodes[point.offset];
	            var clone = insertAfter(point.node.cloneNode(false), point.node);
	            appendChildNodes(clone, listNext(childNode));
	            if (!isSkipPaddingBlankHTML) {
	                paddingBlankHTML(point.node);
	                paddingBlankHTML(clone);
	            }
	            return clone;
	        }
	    }
	
	    function splitTree(root, point, options) {
	        var ancestors = listAncestor(point.node, func.eq(root));
	        if (!ancestors.length) {
	            return null;
	        } else if (ancestors.length === 1) {
	            return splitNode(point, options);
	        }
	        return ancestors.reduce(function (node, parent) {
	            if (node === point.node) {
	                node = splitNode(point, options);
	            }
	            return splitNode({
	                node: parent,
	                offset: node ? position(node) : nodeLength(parent)
	            }, options);
	        });
	    }
	
	    function splitPoint(point, isInline) {
	        var pred = isInline ? isPara : isBodyContainer;
	        var ancestors = listAncestor(point.node, pred);
	        var topAncestor = lists.last(ancestors) || point.node;
	        var splitRoot, container;
	        if (pred(topAncestor)) {
	            splitRoot = ancestors[ancestors.length - 2];
	            container = topAncestor;
	        } else {
	            splitRoot = topAncestor;
	            container = splitRoot.parentNode;
	        }
	
	        var pivot = splitRoot && splitTree(splitRoot, point, {
	            isSkipPaddingBlankHTML: isInline,
	            isNotSplitEdgePoint: isInline
	        });
	
	        if (!pivot && container === point.node) {
	            pivot = point.node.childNodes[point.offset];
	        }
	        return {
	            rightNode: pivot,
	            container: container
	        };
	    }
	    function create(nodeName) {
	        return document.createElement(nodeName);
	    }
	    function createText(text) {
	        return document.createTextNode(text);
	    }
	
	    function remove(node, isRemoveChild) {
	        if (!node || !node.parentNode) {
	            return;
	        }
	        if (node.removeNode) {
	            return node.removeNode(isRemoveChild);
	        }
	        var parent = node.parentNode;
	        if (!isRemoveChild) {
	            var nodes = [];
	            for (var i = 0, len = node.childNodes.length; i < len; i++) {
	                nodes.push(node.childNodes[i]);
	            }
	            for (var i = 0, len = nodes.length; i < len; i++) {
	                parent.insertBefore(nodes[i], node);
	            }
	        }
	        parent.removeChild(node);
	    }
	
	    function removeWhile(node, pred) {
	        while (node) {
	            if (isEditable(node) || !pred(node)) {
	                break;
	            }
	            var parent = node.parentNode;
	            remove(node);
	            node = parent;
	        }
	    }
	
	    function replace(node, nodeName) {
	        if (node.nodeName.toUpperCase() === nodeName.toUpperCase()) {
	            return node;
	        }
	        var newNode = create(nodeName);
	        if (node.style.cssText) {
	            newNode.style.cssText = node.style.cssText;
	        }
	        appendChildNodes(newNode, lists.from(node.childNodes));
	        insertAfter(newNode, node);
	        remove(node);
	        return newNode;
	    }
	    var isTextarea = makePredByNodeName('TEXTAREA');
	
	    function value($node, stripLinebreaks) {
	        var val = isTextarea($node[0]) ? $node.val() : $node.html();
	        if (stripLinebreaks) {
	            return val.replace(/[\n\r]/g, '');
	        }
	        return val;
	    }
	
	    function html($node, isNewlineOnBlock) {
	        var markup = value($node);
	        if (isNewlineOnBlock) {
	            var regexTag = /<(\/?)(\b(?!!)[^>\s]*)(.*?)(\s*\/?>)/g;
	            markup = markup.replace(regexTag, function (match, endSlash, name) {
	                name = name.toUpperCase();
	                var isEndOfInlineContainer = /^DIV|^TD|^TH|^P|^LI|^H[1-7]/.test(name) && !!endSlash;
	                var isBlockNode = /^BLOCKQUOTE|^TABLE|^TBODY|^TR|^HR|^UL|^OL/.test(name);
	                return match + (isEndOfInlineContainer || isBlockNode ? '\n' : '');
	            });
	            markup = $$1.trim(markup);
	        }
	        return markup;
	    }
	    function posFromPlaceholder(placeholder) {
	        var $placeholder = $$1(placeholder);
	        var pos = $placeholder.offset();
	        var height = $placeholder.outerHeight(true);
	        return {
	            left: pos.left,
	            top: pos.top + height
	        };
	    }
	    function attachEvents($node, events) {
	        (0, _keys2.default)(events).forEach(function (key) {
	            $node.on(key, events[key]);
	        });
	    }
	    function detachEvents($node, events) {
	        (0, _keys2.default)(events).forEach(function (key) {
	            $node.off(key, events[key]);
	        });
	    }
	
	    function isCustomStyleTag(node) {
	        return node && !isText(node) && lists.contains(node.classList, 'note-styletag');
	    }
	    var dom = {
	        NBSP_CHAR: NBSP_CHAR,
	
	        ZERO_WIDTH_NBSP_CHAR: ZERO_WIDTH_NBSP_CHAR,
	
	        blank: blankHTML,
	
	        emptyPara: "<p>" + blankHTML + "</p>",
	        makePredByNodeName: makePredByNodeName,
	        isEditable: isEditable,
	        isControlSizing: isControlSizing,
	        isText: isText,
	        isElement: isElement,
	        isVoid: isVoid,
	        isPara: isPara,
	        isPurePara: isPurePara,
	        isHeading: isHeading,
	        isInline: isInline,
	        isBlock: func.not(isInline),
	        isBodyInline: isBodyInline,
	        isBody: isBody,
	        isParaInline: isParaInline,
	        isPre: isPre,
	        isList: isList,
	        isTable: isTable,
	        isData: isData,
	        isCell: isCell,
	        isBlockquote: isBlockquote,
	        isBodyContainer: isBodyContainer,
	        isAnchor: isAnchor,
	        isDiv: makePredByNodeName('DIV'),
	        isLi: isLi,
	        isBR: makePredByNodeName('BR'),
	        isSpan: makePredByNodeName('SPAN'),
	        isB: makePredByNodeName('B'),
	        isU: makePredByNodeName('U'),
	        isS: makePredByNodeName('S'),
	        isI: makePredByNodeName('I'),
	        isImg: makePredByNodeName('IMG'),
	        isTextarea: isTextarea,
	        isEmpty: isEmpty,
	        isEmptyAnchor: func.and(isAnchor, isEmpty),
	        isClosestSibling: isClosestSibling,
	        withClosestSiblings: withClosestSiblings,
	        nodeLength: nodeLength,
	        isLeftEdgePoint: isLeftEdgePoint,
	        isRightEdgePoint: isRightEdgePoint,
	        isEdgePoint: isEdgePoint,
	        isLeftEdgeOf: isLeftEdgeOf,
	        isRightEdgeOf: isRightEdgeOf,
	        isLeftEdgePointOf: isLeftEdgePointOf,
	        isRightEdgePointOf: isRightEdgePointOf,
	        prevPoint: prevPoint,
	        nextPoint: nextPoint,
	        isSamePoint: isSamePoint,
	        isVisiblePoint: isVisiblePoint,
	        prevPointUntil: prevPointUntil,
	        nextPointUntil: nextPointUntil,
	        isCharPoint: isCharPoint,
	        walkPoint: walkPoint,
	        ancestor: ancestor,
	        singleChildAncestor: singleChildAncestor,
	        listAncestor: listAncestor,
	        lastAncestor: lastAncestor,
	        listNext: listNext,
	        listPrev: listPrev,
	        listDescendant: listDescendant,
	        commonAncestor: commonAncestor,
	        wrap: wrap,
	        insertAfter: insertAfter,
	        appendChildNodes: appendChildNodes,
	        position: position,
	        hasChildren: hasChildren,
	        makeOffsetPath: makeOffsetPath,
	        fromOffsetPath: fromOffsetPath,
	        splitTree: splitTree,
	        splitPoint: splitPoint,
	        create: create,
	        createText: createText,
	        remove: remove,
	        removeWhile: removeWhile,
	        replace: replace,
	        html: html,
	        value: value,
	        posFromPlaceholder: posFromPlaceholder,
	        attachEvents: attachEvents,
	        detachEvents: detachEvents,
	        isCustomStyleTag: isCustomStyleTag
	    };
	
	    $$1.summernote = $$1.summernote || {
	        lang: {}
	    };
	    $$1.extend($$1.summernote.lang, {
	        'en-US': {
	            font: {
	                bold: 'Bold',
	                italic: 'Italic',
	                underline: 'Underline',
	                clear: 'Remove Font Style',
	                height: 'Line Height',
	                name: 'Font Family',
	                strikethrough: 'Strikethrough',
	                subscript: 'Subscript',
	                superscript: 'Superscript',
	                size: 'Font Size'
	            },
	            image: {
	                image: 'Picture',
	                insert: 'Insert Image',
	                resizeFull: 'Resize Full',
	                resizeHalf: 'Resize Half',
	                resizeQuarter: 'Resize Quarter',
	                floatLeft: 'Float Left',
	                floatRight: 'Float Right',
	                floatNone: 'Float None',
	                shapeRounded: 'Shape: Rounded',
	                shapeCircle: 'Shape: Circle',
	                shapeThumbnail: 'Shape: Thumbnail',
	                shapeNone: 'Shape: None',
	                dragImageHere: 'Drag image or text here',
	                dropImage: 'Drop image or Text',
	                selectFromFiles: 'Select from files',
	                maximumFileSize: 'Maximum file size',
	                maximumFileSizeError: 'Maximum file size exceeded.',
	                url: 'Image URL',
	                remove: 'Remove Image',
	                original: 'Original'
	            },
	            video: {
	                video: 'Video',
	                videoLink: 'Video Link',
	                insert: 'Insert Video',
	                url: 'Video URL',
	                providers: '(YouTube, Vimeo, Vine, Instagram, DailyMotion or Youku)'
	            },
	            link: {
	                link: 'Link',
	                insert: 'Insert Link',
	                unlink: 'Unlink',
	                edit: 'Edit',
	                textToDisplay: 'Text to display',
	                url: 'To what URL should this link go?',
	                openInNewWindow: 'Open in new window'
	            },
	            table: {
	                table: 'Table',
	                addRowAbove: 'Add row above',
	                addRowBelow: 'Add row below',
	                addColLeft: 'Add column left',
	                addColRight: 'Add column right',
	                delRow: 'Delete row',
	                delCol: 'Delete column',
	                delTable: 'Delete table'
	            },
	            hr: {
	                insert: 'Insert Horizontal Rule'
	            },
	            style: {
	                style: 'Style',
	                p: 'Normal',
	                blockquote: 'Quote',
	                pre: 'Code',
	                h1: 'Header 1',
	                h2: 'Header 2',
	                h3: 'Header 3',
	                h4: 'Header 4',
	                h5: 'Header 5',
	                h6: 'Header 6'
	            },
	            lists: {
	                unordered: 'Unordered list',
	                ordered: 'Ordered list'
	            },
	            options: {
	                help: 'Help',
	                fullscreen: 'Full Screen',
	                codeview: 'Code View'
	            },
	            paragraph: {
	                paragraph: 'Paragraph',
	                outdent: 'Outdent',
	                indent: 'Indent',
	                left: 'Align left',
	                center: 'Align center',
	                right: 'Align right',
	                justify: 'Justify full'
	            },
	            color: {
	                recent: 'Recent Color',
	                more: 'More Color',
	                background: 'Background Color',
	                foreground: 'Foreground Color',
	                transparent: 'Transparent',
	                setTransparent: 'Set transparent',
	                reset: 'Reset',
	                resetToDefault: 'Reset to default'
	            },
	            shortcut: {
	                shortcuts: 'Keyboard shortcuts',
	                close: 'Close',
	                textFormatting: 'Text formatting',
	                action: 'Action',
	                paragraphFormatting: 'Paragraph formatting',
	                documentStyle: 'Document Style',
	                extraKeys: 'Extra keys'
	            },
	            help: {
	                'insertParagraph': 'Insert Paragraph',
	                'undo': 'Undoes the last command',
	                'redo': 'Redoes the last command',
	                'tab': 'Tab',
	                'untab': 'Untab',
	                'bold': 'Set a bold style',
	                'italic': 'Set a italic style',
	                'underline': 'Set a underline style',
	                'strikethrough': 'Set a strikethrough style',
	                'removeFormat': 'Clean a style',
	                'justifyLeft': 'Set left align',
	                'justifyCenter': 'Set center align',
	                'justifyRight': 'Set right align',
	                'justifyFull': 'Set full align',
	                'insertUnorderedList': 'Toggle unordered list',
	                'insertOrderedList': 'Toggle ordered list',
	                'outdent': 'Outdent on current paragraph',
	                'indent': 'Indent on current paragraph',
	                'formatPara': 'Change current block\'s format as a paragraph(P tag)',
	                'formatH1': 'Change current block\'s format as H1',
	                'formatH2': 'Change current block\'s format as H2',
	                'formatH3': 'Change current block\'s format as H3',
	                'formatH4': 'Change current block\'s format as H4',
	                'formatH5': 'Change current block\'s format as H5',
	                'formatH6': 'Change current block\'s format as H6',
	                'insertHorizontalRule': 'Insert horizontal rule',
	                'linkDialog.show': 'Show Link Dialog'
	            },
	            history: {
	                undo: 'Undo',
	                redo: 'Redo'
	            },
	            specialChar: {
	                specialChar: 'SPECIAL CHARACTERS',
	                select: 'Select Special characters'
	            }
	        }
	    });
	
	    var KEY_MAP = {
	        'BACKSPACE': 8,
	        'TAB': 9,
	        'ENTER': 13,
	        'SPACE': 32,
	        'DELETE': 46,
	
	        'LEFT': 37,
	        'UP': 38,
	        'RIGHT': 39,
	        'DOWN': 40,
	
	        'NUM0': 48,
	        'NUM1': 49,
	        'NUM2': 50,
	        'NUM3': 51,
	        'NUM4': 52,
	        'NUM5': 53,
	        'NUM6': 54,
	        'NUM7': 55,
	        'NUM8': 56,
	
	        'B': 66,
	        'E': 69,
	        'I': 73,
	        'J': 74,
	        'K': 75,
	        'L': 76,
	        'R': 82,
	        'S': 83,
	        'U': 85,
	        'V': 86,
	        'Y': 89,
	        'Z': 90,
	        'SLASH': 191,
	        'LEFTBRACKET': 219,
	        'BACKSLASH': 220,
	        'RIGHTBRACKET': 221
	    };
	
	    var key = {
	        isEdit: function isEdit(keyCode) {
	            return lists.contains([KEY_MAP.BACKSPACE, KEY_MAP.TAB, KEY_MAP.ENTER, KEY_MAP.SPACE, KEY_MAP.DELETE], keyCode);
	        },
	
	        isMove: function isMove(keyCode) {
	            return lists.contains([KEY_MAP.LEFT, KEY_MAP.UP, KEY_MAP.RIGHT, KEY_MAP.DOWN], keyCode);
	        },
	
	        nameFromCode: func.invertObject(KEY_MAP),
	        code: KEY_MAP
	    };
	
	    function textRangeToPoint(textRange, isStart) {
	        var container = textRange.parentElement();
	        var offset;
	        var tester = document.body.createTextRange();
	        var prevContainer;
	        var childNodes = lists.from(container.childNodes);
	        for (offset = 0; offset < childNodes.length; offset++) {
	            if (dom.isText(childNodes[offset])) {
	                continue;
	            }
	            tester.moveToElementText(childNodes[offset]);
	            if (tester.compareEndPoints('StartToStart', textRange) >= 0) {
	                break;
	            }
	            prevContainer = childNodes[offset];
	        }
	        if (offset !== 0 && dom.isText(childNodes[offset - 1])) {
	            var textRangeStart = document.body.createTextRange();
	            var curTextNode = null;
	            textRangeStart.moveToElementText(prevContainer || container);
	            textRangeStart.collapse(!prevContainer);
	            curTextNode = prevContainer ? prevContainer.nextSibling : container.firstChild;
	            var pointTester = textRange.duplicate();
	            pointTester.setEndPoint('StartToStart', textRangeStart);
	            var textCount = pointTester.text.replace(/[\r\n]/g, '').length;
	            while (textCount > curTextNode.nodeValue.length && curTextNode.nextSibling) {
	                textCount -= curTextNode.nodeValue.length;
	                curTextNode = curTextNode.nextSibling;
	            }
	
	            var dummy = curTextNode.nodeValue;
	            if (isStart && curTextNode.nextSibling && dom.isText(curTextNode.nextSibling) && textCount === curTextNode.nodeValue.length) {
	                textCount -= curTextNode.nodeValue.length;
	                curTextNode = curTextNode.nextSibling;
	            }
	            container = curTextNode;
	            offset = textCount;
	        }
	        return {
	            cont: container,
	            offset: offset
	        };
	    }
	
	    function pointToTextRange(point) {
	        var textRangeInfo = function textRangeInfo(container, offset) {
	            var node, isCollapseToStart;
	            if (dom.isText(container)) {
	                var prevTextNodes = dom.listPrev(container, func.not(dom.isText));
	                var prevContainer = lists.last(prevTextNodes).previousSibling;
	                node = prevContainer || container.parentNode;
	                offset += lists.sum(lists.tail(prevTextNodes), dom.nodeLength);
	                isCollapseToStart = !prevContainer;
	            } else {
	                node = container.childNodes[offset] || container;
	                if (dom.isText(node)) {
	                    return textRangeInfo(node, 0);
	                }
	                offset = 0;
	                isCollapseToStart = false;
	            }
	            return {
	                node: node,
	                collapseToStart: isCollapseToStart,
	                offset: offset
	            };
	        };
	        var textRange = document.body.createTextRange();
	        var info = textRangeInfo(point.node, point.offset);
	        textRange.moveToElementText(info.node);
	        textRange.collapse(info.collapseToStart);
	        textRange.moveStart('character', info.offset);
	        return textRange;
	    }
	
	    var WrappedRange = function () {
	        function WrappedRange(sc, so, ec, eo) {
	            this.sc = sc;
	            this.so = so;
	            this.ec = ec;
	            this.eo = eo;
	
	            this.isOnEditable = this.makeIsOn(dom.isEditable);
	
	            this.isOnList = this.makeIsOn(dom.isList);
	
	            this.isOnAnchor = this.makeIsOn(dom.isAnchor);
	
	            this.isOnCell = this.makeIsOn(dom.isCell);
	
	            this.isOnData = this.makeIsOn(dom.isData);
	        }
	
	        WrappedRange.prototype.nativeRange = function () {
	            if (env.isW3CRangeSupport) {
	                var w3cRange = document.createRange();
	                w3cRange.setStart(this.sc, this.so);
	                w3cRange.setEnd(this.ec, this.eo);
	                return w3cRange;
	            } else {
	                var textRange = pointToTextRange({
	                    node: this.sc,
	                    offset: this.so
	                });
	                textRange.setEndPoint('EndToEnd', pointToTextRange({
	                    node: this.ec,
	                    offset: this.eo
	                }));
	                return textRange;
	            }
	        };
	        WrappedRange.prototype.getPoints = function () {
	            return {
	                sc: this.sc,
	                so: this.so,
	                ec: this.ec,
	                eo: this.eo
	            };
	        };
	        WrappedRange.prototype.getStartPoint = function () {
	            return {
	                node: this.sc,
	                offset: this.so
	            };
	        };
	        WrappedRange.prototype.getEndPoint = function () {
	            return {
	                node: this.ec,
	                offset: this.eo
	            };
	        };
	
	        WrappedRange.prototype.select = function () {
	            var nativeRng = this.nativeRange();
	            if (env.isW3CRangeSupport) {
	                var selection = document.getSelection();
	                if (selection.rangeCount > 0) {
	                    selection.removeAllRanges();
	                }
	                selection.addRange(nativeRng);
	            } else {
	                nativeRng.select();
	            }
	            return this;
	        };
	
	        WrappedRange.prototype.scrollIntoView = function (container) {
	            var height = $$1(container).height();
	            if (container.scrollTop + height < this.sc.offsetTop) {
	                container.scrollTop += Math.abs(container.scrollTop + height - this.sc.offsetTop);
	            }
	            return this;
	        };
	
	        WrappedRange.prototype.normalize = function () {
	            var getVisiblePoint = function getVisiblePoint(point, isLeftToRight) {
	                if (dom.isVisiblePoint(point) && !dom.isEdgePoint(point) || dom.isVisiblePoint(point) && dom.isRightEdgePoint(point) && !isLeftToRight || dom.isVisiblePoint(point) && dom.isLeftEdgePoint(point) && isLeftToRight || dom.isVisiblePoint(point) && dom.isBlock(point.node) && dom.isEmpty(point.node)) {
	                    return point;
	                }
	
	                var block = dom.ancestor(point.node, dom.isBlock);
	                if ((dom.isLeftEdgePointOf(point, block) || dom.isVoid(dom.prevPoint(point).node)) && !isLeftToRight || (dom.isRightEdgePointOf(point, block) || dom.isVoid(dom.nextPoint(point).node)) && isLeftToRight) {
	                    if (dom.isVisiblePoint(point)) {
	                        return point;
	                    }
	
	                    isLeftToRight = !isLeftToRight;
	                }
	                var nextPoint = isLeftToRight ? dom.nextPointUntil(dom.nextPoint(point), dom.isVisiblePoint) : dom.prevPointUntil(dom.prevPoint(point), dom.isVisiblePoint);
	                return nextPoint || point;
	            };
	            var endPoint = getVisiblePoint(this.getEndPoint(), false);
	            var startPoint = this.isCollapsed() ? endPoint : getVisiblePoint(this.getStartPoint(), true);
	            return new WrappedRange(startPoint.node, startPoint.offset, endPoint.node, endPoint.offset);
	        };
	
	        WrappedRange.prototype.nodes = function (pred, options) {
	            pred = pred || func.ok;
	            var includeAncestor = options && options.includeAncestor;
	            var fullyContains = options && options.fullyContains;
	
	            var startPoint = this.getStartPoint();
	            var endPoint = this.getEndPoint();
	            var nodes = [];
	            var leftEdgeNodes = [];
	            dom.walkPoint(startPoint, endPoint, function (point) {
	                if (dom.isEditable(point.node)) {
	                    return;
	                }
	                var node;
	                if (fullyContains) {
	                    if (dom.isLeftEdgePoint(point)) {
	                        leftEdgeNodes.push(point.node);
	                    }
	                    if (dom.isRightEdgePoint(point) && lists.contains(leftEdgeNodes, point.node)) {
	                        node = point.node;
	                    }
	                } else if (includeAncestor) {
	                    node = dom.ancestor(point.node, pred);
	                } else {
	                    node = point.node;
	                }
	                if (node && pred(node)) {
	                    nodes.push(node);
	                }
	            }, true);
	            return lists.unique(nodes);
	        };
	
	        WrappedRange.prototype.commonAncestor = function () {
	            return dom.commonAncestor(this.sc, this.ec);
	        };
	
	        WrappedRange.prototype.expand = function (pred) {
	            var startAncestor = dom.ancestor(this.sc, pred);
	            var endAncestor = dom.ancestor(this.ec, pred);
	            if (!startAncestor && !endAncestor) {
	                return new WrappedRange(this.sc, this.so, this.ec, this.eo);
	            }
	            var boundaryPoints = this.getPoints();
	            if (startAncestor) {
	                boundaryPoints.sc = startAncestor;
	                boundaryPoints.so = 0;
	            }
	            if (endAncestor) {
	                boundaryPoints.ec = endAncestor;
	                boundaryPoints.eo = dom.nodeLength(endAncestor);
	            }
	            return new WrappedRange(boundaryPoints.sc, boundaryPoints.so, boundaryPoints.ec, boundaryPoints.eo);
	        };
	
	        WrappedRange.prototype.collapse = function (isCollapseToStart) {
	            if (isCollapseToStart) {
	                return new WrappedRange(this.sc, this.so, this.sc, this.so);
	            } else {
	                return new WrappedRange(this.ec, this.eo, this.ec, this.eo);
	            }
	        };
	
	        WrappedRange.prototype.splitText = function () {
	            var isSameContainer = this.sc === this.ec;
	            var boundaryPoints = this.getPoints();
	            if (dom.isText(this.ec) && !dom.isEdgePoint(this.getEndPoint())) {
	                this.ec.splitText(this.eo);
	            }
	            if (dom.isText(this.sc) && !dom.isEdgePoint(this.getStartPoint())) {
	                boundaryPoints.sc = this.sc.splitText(this.so);
	                boundaryPoints.so = 0;
	                if (isSameContainer) {
	                    boundaryPoints.ec = boundaryPoints.sc;
	                    boundaryPoints.eo = this.eo - this.so;
	                }
	            }
	            return new WrappedRange(boundaryPoints.sc, boundaryPoints.so, boundaryPoints.ec, boundaryPoints.eo);
	        };
	
	        WrappedRange.prototype.deleteContents = function () {
	            if (this.isCollapsed()) {
	                return this;
	            }
	            var rng = this.splitText();
	            var nodes = rng.nodes(null, {
	                fullyContains: true
	            });
	
	            var point = dom.prevPointUntil(rng.getStartPoint(), function (point) {
	                return !lists.contains(nodes, point.node);
	            });
	            var emptyParents = [];
	            $$1.each(nodes, function (idx, node) {
	                var parent = node.parentNode;
	                if (point.node !== parent && dom.nodeLength(parent) === 1) {
	                    emptyParents.push(parent);
	                }
	                dom.remove(node, false);
	            });
	
	            $$1.each(emptyParents, function (idx, node) {
	                dom.remove(node, false);
	            });
	            return new WrappedRange(point.node, point.offset, point.node, point.offset).normalize();
	        };
	
	        WrappedRange.prototype.makeIsOn = function (pred) {
	            return function () {
	                var ancestor = dom.ancestor(this.sc, pred);
	                return !!ancestor && ancestor === dom.ancestor(this.ec, pred);
	            };
	        };
	
	        WrappedRange.prototype.isLeftEdgeOf = function (pred) {
	            if (!dom.isLeftEdgePoint(this.getStartPoint())) {
	                return false;
	            }
	            var node = dom.ancestor(this.sc, pred);
	            return node && dom.isLeftEdgeOf(this.sc, node);
	        };
	
	        WrappedRange.prototype.isCollapsed = function () {
	            return this.sc === this.ec && this.so === this.eo;
	        };
	
	        WrappedRange.prototype.wrapBodyInlineWithPara = function () {
	            if (dom.isBodyContainer(this.sc) && dom.isEmpty(this.sc)) {
	                this.sc.innerHTML = dom.emptyPara;
	                return new WrappedRange(this.sc.firstChild, 0, this.sc.firstChild, 0);
	            }
	
	            var rng = this.normalize();
	            if (dom.isParaInline(this.sc) || dom.isPara(this.sc)) {
	                return rng;
	            }
	
	            var topAncestor;
	            if (dom.isInline(rng.sc)) {
	                var ancestors = dom.listAncestor(rng.sc, func.not(dom.isInline));
	                topAncestor = lists.last(ancestors);
	                if (!dom.isInline(topAncestor)) {
	                    topAncestor = ancestors[ancestors.length - 2] || rng.sc.childNodes[rng.so];
	                }
	            } else {
	                topAncestor = rng.sc.childNodes[rng.so > 0 ? rng.so - 1 : 0];
	            }
	
	            var inlineSiblings = dom.listPrev(topAncestor, dom.isParaInline).reverse();
	            inlineSiblings = inlineSiblings.concat(dom.listNext(topAncestor.nextSibling, dom.isParaInline));
	
	            if (inlineSiblings.length) {
	                var para = dom.wrap(lists.head(inlineSiblings), 'p');
	                dom.appendChildNodes(para, lists.tail(inlineSiblings));
	            }
	            return this.normalize();
	        };
	
	        WrappedRange.prototype.insertNode = function (node) {
	            var rng = this.wrapBodyInlineWithPara().deleteContents();
	            var info = dom.splitPoint(rng.getStartPoint(), dom.isInline(node));
	            if (info.rightNode) {
	                info.rightNode.parentNode.insertBefore(node, info.rightNode);
	            } else {
	                info.container.appendChild(node);
	            }
	            return node;
	        };
	
	        WrappedRange.prototype.pasteHTML = function (markup) {
	            var contentsContainer = $$1('<div></div>').html(markup)[0];
	            var childNodes = lists.from(contentsContainer.childNodes);
	            var rng = this.wrapBodyInlineWithPara().deleteContents();
	            return childNodes.reverse().map(function (childNode) {
	                return rng.insertNode(childNode);
	            }).reverse();
	        };
	
	        WrappedRange.prototype.toString = function () {
	            var nativeRng = this.nativeRange();
	            return env.isW3CRangeSupport ? nativeRng.toString() : nativeRng.text;
	        };
	
	        WrappedRange.prototype.getWordRange = function (findAfter) {
	            var endPoint = this.getEndPoint();
	            if (!dom.isCharPoint(endPoint)) {
	                return this;
	            }
	            var startPoint = dom.prevPointUntil(endPoint, function (point) {
	                return !dom.isCharPoint(point);
	            });
	            if (findAfter) {
	                endPoint = dom.nextPointUntil(endPoint, function (point) {
	                    return !dom.isCharPoint(point);
	                });
	            }
	            return new WrappedRange(startPoint.node, startPoint.offset, endPoint.node, endPoint.offset);
	        };
	
	        WrappedRange.prototype.bookmark = function (editable) {
	            return {
	                s: {
	                    path: dom.makeOffsetPath(editable, this.sc),
	                    offset: this.so
	                },
	                e: {
	                    path: dom.makeOffsetPath(editable, this.ec),
	                    offset: this.eo
	                }
	            };
	        };
	
	        WrappedRange.prototype.paraBookmark = function (paras) {
	            return {
	                s: {
	                    path: lists.tail(dom.makeOffsetPath(lists.head(paras), this.sc)),
	                    offset: this.so
	                },
	                e: {
	                    path: lists.tail(dom.makeOffsetPath(lists.last(paras), this.ec)),
	                    offset: this.eo
	                }
	            };
	        };
	
	        WrappedRange.prototype.getClientRects = function () {
	            var nativeRng = this.nativeRange();
	            return nativeRng.getClientRects();
	        };
	        return WrappedRange;
	    }();
	
	    var range = {
	        create: function create(sc, so, ec, eo) {
	            if (arguments.length === 4) {
	                return new WrappedRange(sc, so, ec, eo);
	            } else if (arguments.length === 2) {
	                ec = sc;
	                eo = so;
	                return new WrappedRange(sc, so, ec, eo);
	            } else {
	                var wrappedRange = this.createFromSelection();
	                if (!wrappedRange && arguments.length === 1) {
	                    wrappedRange = this.createFromNode(arguments[0]);
	                    return wrappedRange.collapse(dom.emptyPara === arguments[0].innerHTML);
	                }
	                return wrappedRange;
	            }
	        },
	        createFromSelection: function createFromSelection() {
	            var sc, so, ec, eo;
	            if (env.isW3CRangeSupport) {
	                var selection = document.getSelection();
	                if (!selection || selection.rangeCount === 0) {
	                    return null;
	                } else if (dom.isBody(selection.anchorNode)) {
	                    return null;
	                }
	                var nativeRng = selection.getRangeAt(0);
	                sc = nativeRng.startContainer;
	                so = nativeRng.startOffset;
	                ec = nativeRng.endContainer;
	                eo = nativeRng.endOffset;
	            } else {
	                var textRange = document.selection.createRange();
	                var textRangeEnd = textRange.duplicate();
	                textRangeEnd.collapse(false);
	                var textRangeStart = textRange;
	                textRangeStart.collapse(true);
	                var startPoint = textRangeToPoint(textRangeStart, true);
	                var endPoint = textRangeToPoint(textRangeEnd, false);
	
	                if (dom.isText(startPoint.node) && dom.isLeftEdgePoint(startPoint) && dom.isTextNode(endPoint.node) && dom.isRightEdgePoint(endPoint) && endPoint.node.nextSibling === startPoint.node) {
	                    startPoint = endPoint;
	                }
	                sc = startPoint.cont;
	                so = startPoint.offset;
	                ec = endPoint.cont;
	                eo = endPoint.offset;
	            }
	            return new WrappedRange(sc, so, ec, eo);
	        },
	
	        createFromNode: function createFromNode(node) {
	            var sc = node;
	            var so = 0;
	            var ec = node;
	            var eo = dom.nodeLength(ec);
	
	            if (dom.isVoid(sc)) {
	                so = dom.listPrev(sc).length - 1;
	                sc = sc.parentNode;
	            }
	            if (dom.isBR(ec)) {
	                eo = dom.listPrev(ec).length - 1;
	                ec = ec.parentNode;
	            } else if (dom.isVoid(ec)) {
	                eo = dom.listPrev(ec).length;
	                ec = ec.parentNode;
	            }
	            return this.create(sc, so, ec, eo);
	        },
	
	        createFromNodeBefore: function createFromNodeBefore(node) {
	            return this.createFromNode(node).collapse(true);
	        },
	
	        createFromNodeAfter: function createFromNodeAfter(node) {
	            return this.createFromNode(node).collapse();
	        },
	
	        createFromBookmark: function createFromBookmark(editable, bookmark) {
	            var sc = dom.fromOffsetPath(editable, bookmark.s.path);
	            var so = bookmark.s.offset;
	            var ec = dom.fromOffsetPath(editable, bookmark.e.path);
	            var eo = bookmark.e.offset;
	            return new WrappedRange(sc, so, ec, eo);
	        },
	
	        createFromParaBookmark: function createFromParaBookmark(bookmark, paras) {
	            var so = bookmark.s.offset;
	            var eo = bookmark.e.offset;
	            var sc = dom.fromOffsetPath(lists.head(paras), bookmark.s.path);
	            var ec = dom.fromOffsetPath(lists.last(paras), bookmark.e.path);
	            return new WrappedRange(sc, so, ec, eo);
	        }
	    };
	
	    function readFileAsDataURL(file) {
	        return $$1.Deferred(function (deferred) {
	            $$1.extend(new FileReader(), {
	                onload: function onload(e) {
	                    var dataURL = e.target.result;
	                    deferred.resolve(dataURL);
	                },
	                onerror: function onerror(err) {
	                    deferred.reject(err);
	                }
	            }).readAsDataURL(file);
	        }).promise();
	    }
	
	    function createImage(url) {
	        return $$1.Deferred(function (deferred) {
	            var $img = $$1('<img>');
	            $img.one('load', function () {
	                $img.off('error abort');
	                deferred.resolve($img);
	            }).one('error abort', function () {
	                $img.off('load').detach();
	                deferred.reject($img);
	            }).css({
	                display: 'none'
	            }).appendTo(document.body).attr('src', url);
	        }).promise();
	    }
	
	    var History = function () {
	        function History($editable) {
	            this.stack = [];
	            this.stackOffset = -1;
	            this.$editable = $editable;
	            this.editable = $editable[0];
	        }
	        History.prototype.makeSnapshot = function () {
	            var rng = range.create(this.editable);
	            var emptyBookmark = { s: { path: [], offset: 0 }, e: { path: [], offset: 0 } };
	            return {
	                contents: this.$editable.html(),
	                bookmark: rng ? rng.bookmark(this.editable) : emptyBookmark
	            };
	        };
	        History.prototype.applySnapshot = function (snapshot) {
	            if (snapshot.contents !== null) {
	                this.$editable.html(snapshot.contents);
	            }
	            if (snapshot.bookmark !== null) {
	                range.createFromBookmark(this.editable, snapshot.bookmark).select();
	            }
	        };
	
	        History.prototype.rewind = function () {
	            if (this.$editable.html() !== this.stack[this.stackOffset].contents) {
	                this.recordUndo();
	            }
	
	            this.stackOffset = 0;
	
	            this.applySnapshot(this.stack[this.stackOffset]);
	        };
	
	        History.prototype.reset = function () {
	            this.stack = [];
	
	            this.stackOffset = -1;
	
	            this.$editable.html('');
	
	            this.recordUndo();
	        };
	
	        History.prototype.undo = function () {
	            if (this.$editable.html() !== this.stack[this.stackOffset].contents) {
	                this.recordUndo();
	            }
	            if (this.stackOffset > 0) {
	                this.stackOffset--;
	                this.applySnapshot(this.stack[this.stackOffset]);
	            }
	        };
	
	        History.prototype.redo = function () {
	            if (this.stack.length - 1 > this.stackOffset) {
	                this.stackOffset++;
	                this.applySnapshot(this.stack[this.stackOffset]);
	            }
	        };
	
	        History.prototype.recordUndo = function () {
	            this.stackOffset++;
	
	            if (this.stack.length > this.stackOffset) {
	                this.stack = this.stack.slice(0, this.stackOffset);
	            }
	
	            this.stack.push(this.makeSnapshot());
	        };
	        return History;
	    }();
	
	    var Style = function () {
	        function Style() {}
	
	        Style.prototype.jQueryCSS = function ($obj, propertyNames) {
	            if (env.jqueryVersion < 1.9) {
	                var result_1 = {};
	                $$1.each(propertyNames, function (idx, propertyName) {
	                    result_1[propertyName] = $obj.css(propertyName);
	                });
	                return result_1;
	            }
	            return $obj.css(propertyNames);
	        };
	
	        Style.prototype.fromNode = function ($node) {
	            var properties = ['font-family', 'font-size', 'text-align', 'list-style-type', 'line-height'];
	            var styleInfo = this.jQueryCSS($node, properties) || {};
	            styleInfo['font-size'] = parseInt(styleInfo['font-size'], 10);
	            return styleInfo;
	        };
	
	        Style.prototype.stylePara = function (rng, styleInfo) {
	            $$1.each(rng.nodes(dom.isPara, {
	                includeAncestor: true
	            }), function (idx, para) {
	                $$1(para).css(styleInfo);
	            });
	        };
	
	        Style.prototype.styleNodes = function (rng, options) {
	            rng = rng.splitText();
	            var nodeName = options && options.nodeName || 'SPAN';
	            var expandClosestSibling = !!(options && options.expandClosestSibling);
	            var onlyPartialContains = !!(options && options.onlyPartialContains);
	            if (rng.isCollapsed()) {
	                return [rng.insertNode(dom.create(nodeName))];
	            }
	            var pred = dom.makePredByNodeName(nodeName);
	            var nodes = rng.nodes(dom.isText, {
	                fullyContains: true
	            }).map(function (text) {
	                return dom.singleChildAncestor(text, pred) || dom.wrap(text, nodeName);
	            });
	            if (expandClosestSibling) {
	                if (onlyPartialContains) {
	                    var nodesInRange_1 = rng.nodes();
	
	                    pred = func.and(pred, function (node) {
	                        return lists.contains(nodesInRange_1, node);
	                    });
	                }
	                return nodes.map(function (node) {
	                    var siblings = dom.withClosestSiblings(node, pred);
	                    var head = lists.head(siblings);
	                    var tails = lists.tail(siblings);
	                    $$1.each(tails, function (idx, elem) {
	                        dom.appendChildNodes(head, elem.childNodes);
	                        dom.remove(elem);
	                    });
	                    return lists.head(siblings);
	                });
	            } else {
	                return nodes;
	            }
	        };
	
	        Style.prototype.current = function (rng) {
	            var $cont = $$1(!dom.isElement(rng.sc) ? rng.sc.parentNode : rng.sc);
	            var styleInfo = this.fromNode($cont);
	
	            try {
	                styleInfo = $$1.extend(styleInfo, {
	                    'font-bold': document.queryCommandState('bold') ? 'bold' : 'normal',
	                    'font-italic': document.queryCommandState('italic') ? 'italic' : 'normal',
	                    'font-underline': document.queryCommandState('underline') ? 'underline' : 'normal',
	                    'font-subscript': document.queryCommandState('subscript') ? 'subscript' : 'normal',
	                    'font-superscript': document.queryCommandState('superscript') ? 'superscript' : 'normal',
	                    'font-strikethrough': document.queryCommandState('strikethrough') ? 'strikethrough' : 'normal',
	                    'font-family': document.queryCommandValue('fontname') || styleInfo['font-family']
	                });
	            } catch (e) {}
	
	            if (!rng.isOnList()) {
	                styleInfo['list-style'] = 'none';
	            } else {
	                var orderedTypes = ['circle', 'disc', 'disc-leading-zero', 'square'];
	                var isUnordered = $$1.inArray(styleInfo['list-style-type'], orderedTypes) > -1;
	                styleInfo['list-style'] = isUnordered ? 'unordered' : 'ordered';
	            }
	            var para = dom.ancestor(rng.sc, dom.isPara);
	            if (para && para.style['line-height']) {
	                styleInfo['line-height'] = para.style.lineHeight;
	            } else {
	                var lineHeight = parseInt(styleInfo['line-height'], 10) / parseInt(styleInfo['font-size'], 10);
	                styleInfo['line-height'] = lineHeight.toFixed(1);
	            }
	            styleInfo.anchor = rng.isOnAnchor() && dom.ancestor(rng.sc, dom.isAnchor);
	            styleInfo.ancestors = dom.listAncestor(rng.sc, dom.isEditable);
	            styleInfo.range = rng;
	            return styleInfo;
	        };
	        return Style;
	    }();
	
	    var Bullet = function () {
	        function Bullet() {}
	
	        Bullet.prototype.insertOrderedList = function (editable) {
	            this.toggleList('OL', editable);
	        };
	
	        Bullet.prototype.insertUnorderedList = function (editable) {
	            this.toggleList('UL', editable);
	        };
	
	        Bullet.prototype.indent = function (editable) {
	            var _this = this;
	            var rng = range.create(editable).wrapBodyInlineWithPara();
	            var paras = rng.nodes(dom.isPara, { includeAncestor: true });
	            var clustereds = lists.clusterBy(paras, func.peq2('parentNode'));
	            $$1.each(clustereds, function (idx, paras) {
	                var head = lists.head(paras);
	                if (dom.isLi(head)) {
	                    _this.wrapList(paras, head.parentNode.nodeName);
	                } else {
	                    $$1.each(paras, function (idx, para) {
	                        $$1(para).css('marginLeft', function (idx, val) {
	                            return (parseInt(val, 10) || 0) + 25;
	                        });
	                    });
	                }
	            });
	            rng.select();
	        };
	
	        Bullet.prototype.outdent = function (editable) {
	            var _this = this;
	            var rng = range.create(editable).wrapBodyInlineWithPara();
	            var paras = rng.nodes(dom.isPara, { includeAncestor: true });
	            var clustereds = lists.clusterBy(paras, func.peq2('parentNode'));
	            $$1.each(clustereds, function (idx, paras) {
	                var head = lists.head(paras);
	                if (dom.isLi(head)) {
	                    _this.releaseList([paras]);
	                } else {
	                    $$1.each(paras, function (idx, para) {
	                        $$1(para).css('marginLeft', function (idx, val) {
	                            val = parseInt(val, 10) || 0;
	                            return val > 25 ? val - 25 : '';
	                        });
	                    });
	                }
	            });
	            rng.select();
	        };
	
	        Bullet.prototype.toggleList = function (listName, editable) {
	            var _this = this;
	            var rng = range.create(editable).wrapBodyInlineWithPara();
	            var paras = rng.nodes(dom.isPara, { includeAncestor: true });
	            var bookmark = rng.paraBookmark(paras);
	            var clustereds = lists.clusterBy(paras, func.peq2('parentNode'));
	
	            if (lists.find(paras, dom.isPurePara)) {
	                var wrappedParas_1 = [];
	                $$1.each(clustereds, function (idx, paras) {
	                    wrappedParas_1 = wrappedParas_1.concat(_this.wrapList(paras, listName));
	                });
	                paras = wrappedParas_1;
	            } else {
	                var diffLists = rng.nodes(dom.isList, {
	                    includeAncestor: true
	                }).filter(function (listNode) {
	                    return !$$1.nodeName(listNode, listName);
	                });
	                if (diffLists.length) {
	                    $$1.each(diffLists, function (idx, listNode) {
	                        dom.replace(listNode, listName);
	                    });
	                } else {
	                    paras = this.releaseList(clustereds, true);
	                }
	            }
	            range.createFromParaBookmark(bookmark, paras).select();
	        };
	
	        Bullet.prototype.wrapList = function (paras, listName) {
	            var head = lists.head(paras);
	            var last = lists.last(paras);
	            var prevList = dom.isList(head.previousSibling) && head.previousSibling;
	            var nextList = dom.isList(last.nextSibling) && last.nextSibling;
	            var listNode = prevList || dom.insertAfter(dom.create(listName || 'UL'), last);
	
	            paras = paras.map(function (para) {
	                return dom.isPurePara(para) ? dom.replace(para, 'LI') : para;
	            });
	
	            dom.appendChildNodes(listNode, paras);
	            if (nextList) {
	                dom.appendChildNodes(listNode, lists.from(nextList.childNodes));
	                dom.remove(nextList);
	            }
	            return paras;
	        };
	
	        Bullet.prototype.releaseList = function (clustereds, isEscapseToBody) {
	            var releasedParas = [];
	            $$1.each(clustereds, function (idx, paras) {
	                var head = lists.head(paras);
	                var last = lists.last(paras);
	                var headList = isEscapseToBody ? dom.lastAncestor(head, dom.isList) : head.parentNode;
	                var lastList = headList.childNodes.length > 1 ? dom.splitTree(headList, {
	                    node: last.parentNode,
	                    offset: dom.position(last) + 1
	                }, {
	                    isSkipPaddingBlankHTML: true
	                }) : null;
	                var middleList = dom.splitTree(headList, {
	                    node: head.parentNode,
	                    offset: dom.position(head)
	                }, {
	                    isSkipPaddingBlankHTML: true
	                });
	                paras = isEscapseToBody ? dom.listDescendant(middleList, dom.isLi) : lists.from(middleList.childNodes).filter(dom.isLi);
	
	                if (isEscapseToBody || !dom.isList(headList.parentNode)) {
	                    paras = paras.map(function (para) {
	                        return dom.replace(para, 'P');
	                    });
	                }
	                $$1.each(lists.from(paras).reverse(), function (idx, para) {
	                    dom.insertAfter(para, headList);
	                });
	
	                var rootLists = lists.compact([headList, middleList, lastList]);
	                $$1.each(rootLists, function (idx, rootList) {
	                    var listNodes = [rootList].concat(dom.listDescendant(rootList, dom.isList));
	                    $$1.each(listNodes.reverse(), function (idx, listNode) {
	                        if (!dom.nodeLength(listNode)) {
	                            dom.remove(listNode, true);
	                        }
	                    });
	                });
	                releasedParas = releasedParas.concat(paras);
	            });
	            return releasedParas;
	        };
	        return Bullet;
	    }();
	
	    var Typing = function () {
	        function Typing() {
	            this.bullet = new Bullet();
	        }
	
	        Typing.prototype.insertTab = function (rng, tabsize) {
	            var tab = dom.createText(new Array(tabsize + 1).join(dom.NBSP_CHAR));
	            rng = rng.deleteContents();
	            rng.insertNode(tab, true);
	            rng = range.create(tab, tabsize);
	            rng.select();
	        };
	
	        Typing.prototype.insertParagraph = function (editable) {
	            var rng = range.create(editable);
	
	            rng = rng.deleteContents();
	
	            rng = rng.wrapBodyInlineWithPara();
	
	            var splitRoot = dom.ancestor(rng.sc, dom.isPara);
	            var nextPara;
	
	            if (splitRoot) {
	                if (dom.isEmpty(splitRoot) && dom.isLi(splitRoot)) {
	                    this.bullet.toggleList(splitRoot.parentNode.nodeName);
	                    return;
	                } else if (dom.isEmpty(splitRoot) && dom.isPara(splitRoot) && dom.isBlockquote(splitRoot.parentNode)) {
	                    dom.insertAfter(splitRoot, splitRoot.parentNode);
	                    nextPara = splitRoot;
	                } else {
	                    nextPara = dom.splitTree(splitRoot, rng.getStartPoint());
	                    var emptyAnchors = dom.listDescendant(splitRoot, dom.isEmptyAnchor);
	                    emptyAnchors = emptyAnchors.concat(dom.listDescendant(nextPara, dom.isEmptyAnchor));
	                    $$1.each(emptyAnchors, function (idx, anchor) {
	                        dom.remove(anchor);
	                    });
	
	                    if ((dom.isHeading(nextPara) || dom.isPre(nextPara) || dom.isCustomStyleTag(nextPara)) && dom.isEmpty(nextPara)) {
	                        nextPara = dom.replace(nextPara, 'p');
	                    }
	                }
	            } else {
	                var next = rng.sc.childNodes[rng.so];
	                nextPara = $$1(dom.emptyPara)[0];
	                if (next) {
	                    rng.sc.insertBefore(nextPara, next);
	                } else {
	                    rng.sc.appendChild(nextPara);
	                }
	            }
	            range.create(nextPara, 0).normalize().select().scrollIntoView(editable);
	        };
	        return Typing;
	    }();
	
	    var TableResultAction = function TableResultAction(startPoint, where, action, domTable) {
	        var _startPoint = { 'colPos': 0, 'rowPos': 0 };
	        var _virtualTable = [];
	        var _actionCellList = [];
	
	        function setStartPoint() {
	            if (!startPoint || !startPoint.tagName || startPoint.tagName.toLowerCase() !== 'td' && startPoint.tagName.toLowerCase() !== 'th') {
	                console.error('Impossible to identify start Cell point.', startPoint);
	                return;
	            }
	            _startPoint.colPos = startPoint.cellIndex;
	            if (!startPoint.parentElement || !startPoint.parentElement.tagName || startPoint.parentElement.tagName.toLowerCase() !== 'tr') {
	                console.error('Impossible to identify start Row point.', startPoint);
	                return;
	            }
	            _startPoint.rowPos = startPoint.parentElement.rowIndex;
	        }
	
	        function setVirtualTablePosition(rowIndex, cellIndex, baseRow, baseCell, isRowSpan, isColSpan, isVirtualCell) {
	            var objPosition = {
	                'baseRow': baseRow,
	                'baseCell': baseCell,
	                'isRowSpan': isRowSpan,
	                'isColSpan': isColSpan,
	                'isVirtual': isVirtualCell
	            };
	            if (!_virtualTable[rowIndex]) {
	                _virtualTable[rowIndex] = [];
	            }
	            _virtualTable[rowIndex][cellIndex] = objPosition;
	        }
	
	        function getActionCell(virtualTableCellObj, resultAction, virtualRowPosition, virtualColPosition) {
	            return {
	                'baseCell': virtualTableCellObj.baseCell,
	                'action': resultAction,
	                'virtualTable': {
	                    'rowIndex': virtualRowPosition,
	                    'cellIndex': virtualColPosition
	                }
	            };
	        }
	
	        function recoverCellIndex(rowIndex, cellIndex) {
	            if (!_virtualTable[rowIndex]) {
	                return cellIndex;
	            }
	            if (!_virtualTable[rowIndex][cellIndex]) {
	                return cellIndex;
	            }
	            var newCellIndex = cellIndex;
	            while (_virtualTable[rowIndex][newCellIndex]) {
	                newCellIndex++;
	                if (!_virtualTable[rowIndex][newCellIndex]) {
	                    return newCellIndex;
	                }
	            }
	        }
	
	        function addCellInfoToVirtual(row, cell) {
	            var cellIndex = recoverCellIndex(row.rowIndex, cell.cellIndex);
	            var cellHasColspan = cell.colSpan > 1;
	            var cellHasRowspan = cell.rowSpan > 1;
	            var isThisSelectedCell = row.rowIndex === _startPoint.rowPos && cell.cellIndex === _startPoint.colPos;
	            setVirtualTablePosition(row.rowIndex, cellIndex, row, cell, cellHasRowspan, cellHasColspan, false);
	
	            var rowspanNumber = cell.attributes.rowSpan ? parseInt(cell.attributes.rowSpan.value, 10) : 0;
	            if (rowspanNumber > 1) {
	                for (var rp = 1; rp < rowspanNumber; rp++) {
	                    var rowspanIndex = row.rowIndex + rp;
	                    adjustStartPoint(rowspanIndex, cellIndex, cell, isThisSelectedCell);
	                    setVirtualTablePosition(rowspanIndex, cellIndex, row, cell, true, cellHasColspan, true);
	                }
	            }
	
	            var colspanNumber = cell.attributes.colSpan ? parseInt(cell.attributes.colSpan.value, 10) : 0;
	            if (colspanNumber > 1) {
	                for (var cp = 1; cp < colspanNumber; cp++) {
	                    var cellspanIndex = recoverCellIndex(row.rowIndex, cellIndex + cp);
	                    adjustStartPoint(row.rowIndex, cellspanIndex, cell, isThisSelectedCell);
	                    setVirtualTablePosition(row.rowIndex, cellspanIndex, row, cell, cellHasRowspan, true, true);
	                }
	            }
	        }
	
	        function adjustStartPoint(rowIndex, cellIndex, cell, isSelectedCell) {
	            if (rowIndex === _startPoint.rowPos && _startPoint.colPos >= cell.cellIndex && cell.cellIndex <= cellIndex && !isSelectedCell) {
	                _startPoint.colPos++;
	            }
	        }
	
	        function createVirtualTable() {
	            var rows = domTable.rows;
	            for (var rowIndex = 0; rowIndex < rows.length; rowIndex++) {
	                var cells = rows[rowIndex].cells;
	                for (var cellIndex = 0; cellIndex < cells.length; cellIndex++) {
	                    addCellInfoToVirtual(rows[rowIndex], cells[cellIndex]);
	                }
	            }
	        }
	
	        function getDeleteResultActionToCell(cell) {
	            switch (where) {
	                case TableResultAction.where.Column:
	                    if (cell.isColSpan) {
	                        return TableResultAction.resultAction.SubtractSpanCount;
	                    }
	                    break;
	                case TableResultAction.where.Row:
	                    if (!cell.isVirtual && cell.isRowSpan) {
	                        return TableResultAction.resultAction.AddCell;
	                    } else if (cell.isRowSpan) {
	                        return TableResultAction.resultAction.SubtractSpanCount;
	                    }
	                    break;
	            }
	            return TableResultAction.resultAction.RemoveCell;
	        }
	
	        function getAddResultActionToCell(cell) {
	            switch (where) {
	                case TableResultAction.where.Column:
	                    if (cell.isColSpan) {
	                        return TableResultAction.resultAction.SumSpanCount;
	                    } else if (cell.isRowSpan && cell.isVirtual) {
	                        return TableResultAction.resultAction.Ignore;
	                    }
	                    break;
	                case TableResultAction.where.Row:
	                    if (cell.isRowSpan) {
	                        return TableResultAction.resultAction.SumSpanCount;
	                    } else if (cell.isColSpan && cell.isVirtual) {
	                        return TableResultAction.resultAction.Ignore;
	                    }
	                    break;
	            }
	            return TableResultAction.resultAction.AddCell;
	        }
	        function init() {
	            setStartPoint();
	            createVirtualTable();
	        }
	
	        this.getActionList = function () {
	            var fixedRow = where === TableResultAction.where.Row ? _startPoint.rowPos : -1;
	            var fixedCol = where === TableResultAction.where.Column ? _startPoint.colPos : -1;
	            var actualPosition = 0;
	            var canContinue = true;
	            while (canContinue) {
	                var rowPosition = fixedRow >= 0 ? fixedRow : actualPosition;
	                var colPosition = fixedCol >= 0 ? fixedCol : actualPosition;
	                var row = _virtualTable[rowPosition];
	                if (!row) {
	                    canContinue = false;
	                    return _actionCellList;
	                }
	                var cell = row[colPosition];
	                if (!cell) {
	                    canContinue = false;
	                    return _actionCellList;
	                }
	
	                var resultAction = TableResultAction.resultAction.Ignore;
	                switch (action) {
	                    case TableResultAction.requestAction.Add:
	                        resultAction = getAddResultActionToCell(cell);
	                        break;
	                    case TableResultAction.requestAction.Delete:
	                        resultAction = getDeleteResultActionToCell(cell);
	                        break;
	                }
	                _actionCellList.push(getActionCell(cell, resultAction, rowPosition, colPosition));
	                actualPosition++;
	            }
	            return _actionCellList;
	        };
	        init();
	    };
	
	    TableResultAction.where = { 'Row': 0, 'Column': 1 };
	
	    TableResultAction.requestAction = { 'Add': 0, 'Delete': 1 };
	
	    TableResultAction.resultAction = { 'Ignore': 0, 'SubtractSpanCount': 1, 'RemoveCell': 2, 'AddCell': 3, 'SumSpanCount': 4 };
	
	    var Table = function () {
	        function Table() {}
	
	        Table.prototype.tab = function (rng, isShift) {
	            var cell = dom.ancestor(rng.commonAncestor(), dom.isCell);
	            var table = dom.ancestor(cell, dom.isTable);
	            var cells = dom.listDescendant(table, dom.isCell);
	            var nextCell = lists[isShift ? 'prev' : 'next'](cells, cell);
	            if (nextCell) {
	                range.create(nextCell, 0).select();
	            }
	        };
	
	        Table.prototype.addRow = function (rng, position) {
	            var cell = dom.ancestor(rng.commonAncestor(), dom.isCell);
	            var currentTr = $$1(cell).closest('tr');
	            var trAttributes = this.recoverAttributes(currentTr);
	            var html = $$1('<tr' + trAttributes + '></tr>');
	            var vTable = new TableResultAction(cell, TableResultAction.where.Row, TableResultAction.requestAction.Add, $$1(currentTr).closest('table')[0]);
	            var actions = vTable.getActionList();
	            for (var idCell = 0; idCell < actions.length; idCell++) {
	                var currentCell = actions[idCell];
	                var tdAttributes = this.recoverAttributes(currentCell.baseCell);
	                switch (currentCell.action) {
	                    case TableResultAction.resultAction.AddCell:
	                        html.append('<td' + tdAttributes + '>' + dom.blank + '</td>');
	                        break;
	                    case TableResultAction.resultAction.SumSpanCount:
	                        if (position === 'top') {
	                            var baseCellTr = currentCell.baseCell.parent;
	                            var isTopFromRowSpan = (!baseCellTr ? 0 : currentCell.baseCell.closest('tr').rowIndex) <= currentTr[0].rowIndex;
	                            if (isTopFromRowSpan) {
	                                var newTd = $$1('<div></div>').append($$1('<td' + tdAttributes + '>' + dom.blank + '</td>').removeAttr('rowspan')).html();
	                                html.append(newTd);
	                                break;
	                            }
	                        }
	                        var rowspanNumber = parseInt(currentCell.baseCell.rowSpan, 10);
	                        rowspanNumber++;
	                        currentCell.baseCell.setAttribute('rowSpan', rowspanNumber);
	                        break;
	                }
	            }
	            if (position === 'top') {
	                currentTr.before(html);
	            } else {
	                var cellHasRowspan = cell.rowSpan > 1;
	                if (cellHasRowspan) {
	                    var lastTrIndex = currentTr[0].rowIndex + (cell.rowSpan - 2);
	                    $$1($$1(currentTr).parent().find('tr')[lastTrIndex]).after($$1(html));
	                    return;
	                }
	                currentTr.after(html);
	            }
	        };
	
	        Table.prototype.addCol = function (rng, position) {
	            var cell = dom.ancestor(rng.commonAncestor(), dom.isCell);
	            var row = $$1(cell).closest('tr');
	            var rowsGroup = $$1(row).siblings();
	            rowsGroup.push(row);
	            var vTable = new TableResultAction(cell, TableResultAction.where.Column, TableResultAction.requestAction.Add, $$1(row).closest('table')[0]);
	            var actions = vTable.getActionList();
	            for (var actionIndex = 0; actionIndex < actions.length; actionIndex++) {
	                var currentCell = actions[actionIndex];
	                var tdAttributes = this.recoverAttributes(currentCell.baseCell);
	                switch (currentCell.action) {
	                    case TableResultAction.resultAction.AddCell:
	                        if (position === 'right') {
	                            $$1(currentCell.baseCell).after('<td' + tdAttributes + '>' + dom.blank + '</td>');
	                        } else {
	                            $$1(currentCell.baseCell).before('<td' + tdAttributes + '>' + dom.blank + '</td>');
	                        }
	                        break;
	                    case TableResultAction.resultAction.SumSpanCount:
	                        if (position === 'right') {
	                            var colspanNumber = parseInt(currentCell.baseCell.colSpan, 10);
	                            colspanNumber++;
	                            currentCell.baseCell.setAttribute('colSpan', colspanNumber);
	                        } else {
	                            $$1(currentCell.baseCell).before('<td' + tdAttributes + '>' + dom.blank + '</td>');
	                        }
	                        break;
	                }
	            }
	        };
	
	        Table.prototype.recoverAttributes = function (el) {
	            var resultStr = '';
	            if (!el) {
	                return resultStr;
	            }
	            var attrList = el.attributes || [];
	            for (var i = 0; i < attrList.length; i++) {
	                if (attrList[i].name.toLowerCase() === 'id') {
	                    continue;
	                }
	                if (attrList[i].specified) {
	                    resultStr += ' ' + attrList[i].name + '=\'' + attrList[i].value + '\'';
	                }
	            }
	            return resultStr;
	        };
	
	        Table.prototype.deleteRow = function (rng) {
	            var cell = dom.ancestor(rng.commonAncestor(), dom.isCell);
	            var row = $$1(cell).closest('tr');
	            var cellPos = row.children('td, th').index($$1(cell));
	            var rowPos = row[0].rowIndex;
	            var vTable = new TableResultAction(cell, TableResultAction.where.Row, TableResultAction.requestAction.Delete, $$1(row).closest('table')[0]);
	            var actions = vTable.getActionList();
	            for (var actionIndex = 0; actionIndex < actions.length; actionIndex++) {
	                if (!actions[actionIndex]) {
	                    continue;
	                }
	                var baseCell = actions[actionIndex].baseCell;
	                var virtualPosition = actions[actionIndex].virtualTable;
	                var hasRowspan = baseCell.rowSpan && baseCell.rowSpan > 1;
	                var rowspanNumber = hasRowspan ? parseInt(baseCell.rowSpan, 10) : 0;
	                switch (actions[actionIndex].action) {
	                    case TableResultAction.resultAction.Ignore:
	                        continue;
	                    case TableResultAction.resultAction.AddCell:
	                        var nextRow = row.next('tr')[0];
	                        if (!nextRow) {
	                            continue;
	                        }
	                        var cloneRow = row[0].cells[cellPos];
	                        if (hasRowspan) {
	                            if (rowspanNumber > 2) {
	                                rowspanNumber--;
	                                nextRow.insertBefore(cloneRow, nextRow.cells[cellPos]);
	                                nextRow.cells[cellPos].setAttribute('rowSpan', rowspanNumber);
	                                nextRow.cells[cellPos].innerHTML = '';
	                            } else if (rowspanNumber === 2) {
	                                nextRow.insertBefore(cloneRow, nextRow.cells[cellPos]);
	                                nextRow.cells[cellPos].removeAttribute('rowSpan');
	                                nextRow.cells[cellPos].innerHTML = '';
	                            }
	                        }
	                        continue;
	                    case TableResultAction.resultAction.SubtractSpanCount:
	                        if (hasRowspan) {
	                            if (rowspanNumber > 2) {
	                                rowspanNumber--;
	                                baseCell.setAttribute('rowSpan', rowspanNumber);
	                                if (virtualPosition.rowIndex !== rowPos && baseCell.cellIndex === cellPos) {
	                                    baseCell.innerHTML = '';
	                                }
	                            } else if (rowspanNumber === 2) {
	                                baseCell.removeAttribute('rowSpan');
	                                if (virtualPosition.rowIndex !== rowPos && baseCell.cellIndex === cellPos) {
	                                    baseCell.innerHTML = '';
	                                }
	                            }
	                        }
	                        continue;
	                    case TableResultAction.resultAction.RemoveCell:
	                        continue;
	                }
	            }
	            row.remove();
	        };
	
	        Table.prototype.deleteCol = function (rng) {
	            var cell = dom.ancestor(rng.commonAncestor(), dom.isCell);
	            var row = $$1(cell).closest('tr');
	            var cellPos = row.children('td, th').index($$1(cell));
	            var vTable = new TableResultAction(cell, TableResultAction.where.Column, TableResultAction.requestAction.Delete, $$1(row).closest('table')[0]);
	            var actions = vTable.getActionList();
	            for (var actionIndex = 0; actionIndex < actions.length; actionIndex++) {
	                if (!actions[actionIndex]) {
	                    continue;
	                }
	                switch (actions[actionIndex].action) {
	                    case TableResultAction.resultAction.Ignore:
	                        continue;
	                    case TableResultAction.resultAction.SubtractSpanCount:
	                        var baseCell = actions[actionIndex].baseCell;
	                        var hasColspan = baseCell.colSpan && baseCell.colSpan > 1;
	                        if (hasColspan) {
	                            var colspanNumber = baseCell.colSpan ? parseInt(baseCell.colSpan, 10) : 0;
	                            if (colspanNumber > 2) {
	                                colspanNumber--;
	                                baseCell.setAttribute('colSpan', colspanNumber);
	                                if (baseCell.cellIndex === cellPos) {
	                                    baseCell.innerHTML = '';
	                                }
	                            } else if (colspanNumber === 2) {
	                                baseCell.removeAttribute('colSpan');
	                                if (baseCell.cellIndex === cellPos) {
	                                    baseCell.innerHTML = '';
	                                }
	                            }
	                        }
	                        continue;
	                    case TableResultAction.resultAction.RemoveCell:
	                        dom.remove(actions[actionIndex].baseCell, true);
	                        continue;
	                }
	            }
	        };
	
	        Table.prototype.createTable = function (colCount, rowCount, options) {
	            var tds = [];
	            var tdHTML;
	            for (var idxCol = 0; idxCol < colCount; idxCol++) {
	                tds.push('<td>' + dom.blank + '</td>');
	            }
	            tdHTML = tds.join('');
	            var trs = [];
	            var trHTML;
	            for (var idxRow = 0; idxRow < rowCount; idxRow++) {
	                trs.push('<tr>' + tdHTML + '</tr>');
	            }
	            trHTML = trs.join('');
	            var $table = $$1('<table>' + trHTML + '</table>');
	            if (options && options.tableClassName) {
	                $table.addClass(options.tableClassName);
	            }
	            return $table[0];
	        };
	
	        Table.prototype.deleteTable = function (rng) {
	            var cell = dom.ancestor(rng.commonAncestor(), dom.isCell);
	            $$1(cell).closest('table').remove();
	        };
	        return Table;
	    }();
	
	    var KEY_BOGUS = 'bogus';
	
	    var Editor = function () {
	        function Editor(context) {
	            var _this = this;
	            this.context = context;
	            this.$note = context.layoutInfo.note;
	            this.$editor = context.layoutInfo.editor;
	            this.$editable = context.layoutInfo.editable;
	            this.options = context.options;
	            this.lang = this.options.langInfo;
	            this.editable = this.$editable[0];
	            this.lastRange = null;
	            this.style = new Style();
	            this.table = new Table();
	            this.typing = new Typing();
	            this.bullet = new Bullet();
	            this.history = new History(this.$editable);
	            this.context.memo('help.undo', this.lang.help.undo);
	            this.context.memo('help.redo', this.lang.help.redo);
	            this.context.memo('help.tab', this.lang.help.tab);
	            this.context.memo('help.untab', this.lang.help.untab);
	            this.context.memo('help.insertParagraph', this.lang.help.insertParagraph);
	            this.context.memo('help.insertOrderedList', this.lang.help.insertOrderedList);
	            this.context.memo('help.insertUnorderedList', this.lang.help.insertUnorderedList);
	            this.context.memo('help.indent', this.lang.help.indent);
	            this.context.memo('help.outdent', this.lang.help.outdent);
	            this.context.memo('help.formatPara', this.lang.help.formatPara);
	            this.context.memo('help.insertHorizontalRule', this.lang.help.insertHorizontalRule);
	            this.context.memo('help.fontName', this.lang.help.fontName);
	
	            var commands = ['bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript', 'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'formatBlock', 'removeFormat', 'backColor'];
	            for (var idx = 0, len = commands.length; idx < len; idx++) {
	                this[commands[idx]] = function (sCmd) {
	                    return function (value) {
	                        _this.beforeCommand();
	                        document.execCommand(sCmd, false, value);
	                        _this.afterCommand(true);
	                    };
	                }(commands[idx]);
	                this.context.memo('help.' + commands[idx], this.lang.help[commands[idx]]);
	            }
	            this.fontName = this.wrapCommand(function (value) {
	                return _this.fontStyling('font-family', "\'" + value + "\'");
	            });
	            this.fontSize = this.wrapCommand(function (value) {
	                return _this.fontStyling('font-size', value + 'px');
	            });
	            for (var idx = 1; idx <= 6; idx++) {
	                this['formatH' + idx] = function (idx) {
	                    return function () {
	                        _this.formatBlock('H' + idx);
	                    };
	                }(idx);
	                this.context.memo('help.formatH' + idx, this.lang.help['formatH' + idx]);
	            }
	
	            this.insertParagraph = this.wrapCommand(function () {
	                _this.typing.insertParagraph(_this.editable);
	            });
	            this.insertOrderedList = this.wrapCommand(function () {
	                _this.bullet.insertOrderedList(_this.editable);
	            });
	            this.insertUnorderedList = this.wrapCommand(function () {
	                _this.bullet.insertUnorderedList(_this.editable);
	            });
	            this.indent = this.wrapCommand(function () {
	                _this.bullet.indent(_this.editable);
	            });
	            this.outdent = this.wrapCommand(function () {
	                _this.bullet.outdent(_this.editable);
	            });
	
	            this.insertNode = this.wrapCommand(function (node) {
	                if (_this.isLimited($$1(node).text().length)) {
	                    return;
	                }
	                var rng = _this.createRange();
	                rng.insertNode(node);
	                range.createFromNodeAfter(node).select();
	            });
	
	            this.insertText = this.wrapCommand(function (text) {
	                if (_this.isLimited(text.length)) {
	                    return;
	                }
	                var rng = _this.createRange();
	                var textNode = rng.insertNode(dom.createText(text));
	                range.create(textNode, dom.nodeLength(textNode)).select();
	            });
	
	            this.pasteHTML = this.wrapCommand(function (markup) {
	                if (_this.isLimited(markup.length)) {
	                    return;
	                }
	                var contents = _this.createRange().pasteHTML(markup);
	                range.createFromNodeAfter(lists.last(contents)).select();
	            });
	
	            this.formatBlock = this.wrapCommand(function (tagName, $target) {
	                var onApplyCustomStyle = _this.options.callbacks.onApplyCustomStyle;
	                if (onApplyCustomStyle) {
	                    onApplyCustomStyle.call(_this, $target, _this.context, _this.onFormatBlock);
	                } else {
	                    _this.onFormatBlock(tagName, $target);
	                }
	            });
	
	            this.insertHorizontalRule = this.wrapCommand(function () {
	                var hrNode = _this.createRange().insertNode(dom.create('HR'));
	                if (hrNode.nextSibling) {
	                    range.create(hrNode.nextSibling, 0).normalize().select();
	                }
	            });
	
	            this.lineHeight = this.wrapCommand(function (value) {
	                _this.style.stylePara(_this.createRange(), {
	                    lineHeight: value
	                });
	            });
	
	            this.createLink = this.wrapCommand(function (linkInfo) {
	                var linkUrl = linkInfo.url;
	                var linkText = linkInfo.text;
	                var isNewWindow = linkInfo.isNewWindow;
	                var rng = linkInfo.range || _this.createRange();
	                var isTextChanged = rng.toString() !== linkText;
	
	                if (typeof linkUrl === 'string') {
	                    linkUrl = linkUrl.trim();
	                }
	                if (_this.options.onCreateLink) {
	                    linkUrl = _this.options.onCreateLink(linkUrl);
	                } else {
	                    linkUrl = /^[A-Za-z][A-Za-z0-9+-.]*\:[\/\/]?/.test(linkUrl) ? linkUrl : 'http://' + linkUrl;
	                }
	                var anchors = [];
	                if (isTextChanged) {
	                    rng = rng.deleteContents();
	                    var anchor = rng.insertNode($$1('<A>' + linkText + '</A>')[0]);
	                    anchors.push(anchor);
	                } else {
	                    anchors = _this.style.styleNodes(rng, {
	                        nodeName: 'A',
	                        expandClosestSibling: true,
	                        onlyPartialContains: true
	                    });
	                }
	                $$1.each(anchors, function (idx, anchor) {
	                    $$1(anchor).attr('href', linkUrl);
	                    if (isNewWindow) {
	                        $$1(anchor).attr('target', '_blank');
	                    } else {
	                        $$1(anchor).removeAttr('target');
	                    }
	                });
	                var startRange = range.createFromNodeBefore(lists.head(anchors));
	                var startPoint = startRange.getStartPoint();
	                var endRange = range.createFromNodeAfter(lists.last(anchors));
	                var endPoint = endRange.getEndPoint();
	                range.create(startPoint.node, startPoint.offset, endPoint.node, endPoint.offset).select();
	            });
	
	            this.color = this.wrapCommand(function (colorInfo) {
	                var foreColor = colorInfo.foreColor;
	                var backColor = colorInfo.backColor;
	                if (foreColor) {
	                    document.execCommand('foreColor', false, foreColor);
	                }
	                if (backColor) {
	                    document.execCommand('backColor', false, backColor);
	                }
	            });
	
	            this.foreColor = this.wrapCommand(function (colorInfo) {
	                document.execCommand('styleWithCSS', false, true);
	                document.execCommand('foreColor', false, colorInfo);
	            });
	
	            this.insertTable = this.wrapCommand(function (dim) {
	                var dimension = dim.split('x');
	                var rng = _this.createRange().deleteContents();
	                rng.insertNode(_this.table.createTable(dimension[0], dimension[1], _this.options));
	            });
	
	            this.removeMedia = this.wrapCommand(function () {
	                var $target = $$1(_this.restoreTarget()).parent();
	                if ($target.parent('figure').length) {
	                    $target.parent('figure').remove();
	                } else {
	                    $target = $$1(_this.restoreTarget()).detach();
	                }
	                _this.context.triggerEvent('media.delete', $target, _this.$editable);
	            });
	
	            this.floatMe = this.wrapCommand(function (value) {
	                var $target = $$1(_this.restoreTarget());
	                $target.toggleClass('note-float-left', value === 'left');
	                $target.toggleClass('note-float-right', value === 'right');
	                $target.css('float', value);
	            });
	
	            this.resize = this.wrapCommand(function (value) {
	                var $target = $$1(_this.restoreTarget());
	                $target.css({
	                    width: value * 100 + '%',
	                    height: ''
	                });
	            });
	        }
	        Editor.prototype.initialize = function () {
	            var _this = this;
	
	            this.$editable.on('keydown', function (event) {
	                if (event.keyCode === key.code.ENTER) {
	                    _this.context.triggerEvent('enter', event);
	                }
	                _this.context.triggerEvent('keydown', event);
	                if (!event.isDefaultPrevented()) {
	                    if (_this.options.shortcuts) {
	                        _this.handleKeyMap(event);
	                    } else {
	                        _this.preventDefaultEditableShortCuts(event);
	                    }
	                }
	                if (_this.isLimited(1, event)) {
	                    return false;
	                }
	            }).on('keyup', function (event) {
	                _this.context.triggerEvent('keyup', event);
	            }).on('focus', function (event) {
	                _this.context.triggerEvent('focus', event);
	            }).on('blur', function (event) {
	                _this.context.triggerEvent('blur', event);
	            }).on('mousedown', function (event) {
	                _this.context.triggerEvent('mousedown', event);
	            }).on('mouseup', function (event) {
	                _this.context.triggerEvent('mouseup', event);
	            }).on('scroll', function (event) {
	                _this.context.triggerEvent('scroll', event);
	            }).on('paste', function (event) {
	                _this.context.triggerEvent('paste', event);
	            });
	
	            this.$editable.html(dom.html(this.$note) || dom.emptyPara);
	            this.$editable.on(env.inputEventName, func.debounce(function () {
	                _this.context.triggerEvent('change', _this.$editable.html());
	            }, 100));
	            this.$editor.on('focusin', function (event) {
	                _this.context.triggerEvent('focusin', event);
	            }).on('focusout', function (event) {
	                _this.context.triggerEvent('focusout', event);
	            });
	            if (!this.options.airMode) {
	                if (this.options.width) {
	                    this.$editor.outerWidth(this.options.width);
	                }
	                if (this.options.height) {
	                    this.$editable.outerHeight(this.options.height);
	                }
	                if (this.options.maxHeight) {
	                    this.$editable.css('max-height', this.options.maxHeight);
	                }
	                if (this.options.minHeight) {
	                    this.$editable.css('min-height', this.options.minHeight);
	                }
	            }
	            this.history.recordUndo();
	        };
	        Editor.prototype.destroy = function () {
	            this.$editable.off();
	        };
	        Editor.prototype.handleKeyMap = function (event) {
	            var keyMap = this.options.keyMap[env.isMac ? 'mac' : 'pc'];
	            var keys = [];
	            if (event.metaKey) {
	                keys.push('CMD');
	            }
	            if (event.ctrlKey && !event.altKey) {
	                keys.push('CTRL');
	            }
	            if (event.shiftKey) {
	                keys.push('SHIFT');
	            }
	            var keyName = key.nameFromCode[event.keyCode];
	            if (keyName) {
	                keys.push(keyName);
	            }
	            var eventName = keyMap[keys.join('+')];
	            if (eventName) {
	                if (this.context.invoke(eventName) !== false) {
	                    event.preventDefault();
	                }
	            } else if (key.isEdit(event.keyCode)) {
	                this.afterCommand();
	            }
	        };
	        Editor.prototype.preventDefaultEditableShortCuts = function (event) {
	            if ((event.ctrlKey || event.metaKey) && lists.contains([66, 73, 85], event.keyCode)) {
	                event.preventDefault();
	            }
	        };
	        Editor.prototype.isLimited = function (pad, event) {
	            pad = pad || 0;
	            if (typeof event !== 'undefined') {
	                if (key.isMove(event.keyCode) || event.ctrlKey || event.metaKey || lists.contains([key.code.BACKSPACE, key.code.DELETE], event.keyCode)) {
	                    return false;
	                }
	            }
	            if (this.options.maxTextLength > 0) {
	                if (this.$editable.text().length + pad >= this.options.maxTextLength) {
	                    return true;
	                }
	            }
	            return false;
	        };
	
	        Editor.prototype.createRange = function () {
	            this.focus();
	            return range.create(this.editable);
	        };
	
	        Editor.prototype.saveRange = function (thenCollapse) {
	            this.lastRange = this.createRange();
	            if (thenCollapse) {
	                this.lastRange.collapse().select();
	            }
	        };
	
	        Editor.prototype.restoreRange = function () {
	            if (this.lastRange) {
	                this.lastRange.select();
	                this.focus();
	            }
	        };
	        Editor.prototype.saveTarget = function (node) {
	            this.$editable.data('target', node);
	        };
	        Editor.prototype.clearTarget = function () {
	            this.$editable.removeData('target');
	        };
	        Editor.prototype.restoreTarget = function () {
	            return this.$editable.data('target');
	        };
	
	        Editor.prototype.currentStyle = function () {
	            var rng = range.create();
	            if (rng) {
	                rng = rng.normalize();
	            }
	            return rng ? this.style.current(rng) : this.style.fromNode(this.$editable);
	        };
	
	        Editor.prototype.styleFromNode = function ($node) {
	            return this.style.fromNode($node);
	        };
	
	        Editor.prototype.undo = function () {
	            this.context.triggerEvent('before.command', this.$editable.html());
	            this.history.undo();
	            this.context.triggerEvent('change', this.$editable.html());
	        };
	
	        Editor.prototype.redo = function () {
	            this.context.triggerEvent('before.command', this.$editable.html());
	            this.history.redo();
	            this.context.triggerEvent('change', this.$editable.html());
	        };
	
	        Editor.prototype.beforeCommand = function () {
	            this.context.triggerEvent('before.command', this.$editable.html());
	
	            this.focus();
	        };
	
	        Editor.prototype.afterCommand = function (isPreventTrigger) {
	            this.history.recordUndo();
	            if (!isPreventTrigger) {
	                this.context.triggerEvent('change', this.$editable.html());
	            }
	        };
	
	        Editor.prototype.tab = function () {
	            var rng = this.createRange();
	            if (rng.isCollapsed() && rng.isOnCell()) {
	                this.table.tab(rng);
	            } else {
	                if (this.options.tabSize === 0) {
	                    return false;
	                }
	                if (!this.isLimited(this.options.tabSize)) {
	                    this.beforeCommand();
	                    this.typing.insertTab(rng, this.options.tabSize);
	                    this.afterCommand();
	                }
	            }
	        };
	
	        Editor.prototype.untab = function () {
	            var rng = this.createRange();
	            if (rng.isCollapsed() && rng.isOnCell()) {
	                this.table.tab(rng, true);
	            } else {
	                if (this.options.tabSize === 0) {
	                    return false;
	                }
	            }
	        };
	
	        Editor.prototype.wrapCommand = function (fn) {
	            var _this = this;
	            return function () {
	                _this.beforeCommand();
	                fn.apply(_this, arguments);
	                _this.afterCommand();
	            };
	        };
	
	        Editor.prototype.insertImage = function (src, param) {
	            var _this = this;
	            return createImage(src, param).then(function ($image) {
	                _this.beforeCommand();
	                if (typeof param === 'function') {
	                    param($image);
	                } else {
	                    if (typeof param === 'string') {
	                        $image.attr('data-filename', param);
	                    }
	                    $image.css('width', Math.min(_this.$editable.width(), $image.width()));
	                }
	                $image.show();
	                range.create(_this.editable).insertNode($image[0]);
	                range.createFromNodeAfter($image[0]).select();
	                _this.afterCommand();
	            }).fail(function (e) {
	                _this.context.triggerEvent('image.upload.error', e);
	            });
	        };
	
	        Editor.prototype.insertImages = function (files) {
	            var _this = this;
	            $$1.each(files, function (idx, file) {
	                var filename = file.name;
	                if (_this.options.maximumImageFileSize && _this.options.maximumImageFileSize < file.size) {
	                    _this.context.triggerEvent('image.upload.error', _this.lang.image.maximumFileSizeError);
	                } else {
	                    readFileAsDataURL(file).then(function (dataURL) {
	                        return _this.insertImage(dataURL, filename);
	                    }).fail(function () {
	                        _this.context.triggerEvent('image.upload.error');
	                    });
	                }
	            });
	        };
	
	        Editor.prototype.insertImagesOrCallback = function (files) {
	            var callbacks = this.options.callbacks;
	
	            if (callbacks.onImageUpload) {
	                this.context.triggerEvent('image.upload', files);
	            } else {
	                this.insertImages(files);
	            }
	        };
	
	        Editor.prototype.getSelectedText = function () {
	            var rng = this.createRange();
	
	            if (rng.isOnAnchor()) {
	                rng = range.createFromNode(dom.ancestor(rng.sc, dom.isAnchor));
	            }
	            return rng.toString();
	        };
	        Editor.prototype.onFormatBlock = function (tagName, $target) {
	            tagName = env.isMSIE ? '<' + tagName + '>' : tagName;
	            document.execCommand('FormatBlock', false, tagName);
	
	            if ($target && $target.length) {
	                var className = $target[0].className || '';
	                if (className) {
	                    var currentRange = this.createRange();
	                    var $parent = $$1([currentRange.sc, currentRange.ec]).closest(tagName);
	                    $parent.addClass(className);
	                }
	            }
	        };
	        Editor.prototype.formatPara = function () {
	            this.formatBlock('P');
	        };
	        Editor.prototype.fontStyling = function (target, value) {
	            var rng = this.createRange();
	            if (rng) {
	                var spans = this.style.styleNodes(rng);
	                $$1(spans).css(target, value);
	
	                if (rng.isCollapsed()) {
	                    var firstSpan = lists.head(spans);
	                    if (firstSpan && !dom.nodeLength(firstSpan)) {
	                        firstSpan.innerHTML = dom.ZERO_WIDTH_NBSP_CHAR;
	                        range.createFromNodeAfter(firstSpan.firstChild).select();
	                        this.$editable.data(KEY_BOGUS, firstSpan);
	                    }
	                }
	            }
	        };
	
	        Editor.prototype.unlink = function () {
	            var rng = this.createRange();
	            if (rng.isOnAnchor()) {
	                var anchor = dom.ancestor(rng.sc, dom.isAnchor);
	                rng = range.createFromNode(anchor);
	                rng.select();
	                this.beforeCommand();
	                document.execCommand('unlink');
	                this.afterCommand();
	            }
	        };
	
	        Editor.prototype.getLinkInfo = function () {
	            var rng = this.createRange().expand(dom.isAnchor);
	
	            var $anchor = $$1(lists.head(rng.nodes(dom.isAnchor)));
	            var linkInfo = {
	                range: rng,
	                text: rng.toString(),
	                url: $anchor.length ? $anchor.attr('href') : ''
	            };
	
	            if ($anchor.length) {
	                linkInfo.isNewWindow = $anchor.attr('target') === '_blank';
	            }
	            return linkInfo;
	        };
	        Editor.prototype.addRow = function (position) {
	            var rng = this.createRange(this.$editable);
	            if (rng.isCollapsed() && rng.isOnCell()) {
	                this.beforeCommand();
	                this.table.addRow(rng, position);
	                this.afterCommand();
	            }
	        };
	        Editor.prototype.addCol = function (position) {
	            var rng = this.createRange(this.$editable);
	            if (rng.isCollapsed() && rng.isOnCell()) {
	                this.beforeCommand();
	                this.table.addCol(rng, position);
	                this.afterCommand();
	            }
	        };
	        Editor.prototype.deleteRow = function () {
	            var rng = this.createRange(this.$editable);
	            if (rng.isCollapsed() && rng.isOnCell()) {
	                this.beforeCommand();
	                this.table.deleteRow(rng);
	                this.afterCommand();
	            }
	        };
	        Editor.prototype.deleteCol = function () {
	            var rng = this.createRange(this.$editable);
	            if (rng.isCollapsed() && rng.isOnCell()) {
	                this.beforeCommand();
	                this.table.deleteCol(rng);
	                this.afterCommand();
	            }
	        };
	        Editor.prototype.deleteTable = function () {
	            var rng = this.createRange(this.$editable);
	            if (rng.isCollapsed() && rng.isOnCell()) {
	                this.beforeCommand();
	                this.table.deleteTable(rng);
	                this.afterCommand();
	            }
	        };
	
	        Editor.prototype.resizeTo = function (pos, $target, bKeepRatio) {
	            var imageSize;
	            if (bKeepRatio) {
	                var newRatio = pos.y / pos.x;
	                var ratio = $target.data('ratio');
	                imageSize = {
	                    width: ratio > newRatio ? pos.x : pos.y / ratio,
	                    height: ratio > newRatio ? pos.x * ratio : pos.y
	                };
	            } else {
	                imageSize = {
	                    width: pos.x,
	                    height: pos.y
	                };
	            }
	            $target.css(imageSize);
	        };
	
	        Editor.prototype.hasFocus = function () {
	            return this.$editable.is(':focus');
	        };
	
	        Editor.prototype.focus = function () {
	            if (!this.hasFocus()) {
	                this.$editable.focus();
	            }
	        };
	
	        Editor.prototype.isEmpty = function () {
	            return dom.isEmpty(this.$editable[0]) || dom.emptyPara === this.$editable.html();
	        };
	
	        Editor.prototype.empty = function () {
	            this.context.invoke('code', dom.emptyPara);
	        };
	        return Editor;
	    }();
	
	    var Clipboard = function () {
	        function Clipboard(context) {
	            this.context = context;
	            this.$editable = context.layoutInfo.editable;
	        }
	        Clipboard.prototype.initialize = function () {
	            this.$editable.on('paste', this.pasteByEvent.bind(this));
	        };
	
	        Clipboard.prototype.pasteByEvent = function (event) {
	            var clipboardData = event.originalEvent.clipboardData;
	            if (clipboardData && clipboardData.items && clipboardData.items.length) {
	                var item = lists.head(clipboardData.items);
	                if (item.kind === 'file' && item.type.indexOf('image/') !== -1) {
	                    this.context.invoke('editor.insertImagesOrCallback', [item.getAsFile()]);
	                }
	                this.context.invoke('editor.afterCommand');
	            }
	        };
	        return Clipboard;
	    }();
	
	    var Dropzone = function () {
	        function Dropzone(context) {
	            this.context = context;
	            this.$eventListener = $$1(document);
	            this.$editor = context.layoutInfo.editor;
	            this.$editable = context.layoutInfo.editable;
	            this.options = context.options;
	            this.lang = this.options.langInfo;
	            this.documentEventHandlers = {};
	            this.$dropzone = $$1(['<div class="note-dropzone">', '  <div class="note-dropzone-message"/>', '</div>'].join('')).prependTo(this.$editor);
	        }
	
	        Dropzone.prototype.initialize = function () {
	            if (this.options.disableDragAndDrop) {
	                this.documentEventHandlers.onDrop = function (e) {
	                    e.preventDefault();
	                };
	
	                this.$eventListener = this.$dropzone;
	                this.$eventListener.on('drop', this.documentEventHandlers.onDrop);
	            } else {
	                this.attachDragAndDropEvent();
	            }
	        };
	
	        Dropzone.prototype.attachDragAndDropEvent = function () {
	            var _this = this;
	            var collection = $$1();
	            var $dropzoneMessage = this.$dropzone.find('.note-dropzone-message');
	            this.documentEventHandlers.onDragenter = function (e) {
	                var isCodeview = _this.context.invoke('codeview.isActivated');
	                var hasEditorSize = _this.$editor.width() > 0 && _this.$editor.height() > 0;
	                if (!isCodeview && !collection.length && hasEditorSize) {
	                    _this.$editor.addClass('dragover');
	                    _this.$dropzone.width(_this.$editor.width());
	                    _this.$dropzone.height(_this.$editor.height());
	                    $dropzoneMessage.text(_this.lang.image.dragImageHere);
	                }
	                collection = collection.add(e.target);
	            };
	            this.documentEventHandlers.onDragleave = function (e) {
	                collection = collection.not(e.target);
	                if (!collection.length) {
	                    _this.$editor.removeClass('dragover');
	                }
	            };
	            this.documentEventHandlers.onDrop = function () {
	                collection = $$1();
	                _this.$editor.removeClass('dragover');
	            };
	
	            this.$eventListener.on('dragenter', this.documentEventHandlers.onDragenter).on('dragleave', this.documentEventHandlers.onDragleave).on('drop', this.documentEventHandlers.onDrop);
	
	            this.$dropzone.on('dragenter', function () {
	                _this.$dropzone.addClass('hover');
	                $dropzoneMessage.text(_this.lang.image.dropImage);
	            }).on('dragleave', function () {
	                _this.$dropzone.removeClass('hover');
	                $dropzoneMessage.text(_this.lang.image.dragImageHere);
	            });
	
	            this.$dropzone.on('drop', function (event) {
	                var dataTransfer = event.originalEvent.dataTransfer;
	
	                event.preventDefault();
	                if (dataTransfer && dataTransfer.files && dataTransfer.files.length) {
	                    _this.$editable.focus();
	                    _this.context.invoke('editor.insertImagesOrCallback', dataTransfer.files);
	                } else {
	                    $$1.each(dataTransfer.types, function (idx, type) {
	                        var content = dataTransfer.getData(type);
	                        if (type.toLowerCase().indexOf('text') > -1) {
	                            _this.context.invoke('editor.pasteHTML', content);
	                        } else {
	                            $$1(content).each(function (idx, item) {
	                                _this.context.invoke('editor.insertNode', item);
	                            });
	                        }
	                    });
	                }
	            }).on('dragover', false);
	        };
	        Dropzone.prototype.destroy = function () {
	            var _this = this;
	            (0, _keys2.default)(this.documentEventHandlers).forEach(function (key) {
	                _this.$eventListener.off(key.substr(2).toLowerCase(), _this.documentEventHandlers[key]);
	            });
	            this.documentEventHandlers = {};
	        };
	        return Dropzone;
	    }();
	
	    var CodeMirror;
	    if (env.hasCodeMirror) {
	        if (env.isSupportAmd) {
	            __webpack_require__.e/* require */(1, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(568)]; (function (cm) {
	                CodeMirror = cm;
	            }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));});
	        } else {
	            CodeMirror = window.CodeMirror;
	        }
	    }
	
	    var CodeView = function () {
	        function CodeView(context) {
	            this.context = context;
	            this.$editor = context.layoutInfo.editor;
	            this.$editable = context.layoutInfo.editable;
	            this.$codable = context.layoutInfo.codable;
	            this.options = context.options;
	        }
	        CodeView.prototype.sync = function () {
	            var isCodeview = this.isActivated();
	            if (isCodeview && env.hasCodeMirror) {
	                this.$codable.data('cmEditor').save();
	            }
	        };
	
	        CodeView.prototype.isActivated = function () {
	            return this.$editor.hasClass('codeview');
	        };
	
	        CodeView.prototype.toggle = function () {
	            if (this.isActivated()) {
	                this.deactivate();
	            } else {
	                this.activate();
	            }
	            this.context.triggerEvent('codeview.toggled');
	        };
	
	        CodeView.prototype.activate = function () {
	            var _this = this;
	            this.$codable.val(dom.html(this.$editable, this.options.prettifyHtml));
	            this.$codable.height(this.$editable.height());
	            this.context.invoke('toolbar.updateCodeview', true);
	            this.$editor.addClass('codeview');
	            this.$codable.focus();
	
	            if (env.hasCodeMirror) {
	                var cmEditor_1 = CodeMirror.fromTextArea(this.$codable[0], this.options.codemirror);
	
	                if (this.options.codemirror.tern) {
	                    var server_1 = new CodeMirror.TernServer(this.options.codemirror.tern);
	                    cmEditor_1.ternServer = server_1;
	                    cmEditor_1.on('cursorActivity', function (cm) {
	                        server_1.updateArgHints(cm);
	                    });
	                }
	                cmEditor_1.on('blur', function (event) {
	                    _this.context.triggerEvent('blur.codeview', cmEditor_1.getValue(), event);
	                });
	
	                cmEditor_1.setSize(null, this.$editable.outerHeight());
	                this.$codable.data('cmEditor', cmEditor_1);
	            } else {
	                this.$codable.on('blur', function (event) {
	                    _this.context.triggerEvent('blur.codeview', _this.$codable.val(), event);
	                });
	            }
	        };
	
	        CodeView.prototype.deactivate = function () {
	            if (env.hasCodeMirror) {
	                var cmEditor = this.$codable.data('cmEditor');
	                this.$codable.val(cmEditor.getValue());
	                cmEditor.toTextArea();
	            }
	            var value = dom.value(this.$codable, this.options.prettifyHtml) || dom.emptyPara;
	            var isChange = this.$editable.html() !== value;
	            this.$editable.html(value);
	            this.$editable.height(this.options.height ? this.$codable.height() : 'auto');
	            this.$editor.removeClass('codeview');
	            if (isChange) {
	                this.context.triggerEvent('change', this.$editable.html(), this.$editable);
	            }
	            this.$editable.focus();
	            this.context.invoke('toolbar.updateCodeview', false);
	        };
	        CodeView.prototype.destroy = function () {
	            if (this.isActivated()) {
	                this.deactivate();
	            }
	        };
	        return CodeView;
	    }();
	
	    var EDITABLE_PADDING = 24;
	    var Statusbar = function () {
	        function Statusbar(context) {
	            this.$document = $$1(document);
	            this.$statusbar = context.layoutInfo.statusbar;
	            this.$editable = context.layoutInfo.editable;
	            this.options = context.options;
	        }
	        Statusbar.prototype.initialize = function () {
	            var _this = this;
	            if (this.options.airMode || this.options.disableResizeEditor) {
	                this.destroy();
	                return;
	            }
	            this.$statusbar.on('mousedown', function (event) {
	                event.preventDefault();
	                event.stopPropagation();
	                var editableTop = _this.$editable.offset().top - _this.$document.scrollTop();
	                var onMouseMove = function onMouseMove(event) {
	                    var height = event.clientY - (editableTop + EDITABLE_PADDING);
	                    height = _this.options.minheight > 0 ? Math.max(height, _this.options.minheight) : height;
	                    height = _this.options.maxHeight > 0 ? Math.min(height, _this.options.maxHeight) : height;
	                    _this.$editable.height(height);
	                };
	                _this.$document.on('mousemove', onMouseMove).one('mouseup', function () {
	                    _this.$document.off('mousemove', onMouseMove);
	                });
	            });
	        };
	        Statusbar.prototype.destroy = function () {
	            this.$statusbar.off();
	        };
	        return Statusbar;
	    }();
	
	    var Fullscreen = function () {
	        function Fullscreen(context) {
	            var _this = this;
	            this.context = context;
	            this.$editor = context.layoutInfo.editor;
	            this.$toolbar = context.layoutInfo.toolbar;
	            this.$editable = context.layoutInfo.editable;
	            this.$codable = context.layoutInfo.codable;
	            this.$window = $$1(window);
	            this.$scrollbar = $$1('html, body');
	            this.onResize = function () {
	                _this.resizeTo({
	                    h: _this.$window.height() - _this.$toolbar.outerHeight()
	                });
	            };
	        }
	        Fullscreen.prototype.resizeTo = function (size) {
	            this.$editable.css('height', size.h);
	            this.$codable.css('height', size.h);
	            if (this.$codable.data('cmeditor')) {
	                this.$codable.data('cmeditor').setsize(null, size.h);
	            }
	        };
	
	        Fullscreen.prototype.toggle = function () {
	            this.$editor.toggleClass('fullscreen');
	            if (this.isFullscreen()) {
	                this.$editable.data('orgHeight', this.$editable.css('height'));
	                this.$window.on('resize', this.onResize).trigger('resize');
	                this.$scrollbar.css('overflow', 'hidden');
	            } else {
	                this.$window.off('resize', this.onResize);
	                this.resizeTo({ h: this.$editable.data('orgHeight') });
	                this.$scrollbar.css('overflow', 'visible');
	            }
	            this.context.invoke('toolbar.updateFullscreen', this.isFullscreen());
	        };
	        Fullscreen.prototype.isFullscreen = function () {
	            return this.$editor.hasClass('fullscreen');
	        };
	        return Fullscreen;
	    }();
	
	    var Handle = function () {
	        function Handle(context) {
	            var _this = this;
	            this.context = context;
	            this.$document = $$1(document);
	            this.$editingArea = context.layoutInfo.editingArea;
	            this.options = context.options;
	            this.lang = this.options.langInfo;
	            this.events = {
	                'summernote.mousedown': function summernoteMousedown(we, e) {
	                    if (_this.update(e.target)) {
	                        e.preventDefault();
	                    }
	                },
	                'summernote.keyup summernote.scroll summernote.change summernote.dialog.shown': function summernoteKeyupSummernoteScrollSummernoteChangeSummernoteDialogShown() {
	                    _this.update();
	                },
	                'summernote.disable': function summernoteDisable() {
	                    _this.hide();
	                },
	                'summernote.codeview.toggled': function summernoteCodeviewToggled() {
	                    _this.update();
	                }
	            };
	        }
	        Handle.prototype.initialize = function () {
	            var _this = this;
	            this.$handle = $$1(['<div class="note-handle">', '<div class="note-control-selection">', '<div class="note-control-selection-bg"></div>', '<div class="note-control-holder note-control-nw"></div>', '<div class="note-control-holder note-control-ne"></div>', '<div class="note-control-holder note-control-sw"></div>', '<div class="', this.options.disableResizeImage ? 'note-control-holder' : 'note-control-sizing', ' note-control-se"></div>', this.options.disableResizeImage ? '' : '<div class="note-control-selection-info"></div>', '</div>', '</div>'].join('')).prependTo(this.$editingArea);
	            this.$handle.on('mousedown', function (event) {
	                if (dom.isControlSizing(event.target)) {
	                    event.preventDefault();
	                    event.stopPropagation();
	                    var $target_1 = _this.$handle.find('.note-control-selection').data('target');
	                    var posStart_1 = $target_1.offset();
	                    var scrollTop_1 = _this.$document.scrollTop();
	                    var onMouseMove_1 = function onMouseMove_1(event) {
	                        _this.context.invoke('editor.resizeTo', {
	                            x: event.clientX - posStart_1.left,
	                            y: event.clientY - (posStart_1.top - scrollTop_1)
	                        }, $target_1, !event.shiftKey);
	                        _this.update($target_1[0]);
	                    };
	                    _this.$document.on('mousemove', onMouseMove_1).one('mouseup', function (e) {
	                        e.preventDefault();
	                        _this.$document.off('mousemove', onMouseMove_1);
	                        _this.context.invoke('editor.afterCommand');
	                    });
	                    if (!$target_1.data('ratio')) {
	                        $target_1.data('ratio', $target_1.height() / $target_1.width());
	                    }
	                }
	            });
	
	            this.$handle.on('wheel', function (e) {
	                e.preventDefault();
	                _this.update();
	            });
	        };
	        Handle.prototype.destroy = function () {
	            this.$handle.remove();
	        };
	        Handle.prototype.update = function (target) {
	            if (this.context.isDisabled()) {
	                return false;
	            }
	            var isImage = dom.isImg(target);
	            var $selection = this.$handle.find('.note-control-selection');
	            this.context.invoke('imagePopover.update', target);
	            if (isImage) {
	                var $image = $$1(target);
	                var position = $image.position();
	                var pos = {
	                    left: position.left + parseInt($image.css('marginLeft'), 10),
	                    top: position.top + parseInt($image.css('marginTop'), 10)
	                };
	
	                var imageSize = {
	                    w: $image.outerWidth(false),
	                    h: $image.outerHeight(false)
	                };
	                $selection.css({
	                    display: 'block',
	                    left: pos.left,
	                    top: pos.top,
	                    width: imageSize.w,
	                    height: imageSize.h
	                }).data('target', $image);
	                var origImageObj = new Image();
	                origImageObj.src = $image.attr('src');
	                var sizingText = imageSize.w + 'x' + imageSize.h + ' (' + this.lang.image.original + ': ' + origImageObj.width + 'x' + origImageObj.height + ')';
	                $selection.find('.note-control-selection-info').text(sizingText);
	                this.context.invoke('editor.saveTarget', target);
	            } else {
	                this.hide();
	            }
	            return isImage;
	        };
	
	        Handle.prototype.hide = function () {
	            this.context.invoke('editor.clearTarget');
	            this.$handle.children().hide();
	        };
	        return Handle;
	    }();
	
	    var defaultScheme = 'http://';
	    var linkPattern = /^([A-Za-z][A-Za-z0-9+-.]*\:[\/\/]?|mailto:[A-Z0-9._%+-]+@)?(www\.)?(.+)$/i;
	    var AutoLink = function () {
	        function AutoLink(context) {
	            var _this = this;
	            this.context = context;
	            this.events = {
	                'summernote.keyup': function summernoteKeyup(we, e) {
	                    if (!e.isDefaultPrevented()) {
	                        _this.handleKeyup(e);
	                    }
	                },
	                'summernote.keydown': function summernoteKeydown(we, e) {
	                    _this.handleKeydown(e);
	                }
	            };
	        }
	        AutoLink.prototype.initialize = function () {
	            this.lastWordRange = null;
	        };
	        AutoLink.prototype.destroy = function () {
	            this.lastWordRange = null;
	        };
	        AutoLink.prototype.replace = function () {
	            if (!this.lastWordRange) {
	                return;
	            }
	            var keyword = this.lastWordRange.toString();
	            var match = keyword.match(linkPattern);
	            if (match && (match[1] || match[2])) {
	                var link = match[1] ? keyword : defaultScheme + keyword;
	                var node = $$1('<a />').html(keyword).attr('href', link)[0];
	                this.lastWordRange.insertNode(node);
	                this.lastWordRange = null;
	                this.context.invoke('editor.focus');
	            }
	        };
	        AutoLink.prototype.handleKeydown = function (e) {
	            if (lists.contains([key.code.ENTER, key.code.SPACE], e.keyCode)) {
	                var wordRange = this.context.invoke('editor.createRange').getWordRange();
	                this.lastWordRange = wordRange;
	            }
	        };
	        AutoLink.prototype.handleKeyup = function (e) {
	            if (lists.contains([key.code.ENTER, key.code.SPACE], e.keyCode)) {
	                this.replace();
	            }
	        };
	        return AutoLink;
	    }();
	
	    var AutoSync = function () {
	        function AutoSync(context) {
	            var _this = this;
	            this.$note = context.layoutInfo.note;
	            this.events = {
	                'summernote.change': function summernoteChange() {
	                    _this.$note.val(context.invoke('code'));
	                }
	            };
	        }
	        AutoSync.prototype.shouldInitialize = function () {
	            return dom.isTextarea(this.$note[0]);
	        };
	        return AutoSync;
	    }();
	
	    var Placeholder = function () {
	        function Placeholder(context) {
	            var _this = this;
	            this.context = context;
	            this.$editingArea = context.layoutInfo.editingArea;
	            this.options = context.options;
	            this.events = {
	                'summernote.init summernote.change': function summernoteInitSummernoteChange() {
	                    _this.update();
	                },
	                'summernote.codeview.toggled': function summernoteCodeviewToggled() {
	                    _this.update();
	                }
	            };
	        }
	        Placeholder.prototype.shouldInitialize = function () {
	            return !!this.options.placeholder;
	        };
	        Placeholder.prototype.initialize = function () {
	            var _this = this;
	            this.$placeholder = $$1('<div class="note-placeholder">');
	            this.$placeholder.on('click', function () {
	                _this.context.invoke('focus');
	            }).text(this.options.placeholder).prependTo(this.$editingArea);
	            this.update();
	        };
	        Placeholder.prototype.destroy = function () {
	            this.$placeholder.remove();
	        };
	        Placeholder.prototype.update = function () {
	            var isShow = !this.context.invoke('codeview.isActivated') && this.context.invoke('editor.isEmpty');
	            this.$placeholder.toggle(isShow);
	        };
	        return Placeholder;
	    }();
	
	    var Buttons = function () {
	        function Buttons(context) {
	            this.ui = $$1.summernote.ui;
	            this.context = context;
	            this.$toolbar = context.layoutInfo.toolbar;
	            this.options = context.options;
	            this.lang = this.options.langInfo;
	            this.invertedKeyMap = func.invertObject(this.options.keyMap[env.isMac ? 'mac' : 'pc']);
	        }
	        Buttons.prototype.representShortcut = function (editorMethod) {
	            var shortcut = this.invertedKeyMap[editorMethod];
	            if (!this.options.shortcuts || !shortcut) {
	                return '';
	            }
	            if (env.isMac) {
	                shortcut = shortcut.replace('CMD', '⌘').replace('SHIFT', '⇧');
	            }
	            shortcut = shortcut.replace('BACKSLASH', '\\').replace('SLASH', '/').replace('LEFTBRACKET', '[').replace('RIGHTBRACKET', ']');
	            return ' (' + shortcut + ')';
	        };
	        Buttons.prototype.button = function (o) {
	            if (!this.options.tooltip && o.tooltip) {
	                delete o.tooltip;
	            }
	            o.container = this.options.container;
	            return this.ui.button(o);
	        };
	        Buttons.prototype.initialize = function () {
	            this.addToolbarButtons();
	            this.addImagePopoverButtons();
	            this.addLinkPopoverButtons();
	            this.addTablePopoverButtons();
	            this.fontInstalledMap = {};
	        };
	        Buttons.prototype.destroy = function () {
	            delete this.fontInstalledMap;
	        };
	        Buttons.prototype.isFontInstalled = function (name) {
	            if (!this.fontInstalledMap.hasOwnProperty(name)) {
	                this.fontInstalledMap[name] = env.isFontInstalled(name) || lists.contains(this.options.fontNamesIgnoreCheck, name);
	            }
	            return this.fontInstalledMap[name];
	        };
	        Buttons.prototype.isFontDeservedToAdd = function (name) {
	            var genericFamilies = ['sans-serif', 'serif', 'monospace', 'cursive', 'fantasy'];
	            name = name.toLowerCase();
	            return name !== '' && this.isFontInstalled(name) && $$1.inArray(name, genericFamilies) === -1;
	        };
	        Buttons.prototype.addToolbarButtons = function () {
	            var _this = this;
	            this.context.memo('button.style', function () {
	                return _this.ui.buttonGroup([_this.button({
	                    className: 'dropdown-toggle',
	                    contents: _this.ui.dropdownButtonContents(_this.ui.icon(_this.options.icons.magic), _this.options),
	                    tooltip: _this.lang.style.style,
	                    data: {
	                        toggle: 'dropdown'
	                    }
	                }), _this.ui.dropdown({
	                    className: 'dropdown-style',
	                    items: _this.options.styleTags,
	                    template: function template(item) {
	                        if (typeof item === 'string') {
	                            item = { tag: item, title: _this.lang.style.hasOwnProperty(item) ? _this.lang.style[item] : item };
	                        }
	                        var tag = item.tag;
	                        var title = item.title;
	                        var style = item.style ? ' style="' + item.style + '" ' : '';
	                        var className = item.className ? ' class="' + item.className + '"' : '';
	                        return '<' + tag + style + className + '>' + title + '</' + tag + '>';
	                    },
	                    click: _this.context.createInvokeHandler('editor.formatBlock')
	                })]).render();
	            });
	            var _loop_1 = function _loop_1(styleIdx, styleLen) {
	                var item = this_1.options.styleTags[styleIdx];
	                this_1.context.memo('button.style.' + item, function () {
	                    return _this.button({
	                        className: 'note-btn-style-' + item,
	                        contents: '<div data-value="' + item + '">' + item.toUpperCase() + '</div>',
	                        tooltip: item.toUpperCase(),
	                        click: _this.context.createInvokeHandler('editor.formatBlock')
	                    }).render();
	                });
	            };
	            var this_1 = this;
	            for (var styleIdx = 0, styleLen = this.options.styleTags.length; styleIdx < styleLen; styleIdx++) {
	                _loop_1(styleIdx, styleLen);
	            }
	            this.context.memo('button.bold', function () {
	                return _this.button({
	                    className: 'note-btn-bold',
	                    contents: _this.ui.icon(_this.options.icons.bold),
	                    tooltip: _this.lang.font.bold + _this.representShortcut('bold'),
	                    click: _this.context.createInvokeHandlerAndUpdateState('editor.bold')
	                }).render();
	            });
	            this.context.memo('button.italic', function () {
	                return _this.button({
	                    className: 'note-btn-italic',
	                    contents: _this.ui.icon(_this.options.icons.italic),
	                    tooltip: _this.lang.font.italic + _this.representShortcut('italic'),
	                    click: _this.context.createInvokeHandlerAndUpdateState('editor.italic')
	                }).render();
	            });
	            this.context.memo('button.underline', function () {
	                return _this.button({
	                    className: 'note-btn-underline',
	                    contents: _this.ui.icon(_this.options.icons.underline),
	                    tooltip: _this.lang.font.underline + _this.representShortcut('underline'),
	                    click: _this.context.createInvokeHandlerAndUpdateState('editor.underline')
	                }).render();
	            });
	            this.context.memo('button.clear', function () {
	                return _this.button({
	                    contents: _this.ui.icon(_this.options.icons.eraser),
	                    tooltip: _this.lang.font.clear + _this.representShortcut('removeFormat'),
	                    click: _this.context.createInvokeHandler('editor.removeFormat')
	                }).render();
	            });
	            this.context.memo('button.strikethrough', function () {
	                return _this.button({
	                    className: 'note-btn-strikethrough',
	                    contents: _this.ui.icon(_this.options.icons.strikethrough),
	                    tooltip: _this.lang.font.strikethrough + _this.representShortcut('strikethrough'),
	                    click: _this.context.createInvokeHandlerAndUpdateState('editor.strikethrough')
	                }).render();
	            });
	            this.context.memo('button.superscript', function () {
	                return _this.button({
	                    className: 'note-btn-superscript',
	                    contents: _this.ui.icon(_this.options.icons.superscript),
	                    tooltip: _this.lang.font.superscript,
	                    click: _this.context.createInvokeHandlerAndUpdateState('editor.superscript')
	                }).render();
	            });
	            this.context.memo('button.subscript', function () {
	                return _this.button({
	                    className: 'note-btn-subscript',
	                    contents: _this.ui.icon(_this.options.icons.subscript),
	                    tooltip: _this.lang.font.subscript,
	                    click: _this.context.createInvokeHandlerAndUpdateState('editor.subscript')
	                }).render();
	            });
	            this.context.memo('button.fontname', function () {
	                var styleInfo = _this.context.invoke('editor.currentStyle');
	
	                $$1.each(styleInfo['font-family'].split(','), function (idx, fontname) {
	                    fontname = fontname.trim().replace(/['"]+/g, '');
	                    if (_this.isFontDeservedToAdd(fontname)) {
	                        if ($$1.inArray(fontname, _this.options.fontNames) === -1) {
	                            _this.options.fontNames.push(fontname);
	                        }
	                    }
	                });
	                return _this.ui.buttonGroup([_this.button({
	                    className: 'dropdown-toggle',
	                    contents: _this.ui.dropdownButtonContents('<span class="note-current-fontname"/>', _this.options),
	                    tooltip: _this.lang.font.name,
	                    data: {
	                        toggle: 'dropdown'
	                    }
	                }), _this.ui.dropdownCheck({
	                    className: 'dropdown-fontname',
	                    checkClassName: _this.options.icons.menuCheck,
	                    items: _this.options.fontNames.filter(_this.isFontInstalled.bind(_this)),
	                    template: function template(item) {
	                        return '<span style="font-family: \'' + item + '\'">' + item + '</span>';
	                    },
	                    click: _this.context.createInvokeHandlerAndUpdateState('editor.fontName')
	                })]).render();
	            });
	            this.context.memo('button.fontsize', function () {
	                return _this.ui.buttonGroup([_this.button({
	                    className: 'dropdown-toggle',
	                    contents: _this.ui.dropdownButtonContents('<span class="note-current-fontsize"/>', _this.options),
	                    tooltip: _this.lang.font.size,
	                    data: {
	                        toggle: 'dropdown'
	                    }
	                }), _this.ui.dropdownCheck({
	                    className: 'dropdown-fontsize',
	                    checkClassName: _this.options.icons.menuCheck,
	                    items: _this.options.fontSizes,
	                    click: _this.context.createInvokeHandlerAndUpdateState('editor.fontSize')
	                })]).render();
	            });
	            this.context.memo('button.color', function () {
	                return _this.ui.buttonGroup({
	                    className: 'note-color',
	                    children: [_this.button({
	                        className: 'note-current-color-button',
	                        contents: _this.ui.icon(_this.options.icons.font + ' note-recent-color'),
	                        tooltip: _this.lang.color.recent,
	                        click: function click(e) {
	                            var $button = $$1(e.currentTarget);
	                            _this.context.invoke('editor.color', {
	                                backColor: $button.attr('data-backColor'),
	                                foreColor: $button.attr('data-foreColor')
	                            });
	                        },
	                        callback: function callback($button) {
	                            var $recentColor = $button.find('.note-recent-color');
	                            $recentColor.css('background-color', '#FFFF00');
	                            $button.attr('data-backColor', '#FFFF00');
	                        }
	                    }), _this.button({
	                        className: 'dropdown-toggle',
	                        contents: _this.ui.dropdownButtonContents('', _this.options),
	                        tooltip: _this.lang.color.more,
	                        data: {
	                            toggle: 'dropdown'
	                        }
	                    }), _this.ui.dropdown({
	                        items: ['<div class="note-palette">', '  <div class="note-palette-title">' + _this.lang.color.background + '</div>', '  <div>', '    <button type="button" class="note-color-reset btn btn-light" data-event="backColor" data-value="inherit">', _this.lang.color.transparent, '    </button>', '  </div>', '  <div class="note-holder" data-event="backColor"/>', '</div>', '<div class="note-palette">', '  <div class="note-palette-title">' + _this.lang.color.foreground + '</div>', '  <div>', '    <button type="button" class="note-color-reset btn btn-light" data-event="removeFormat" data-value="foreColor">', _this.lang.color.resetToDefault, '    </button>', '  </div>', '  <div class="note-holder" data-event="foreColor"/>', '</div>'].join(''),
	                        callback: function callback($dropdown) {
	                            $dropdown.find('.note-holder').each(function (idx, item) {
	                                var $holder = $$1(item);
	                                $holder.append(_this.ui.palette({
	                                    colors: _this.options.colors,
	                                    eventName: $holder.data('event'),
	                                    container: _this.options.container,
	                                    tooltip: _this.options.tooltip
	                                }).render());
	                            });
	                        },
	                        click: function click(event) {
	                            var $button = $$1(event.target);
	                            var eventName = $button.data('event');
	                            var value = $button.data('value');
	                            if (eventName && value) {
	                                var key = eventName === 'backColor' ? 'background-color' : 'color';
	                                var $color = $button.closest('.note-color').find('.note-recent-color');
	                                var $currentButton = $button.closest('.note-color').find('.note-current-color-button');
	                                $color.css(key, value);
	                                $currentButton.attr('data-' + eventName, value);
	                                _this.context.invoke('editor.' + eventName, value);
	                            }
	                        }
	                    })]
	                }).render();
	            });
	            this.context.memo('button.ul', function () {
	                return _this.button({
	                    contents: _this.ui.icon(_this.options.icons.unorderedlist),
	                    tooltip: _this.lang.lists.unordered + _this.representShortcut('insertUnorderedList'),
	                    click: _this.context.createInvokeHandler('editor.insertUnorderedList')
	                }).render();
	            });
	            this.context.memo('button.ol', function () {
	                return _this.button({
	                    contents: _this.ui.icon(_this.options.icons.orderedlist),
	                    tooltip: _this.lang.lists.ordered + _this.representShortcut('insertOrderedList'),
	                    click: _this.context.createInvokeHandler('editor.insertOrderedList')
	                }).render();
	            });
	            var justifyLeft = this.button({
	                contents: this.ui.icon(this.options.icons.alignLeft),
	                tooltip: this.lang.paragraph.left + this.representShortcut('justifyLeft'),
	                click: this.context.createInvokeHandler('editor.justifyLeft')
	            });
	            var justifyCenter = this.button({
	                contents: this.ui.icon(this.options.icons.alignCenter),
	                tooltip: this.lang.paragraph.center + this.representShortcut('justifyCenter'),
	                click: this.context.createInvokeHandler('editor.justifyCenter')
	            });
	            var justifyRight = this.button({
	                contents: this.ui.icon(this.options.icons.alignRight),
	                tooltip: this.lang.paragraph.right + this.representShortcut('justifyRight'),
	                click: this.context.createInvokeHandler('editor.justifyRight')
	            });
	            var justifyFull = this.button({
	                contents: this.ui.icon(this.options.icons.alignJustify),
	                tooltip: this.lang.paragraph.justify + this.representShortcut('justifyFull'),
	                click: this.context.createInvokeHandler('editor.justifyFull')
	            });
	            var outdent = this.button({
	                contents: this.ui.icon(this.options.icons.outdent),
	                tooltip: this.lang.paragraph.outdent + this.representShortcut('outdent'),
	                click: this.context.createInvokeHandler('editor.outdent')
	            });
	            var indent = this.button({
	                contents: this.ui.icon(this.options.icons.indent),
	                tooltip: this.lang.paragraph.indent + this.representShortcut('indent'),
	                click: this.context.createInvokeHandler('editor.indent')
	            });
	            this.context.memo('button.justifyLeft', func.invoke(justifyLeft, 'render'));
	            this.context.memo('button.justifyCenter', func.invoke(justifyCenter, 'render'));
	            this.context.memo('button.justifyRight', func.invoke(justifyRight, 'render'));
	            this.context.memo('button.justifyFull', func.invoke(justifyFull, 'render'));
	            this.context.memo('button.outdent', func.invoke(outdent, 'render'));
	            this.context.memo('button.indent', func.invoke(indent, 'render'));
	            this.context.memo('button.paragraph', function () {
	                return _this.ui.buttonGroup([_this.button({
	                    className: 'dropdown-toggle',
	                    contents: _this.ui.dropdownButtonContents(_this.ui.icon(_this.options.icons.alignLeft), _this.options),
	                    tooltip: _this.lang.paragraph.paragraph,
	                    data: {
	                        toggle: 'dropdown'
	                    }
	                }), _this.ui.dropdown([_this.ui.buttonGroup({
	                    className: 'note-align',
	                    children: [justifyLeft, justifyCenter, justifyRight, justifyFull]
	                }), _this.ui.buttonGroup({
	                    className: 'note-list',
	                    children: [outdent, indent]
	                })])]).render();
	            });
	            this.context.memo('button.height', function () {
	                return _this.ui.buttonGroup([_this.button({
	                    className: 'dropdown-toggle',
	                    contents: _this.ui.dropdownButtonContents(_this.ui.icon(_this.options.icons.textHeight), _this.options),
	                    tooltip: _this.lang.font.height,
	                    data: {
	                        toggle: 'dropdown'
	                    }
	                }), _this.ui.dropdownCheck({
	                    items: _this.options.lineHeights,
	                    checkClassName: _this.options.icons.menuCheck,
	                    className: 'dropdown-line-height',
	                    click: _this.context.createInvokeHandler('editor.lineHeight')
	                })]).render();
	            });
	            this.context.memo('button.table', function () {
	                return _this.ui.buttonGroup([_this.button({
	                    className: 'dropdown-toggle',
	                    contents: _this.ui.dropdownButtonContents(_this.ui.icon(_this.options.icons.table), _this.options),
	                    tooltip: _this.lang.table.table,
	                    data: {
	                        toggle: 'dropdown'
	                    }
	                }), _this.ui.dropdown({
	                    className: 'note-table',
	                    items: ['<div class="note-dimension-picker">', '  <div class="note-dimension-picker-mousecatcher" data-event="insertTable" data-value="1x1"/>', '  <div class="note-dimension-picker-highlighted"/>', '  <div class="note-dimension-picker-unhighlighted"/>', '</div>', '<div class="note-dimension-display">1 x 1</div>'].join('')
	                })], {
	                    callback: function callback($node) {
	                        var $catcher = $node.find('.note-dimension-picker-mousecatcher');
	                        $catcher.css({
	                            width: _this.options.insertTableMaxSize.col + 'em',
	                            height: _this.options.insertTableMaxSize.row + 'em'
	                        }).mousedown(_this.context.createInvokeHandler('editor.insertTable')).on('mousemove', _this.tableMoveHandler.bind(_this));
	                    }
	                }).render();
	            });
	            this.context.memo('button.link', function () {
	                return _this.button({
	                    contents: _this.ui.icon(_this.options.icons.link),
	                    tooltip: _this.lang.link.link + _this.representShortcut('linkDialog.show'),
	                    click: _this.context.createInvokeHandler('linkDialog.show')
	                }).render();
	            });
	            this.context.memo('button.picture', function () {
	                return _this.button({
	                    contents: _this.ui.icon(_this.options.icons.picture),
	                    tooltip: _this.lang.image.image,
	                    click: _this.context.createInvokeHandler('imageDialog.show')
	                }).render();
	            });
	            this.context.memo('button.video', function () {
	                return _this.button({
	                    contents: _this.ui.icon(_this.options.icons.video),
	                    tooltip: _this.lang.video.video,
	                    click: _this.context.createInvokeHandler('videoDialog.show')
	                }).render();
	            });
	            this.context.memo('button.hr', function () {
	                return _this.button({
	                    contents: _this.ui.icon(_this.options.icons.minus),
	                    tooltip: _this.lang.hr.insert + _this.representShortcut('insertHorizontalRule'),
	                    click: _this.context.createInvokeHandler('editor.insertHorizontalRule')
	                }).render();
	            });
	            this.context.memo('button.fullscreen', function () {
	                return _this.button({
	                    className: 'btn-fullscreen',
	                    contents: _this.ui.icon(_this.options.icons.arrowsAlt),
	                    tooltip: _this.options.fullscreen,
	                    click: _this.context.createInvokeHandler('fullscreen.toggle')
	                }).render();
	            });
	            this.context.memo('button.codeview', function () {
	                return _this.button({
	                    className: 'btn-codeview',
	                    contents: _this.ui.icon(_this.options.icons.code),
	                    tooltip: _this.options.codeview,
	                    click: _this.context.createInvokeHandler('codeview.toggle')
	                }).render();
	            });
	            this.context.memo('button.redo', function () {
	                return _this.button({
	                    contents: _this.ui.icon(_this.options.icons.redo),
	                    tooltip: _this.lang.history.redo + _this.representShortcut('redo'),
	                    click: _this.context.createInvokeHandler('editor.redo')
	                }).render();
	            });
	            this.context.memo('button.undo', function () {
	                return _this.button({
	                    contents: _this.ui.icon(_this.options.icons.undo),
	                    tooltip: _this.lang.history.undo + _this.representShortcut('undo'),
	                    click: _this.context.createInvokeHandler('editor.undo')
	                }).render();
	            });
	            this.context.memo('button.help', function () {
	                return _this.button({
	                    contents: _this.ui.icon(_this.options.icons.question),
	                    tooltip: _this.options.help,
	                    click: _this.context.createInvokeHandler('helpDialog.show')
	                }).render();
	            });
	        };
	
	        Buttons.prototype.addImagePopoverButtons = function () {
	            var _this = this;
	
	            this.context.memo('button.imageSize100', function () {
	                return _this.button({
	                    contents: '<span class="note-fontsize-10">100%</span>',
	                    tooltip: _this.lang.image.resizeFull,
	                    click: _this.context.createInvokeHandler('editor.resize', '1')
	                }).render();
	            });
	            this.context.memo('button.imageSize50', function () {
	                return _this.button({
	                    contents: '<span class="note-fontsize-10">50%</span>',
	                    tooltip: _this.lang.image.resizeHalf,
	                    click: _this.context.createInvokeHandler('editor.resize', '0.5')
	                }).render();
	            });
	            this.context.memo('button.imageSize25', function () {
	                return _this.button({
	                    contents: '<span class="note-fontsize-10">25%</span>',
	                    tooltip: _this.lang.image.resizeQuarter,
	                    click: _this.context.createInvokeHandler('editor.resize', '0.25')
	                }).render();
	            });
	
	            this.context.memo('button.floatLeft', function () {
	                return _this.button({
	                    contents: _this.ui.icon(_this.options.icons.alignLeft),
	                    tooltip: _this.lang.image.floatLeft,
	                    click: _this.context.createInvokeHandler('editor.floatMe', 'left')
	                }).render();
	            });
	            this.context.memo('button.floatRight', function () {
	                return _this.button({
	                    contents: _this.ui.icon(_this.options.icons.alignRight),
	                    tooltip: _this.lang.image.floatRight,
	                    click: _this.context.createInvokeHandler('editor.floatMe', 'right')
	                }).render();
	            });
	            this.context.memo('button.floatNone', function () {
	                return _this.button({
	                    contents: _this.ui.icon(_this.options.icons.alignJustify),
	                    tooltip: _this.lang.image.floatNone,
	                    click: _this.context.createInvokeHandler('editor.floatMe', 'none')
	                }).render();
	            });
	
	            this.context.memo('button.removeMedia', function () {
	                return _this.button({
	                    contents: _this.ui.icon(_this.options.icons.trash),
	                    tooltip: _this.lang.image.remove,
	                    click: _this.context.createInvokeHandler('editor.removeMedia')
	                }).render();
	            });
	        };
	        Buttons.prototype.addLinkPopoverButtons = function () {
	            var _this = this;
	            this.context.memo('button.linkDialogShow', function () {
	                return _this.button({
	                    contents: _this.ui.icon(_this.options.icons.link),
	                    tooltip: _this.lang.link.edit,
	                    click: _this.context.createInvokeHandler('linkDialog.show')
	                }).render();
	            });
	            this.context.memo('button.unlink', function () {
	                return _this.button({
	                    contents: _this.ui.icon(_this.options.icons.unlink),
	                    tooltip: _this.lang.link.unlink,
	                    click: _this.context.createInvokeHandler('editor.unlink')
	                }).render();
	            });
	        };
	
	        Buttons.prototype.addTablePopoverButtons = function () {
	            var _this = this;
	            this.context.memo('button.addRowUp', function () {
	                return _this.button({
	                    className: 'btn-md',
	                    contents: _this.ui.icon(_this.options.icons.rowAbove),
	                    tooltip: _this.lang.table.addRowAbove,
	                    click: _this.context.createInvokeHandler('editor.addRow', 'top')
	                }).render();
	            });
	            this.context.memo('button.addRowDown', function () {
	                return _this.button({
	                    className: 'btn-md',
	                    contents: _this.ui.icon(_this.options.icons.rowBelow),
	                    tooltip: _this.lang.table.addRowBelow,
	                    click: _this.context.createInvokeHandler('editor.addRow', 'bottom')
	                }).render();
	            });
	            this.context.memo('button.addColLeft', function () {
	                return _this.button({
	                    className: 'btn-md',
	                    contents: _this.ui.icon(_this.options.icons.colBefore),
	                    tooltip: _this.lang.table.addColLeft,
	                    click: _this.context.createInvokeHandler('editor.addCol', 'left')
	                }).render();
	            });
	            this.context.memo('button.addColRight', function () {
	                return _this.button({
	                    className: 'btn-md',
	                    contents: _this.ui.icon(_this.options.icons.colAfter),
	                    tooltip: _this.lang.table.addColRight,
	                    click: _this.context.createInvokeHandler('editor.addCol', 'right')
	                }).render();
	            });
	            this.context.memo('button.deleteRow', function () {
	                return _this.button({
	                    className: 'btn-md',
	                    contents: _this.ui.icon(_this.options.icons.rowRemove),
	                    tooltip: _this.lang.table.delRow,
	                    click: _this.context.createInvokeHandler('editor.deleteRow')
	                }).render();
	            });
	            this.context.memo('button.deleteCol', function () {
	                return _this.button({
	                    className: 'btn-md',
	                    contents: _this.ui.icon(_this.options.icons.colRemove),
	                    tooltip: _this.lang.table.delCol,
	                    click: _this.context.createInvokeHandler('editor.deleteCol')
	                }).render();
	            });
	            this.context.memo('button.deleteTable', function () {
	                return _this.button({
	                    className: 'btn-md',
	                    contents: _this.ui.icon(_this.options.icons.trash),
	                    tooltip: _this.lang.table.delTable,
	                    click: _this.context.createInvokeHandler('editor.deleteTable')
	                }).render();
	            });
	        };
	        Buttons.prototype.build = function ($container, groups) {
	            for (var groupIdx = 0, groupLen = groups.length; groupIdx < groupLen; groupIdx++) {
	                var group = groups[groupIdx];
	                var groupName = $$1.isArray(group) ? group[0] : group;
	                var buttons = $$1.isArray(group) ? group.length === 1 ? [group[0]] : group[1] : [group];
	                var $group = this.ui.buttonGroup({
	                    className: 'note-' + groupName
	                }).render();
	                for (var idx = 0, len = buttons.length; idx < len; idx++) {
	                    var btn = this.context.memo('button.' + buttons[idx]);
	                    if (btn) {
	                        $group.append(typeof btn === 'function' ? btn(this.context) : btn);
	                    }
	                }
	                $group.appendTo($container);
	            }
	        };
	
	        Buttons.prototype.updateCurrentStyle = function ($container) {
	            var _this = this;
	            var $cont = $container || this.$toolbar;
	            var styleInfo = this.context.invoke('editor.currentStyle');
	            this.updateBtnStates($cont, {
	                '.note-btn-bold': function noteBtnBold() {
	                    return styleInfo['font-bold'] === 'bold';
	                },
	                '.note-btn-italic': function noteBtnItalic() {
	                    return styleInfo['font-italic'] === 'italic';
	                },
	                '.note-btn-underline': function noteBtnUnderline() {
	                    return styleInfo['font-underline'] === 'underline';
	                },
	                '.note-btn-subscript': function noteBtnSubscript() {
	                    return styleInfo['font-subscript'] === 'subscript';
	                },
	                '.note-btn-superscript': function noteBtnSuperscript() {
	                    return styleInfo['font-superscript'] === 'superscript';
	                },
	                '.note-btn-strikethrough': function noteBtnStrikethrough() {
	                    return styleInfo['font-strikethrough'] === 'strikethrough';
	                }
	            });
	            if (styleInfo['font-family']) {
	                var fontNames = styleInfo['font-family'].split(',').map(function (name) {
	                    return name.replace(/[\'\"]/g, '').replace(/\s+$/, '').replace(/^\s+/, '');
	                });
	                var fontName_1 = lists.find(fontNames, this.isFontInstalled.bind(this));
	                $cont.find('.dropdown-fontname a').each(function (idx, item) {
	                    var $item = $$1(item);
	
	                    var isChecked = $item.data('value') + '' === fontName_1 + '';
	                    $item.toggleClass('checked', isChecked);
	                });
	                $cont.find('.note-current-fontname').text(fontName_1).css('font-family', fontName_1);
	            }
	            if (styleInfo['font-size']) {
	                var fontSize_1 = styleInfo['font-size'];
	                $cont.find('.dropdown-fontsize a').each(function (idx, item) {
	                    var $item = $$1(item);
	
	                    var isChecked = $item.data('value') + '' === fontSize_1 + '';
	                    $item.toggleClass('checked', isChecked);
	                });
	                $cont.find('.note-current-fontsize').text(fontSize_1);
	            }
	            if (styleInfo['line-height']) {
	                var lineHeight_1 = styleInfo['line-height'];
	                $cont.find('.dropdown-line-height li a').each(function (idx, item) {
	                    var isChecked = $$1(item).data('value') + '' === lineHeight_1 + '';
	                    _this.className = isChecked ? 'checked' : '';
	                });
	            }
	        };
	        Buttons.prototype.updateBtnStates = function ($container, infos) {
	            var _this = this;
	            $$1.each(infos, function (selector, pred) {
	                _this.ui.toggleBtnActive($container.find(selector), pred());
	            });
	        };
	        Buttons.prototype.tableMoveHandler = function (event) {
	            var PX_PER_EM = 18;
	            var $picker = $$1(event.target.parentNode);
	            var $dimensionDisplay = $picker.next();
	            var $catcher = $picker.find('.note-dimension-picker-mousecatcher');
	            var $highlighted = $picker.find('.note-dimension-picker-highlighted');
	            var $unhighlighted = $picker.find('.note-dimension-picker-unhighlighted');
	            var posOffset;
	
	            if (event.offsetX === undefined) {
	                var posCatcher = $$1(event.target).offset();
	                posOffset = {
	                    x: event.pageX - posCatcher.left,
	                    y: event.pageY - posCatcher.top
	                };
	            } else {
	                posOffset = {
	                    x: event.offsetX,
	                    y: event.offsetY
	                };
	            }
	            var dim = {
	                c: Math.ceil(posOffset.x / PX_PER_EM) || 1,
	                r: Math.ceil(posOffset.y / PX_PER_EM) || 1
	            };
	            $highlighted.css({ width: dim.c + 'em', height: dim.r + 'em' });
	            $catcher.data('value', dim.c + 'x' + dim.r);
	            if (dim.c > 3 && dim.c < this.options.insertTableMaxSize.col) {
	                $unhighlighted.css({ width: dim.c + 1 + 'em' });
	            }
	            if (dim.r > 3 && dim.r < this.options.insertTableMaxSize.row) {
	                $unhighlighted.css({ height: dim.r + 1 + 'em' });
	            }
	            $dimensionDisplay.html(dim.c + ' x ' + dim.r);
	        };
	        return Buttons;
	    }();
	
	    var Toolbar = function () {
	        function Toolbar(context) {
	            this.context = context;
	            this.$window = $$1(window);
	            this.$document = $$1(document);
	            this.ui = $$1.summernote.ui;
	            this.$note = context.layoutInfo.note;
	            this.$editor = context.layoutInfo.editor;
	            this.$toolbar = context.layoutInfo.toolbar;
	            this.options = context.options;
	            this.followScroll = this.followScroll.bind(this);
	        }
	        Toolbar.prototype.shouldInitialize = function () {
	            return !this.options.airMode;
	        };
	        Toolbar.prototype.initialize = function () {
	            var _this = this;
	            this.options.toolbar = this.options.toolbar || [];
	            if (!this.options.toolbar.length) {
	                this.$toolbar.hide();
	            } else {
	                this.context.invoke('buttons.build', this.$toolbar, this.options.toolbar);
	            }
	            if (this.options.toolbarContainer) {
	                this.$toolbar.appendTo(this.options.toolbarContainer);
	            }
	            this.changeContainer(false);
	            this.$note.on('summernote.keyup summernote.mouseup summernote.change', function () {
	                _this.context.invoke('buttons.updateCurrentStyle');
	            });
	            this.context.invoke('buttons.updateCurrentStyle');
	            if (this.options.followingToolbar) {
	                this.$window.on('scroll resize', this.followScroll);
	            }
	        };
	        Toolbar.prototype.destroy = function () {
	            this.$toolbar.children().remove();
	            if (this.options.followingToolbar) {
	                this.$window.off('scroll resize', this.followScroll);
	            }
	        };
	        Toolbar.prototype.followScroll = function () {
	            if (this.$editor.hasClass('fullscreen')) {
	                return false;
	            }
	            var $toolbarWrapper = this.$toolbar.parent('.note-toolbar-wrapper');
	            var editorHeight = this.$editor.outerHeight();
	            var editorWidth = this.$editor.width();
	            var toolbarHeight = this.$toolbar.height();
	            $toolbarWrapper.css({
	                height: toolbarHeight
	            });
	
	            var otherBarHeight = 0;
	            if (this.options.otherStaticBar) {
	                otherBarHeight = $$1(this.options.otherStaticBar).outerHeight();
	            }
	            var currentOffset = this.$document.scrollTop();
	            var editorOffsetTop = this.$editor.offset().top;
	            var editorOffsetBottom = editorOffsetTop + editorHeight;
	            var activateOffset = editorOffsetTop - otherBarHeight;
	            var deactivateOffsetBottom = editorOffsetBottom - otherBarHeight - toolbarHeight;
	            if (currentOffset > activateOffset && currentOffset < deactivateOffsetBottom) {
	                this.$toolbar.css({
	                    position: 'fixed',
	                    top: otherBarHeight,
	                    width: editorWidth
	                });
	            } else {
	                this.$toolbar.css({
	                    position: 'relative',
	                    top: 0,
	                    width: '100%'
	                });
	            }
	        };
	        Toolbar.prototype.changeContainer = function (isFullscreen) {
	            if (isFullscreen) {
	                this.$toolbar.prependTo(this.$editor);
	            } else {
	                if (this.options.toolbarContainer) {
	                    this.$toolbar.appendTo(this.options.toolbarContainer);
	                }
	            }
	        };
	        Toolbar.prototype.updateFullscreen = function (isFullscreen) {
	            this.ui.toggleBtnActive(this.$toolbar.find('.btn-fullscreen'), isFullscreen);
	            this.changeContainer(isFullscreen);
	        };
	        Toolbar.prototype.updateCodeview = function (isCodeview) {
	            this.ui.toggleBtnActive(this.$toolbar.find('.btn-codeview'), isCodeview);
	            if (isCodeview) {
	                this.deactivate();
	            } else {
	                this.activate();
	            }
	        };
	        Toolbar.prototype.activate = function (isIncludeCodeview) {
	            var $btn = this.$toolbar.find('button');
	            if (!isIncludeCodeview) {
	                $btn = $btn.not('.btn-codeview');
	            }
	            this.ui.toggleBtn($btn, true);
	        };
	        Toolbar.prototype.deactivate = function (isIncludeCodeview) {
	            var $btn = this.$toolbar.find('button');
	            if (!isIncludeCodeview) {
	                $btn = $btn.not('.btn-codeview');
	            }
	            this.ui.toggleBtn($btn, false);
	        };
	        return Toolbar;
	    }();
	
	    var LinkDialog = function () {
	        function LinkDialog(context) {
	            this.context = context;
	            this.ui = $$1.summernote.ui;
	            this.$body = $$1(document.body);
	            this.$editor = context.layoutInfo.editor;
	            this.options = context.options;
	            this.lang = this.options.langInfo;
	            context.memo('help.linkDialog.show', this.options.langInfo.help['linkDialog.show']);
	        }
	        LinkDialog.prototype.initialize = function () {
	            var $container = this.options.dialogsInBody ? this.$body : this.$editor;
	            var body = ['<div class="form-group note-form-group">', "<label class=\"note-form-label\">" + this.lang.link.textToDisplay + "</label>", '<input class="note-link-text form-control note-form-control  note-input" type="text" />', '</div>', '<div class="form-group note-form-group">', "<label class=\"note-form-label\">" + this.lang.link.url + "</label>", '<input class="note-link-url form-control note-form-control note-input" type="text" value="http://" />', '</div>', !this.options.disableLinkTarget ? $$1('<div/>').append(this.ui.checkbox({
	                id: 'sn-checkbox-open-in-new-window',
	                text: this.lang.link.openInNewWindow,
	                checked: true
	            }).render()).html() : ''].join('');
	            var buttonClass = 'btn btn-primary note-btn note-btn-primary note-link-btn';
	            var footer = "<button type=\"submit\" href=\"#\" class=\"" + buttonClass + "\" disabled>" + this.lang.link.insert + "</button>";
	            this.$dialog = this.ui.dialog({
	                className: 'link-dialog',
	                title: this.lang.link.insert,
	                fade: this.options.dialogsFade,
	                body: body,
	                footer: footer
	            }).render().appendTo($container);
	        };
	        LinkDialog.prototype.destroy = function () {
	            this.ui.hideDialog(this.$dialog);
	            this.$dialog.remove();
	        };
	        LinkDialog.prototype.bindEnterKey = function ($input, $btn) {
	            $input.on('keypress', function (event) {
	                if (event.keyCode === key.code.ENTER) {
	                    event.preventDefault();
	                    $btn.trigger('click');
	                }
	            });
	        };
	
	        LinkDialog.prototype.toggleLinkBtn = function ($linkBtn, $linkText, $linkUrl) {
	            this.ui.toggleBtn($linkBtn, $linkText.val() && $linkUrl.val());
	        };
	
	        LinkDialog.prototype.showLinkDialog = function (linkInfo) {
	            var _this = this;
	            return $$1.Deferred(function (deferred) {
	                var $linkText = _this.$dialog.find('.note-link-text');
	                var $linkUrl = _this.$dialog.find('.note-link-url');
	                var $linkBtn = _this.$dialog.find('.note-link-btn');
	                var $openInNewWindow = _this.$dialog.find('input[type=checkbox]');
	                _this.ui.onDialogShown(_this.$dialog, function () {
	                    _this.context.triggerEvent('dialog.shown');
	
	                    if (!linkInfo.url) {
	                        linkInfo.url = linkInfo.text;
	                    }
	                    $linkText.val(linkInfo.text);
	                    var handleLinkTextUpdate = function handleLinkTextUpdate() {
	                        _this.toggleLinkBtn($linkBtn, $linkText, $linkUrl);
	
	                        linkInfo.text = $linkText.val();
	                    };
	                    $linkText.on('input', handleLinkTextUpdate).on('paste', function () {
	                        setTimeout(handleLinkTextUpdate, 0);
	                    });
	                    var handleLinkUrlUpdate = function handleLinkUrlUpdate() {
	                        _this.toggleLinkBtn($linkBtn, $linkText, $linkUrl);
	
	                        if (!linkInfo.text) {
	                            $linkText.val($linkUrl.val());
	                        }
	                    };
	                    $linkUrl.on('input', handleLinkUrlUpdate).on('paste', function () {
	                        setTimeout(handleLinkUrlUpdate, 0);
	                    }).val(linkInfo.url);
	                    if (!env.isSupportTouch) {
	                        $linkUrl.trigger('focus');
	                    }
	                    _this.toggleLinkBtn($linkBtn, $linkText, $linkUrl);
	                    _this.bindEnterKey($linkUrl, $linkBtn);
	                    _this.bindEnterKey($linkText, $linkBtn);
	                    var isChecked = linkInfo.isNewWindow !== undefined ? linkInfo.isNewWindow : _this.context.options.linkTargetBlank;
	                    $openInNewWindow.prop('checked', isChecked);
	                    $linkBtn.one('click', function (event) {
	                        event.preventDefault();
	                        deferred.resolve({
	                            range: linkInfo.range,
	                            url: $linkUrl.val(),
	                            text: $linkText.val(),
	                            isNewWindow: $openInNewWindow.is(':checked')
	                        });
	                        _this.ui.hideDialog(_this.$dialog);
	                    });
	                });
	                _this.ui.onDialogHidden(_this.$dialog, function () {
	                    $linkText.off('input paste keypress');
	                    $linkUrl.off('input paste keypress');
	                    $linkBtn.off('click');
	                    if (deferred.state() === 'pending') {
	                        deferred.reject();
	                    }
	                });
	                _this.ui.showDialog(_this.$dialog);
	            }).promise();
	        };
	
	        LinkDialog.prototype.show = function () {
	            var _this = this;
	            var linkInfo = this.context.invoke('editor.getLinkInfo');
	            this.context.invoke('editor.saveRange');
	            this.showLinkDialog(linkInfo).then(function (linkInfo) {
	                _this.context.invoke('editor.restoreRange');
	                _this.context.invoke('editor.createLink', linkInfo);
	            }).fail(function () {
	                _this.context.invoke('editor.restoreRange');
	            });
	        };
	        return LinkDialog;
	    }();
	
	    var LinkPopover = function () {
	        function LinkPopover(context) {
	            var _this = this;
	            this.context = context;
	            this.ui = $$1.summernote.ui;
	            this.options = context.options;
	            this.events = {
	                'summernote.keyup summernote.mouseup summernote.change summernote.scroll': function summernoteKeyupSummernoteMouseupSummernoteChangeSummernoteScroll() {
	                    _this.update();
	                },
	                'summernote.disable summernote.dialog.shown': function summernoteDisableSummernoteDialogShown() {
	                    _this.hide();
	                }
	            };
	        }
	        LinkPopover.prototype.shouldInitialize = function () {
	            return !lists.isEmpty(this.options.popover.link);
	        };
	        LinkPopover.prototype.initialize = function () {
	            this.$popover = this.ui.popover({
	                className: 'note-link-popover',
	                callback: function callback($node) {
	                    var $content = $node.find('.popover-content,.note-popover-content');
	                    $content.prepend('<span><a target="_blank"></a>&nbsp;</span>');
	                }
	            }).render().appendTo(this.options.container);
	            var $content = this.$popover.find('.popover-content,.note-popover-content');
	            this.context.invoke('buttons.build', $content, this.options.popover.link);
	        };
	        LinkPopover.prototype.destroy = function () {
	            this.$popover.remove();
	        };
	        LinkPopover.prototype.update = function () {
	            if (!this.context.invoke('editor.hasFocus')) {
	                this.hide();
	                return;
	            }
	            var rng = this.context.invoke('editor.createRange');
	            if (rng.isCollapsed() && rng.isOnAnchor()) {
	                var anchor = dom.ancestor(rng.sc, dom.isAnchor);
	                var href = $$1(anchor).attr('href');
	                this.$popover.find('a').attr('href', href).html(href);
	                var pos = dom.posFromPlaceholder(anchor);
	                this.$popover.css({
	                    display: 'block',
	                    left: pos.left,
	                    top: pos.top
	                });
	            } else {
	                this.hide();
	            }
	        };
	        LinkPopover.prototype.hide = function () {
	            this.$popover.hide();
	        };
	        return LinkPopover;
	    }();
	
	    var ImageDialog = function () {
	        function ImageDialog(context) {
	            this.context = context;
	            this.ui = $$1.summernote.ui;
	            this.$body = $$1(document.body);
	            this.$editor = context.layoutInfo.editor;
	            this.options = context.options;
	            this.lang = this.options.langInfo;
	        }
	        ImageDialog.prototype.initialize = function () {
	            var $container = this.options.dialogsInBody ? this.$body : this.$editor;
	            var imageLimitation = '';
	            if (this.options.maximumImageFileSize) {
	                var unit = Math.floor(Math.log(this.options.maximumImageFileSize) / Math.log(1024));
	                var readableSize = (this.options.maximumImageFileSize / Math.pow(1024, unit)).toFixed(2) * 1 + ' ' + ' KMGTP'[unit] + 'B';
	                imageLimitation = "<small>" + (this.lang.image.maximumFileSize + ' : ' + readableSize) + "</small>";
	            }
	            var body = ['<div class="form-group note-form-group note-group-select-from-files">', '<label class="note-form-label">' + this.lang.image.selectFromFiles + '</label>', '<input class="note-image-input note-form-control note-input" ', ' type="file" name="files" accept="image/*" multiple="multiple" />', imageLimitation, '</div>', '<div class="form-group note-group-image-url" style="overflow:auto;">', '<label class="note-form-label">' + this.lang.image.url + '</label>', '<input class="note-image-url form-control note-form-control note-input ', ' col-md-12" type="text" />', '</div>'].join('');
	            var buttonClass = 'btn btn-primary note-btn note-btn-primary note-image-btn';
	            var footer = "<button type=\"submit\" href=\"#\" class=\"" + buttonClass + "\" disabled>" + this.lang.image.insert + "</button>";
	            this.$dialog = this.ui.dialog({
	                title: this.lang.image.insert,
	                fade: this.options.dialogsFade,
	                body: body,
	                footer: footer
	            }).render().appendTo($container);
	        };
	        ImageDialog.prototype.destroy = function () {
	            this.ui.hideDialog(this.$dialog);
	            this.$dialog.remove();
	        };
	        ImageDialog.prototype.bindEnterKey = function ($input, $btn) {
	            $input.on('keypress', function (event) {
	                if (event.keyCode === key.code.ENTER) {
	                    event.preventDefault();
	                    $btn.trigger('click');
	                }
	            });
	        };
	        ImageDialog.prototype.show = function () {
	            var _this = this;
	            this.context.invoke('editor.saveRange');
	            this.showImageDialog().then(function (data) {
	                _this.ui.hideDialog(_this.$dialog);
	                _this.context.invoke('editor.restoreRange');
	                if (typeof data === 'string') {
	                    _this.context.invoke('editor.insertImage', data);
	                } else {
	                    _this.context.invoke('editor.insertImagesOrCallback', data);
	                }
	            }).fail(function () {
	                _this.context.invoke('editor.restoreRange');
	            });
	        };
	
	        ImageDialog.prototype.showImageDialog = function () {
	            var _this = this;
	            return $$1.Deferred(function (deferred) {
	                var $imageInput = _this.$dialog.find('.note-image-input');
	                var $imageUrl = _this.$dialog.find('.note-image-url');
	                var $imageBtn = _this.$dialog.find('.note-image-btn');
	                _this.ui.onDialogShown(_this.$dialog, function () {
	                    _this.context.triggerEvent('dialog.shown');
	
	                    $imageInput.replaceWith($imageInput.clone().on('change', function (event) {
	                        deferred.resolve(event.target.files || event.target.value);
	                    }).val(''));
	                    $imageBtn.click(function (event) {
	                        event.preventDefault();
	                        deferred.resolve($imageUrl.val());
	                    });
	                    $imageUrl.on('keyup paste', function () {
	                        var url = $imageUrl.val();
	                        _this.ui.toggleBtn($imageBtn, url);
	                    }).val('');
	                    if (!env.isSupportTouch) {
	                        $imageUrl.trigger('focus');
	                    }
	                    _this.bindEnterKey($imageUrl, $imageBtn);
	                });
	                _this.ui.onDialogHidden(_this.$dialog, function () {
	                    $imageInput.off('change');
	                    $imageUrl.off('keyup paste keypress');
	                    $imageBtn.off('click');
	                    if (deferred.state() === 'pending') {
	                        deferred.reject();
	                    }
	                });
	                _this.ui.showDialog(_this.$dialog);
	            });
	        };
	        return ImageDialog;
	    }();
	
	    var ImagePopover = function () {
	        function ImagePopover(context) {
	            var _this = this;
	            this.context = context;
	            this.ui = $$1.summernote.ui;
	            this.editable = context.layoutInfo.editable[0];
	            this.options = context.options;
	            this.events = {
	                'summernote.disable': function summernoteDisable() {
	                    _this.hide();
	                }
	            };
	        }
	        ImagePopover.prototype.shouldInitialize = function () {
	            return !lists.isEmpty(this.options.popover.image);
	        };
	        ImagePopover.prototype.initialize = function () {
	            this.$popover = this.ui.popover({
	                className: 'note-image-popover'
	            }).render().appendTo(this.options.container);
	            var $content = this.$popover.find('.popover-content,.note-popover-content');
	            this.context.invoke('buttons.build', $content, this.options.popover.image);
	        };
	        ImagePopover.prototype.destroy = function () {
	            this.$popover.remove();
	        };
	        ImagePopover.prototype.update = function (target) {
	            if (dom.isImg(target)) {
	                var pos = dom.posFromPlaceholder(target);
	                var posEditor = dom.posFromPlaceholder(this.editable);
	                this.$popover.css({
	                    display: 'block',
	                    left: this.options.popatmouse ? event.pageX - 20 : pos.left,
	                    top: this.options.popatmouse ? event.pageY : Math.min(pos.top, posEditor.top)
	                });
	            } else {
	                this.hide();
	            }
	        };
	        ImagePopover.prototype.hide = function () {
	            this.$popover.hide();
	        };
	        return ImagePopover;
	    }();
	
	    var TablePopover = function () {
	        function TablePopover(context) {
	            var _this = this;
	            this.context = context;
	            this.ui = $$1.summernote.ui;
	            this.options = context.options;
	            this.events = {
	                'summernote.mousedown': function summernoteMousedown(we, e) {
	                    _this.update(e.target);
	                },
	                'summernote.keyup summernote.scroll summernote.change': function summernoteKeyupSummernoteScrollSummernoteChange() {
	                    _this.update();
	                },
	                'summernote.disable': function summernoteDisable() {
	                    _this.hide();
	                }
	            };
	        }
	        TablePopover.prototype.shouldInitialize = function () {
	            return !lists.isEmpty(this.options.popover.table);
	        };
	        TablePopover.prototype.initialize = function () {
	            this.$popover = this.ui.popover({
	                className: 'note-table-popover'
	            }).render().appendTo(this.options.container);
	            var $content = this.$popover.find('.popover-content,.note-popover-content');
	            this.context.invoke('buttons.build', $content, this.options.popover.table);
	
	            if (env.isFF) {
	                document.execCommand('enableInlineTableEditing', false, false);
	            }
	        };
	        TablePopover.prototype.destroy = function () {
	            this.$popover.remove();
	        };
	        TablePopover.prototype.update = function (target) {
	            if (this.context.isDisabled()) {
	                return false;
	            }
	            var isCell = dom.isCell(target);
	            if (isCell) {
	                var pos = dom.posFromPlaceholder(target);
	                this.$popover.css({
	                    display: 'block',
	                    left: pos.left,
	                    top: pos.top
	                });
	            } else {
	                this.hide();
	            }
	            return isCell;
	        };
	        TablePopover.prototype.hide = function () {
	            this.$popover.hide();
	        };
	        return TablePopover;
	    }();
	
	    var VideoDialog = function () {
	        function VideoDialog(context) {
	            this.context = context;
	            this.ui = $$1.summernote.ui;
	            this.$body = $$1(document.body);
	            this.$editor = context.layoutInfo.editor;
	            this.options = context.options;
	            this.lang = this.options.langInfo;
	        }
	        VideoDialog.prototype.initialize = function () {
	            var $container = this.options.dialogsInBody ? this.$body : this.$editor;
	            var body = ['<div class="form-group note-form-group row-fluid">', "<label class=\"note-form-label\">" + this.lang.video.url + " <small class=\"text-muted\">" + this.lang.video.providers + "</small></label>", '<input class="note-video-url form-control note-form-control note-input" type="text" />', '</div>'].join('');
	            var buttonClass = 'btn btn-primary note-btn note-btn-primary note-video-btn';
	            var footer = "<button type=\"submit\" href=\"#\" class=\"" + buttonClass + "\" disabled>" + this.lang.video.insert + "</button>";
	            this.$dialog = this.ui.dialog({
	                title: this.lang.video.insert,
	                fade: this.options.dialogsFade,
	                body: body,
	                footer: footer
	            }).render().appendTo($container);
	        };
	        VideoDialog.prototype.destroy = function () {
	            this.ui.hideDialog(this.$dialog);
	            this.$dialog.remove();
	        };
	        VideoDialog.prototype.bindEnterKey = function ($input, $btn) {
	            $input.on('keypress', function (event) {
	                if (event.keyCode === key.code.ENTER) {
	                    event.preventDefault();
	                    $btn.trigger('click');
	                }
	            });
	        };
	        VideoDialog.prototype.createVideoNode = function (url) {
	            var ytRegExp = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
	            var ytMatch = url.match(ytRegExp);
	            var igRegExp = /(?:www\.|\/\/)instagram\.com\/p\/(.[a-zA-Z0-9_-]*)/;
	            var igMatch = url.match(igRegExp);
	            var vRegExp = /\/\/vine\.co\/v\/([a-zA-Z0-9]+)/;
	            var vMatch = url.match(vRegExp);
	            var vimRegExp = /\/\/(player\.)?vimeo\.com\/([a-z]*\/)*(\d+)[?]?.*/;
	            var vimMatch = url.match(vimRegExp);
	            var dmRegExp = /.+dailymotion.com\/(video|hub)\/([^_]+)[^#]*(#video=([^_&]+))?/;
	            var dmMatch = url.match(dmRegExp);
	            var youkuRegExp = /\/\/v\.youku\.com\/v_show\/id_(\w+)=*\.html/;
	            var youkuMatch = url.match(youkuRegExp);
	            var qqRegExp = /\/\/v\.qq\.com.*?vid=(.+)/;
	            var qqMatch = url.match(qqRegExp);
	            var qqRegExp2 = /\/\/v\.qq\.com\/x?\/?(page|cover).*?\/([^\/]+)\.html\??.*/;
	            var qqMatch2 = url.match(qqRegExp2);
	            var mp4RegExp = /^.+.(mp4|m4v)$/;
	            var mp4Match = url.match(mp4RegExp);
	            var oggRegExp = /^.+.(ogg|ogv)$/;
	            var oggMatch = url.match(oggRegExp);
	            var webmRegExp = /^.+.(webm)$/;
	            var webmMatch = url.match(webmRegExp);
	            var $video;
	            if (ytMatch && ytMatch[1].length === 11) {
	                var youtubeId = ytMatch[1];
	                $video = $$1('<iframe>').attr('frameborder', 0).attr('src', '//www.youtube.com/embed/' + youtubeId).attr('width', '640').attr('height', '360');
	            } else if (igMatch && igMatch[0].length) {
	                $video = $$1('<iframe>').attr('frameborder', 0).attr('src', 'https://instagram.com/p/' + igMatch[1] + '/embed/').attr('width', '612').attr('height', '710').attr('scrolling', 'no').attr('allowtransparency', 'true');
	            } else if (vMatch && vMatch[0].length) {
	                $video = $$1('<iframe>').attr('frameborder', 0).attr('src', vMatch[0] + '/embed/simple').attr('width', '600').attr('height', '600').attr('class', 'vine-embed');
	            } else if (vimMatch && vimMatch[3].length) {
	                $video = $$1('<iframe webkitallowfullscreen mozallowfullscreen allowfullscreen>').attr('frameborder', 0).attr('src', '//player.vimeo.com/video/' + vimMatch[3]).attr('width', '640').attr('height', '360');
	            } else if (dmMatch && dmMatch[2].length) {
	                $video = $$1('<iframe>').attr('frameborder', 0).attr('src', '//www.dailymotion.com/embed/video/' + dmMatch[2]).attr('width', '640').attr('height', '360');
	            } else if (youkuMatch && youkuMatch[1].length) {
	                $video = $$1('<iframe webkitallowfullscreen mozallowfullscreen allowfullscreen>').attr('frameborder', 0).attr('height', '498').attr('width', '510').attr('src', '//player.youku.com/embed/' + youkuMatch[1]);
	            } else if (qqMatch && qqMatch[1].length || qqMatch2 && qqMatch2[2].length) {
	                var vid = qqMatch && qqMatch[1].length ? qqMatch[1] : qqMatch2[2];
	                $video = $$1('<iframe webkitallowfullscreen mozallowfullscreen allowfullscreen>').attr('frameborder', 0).attr('height', '310').attr('width', '500').attr('src', 'http://v.qq.com/iframe/player.html?vid=' + vid + '&amp;auto=0');
	            } else if (mp4Match || oggMatch || webmMatch) {
	                $video = $$1('<video controls>').attr('src', url).attr('width', '640').attr('height', '360');
	            } else {
	                return false;
	            }
	            $video.addClass('note-video-clip');
	            return $video[0];
	        };
	        VideoDialog.prototype.show = function () {
	            var _this = this;
	            var text = this.context.invoke('editor.getSelectedText');
	            this.context.invoke('editor.saveRange');
	            this.showVideoDialog(text).then(function (url) {
	                _this.ui.hideDialog(_this.$dialog);
	                _this.context.invoke('editor.restoreRange');
	
	                var $node = _this.createVideoNode(url);
	                if ($node) {
	                    _this.context.invoke('editor.insertNode', $node);
	                }
	            }).fail(function () {
	                _this.context.invoke('editor.restoreRange');
	            });
	        };
	
	        VideoDialog.prototype.showVideoDialog = function (text) {
	            var _this = this;
	            return $$1.Deferred(function (deferred) {
	                var $videoUrl = _this.$dialog.find('.note-video-url');
	                var $videoBtn = _this.$dialog.find('.note-video-btn');
	                _this.ui.onDialogShown(_this.$dialog, function () {
	                    _this.context.triggerEvent('dialog.shown');
	                    $videoUrl.val(text).on('input', function () {
	                        _this.ui.toggleBtn($videoBtn, $videoUrl.val());
	                    });
	                    if (!env.isSupportTouch) {
	                        $videoUrl.trigger('focus');
	                    }
	                    $videoBtn.click(function (event) {
	                        event.preventDefault();
	                        deferred.resolve($videoUrl.val());
	                    });
	                    _this.bindEnterKey($videoUrl, $videoBtn);
	                });
	                _this.ui.onDialogHidden(_this.$dialog, function () {
	                    $videoUrl.off('input');
	                    $videoBtn.off('click');
	                    if (deferred.state() === 'pending') {
	                        deferred.reject();
	                    }
	                });
	                _this.ui.showDialog(_this.$dialog);
	            });
	        };
	        return VideoDialog;
	    }();
	
	    var HelpDialog = function () {
	        function HelpDialog(context) {
	            this.context = context;
	            this.ui = $$1.summernote.ui;
	            this.$body = $$1(document.body);
	            this.$editor = context.layoutInfo.editor;
	            this.options = context.options;
	            this.lang = this.options.langInfo;
	        }
	        HelpDialog.prototype.initialize = function () {
	            var $container = this.options.dialogsInBody ? this.$body : this.$editor;
	            var body = ['<p class="text-center">', '<a href="http://summernote.org/" target="_blank">Summernote 0.8.9</a> · ', '<a href="https://github.com/summernote/summernote" target="_blank">Project</a> · ', '<a href="https://github.com/summernote/summernote/issues" target="_blank">Issues</a>', '</p>'].join('');
	            this.$dialog = this.ui.dialog({
	                title: this.lang.options.help,
	                fade: this.options.dialogsFade,
	                body: this.createShortcutList(),
	                footer: body,
	                callback: function callback($node) {
	                    $node.find('.modal-body,.note-modal-body').css({
	                        'max-height': 300,
	                        'overflow': 'scroll'
	                    });
	                }
	            }).render().appendTo($container);
	        };
	        HelpDialog.prototype.destroy = function () {
	            this.ui.hideDialog(this.$dialog);
	            this.$dialog.remove();
	        };
	        HelpDialog.prototype.createShortcutList = function () {
	            var _this = this;
	            var keyMap = this.options.keyMap[env.isMac ? 'mac' : 'pc'];
	            return (0, _keys2.default)(keyMap).map(function (key) {
	                var command = keyMap[key];
	                var $row = $$1('<div><div class="help-list-item"/></div>');
	                $row.append($$1('<label><kbd>' + key + '</kdb></label>').css({
	                    'width': 180,
	                    'margin-right': 10
	                })).append($$1('<span/>').html(_this.context.memo('help.' + command) || command));
	                return $row.html();
	            }).join('');
	        };
	
	        HelpDialog.prototype.showHelpDialog = function () {
	            var _this = this;
	            return $$1.Deferred(function (deferred) {
	                _this.ui.onDialogShown(_this.$dialog, function () {
	                    _this.context.triggerEvent('dialog.shown');
	                    deferred.resolve();
	                });
	                _this.ui.showDialog(_this.$dialog);
	            }).promise();
	        };
	        HelpDialog.prototype.show = function () {
	            var _this = this;
	            this.context.invoke('editor.saveRange');
	            this.showHelpDialog().then(function () {
	                _this.context.invoke('editor.restoreRange');
	            });
	        };
	        return HelpDialog;
	    }();
	
	    var AIR_MODE_POPOVER_X_OFFSET = 20;
	    var AirPopover = function () {
	        function AirPopover(context) {
	            var _this = this;
	            this.context = context;
	            this.ui = $$1.summernote.ui;
	            this.options = context.options;
	            this.events = {
	                'summernote.keyup summernote.mouseup summernote.scroll': function summernoteKeyupSummernoteMouseupSummernoteScroll() {
	                    _this.update();
	                },
	                'summernote.disable summernote.change summernote.dialog.shown': function summernoteDisableSummernoteChangeSummernoteDialogShown() {
	                    _this.hide();
	                },
	                'summernote.focusout': function summernoteFocusout(we, e) {
	                    if (env.isFF) {
	                        return;
	                    }
	                    if (!e.relatedTarget || !dom.ancestor(e.relatedTarget, func.eq(_this.$popover[0]))) {
	                        _this.hide();
	                    }
	                }
	            };
	        }
	        AirPopover.prototype.shouldInitialize = function () {
	            return this.options.airMode && !lists.isEmpty(this.options.popover.air);
	        };
	        AirPopover.prototype.initialize = function () {
	            this.$popover = this.ui.popover({
	                className: 'note-air-popover'
	            }).render().appendTo(this.options.container);
	            var $content = this.$popover.find('.popover-content');
	            this.context.invoke('buttons.build', $content, this.options.popover.air);
	        };
	        AirPopover.prototype.destroy = function () {
	            this.$popover.remove();
	        };
	        AirPopover.prototype.update = function () {
	            var styleInfo = this.context.invoke('editor.currentStyle');
	            if (styleInfo.range && !styleInfo.range.isCollapsed()) {
	                var rect = lists.last(styleInfo.range.getClientRects());
	                if (rect) {
	                    var bnd = func.rect2bnd(rect);
	                    this.$popover.css({
	                        display: 'block',
	                        left: Math.max(bnd.left + bnd.width / 2, 0) - AIR_MODE_POPOVER_X_OFFSET,
	                        top: bnd.top + bnd.height
	                    });
	                    this.context.invoke('buttons.updateCurrentStyle', this.$popover);
	                }
	            } else {
	                this.hide();
	            }
	        };
	        AirPopover.prototype.hide = function () {
	            this.$popover.hide();
	        };
	        return AirPopover;
	    }();
	
	    var POPOVER_DIST = 5;
	    var HintPopover = function () {
	        function HintPopover(context) {
	            var _this = this;
	            this.context = context;
	            this.ui = $$1.summernote.ui;
	            this.$editable = context.layoutInfo.editable;
	            this.options = context.options;
	            this.hint = this.options.hint || [];
	            this.direction = this.options.hintDirection || 'bottom';
	            this.hints = $$1.isArray(this.hint) ? this.hint : [this.hint];
	            this.events = {
	                'summernote.keyup': function summernoteKeyup(we, e) {
	                    if (!e.isDefaultPrevented()) {
	                        _this.handleKeyup(e);
	                    }
	                },
	                'summernote.keydown': function summernoteKeydown(we, e) {
	                    _this.handleKeydown(e);
	                },
	                'summernote.disable summernote.dialog.shown': function summernoteDisableSummernoteDialogShown() {
	                    _this.hide();
	                }
	            };
	        }
	        HintPopover.prototype.shouldInitialize = function () {
	            return this.hints.length > 0;
	        };
	        HintPopover.prototype.initialize = function () {
	            var _this = this;
	            this.lastWordRange = null;
	            this.$popover = this.ui.popover({
	                className: 'note-hint-popover',
	                hideArrow: true,
	                direction: ''
	            }).render().appendTo(this.options.container);
	            this.$popover.hide();
	            this.$content = this.$popover.find('.popover-content,.note-popover-content');
	            this.$content.on('click', '.note-hint-item', function () {
	                _this.$content.find('.active').removeClass('active');
	                $$1(_this).addClass('active');
	                _this.replace();
	            });
	        };
	        HintPopover.prototype.destroy = function () {
	            this.$popover.remove();
	        };
	        HintPopover.prototype.selectItem = function ($item) {
	            this.$content.find('.active').removeClass('active');
	            $item.addClass('active');
	            this.$content[0].scrollTop = $item[0].offsetTop - this.$content.innerHeight() / 2;
	        };
	        HintPopover.prototype.moveDown = function () {
	            var $current = this.$content.find('.note-hint-item.active');
	            var $next = $current.next();
	            if ($next.length) {
	                this.selectItem($next);
	            } else {
	                var $nextGroup = $current.parent().next();
	                if (!$nextGroup.length) {
	                    $nextGroup = this.$content.find('.note-hint-group').first();
	                }
	                this.selectItem($nextGroup.find('.note-hint-item').first());
	            }
	        };
	        HintPopover.prototype.moveUp = function () {
	            var $current = this.$content.find('.note-hint-item.active');
	            var $prev = $current.prev();
	            if ($prev.length) {
	                this.selectItem($prev);
	            } else {
	                var $prevGroup = $current.parent().prev();
	                if (!$prevGroup.length) {
	                    $prevGroup = this.$content.find('.note-hint-group').last();
	                }
	                this.selectItem($prevGroup.find('.note-hint-item').last());
	            }
	        };
	        HintPopover.prototype.replace = function () {
	            var $item = this.$content.find('.note-hint-item.active');
	            if ($item.length) {
	                var node = this.nodeFromItem($item);
	
	                this.lastWordRange.insertNode(node);
	                range.createFromNode(node).collapse().select();
	                this.lastWordRange = null;
	                this.hide();
	                this.context.triggerEvent('change', this.$editable.html(), this.$editable[0]);
	                this.context.invoke('editor.focus');
	            }
	        };
	        HintPopover.prototype.nodeFromItem = function ($item) {
	            var hint = this.hints[$item.data('index')];
	            var item = $item.data('item');
	            var node = hint.content ? hint.content(item) : item;
	            if (typeof node === 'string') {
	                node = dom.createText(node);
	            }
	            return node;
	        };
	        HintPopover.prototype.createItemTemplates = function (hintIdx, items) {
	            var hint = this.hints[hintIdx];
	            return items.map(function (item, idx) {
	                var $item = $$1('<div class="note-hint-item"/>');
	                $item.append(hint.template ? hint.template(item) : item + '');
	                $item.data({
	                    'index': hintIdx,
	                    'item': item
	                });
	                return $item;
	            });
	        };
	        HintPopover.prototype.handleKeydown = function (e) {
	            if (!this.$popover.is(':visible')) {
	                return;
	            }
	            if (e.keyCode === key.code.ENTER) {
	                e.preventDefault();
	                this.replace();
	            } else if (e.keyCode === key.code.UP) {
	                e.preventDefault();
	                this.moveUp();
	            } else if (e.keyCode === key.code.DOWN) {
	                e.preventDefault();
	                this.moveDown();
	            }
	        };
	        HintPopover.prototype.searchKeyword = function (index, keyword, callback) {
	            var hint = this.hints[index];
	            if (hint && hint.match.test(keyword) && hint.search) {
	                var matches = hint.match.exec(keyword);
	                hint.search(matches[1], callback);
	            } else {
	                callback();
	            }
	        };
	        HintPopover.prototype.createGroup = function (idx, keyword) {
	            var _this = this;
	            var $group = $$1('<div class="note-hint-group note-hint-group-' + idx + '"/>');
	            this.searchKeyword(idx, keyword, function (items) {
	                items = items || [];
	                if (items.length) {
	                    $group.html(_this.createItemTemplates(idx, items));
	                    _this.show();
	                }
	            });
	            return $group;
	        };
	        HintPopover.prototype.handleKeyup = function (e) {
	            var _this = this;
	            if (!lists.contains([key.code.ENTER, key.code.UP, key.code.DOWN], e.keyCode)) {
	                var wordRange = this.context.invoke('editor.createRange').getWordRange();
	                var keyword_1 = wordRange.toString();
	                if (this.hints.length && keyword_1) {
	                    this.$content.empty();
	                    var bnd = func.rect2bnd(lists.last(wordRange.getClientRects()));
	                    if (bnd) {
	                        this.$popover.hide();
	                        this.lastWordRange = wordRange;
	                        this.hints.forEach(function (hint, idx) {
	                            if (hint.match.test(keyword_1)) {
	                                _this.createGroup(idx, keyword_1).appendTo(_this.$content);
	                            }
	                        });
	
	                        this.$content.find('.note-hint-item:first').addClass('active');
	
	                        if (this.direction === 'top') {
	                            this.$popover.css({
	                                left: bnd.left,
	                                top: bnd.top - this.$popover.outerHeight() - POPOVER_DIST
	                            });
	                        } else {
	                            this.$popover.css({
	                                left: bnd.left,
	                                top: bnd.top + bnd.height + POPOVER_DIST
	                            });
	                        }
	                    }
	                } else {
	                    this.hide();
	                }
	            }
	        };
	        HintPopover.prototype.show = function () {
	            this.$popover.show();
	        };
	        HintPopover.prototype.hide = function () {
	            this.$popover.hide();
	        };
	        return HintPopover;
	    }();
	
	    var Context = function () {
	        function Context($note, options) {
	            this.ui = $$1.summernote.ui;
	            this.$note = $note;
	            this.memos = {};
	            this.modules = {};
	            this.layoutInfo = {};
	            this.options = options;
	            this.initialize();
	        }
	
	        Context.prototype.initialize = function () {
	            this.layoutInfo = this.ui.createLayout(this.$note, this.options);
	            this._initialize();
	            this.$note.hide();
	            return this;
	        };
	
	        Context.prototype.destroy = function () {
	            this._destroy();
	            this.$note.removeData('summernote');
	            this.ui.removeLayout(this.$note, this.layoutInfo);
	        };
	
	        Context.prototype.reset = function () {
	            var disabled = this.isDisabled();
	            this.code(dom.emptyPara);
	            this._destroy();
	            this._initialize();
	            if (disabled) {
	                this.disable();
	            }
	        };
	        Context.prototype._initialize = function () {
	            var _this = this;
	
	            var buttons = $$1.extend({}, this.options.buttons);
	            (0, _keys2.default)(buttons).forEach(function (key) {
	                _this.memo('button.' + key, buttons[key]);
	            });
	            var modules = $$1.extend({}, this.options.modules, $$1.summernote.plugins || {});
	
	            (0, _keys2.default)(modules).forEach(function (key) {
	                _this.module(key, modules[key], true);
	            });
	            (0, _keys2.default)(this.modules).forEach(function (key) {
	                _this.initializeModule(key);
	            });
	        };
	        Context.prototype._destroy = function () {
	            var _this = this;
	
	            (0, _keys2.default)(this.modules).reverse().forEach(function (key) {
	                _this.removeModule(key);
	            });
	            (0, _keys2.default)(this.memos).forEach(function (key) {
	                _this.removeMemo(key);
	            });
	
	            this.triggerEvent('destroy', this);
	        };
	        Context.prototype.code = function (html) {
	            var isActivated = this.invoke('codeview.isActivated');
	            if (html === undefined) {
	                this.invoke('codeview.sync');
	                return isActivated ? this.layoutInfo.codable.val() : this.layoutInfo.editable.html();
	            } else {
	                if (isActivated) {
	                    this.layoutInfo.codable.val(html);
	                } else {
	                    this.layoutInfo.editable.html(html);
	                }
	                this.$note.val(html);
	                this.triggerEvent('change', html);
	            }
	        };
	        Context.prototype.isDisabled = function () {
	            return this.layoutInfo.editable.attr('contenteditable') === 'false';
	        };
	        Context.prototype.enable = function () {
	            this.layoutInfo.editable.attr('contenteditable', true);
	            this.invoke('toolbar.activate', true);
	            this.triggerEvent('disable', false);
	        };
	        Context.prototype.disable = function () {
	            if (this.invoke('codeview.isActivated')) {
	                this.invoke('codeview.deactivate');
	            }
	            this.layoutInfo.editable.attr('contenteditable', false);
	            this.invoke('toolbar.deactivate', true);
	            this.triggerEvent('disable', true);
	        };
	        Context.prototype.triggerEvent = function () {
	            var namespace = lists.head(arguments);
	            var args = lists.tail(lists.from(arguments));
	            var callback = this.options.callbacks[func.namespaceToCamel(namespace, 'on')];
	            if (callback) {
	                callback.apply(this.$note[0], args);
	            }
	            this.$note.trigger('summernote.' + namespace, args);
	        };
	        Context.prototype.initializeModule = function (key) {
	            var module = this.modules[key];
	            module.shouldInitialize = module.shouldInitialize || func.ok;
	            if (!module.shouldInitialize()) {
	                return;
	            }
	
	            if (module.initialize) {
	                module.initialize();
	            }
	
	            if (module.events) {
	                dom.attachEvents(this.$note, module.events);
	            }
	        };
	        Context.prototype.module = function (key, ModuleClass, withoutIntialize) {
	            if (arguments.length === 1) {
	                return this.modules[key];
	            }
	            this.modules[key] = new ModuleClass(this);
	            if (!withoutIntialize) {
	                this.initializeModule(key);
	            }
	        };
	        Context.prototype.removeModule = function (key) {
	            var module = this.modules[key];
	            if (module.shouldInitialize()) {
	                if (module.events) {
	                    dom.detachEvents(this.$note, module.events);
	                }
	                if (module.destroy) {
	                    module.destroy();
	                }
	            }
	            delete this.modules[key];
	        };
	        Context.prototype.memo = function (key, obj) {
	            if (arguments.length === 1) {
	                return this.memos[key];
	            }
	            this.memos[key] = obj;
	        };
	        Context.prototype.removeMemo = function (key) {
	            if (this.memos[key] && this.memos[key].destroy) {
	                this.memos[key].destroy();
	            }
	            delete this.memos[key];
	        };
	
	        Context.prototype.createInvokeHandlerAndUpdateState = function (namespace, value) {
	            var _this = this;
	            return function (event) {
	                _this.createInvokeHandler(namespace, value)(event);
	                _this.invoke('buttons.updateCurrentStyle');
	            };
	        };
	        Context.prototype.createInvokeHandler = function (namespace, value) {
	            var _this = this;
	            return function (event) {
	                event.preventDefault();
	                var $target = $$1(event.target);
	                _this.invoke(namespace, value || $target.closest('[data-value]').data('value'), $target);
	            };
	        };
	        Context.prototype.invoke = function () {
	            var namespace = lists.head(arguments);
	            var args = lists.tail(lists.from(arguments));
	            var splits = namespace.split('.');
	            var hasSeparator = splits.length > 1;
	            var moduleName = hasSeparator && lists.head(splits);
	            var methodName = hasSeparator ? lists.last(splits) : lists.head(splits);
	            var module = this.modules[moduleName || 'editor'];
	            if (!moduleName && this[methodName]) {
	                return this[methodName].apply(this, args);
	            } else if (module && module[methodName] && module.shouldInitialize()) {
	                return module[methodName].apply(module, args);
	            }
	        };
	        return Context;
	    }();
	
	    $$1.fn.extend({
	        summernote: function summernote() {
	            var type = $$1.type(lists.head(arguments));
	            var isExternalAPICalled = type === 'string';
	            var hasInitOptions = type === 'object';
	            var options = $$1.extend({}, $$1.summernote.options, hasInitOptions ? lists.head(arguments) : {});
	
	            options.langInfo = $$1.extend(true, {}, $$1.summernote.lang['en-US'], $$1.summernote.lang[options.lang]);
	            options.icons = $$1.extend(true, {}, $$1.summernote.options.icons, options.icons);
	            options.tooltip = options.tooltip === 'auto' ? !env.isSupportTouch : options.tooltip;
	            this.each(function (idx, note) {
	                var $note = $$1(note);
	                if (!$note.data('summernote')) {
	                    var context = new Context($note, options);
	                    $note.data('summernote', context);
	                    $note.data('summernote').triggerEvent('init', context.layoutInfo);
	                }
	            });
	            var $note = this.first();
	            if ($note.length) {
	                var context = $note.data('summernote');
	                if (isExternalAPICalled) {
	                    return context.invoke.apply(context, lists.from(arguments));
	                } else if (options.focus) {
	                    context.invoke('editor.focus');
	                }
	            }
	            return this;
	        }
	    });
	
	    $$1.summernote = $$1.extend($$1.summernote, {
	        version: '0.8.9',
	        ui: ui,
	        dom: dom,
	        plugins: {},
	        options: {
	            modules: {
	                'editor': Editor,
	                'clipboard': Clipboard,
	                'dropzone': Dropzone,
	                'codeview': CodeView,
	                'statusbar': Statusbar,
	                'fullscreen': Fullscreen,
	                'handle': Handle,
	
	                'hintPopover': HintPopover,
	                'autoLink': AutoLink,
	                'autoSync': AutoSync,
	                'placeholder': Placeholder,
	                'buttons': Buttons,
	                'toolbar': Toolbar,
	                'linkDialog': LinkDialog,
	                'linkPopover': LinkPopover,
	                'imageDialog': ImageDialog,
	                'imagePopover': ImagePopover,
	                'tablePopover': TablePopover,
	                'videoDialog': VideoDialog,
	                'helpDialog': HelpDialog,
	                'airPopover': AirPopover
	            },
	            buttons: {},
	            lang: 'en-US',
	            followingToolbar: true,
	            otherStaticBar: '',
	
	            toolbar: [['style', ['style']], ['font', ['bold', 'underline', 'clear']], ['fontname', ['fontname']], ['color', ['color']], ['para', ['ul', 'ol', 'paragraph']], ['table', ['table']], ['insert', ['link', 'picture', 'video']], ['view', ['fullscreen', 'codeview', 'help']]],
	
	            popatmouse: true,
	            popover: {
	                image: [['imagesize', ['imageSize100', 'imageSize50', 'imageSize25']], ['float', ['floatLeft', 'floatRight', 'floatNone']], ['remove', ['removeMedia']]],
	                link: [['link', ['linkDialogShow', 'unlink']]],
	                table: [['add', ['addRowDown', 'addRowUp', 'addColLeft', 'addColRight']], ['delete', ['deleteRow', 'deleteCol', 'deleteTable']]],
	                air: [['color', ['color']], ['font', ['bold', 'underline', 'clear']], ['para', ['ul', 'paragraph']], ['table', ['table']], ['insert', ['link', 'picture']]]
	            },
	
	            airMode: false,
	            width: null,
	            height: null,
	            linkTargetBlank: true,
	            focus: false,
	            tabSize: 4,
	            styleWithSpan: true,
	            shortcuts: true,
	            textareaAutoSync: true,
	            hintDirection: 'bottom',
	            tooltip: 'auto',
	            container: 'body',
	            maxTextLength: 0,
	            styleTags: ['p', 'blockquote', 'pre', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
	            fontNames: ['Arial', 'Arial Black', 'Comic Sans MS', 'Courier New', 'Helvetica Neue', 'Helvetica', 'Impact', 'Lucida Grande', 'Tahoma', 'Times New Roman', 'Verdana'],
	            fontSizes: ['8', '9', '10', '11', '12', '14', '18', '24', '36'],
	
	            colors: [['#000000', '#424242', '#636363', '#9C9C94', '#CEC6CE', '#EFEFEF', '#F7F7F7', '#FFFFFF'], ['#FF0000', '#FF9C00', '#FFFF00', '#00FF00', '#00FFFF', '#0000FF', '#9C00FF', '#FF00FF'], ['#F7C6CE', '#FFE7CE', '#FFEFC6', '#D6EFD6', '#CEDEE7', '#CEE7F7', '#D6D6E7', '#E7D6DE'], ['#E79C9C', '#FFC69C', '#FFE79C', '#B5D6A5', '#A5C6CE', '#9CC6EF', '#B5A5D6', '#D6A5BD'], ['#E76363', '#F7AD6B', '#FFD663', '#94BD7B', '#73A5AD', '#6BADDE', '#8C7BC6', '#C67BA5'], ['#CE0000', '#E79439', '#EFC631', '#6BA54A', '#4A7B8C', '#3984C6', '#634AA5', '#A54A7B'], ['#9C0000', '#B56308', '#BD9400', '#397B21', '#104A5A', '#085294', '#311873', '#731842'], ['#630000', '#7B3900', '#846300', '#295218', '#083139', '#003163', '#21104A', '#4A1031']],
	            lineHeights: ['1.0', '1.2', '1.4', '1.5', '1.6', '1.8', '2.0', '3.0'],
	            tableClassName: 'table table-bordered',
	            insertTableMaxSize: {
	                col: 10,
	                row: 10
	            },
	            dialogsInBody: false,
	            dialogsFade: false,
	            maximumImageFileSize: null,
	            callbacks: {
	                onInit: null,
	                onFocus: null,
	                onBlur: null,
	                onBlurCodeview: null,
	                onEnter: null,
	                onKeyup: null,
	                onKeydown: null,
	                onImageUpload: null,
	                onImageUploadError: null
	            },
	            codemirror: {
	                mode: 'text/html',
	                htmlMode: true,
	                lineNumbers: true
	            },
	            keyMap: {
	                pc: {
	                    'ENTER': 'insertParagraph',
	                    'CTRL+Z': 'undo',
	                    'CTRL+Y': 'redo',
	                    'TAB': 'tab',
	                    'SHIFT+TAB': 'untab',
	                    'CTRL+B': 'bold',
	                    'CTRL+I': 'italic',
	                    'CTRL+U': 'underline',
	                    'CTRL+SHIFT+S': 'strikethrough',
	                    'CTRL+BACKSLASH': 'removeFormat',
	                    'CTRL+SHIFT+L': 'justifyLeft',
	                    'CTRL+SHIFT+E': 'justifyCenter',
	                    'CTRL+SHIFT+R': 'justifyRight',
	                    'CTRL+SHIFT+J': 'justifyFull',
	                    'CTRL+SHIFT+NUM7': 'insertUnorderedList',
	                    'CTRL+SHIFT+NUM8': 'insertOrderedList',
	                    'CTRL+LEFTBRACKET': 'outdent',
	                    'CTRL+RIGHTBRACKET': 'indent',
	                    'CTRL+NUM0': 'formatPara',
	                    'CTRL+NUM1': 'formatH1',
	                    'CTRL+NUM2': 'formatH2',
	                    'CTRL+NUM3': 'formatH3',
	                    'CTRL+NUM4': 'formatH4',
	                    'CTRL+NUM5': 'formatH5',
	                    'CTRL+NUM6': 'formatH6',
	                    'CTRL+ENTER': 'insertHorizontalRule',
	                    'CTRL+K': 'linkDialog.show'
	                },
	                mac: {
	                    'ENTER': 'insertParagraph',
	                    'CMD+Z': 'undo',
	                    'CMD+SHIFT+Z': 'redo',
	                    'TAB': 'tab',
	                    'SHIFT+TAB': 'untab',
	                    'CMD+B': 'bold',
	                    'CMD+I': 'italic',
	                    'CMD+U': 'underline',
	                    'CMD+SHIFT+S': 'strikethrough',
	                    'CMD+BACKSLASH': 'removeFormat',
	                    'CMD+SHIFT+L': 'justifyLeft',
	                    'CMD+SHIFT+E': 'justifyCenter',
	                    'CMD+SHIFT+R': 'justifyRight',
	                    'CMD+SHIFT+J': 'justifyFull',
	                    'CMD+SHIFT+NUM7': 'insertUnorderedList',
	                    'CMD+SHIFT+NUM8': 'insertOrderedList',
	                    'CMD+LEFTBRACKET': 'outdent',
	                    'CMD+RIGHTBRACKET': 'indent',
	                    'CMD+NUM0': 'formatPara',
	                    'CMD+NUM1': 'formatH1',
	                    'CMD+NUM2': 'formatH2',
	                    'CMD+NUM3': 'formatH3',
	                    'CMD+NUM4': 'formatH4',
	                    'CMD+NUM5': 'formatH5',
	                    'CMD+NUM6': 'formatH6',
	                    'CMD+ENTER': 'insertHorizontalRule',
	                    'CMD+K': 'linkDialog.show'
	                }
	            },
	            icons: {
	                'align': 'note-icon-align',
	                'alignCenter': 'note-icon-align-center',
	                'alignJustify': 'note-icon-align-justify',
	                'alignLeft': 'note-icon-align-left',
	                'alignRight': 'note-icon-align-right',
	                'rowBelow': 'note-icon-row-below',
	                'colBefore': 'note-icon-col-before',
	                'colAfter': 'note-icon-col-after',
	                'rowAbove': 'note-icon-row-above',
	                'rowRemove': 'note-icon-row-remove',
	                'colRemove': 'note-icon-col-remove',
	                'indent': 'note-icon-align-indent',
	                'outdent': 'note-icon-align-outdent',
	                'arrowsAlt': 'note-icon-arrows-alt',
	                'bold': 'note-icon-bold',
	                'caret': 'note-icon-caret',
	                'circle': 'note-icon-circle',
	                'close': 'note-icon-close',
	                'code': 'note-icon-code',
	                'eraser': 'note-icon-eraser',
	                'font': 'note-icon-font',
	                'frame': 'note-icon-frame',
	                'italic': 'note-icon-italic',
	                'link': 'note-icon-link',
	                'unlink': 'note-icon-chain-broken',
	                'magic': 'note-icon-magic',
	                'menuCheck': 'note-icon-menu-check',
	                'minus': 'note-icon-minus',
	                'orderedlist': 'note-icon-orderedlist',
	                'pencil': 'note-icon-pencil',
	                'picture': 'note-icon-picture',
	                'question': 'note-icon-question',
	                'redo': 'note-icon-redo',
	                'square': 'note-icon-square',
	                'strikethrough': 'note-icon-strikethrough',
	                'subscript': 'note-icon-subscript',
	                'superscript': 'note-icon-superscript',
	                'table': 'note-icon-table',
	                'textHeight': 'note-icon-text-height',
	                'trash': 'note-icon-trash',
	                'underline': 'note-icon-underline',
	                'undo': 'note-icon-undo',
	                'unorderedlist': 'note-icon-unorderedlist',
	                'video': 'note-icon-video'
	            }
	        }
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1);

/***/ }),
/* 568 */,
/* 569 */
93,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	angular.module('summernote', []).controller('SummernoteController', ['$scope', '$attrs', '$timeout', function ($scope, $attrs, $timeout) {
	  'use strict';
	
	  var currentElement,
	      summernoteConfig = angular.copy($scope.summernoteConfig) || {};
	
	  if (angular.isDefined($attrs.height)) {
	    summernoteConfig.height = +$attrs.height;
	  }
	  if (angular.isDefined($attrs.minHeight)) {
	    summernoteConfig.minHeight = +$attrs.minHeight;
	  }
	  if (angular.isDefined($attrs.maxHeight)) {
	    summernoteConfig.maxHeight = +$attrs.maxHeight;
	  }
	  if (angular.isDefined($attrs.placeholder)) {
	    summernoteConfig.placeholder = $attrs.placeholder;
	  }
	  if (angular.isDefined($attrs.focus)) {
	    summernoteConfig.focus = true;
	  }
	  if (angular.isDefined($attrs.airmode)) {
	    summernoteConfig.airMode = true;
	  }
	  if (angular.isDefined($attrs.lang)) {
	    if (!angular.isDefined($.summernote.lang[$attrs.lang])) {
	      throw new Error('"' + $attrs.lang + '" lang file must be exist.');
	    }
	    summernoteConfig.lang = $attrs.lang;
	  }
	
	  summernoteConfig.callbacks = summernoteConfig.callbacks || {};
	
	  if (angular.isDefined($attrs.onInit)) {
	    summernoteConfig.callbacks.onInit = function (evt) {
	      $scope.init({ evt: evt });
	    };
	  }
	  if (angular.isDefined($attrs.onEnter)) {
	    summernoteConfig.callbacks.onEnter = function (evt) {
	      $scope.enter({ evt: evt });
	    };
	  }
	  if (angular.isDefined($attrs.onFocus)) {
	    summernoteConfig.callbacks.onFocus = function (evt) {
	      $scope.focus({ evt: evt });
	    };
	  }
	  if (angular.isDefined($attrs.onPaste)) {
	    summernoteConfig.callbacks.onPaste = function (evt) {
	      $scope.paste({ evt: evt });
	    };
	  }
	  if (angular.isDefined($attrs.onKeyup)) {
	    summernoteConfig.callbacks.onKeyup = function (evt) {
	      $scope.keyup({ evt: evt });
	    };
	  }
	  if (angular.isDefined($attrs.onKeydown)) {
	    summernoteConfig.callbacks.onKeydown = function (evt) {
	      $scope.keydown({ evt: evt });
	    };
	  }
	  if (angular.isDefined($attrs.onImageUpload)) {
	    summernoteConfig.callbacks.onImageUpload = function (files) {
	      $scope.imageUpload({ files: files, editable: $scope.editable });
	    };
	  }
	  if (angular.isDefined($attrs.onMediaDelete)) {
	    summernoteConfig.callbacks.onMediaDelete = function (target) {
	      var removedMedia = { attrs: {} };
	      removedMedia.tagName = target[0].tagName;
	      angular.forEach(target[0].attributes, function (attr) {
	        removedMedia.attrs[attr.name] = attr.value;
	      });
	      $scope.mediaDelete({ target: removedMedia });
	    };
	  }
	
	  this.activate = function (scope, element, ngModel) {
	    var updateNgModel = function updateNgModel() {
	      var newValue = element.summernote('code');
	      if (element.summernote('isEmpty')) {
	        newValue = '';
	      }
	      if (ngModel && ngModel.$viewValue !== newValue) {
	        $timeout(function () {
	          ngModel.$setViewValue(newValue);
	        }, 0);
	      }
	    };
	
	    var originalOnChange = summernoteConfig.callbacks.onChange;
	    summernoteConfig.callbacks.onChange = function (contents) {
	      $timeout(function () {
	        if (element.summernote('isEmpty')) {
	          contents = '';
	        }
	        updateNgModel();
	      }, 0);
	      if (angular.isDefined($attrs.onChange)) {
	        $scope.change({ contents: contents, editable: $scope.editable });
	      } else if (angular.isFunction(originalOnChange)) {
	        originalOnChange.apply(this, arguments);
	      }
	    };
	    if (angular.isDefined($attrs.onBlur)) {
	      summernoteConfig.callbacks.onBlur = function (evt) {
	        !summernoteConfig.airMode && element.blur();
	        $scope.blur({ evt: evt });
	      };
	    }
	    element.summernote(summernoteConfig);
	
	    var editor$ = element.next('.note-editor'),
	        unwatchNgModel;
	    editor$.find('.note-toolbar').click(function () {
	      updateNgModel();
	
	      if (editor$.hasClass('codeview')) {
	        editor$.on('keyup', updateNgModel);
	        if (ngModel) {
	          unwatchNgModel = scope.$watch(function () {
	            return ngModel.$modelValue;
	          }, function (newValue) {
	            editor$.find('.note-codable').val(newValue);
	          });
	        }
	      } else {
	        editor$.off('keyup', updateNgModel);
	        if (angular.isFunction(unwatchNgModel)) {
	          unwatchNgModel();
	        }
	      }
	    });
	
	    if (ngModel) {
	      ngModel.$render = function () {
	        if (ngModel.$viewValue) {
	          element.summernote('code', ngModel.$viewValue);
	        } else {
	          element.summernote('empty');
	        }
	      };
	    }
	
	    if (angular.isDefined($attrs.editable)) {
	      $scope.editable = editor$.find('.note-editable');
	    }
	    if (angular.isDefined($attrs.editor)) {
	      $scope.editor = element;
	    }
	
	    currentElement = element;
	
	    element.on('$destroy', function () {
	      element.summernote('destroy');
	      $scope.summernoteDestroyed = true;
	    });
	  };
	
	  $scope.$on('$destroy', function () {
	    if (!$scope.summernoteDestroyed) {
	      currentElement.summernote('destroy');
	    }
	  });
	}]).directive('summernote', [function () {
	  'use strict';
	
	  return {
	    restrict: 'EA',
	    transclude: 'element',
	    replace: true,
	    require: ['summernote', '?ngModel'],
	    controller: 'SummernoteController',
	    scope: {
	      summernoteConfig: '=config',
	      editable: '=',
	      editor: '=',
	      init: '&onInit',
	      enter: '&onEnter',
	      focus: '&onFocus',
	      blur: '&onBlur',
	      paste: '&onPaste',
	      keyup: '&onKeyup',
	      keydown: '&onKeydown',
	      change: '&onChange',
	      imageUpload: '&onImageUpload',
	      mediaDelete: '&onMediaDelete'
	    },
	    template: '<div class="summernote"></div>',
	    link: function link(scope, element, attrs, ctrls, transclude) {
	      var summernoteController = ctrls[0],
	          ngModel = ctrls[1];
	
	      if (!ngModel) {
	        transclude(scope, function (clone, scope) {
	          element.append(clone.html());
	        });
	        summernoteController.activate(scope, element, ngModel);
	      } else {
	        var clearWatch = scope.$watch(function () {
	          return ngModel.$viewValue;
	        }, function (value) {
	          clearWatch();
	          element.append(value);
	          summernoteController.activate(scope, element, ngModel);
	        }, true);
	      }
	    }
	  };
	}]);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ })
]);


// WEBPACK FOOTER //
// app.11bad01e2cc62674c093.js